(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 74107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_IconFont)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/config.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var config = {
  isIntl: false
};
var getConfig = function getConfig() {
  return _objectSpread({}, config);
};
var setConfig = function setConfig(params) {
  for (var key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      var typedKey = key;
      config[typedKey] = params[typedKey];
    }
  }
};
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/iconHash.js
// ⚠️ 此文件由 scripts/gen-icon-hash.ts 自动生成，请勿手动修改 
var ICON_HASH = '54d4c0b4';
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js
/* provided dependency */ var process = __webpack_require__(34155);
function IconFont_typeof(o) { "@babel/helpers - typeof"; return IconFont_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, IconFont_typeof(o); }
var _excluded = ["name", "className", "color", "fontSize", "style", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function IconFont_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IconFont_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IconFont_ownKeys(Object(t), !0).forEach(function (r) { IconFont_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IconFont_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function IconFont_defineProperty(obj, key, value) { key = IconFont_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function IconFont_toPropertyKey(t) { var i = IconFont_toPrimitive(t, "string"); return "symbol" == IconFont_typeof(i) ? i : String(i); }
function IconFont_toPrimitive(t, r) { if ("object" != IconFont_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != IconFont_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == IconFont_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(IconFont_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var iconCache = new Map();
var pendingFetches = new Map();
var IconFont = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var name = props.name,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    color = props.color,
    fontSize = props.fontSize,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    onClick = props.onClick,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = (0,react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    svgContent = _useState2[0],
    setSvgContent = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _getConfig = getConfig(),
    isIntl = _getConfig.isIntl;
  (0,react.useEffect)(function () {
    var _process$env;
    if (!name) return;
    var isMounted = true;
    var isDev = typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.UMI_APP_ENV) === 'development'; // 兼容SSR环境
    var cdnPrefix = isIntl ? 'https://x-design-static-release.stariicloud.com' : 'https://pc.meitudata.com';
    var nameOriginal = name.charAt(0).toLowerCase() + name.slice(1);
    var url = isDev ? "/x-design-icons/icons/".concat(nameOriginal, ".svg") : "".concat(cdnPrefix, "/x-design-icons/").concat(ICON_HASH, "/").concat(nameOriginal, ".svg");
    var loadSVG = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var content, fetchPromise, svg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!iconCache.has(name)) {
                _context2.next = 3;
                break;
              }
              setSvgContent(iconCache.get(name));
              return _context2.abrupt("return");
            case 3:
              if (!pendingFetches.has(name)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 6;
              return pendingFetches.get(name);
            case 6:
              content = _context2.sent;
              if (isMounted) setSvgContent(content);
              return _context2.abrupt("return");
            case 9:
              fetchPromise = fetch(url).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var svgText, parser, doc, svg;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (res.ok) {
                          _context.next = 2;
                          break;
                        }
                        throw new Error("Failed to load ".concat(name));
                      case 2:
                        _context.next = 4;
                        return res.text();
                      case 4:
                        svgText = _context.sent;
                        // 用 DOMParser 解析 SVG 内容为 DOM
                        parser = new DOMParser();
                        doc = parser.parseFromString(svgText, 'image/svg+xml');
                        svg = doc.querySelector('svg');
                        if (svg) {
                          _context.next = 10;
                          break;
                        }
                        throw new Error("Invalid SVG content for icon [".concat(name, "]"));
                      case 10:
                        // 设置 width/height 为 1em
                        svg.setAttribute('width', '1em');
                        svg.setAttribute('height', '1em');

                        // 设置 fill="currentColor"（排除 fill="none"）
                        svg.querySelectorAll('[fill]').forEach(function (el) {
                          var fill = el.getAttribute('fill');
                          if (fill && fill.toLowerCase() !== 'none') {
                            el.setAttribute('fill', 'currentColor');
                          }
                        });

                        // 移除 <defs> 节点
                        svg.querySelectorAll('defs').forEach(function (defs) {
                          return defs.remove();
                        });

                        // 移除 clip-path、mask、filter 属性
                        ['clip-path', 'mask', 'filter'].forEach(function (attr) {
                          svg.querySelectorAll("[".concat(attr, "]")).forEach(function (el) {
                            el.removeAttribute(attr);
                          });
                        });
                        return _context.abrupt("return", svg.outerHTML);
                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()).then(function (svg) {
                iconCache.set(name, svg);
                return svg;
              }).catch(function (err) {
                console.error("Icon load error [".concat(name, "]:"), err);
                setError(true);
                return '';
              });
              pendingFetches.set(name, fetchPromise);
              _context2.next = 13;
              return fetchPromise;
            case 13:
              svg = _context2.sent;
              if (isMounted) setSvgContent(svg);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadSVG() {
        return _ref.apply(this, arguments);
      };
    }();
    loadSVG();
    return function () {
      isMounted = false;
    };
  }, [name]);
  var size = style.fontSize || fontSize || 12;
  return /*#__PURE__*/react.createElement("span", _extends({
    className: "iconfont icon-".concat(name, " ").concat(className),
    "alias-name": name,
    style: IconFont_objectSpread({
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: color,
      fontSize: size
    }, style),
    dangerouslySetInnerHTML: svgContent && !error ? {
      __html: svgContent
    } : undefined,
    ref: ref
  }, restProps, {
    onClick: onClick
  }));
});
/* harmony default export */ const dist_IconFont = (/*#__PURE__*/react.memo(IconFont));

/***/ }),

/***/ 7189:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 47708:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(49647);
var parse = __webpack_require__(90713);
var formats = __webpack_require__(7189);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 90713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(27651);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: true,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && leaf === '' ? [] : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 49647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(27651);
var formats = __webpack_require__(7189);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 27651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(7189);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 93379:
/***/ ((module) => {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ 79742:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 58509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qp": () => (/* binding */ disableBodyScroll),
/* harmony export */   "tG": () => (/* binding */ enableBodyScroll)
/* harmony export */ });
/* unused harmony export clearAllBodyScrollLocks */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

var setPositionFixed = function setPositionFixed() {
  return window.requestAnimationFrame(function () {
    // If previousBodyPosition is already set, don't set it again.
    if (previousBodyPosition === undefined) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };

      // Update the dom inside an animation frame 
      var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX,
          innerHeight = _window.innerHeight;

      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY;
      document.body.style.left = -scrollX;

      setTimeout(function () {
        return window.requestAnimationFrame(function () {
          // Attempt to check if the bottom bar appeared due to the position change
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            // Move the content further up so that the bottom bar doesn't hide it
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};

var restorePositionSetting = function restorePositionSetting() {
  if (previousBodyPosition !== undefined) {
    // Convert the position from "px" to Int
    var y = -parseInt(document.body.style.top, 10);
    var x = -parseInt(document.body.style.left, 10);

    // Restore styles
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;

    // Restore scroll
    window.scrollTo(x, y);

    previousBodyPosition = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  }
};

var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }

  locks = [];
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};



/***/ }),

/***/ 48764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(79742)
const ieee754 = __webpack_require__(80645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 25730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ ((module) => {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ ((module) => {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {import('.')} */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ ((module) => {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	// eslint-disable-next-line no-extra-parens
	var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic([intrinsic]);
	}
	return intrinsic;
};


/***/ }),

/***/ 78249:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(42480);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 98269:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 63465:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Hex;

}));

/***/ }),

/***/ 55743:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ 68398:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(62783), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));

/***/ }),

/***/ 88010:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(52153), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),

/***/ 89824:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 62783:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 52153:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 53879:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var prefix = __webpack_require__(87236)
var toCamelCase = __webpack_require__(6189)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(93379)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),

/***/ 96504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 94501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g3": () => (/* binding */ StoreProvider),
  "aD": () => (/* binding */ action),
  "MT": () => (/* binding */ dist_createStore),
  "tl": () => (/* binding */ createTypedHooks)
});

// UNUSED EXPORTS: actionOn, computed, createContextStore, createStoreActionsHook, createStoreDispatchHook, createStoreRehydratedHook, createStoreStateHook, createTransform, debug, effectOn, generic, initializeUseStoreState, persist, reducer, thunk, thunkOn, useLocalStore, useStore, useStoreActions, useStoreDispatch, useStoreRehydrated, useStoreState

// EXTERNAL MODULE: ./node_modules/easy-peasy/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(19509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ const es = (thunk);
;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ const immer_esm = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/es6/index.js
var es6 = __webpack_require__(62991);
var es6_default = /*#__PURE__*/__webpack_require__.n(es6);
;// CONCATENATED MODULE: ./node_modules/easy-peasy/dist/index.js








var StoreContext = (0,react.createContext)();

var useNotInitialized = function useNotInitialized() {
  throw new Error('uSES not initialized!');
};
var useSyncExternalStoreWithSelector = useNotInitialized;
var initializeUseStoreState = function initializeUseStoreState(fn) {
  useSyncExternalStoreWithSelector = fn;
};
var refEquality = function refEquality(a, b) {
  return a === b;
};
function createStoreStateHook(Context) {
  return function useStoreState(mapState, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }
    if (false) {}
    var store = (0,react.useContext)(Context);

    /*
    function useSyncExternalStoreWithSelector<Snapshot, Selection>(
        subscribe: (onStoreChange: () => void) => () => void,
        getSnapshot: () => Snapshot,
        getServerSnapshot: undefined | null | (() => Snapshot),
        selector: (snapshot: Snapshot) => Selection,
        isEqual?: (a: Selection, b: Selection) => boolean,
    ): Selection;
    */
    var selectedState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState,
    // getServerSnapshot = getState
    mapState, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
var useStoreState = createStoreStateHook(StoreContext);
function createStoreActionsHook(Context) {
  return function useStoreActions(mapActions) {
    var store = (0,react.useContext)(Context);
    return mapActions(store.getActions());
  };
}
var useStoreActions = createStoreActionsHook(StoreContext);
function createStoreDispatchHook(Context) {
  return function useStoreDispatch() {
    var store = (0,react.useContext)(Context);
    return store.dispatch;
  };
}
var useStoreDispatch = createStoreDispatchHook(StoreContext);
function useStore() {
  return (0,react.useContext)(StoreContext);
}
function createStoreRehydratedHook(Context) {
  return function useStoreRehydrated() {
    var store = (0,react.useContext)(Context);
    var _useState = (0,react.useState)(false),
      rehydrated = _useState[0],
      setRehydrated = _useState[1];
    (0,react.useEffect)(function () {
      store.persist.resolveRehydration().then(function () {
        return setRehydrated(true);
      });
    }, []);
    return rehydrated;
  };
}
var useStoreRehydrated = createStoreRehydratedHook(StoreContext);
function createTypedHooks() {
  return {
    useStoreActions: useStoreActions,
    useStoreDispatch: useStoreDispatch,
    useStoreState: useStoreState,
    useStoreRehydrated: useStoreRehydrated,
    useStore: useStore
  };
}

var actionSymbol = '$_a';
var actionOnSymbol = '$_aO';
var computedSymbol = '$_c';
var effectOnSymbol = '$_e';
var persistSymbol = '$_p';
var reducerSymbol = '$_r';
var thunkOnSymbol = '$_tO';
var thunkSymbol = '$_t';

var debug = function debug(state) {
  if (isDraft(state)) {
    return current(state);
  }
  return state;
};
var actionOn = function actionOn(targetResolver, fn, config) {
  var _ref;
  return _ref = {}, _ref[actionOnSymbol] = true, _ref.fn = fn, _ref.targetResolver = targetResolver, _ref.config = config, _ref;
};
var action = function action(fn, config) {
  var _ref2;
  return _ref2 = {}, _ref2[actionSymbol] = true, _ref2.fn = fn, _ref2.config = config, _ref2;
};
var defaultStateResolvers = [function (state) {
  return state;
}];
var computed = function computed(fnOrStateResolvers, fn) {
  var _ref4;
  if (typeof fn === 'function') {
    var _ref3;
    return _ref3 = {}, _ref3[computedSymbol] = true, _ref3.fn = fn, _ref3.stateResolvers = fnOrStateResolvers, _ref3;
  }
  return _ref4 = {}, _ref4[computedSymbol] = true, _ref4.fn = fnOrStateResolvers, _ref4.stateResolvers = defaultStateResolvers, _ref4;
};
function effectOn(dependencyResolvers, fn) {
  var _ref5;
  return _ref5 = {}, _ref5[effectOnSymbol] = true, _ref5.dependencyResolvers = dependencyResolvers, _ref5.fn = fn, _ref5;
}
function generic(value) {
  return value;
}
var persist = function persist(model, config) {
  var _objectSpread2;
  return (
    // if we are not running in a browser context this becomes a no-op
    typeof window === 'undefined' ? model : _objectSpread(_objectSpread({}, model), {}, (_objectSpread2 = {}, _objectSpread2[persistSymbol] = config, _objectSpread2))
  );
};
var thunkOn = function thunkOn(targetResolver, fn) {
  var _ref6;
  return _ref6 = {}, _ref6[thunkOnSymbol] = true, _ref6.fn = fn, _ref6.targetResolver = targetResolver, _ref6;
};
var dist_thunk = function thunk(fn) {
  var _ref7;
  return _ref7 = {}, _ref7[thunkSymbol] = true, _ref7.fn = fn, _ref7;
};
var reducer = function reducer(fn, config) {
  var _ref8;
  return _ref8 = {}, _ref8[reducerSymbol] = true, _ref8.fn = fn, _ref8.config = config, _ref8;
};

/**
 * We create our own immer instance to avoid potential issues with autoFreeze
 * becoming default enabled everywhere. We want to disable autofreeze as it
 * does not suit the design of Easy Peasy.
 * https://github.com/immerjs/immer/issues/681#issuecomment-705581111
 */
var easyPeasyImmer;
function dist_isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
function clone(source) {
  function recursiveClone(current) {
    var next = Object.keys(current).reduce(function (acc, key) {
      if (Object.getOwnPropertyDescriptor(current, key).get == null) {
        acc[key] = current[key];
      }
      return acc;
    }, {});
    Object.keys(next).forEach(function (key) {
      if (dist_isPlainObject(next[key])) {
        next[key] = recursiveClone(next[key]);
      }
    });
    return next;
  }
  return recursiveClone(source);
}
function isPromise(x) {
  return x != null && typeof x === 'object' && typeof x.then === 'function';
}
function get(path, target) {
  return path.reduce(function (acc, cur) {
    return dist_isPlainObject(acc) ? acc[cur] : undefined;
  }, target);
}
function newify(currentPath, currentState, finalValue) {
  if (currentPath.length === 0) {
    return finalValue;
  }
  var newState = (0,objectSpread2/* default */.Z)({}, currentState);
  var key = currentPath[0];
  if (currentPath.length === 1) {
    newState[key] = finalValue;
  } else {
    newState[key] = newify(currentPath.slice(1), newState[key], finalValue);
  }
  return newState;
}
function set(path, target, value) {
  if (path.length === 0) {
    if (typeof value === 'object') {
      Object.keys(target).forEach(function (key) {
        delete target[key];
      });
      Object.keys(value).forEach(function (key) {
        target[key] = value[key];
      });
    }
    return;
  }
  path.reduce(function (acc, cur, idx) {
    if (idx + 1 === path.length) {
      acc[cur] = value;
    } else {
      acc[cur] = acc[cur] || {};
    }
    return acc[cur];
  }, target);
}
function createSimpleProduce(disableImmer) {
  if (disableImmer === void 0) {
    disableImmer = false;
  }
  return function simpleProduce(path, state, fn, config) {
    if (config && 'immer' in config ? (config == null ? void 0 : config.immer) === false : disableImmer) {
      var _current = get(path, state);
      var next = fn(_current);
      if (_current !== next) {
        return newify(path, state, next);
      }
      return state;
    }
    if (!easyPeasyImmer) {
      easyPeasyImmer = new un({
        // We need to ensure that we disable proxies if they aren't available
        // on the environment. Users need to ensure that they use the enableES5
        // feature of immer.
        useProxies: typeof Proxy !== 'undefined' && typeof Proxy.revocable !== 'undefined' && typeof Reflect !== 'undefined',
        // Autofreezing breaks easy-peasy, we need a mixed version of immutability
        // and mutability in order to apply updates to our computed properties
        autoFreeze: false
      });
    }
    if (path.length === 0) {
      var _draft = easyPeasyImmer.createDraft(state);
      var _result = fn(_draft);
      if (_result) {
        return r(_result) ? easyPeasyImmer.finishDraft(_result) : _result;
      }
      return easyPeasyImmer.finishDraft(_draft);
    }
    var parentPath = path.slice(0, path.length - 1);
    var draft = easyPeasyImmer.createDraft(state);
    var parent = get(parentPath, state);
    var current = get(path, draft);
    var result = fn(current);
    if (result) {
      parent[path[path.length - 1]] = result;
    }
    return easyPeasyImmer.finishDraft(draft);
  };
}
var pReduce = function pReduce(iterable, reducer, initialValue) {
  return new Promise(function (resolve, reject) {
    var iterator = iterable[Symbol.iterator]();
    var index = 0;
    var next = function next(total) {
      var element = iterator.next();
      if (element.done) {
        resolve(total);
        return;
      }
      Promise.all([total, element.value]).then(function (value) {
        return (
          // eslint-disable-next-line no-plusplus
          next(reducer(value[0], value[1], index++))
        );
      }).catch(function (err) {
        return reject(err);
      });
    };
    next(initialValue);
  });
};
var pSeries = function pSeries(tasks) {
  var results = [];
  return pReduce(tasks, function (_, task) {
    return task().then(function (value) {
      results.push(value);
    });
  }).then(function () {
    return results;
  });
};
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i += 1) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
}
function useMemoOne(
// getResult changes on every call,
getResult,
// the inputs array changes on every call
inputs) {
  // using useState to generate initial value as it is lazy
  var initial = React.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = React.useRef(initial);

  // persist any uncommitted changes after they have been committed

  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));

  // create a new cache if required
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };

  // commit the cache
  React.useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
var logEventListenerError = function logEventListenerError(type, err) {
  // eslint-disable-next-line no-console
  console.log("Error in " + type);
  // eslint-disable-next-line no-console
  console.log(err);
};
var handleEventDispatchErrors = function handleEventDispatchErrors(type, dispatcher) {
  return function () {
    try {
      var result = dispatcher.apply(void 0, arguments);
      if (isPromise(result)) {
        result.catch(function (err) {
          logEventListenerError(type, err);
        });
      }
    } catch (err) {
      logEventListenerError(type, err);
    }
  };
};

function createReducer(disableImmer, _aRD, _cR, _cP) {
  var simpleProduce = createSimpleProduce(disableImmer);
  var runActionReducerAtPath = function runActionReducerAtPath(state, action, actionReducer, path, config) {
    return simpleProduce(path, state, function (draft) {
      return actionReducer(draft, action.payload);
    }, config);
  };
  var reducerForActions = function reducerForActions(state, action) {
    var actionReducer = _aRD[action.type];
    if (actionReducer) {
      return runActionReducerAtPath(state, action, actionReducer, actionReducer.def.meta.parent, actionReducer.def.config);
    }
    return state;
  };
  var reducerForCustomReducers = function reducerForCustomReducers(state, action) {
    return _cR.reduce(function (acc, _ref) {
      var parentPath = _ref.parentPath,
        key = _ref.key,
        reducer = _ref.reducer,
        config = _ref.config;
      return simpleProduce(parentPath, acc, function (draft) {
        draft[key] = reducer(r(draft[key]) ? e(draft[key]) : draft[key], action);
        return draft;
      }, config);
    }, state);
  };
  var rootReducer = function rootReducer(state, action) {
    var stateAfterActions = reducerForActions(state, action);
    var next = _cR.length > 0 ? reducerForCustomReducers(stateAfterActions, action) : stateAfterActions;
    if (state !== next) {
      _cP.forEach(function (_ref2) {
        var parentPath = _ref2.parentPath,
          bindComputedProperty = _ref2.bindComputedProperty;
        var parentState = get(parentPath, next);
        if (parentState != null) bindComputedProperty(parentState, next);
      });
    }
    return next;
  };
  return rootReducer;
}

var migrate = function migrate(data, migrations) {
  var _data$_migrationVersi;
  sn(false);
  var version = (_data$_migrationVersi = data._migrationVersion) != null ? _data$_migrationVersi : 0;
  var toVersion = migrations.migrationVersion;
  if (typeof version !== "number" || typeof toVersion !== 'number') {
    throw new Error('No migration version found');
  }
  while (version < toVersion) {
    var nextVersion = version + 1;
    var migrator = migrations[nextVersion];
    if (!migrator) {
      throw new Error("No migrator found for `migrationVersion` " + nextVersion);
    }
    data = fn(data, migrator);
    data._migrationVersion = nextVersion;
    version = data._migrationVersion;
  }
  sn(true);
  return data;
};

var noopStorage = {
  getItem: function getItem() {
    return undefined;
  },
  setItem: function setItem() {
    return undefined;
  },
  removeItem: function removeItem() {
    return undefined;
  }
};
var getBrowserStorage = function getBrowserStorage(storageName) {
  var storageCache;
  return function () {
    if (!storageCache) {
      try {
        if (typeof window !== 'undefined' && typeof window[storageName] !== 'undefined') {
          storageCache = window[storageName];
        }
      } catch (_) {
        // swallow the failure
      }
      if (!storageCache) {
        storageCache = noopStorage;
      }
    }
    return storageCache;
  };
};
var localStorage = getBrowserStorage('localStorage');
var sessionStorage = getBrowserStorage('sessionStorage');
function createStorageWrapper(storage, transformers, migrations) {
  if (transformers === void 0) {
    transformers = [];
  }
  if (migrations === void 0) {
    migrations = {};
  }
  if (storage == null) {
    storage = sessionStorage();
  }
  if (typeof storage === 'string') {
    if (storage === 'localStorage') {
      storage = localStorage();
    } else if (storage === 'sessionStorage') {
      storage = sessionStorage();
    } else {
      if (false) {}
      storage = noopStorage;
    }
  }
  var outTransformers = [].concat(transformers).reverse();
  var serialize = function serialize(data) {
    if (transformers.length > 0 && data != null && typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        data[key] = transformers.reduce(function (acc, cur) {
          return cur.in(acc, key, data);
        }, data[key]);
      });
    }
    return storage === localStorage() || storage === sessionStorage() ? JSON.stringify({
      data: data
    }) : data;
  };
  var deserialize = function deserialize(data) {
    var storageData = storage === localStorage() || storage === sessionStorage() ? JSON.parse(data).data : data;
    var hasMigrations = Object.keys(migrations).length > 0;
    var result = hasMigrations ? migrate(storageData, migrations) : storageData;
    if (outTransformers.length > 0 && result != null && typeof result === 'object') {
      Object.keys(result).forEach(function (key) {
        result[key] = outTransformers.reduce(function (acc, cur) {
          return cur.out(acc, key, result);
        }, result[key]);
      });
    }
    return result;
  };
  var isAsync = isPromise(storage.getItem('_'));
  return {
    getItem: function getItem(key) {
      if (isAsync) {
        return storage.getItem(key).then(function (wrapped) {
          return wrapped != null ? deserialize(wrapped) : undefined;
        });
      }
      var wrapped = storage.getItem(key);
      return wrapped != null ? deserialize(wrapped) : undefined;
    },
    setItem: function setItem(key, data) {
      return storage.setItem(key, serialize(data));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
}
function extractPersistConfig(path, persistdef) {
  if (persistdef === void 0) {
    persistdef = {};
  }
  return {
    path: path,
    config: {
      allow: persistdef.allow || [],
      deny: persistdef.deny || [],
      mergeStrategy: persistdef.mergeStrategy || 'mergeDeep',
      storage: createStorageWrapper(persistdef.storage, persistdef.transformers, persistdef.migrations)
    }
  };
}
function resolvePersistTargets(target, allow, deny) {
  var targets = Object.keys(target);
  if (allow.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (allow.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return [].concat(acc, [cur]);
      }
      return acc;
    }, []);
  }
  if (deny.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (deny.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return acc;
      }
      return [].concat(acc, [cur]);
    }, []);
  }
  return targets;
}
function createPersistenceClearer(persistKey, _r) {
  return function () {
    if (_r._i._persistenceConfig.length === 0) {
      return Promise.resolve();
    }
    return pSeries(_r._i._persistenceConfig.map(function (_ref) {
      var path = _ref.path,
        config = _ref.config;
      return function () {
        return Promise.resolve(config.storage.removeItem(persistKey(path)));
      };
    }));
  };
}
function createPersistor(persistKey, _r) {
  var persistPromise = Promise.resolve();
  var isPersisting = false;
  var nextPersistOperation;
  var timingMethod = typeof window === 'undefined' ? function (fn) {
    return fn();
  } : window.requestIdleCallback != null ?
  // We need to wrap requestIdleCallback, because it doesn't work without
  // a second parameter on iOS with ReactNative
  function (fn) {
    return window.requestIdleCallback(fn, {
      timeout: 0
    });
  } : window.requestAnimationFrame;
  var persist = function persist(nextState) {
    if (_r._i._persistenceConfig.length === 0) {
      return;
    }
    var operation = function operation() {
      isPersisting = true;
      persistPromise = new Promise(function (resolve) {
        timingMethod(function () {
          pSeries(_r._i._persistenceConfig.map(function (_ref2) {
            var path = _ref2.path,
              config = _ref2.config;
            return function () {
              var storage = config.storage,
                allow = config.allow,
                deny = config.deny;
              var persistRootState = clone(get(path, nextState));
              var persistTargets = resolvePersistTargets(persistRootState, allow, deny);
              var stateToPersist = {};
              persistTargets.map(function (key) {
                var targetPath = [].concat(path, [key]);
                var rawValue = get(targetPath, nextState);
                var value = dist_isPlainObject(rawValue) ? clone(rawValue) : rawValue;
                stateToPersist[key] = value;
              });
              return Promise.resolve(storage.setItem(persistKey(path), stateToPersist));
            };
          })).finally(function () {
            isPersisting = false;
            if (nextPersistOperation) {
              var next = nextPersistOperation;
              nextPersistOperation = null;
              next();
            } else {
              resolve();
            }
          });
        });
      });
    };
    if (isPersisting) {
      nextPersistOperation = operation;
    } else {
      operation();
    }
  };
  return {
    persist: persist,
    clear: createPersistenceClearer(persistKey, _r),
    flush: function flush() {
      if (nextPersistOperation) {
        nextPersistOperation();
      }
      return persistPromise;
    }
  };
}
function createPersistMiddleware(persistor, _r) {
  return function (_ref3) {
    var getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var state = next(action);
        if (action && action.type !== '@action.ePRS' && _r._i._persistenceConfig.length > 0) {
          persistor.persist(getState());
        }
        return state;
      };
    };
  };
}
function rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, root) {
  if (_r._i._persistenceConfig.length === 0) {
    return Promise.resolve();
  }
  var state = clone(_r._i._dS);
  var rehydrating = false;
  return pSeries(_r._i._persistenceConfig.map(function (persistInstance) {
    return function () {
      var path = persistInstance.path,
        config = persistInstance.config;
      var mergeStrategy = config.mergeStrategy,
        storage = config.storage;
      if (root && (path.length < 1 || path[0] !== root)) {
        return Promise.resolve();
      }
      var hasDataModelChanged = function hasDataModelChanged(dataModel, rehydratingModelData) {
        return dataModel != null && rehydratingModelData != null && (typeof dataModel !== typeof rehydratingModelData || Array.isArray(dataModel) && !Array.isArray(rehydratingModelData));
      };
      var applyRehydrationStrategy = function applyRehydrationStrategy(persistedState) {
        if (mergeStrategy === 'overwrite') {
          set(path, state, persistedState);
        } else if (mergeStrategy === 'mergeShallow') {
          var targetState = get(path, state);
          Object.keys(persistedState).forEach(function (key) {
            if (hasDataModelChanged(targetState[key], persistedState[key])) ; else {
              targetState[key] = persistedState[key];
            }
          });
        } else if (mergeStrategy === 'mergeDeep') {
          var _targetState = get(path, state);
          var setAt = function setAt(currentTargetState, currentPersistedState) {
            Object.keys(currentPersistedState).forEach(function (key) {
              if (hasDataModelChanged(currentTargetState[key], currentPersistedState[key])) ; else if (dist_isPlainObject(currentPersistedState[key])) {
                currentTargetState[key] = currentTargetState[key] || {};
                setAt(currentTargetState[key], currentPersistedState[key]);
              } else {
                currentTargetState[key] = currentPersistedState[key];
              }
            });
          };
          setAt(_targetState, persistedState);
        }
      };
      var rehydate = function rehydate(persistedState) {
        if (persistedState != null) {
          applyRehydrationStrategy(persistedState);
          rehydrating = true;
        }
      };
      var getItemResult = storage.getItem(persistKey(path));
      if (isPromise(getItemResult)) {
        return getItemResult.then(rehydate);
      }
      return Promise.resolve(rehydate(getItemResult));
    };
  })).then(function () {
    if (rehydrating) {
      replaceState(state);
    }
  });
}

function createActionCreator(def, _r) {
  function actionCreator(payload) {
    var action = {
      type: def.meta.type,
      payload: payload,
      config: def.config
    };
    if (def[actionOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return _r.dispatch(action);
  }

  // We bind the types to the creator for easy reference by consumers
  actionCreator.type = def.meta.type;
  return actionCreator;
}

function createThunkHandler(def, _r, injections, _aC) {
  return function (payload, fail) {
    var helpers = {
      dispatch: _r.dispatch,
      fail: fail,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (def[thunkOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return def.fn(get(def.meta.parent, _aC), payload, helpers);
  };
}
function createThunkActionsCreator(def, _r) {
  var actionCreator = function actionCreator(payload) {
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        payload: payload
      });
    });
    var dispatchFail = handleEventDispatchErrors(def.meta.failType, function (err) {
      return _r.dispatch({
        type: def.meta.failType,
        payload: payload,
        error: err
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function (result) {
      return _r.dispatch({
        type: def.meta.successType,
        payload: payload,
        result: result
      });
    });
    dispatchStart();
    var failure = null;
    var fail = function fail(_failure) {
      failure = _failure || new Error();
    };
    var result = _r.dispatch(function () {
      return def.thunkHandler(payload, fail);
    });
    if (isPromise(result)) {
      return result.then(function (resolved) {
        if (failure) {
          dispatchFail(failure);
        } else {
          dispatchSuccess(resolved);
        }
        return resolved;
      });
    }
    if (failure) {
      dispatchFail(failure);
    } else {
      dispatchSuccess(result);
    }
    return result;
  };
  actionCreator.type = def.meta.type;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  actionCreator.startType = def.meta.startType;
  return actionCreator;
}

function createListenerMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        var result = next(action);
        if (action && _r._i._lAM[action.type] && _r._i._lAM[action.type].length > 0) {
          var sourceAction = _r._i._aCD[action.type];
          _r._i._lAM[action.type].forEach(function (actionCreator) {
            actionCreator({
              type: sourceAction ? sourceAction.def.meta.type : action.type,
              payload: action.payload,
              error: action.error,
              result: action.result
            });
          });
        }
        return result;
      };
    };
  };
}
function bindListenerdefs(listenerdefs, _aC, _aCD, _lAM) {
  listenerdefs.forEach(function (def) {
    var targets = def.targetResolver(get(def.meta.parent, _aC), _aC);
    var targetTypes = (Array.isArray(targets) ? targets : [targets]).reduce(function (acc, target) {
      if (typeof target === 'function' && target.def.meta.type && _aCD[target.def.meta.type]) {
        if (target.def.meta.successType) {
          acc.push(target.def.meta.successType);
        } else {
          acc.push(target.def.meta.type);
        }
      } else if (typeof target === 'string') {
        acc.push(target);
      }
      return acc;
    }, []);
    def.meta.resolvedTargets = targetTypes;
    targetTypes.forEach(function (targetType) {
      var listenerReg = _lAM[targetType] || [];
      listenerReg.push(_aCD[def.meta.type]);
      _lAM[targetType] = listenerReg;
    });
  });
}

function createComputedPropertyBinder(key, def, _r) {
  var hasRunOnce = false;
  var prevInputs = [];
  var prevValue;
  var prevStoreState;
  var performingEqualityCheck = false;
  var areEqual = function areEqual(a, b) {
    performingEqualityCheck = true;
    var result = es6_default()(a, b);
    performingEqualityCheck = false;
    return result;
  };
  return function createComputedProperty(parentState, storeState) {
    Object.defineProperty(parentState, key, {
      configurable: true,
      enumerable: true,
      get: function get() {
        if (performingEqualityCheck) {
          return prevValue;
        }
        var inputs = def.stateResolvers.map(function (resolver) {
          return resolver(parentState, storeState);
        });
        if (hasRunOnce && (storeState === prevStoreState && areInputsEqual(inputs, prevInputs) ||
        // We don't want computed properties resolved every time an action
        // is handled by the reducer. They need to remain lazy, only being
        // computed when used by a component or getState call;
        _r._i._cS.isInReducer &&
        // This is to account for strange errors that may occur via immer;
        new Error().stack.match(/shallowCopy/gi) !== null)) {
          return prevValue;
        }
        var newValue = def.fn.apply(def, inputs);
        if (!areEqual(newValue, prevValue)) {
          prevValue = newValue;
        }
        prevInputs = inputs;
        prevStoreState = storeState;
        hasRunOnce = true;
        return prevValue;
      }
    });
  };
}
function createComputedPropertiesMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        _r._i._cS.isInReducer = true;
        var result = next(action);
        _r._i._cS.isInReducer = false;
        return result;
      };
    };
  };
}

function createEffectsMiddleware(_r) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (_r._i._e.length === 0) {
          return next(action);
        }
        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();
        if (prevState !== nextState) {
          _r._i._e.forEach(function (def) {
            var prevLocal = get(def.meta.parent, prevState);
            var nextLocal = get(def.meta.parent, nextState);
            var prevDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(prevLocal, prevState);
            });
            var nextDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(nextLocal, nextState);
            });
            var hasChanged = prevDependencies.some(function (dependency, idx) {
              return dependency !== nextDependencies[idx];
            });
            if (hasChanged) {
              def.actionCreator(prevDependencies, nextDependencies, action);
            }
          });
        }
        return result;
      };
    };
  };
}
var logEffectError = function logEffectError(err) {
  // As users can't get a handle on effects we need to report the error
  // eslint-disable-next-line no-console
  console.error(err);
};
function createEffectHandler(def, _r, injections, _aC) {
  var dispose;
  return function (change) {
    var helpers = {
      dispatch: _r.dispatch,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (dispose !== undefined) {
      var disposeResult = dispose();
      dispose = undefined;
      if (isPromise(disposeResult)) {
        disposeResult.catch(logEffectError);
      }
    }
    var actions = get(def.meta.parent, _aC);
    var effectResult = def.fn(actions, change, helpers);
    if (isPromise(effectResult)) {
      return effectResult.then(function (resolved) {
        if (typeof resolved === 'function') {
          if (false) {}
        }
      });
    }
    if (typeof effectResult === 'function') {
      dispose = effectResult;
    }
    return undefined;
  };
}
function createEffectActionsCreator(def, _r, effectHandler) {
  var actionCreator = function actionCreator(previousDependencies, nextDependencies, action) {
    var change = {
      prev: previousDependencies,
      current: nextDependencies,
      action: action
    };
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        change: change
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function () {
      return _r.dispatch({
        type: def.meta.successType,
        change: change
      });
    });
    dispatchStart();
    try {
      var result = _r.dispatch(function () {
        return effectHandler(change);
      });
      if (isPromise(result)) {
        return result.then(function (resolved) {
          dispatchSuccess(resolved);
          return resolved;
        }, logEffectError);
      }
      dispatchSuccess(result);
      return result;
    } catch (err) {
      logEffectError(err);
    }
    return undefined;
  };
  actionCreator.type = def.meta.type;
  actionCreator.startType = def.meta.startType;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  return actionCreator;
}

function extractDataFromModel(model, initialState, injections, _r) {
  var _dS = initialState;
  var _aCD = {};
  var _aC = {};
  var _aRD = {};
  var _cP = [];
  var _cR = [];
  var _e = [];
  var _lAC = {};
  var _lAM = {};
  var listenerdefs = [];
  var _persistenceConfig = [];
  var _cS = {
    isInReducer: false
  };
  var recursiveExtractFromModel = function recursiveExtractFromModel(current, parentPath) {
    return Object.keys(current).forEach(function (key) {
      var value = current[key];
      var path = [].concat(parentPath, [key]);
      var meta = {
        parent: parentPath,
        path: path,
        key: key
      };
      var handleValueAsState = function handleValueAsState() {
        var initialParentRef = get(parentPath, initialState);
        if (initialParentRef && key in initialParentRef) {
          set(path, _dS, initialParentRef[key]);
        } else {
          set(path, _dS, value);
        }
      };
      if (key === persistSymbol) {
        _persistenceConfig.push(extractPersistConfig(parentPath, value));
        return;
      }
      if (value != null && typeof value === 'object') {
        if (value[actionSymbol] || value[actionOnSymbol]) {
          var def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the action
          var category = def[actionSymbol] ? '@action' : '@actionOn';

          // Establish the meta data describing the action
          def.meta = {
            actionName: meta.key,
            category: category,
            type: category + "." + meta.path.join('.'),
            parent: meta.parent,
            path: meta.path
          };

          // Create the "action creator" function
          def.actionCreator = createActionCreator(def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          def.actionCreator.def = def;

          // Create a bidirectional relationship of the def/reducer
          def.fn.def = def;

          // Add the action creator to lookup map
          _aCD[def.meta.type] = def.actionCreator;

          // Add the reducer to lookup map
          _aRD[def.meta.type] = def.fn;

          // We don't want to expose the internal action to consumers
          if (meta.key !== 'ePRS') {
            // Set the action creator in the "actions" object tree for
            // either the listeners object tree, or the standard actions/thunks
            // object tree
            if (def[actionOnSymbol]) {
              listenerdefs.push(def);
              set(path, _lAC, def.actionCreator);
            } else {
              set(path, _aC, def.actionCreator);
            }
          }
        } else if (value[thunkSymbol] || value[thunkOnSymbol]) {
          var _def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the thunk
          var _category = _def[thunkSymbol] ? '@thunk' : '@thunkOn';

          // Establish the meta data describing the thunk
          var type = _category + "." + meta.path.join('.');
          _def.meta = {
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            type: type,
            startType: type + "(start)",
            successType: type + "(success)",
            failType: type + "(fail)"
          };

          // Create the function that will handle, i.e. be executed, when
          // the thunk action is created/dispatched
          _def.thunkHandler = createThunkHandler(_def, _r, injections, _aC);

          // Create the "action creator" function
          _def.actionCreator = createThunkActionsCreator(_def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          _def.actionCreator.def = _def;

          // Register the action creator within the lookup map
          _aCD[_def.meta.type] = _def.actionCreator;

          // Set the action creator in the "actions" object tree for
          // either the listeners object tree, or the standard actions/thunks
          // object tree
          if (_def[thunkOnSymbol]) {
            listenerdefs.push(_def);
            set(path, _lAC, _def.actionCreator);
          } else {
            set(path, _aC, _def.actionCreator);
          }
        } else if (value[computedSymbol]) {
          var parent = get(parentPath, _dS);
          var bindComputedProperty = createComputedPropertyBinder(key, value, _r);
          bindComputedProperty(parent, _dS);
          _cP.push({
            key: key,
            parentPath: parentPath,
            bindComputedProperty: bindComputedProperty
          });
        } else if (value[reducerSymbol]) {
          _cR.push({
            key: key,
            parentPath: parentPath,
            reducer: value.fn,
            config: value.config
          });
        } else if (value[effectOnSymbol]) {
          var _def2 = (0,objectSpread2/* default */.Z)({}, value);

          // Establish the meta data describing the effect
          var _type = "@effectOn." + meta.path.join('.');
          _def2.meta = {
            type: _type,
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            startType: _type + "(start)",
            successType: _type + "(success)",
            failType: _type + "(fail)"
          };
          var effectHandler = createEffectHandler(_def2, _r, injections, _aC);
          var actionCreator = createEffectActionsCreator(_def2, _r, effectHandler);
          _def2.actionCreator = actionCreator;
          _e.push(_def2);
        } else if (dist_isPlainObject(value)) {
          var existing = get(path, _dS);
          if (existing == null) {
            set(path, _dS, {});
          }
          recursiveExtractFromModel(value, path);
        } else {
          handleValueAsState();
        }
      } else {
        handleValueAsState();
      }
    });
  };
  _persistenceConfig = _persistenceConfig.sort(function (a, b) {
    var aPath = a.path.join('.');
    var bPath = b.path.join('.');
    if (aPath < bPath) {
      return -1;
    }
    if (aPath > bPath) {
      return 1;
    }
    return 0;
  });
  recursiveExtractFromModel(model, []);
  bindListenerdefs(listenerdefs, _aC, _aCD, _lAM);
  return {
    _aCD: _aCD,
    _aC: _aC,
    _aRD: _aRD,
    _cP: _cP,
    _cR: _cR,
    _cS: _cS,
    _dS: _dS,
    _e: _e,
    _lAC: _lAC,
    _lAM: _lAM,
    _persistenceConfig: _persistenceConfig
  };
}

function dist_createStore(model, options) {
  if (options === void 0) {
    options = {};
  }
  var modelClone = clone(model);
  var _options = options,
    compose$1 = _options.compose,
    _options$devTools = _options.devTools,
    devTools = _options$devTools === void 0 ? "production" !== 'production' : _options$devTools,
    _options$disableImmer = _options.disableImmer,
    disableImmer = _options$disableImmer === void 0 ? false : _options$disableImmer,
    _options$enhancers = _options.enhancers,
    enhancers = _options$enhancers === void 0 ? [] : _options$enhancers,
    _options$initialState = _options.initialState,
    initialState = _options$initialState === void 0 ? undefined : _options$initialState,
    _options$injections = _options.injections,
    injections = _options$injections === void 0 ? {} : _options$injections,
    _options$middleware = _options.middleware,
    middleware = _options$middleware === void 0 ? [] : _options$middleware,
    _options$mockActions = _options.mockActions,
    mockActions = _options$mockActions === void 0 ? false : _options$mockActions,
    _options$name = _options.name,
    storeName = _options$name === void 0 ? "EasyPeasyStore" : _options$name,
    _options$version = _options.version,
    version = _options$version === void 0 ? 0 : _options$version,
    _options$reducerEnhan = _options.reducerEnhancer,
    reducerEnhancer = _options$reducerEnhan === void 0 ? function (rootReducer) {
      return rootReducer;
    } : _options$reducerEnhan;
  var bindReplaceState = function bindReplaceState(modelDef) {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, modelDef), {}, {
      ePRS: action(function (_, payload) {
        return payload;
      })
    });
  };
  var _r = {};
  var modeldef = bindReplaceState(modelClone);
  var mockedActions = [];
  var persistKey = function persistKey(targetPath) {
    return "[" + storeName + "][" + version + "]" + (targetPath.length > 0 ? "[" + targetPath.join('.') + "]" : '');
  };
  var persistor = createPersistor(persistKey, _r);
  var persistMiddleware = createPersistMiddleware(persistor, _r);
  var replaceState = function replaceState(nextState) {
    return _r._i._aCD['@action.ePRS'](nextState);
  };
  var bindStoreInternals = function bindStoreInternals(state) {
    if (state === void 0) {
      state = {};
    }
    var data = extractDataFromModel(modeldef, state, injections, _r);
    _r._i = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data), {}, {
      reducer: reducerEnhancer(createReducer(disableImmer, data._aRD, data._cR, data._cP))
    });
  };
  var mockActionsMiddleware = function mockActionsMiddleware() {
    return function () {
      return function (action) {
        if (action != null) {
          mockedActions.push(action);
        }
        return undefined;
      };
    };
  };
  var devToolConfig = devTools === true ? {} : devTools;
  var composeEnhancers = compose$1 || (devTools && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__((0,objectSpread2/* default */.Z)({
    name: storeName
  }, devToolConfig)) : compose);
  bindStoreInternals(initialState || {});
  var easyPeasyMiddleware = [createComputedPropertiesMiddleware(_r)].concat(middleware, [es, createListenerMiddleware(_r), createEffectsMiddleware(_r), persistMiddleware]);
  if (mockActions) {
    easyPeasyMiddleware.push(mockActionsMiddleware);
  }
  var store = createStore(_r._i.reducer, _r._i._dS, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, easyPeasyMiddleware)].concat(enhancers)));
  store.subscribe(function () {
    _r._i._cS.isInReducer = false;
  });
  _r.dispatch = store.dispatch;
  _r.getState = store.getState;
  var bindActionCreators = function bindActionCreators() {
    Object.keys(store.dispatch).forEach(function (actionsKey) {
      delete store.dispatch[actionsKey];
    });
    Object.keys(_r._i._aC).forEach(function (key) {
      store.dispatch[key] = _r._i._aC[key];
    });
  };
  bindActionCreators();
  var rebindStore = function rebindStore(removeKey) {
    var currentState = store.getState();
    if (removeKey) {
      delete currentState[removeKey];
    }
    bindStoreInternals(currentState);
    store.replaceReducer(_r._i.reducer);
    replaceState(_r._i._dS);
    bindActionCreators();
  };
  var _resolveRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r);
  return Object.assign(store, {
    addModel: function addModel(key, modelForKey) {
      if (modeldef[key] && "production" !== 'production') {}
      modeldef[key] = modelForKey;
      rebindStore();
      // There may have been persisted state for a dynamic model. We should try
      // and rehydrate the specifc node
      var addModelRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, key);
      return {
        resolveRehydration: function resolveRehydration() {
          return addModelRehydration;
        }
      };
    },
    clearMockedActions: function clearMockedActions() {
      mockedActions = [];
    },
    getActions: function getActions() {
      return _r._i._aC;
    },
    getListeners: function getListeners() {
      return _r._i._lAC;
    },
    getMockedActions: function getMockedActions() {
      return [].concat(mockedActions);
    },
    persist: {
      clear: persistor.clear,
      flush: persistor.flush,
      resolveRehydration: function resolveRehydration() {
        return _resolveRehydration;
      }
    },
    reconfigure: function reconfigure(newModel) {
      modeldef = bindReplaceState(newModel);
      rebindStore();
    },
    removeModel: function removeModel(key) {
      if (!modeldef[key]) {
        return;
      }
      delete modeldef[key];
      rebindStore(key);
    }
  });
}

function createContextStore(model, config) {
  if (config === void 0) {
    config = {};
  }
  // We create a mutable injections reference to allow updating it
  var _config = config,
    _config$injections = _config.injections,
    mutableInjections = _config$injections === void 0 ? {} : _config$injections;
  var StoreContext = createContext();
  function Provider(_ref) {
    var children = _ref.children,
      runtimeModel = _ref.runtimeModel,
      injections = _ref.injections;
    // If the user provided injections we need to ensure our mutable ref
    // is up to date. We could consider doing a shallow compare here?
    if (injections != null) {
      var nextInjections = typeof injections === 'function' ? injections(mutableInjections) : injections;
      var nextKeys = Object.keys(nextInjections);
      var removeKeys = Object.keys(mutableInjections).filter(function (k) {
        return !nextKeys.includes(k);
      });
      removeKeys.forEach(function (k) {
        delete mutableInjections[k];
      });
      Object.assign(mutableInjections, nextInjections);
    }
    var store = useMemoOne(function () {
      return dist_createStore(typeof model === 'function' ? model(runtimeModel) : model, _objectSpread(_objectSpread({}, config), {}, {
        originalInjections: mutableInjections
      }));
    }, []);
    return /*#__PURE__*/React.createElement(StoreContext.Provider, {
      value: store
    }, children);
  }
  function useStore() {
    return useContext(StoreContext);
  }
  return {
    Provider: Provider,
    useStore: useStore,
    useStoreState: createStoreStateHook(StoreContext),
    useStoreActions: createStoreActionsHook(StoreContext),
    useStoreDispatch: createStoreDispatchHook(StoreContext),
    useStoreRehydrated: createStoreRehydratedHook(StoreContext)
  };
}

/**
 * This file has been copied from redux-persist.
 * The intention being to support as much of the redux-persist API as possible.
 */

function createTransform(inbound, outbound, config) {
  if (config === void 0) {
    config = {};
  }
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;
  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }
  return {
    in: function _in(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(data, key, fullState) : data;
    },
    out: function out(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(data, key, fullState) : data;
    }
  };
}

/* eslint-disable react/prop-types */
function StoreProvider(_ref) {
  var children = _ref.children,
    store = _ref.store;
  return /*#__PURE__*/react.createElement(StoreContext.Provider, {
    value: store
  }, children);
}

function useLocalStore(modelCreator, dependencies, configCreator) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  if (configCreator === void 0) {
    configCreator = null;
  }
  var storeRef = useRef();
  var configRef = useRef();
  var store = useMemoOne(function () {
    var previousState = storeRef.current != null ? storeRef.current.getState() : undefined;
    var config = configCreator != null ? configCreator(previousState, configRef.current) : undefined;
    var _store = dist_createStore(modelCreator(previousState), config);
    configRef.current = config;
    storeRef.current = _store;
    return _store;
  }, dependencies);
  var _useState = useState(function () {
      return store.getState();
    }),
    currentState = _useState[0],
    setCurrentState = _useState[1];
  useEffect(function () {
    setCurrentState(store.getState());
    return store.subscribe(function () {
      var nextState = store.getState();
      if (currentState !== nextState) {
        setCurrentState(nextState);
      }
    });
  }, [store]);
  return [currentState, store.getActions(), store];
}

// React 18 requires the use of the useSyncExternalStore hook for external
initializeUseStoreState(with_selector.useSyncExternalStoreWithSelector);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98364:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 50968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(99378);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 99378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(98364);
} else {}


/***/ }),

/***/ 19509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(50968);
} else {}


/***/ }),

/***/ 24429:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17187:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 62991:
/***/ ((module) => {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 40001:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

const Token = __webpack_require__(83416);
const strtok3 = __webpack_require__(35849);
const {
	stringToBytes,
	tarHeaderChecksumMatches,
	uint32SyncSafeToken
} = __webpack_require__(76188);
const supported = __webpack_require__(49898);

const minimumBytes = 4100; // A fair amount of file-types are detectable within this range

async function fromStream(stream) {
	const tokenizer = await strtok3.fromStream(stream);
	try {
		return await fromTokenizer(tokenizer);
	} finally {
		await tokenizer.close();
	}
}

async function fromBuffer(input) {
	if (!(input instanceof Uint8Array || input instanceof ArrayBuffer || Buffer.isBuffer(input))) {
		throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`Buffer\` or \`ArrayBuffer\`, got \`${typeof input}\``);
	}

	const buffer = input instanceof Buffer ? input : Buffer.from(input);

	if (!(buffer && buffer.length > 1)) {
		return;
	}

	const tokenizer = strtok3.fromBuffer(buffer);
	return fromTokenizer(tokenizer);
}

function _check(buffer, headers, options) {
	options = {
		offset: 0,
		...options
	};

	for (const [index, header] of headers.entries()) {
		// If a bitmask is set
		if (options.mask) {
			// If header doesn't equal `buf` with bits masked off
			if (header !== (options.mask[index] & buffer[index + options.offset])) {
				return false;
			}
		} else if (header !== buffer[index + options.offset]) {
			return false;
		}
	}

	return true;
}

async function fromTokenizer(tokenizer) {
	try {
		return _fromTokenizer(tokenizer);
	} catch (error) {
		if (!(error instanceof strtok3.EndOfStreamError)) {
			throw error;
		}
	}
}

async function _fromTokenizer(tokenizer) {
	let buffer = Buffer.alloc(minimumBytes);
	const bytesRead = 12;
	const check = (header, options) => _check(buffer, header, options);
	const checkString = (header, options) => check(stringToBytes(header), options);

	// Keep reading until EOF if the file size is unknown.
	if (!tokenizer.fileInfo.size) {
		tokenizer.fileInfo.size = Number.MAX_SAFE_INTEGER;
	}

	await tokenizer.peekBuffer(buffer, {length: bytesRead, mayBeLess: true});

	// -- 2-byte signatures --

	if (check([0x42, 0x4D])) {
		return {
			ext: 'bmp',
			mime: 'image/bmp'
		};
	}

	if (check([0x0B, 0x77])) {
		return {
			ext: 'ac3',
			mime: 'audio/vnd.dolby.dd-raw'
		};
	}

	if (check([0x78, 0x01])) {
		return {
			ext: 'dmg',
			mime: 'application/x-apple-diskimage'
		};
	}

	if (check([0x4D, 0x5A])) {
		return {
			ext: 'exe',
			mime: 'application/x-msdownload'
		};
	}

	if (check([0x25, 0x21])) {
		await tokenizer.peekBuffer(buffer, {length: 24, mayBeLess: true});

		if (checkString('PS-Adobe-', {offset: 2}) &&
			checkString(' EPSF-', {offset: 14})) {
			return {
				ext: 'eps',
				mime: 'application/eps'
			};
		}

		return {
			ext: 'ps',
			mime: 'application/postscript'
		};
	}

	if (
		check([0x1F, 0xA0]) ||
		check([0x1F, 0x9D])
	) {
		return {
			ext: 'Z',
			mime: 'application/x-compress'
		};
	}

	// -- 3-byte signatures --

	if (check([0xFF, 0xD8, 0xFF])) {
		return {
			ext: 'jpg',
			mime: 'image/jpeg'
		};
	}

	if (check([0x49, 0x49, 0xBC])) {
		return {
			ext: 'jxr',
			mime: 'image/vnd.ms-photo'
		};
	}

	if (check([0x1F, 0x8B, 0x8])) {
		return {
			ext: 'gz',
			mime: 'application/gzip'
		};
	}

	if (check([0x42, 0x5A, 0x68])) {
		return {
			ext: 'bz2',
			mime: 'application/x-bzip2'
		};
	}

	if (checkString('ID3')) {
		await tokenizer.ignore(6); // Skip ID3 header until the header size
		const id3HeaderLen = await tokenizer.readToken(uint32SyncSafeToken);
		if (tokenizer.position + id3HeaderLen > tokenizer.fileInfo.size) {
			// Guess file type based on ID3 header for backward compatibility
			return {
				ext: 'mp3',
				mime: 'audio/mpeg'
			};
		}

		await tokenizer.ignore(id3HeaderLen);
		return fromTokenizer(tokenizer); // Skip ID3 header, recursion
	}

	// Musepack, SV7
	if (checkString('MP+')) {
		return {
			ext: 'mpc',
			mime: 'audio/x-musepack'
		};
	}

	if (
		(buffer[0] === 0x43 || buffer[0] === 0x46) &&
		check([0x57, 0x53], {offset: 1})
	) {
		return {
			ext: 'swf',
			mime: 'application/x-shockwave-flash'
		};
	}

	// -- 4-byte signatures --

	if (check([0x47, 0x49, 0x46])) {
		return {
			ext: 'gif',
			mime: 'image/gif'
		};
	}

	if (checkString('FLIF')) {
		return {
			ext: 'flif',
			mime: 'image/flif'
		};
	}

	if (checkString('8BPS')) {
		return {
			ext: 'psd',
			mime: 'image/vnd.adobe.photoshop'
		};
	}

	if (checkString('WEBP', {offset: 8})) {
		return {
			ext: 'webp',
			mime: 'image/webp'
		};
	}

	// Musepack, SV8
	if (checkString('MPCK')) {
		return {
			ext: 'mpc',
			mime: 'audio/x-musepack'
		};
	}

	if (checkString('FORM')) {
		return {
			ext: 'aif',
			mime: 'audio/aiff'
		};
	}

	if (checkString('icns', {offset: 0})) {
		return {
			ext: 'icns',
			mime: 'image/icns'
		};
	}

	// Zip-based file formats
	// Need to be before the `zip` check
	if (check([0x50, 0x4B, 0x3, 0x4])) { // Local file header signature
		try {
			while (tokenizer.position + 30 < tokenizer.fileInfo.size) {
				await tokenizer.readBuffer(buffer, {length: 30});

				// https://en.wikipedia.org/wiki/Zip_(file_format)#File_headers
				const zipHeader = {
					compressedSize: buffer.readUInt32LE(18),
					uncompressedSize: buffer.readUInt32LE(22),
					filenameLength: buffer.readUInt16LE(26),
					extraFieldLength: buffer.readUInt16LE(28)
				};

				zipHeader.filename = await tokenizer.readToken(new Token.StringType(zipHeader.filenameLength, 'utf-8'));
				await tokenizer.ignore(zipHeader.extraFieldLength);

				// Assumes signed `.xpi` from addons.mozilla.org
				if (zipHeader.filename === 'META-INF/mozilla.rsa') {
					return {
						ext: 'xpi',
						mime: 'application/x-xpinstall'
					};
				}

				if (zipHeader.filename.endsWith('.rels') || zipHeader.filename.endsWith('.xml')) {
					const type = zipHeader.filename.split('/')[0];
					switch (type) {
						case '_rels':
							break;
						case 'word':
							return {
								ext: 'docx',
								mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
							};
						case 'ppt':
							return {
								ext: 'pptx',
								mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
							};
						case 'xl':
							return {
								ext: 'xlsx',
								mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
							};
						default:
							break;
					}
				}

				if (zipHeader.filename.startsWith('xl/')) {
					return {
						ext: 'xlsx',
						mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					};
				}

				if (zipHeader.filename.startsWith('3D/') && zipHeader.filename.endsWith('.model')) {
					return {
						ext: '3mf',
						mime: 'model/3mf'
					};
				}

				// The docx, xlsx and pptx file types extend the Office Open XML file format:
				// https://en.wikipedia.org/wiki/Office_Open_XML_file_formats
				// We look for:
				// - one entry named '[Content_Types].xml' or '_rels/.rels',
				// - one entry indicating specific type of file.
				// MS Office, OpenOffice and LibreOffice may put the parts in different order, so the check should not rely on it.
				if (zipHeader.filename === 'mimetype' && zipHeader.compressedSize === zipHeader.uncompressedSize) {
					const mimeType = await tokenizer.readToken(new Token.StringType(zipHeader.compressedSize, 'utf-8'));

					switch (mimeType) {
						case 'application/epub+zip':
							return {
								ext: 'epub',
								mime: 'application/epub+zip'
							};
						case 'application/vnd.oasis.opendocument.text':
							return {
								ext: 'odt',
								mime: 'application/vnd.oasis.opendocument.text'
							};
						case 'application/vnd.oasis.opendocument.spreadsheet':
							return {
								ext: 'ods',
								mime: 'application/vnd.oasis.opendocument.spreadsheet'
							};
						case 'application/vnd.oasis.opendocument.presentation':
							return {
								ext: 'odp',
								mime: 'application/vnd.oasis.opendocument.presentation'
							};
						default:
					}
				}

				// Try to find next header manually when current one is corrupted
				if (zipHeader.compressedSize === 0) {
					let nextHeaderIndex = -1;

					while (nextHeaderIndex < 0 && (tokenizer.position < tokenizer.fileInfo.size)) {
						await tokenizer.peekBuffer(buffer, {mayBeLess: true});

						nextHeaderIndex = buffer.indexOf('504B0304', 0, 'hex');
						// Move position to the next header if found, skip the whole buffer otherwise
						await tokenizer.ignore(nextHeaderIndex >= 0 ? nextHeaderIndex : buffer.length);
					}
				} else {
					await tokenizer.ignore(zipHeader.compressedSize);
				}
			}
		} catch (error) {
			if (!(error instanceof strtok3.EndOfStreamError)) {
				throw error;
			}
		}

		return {
			ext: 'zip',
			mime: 'application/zip'
		};
	}

	if (checkString('OggS')) {
		// This is an OGG container
		await tokenizer.ignore(28);
		const type = Buffer.alloc(8);
		await tokenizer.readBuffer(type);

		// Needs to be before `ogg` check
		if (_check(type, [0x4F, 0x70, 0x75, 0x73, 0x48, 0x65, 0x61, 0x64])) {
			return {
				ext: 'opus',
				mime: 'audio/opus'
			};
		}

		// If ' theora' in header.
		if (_check(type, [0x80, 0x74, 0x68, 0x65, 0x6F, 0x72, 0x61])) {
			return {
				ext: 'ogv',
				mime: 'video/ogg'
			};
		}

		// If '\x01video' in header.
		if (_check(type, [0x01, 0x76, 0x69, 0x64, 0x65, 0x6F, 0x00])) {
			return {
				ext: 'ogm',
				mime: 'video/ogg'
			};
		}

		// If ' FLAC' in header  https://xiph.org/flac/faq.html
		if (_check(type, [0x7F, 0x46, 0x4C, 0x41, 0x43])) {
			return {
				ext: 'oga',
				mime: 'audio/ogg'
			};
		}

		// 'Speex  ' in header https://en.wikipedia.org/wiki/Speex
		if (_check(type, [0x53, 0x70, 0x65, 0x65, 0x78, 0x20, 0x20])) {
			return {
				ext: 'spx',
				mime: 'audio/ogg'
			};
		}

		// If '\x01vorbis' in header
		if (_check(type, [0x01, 0x76, 0x6F, 0x72, 0x62, 0x69, 0x73])) {
			return {
				ext: 'ogg',
				mime: 'audio/ogg'
			};
		}

		// Default OGG container https://www.iana.org/assignments/media-types/application/ogg
		return {
			ext: 'ogx',
			mime: 'application/ogg'
		};
	}

	if (
		check([0x50, 0x4B]) &&
		(buffer[2] === 0x3 || buffer[2] === 0x5 || buffer[2] === 0x7) &&
		(buffer[3] === 0x4 || buffer[3] === 0x6 || buffer[3] === 0x8)
	) {
		return {
			ext: 'zip',
			mime: 'application/zip'
		};
	}

	//

	// File Type Box (https://en.wikipedia.org/wiki/ISO_base_media_file_format)
	// It's not required to be first, but it's recommended to be. Almost all ISO base media files start with `ftyp` box.
	// `ftyp` box must contain a brand major identifier, which must consist of ISO 8859-1 printable characters.
	// Here we check for 8859-1 printable characters (for simplicity, it's a mask which also catches one non-printable character).
	if (
		checkString('ftyp', {offset: 4}) &&
		(buffer[8] & 0x60) !== 0x00 // Brand major, first character ASCII?
	) {
		// They all can have MIME `video/mp4` except `application/mp4` special-case which is hard to detect.
		// For some cases, we're specific, everything else falls to `video/mp4` with `mp4` extension.
		const brandMajor = buffer.toString('binary', 8, 12).replace('\0', ' ').trim();
		switch (brandMajor) {
			case 'avif':
				return {ext: 'avif', mime: 'image/avif'};
			case 'mif1':
				return {ext: 'heic', mime: 'image/heif'};
			case 'msf1':
				return {ext: 'heic', mime: 'image/heif-sequence'};
			case 'heic':
			case 'heix':
				return {ext: 'heic', mime: 'image/heic'};
			case 'hevc':
			case 'hevx':
				return {ext: 'heic', mime: 'image/heic-sequence'};
			case 'qt':
				return {ext: 'mov', mime: 'video/quicktime'};
			case 'M4V':
			case 'M4VH':
			case 'M4VP':
				return {ext: 'm4v', mime: 'video/x-m4v'};
			case 'M4P':
				return {ext: 'm4p', mime: 'video/mp4'};
			case 'M4B':
				return {ext: 'm4b', mime: 'audio/mp4'};
			case 'M4A':
				return {ext: 'm4a', mime: 'audio/x-m4a'};
			case 'F4V':
				return {ext: 'f4v', mime: 'video/mp4'};
			case 'F4P':
				return {ext: 'f4p', mime: 'video/mp4'};
			case 'F4A':
				return {ext: 'f4a', mime: 'audio/mp4'};
			case 'F4B':
				return {ext: 'f4b', mime: 'audio/mp4'};
			case 'crx':
				return {ext: 'cr3', mime: 'image/x-canon-cr3'};
			default:
				if (brandMajor.startsWith('3g')) {
					if (brandMajor.startsWith('3g2')) {
						return {ext: '3g2', mime: 'video/3gpp2'};
					}

					return {ext: '3gp', mime: 'video/3gpp'};
				}

				return {ext: 'mp4', mime: 'video/mp4'};
		}
	}

	if (checkString('MThd')) {
		return {
			ext: 'mid',
			mime: 'audio/midi'
		};
	}

	if (
		checkString('wOFF') &&
		(
			check([0x00, 0x01, 0x00, 0x00], {offset: 4}) ||
			checkString('OTTO', {offset: 4})
		)
	) {
		return {
			ext: 'woff',
			mime: 'font/woff'
		};
	}

	if (
		checkString('wOF2') &&
		(
			check([0x00, 0x01, 0x00, 0x00], {offset: 4}) ||
			checkString('OTTO', {offset: 4})
		)
	) {
		return {
			ext: 'woff2',
			mime: 'font/woff2'
		};
	}

	if (check([0xD4, 0xC3, 0xB2, 0xA1]) || check([0xA1, 0xB2, 0xC3, 0xD4])) {
		return {
			ext: 'pcap',
			mime: 'application/vnd.tcpdump.pcap'
		};
	}

	// Sony DSD Stream File (DSF)
	if (checkString('DSD ')) {
		return {
			ext: 'dsf',
			mime: 'audio/x-dsf' // Non-standard
		};
	}

	if (checkString('LZIP')) {
		return {
			ext: 'lz',
			mime: 'application/x-lzip'
		};
	}

	if (checkString('fLaC')) {
		return {
			ext: 'flac',
			mime: 'audio/x-flac'
		};
	}

	if (check([0x42, 0x50, 0x47, 0xFB])) {
		return {
			ext: 'bpg',
			mime: 'image/bpg'
		};
	}

	if (checkString('wvpk')) {
		return {
			ext: 'wv',
			mime: 'audio/wavpack'
		};
	}

	if (checkString('%PDF')) {
		await tokenizer.ignore(1350);
		const maxBufferSize = 10 * 1024 * 1024;
		const buffer = Buffer.alloc(Math.min(maxBufferSize, tokenizer.fileInfo.size));
		await tokenizer.readBuffer(buffer, {mayBeLess: true});

		// Check if this is an Adobe Illustrator file
		if (buffer.includes(Buffer.from('AIPrivateData'))) {
			return {
				ext: 'ai',
				mime: 'application/postscript'
			};
		}

		// Assume this is just a normal PDF
		return {
			ext: 'pdf',
			mime: 'application/pdf'
		};
	}

	if (check([0x00, 0x61, 0x73, 0x6D])) {
		return {
			ext: 'wasm',
			mime: 'application/wasm'
		};
	}

	// TIFF, little-endian type
	if (check([0x49, 0x49, 0x2A, 0x0])) {
		if (checkString('CR', {offset: 8})) {
			return {
				ext: 'cr2',
				mime: 'image/x-canon-cr2'
			};
		}

		if (check([0x1C, 0x00, 0xFE, 0x00], {offset: 8}) || check([0x1F, 0x00, 0x0B, 0x00], {offset: 8})) {
			return {
				ext: 'nef',
				mime: 'image/x-nikon-nef'
			};
		}

		if (
			check([0x08, 0x00, 0x00, 0x00], {offset: 4}) &&
			(check([0x2D, 0x00, 0xFE, 0x00], {offset: 8}) ||
				check([0x27, 0x00, 0xFE, 0x00], {offset: 8}))
		) {
			return {
				ext: 'dng',
				mime: 'image/x-adobe-dng'
			};
		}

		buffer = Buffer.alloc(24);
		await tokenizer.peekBuffer(buffer);
		if (
			(check([0x10, 0xFB, 0x86, 0x01], {offset: 4}) || check([0x08, 0x00, 0x00, 0x00], {offset: 4})) &&
			// This pattern differentiates ARW from other TIFF-ish file types:
			check([0x00, 0xFE, 0x00, 0x04, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x03, 0x01], {offset: 9})
		) {
			return {
				ext: 'arw',
				mime: 'image/x-sony-arw'
			};
		}

		return {
			ext: 'tif',
			mime: 'image/tiff'
		};
	}

	// TIFF, big-endian type
	if (check([0x4D, 0x4D, 0x0, 0x2A])) {
		return {
			ext: 'tif',
			mime: 'image/tiff'
		};
	}

	if (checkString('MAC ')) {
		return {
			ext: 'ape',
			mime: 'audio/ape'
		};
	}

	// https://github.com/threatstack/libmagic/blob/master/magic/Magdir/matroska
	if (check([0x1A, 0x45, 0xDF, 0xA3])) { // Root element: EBML
		async function readField() {
			const msb = await tokenizer.peekNumber(Token.UINT8);
			let mask = 0x80;
			let ic = 0; // 0 = A, 1 = B, 2 = C, 3 = D

			while ((msb & mask) === 0 && mask !== 0) {
				++ic;
				mask >>= 1;
			}

			const id = Buffer.alloc(ic + 1);
			await tokenizer.readBuffer(id);
			return id;
		}

		async function readElement() {
			const id = await readField();
			const lenField = await readField();
			lenField[0] ^= 0x80 >> (lenField.length - 1);
			const nrLen = Math.min(6, lenField.length); // JavaScript can max read 6 bytes integer
			return {
				id: id.readUIntBE(0, id.length),
				len: lenField.readUIntBE(lenField.length - nrLen, nrLen)
			};
		}

		async function readChildren(level, children) {
			while (children > 0) {
				const e = await readElement();
				if (e.id === 0x4282) {
					return tokenizer.readToken(new Token.StringType(e.len, 'utf-8')); // Return DocType
				}

				await tokenizer.ignore(e.len); // ignore payload
				--children;
			}
		}

		const re = await readElement();
		const docType = await readChildren(1, re.len);

		switch (docType) {
			case 'webm':
				return {
					ext: 'webm',
					mime: 'video/webm'
				};

			case 'matroska':
				return {
					ext: 'mkv',
					mime: 'video/x-matroska'
				};

			default:
				return;
		}
	}

	// RIFF file format which might be AVI, WAV, QCP, etc
	if (check([0x52, 0x49, 0x46, 0x46])) {
		if (check([0x41, 0x56, 0x49], {offset: 8})) {
			return {
				ext: 'avi',
				mime: 'video/vnd.avi'
			};
		}

		if (check([0x57, 0x41, 0x56, 0x45], {offset: 8})) {
			return {
				ext: 'wav',
				mime: 'audio/vnd.wave'
			};
		}

		// QLCM, QCP file
		if (check([0x51, 0x4C, 0x43, 0x4D], {offset: 8})) {
			return {
				ext: 'qcp',
				mime: 'audio/qcelp'
			};
		}
	}

	if (checkString('SQLi')) {
		return {
			ext: 'sqlite',
			mime: 'application/x-sqlite3'
		};
	}

	if (check([0x4E, 0x45, 0x53, 0x1A])) {
		return {
			ext: 'nes',
			mime: 'application/x-nintendo-nes-rom'
		};
	}

	if (checkString('Cr24')) {
		return {
			ext: 'crx',
			mime: 'application/x-google-chrome-extension'
		};
	}

	if (
		checkString('MSCF') ||
		checkString('ISc(')
	) {
		return {
			ext: 'cab',
			mime: 'application/vnd.ms-cab-compressed'
		};
	}

	if (check([0xED, 0xAB, 0xEE, 0xDB])) {
		return {
			ext: 'rpm',
			mime: 'application/x-rpm'
		};
	}

	if (check([0xC5, 0xD0, 0xD3, 0xC6])) {
		return {
			ext: 'eps',
			mime: 'application/eps'
		};
	}

	if (check([0x28, 0xB5, 0x2F, 0xFD])) {
		return {
			ext: 'zst',
			mime: 'application/zstd'
		};
	}

	// -- 5-byte signatures --

	if (check([0x4F, 0x54, 0x54, 0x4F, 0x00])) {
		return {
			ext: 'otf',
			mime: 'font/otf'
		};
	}

	if (checkString('#!AMR')) {
		return {
			ext: 'amr',
			mime: 'audio/amr'
		};
	}

	if (checkString('{\\rtf')) {
		return {
			ext: 'rtf',
			mime: 'application/rtf'
		};
	}

	if (check([0x46, 0x4C, 0x56, 0x01])) {
		return {
			ext: 'flv',
			mime: 'video/x-flv'
		};
	}

	if (checkString('IMPM')) {
		return {
			ext: 'it',
			mime: 'audio/x-it'
		};
	}

	if (
		checkString('-lh0-', {offset: 2}) ||
		checkString('-lh1-', {offset: 2}) ||
		checkString('-lh2-', {offset: 2}) ||
		checkString('-lh3-', {offset: 2}) ||
		checkString('-lh4-', {offset: 2}) ||
		checkString('-lh5-', {offset: 2}) ||
		checkString('-lh6-', {offset: 2}) ||
		checkString('-lh7-', {offset: 2}) ||
		checkString('-lzs-', {offset: 2}) ||
		checkString('-lz4-', {offset: 2}) ||
		checkString('-lz5-', {offset: 2}) ||
		checkString('-lhd-', {offset: 2})
	) {
		return {
			ext: 'lzh',
			mime: 'application/x-lzh-compressed'
		};
	}

	// MPEG program stream (PS or MPEG-PS)
	if (check([0x00, 0x00, 0x01, 0xBA])) {
		//  MPEG-PS, MPEG-1 Part 1
		if (check([0x21], {offset: 4, mask: [0xF1]})) {
			return {
				ext: 'mpg', // May also be .ps, .mpeg
				mime: 'video/MP1S'
			};
		}

		// MPEG-PS, MPEG-2 Part 1
		if (check([0x44], {offset: 4, mask: [0xC4]})) {
			return {
				ext: 'mpg', // May also be .mpg, .m2p, .vob or .sub
				mime: 'video/MP2P'
			};
		}
	}

	if (checkString('ITSF')) {
		return {
			ext: 'chm',
			mime: 'application/vnd.ms-htmlhelp'
		};
	}

	// -- 6-byte signatures --

	if (check([0xFD, 0x37, 0x7A, 0x58, 0x5A, 0x00])) {
		return {
			ext: 'xz',
			mime: 'application/x-xz'
		};
	}

	if (checkString('<?xml ')) {
		return {
			ext: 'xml',
			mime: 'application/xml'
		};
	}

	if (check([0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C])) {
		return {
			ext: '7z',
			mime: 'application/x-7z-compressed'
		};
	}

	if (
		check([0x52, 0x61, 0x72, 0x21, 0x1A, 0x7]) &&
		(buffer[6] === 0x0 || buffer[6] === 0x1)
	) {
		return {
			ext: 'rar',
			mime: 'application/x-rar-compressed'
		};
	}

	if (checkString('solid ')) {
		return {
			ext: 'stl',
			mime: 'model/stl'
		};
	}

	// -- 7-byte signatures --

	if (checkString('BLENDER')) {
		return {
			ext: 'blend',
			mime: 'application/x-blender'
		};
	}

	if (checkString('!<arch>')) {
		await tokenizer.ignore(8);
		const str = await tokenizer.readToken(new Token.StringType(13, 'ascii'));
		if (str === 'debian-binary') {
			return {
				ext: 'deb',
				mime: 'application/x-deb'
			};
		}

		return {
			ext: 'ar',
			mime: 'application/x-unix-archive'
		};
	}

	// -- 8-byte signatures --

	if (check([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
		// APNG format (https://wiki.mozilla.org/APNG_Specification)
		// 1. Find the first IDAT (image data) chunk (49 44 41 54)
		// 2. Check if there is an "acTL" chunk before the IDAT one (61 63 54 4C)

		// Offset calculated as follows:
		// - 8 bytes: PNG signature
		// - 4 (length) + 4 (chunk type) + 13 (chunk data) + 4 (CRC): IHDR chunk

		await tokenizer.ignore(8); // ignore PNG signature

		async function readChunkHeader() {
			return {
				length: await tokenizer.readToken(Token.INT32_BE),
				type: await tokenizer.readToken(new Token.StringType(4, 'binary'))
			};
		}

		do {
			const chunk = await readChunkHeader();
			if (chunk.length < 0) {
				return; // Invalid chunk length
			}

			switch (chunk.type) {
				case 'IDAT':
					return {
						ext: 'png',
						mime: 'image/png'
					};
				case 'acTL':
					return {
						ext: 'apng',
						mime: 'image/apng'
					};
				default:
					await tokenizer.ignore(chunk.length + 4); // Ignore chunk-data + CRC
			}
		} while (tokenizer.position + 8 < tokenizer.fileInfo.size);

		return {
			ext: 'png',
			mime: 'image/png'
		};
	}

	if (check([0x41, 0x52, 0x52, 0x4F, 0x57, 0x31, 0x00, 0x00])) {
		return {
			ext: 'arrow',
			mime: 'application/x-apache-arrow'
		};
	}

	if (check([0x67, 0x6C, 0x54, 0x46, 0x02, 0x00, 0x00, 0x00])) {
		return {
			ext: 'glb',
			mime: 'model/gltf-binary'
		};
	}

	// `mov` format variants
	if (
		check([0x66, 0x72, 0x65, 0x65], {offset: 4}) || // `free`
		check([0x6D, 0x64, 0x61, 0x74], {offset: 4}) || // `mdat` MJPEG
		check([0x6D, 0x6F, 0x6F, 0x76], {offset: 4}) || // `moov`
		check([0x77, 0x69, 0x64, 0x65], {offset: 4}) // `wide`
	) {
		return {
			ext: 'mov',
			mime: 'video/quicktime'
		};
	}

	// -- 9-byte signatures --

	if (check([0x49, 0x49, 0x52, 0x4F, 0x08, 0x00, 0x00, 0x00, 0x18])) {
		return {
			ext: 'orf',
			mime: 'image/x-olympus-orf'
		};
	}

	if (checkString('gimp xcf ')) {
		return {
			ext: 'xcf',
			mime: 'image/x-xcf'
		};
	}

	// -- 12-byte signatures --

	if (check([0x49, 0x49, 0x55, 0x00, 0x18, 0x00, 0x00, 0x00, 0x88, 0xE7, 0x74, 0xD8])) {
		return {
			ext: 'rw2',
			mime: 'image/x-panasonic-rw2'
		};
	}

	// ASF_Header_Object first 80 bytes
	if (check([0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9])) {
		async function readHeader() {
			const guid = Buffer.alloc(16);
			await tokenizer.readBuffer(guid);
			return {
				id: guid,
				size: Number(await tokenizer.readToken(Token.UINT64_LE))
			};
		}

		await tokenizer.ignore(30);
		// Search for header should be in first 1KB of file.
		while (tokenizer.position + 24 < tokenizer.fileInfo.size) {
			const header = await readHeader();
			let payload = header.size - 24;
			if (_check(header.id, [0x91, 0x07, 0xDC, 0xB7, 0xB7, 0xA9, 0xCF, 0x11, 0x8E, 0xE6, 0x00, 0xC0, 0x0C, 0x20, 0x53, 0x65])) {
				// Sync on Stream-Properties-Object (B7DC0791-A9B7-11CF-8EE6-00C00C205365)
				const typeId = Buffer.alloc(16);
				payload -= await tokenizer.readBuffer(typeId);

				if (_check(typeId, [0x40, 0x9E, 0x69, 0xF8, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
					// Found audio:
					return {
						ext: 'asf',
						mime: 'audio/x-ms-asf'
					};
				}

				if (_check(typeId, [0xC0, 0xEF, 0x19, 0xBC, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
					// Found video:
					return {
						ext: 'asf',
						mime: 'video/x-ms-asf'
					};
				}

				break;
			}

			await tokenizer.ignore(payload);
		}

		// Default to ASF generic extension
		return {
			ext: 'asf',
			mime: 'application/vnd.ms-asf'
		};
	}

	if (check([0xAB, 0x4B, 0x54, 0x58, 0x20, 0x31, 0x31, 0xBB, 0x0D, 0x0A, 0x1A, 0x0A])) {
		return {
			ext: 'ktx',
			mime: 'image/ktx'
		};
	}

	if ((check([0x7E, 0x10, 0x04]) || check([0x7E, 0x18, 0x04])) && check([0x30, 0x4D, 0x49, 0x45], {offset: 4})) {
		return {
			ext: 'mie',
			mime: 'application/x-mie'
		};
	}

	if (check([0x27, 0x0A, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], {offset: 2})) {
		return {
			ext: 'shp',
			mime: 'application/x-esri-shape'
		};
	}

	if (check([0x00, 0x00, 0x00, 0x0C, 0x6A, 0x50, 0x20, 0x20, 0x0D, 0x0A, 0x87, 0x0A])) {
		// JPEG-2000 family

		await tokenizer.ignore(20);
		const type = await tokenizer.readToken(new Token.StringType(4, 'ascii'));
		switch (type) {
			case 'jp2 ':
				return {
					ext: 'jp2',
					mime: 'image/jp2'
				};
			case 'jpx ':
				return {
					ext: 'jpx',
					mime: 'image/jpx'
				};
			case 'jpm ':
				return {
					ext: 'jpm',
					mime: 'image/jpm'
				};
			case 'mjp2':
				return {
					ext: 'mj2',
					mime: 'image/mj2'
				};
			default:
				return;
		}
	}

	if (
		check([0xFF, 0x0A]) ||
		check([0x00, 0x00, 0x00, 0x0C, 0x4A, 0x58, 0x4C, 0x20, 0x0D, 0x0A, 0x87, 0x0A])
	) {
		return {
			ext: 'jxl',
			mime: 'image/jxl'
		};
	}

	// -- Unsafe signatures --

	if (
		check([0x0, 0x0, 0x1, 0xBA]) ||
		check([0x0, 0x0, 0x1, 0xB3])
	) {
		return {
			ext: 'mpg',
			mime: 'video/mpeg'
		};
	}

	if (check([0x00, 0x01, 0x00, 0x00, 0x00])) {
		return {
			ext: 'ttf',
			mime: 'font/ttf'
		};
	}

	if (check([0x00, 0x00, 0x01, 0x00])) {
		return {
			ext: 'ico',
			mime: 'image/x-icon'
		};
	}

	if (check([0x00, 0x00, 0x02, 0x00])) {
		return {
			ext: 'cur',
			mime: 'image/x-icon'
		};
	}

	if (check([0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1])) {
		// Detected Microsoft Compound File Binary File (MS-CFB) Format.
		return {
			ext: 'cfb',
			mime: 'application/x-cfb'
		};
	}

	// Increase sample size from 12 to 256.
	await tokenizer.peekBuffer(buffer, {length: Math.min(256, tokenizer.fileInfo.size), mayBeLess: true});

	// -- 15-byte signatures --

	if (checkString('BEGIN:')) {
		if (checkString('VCARD', {offset: 6})) {
			return {
				ext: 'vcf',
				mime: 'text/vcard'
			};
		}

		if (checkString('VCALENDAR', {offset: 6})) {
			return {
				ext: 'ics',
				mime: 'text/calendar'
			};
		}
	}

	// `raf` is here just to keep all the raw image detectors together.
	if (checkString('FUJIFILMCCD-RAW')) {
		return {
			ext: 'raf',
			mime: 'image/x-fujifilm-raf'
		};
	}

	if (checkString('Extended Module:')) {
		return {
			ext: 'xm',
			mime: 'audio/x-xm'
		};
	}

	if (checkString('Creative Voice File')) {
		return {
			ext: 'voc',
			mime: 'audio/x-voc'
		};
	}

	if (check([0x04, 0x00, 0x00, 0x00]) && buffer.length >= 16) { // Rough & quick check Pickle/ASAR
		const jsonSize = buffer.readUInt32LE(12);
		if (jsonSize > 12 && buffer.length >= jsonSize + 16) {
			try {
				const header = buffer.slice(16, jsonSize + 16).toString();
				const json = JSON.parse(header);
				// Check if Pickle is ASAR
				if (json.files) { // Final check, assuring Pickle/ASAR format
					return {
						ext: 'asar',
						mime: 'application/x-asar'
					};
				}
			} catch (_) {
			}
		}
	}

	if (check([0x06, 0x0E, 0x2B, 0x34, 0x02, 0x05, 0x01, 0x01, 0x0D, 0x01, 0x02, 0x01, 0x01, 0x02])) {
		return {
			ext: 'mxf',
			mime: 'application/mxf'
		};
	}

	if (checkString('SCRM', {offset: 44})) {
		return {
			ext: 's3m',
			mime: 'audio/x-s3m'
		};
	}

	if (check([0x47], {offset: 4}) && (check([0x47], {offset: 192}) || check([0x47], {offset: 196}))) {
		return {
			ext: 'mts',
			mime: 'video/mp2t'
		};
	}

	if (check([0x42, 0x4F, 0x4F, 0x4B, 0x4D, 0x4F, 0x42, 0x49], {offset: 60})) {
		return {
			ext: 'mobi',
			mime: 'application/x-mobipocket-ebook'
		};
	}

	if (check([0x44, 0x49, 0x43, 0x4D], {offset: 128})) {
		return {
			ext: 'dcm',
			mime: 'application/dicom'
		};
	}

	if (check([0x4C, 0x00, 0x00, 0x00, 0x01, 0x14, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x46])) {
		return {
			ext: 'lnk',
			mime: 'application/x.ms.shortcut' // Invented by us
		};
	}

	if (check([0x62, 0x6F, 0x6F, 0x6B, 0x00, 0x00, 0x00, 0x00, 0x6D, 0x61, 0x72, 0x6B, 0x00, 0x00, 0x00, 0x00])) {
		return {
			ext: 'alias',
			mime: 'application/x.apple.alias' // Invented by us
		};
	}

	if (
		check([0x4C, 0x50], {offset: 34}) &&
		(
			check([0x00, 0x00, 0x01], {offset: 8}) ||
			check([0x01, 0x00, 0x02], {offset: 8}) ||
			check([0x02, 0x00, 0x02], {offset: 8})
		)
	) {
		return {
			ext: 'eot',
			mime: 'application/vnd.ms-fontobject'
		};
	}

	if (check([0x06, 0x06, 0xED, 0xF5, 0xD8, 0x1D, 0x46, 0xE5, 0xBD, 0x31, 0xEF, 0xE7, 0xFE, 0x74, 0xB7, 0x1D])) {
		return {
			ext: 'indd',
			mime: 'application/x-indesign'
		};
	}

	// Increase sample size from 256 to 512
	await tokenizer.peekBuffer(buffer, {length: Math.min(512, tokenizer.fileInfo.size), mayBeLess: true});

	// Requires a buffer size of 512 bytes
	if (tarHeaderChecksumMatches(buffer)) {
		return {
			ext: 'tar',
			mime: 'application/x-tar'
		};
	}

	if (check([0xFF, 0xFE, 0xFF, 0x0E, 0x53, 0x00, 0x6B, 0x00, 0x65, 0x00, 0x74, 0x00, 0x63, 0x00, 0x68, 0x00, 0x55, 0x00, 0x70, 0x00, 0x20, 0x00, 0x4D, 0x00, 0x6F, 0x00, 0x64, 0x00, 0x65, 0x00, 0x6C, 0x00])) {
		return {
			ext: 'skp',
			mime: 'application/vnd.sketchup.skp'
		};
	}

	if (checkString('-----BEGIN PGP MESSAGE-----')) {
		return {
			ext: 'pgp',
			mime: 'application/pgp-encrypted'
		};
	}

	// Check MPEG 1 or 2 Layer 3 header, or 'layer 0' for ADTS (MPEG sync-word 0xFFE)
	if (buffer.length >= 2 && check([0xFF, 0xE0], {offset: 0, mask: [0xFF, 0xE0]})) {
		if (check([0x10], {offset: 1, mask: [0x16]})) {
			// Check for (ADTS) MPEG-2
			if (check([0x08], {offset: 1, mask: [0x08]})) {
				return {
					ext: 'aac',
					mime: 'audio/aac'
				};
			}

			// Must be (ADTS) MPEG-4
			return {
				ext: 'aac',
				mime: 'audio/aac'
			};
		}

		// MPEG 1 or 2 Layer 3 header
		// Check for MPEG layer 3
		if (check([0x02], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp3',
				mime: 'audio/mpeg'
			};
		}

		// Check for MPEG layer 2
		if (check([0x04], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp2',
				mime: 'audio/mpeg'
			};
		}

		// Check for MPEG layer 1
		if (check([0x06], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp1',
				mime: 'audio/mpeg'
			};
		}
	}
}

const stream = readableStream => new Promise((resolve, reject) => {
	// Using `eval` to work around issues when bundling with Webpack
	const stream = eval('require')('stream'); // eslint-disable-line no-eval

	readableStream.on('error', reject);
	readableStream.once('readable', async () => {
		// Set up output stream
		const pass = new stream.PassThrough();
		let outputStream;
		if (stream.pipeline) {
			outputStream = stream.pipeline(readableStream, pass, () => {
			});
		} else {
			outputStream = readableStream.pipe(pass);
		}

		// Read the input stream and detect the filetype
		const chunk = readableStream.read(minimumBytes) || readableStream.read() || Buffer.alloc(0);
		try {
			const fileType = await fromBuffer(chunk);
			pass.fileType = fileType;
		} catch (error) {
			reject(error);
		}

		resolve(outputStream);
	});
});

const fileType = {
	fromStream,
	fromTokenizer,
	fromBuffer,
	stream
};

Object.defineProperty(fileType, 'extensions', {
	get() {
		return new Set(supported.extensions);
	}
});

Object.defineProperty(fileType, 'mimeTypes', {
	get() {
		return new Set(supported.mimeTypes);
	}
});

module.exports = fileType;


/***/ }),

/***/ 97769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const strtok3 = __webpack_require__(26597);
const core = __webpack_require__(40001);

async function fromFile(path) {
	const tokenizer = await strtok3.fromFile(path);
	try {
		return await core.fromTokenizer(tokenizer);
	} finally {
		await tokenizer.close();
	}
}

const fileType = {
	fromFile
};

Object.assign(fileType, core);

Object.defineProperty(fileType, 'extensions', {
	get() {
		return core.extensions;
	}
});

Object.defineProperty(fileType, 'mimeTypes', {
	get() {
		return core.mimeTypes;
	}
});

module.exports = fileType;


/***/ }),

/***/ 49898:
/***/ ((module) => {

"use strict";


module.exports = {
	extensions: [
		'jpg',
		'png',
		'apng',
		'gif',
		'webp',
		'flif',
		'xcf',
		'cr2',
		'cr3',
		'orf',
		'arw',
		'dng',
		'nef',
		'rw2',
		'raf',
		'tif',
		'bmp',
		'icns',
		'jxr',
		'psd',
		'indd',
		'zip',
		'tar',
		'rar',
		'gz',
		'bz2',
		'7z',
		'dmg',
		'mp4',
		'mid',
		'mkv',
		'webm',
		'mov',
		'avi',
		'mpg',
		'mp2',
		'mp3',
		'm4a',
		'oga',
		'ogg',
		'ogv',
		'opus',
		'flac',
		'wav',
		'spx',
		'amr',
		'pdf',
		'epub',
		'exe',
		'swf',
		'rtf',
		'wasm',
		'woff',
		'woff2',
		'eot',
		'ttf',
		'otf',
		'ico',
		'flv',
		'ps',
		'xz',
		'sqlite',
		'nes',
		'crx',
		'xpi',
		'cab',
		'deb',
		'ar',
		'rpm',
		'Z',
		'lz',
		'cfb',
		'mxf',
		'mts',
		'blend',
		'bpg',
		'docx',
		'pptx',
		'xlsx',
		'3gp',
		'3g2',
		'jp2',
		'jpm',
		'jpx',
		'mj2',
		'aif',
		'qcp',
		'odt',
		'ods',
		'odp',
		'xml',
		'mobi',
		'heic',
		'cur',
		'ktx',
		'ape',
		'wv',
		'dcm',
		'ics',
		'glb',
		'pcap',
		'dsf',
		'lnk',
		'alias',
		'voc',
		'ac3',
		'm4v',
		'm4p',
		'm4b',
		'f4v',
		'f4p',
		'f4b',
		'f4a',
		'mie',
		'asf',
		'ogm',
		'ogx',
		'mpc',
		'arrow',
		'shp',
		'aac',
		'mp1',
		'it',
		's3m',
		'xm',
		'ai',
		'skp',
		'avif',
		'eps',
		'lzh',
		'pgp',
		'asar',
		'stl',
		'chm',
		'3mf',
		'zst',
		'jxl',
		'vcf'
	],
	mimeTypes: [
		'image/jpeg',
		'image/png',
		'image/gif',
		'image/webp',
		'image/flif',
		'image/x-xcf',
		'image/x-canon-cr2',
		'image/x-canon-cr3',
		'image/tiff',
		'image/bmp',
		'image/vnd.ms-photo',
		'image/vnd.adobe.photoshop',
		'application/x-indesign',
		'application/epub+zip',
		'application/x-xpinstall',
		'application/vnd.oasis.opendocument.text',
		'application/vnd.oasis.opendocument.spreadsheet',
		'application/vnd.oasis.opendocument.presentation',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'application/zip',
		'application/x-tar',
		'application/x-rar-compressed',
		'application/gzip',
		'application/x-bzip2',
		'application/x-7z-compressed',
		'application/x-apple-diskimage',
		'application/x-apache-arrow',
		'video/mp4',
		'audio/midi',
		'video/x-matroska',
		'video/webm',
		'video/quicktime',
		'video/vnd.avi',
		'audio/vnd.wave',
		'audio/qcelp',
		'audio/x-ms-asf',
		'video/x-ms-asf',
		'application/vnd.ms-asf',
		'video/mpeg',
		'video/3gpp',
		'audio/mpeg',
		'audio/mp4', // RFC 4337
		'audio/opus',
		'video/ogg',
		'audio/ogg',
		'application/ogg',
		'audio/x-flac',
		'audio/ape',
		'audio/wavpack',
		'audio/amr',
		'application/pdf',
		'application/x-msdownload',
		'application/x-shockwave-flash',
		'application/rtf',
		'application/wasm',
		'font/woff',
		'font/woff2',
		'application/vnd.ms-fontobject',
		'font/ttf',
		'font/otf',
		'image/x-icon',
		'video/x-flv',
		'application/postscript',
		'application/eps',
		'application/x-xz',
		'application/x-sqlite3',
		'application/x-nintendo-nes-rom',
		'application/x-google-chrome-extension',
		'application/vnd.ms-cab-compressed',
		'application/x-deb',
		'application/x-unix-archive',
		'application/x-rpm',
		'application/x-compress',
		'application/x-lzip',
		'application/x-cfb',
		'application/x-mie',
		'application/mxf',
		'video/mp2t',
		'application/x-blender',
		'image/bpg',
		'image/jp2',
		'image/jpx',
		'image/jpm',
		'image/mj2',
		'audio/aiff',
		'application/xml',
		'application/x-mobipocket-ebook',
		'image/heif',
		'image/heif-sequence',
		'image/heic',
		'image/heic-sequence',
		'image/icns',
		'image/ktx',
		'application/dicom',
		'audio/x-musepack',
		'text/calendar',
		'text/vcard',
		'model/gltf-binary',
		'application/vnd.tcpdump.pcap',
		'audio/x-dsf', // Non-standard
		'application/x.ms.shortcut', // Invented by us
		'application/x.apple.alias', // Invented by us
		'audio/x-voc',
		'audio/vnd.dolby.dd-raw',
		'audio/x-m4a',
		'image/apng',
		'image/x-olympus-orf',
		'image/x-sony-arw',
		'image/x-adobe-dng',
		'image/x-nikon-nef',
		'image/x-panasonic-rw2',
		'image/x-fujifilm-raf',
		'video/x-m4v',
		'video/3gpp2',
		'application/x-esri-shape',
		'audio/aac',
		'audio/x-it',
		'audio/x-s3m',
		'audio/x-xm',
		'video/MP1S',
		'video/MP2P',
		'application/vnd.sketchup.skp',
		'image/avif',
		'application/x-lzh-compressed',
		'application/pgp-encrypted',
		'application/x-asar',
		'model/stl',
		'application/vnd.ms-htmlhelp',
		'model/3mf',
		'image/jxl',
		'application/zstd'
	]
};


/***/ }),

/***/ 76188:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.stringToBytes = string => [...string].map(character => character.charCodeAt(0));

/**
Checks whether the TAR checksum is valid.

@param {Buffer} buffer - The TAR header `[offset ... offset + 512]`.
@param {number} offset - TAR header offset.
@returns {boolean} `true` if the TAR checksum is valid, otherwise `false`.
*/
exports.tarHeaderChecksumMatches = (buffer, offset = 0) => {
	const readSum = parseInt(buffer.toString('utf8', 148, 154).replace(/\0.*$/, '').trim(), 8); // Read sum in header
	if (isNaN(readSum)) {
		return false;
	}

	let sum = 8 * 0x20; // Initialize signed bit sum

	for (let i = offset; i < offset + 148; i++) {
		sum += buffer[i];
	}

	for (let i = offset + 156; i < offset + 512; i++) {
		sum += buffer[i];
	}

	return readSum === sum;
};

/**
ID3 UINT32 sync-safe tokenizer token.
28 bits (representing up to 256MB) integer, the msb is 0 to avoid "false syncsignals".
*/
exports.uint32SyncSafeToken = {
	get: (buffer, offset) => {
		return (buffer[offset + 3] & 0x7F) | ((buffer[offset + 2]) << 7) | ((buffer[offset + 1]) << 14) | ((buffer[offset]) << 21);
	},
	len: 4
};


/***/ }),

/***/ 17648:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();
var getDunderProto = __webpack_require__(96504);

var getProto = (typeof Reflect === 'function' && Reflect.getPrototypeOf)
	|| $Object.getPrototypeOf
	|| getDunderProto;

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 40690:
/***/ ((module) => {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ ((module) => {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 80645:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 59738:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.floor;


/***/ }),

/***/ 52264:
/***/ ((module) => {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ ((module) => {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ ((module) => {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 6840:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(16505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45801:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/svip_badage.fa062dc7.png","height":32,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/Ab/93FMCAgKaAgACEvz9/P/7+wYA/v8SAfn2CO7/9wJmAcb/4vPc2NYM3dHa/wYKFAEGCxsA29PX/ysjNQEvIzLzAcL/5PLh2eQNzcLY/wwNEwEaFSIA17y+/zctQgEmIir0AbP16VP++w6aAfoIEgLv/v8I9AAACfoCAQH5AO78+/9mEcZAwZw5emwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 37645:
/***/ ((module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 90480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * 全局接口 code 状态码定义
 */ const CODE = {
    /** 成功 */ OK: 0,
    /** 用户端-未登录 */ UNAUTHORIZED: [
        401
    ]
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CODE);


/***/ }),

/***/ 1880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": () => (/* binding */ getAppKey),
/* harmony export */   "Cu": () => (/* binding */ getIntranetHost),
/* harmony export */   "Em": () => (/* binding */ getWsHostname),
/* harmony export */   "OG": () => (/* binding */ getPrePageFix),
/* harmony export */   "R": () => (/* binding */ TITLE),
/* harmony export */   "SR": () => (/* binding */ WORKBENCH_DESCRIPTION),
/* harmony export */   "X6": () => (/* binding */ getPreFix),
/* harmony export */   "Z8": () => (/* binding */ WORKBENCH_KEYWORDS),
/* harmony export */   "ce": () => (/* binding */ MODULE_ID),
/* harmony export */   "cr": () => (/* binding */ MATRIX_CHANNEL),
/* harmony export */   "e3": () => (/* binding */ HOME_KEYWORDS),
/* harmony export */   "hg": () => (/* binding */ getPPTUrl),
/* harmony export */   "i4": () => (/* binding */ PREVIEW_MODE),
/* harmony export */   "jN": () => (/* binding */ HOME_DESCRIPTION),
/* harmony export */   "kU": () => (/* binding */ getClientID),
/* harmony export */   "vX": () => (/* binding */ SCENE),
/* harmony export */   "y$": () => (/* binding */ getDesignHome)
/* harmony export */ });
/* unused harmony exports CLIENT_ID, getApiHostForWeb */
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3269);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);


const MODULE_ID = "hbsj";
const SCENE = "aippt";
const CLIENT_ID = "1189857523";
const getClientID = ()=>{
    const query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_1__/* .getQuery */ .pm)();
    return (query === null || query === void 0 ? void 0 : query.clientId) || CLIENT_ID;
};
const getAppKey = (oid)=>{
    const identity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
    if (oid !== null && oid !== void 0 ? oid : identity === null || identity === void 0 ? void 0 : identity.oid) {
        return  true ? "3EDDE044EAA4A219" : 0;
    }
    return  true ? "C5F34252F04B6D50" : 0;
};
// 1 为(预发布+正式),0 或者不传 为正式模式
const PREVIEW_MODE =  true ? 0 : 0;
const MATRIX_CHANNEL = "mtsjs_web";
const getPreFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "";
    }
    return preFix;
};
const getPrePageFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return preFix;
};
const getPPTUrl = ()=>{
    return "https://".concat(getPrePageFix(), ".designkit.cn/ppt");
};
const getApiHostForWeb = ()=>{
    return "https://".concat(getPreFix(), "webapi.designkit.cn");
};
// api内网域名
const getIntranetHost = ()=>{
    // 开发环境继续走公网
    if (true) {
        return getApiHostForWeb();
    }
    return "http://".concat(getPreFix(), "webapi-pc.m.com");
};
const getWsHostname = ()=>{
    let preFix = "release";
    return preFix === "pre" ? "wss://prewebsocket-design.meitu.com" : preFix === "beta" ? "wss://betawebsocket-design.meitu.com" : "wss://websocket-design.meitu.com";
};
const getDesignHome = ()=>{
    if (false) {}
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return "https://".concat(preFix, ".designkit.cn");
};
const TITLE = "美图设计室LivePPT";
const WORKBENCH_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const WORKBENCH_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";
const HOME_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const HOME_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";


/***/ }),

/***/ 40313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": () => (/* binding */ UPLOAD_FILE_MEMBER_FORMAT),
/* harmony export */   "$p": () => (/* binding */ FOOTER_TABS),
/* harmony export */   "AI": () => (/* binding */ MTCCDataScene),
/* harmony export */   "Ag": () => (/* binding */ TIP_TEXT),
/* harmony export */   "G7": () => (/* binding */ TABS),
/* harmony export */   "H1": () => (/* binding */ generateMap),
/* harmony export */   "HZ": () => (/* binding */ FILE_TEXT_MAX_LEN),
/* harmony export */   "M4": () => (/* binding */ FooterTabKey),
/* harmony export */   "Mh": () => (/* binding */ lenMap),
/* harmony export */   "NG": () => (/* binding */ MIN_PAGE_COUNT),
/* harmony export */   "Ph": () => (/* binding */ MAX_PAGE_COUNT),
/* harmony export */   "Rc": () => (/* binding */ TabKey),
/* harmony export */   "WU": () => (/* binding */ StepType),
/* harmony export */   "aR": () => (/* binding */ RICH_TEXT_MAX_LEN),
/* harmony export */   "gA": () => (/* binding */ MTCCData),
/* harmony export */   "gV": () => (/* binding */ SDK_PLATFORM),
/* harmony export */   "pR": () => (/* binding */ BTN_UUID),
/* harmony export */   "pZ": () => (/* binding */ TRACK_MAP),
/* harmony export */   "pf": () => (/* binding */ MESSAGE_KEY),
/* harmony export */   "re": () => (/* binding */ PPTProcessStatus),
/* harmony export */   "sB": () => (/* binding */ SdkModuleName),
/* harmony export */   "xs": () => (/* binding */ Scene)
/* harmony export */ });
/* unused harmony exports DownloadImgType, DOWNLOAD_SELECT */
/* harmony import */ var _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45801);

var DownloadImgType;
(function(DownloadImgType) {
    DownloadImgType["jpg"] = "jpg";
    DownloadImgType["png"] = "png";
    DownloadImgType["ppt"] = "ppt";
    DownloadImgType["pdf"] = "pdf";
})(DownloadImgType || (DownloadImgType = {}));
const RICH_TEXT_MAX_LEN = 20000;
const BTN_UUID = "create_ppt_submit";
const FILE_TEXT_MAX_LEN = 30000;
var StepType;
(function(StepType) {
    StepType[StepType[/**
   * 前置输入，一句话，导入文件，粘贴文本
   */ "write"] = 0] = "write";
    StepType[StepType[/**
   * 生成大纲
   */ "outline"] = 1] = "outline";
    StepType[StepType[/**
   * 生成PPT
   */ "ppt"] = 2] = "ppt";
    StepType[StepType[/**
   * 选择模板
   */ "template"] = 3] = "template";
    StepType[StepType[/**
   * 分段分页
   */ "page"] = 4] = "page";
})(StepType || (StepType = {}));
var TabKey;
(function(TabKey) {
    TabKey["inAWord"] = "0";
    TabKey["pasteText"] = "1";
    TabKey["importFile"] = "2";
})(TabKey || (TabKey = {}));
const lenMap = {
    short: "1",
    medium: "2",
    long: "3"
};
const generateMap = {
    retain: "2",
    simplify: "1",
    expand: "3"
};
const TABS = [
    {
        key: TabKey.inAWord,
        icon: "MagicWandBold",
        title: "一句话生成"
    },
    {
        key: TabKey.pasteText,
        icon: "TextSquareBold",
        title: "已有文本生成"
    },
    {
        key: TabKey.importFile,
        icon: "UploadFlowBold",
        title: "导入文件生成",
        tag: _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
    }
];
var FooterTabKey;
(function(FooterTabKey) {
    FooterTabKey["record"] = "0";
    FooterTabKey["template"] = "1";
})(FooterTabKey || (FooterTabKey = {}));
const FOOTER_TABS = [
    {
        key: FooterTabKey.record,
        title: "历史记录",
        forceLogin: true
    },
    {
        key: FooterTabKey.template,
        title: "PPT模板"
    }
];
const TRACK_MAP = {
    [TabKey.inAWord]: "one_sentence_subject",
    [TabKey.pasteText]: "text_subject",
    [TabKey.importFile]: "upload_file"
};
const DOWNLOAD_SELECT = [
    {
        type: DownloadImgType.jpg,
        title: "JPG",
        message: "文件较小，不支持透明背景"
    },
    {
        type: DownloadImgType.png,
        title: "PNG",
        message: "无损图片，文件较大，不支持透明背景"
    },
    {
        type: DownloadImgType.ppt,
        title: "PPT",
        message: "文件较大，可编辑"
    },
    {
        type: DownloadImgType.pdf,
        title: "PDF",
        message: "比 PPT 文件大，不可编辑"
    }
];
var PPTProcessStatus;
(function(PPTProcessStatus) {
    PPTProcessStatus[PPTProcessStatus[// 不存在该记录
    "noExist"] = 0] = "noExist";
    PPTProcessStatus[PPTProcessStatus[// 投递成功待处理
    "pending"] = 1] = "pending";
    PPTProcessStatus[PPTProcessStatus[// 处理进行中
    "processing"] = 10] = "processing";
    PPTProcessStatus[PPTProcessStatus[// 处理失败
    "fail"] = 20] = "fail";
    PPTProcessStatus[PPTProcessStatus[// 处理成功
    "success"] = 30] = "success";
})(PPTProcessStatus || (PPTProcessStatus = {}));
const MESSAGE_KEY = "MESSAGE_KEY";
const MAX_PAGE_COUNT = 30;
const MIN_PAGE_COUNT = 1;
var SdkModuleName;
(function(SdkModuleName) {
    SdkModuleName["aippt"] = "aippt-sdk";
})(SdkModuleName || (SdkModuleName = {}));
var Scene;
(function(Scene) {
    Scene["AiPPT"] = "aippt";
})(Scene || (Scene = {}));
const SDK_PLATFORM = {
    "221": "roboneo"
};
const MTCCDataScene = {
    aippt: "00119"
};
// 成本分摊埋点 https://cf.meitu.com/confluence/pages/viewpage.action?pageId=416230853
const MTCCData = {
    // 生成完整 PPT
    "/ppt/apply": {
        positionKey: "",
        function: MTCCDataScene["aippt"],
        position: {
            default: MTCCDataScene["aippt"]
        }
    }
};
const TIP_TEXT = "您的内容已加密，生成后将自动删除";
/**
 * 上传文件需要会员的格式
 */ const UPLOAD_FILE_MEMBER_FORMAT = [
    "txt",
    "pdf",
    "docx"
];


/***/ }),

/***/ 16505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14222);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94501);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25344);
/* harmony import */ var _appLogic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95500);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_mtstat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32711);







// @ts-ignore
const WpsPayModal = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 6252).then(__webpack_require__.bind(__webpack_require__, 96252)).then((mod)=>mod.WpsPayModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96252)
            ]
    },
    ssr: false
});
Promise.all(/* import() */[__webpack_require__.e(650), __webpack_require__.e(938), __webpack_require__.e(982), __webpack_require__.e(9948)]).then(__webpack_require__.bind(__webpack_require__, 67055)).then((param)=>{
    let { initResignedListener  } = param;
    initResignedListener();
});
const MyApp = (param)=>{
    let { Component , pageProps  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(easy_peasy__WEBPACK_IMPORTED_MODULE_2__/* .StoreProvider */ .g3, {
        store: _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_appLogic__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WpsPayModal, {
                onStatTrack: _utils_mtstat__WEBPACK_IMPORTED_MODULE_6__/* .statTrack */ .SF
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...pageProps
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MyApp);


/***/ }),

/***/ 95500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ appLogic)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(32711);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/hooks/useWpsNavigationIntercept.js
var useWpsNavigationIntercept = __webpack_require__(1504);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/source.js + 1 modules
var source = __webpack_require__(27474);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js + 1 modules
var utils = __webpack_require__(59391);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
;// CONCATENATED MODULE: ./src/services/enterprise/index.ts



async function initEnterprise() {
    (0,configProvider/* setConfigPartial */.qK)({
        client_id: (0,constants/* getClientID */.kU)(),
        env: "release"
    });
    // 企业相关配置，目前主要使用到上传app
    const res = await (0,dist_teamInfo/* enterpriseInit */.P3)();
}
// 是否企业标识
const isEnterprise = ()=>!!getEnterpriseID();

// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/constants.js
/**
 * ABTest 环境变量
 */
var ABTestEnv;
(function (ABTestEnv) {
    /** 正式环境 */
    ABTestEnv["Release"] = "release";
    /** 测试环境 */
    ABTestEnv["Beta"] = "beta";
    /** 预发环境 */
    ABTestEnv["Test"] = "test";
})(ABTestEnv || (ABTestEnv = {}));
/**
 * ABTest code信息列表接口请求地址
 */
const ABTestApi = {
    [ABTestEnv.Release]: 'https://meepo.meitustat.com/ab_allot_web_v2',
    [ABTestEnv.Beta]: 'https://test-meepo.meitustat.com/ab_allot_web_v2', // https://api-mock.meitu-int.com/mock/14/ab_allot  http://test.meepo.meitustat.com/ab_allot_web
    [ABTestEnv.Test]: 'https://test-meepo.meitustat.com/ab_allot_web_v2'
};
/**
 * 本地存储 key
 *
 * @since 1.3.0
 *
 * @deprecated 已弃用，请改用 `cacheKey` 属性替代
 */
const LS_AB_TEST = 'abTest';
/**
 * 埋点统计sdk 存储的 本地缓存 为了取 wgid;
 *
 *  @since 1.3.0
 */
const MTSTAT_COOKIE_NAME = 'meitustat';
/**
 * ABTest Web 服务端设备标记 cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_WEB_SERVER_ID = '__mt_ab_test_wsid__';
/**
 * ABTest Web 服务端进入实验 code cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_SERVER_IN_TEST_CODE = '__mt_ab_test_server_codes__';
/**
 * 协议版本 目前 Web 是传 3
 */
const ProtocolVersion = 3;
/**
 * ABTest 进入实验 默认上报的事件名称
 */
const ABCODE_ENTER_TEST = 'abcode_enter_test';
/**
 * 控制台日志前缀
 *
 * @since 1.2.0
 */
const LOG_PREFIX = '[@meitu/ab-test]';
/**
 * 实验状态
 */
var ExperimentStatus;
(function (ExperimentStatus) {
    /** 已创建 */
    ExperimentStatus[ExperimentStatus["Created"] = 0] = "Created";
    /** 进行中 */
    ExperimentStatus[ExperimentStatus["InProgress"] = 1] = "InProgress";
    /** 已完成 */
    ExperimentStatus[ExperimentStatus["Completed"] = 2] = "Completed";
    /** 人为终止 */
    ExperimentStatus[ExperimentStatus["Terminated"] = 3] = "Terminated";
    /** 一键发布 */
    ExperimentStatus[ExperimentStatus["Publish"] = 4] = "Publish";
    /** 已发布 */
    ExperimentStatus[ExperimentStatus["Published"] = 5] = "Published";
    /** 已结束 */
    ExperimentStatus[ExperimentStatus["End"] = 6] = "End";
})(ExperimentStatus || (ExperimentStatus = {}));
/**
 * 实验类型
 */
var ExperimentType;
(function (ExperimentType) {
    /** 客户端实验 */
    ExperimentType[ExperimentType["Client"] = 1] = "Client";
    /** 客户端本地实验 */
    ExperimentType[ExperimentType["ClientLocal"] = 2] = "ClientLocal";
    /** 服务端实验 */
    ExperimentType[ExperimentType["Server"] = 3] = "Server";
    /** 异步实验-通用实验 */
    ExperimentType[ExperimentType["AsyncCommon"] = 4] = "AsyncCommon";
    /** 异步实验-push */
    ExperimentType[ExperimentType["AsyncPush"] = 5] = "AsyncPush";
    /** 异步实验-推荐 */
    ExperimentType[ExperimentType["AsyncRecommend"] = 6] = "AsyncRecommend";
})(ExperimentType || (ExperimentType = {}));
/**
 * 标识类型
 */
var IdentifyType;
(function (IdentifyType) {
    /** 用户id */
    IdentifyType["Uid"] = "type1";
    /** app gid */
    IdentifyType["AppGid"] = "type2";
    /** web gid */
    IdentifyType["WebGid"] = "type3";
    /** pc gid */
    IdentifyType["PcGid"] = "type4";
    /** Mac 地址 */
    IdentifyType["MacAddress"] = "type5";
    /**
     * Web 服务端设备标记
     *
     * @since 1.3.0
     **/
    IdentifyType["WebServerId"] = "type6";
})(IdentifyType || (IdentifyType = {}));

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/types.js

/**
 * 获取 ABTest 类的默认配置选项
 *
 * @since 1.2.0
 */
function getDefaultABTestOptions() {
    return {
        appKey: '',
        gid: '',
        wgid: '',
        custom: [],
        env: ABTestEnv.Release
    };
}
/**
 * 验证配置项是否有效
 *
 * @since 1.3.1
 */
function validateOptions(options) {
    var _a, _b;
    if (!((_b = (_a = options === null || options === void 0 ? void 0 : options.appKey) === null || _a === void 0 ? void 0 : _a.trim) === null || _b === void 0 ? void 0 : _b.call(_a))) {
        throw new Error('appKey 为必传参数');
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/utils.js
/**
 * 将字符串转成十六进制
 *
 * @param str 需要转成十六进制的字符串
 */
function strToHex(str) {
    let val = '';
    for (let i = 0; i < str.length; i++) {
        val += str.charCodeAt(i).toString(16);
    }
    return val.toUpperCase();
}
/**
 * 打平设备自定义标识数组
 *
 * @since 1.3.0
 */
function flatIdentify(custom) {
    return custom.reduce((acc, current) => {
        const { type, value } = current;
        acc[type] = value;
        return acc;
    }, {});
}
/**
 * 转换成特定的命名法
 * @param transform 转换函数
 * @param input 输入值
 *
 * @since 1.3.0
 */
function toSpecificCase(transform, input) {
    if (Array.isArray(input)) {
        return input.map(toSpecificCase.bind(null, transform));
    }
    if (typeof input === 'object' && input !== null) {
        return Object.keys(input).reduce((acc, key) => Object.assign(acc, {
            [transform(key)]: toSpecificCase(transform, input[key])
        }), {});
    }
    return input;
}
/**
 * 转换为小驼峰
 * @param input 输入
 *
 * @since 1.3.0
 * @example
 * // returns { eventProduct: '美图秀秀社区后台' }
 * // toCamelCase<{ eventProduct: string; }>({ event_product: '美图秀秀社区后台' })
 */
function toCamelCase(input) {
    return toSpecificCase(camelCase, input);
}
/**
 * 将给定的字符串转换为小驼峰
 */
function camelCase(str) {
    const words = str
        .replace(/[^a-zA-Z0-9]+/g, ' ')
        .split(' ')
        .filter(Boolean);
    return words
        .map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join('');
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/AbTest.js



/**
 * A/B 测试核心 / 基类
 */
class ABTestCore {
    /**
     * Web 服务端设备标记
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        return '';
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        return [];
    }
    constructor(options) {
        /**
         * ABTest 配置
         */
        this.options = getDefaultABTestOptions();
        /**
         * 是否已经初始化完成
         *
         * 异步请求 A/B 测试数据之后才能调用其他相关的接口
         *
         * @default false
         */
        this.initialize = false;
        this.options = Object.assign(Object.assign({}, this.options), options);
        validateOptions(this.options);
        this._storage = this.createStorageCache();
    }
    /**
     * 版本号
     *
     * @getter
     * @readonly
     * @since 1.2.0
     */
    get version() {
        return '1.3.1';
    }
    /**
     * 当前运行环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env || ABTestEnv.Release;
    }
    /**
     * 存储实例对象
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get storage() {
        return this._storage;
    }
    /**
     * 不同环境变量对应请求的 api 地址
     *
     * @getter
     * @readonly
     */
    get url() {
        return ABTestApi[this.env];
    }
    /**
     * 自定义设备标识列表
     *
     * @getter
     * @readonly
     */
    get custom() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.custom) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * 平铺后的自定义设备标识列表
     *
     * @getter
     * @readonly
     * @protected
     */
    get identifyMap() {
        return flatIdentify(this.custom);
    }
    /**
     * 本地存储 key
     *
     * 不同 appKey 之间对应不同的存储 key
     * @getter
     * @readonly
     * @since 1.3.1
     */
    get cacheKey() {
        return `${LS_AB_TEST}_${this.options.appKey}`;
    }
    /**
     * A/B 测试编码列表（本地缓存）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodes() {
        // 兼容旧数据
        const oldCodes = this.storage.getItem(LS_AB_TEST);
        return this.storage.getItem(this.cacheKey, oldCodes !== null && oldCodes !== void 0 ? oldCodes : []);
    }
    /**
     * A/B 测试编码列表映射对象（按 code）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodesMap() {
        return this.abCodes.reduce((codes, ab) => {
            codes[ab.abCode] = ab;
            return codes;
        }, {});
    }
    /**
     * 检查是否已经初始化完毕 ABTest SDK
     *
     * @since 1.3.0
     */
    checkHasInit(methodName = '该') {
        if (!this.initialize) {
            console.warn(LOG_PREFIX, `尚未初始化成功，请确保初始化完毕再调用 【${methodName}】 方法`);
        }
        return this.initialize;
    }
    /**
     * 判断当前 code 是否进入 A/B 实验当中
     *
     * @param code A/B 实验编码
     */
    isInABTesting(code) {
        var _a, _b;
        if (!this.checkHasInit('isInABTesting')) {
            return false;
        }
        const abCodes = this.abCodes;
        const index = abCodes.findIndex(({ abCode }) => abCode === code);
        if (index >= 0) {
            const count = ((_a = abCodes[index]) === null || _a === void 0 ? void 0 : _a.count) || 0;
            if (count === 0) {
                // 第一次进入实验 上报默认埋点事件 abcode_enter_test
                const code = ((_b = abCodes[index]) === null || _b === void 0 ? void 0 : _b.abCode) || 0;
                if (code) {
                    this.reportABCodeEnterTest(code);
                }
            }
            abCodes[index].count += 1;
            this.storage.setItem(this.cacheKey, abCodes); // count 进入实验后 自增 1 并更新本地缓存
            return true;
        }
        return false;
    }
    /**
     * 获取进入 A/B 测试实验的编码
     *
     * @param codes 做实验的整组 code [1001,1002,1003] | example: 实验组 1 code = 1001, 实验组 2 code = 1002, 对照组 3 code = 1003
     * @returns 返回命中的 AB Test code 值；返回值为 0 表示没有命中
     */
    inABTestingCode(codes) {
        if (!this.checkHasInit('inABTestingCode')) {
            return 0;
        }
        const codeMap = this.abCodesMap;
        const code = codes.find((code) => codeMap[code]);
        if (code) {
            this.isInABTesting(code); // 如果进入实验需要更新 本地 count 并上报默认事件
        }
        return code || 0;
    }
    /**
     * 获取服务端实验中的 A/B 测试编码列表
     */
    getABTestingServerCodes() {
        if (!this.checkHasInit('getABTestingServerCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, et: experimentType } = current;
            const types = [
                ExperimentType.Server,
                ExperimentType.AsyncCommon,
                ExperimentType.AsyncPush,
                ExperimentType.AsyncRecommend
            ];
            if (types.indexOf(experimentType) >= 0) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
    /**
     * 设置服务端实验中的 A/B 测试码
     *
     * 更新本地缓存中对应实验中 count 计数 目前 count 由前端维护 代表进入实验的次数
     *
     * 作用：
     *
     * 1. `count` => 1 需要上报，默认的 `abcode_enter_test` 事件 通过埋点sdk 上报 当作进入实验的指标
     * 2. 预留以后需要统计进入`实验次数`这个口子
     *
     */
    setABTestingServerCodes(codes) {
        if (!(codes === null || codes === void 0 ? void 0 : codes.length)) {
            console.warn(LOG_PREFIX, `setABTestingServerCodes: codes is empty`);
            return;
        }
        if (!this.checkHasInit('setABTestingServerCodes')) {
            return;
        }
        codes.forEach((code) => {
            this.isInABTesting(code);
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const codes = this.abCodes.reduce((acc, { abCode, status, count }) => {
            if (status === ExperimentStatus.InProgress) {
                acc.push({
                    code: abCode,
                    count
                });
            }
            return acc;
        }, []);
        return {
            // eslint-disable-next-line camelcase
            ab_codes: codes, // 此处用 snakeCase 是为了用户调用接口获取到的数据，可以直接用作 WebSDK 上报的行为日志
            version: this.version
        };
    }
    /**
     * 设置本地缓存 abCodes 信息
     *
     * @protected
     * @since 1.3.0
     */
    cacheABInfo(codes = []) {
        const codeMap = this.abCodesMap;
        const abInfo = codes.map(({ abCode, et, status, v }) => {
            const localABInfo = ((codeMap === null || codeMap === void 0 ? void 0 : codeMap[abCode]) || {});
            const count = (localABInfo === null || localABInfo === void 0 ? void 0 : localABInfo.v) === v ? localABInfo.count || 0 : 0; // 当版本变更时需要重置 count 为 0；
            return {
                abCode,
                et,
                status,
                v,
                count
            };
        });
        this.storage.setItem(this.cacheKey, abInfo); // 设置本地缓存
    }
    /**
     * 生成请求 ABCode 接口参数
     *
     * @protected
     */
    toQueryParams() {
        const { identifyMap } = this;
        const { appKey, gid, uid } = this.options;
        const result = {
            appKey,
            version: ProtocolVersion
        };
        if (gid) {
            result[IdentifyType.AppGid] = gid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        if (uid) {
            result[IdentifyType.Uid] = uid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        return Object.assign(Object.assign({}, result), identifyMap);
    }
    /**
     * 获取所有实验中的 A/B 测试编码列表
     */
    getABTestingCodes() {
        if (!this.checkHasInit('getABTestingCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, status } = current;
            if (status === ExperimentStatus.InProgress) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/index.js





// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/storage.js
const storage = typeof window !== 'undefined' && window.localStorage;
/**
 * 设置本地存储项
 * @param key 键
 * @param value 值
 */
function setItem(key, value) {
    storage.setItem(key, JSON.stringify(value === undefined ? null : value));
}
/**
 * 获取本地存储项
 * @param key 键
 */
function getItem(key, defaultValue) {
    try {
        const item = storage.getItem(key);
        const value = item == null ? null : JSON.parse(item);
        return value !== null && value !== void 0 ? value : defaultValue;
    }
    catch (err) {
        return defaultValue;
    }
}
/**
 * 移除本地存储项
 * @param key 键
 */
function removeItem(key) {
    storage.removeItem(key);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/AbTest.js

/// <reference types="@meitu/mtstat-sdk" />



/**
 * A/B 测试类
 */
class ABTest extends ABTestCore {
    /**
     * 通过埋点统计 Web SDK 生成的设备标识
     *
     * @getter
     * @readonly
     */
    get wgid() {
        var _a, _b;
        let webGid = '';
        try {
            webGid = (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.getDeviceId();
        }
        catch (err) {
            console.warn(err);
        }
        return (((_b = this.identifyMap) === null || _b === void 0 ? void 0 : _b[IdentifyType.WebGid]) || webGid) + ''; // 默认使用 WebSDK 里的 wgid,如果自定传入 wgid 的话再覆盖
    }
    /**
     * Web 服务端设备标记
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        var _a, _b;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.wsid) {
            return (_b = this.options) === null || _b === void 0 ? void 0 : _b.wsid;
        }
        const webServerIdValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_WEB_SERVER_ID) || '';
        try {
            const value = JSON.parse(webServerIdValue);
            return value[this.options.appKey] || '';
        }
        catch (error) {
            console.warn(error);
            return webServerIdValue;
        }
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        var _a, _b;
        const codesValue = (_a = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE)) !== null && _a !== void 0 ? _a : '';
        let abCodes = [];
        if (!codesValue) {
            return abCodes;
        }
        try {
            const value = JSON.parse(codesValue);
            abCodes = Array.isArray(value)
                ? value
                : (_b = value[this.options.appKey]) !== null && _b !== void 0 ? _b : [];
        }
        catch (error) {
            console.warn(error);
        }
        return abCodes;
    }
    createStorageCache() {
        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        };
    }
    /**
     * 合并目标 ABTestCode 数组与结果 ABTestCode 数组。
     *
     * @since 1.3.0
     */
    mergeAbTestCodes(abCodes, target) {
        const map = abCodes.reduce((acc, item) => {
            acc[item.abCode] = Object.assign({ count: 0 }, item);
            return acc;
        }, {});
        target.forEach((item) => {
            if (!map[item.abCode]) {
                // 没有的话，直接添加
                map[item.abCode] = Object.assign(Object.assign({}, item), { count: 0 });
            }
        });
        return Object.values(map);
    }
    // 保证主包 JS API 文档的正确生成
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            let abCodes = [];
            // 保证初始化【埋点统计SDK】并生成 wgid 之后再初始化【ABTest SDK】
            if (window.mtstat &&
                typeof window.mtstat.init === 'function' &&
                this.wgid) {
                try {
                    const abInfo = yield this.fetchABCodes(); // 获取服务端abCodes
                    abCodes = this.mergeAbTestCodes(abInfo.abCodes, this.webServerTestCodes);
                }
                catch (err) {
                    console.error(err);
                }
                this.cacheABInfo(abCodes); // 设置本地缓存
                // 在这里先设置初始化完毕是为了能够在 setABTestingServerCodes 中 count + 1，让后上报
                this.initialize = true; // 初始化完毕
                if (this.webServerTestCodes.length) {
                    if (this.webServerId) {
                        // 有接收服务器给的 ab code 时，需要提前设置 abInfo 后续才能上报
                        const abInfo = this.getABInfo();
                        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.setABInfo(abInfo);
                    }
                    // 有接收服务器给的 ab code 时，需要 count + 1
                    this.setABTestingServerCodes(this.webServerTestCodes.map((item) => item.abCode));
                    try {
                        const codesValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        const value = JSON.parse(codesValue);
                        if (Array.isArray(value)) {
                            js_cookie/* default.remove */.Z.remove(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        }
                        else {
                            delete value[this.options.appKey];
                            js_cookie/* default.set */.Z.set(COOKIE_NAME_SERVER_IN_TEST_CODE, JSON.stringify(value));
                        }
                    }
                    catch (error) {
                        console.warn(error);
                    }
                }
            }
            else {
                console.warn(LOG_PREFIX, '请确保先引入埋点统计 JS SDK（@meitu/mtstat-sdk），并调用 mtstat.init() 初始化之后，再进行 ABTest SDK 的初始化');
            }
            return abCodes;
        });
    }
    fetchABCodes() {
        if (typeof fetch === 'undefined') {
            throw new Error('Fetch API undefined');
        }
        const postData = this.toQueryParams();
        if (this.webServerId) {
            postData[IdentifyType.WebServerId] = this.webServerId;
        }
        const hexStr = strToHex(JSON.stringify(Object.assign(Object.assign({}, postData), { [IdentifyType.WebGid]: this.wgid })));
        return new Promise((resolve, reject) => {
            fetch === null || fetch === void 0 ? void 0 : fetch(this.url, {
                method: 'POST',
                body: hexStr
            }).then((res) => (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
                const result = yield res.json();
                resolve(toCamelCase(result));
            })).catch((error) => reject(error));
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const abInfo = super.getABInfo();
        return this.webServerId
            ? Object.assign(Object.assign({}, abInfo), { 
                // eslint-disable-next-line camelcase
                ab_wsid: this.webServerId }) : abInfo;
    }
    /**
     * 第一次进入实验 上报默认埋点事件 `abcode_enter_test`
     *
     * 埋点事件数据示例：`{event_id: "abcode_enter_test", params: { current_abcode: 100x }}`
     */
    reportABCodeEnterTest(code) {
        var _a;
        if (!this.checkHasInit('reportABCodeEnterTest')) {
            return;
        }
        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.track(ABCODE_ENTER_TEST, {
            // eslint-disable-next-line camelcase
            current_abcode: code
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test/dist/esm/index.js


;// CONCATENATED MODULE: ./src/utils/abtest.ts

let abInfo = {};
let abTest = null;
const initABTest = async ()=>{
    var // 通过websdk 设置ab_info的信息
    ref;
    const abTestParams = {
        /** Web项目id */ appKey: "C5F34252F04B6D50",
        /** 环境变量 不传默认选择正式环境*/ env: ABTestEnv.Release
    };
    // 实例化 ABTest SDK
    const abTestInstance = new ABTest(abTestParams);
    await abTestInstance.init(); // 初始化 ABTest SDK
    abTest = abTestInstance;
    abInfo = abTest.getABInfo();
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setABInfo(abInfo);
};
const getAbInfo = ()=>{
    return abInfo;
};
/**
 * 是否开启deepsSeek
 */ const isOpenDeepSeek = async ()=>{
    if (!abTest) await initABTest();
    // 对照组，默认开启
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(25314)) {
        ;
        return true;
    }
    // 实验组，默认关闭
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(25315)) {
        ;
        return false;
    }
    ;
    return true;
};
/**
 * ppt商业化
 */ const isOpenPptCommercialization = async ()=>{
    if (!abTest) await initABTest();
    // 对照组，默认关闭
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27220)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: false
        };
    }
    // 实验组1
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27221)) {
        return {
            isHitGroupOne: true,
            isHitGroupTwo: false
        };
    }
    // 实验组2
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27222)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: true
        };
    }
    return {
        isHitGroupOne: false,
        isHitGroupTwo: false
    };
};

// EXTERNAL MODULE: ./src/utils/sdk.ts
var sdk = __webpack_require__(82345);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(38389);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/types.js
var RecentFeatureKey = /*#__PURE__*/ function(RecentFeatureKey) {
    RecentFeatureKey["CutOut"] = "cutOut";
    RecentFeatureKey["Eliminate"] = "eliminate";
    RecentFeatureKey["HD"] = "hd";
    RecentFeatureKey["ProductSetImages"] = "productSetImages";
    RecentFeatureKey["LongPicturePoster"] = "longPicturePoster";
    RecentFeatureKey["ClothSetImages"] = "clothSetImages";
    RecentFeatureKey["IDPhoto"] = "idPhoto";
    RecentFeatureKey["Portrait"] = "portrait";
    RecentFeatureKey["LivePPT"] = "livePPT";
    RecentFeatureKey["AiProducts"] = "aiProducts";
    RecentFeatureKey["Puzzle"] = "puzzle";
    RecentFeatureKey["BatchProcess"] = "batchProcess";
    RecentFeatureKey["Upscale"] = "upscale";
    RecentFeatureKey["AiModel"] = "aiModel";
    RecentFeatureKey["AiFitting"] = "aiFitting";
    RecentFeatureKey["AiLogo"] = "aiLogo";
    RecentFeatureKey["AiShoes"] = "aiShoes";
    RecentFeatureKey["AiCopywriting"] = "aiCopywriting";
    RecentFeatureKey["AiPoster"] = "aiPoster";
    RecentFeatureKey["PhotoEditor"] = "photoEditor";
    RecentFeatureKey["Design"] = "design";
    RecentFeatureKey["ClothesWrinkle"] = "clothesWrinkle";
    RecentFeatureKey["ClothesRecolor"] = "clothesRecolor";
    RecentFeatureKey["PortraitBackground"] = "portraitBackground";
    RecentFeatureKey["AiProductVideo"] = "aiProductVideo";
    RecentFeatureKey["AiPosterNote"] = "aiPosterNote";
    return RecentFeatureKey;
}({});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/constants.js

var _RECENT_FEATURE_META;

var constants_RECENT_FEATURE_COOKIE_KEY = "xdesign_recent_features_v1";
/** @deprecated 请改用 RECENT_FEATURE_COOKIE_KEY */ var RECENT_FEATURE_STORAGE_KEY = (/* unused pure expression or super */ null && (constants_RECENT_FEATURE_COOKIE_KEY));
var constants_DEFAULT_RECENT_FEATURE_LIMIT = 10;
var RECENT_FEATURE_COOKIE_EXPIRES_DAYS = 365;
var constants_RECENT_FEATURE_META = (_RECENT_FEATURE_META = {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.CutOut, {
    name: "智能抠图",
    icon: "CutOut",
    url: "/cutout/edit"
}), RecentFeatureKey.Eliminate, {
    name: "AI消除",
    icon: "Eliminate",
    url: "/aieraser"
}), RecentFeatureKey.HD, {
    name: "变清晰",
    icon: "Hd",
    url: "/quality"
}), RecentFeatureKey.ProductSetImages, {
    name: "商品套图",
    icon: "ProductSetImages",
    url: "/product-kit"
}), RecentFeatureKey.LongPicturePoster, {
    name: "A+/详情页",
    icon: "LongPicturePoster",
    url: "/product-kit/detailpage"
}), RecentFeatureKey.ClothSetImages, {
    name: "穿戴套图",
    icon: "ClothSetImages",
    url: "/product-kit/try-on"
}), RecentFeatureKey.IDPhoto, {
    name: "证件照",
    icon: "IDPhoto",
    url: "/certified"
}), RecentFeatureKey.Portrait, {
    name: "形象照",
    icon: "IDPhoto",
    url: "/portrait-photo"
}), RecentFeatureKey.LivePPT, {
    name: "LivePPT",
    icon: "Ppt",
    url: "/ppt/edit"
}), RecentFeatureKey.AiProducts, {
    name: "AI商品图",
    icon: "AiProducts",
    url: "/product-shoot-editor"
}), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.Puzzle, {
    name: "拼图",
    icon: "Jigsaw",
    url: "/puzzle"
}), RecentFeatureKey.BatchProcess, {
    name: "图片批处理",
    icon: "Batch",
    url: "/bulk-ai-editor"
}), RecentFeatureKey.AiModel, {
    name: "AI模特",
    icon: "AiModel",
    url: "/model"
}), RecentFeatureKey.Upscale, {
    name: "无损改尺寸",
    icon: "LosslessAmplification",
    url: "/upscale"
}), RecentFeatureKey.AiFitting, {
    name: "AI试衣",
    icon: "Suit",
    url: "/clothes"
}), RecentFeatureKey.AiLogo, {
    name: "AI Logo",
    icon: "Logo",
    url: "/logo-design"
}), RecentFeatureKey.AiShoes, {
    name: "AI试鞋",
    icon: "Shoes",
    url: "/shoes"
}), RecentFeatureKey.AiCopywriting, {
    name: "AI文案",
    icon: "AiFile",
    url: "/copywriting"
}), RecentFeatureKey.AiPoster, {
    name: "AI海报",
    icon: "AiPoster",
    url: "/poster"
}), RecentFeatureKey.PhotoEditor, {
    name: "图片编辑",
    icon: "Picture",
    url: "/editor"
}), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.Design, {
    name: "在线设计",
    icon: "FrameToPoster",
    url: "/design"
}), RecentFeatureKey.ClothesWrinkle, {
    name: "服装去皱",
    icon: "Clothes",
    url: "/rmwrinkle"
}), RecentFeatureKey.ClothesRecolor, {
    name: "服装换色",
    icon: "AiVirtualTryOn",
    url: "/recolor"
}), RecentFeatureKey.PortraitBackground, {
    name: "人像背景",
    icon: "PortraitBackground",
    url: "/person-shoot"
}), RecentFeatureKey.AiProductVideo, {
    name: "AI带货视频",
    icon: "Video",
    url: "/marketingvideo"
}), RecentFeatureKey.AiPosterNote, {
    name: "AI图文笔记",
    icon: "Poster",
    url: "/post-gen"
}));
var RECENT_FEATURE_KEY_SET = new Set(Object.values(RecentFeatureKey));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/storage.js




var memoryData = null;
var persistScheduled = false;
var isBrowser = function isBrowser() {
    return  true && typeof document !== "undefined";
};
var isRecentFeatureKey = function isRecentFeatureKey(key) {
    return RECENT_FEATURE_KEY_SET.has(key);
};
var normalizeRecord = function normalizeRecord(input) {
    if (!input || (0,esm_typeof/* default */.Z)(input) !== "object") return {};
    return Object.entries(input).reduce(function(acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!isRecentFeatureKey(key)) return acc;
        var timestamp = Number(value);
        if (!Number.isFinite(timestamp) || timestamp <= 0) return acc;
        acc[key] = timestamp;
        return acc;
    }, {});
};
var getCookieValue = function getCookieValue(cookie) {
    void cookie;
    if (!isBrowser()) return undefined;
    try {
        return js_cookie/* default.get */.Z.get(constants_RECENT_FEATURE_COOKIE_KEY);
    } catch (error) {
        return undefined;
    }
};
var loadFromCookie = function loadFromCookie(cookie) {
    try {
        var raw = getCookieValue(cookie);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        if (!parsed || (0,esm_typeof/* default */.Z)(parsed) !== "object") return {};
        if ("data" in parsed) {
            return normalizeRecord(parsed.data);
        }
        return normalizeRecord(parsed);
    } catch (error) {
        return {};
    }
};
var getMemoryData = function getMemoryData(cookie) {
    if (!isBrowser()) return {};
    if (memoryData) return memoryData;
    memoryData = loadFromCookie(cookie);
    return memoryData;
};
var persistToCookie = function persistToCookie() {
    persistScheduled = false;
    if (!isBrowser()) return;
    try {
        var payload = {
            version: 1,
            data: getMemoryData()
        };
        js_cookie/* default.set */.Z.set(constants_RECENT_FEATURE_COOKIE_KEY, JSON.stringify(payload), {
            expires: RECENT_FEATURE_COOKIE_EXPIRES_DAYS,
            path: "/",
            sameSite: "lax"
        });
    } catch (error) {
    /* noop */ }
};
var schedulePersist = function schedulePersist() {
    if (!isBrowser()) return;
    if (persistScheduled) return;
    persistScheduled = true;
    if ("requestIdleCallback" in window) {
        window.requestIdleCallback(function() {
            persistToCookie();
        });
        return;
    }
    setTimeout(function() {
        persistToCookie();
    }, 0);
};
var normalizeLimit = function normalizeLimit(limit) {
    if (!Number.isFinite(limit)) return DEFAULT_RECENT_FEATURE_LIMIT;
    var normalized = Math.floor(limit);
    return normalized > 0 ? normalized : 0;
};
var markRecentFeature = function markRecentFeature(key) {
    var lastUsedAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    if (!constants_RECENT_FEATURE_META[key]) return;
    if (!isBrowser()) return;
    getMemoryData()[key] = lastUsedAt;
    schedulePersist();
};
var normalizeGetRecentFeaturesOptions = function normalizeGetRecentFeaturesOptions(options) {
    var _options$limit;
    if (typeof options === "number") {
        return {
            limit: normalizeLimit(options),
            cookie: undefined
        };
    }
    return {
        limit: normalizeLimit((_options$limit = options === null || options === void 0 ? void 0 : options.limit) !== null && _options$limit !== void 0 ? _options$limit : DEFAULT_RECENT_FEATURE_LIMIT),
        cookie: options === null || options === void 0 ? void 0 : options.cookie
    };
};
var getRecentFeatures = function getRecentFeatures(options) {
    var _normalizeGetRecentFe = normalizeGetRecentFeaturesOptions(options), limit = _normalizeGetRecentFe.limit;
    var normalizedLimit = limit;
    if (normalizedLimit === 0) return [];
    return Object.entries(getMemoryData()).filter(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], lastUsedAt = _ref4[1];
        return isRecentFeatureKey(key) && Number.isFinite(lastUsedAt);
    }).sort(function(_ref5, _ref6) {
        var _ref7 = _slicedToArray(_ref5, 2), leftTime = _ref7[1];
        var _ref8 = _slicedToArray(_ref6, 2), rightTime = _ref8[1];
        return Number(rightTime) - Number(leftTime);
    }).slice(0, normalizedLimit).map(function(_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2), key = _ref10[0], lastUsedAt = _ref10[1];
        var featureKey = key;
        var meta = RECENT_FEATURE_META[featureKey];
        return {
            key: featureKey,
            name: meta.name,
            icon: meta.icon,
            url: meta.url,
            lastUsedAt: Number(lastUsedAt)
        };
    });
};
var clearRecentFeatures = function clearRecentFeatures() {
    memoryData = {};
    if (!isBrowser()) return;
    try {
        Cookies.remove(RECENT_FEATURE_COOKIE_KEY, {
            path: "/"
        });
    } catch (error) {
    /* noop */ }
};

// EXTERNAL MODULE: ./src/utils/login.tsx + 6 modules
var login = __webpack_require__(71231);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(19945);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(70072);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var request = __webpack_require__(57526);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/api.js



/**
 * 商业存储摘要接口返回（后端字段）。
 */ /**
 * 获取商业存储摘要信息。
 * docs: https://api-mock.meitu-int.com/project/2110/interface/api/226590
 */ var fetchStorageCostSummary = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,request/* default */.ZP)("/v1/my_space/summary", {
                        method: "GET"
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchStorageCostSummary() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js + 1 modules
var createModalComponent = __webpack_require__(69289);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/components/storageCostAlertModal/index.less
var storageCostAlertModal = __webpack_require__(91611);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/components/storageCostAlertModal/index.js





var StorageCostAlertModalInner = function StorageCostAlertModalInner(_ref) {
    var iconColor = _ref.iconColor, title = _ref.title, description = _ref.description, onClose = _ref.onClose, setMode = _ref.setMode, primaryAction = _ref.primaryAction, secondaryAction = _ref.secondaryAction;
    var handleClose = function handleClose() {
        var isManualClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        setMode === null || setMode === void 0 || setMode("");
        onClose === null || onClose === void 0 || onClose(isManualClose);
    };
    var renderPrimaryAction = function renderPrimaryAction() {
        if (!primaryAction) {
            return null;
        }
        return /*#__PURE__*/ react.createElement("button", {
            type: "button",
            className: "xdesign-storage-cost-modal__action xdesign-storage-cost-modal__action--primary",
            onClick: function onClick() {
                var _primaryAction$onClic;
                (_primaryAction$onClic = primaryAction.onClick) === null || _primaryAction$onClic === void 0 || _primaryAction$onClic.call(primaryAction);
                handleClose();
            },
            disabled: primaryAction.disabled
        }, /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-main"
        }, /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-title"
        }, primaryAction.iconName ? /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
            name: primaryAction.iconName,
            fontSize: 12
        }) : null, /*#__PURE__*/ react.createElement("span", null, primaryAction.text)), primaryAction.subText ? /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-sub-title"
        }, primaryAction.subText) : null));
    };
    var renderSecondaryAction = function renderSecondaryAction() {
        if (!secondaryAction) {
            return null;
        }
        return /*#__PURE__*/ react.createElement("button", {
            type: "button",
            className: "xdesign-storage-cost-modal__action xdesign-storage-cost-modal__action--secondary",
            onClick: function onClick() {
                var _secondaryAction$onCl;
                (_secondaryAction$onCl = secondaryAction.onClick) === null || _secondaryAction$onCl === void 0 || _secondaryAction$onCl.call(secondaryAction);
                handleClose();
            },
            disabled: secondaryAction.disabled
        }, /*#__PURE__*/ react.createElement("span", null, secondaryAction.text));
    };
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        open: true,
        destroyOnClose: true,
        className: "xdesign-storage-cost-modal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__panel"
    }, /*#__PURE__*/ react.createElement("button", {
        type: "button",
        className: "xdesign-storage-cost-modal__close",
        onClick: function onClick() {
            return handleClose(true);
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "CrossBlack",
        fontSize: 14,
        color: "var(--content-system-tertiary, #939599)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__header"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "InfoCircleFill",
        fontSize: 54,
        color: iconColor !== null && iconColor !== void 0 ? iconColor : "var(--background-btn-svip, #ffcaa8)"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__title"
    }, title), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__description",
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__actions"
    }, renderPrimaryAction(), renderSecondaryAction())));
};
var StorageCostAlertModalModalController = (0,createModalComponent/* default */.Z)(StorageCostAlertModalInner);
var openStorageCostAlertModal = function openStorageCostAlertModal(options) {
    StorageCostAlertModalModalController.open(options);
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/userInfo.js
var userInfo = __webpack_require__(8209);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/type.js
/**
 * 存储管理的身份枚举。
 */ var StorageCostUserIdentityKind = /*#__PURE__*/ function(StorageCostUserIdentityKind) {
    StorageCostUserIdentityKind["PersonalFreeOther"] = "personal_free_other";
    StorageCostUserIdentityKind["PersonalFreeNewlyExpired"] = "personal_free_newly_expired";
    StorageCostUserIdentityKind["PersonalStandardVip"] = "personal_standard_vip";
    StorageCostUserIdentityKind["PersonalProVip"] = "personal_pro_vip";
    StorageCostUserIdentityKind["TeamFreeAdmin"] = "team_free_admin";
    StorageCostUserIdentityKind["TeamFreeMember"] = "team_free_member";
    StorageCostUserIdentityKind["TeamVipAdmin"] = "team_vip_admin";
    StorageCostUserIdentityKind["TeamVipMember"] = "team_vip_member";
    StorageCostUserIdentityKind["EnterpriseNoExpiredAdmin"] = "enterprise_no_expired_admin";
    StorageCostUserIdentityKind["EnterpriseNoExpiredMember"] = "enterprise_no_expired_member";
    StorageCostUserIdentityKind["EnterpriseExpiredAdmin"] = "enterprise_expired_admin";
    StorageCostUserIdentityKind["EnterpriseExpiredMember"] = "enterprise_expired_member";
    return StorageCostUserIdentityKind;
}({}); /**
 * 初始化参数：用于 initStorageCost 初始化逻辑（含弹窗等业务扩展入口）。
 */  /**
 * 空间状态。
 */  /**
 * 存储商业化所有相关的信息汇总。
 */ 

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/transform.js




var LOW_SPACE_THRESHOLD = 0.1;
var MEMBERSHIP_SOON_EXPIRE_DAYS = 7;
var PERSONAL_FREE_NEWLY_EXPIRED_DAYS = 60;
var resolvePersonalIdentityKind = function resolvePersonalIdentityKind(options) {
    if (!options.userInfo.isVip) {
        var isPersonalFreeNewlyExpired = options.userInfo.vipDays < 0 && options.userInfo.vipDays >= -PERSONAL_FREE_NEWLY_EXPIRED_DAYS;
        if (isPersonalFreeNewlyExpired) {
            return StorageCostUserIdentityKind.PersonalFreeNewlyExpired;
        }
        return StorageCostUserIdentityKind.PersonalFreeOther;
    }
    var isProVip = options.userInfo.vipLevel === userInfo/* VipLevel.ProCn */.Dv.ProCn;
    return isProVip ? StorageCostUserIdentityKind.PersonalProVip : StorageCostUserIdentityKind.PersonalStandardVip;
};
var isTeamManagerRole = function isTeamManagerRole(role) {
    return role === teamInfo/* TeamRoleType.owner */.xO.owner || role === teamInfo/* TeamRoleType.admin */.xO.admin;
};
var resolveIdentityKind = function resolveIdentityKind(options) {
    var _teamInfo$member, _checkTeamStatusIsVip;
    var teamInfo = (0,dist_teamInfo/* getTeamInfo */.Iu)();
    if (!(0,dist_teamInfo/* checkIsTeam */.hU)(teamInfo)) {
        return resolvePersonalIdentityKind(options);
    }
    var isManager = isTeamManagerRole(teamInfo === null || teamInfo === void 0 || (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.role);
    var isEnterprise = (0,dist_teamInfo/* checkTeamIsEnterprise */.Yt)(teamInfo);
    var isTeamVip = (_checkTeamStatusIsVip = (0,dist_teamInfo/* checkTeamStatusIsVip */.zb)(teamInfo)) !== null && _checkTeamStatusIsVip !== void 0 ? _checkTeamStatusIsVip : false;
    if (isEnterprise) {
        if (isTeamVip) {
            return isManager ? StorageCostUserIdentityKind.EnterpriseNoExpiredAdmin : StorageCostUserIdentityKind.EnterpriseNoExpiredMember;
        }
        return isManager ? StorageCostUserIdentityKind.EnterpriseExpiredAdmin : StorageCostUserIdentityKind.EnterpriseExpiredMember;
    }
    if (isTeamVip) {
        return isManager ? StorageCostUserIdentityKind.TeamVipAdmin : StorageCostUserIdentityKind.TeamVipMember;
    }
    return isManager ? StorageCostUserIdentityKind.TeamFreeAdmin : StorageCostUserIdentityKind.TeamFreeMember;
};
/**
 * 后端结构 -> 通用状态结构
 */ var transformStorageCostStatus = function transformStorageCostStatus(apiData, options) {
    var _apiData$soon_expire_, _apiData$expired_coun;
    var _options$userInfo = options.userInfo, vipDays = _options$userInfo.vipDays, isVip = _options$userInfo.isVip;
    var isMembershipNewlyExpired = !isVip && vipDays < 0 && vipDays >= -PERSONAL_FREE_NEWLY_EXPIRED_DAYS;
    var isMembershipSoonExpire = isVip && !isMembershipNewlyExpired && vipDays > 0 && vipDays <= MEMBERSHIP_SOON_EXPIRE_DAYS;
    return {
        identity: resolveIdentityKind(options),
        space: {
            capacity: apiData.capacity,
            usedSize: apiData.used_size,
            lowSpaceThreshold: LOW_SPACE_THRESHOLD
        },
        lifecycle: {
            isMembershipSoonExpire: isMembershipSoonExpire,
            isMembershipNewlyExpired: isMembershipNewlyExpired
        },
        soonExpireFileCount: (_apiData$soon_expire_ = apiData.soon_expire_count) !== null && _apiData$soon_expire_ !== void 0 ? _apiData$soon_expire_ : 0,
        expiredFileCount: (_apiData$expired_coun = apiData.expired_count) !== null && _apiData$expired_coun !== void 0 ? _apiData$expired_coun : 0
    };
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/init.js











/**
 * 仅用于 {@link StorageCostService.init} 内弹窗调度，不写入 {@link StorageCostStatus}、不对外导出。
 */ var StorageCostInitModalKind = /*#__PURE__*/ function(StorageCostInitModalKind) {
    StorageCostInitModalKind["FileSoonExpire"] = "file_soon_expire";
    StorageCostInitModalKind["SpaceLow"] = "space_low";
    StorageCostInitModalKind["SpaceFull"] = "space_full";
    StorageCostInitModalKind["MembershipNewlyExpired"] = "membership_newly_expired";
    return StorageCostInitModalKind;
}(StorageCostInitModalKind || {});
var TEAM_OR_ENTERPRISE_MEMBER_IDENTITIES = new Set([
    StorageCostUserIdentityKind.TeamFreeMember,
    StorageCostUserIdentityKind.TeamVipMember,
    StorageCostUserIdentityKind.EnterpriseNoExpiredMember,
    StorageCostUserIdentityKind.EnterpriseExpiredMember
]);
var ALERT_PRIORITY = [
    StorageCostInitModalKind.FileSoonExpire,
    StorageCostInitModalKind.MembershipNewlyExpired,
    StorageCostInitModalKind.SpaceFull
];
var resolvePageMode = function resolvePageMode(options) {
    var _options$pageMode;
    return (_options$pageMode = options.pageMode) !== null && _options$pageMode !== void 0 ? _options$pageMode : "no-aigc";
};
var ensureTeamInfoReady = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        var _getConfig, isTeam;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _getConfig = (0,configProvider/* getConfig */.iE)(), isTeam = _getConfig.isTeam;
                    if (isTeam) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return");
                case 3:
                    _context.prev = 3;
                    _context.next = 6;
                    return (0,dist_teamInfo/* fetchTeamInfo */.mR)();
                case 6:
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](3);
                    ;
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                8
            ]
        ]);
    }));
    return function ensureTeamInfoReady() {
        return _ref.apply(this, arguments);
    };
}();
var getMatchedAlerts = function getMatchedAlerts(status, isSpaceLow, isSpaceFull, options) {
    var pageMode = resolvePageMode(options);
    var hasFileRisk = status.expiredFileCount > 0 || status.soonExpireFileCount > 0;
    // 首页只弹文件时间告警
    if (pageMode === "home" && hasFileRisk) {
        return [
            StorageCostInitModalKind.FileSoonExpire
        ];
    }
    var matchedAlerts = [];
    if (hasFileRisk) {
        matchedAlerts.push(StorageCostInitModalKind.FileSoonExpire);
    }
    if (status.lifecycle.isMembershipNewlyExpired) {
        matchedAlerts.push(StorageCostInitModalKind.MembershipNewlyExpired);
    }
    if (isSpaceFull) {
        matchedAlerts.push(StorageCostInitModalKind.SpaceFull);
    } else if (isSpaceLow) {
        matchedAlerts.push(StorageCostInitModalKind.SpaceLow);
    }
    return matchedAlerts;
};
var getTopPriorityAlert = function getTopPriorityAlert(status, isSpaceLow, isSpaceFull, options) {
    var pageMode = resolvePageMode(options);
    if (pageMode === "space-manage") return null;
    if (isSpaceFull && pageMode !== "home") {
        return StorageCostInitModalKind.SpaceFull;
    }
    var matchedAlerts = getMatchedAlerts(status, isSpaceLow, isSpaceFull, options);
    for(var _i = 0, _ALERT_PRIORITY = ALERT_PRIORITY; _i < _ALERT_PRIORITY.length; _i++){
        var alertType = _ALERT_PRIORITY[_i];
        if (matchedAlerts.includes(alertType)) {
            return alertType;
        }
    }
    return null;
};
/**
 * 是否阻止商业化存储弹窗
 * 团队版、企业版的相关通知，都只下发到管理员和创建团队的uid进行展示
 */ var shouldBlockAlertForIdentity = function shouldBlockAlertForIdentity(identity) {
    return TEAM_OR_ENTERPRISE_MEMBER_IDENTITIES.has(identity);
};
var canShowUpgradeAction = function canShowUpgradeAction(identity) {
    return identity !== StorageCostUserIdentityKind.PersonalProVip && identity !== StorageCostUserIdentityKind.TeamVipAdmin && identity !== StorageCostUserIdentityKind.EnterpriseNoExpiredAdmin;
};
var resolveSpaceFullModalConfig = function resolveSpaceFullModalConfig(status, options) {
    var pageMode = resolvePageMode(options);
    var isFree = [
        StorageCostUserIdentityKind.PersonalFreeOther,
        StorageCostUserIdentityKind.PersonalFreeNewlyExpired,
        StorageCostUserIdentityKind.TeamFreeAdmin,
        StorageCostUserIdentityKind.TeamFreeMember,
        StorageCostUserIdentityKind.EnterpriseExpiredAdmin,
        StorageCostUserIdentityKind.EnterpriseExpiredMember
    ].includes(status.identity);
    var showUpgradeAction = canShowUpgradeAction(status.identity);
    var iconColor = showUpgradeAction ? undefined : "var(--content-system-info-icon-regular)";
    var title = "您的存储空间已满".concat(showUpgradeAction ? "" : "，请清理");
    switch(pageMode){
        case "home":
        case "space-manage":
            return null;
        case "project":
            return {
                iconColor: iconColor,
                title: title,
                description: "您的".concat(isFree ? "免费" : "", "存储空间已满，请删除部分内容").concat(showUpgradeAction ? "或升级会员" : "", "，否则过往作图记录可能会消失。"),
                showUpgradeAction: showUpgradeAction
            };
        case "aigc":
            return {
                iconColor: iconColor,
                title: title,
                description: "您的".concat(isFree ? "免费" : "", "储存空间已满，当前生成内容会<strong>临时储存7天</strong>，请删除部分内容").concat(showUpgradeAction ? "或升级会员" : "", "，否则作图记录可能会消失。"),
                showUpgradeAction: showUpgradeAction
            };
        case "no-aigc":
            return {
                iconColor: iconColor,
                title: title,
                description: "您可以选择<strong>将文件下载至本地</strong>，或者选择清理文件".concat(showUpgradeAction ? "、升级会员" : "", "来获取更多存储空间。"),
                showUpgradeAction: showUpgradeAction
            };
        default:
            return null;
    }
};
var buildUpgradeSubText = function buildUpgradeSubText(alertType, options) {
    var pageMode = resolvePageMode(options);
    if (alertType === StorageCostInitModalKind.SpaceFull) {
        return "解锁更多储存空间";
    }
    if (pageMode !== "home") {
        return "文件可无限期保存";
    }
    return "解锁更多储存空间";
};
var openAlertModal = function openAlertModal(status, alertType, options) {
    if (shouldBlockAlertForIdentity(status.identity)) {
        return;
    }
    var handleClickTrack = function handleClickTrack(clickType) {
        var _options$onTrack;
        (_options$onTrack = options.onTrack) === null || _options$onTrack === void 0 || _options$onTrack.call(options, "space_upgrade_click", {
            class: alertType === StorageCostInitModalKind.SpaceFull ? "lack" : "expiring_soon",
            click_type: clickType
        });
    };
    var handleShowTrack = function handleShowTrack(showType) {
        var _options$onTrack2;
        (_options$onTrack2 = options.onTrack) === null || _options$onTrack2 === void 0 || _options$onTrack2.call(options, "space_upgrade_show", {
            class: showType === "spaceRisk" ? "lack" : "expiring_soon"
        });
    };
    var hasUpgradeAction = canShowUpgradeAction(status.identity);
    var openVipByContext = function openVipByContext() {
        var _options$onOpenVipMod;
        handleClickTrack("yes");
        (_options$onOpenVipMod = options.onOpenVipModal) === null || _options$onOpenVipMod === void 0 || _options$onOpenVipMod.call(options);
    };
    var openSpaceManager = function openSpaceManager(options) {
        handleClickTrack("clean");
        if (options.onOpenSpaceManager) {
            options.onOpenSpaceManager();
            return;
        }
        window.location.href = "/space/manage/";
    };
    // 首页不弹空间满弹窗
    if (alertType === StorageCostInitModalKind.SpaceFull && options.pageMode !== "home") {
        var spaceFullModalConfig = resolveSpaceFullModalConfig(status, options);
        if (spaceFullModalConfig) {
            handleShowTrack("spaceRisk");
            openStorageCostAlertModal({
                iconColor: spaceFullModalConfig.iconColor,
                title: spaceFullModalConfig.title,
                description: spaceFullModalConfig.description,
                primaryAction: spaceFullModalConfig.showUpgradeAction ? {
                    iconName: "VipBoldFill",
                    text: "升级会员",
                    subText: buildUpgradeSubText(alertType, options),
                    onClick: openVipByContext
                } : undefined,
                secondaryAction: {
                    text: "清理空间",
                    onClick: function onClick() {
                        return openSpaceManager(options);
                    }
                },
                onClose: function onClose(isManualClose) {
                    if (isManualClose) {
                        handleClickTrack("close");
                    }
                }
            });
        }
        return;
    }
    // 首页才弹文件时间告警弹窗
    if (alertType === StorageCostInitModalKind.FileSoonExpire && options.pageMode === "home") {
        handleShowTrack("fileTimeRisk");
        openStorageCostAlertModal({
            title: "您的文件即将过期",
            description: "文件过期后将会自动清理，请及时管理您的创作内容。",
            primaryAction: hasUpgradeAction ? {
                iconName: "VipBoldFill",
                text: "升级会员",
                subText: buildUpgradeSubText(alertType, options),
                onClick: openVipByContext
            } : undefined,
            secondaryAction: {
                text: "整理文件",
                onClick: function onClick() {
                    return openSpaceManager(options);
                }
            },
            onClose: function onClose(isManualClose) {
                if (isManualClose) {
                    handleClickTrack("close");
                }
            }
        });
        return;
    }
};
var checkIsMobile = function checkIsMobile() {
    var ua = navigator.userAgent.toLowerCase();
    var isPCWechat = ua.includes("macwechat") || ua.includes("windowswechat");
    return /iphone|ipod|android.*mobile|mobile|windows phone|micromessenger/i.test(ua) && !isPCWechat;
};
/**
 * 存储治理通用服务：
 * - new 时不需要传参
 * - init 时才接收业务参数
 * - 支持读取最近一次状态，供业务自行控制提示
 */ var StorageCostService = /*#__PURE__*/ function() {
    function StorageCostService() {
        (0,classCallCheck/* default */.Z)(this, StorageCostService);
        (0,defineProperty/* default */.Z)(this, "storageCostStatus", null);
    }
    (0,createClass/* default */.Z)(StorageCostService, [
        {
            key: "init",
            value: function() {
                var _init = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(options) {
                    var apiData, status, spaceRatio, isSpaceLow, isSpaceFull, topAlertType;
                    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                        while(1)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!checkIsMobile()) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("storage cost is not supported on mobile");
                            case 2:
                                _context2.next = 4;
                                return ensureTeamInfoReady();
                            case 4:
                                _context2.next = 6;
                                return fetchStorageCostSummary();
                            case 6:
                                apiData = _context2.sent;
                                status = transformStorageCostStatus(apiData, options);
                                spaceRatio = status.space.capacity > 0 ? status.space.usedSize / status.space.capacity : 0;
                                isSpaceLow = status.space.capacity > 0 && spaceRatio >= 1 - status.space.lowSpaceThreshold;
                                isSpaceFull = status.space.capacity > 0 && status.space.usedSize >= status.space.capacity;
                                topAlertType = getTopPriorityAlert(status, isSpaceLow, isSpaceFull, options);
                                this.storageCostStatus = status;
                                if (topAlertType) {
                                    openAlertModal(status, topAlertType, options);
                                }
                                return _context2.abrupt("return", status);
                            case 15:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "getStorageCostStatus",
            value: function getStorageCostStatus() {
                return this.storageCostStatus;
            }
        }
    ]);
    return StorageCostService;
}();

;// CONCATENATED MODULE: ./src/services/storage-cost.ts


const storageCostService = new StorageCostService();
let isChecking = false;
const triggerGenerateStorageAlert = (param)=>{
    let { userInfo , onOpenVipModal , onOpenSpaceManager  } = param;
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || isChecking) {
        return;
    }
    isChecking = true;
    var _vip_level, _vip_days, _vip_end_time;
    storageCostService.init({
        pageMode: "aigc",
        userInfo: {
            isVip: Boolean(userInfo.is_vip),
            vipLevel: (_vip_level = userInfo.vip_level) !== null && _vip_level !== void 0 ? _vip_level : 0,
            vipDays: (_vip_days = userInfo.vip_days) !== null && _vip_days !== void 0 ? _vip_days : 0,
            vipEndTime: (_vip_end_time = userInfo.vip_end_time) !== null && _vip_end_time !== void 0 ? _vip_end_time : -1
        },
        onOpenVipModal,
        onOpenSpaceManager,
        onTrack: mtstat/* statTrack */.SF
    }).catch((error)=>{
        ;
    }).finally(()=>{
        isChecking = false;
    });
};

;// CONCATENATED MODULE: ./src/pages/appLogic.tsx














const AppLogic = ()=>{
    const finishWidgetsConfig = (0,store/* useStoreActions */.WX)((action)=>action.finishWidgetsConfig);
    const setIsOpenDeepSeek = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenDeepSeek);
    const setIsOpenPptCommercialization = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenPptCommercialization);
    const finishTrack = (0,store/* useStoreState */.Kw)((state)=>state.finishTrack);
    const userInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.userInfo);
    const finishFetchUserInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.isRequested);
    const storageCostInitUserIdRef = (0,react.useRef)(null);
    const handleInitAbTest = async ()=>{
        await initABTest();
        if ((0,src_utils/* isMobile */.tq)()) {
            setIsOpenDeepSeek(true);
            return;
        }
        if ((0,sdk/* checkIsInSdk */.X)()) {
            setIsOpenDeepSeek(false);
        } else {
            isOpenDeepSeek().then((isOpen)=>{
                setIsOpenDeepSeek(isOpen);
            });
        }
        isOpenPptCommercialization().then((isOpen)=>{
            setIsOpenPptCommercialization(isOpen);
        });
    };
    (0,useWpsNavigationIntercept/* useWpsNavigationIntercept */.d)();
    (0,source/* syncWpsSourceParamsFromUrl */._i)();
    (0,react.useEffect)(()=>{
        // xdesign-widgets组件公共参数
        (0,configProvider/* setConfig */.v6)("client_id", (0,constants/* getClientID */.kU)());
        (0,configProvider/* setConfig */.v6)("env", "release");
        (0,configProvider/* setConfig */.v6)("app_key", (0,constants/* getAppKey */.AJ)());
        (0,configProvider/* setConfig */.v6)("module_id", constants/* MODULE_ID */.ce);
        (0,configProvider/* setConfig */.v6)("theme", "light");
        (0,configProvider/* setConfig */.v6)("isTeam", true);
        (0,configProvider/* setConfig */.v6)("isWpsUser", (0,utils/* isFromWPS */.ji)());
        finishWidgetsConfig();
        // 依赖上面env的设置
        (0,uidKit/* initLocalUid */.sw)();
        const initFn = async ()=>{
            // 定制企业版逻辑
            await initEnterprise();
            const is = await __webpack_require__.e(/* import() */ 128).then(__webpack_require__.bind(__webpack_require__, 60128));
            if (is.isMobile && (is.isXiuXiu || is.isPoster) && is.isIOS) {
                window.addEventListener("WebviewJsBridgeReady", ()=>{
                    ;
                    // 初始化埋点SDK逻辑
                    (0,mtstat/* initMtstat */.jt)(handleInitAbTest);
                });
            } else {
                // 初始化埋点SDK逻辑
                (0,mtstat/* initMtstat */.jt)(handleInitAbTest);
            }
        };
        initFn();
        markRecentFeature(RecentFeatureKey.LivePPT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //埋点初始化完成并且用户信息请求完成
    (0,react.useEffect)(()=>{
        ;
        if (finishTrack && finishFetchUserInfo) {
            (0,mtstat/* setUserCommonParams */.xT)({
                isVip: userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip,
                availableAmount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount
            });
        }
    }, [
        finishTrack,
        finishFetchUserInfo,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip
    ]);
    (0,react.useEffect)(()=>{
        if (userInfo) {
            (0,configProvider/* setConfig */.v6)("userInfo", userInfo);
        }
    }, [
        userInfo
    ]);
    (0,react.useEffect)(()=>{
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            return;
        }
        if (storageCostInitUserIdRef.current === userInfo.id) {
            return;
        }
        storageCostInitUserIdRef.current = userInfo.id;
        triggerGenerateStorageAlert({
            userInfo,
            onOpenVipModal: ()=>{
                (0,login/* openVipModal */.C2)({
                    entrance: "storage_space",
                    subscribe_type: ""
                });
            }
        });
    }, [
        userInfo
    ]);
    return null;
};
/* harmony default export */ const appLogic = (AppLogic);


/***/ }),

/***/ 25344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ src_store),
  "WX": () => (/* binding */ useStoreActions),
  "Kw": () => (/* binding */ useStoreState)
});

// UNUSED EXPORTS: useStoreDispatch

// EXTERNAL MODULE: ./node_modules/easy-peasy/dist/index.js + 3 modules
var dist = __webpack_require__(94501);
;// CONCATENATED MODULE: ./src/store/userModel/index.ts

const userModel = {
    userInfo: undefined,
    setUserInfo: (0,dist/* action */.aD)((state, value)=>{
        state.userInfo = value;
    }),
    meidouInfo: null,
    setMeidouInfo: (0,dist/* action */.aD)((state, value)=>{
        state.meidouInfo = value;
    }),
    cutoutInfo: null,
    setCutoutInfo: (0,dist/* action */.aD)((state, value)=>{
        state.cutoutInfo = value;
    }),
    isRequested: false,
    setIsRequested: (0,dist/* action */.aD)((state, value)=>{
        state.isRequested = value;
    })
};

;// CONCATENATED MODULE: ./src/store/index.ts


const store = (0,dist/* createStore */.MT)({
    userModel: userModel,
    isWidgetsConfigDone: false,
    finishWidgetsConfig: (0,dist/* action */.aD)((state)=>{
        state.isWidgetsConfigDone = true;
    }),
    isOpenDeepSeek: true,
    setIsOpenDeepSeek: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenDeepSeek = payload;
    }),
    finishTrack: false,
    setFinishTrack: (0,dist/* action */.aD)((state, payload)=>{
        state.finishTrack = payload;
    }),
    isOpenPptCommercialization: undefined,
    setIsOpenPptCommercialization: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenPptCommercialization = payload;
    })
});
const typedHooks = (0,dist/* createTypedHooks */.tl)();
const useStoreState = typedHooks.useStoreState;
const useStoreActions = typedHooks.useStoreActions;
const useStoreDispatch = typedHooks.useStoreDispatch;
/* harmony default export */ const src_store = (store);


/***/ }),

/***/ 62444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ getFirstUrl)
/* harmony export */ });
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3269);

/**
 * 首次进入页 URL：优先地址栏 first_url，其次 sessionStorage
 */ const getFirstUrl = ()=>{
    if (false) {}
    return decodeURIComponent((0,_query__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("first_url") || "") || window.sessionStorage.getItem("first_url") || "";
};


/***/ }),

/***/ 83353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ waitUntilGetGid)
/* harmony export */ });
/* unused harmony export getUnionDeviceId */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57632);

let wgid = "";
let iframeDom = {};
/**
 * 同步主站(designkit.com)的wgid
 *
 * @return {*}  {Promise<string>}
 * const deviceId = await getUnionDeviceId();
 */ function getUnionDeviceId() {
    var ref, ref1;
    const gid = ((ref = window.mtstat) === null || ref === void 0 ? void 0 : (ref1 = ref.getStatsMarker) === null || ref1 === void 0 ? void 0 : ref1.call(ref)) || "";
    return gid;
}
/**
 * 循环取gid, 如果1s内没取到就随机生成(可能遇到埋点web sdk初始化失败)
 * @returns Promise<string>  返回gid
 */ const waitUntilGetGid = ()=>{
    return new Promise((resolve)=>{
        if (wgid) {
            resolve(wgid);
            return;
        }
        let loopTimes = 4;
        const getData = async ()=>{
            wgid = await getUnionDeviceId();
            if (!wgid && loopTimes === 0) {
                wgid = (0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
                resolve(wgid);
            } else if (!wgid) {
                setTimeout(()=>{
                    loopTimes = loopTimes - 1;
                    getData();
                }, 500);
            } else {
                resolve(wgid);
            }
        };
        getData();
    });
};


/***/ }),

/***/ 45332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": () => (/* binding */ isAndroid),
/* harmony export */   "FZ": () => (/* binding */ isPcPlatform),
/* harmony export */   "G6": () => (/* binding */ isSafari),
/* harmony export */   "GP": () => (/* binding */ isQQ),
/* harmony export */   "Hq": () => (/* binding */ workerSleep),
/* harmony export */   "Lt": () => (/* binding */ filterParams),
/* harmony export */   "MH": () => (/* binding */ isFromHuaweiCustom),
/* harmony export */   "Q1": () => (/* binding */ thumbnail),
/* harmony export */   "R$": () => (/* binding */ isSupportWebp),
/* harmony export */   "T5": () => (/* binding */ getMatrixChannel),
/* harmony export */   "WY": () => (/* binding */ isJsonStr),
/* harmony export */   "_v": () => (/* binding */ sleep),
/* harmony export */   "b5": () => (/* binding */ getSource),
/* harmony export */   "fP": () => (/* binding */ getOsType),
/* harmony export */   "gn": () => (/* binding */ isIOS),
/* harmony export */   "iX": () => (/* binding */ getJSONByUrl),
/* harmony export */   "mr": () => (/* binding */ getChannel),
/* harmony export */   "qW": () => (/* binding */ isWeiXin),
/* harmony export */   "tq": () => (/* binding */ isMobile)
/* harmony export */ });
/* unused harmony exports loadScript, is, isNumber, getCookies, getClientInfo */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81167);


const getSessionStorage = (key)=>{
    return window.sessionStorage.getItem(key) && decodeURIComponent(window.sessionStorage.getItem(key));
};
const getChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.channel && decodeURIComponent(params.channel) || getSessionStorage("channel") || "";
};
/**
 * 动态创建script标签
 * @param url
 * @param callback
 */ const loadScript = (url, callback)=>{
    const eleScript = document.createElement("script");
    eleScript.type = "text/javascript";
    eleScript.src = url;
    document.getElementsByTagName("head")[0].appendChild(eleScript);
    if (eleScript.readyState) {
        eleScript.onreadystatechange = function() {
            if (eleScript.readyState === "loaded" || eleScript.readyState === "complete") {
                eleScript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        eleScript.onload = function() {
            callback();
        };
    }
};
const getMatrixChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.matrix_channel || window.sessionStorage.getItem("matrix_channel") || _constants__WEBPACK_IMPORTED_MODULE_0__/* .MATRIX_CHANNEL */ .cr;
};
const is = (val, type)=>{
    return toString.call(val) === "[object ".concat(type, "]");
};
const isNumber = (val)=>{
    return is(val, "Number");
};
function getCookies(cookies) {
    try {
        if (!cookies) return {};
        const list = cookies.split(";");
        const params = {};
        for(let i = 0; i < list.length; i++){
            const [key, value] = list[i].split("=");
            params[key.trim()] = decodeURIComponent(value);
        }
        return params;
    } catch (e) {
        ;
        return {};
    }
}
const isMobile = ()=>{
    if (false) {}
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const sleep = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
// 判断gpt_content 是否为json字符串
const isJsonStr = (str)=>{
    if (typeof str === "string") {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};
const isSafari = ()=>{
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
// 判断是否来自华为PC预装定制版内嵌
const isFromHuaweiCustom = ()=>{
    if (false) {}
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes("channel:zhyshop");
};
let supportWebp = undefined;
const isSupportWebp = ()=>{
    if (false) {}
    if (supportWebp === void 0) {
        supportWebp = document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    return supportWebp;
};
const thumbnail = function(url, width) {
    let quality = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 80;
    var ref, ref1, ref2;
    if (/\.svg$/.test(url) || /\.(webp)$/.test(url)) return url;
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parseUrl */ .Z.parseUrl(url);
    // imageView2 加上这个后，会导致不校验 token
    // 暂时不处理 token 地址
    if (params === null || params === void 0 ? void 0 : (ref = params.query) === null || ref === void 0 ? void 0 : ref.token) return url;
    // 加签参数需要保留
    const signString = (params === null || params === void 0 ? void 0 : (ref1 = params.query) === null || ref1 === void 0 ? void 0 : ref1.k) && (params === null || params === void 0 ? void 0 : (ref2 = params.query) === null || ref2 === void 0 ? void 0 : ref2.t) ? "&k=".concat(params.query.k, "&t=").concat(params.query.t) : "";
    // 分割参数，转 webp 将会被丢弃
    const uri = url.split("?");
    // 分割缩略图 https://material-center-pre.meitudata.com/material/image/6462f5d0f05f84631.png!thumb-w240
    const realUrl = uri[0].split("!");
    const currentUrl = "".concat(realUrl[0], "?imageView2/2").concat(width ? "/w/" + width : "");
    if (isSupportWebp()) {
        return "".concat(currentUrl, "/format/webp/q/").concat(quality, "/ignore-error/1").concat(signString);
    }
    return "".concat(currentUrl, "/q/").concat(quality, "/ignore-error/1").concat(signString);
};
const isAndroid = ()=>{
    if (false) {}
    return /Android/i.test(navigator.userAgent);
};
const isQQ = ()=>{
    if (false) {}
    return /QQ/i.test(navigator.userAgent);
};
const isWeiXin = ()=>{
    if (false) {}
    // 微信浏览器 或者 企业微信浏览器
    return /MicroMessenger/i.test(navigator.userAgent) || /wxwork/i.test(navigator.userAgent);
};
const workerScript = "\n    onmessage = function(event) {\n        const { timeout } = event.data;\n\n        setTimeout(() => {\n            postMessage('done');\n        }, timeout);\n    };\n";
const workerSleep = function() {
    let timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
    return new Promise((resolve)=>{
        const blob = new Blob([
            workerScript
        ], {
            type: "application/javascript"
        });
        const worker = new Worker(URL.createObjectURL(blob));
        worker.onmessage = function() {
            resolve();
            worker.terminate(); // 结束工作者线程
        };
        worker.postMessage({
            timeout
        });
    });
};
const getJSONByUrl = async (url)=>{
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "json";
        xhr.onload = ()=>{
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error("请求失败，状态码：".concat(xhr.status)));
            }
        };
        xhr.onerror = ()=>{
            reject(new Error("网络错误"));
        };
        xhr.send();
    });
};
const isIOS = ()=>{
    if (false) {}
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
const filterParams = (params)=>{
    let paramsStr = "?";
    for(const key in params){
        paramsStr += "".concat(key, "=").concat(key === "tool_url" ? encodeURIComponent(params[key]) : params[key], "&");
    }
    return paramsStr.slice(0, -1);
};
let clientInfo = undefined;
const getClientInfo = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    }
    return clientInfo;
};
const isPcPlatform = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await getClientInfo();
    }
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.isClient) {
        return true;
    }
    return false;
};
const getOsType = async ()=>{
    let osType = "web";
    if ((await getClientInfo()).isClient) {
        osType = (await getClientInfo()).isMac ? "macos" : "windows";
    }
    return osType;
};
const getSource = async ()=>{
    const clientInfo = await getClientInfo();
    let source = "";
    if (clientInfo.isMac || clientInfo.isMacAppStore) {
        source = "MTXX-MAC";
    } else if (clientInfo.isPC) {
        source = "MTXX-PC";
    } else if (clientInfo.isLinux) {
        source = "MTXX-LINUX";
    } else {
        source = "MTXX-WEB";
    }
    return source;
};


/***/ }),

/***/ 71231:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RN": () => (/* binding */ getCallback),
  "bG": () => (/* binding */ getUserInfo),
  "hY": () => (/* binding */ handleLogout),
  "Br": () => (/* binding */ initAccount),
  "lU": () => (/* binding */ jumpToLogin),
  "C2": () => (/* binding */ openVipModal)
});

// UNUSED EXPORTS: updateLogoutAccessToken

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/overseasAccessModal/jumpQuery.js
var overseasAccessModal_jumpQuery = __webpack_require__(30106);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./src/constants/code.ts
var code = __webpack_require__(90480);
// EXTERNAL MODULE: ./src/utils/request.ts + 6 modules
var utils_request = __webpack_require__(31738);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./src/services/user/index.ts
/* provided dependency */ var process = __webpack_require__(34155);


/**
 * 用户信息详情
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/82889
 */ const fetchUserInfo = async function() {
    return await (0,utils_request/* default */.ZP)("".concat((0,constants/* getIntranetHost */.Cu)(), "/user/info"), {
        method: "GET",
        hideErrorToast: true
    });
};
const fetchUnReadMessage = async function(params) {
    return await request("".concat(process.env.REACT_APP_API_FEEDBACK, "/im_v2/unread_count.json"), {
        method: "GET",
        data: params
    });
};

// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./src/utils/gid.ts
var utils_gid = __webpack_require__(83353);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
var CloseFromEnum = /*#__PURE__*/function (CloseFromEnum) {
  CloseFromEnum["PAYSUCCESS"] = "pay-success";
  CloseFromEnum["UNLOGIN"] = "unLogin";
  CloseFromEnum["CLOSE"] = "close";
  return CloseFromEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/**
 * 订阅弹窗样式
 */
var dialogCss = "\n  .saas-subscription-popup {\n    background-color: rgba(21, 20, 23, 0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #000;\n    position: relative;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #000;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  @media screen and (max-height: 620px) {\n    .saas-subscription-popup {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n";

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [
    // ["智能抠图", false, "1200张/年", "100张*席位数/月"],
    ["会员美豆", false, "330个/月", "330个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248VIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5318/\u5E74/\u4EBA</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var SaasSubscription = /*#__PURE__*/function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false, CloseFromEnum.UNLOGIN);
          return;
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false, CloseFromEnum.PAYSUCCESS);
          return;
        }
        _this.close(false, CloseFromEnum.CLOSE);
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var queryString = Object.keys(params).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(encodeURIComponent(params[key] || ""), "&");
      }, "");
      var preHost = "";
      if (
      // /\.meitu\.com/.test(window.location.host) ||
      /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://prepc.meitu.com";
            break;
          case EnvEnum.BETA:
            preHost = "https://betapc.meitu.com";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://pc.meitu.com";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://prepc.meitu.com";
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 更新弹窗大小
     */
    _defineProperty(this, "updateDialogSize", function (isOnlyShowScanUIPopup) {
      if (!_this.ele) return;
      var eleInner = _this.ele.querySelector(".saas-subscription-popup__inner");
      if (!eleInner) return;
      if (isOnlyShowScanUIPopup) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      } else {
        // 恢复默认大小（通过移除内联样式，使用CSS默认值）
        eleInner.style.width = "";
        eleInner.style.height = "";
      }
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function (isOnlyShowScanUIPopup) {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = "saas-subscription-popup ".concat(_this.theme);
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";
      if (isOnlyShowScanUIPopup) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      }

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/x-design/subscription/close.png";
      eleClose.onclick = function () {
        var _window;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem("uid");
        if (uid) (_window = window) === null || _window === void 0 || (_window = _window.mtstat) === null || _window === void 0 || _window.login(uid);
        _this.close();
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 || _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe = _this.eleIframe) === null || _this$eleIframe === void 0 || (_this$eleIframe = _this$eleIframe.contentWindow) === null || _this$eleIframe === void 0 || _this$eleIframe.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 || _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 || _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      if (!this.ele) {
        this.createDialog(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      } else {
        // 弹窗已存在时，更新弹窗大小
        this.updateDialogSize(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
      }
      if (this.ele) {
        document.body.appendChild(this.ele);
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(this.ele, {
          reserveScrollBarGap: true
        });
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CloseFromEnum.CLOSE;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler(from);
      }
      if (this.ele) {
        (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(this.ele);
        document.body.removeChild(this.ele);
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = "saas-subscription-popup ".concat(this.theme);
      }
    }
  }]);
  return SaasSubscription;
}();
/* harmony default export */ const esm_lib = (SaasSubscription);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = (esm_lib);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
// EXTERNAL MODULE: ./src/utils/firstUrl.ts
var firstUrl = __webpack_require__(62444);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js + 1 modules
var wps_utils = __webpack_require__(59391);
;// CONCATENATED MODULE: ./src/utils/login.tsx
// import * as Sentry from "@sentry/react";














let processingLogin = ()=>{};
// HACK 退登问题
let accessToken = "";
let actionType;
let vipModalCloseCallback = undefined;
let vipModalPayCallback = undefined;
const updateLogoutAccessToken = (token)=>{
    accessToken = token;
};
const getEnvValue = (env)=>{
    // 1 test, 0 线上（默认）, 2 beta
    let value;
    switch(env){
        case "release":
            value = 0;
            break;
        case "beta":
            value = 2;
            break;
        default:
            value = 1;
    }
    return value;
};
const getCallback = ()=>{
    const url = "".concat(window.location.protocol, "//").concat(window.location.host, "/callback.html?refresh=0");
    return url;
};
/**
 * 初始化订阅弹窗组件
 */ const initVipModal = async (initVipModalOptions)=>{
    let env = "release";
    if (false) {}
    const first_url = (0,firstUrl/* getFirstUrl */.q)();
    // 订阅团队id
    const localIdentity = (0,lib/* getLocalIdentity */.u5)();
    const jumpQuery = (0,overseasAccessModal_jumpQuery/* getJumpQuery */.H)();
    const instanceVipModal = new esm({
        env,
        theme: "light",
        commonParams: {
            entrance: constants/* SCENE */.vX,
            module_id: constants/* SCENE */.vX,
            source: constants/* SCENE */.vX,
            app_key: (0,constants/* getAppKey */.AJ)(),
            client_id: (0,constants/* getClientID */.kU)(),
            matrix_channel: (0,utils/* getMatrixChannel */.T5)(),
            callback_origin: window.location.origin,
            channel: (0,utils/* getChannel */.mr)(),
            first_ur: first_url,
            subscribe_type: "meidou",
            ...jumpQuery,
            ...localIdentity ? {
                oid: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.oid) || 0,
                groupId: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.groupId) || 0,
                purchase_scene: "normal"
            } : {},
            ...initVipModalOptions
        }
    });
    instanceVipModal.on(EventNameEnum.SUCCESS, async ()=>{
        // 更新接口
        await getUserInfo();
        vipModalPayCallback === null || vipModalPayCallback === void 0 ? void 0 : vipModalPayCallback();
    }).on(EventNameEnum.LOGININVALID, ()=>{
        // 登录态失效
        handleLogout();
    }).on(EventNameEnum.CLOSE, ()=>{
        vipModalCloseCallback === null || vipModalCloseCallback === void 0 ? void 0 : vipModalCloseCallback();
    });
    window.instanceVipModal = instanceVipModal;
};
const initAccount = async ()=>{
    const gid = await (0,utils_gid/* waitUntilGetGid */.S)();
    const { MeituAccount  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(6881), __webpack_require__.e(5257), __webpack_require__.e(5112), __webpack_require__.e(9713), __webpack_require__.e(3999), __webpack_require__.e(1275)]).then(__webpack_require__.bind(__webpack_require__, 91275));
    window.account = MeituAccount({
        env: getEnvValue("release"),
        gid,
        clientId: (0,constants/* getClientID */.kU)(),
        theme: "mtxx",
        clientLanguage: "zh-Hans",
        overseas: 0,
        clientConfigs: {
            abroad: false,
            needPhone: false,
            enableWeChatOfficialAccount: true
        },
        syncDomains: true,
        onNeedLogin () {},
        onLogining () {},
        onLoginError () {},
        onLoginSuccess: async (result)=>{
            actionType = "login";
            window.localStorage.setItem("access_token", result.accessToken);
            ;
            const status = await (0,teamInfo/* openIdentitySwitchPopupAfterLogin */.lz)(result.uid, result.result);
            if (!status) return;
            // 登录成功
            processingLogin(result.accessToken);
            (0,uidKit/* setLocalUid */.Tc)(result.uid);
            getUserInfo();
            // 登录成功默认切换为个人身份
            (0,lib/* setLocalIdentity */.kF)(0, 0);
        },
        onLogoutError () {},
        onLogoutSuccess () {
            actionType = "logout";
        },
        syncDomainsOptions: {
            onComplete () {
                if (actionType === "logout") {
                    window.location.reload();
                }
            }
        }
    });
};
const openAccount = async ()=>{
    //第三方帐号登录，退出后使用页面跳转涉及帐号内部状态同步，须确保帐号内部登录态清除
    await window.account.isLogin();
    const { openLoginPopup  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4644), __webpack_require__.e(4640), __webpack_require__.e(6881), __webpack_require__.e(5257), __webpack_require__.e(5112), __webpack_require__.e(7722), __webpack_require__.e(9713), __webpack_require__.e(3999), __webpack_require__.e(2071)]).then(__webpack_require__.bind(__webpack_require__, 42071));
    const { ThirdPartyPlatform  } = await Promise.all(/* import() */[__webpack_require__.e(4640), __webpack_require__.e(6881), __webpack_require__.e(5257), __webpack_require__.e(5112)]).then(__webpack_require__.bind(__webpack_require__, 75112));
    const { setClientTheme  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(6881), __webpack_require__.e(5257), __webpack_require__.e(5112), __webpack_require__.e(9713)]).then(__webpack_require__.bind(__webpack_require__, 99713));
    openLoginPopup({
        // ...登录弹窗配置选项，详见：LoginPopupProps
        title (text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: "var(--content-primary, #0f1729)",
                    textAlign: "center",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "32px"
                },
                children: text
            });
        },
        autoDetectAndSetDarkTheme: false,
        theme: "v4",
        containerStyle: {
            minHeight: 473
        },
        useLoginMethod: "",
        showMeituXiuXiuQRCode: false,
        thirdPartyAccounts: [
            ThirdPartyPlatform.Meitu,
            ThirdPartyPlatform.Weibo,
            ThirdPartyPlatform.WeChat,
            ThirdPartyPlatform.QQ
        ],
        borderRadius: "14px",
        // 隐藏关闭按钮
        showCloseButton: true,
        closeable: true,
        switch: true,
        leftSide () {
            return '<div style="width: 300px; height: 100%; min-height: 509px; border-radius: 14px 0 0 14px; background-image: url(https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/login/login.svg); background-size: cover; background-position: center center;"></div>';
        },
        onClose () {
        // 关闭弹窗后的自定义处理，略...
        }
    });
};
// 未登录态时，打开登录弹窗
const jumpToLogin = async ()=>{
    // WPS 场景：走 WPS 授权登录流程
    if ((0,wps_utils/* isFromWPS */.ji)()) {
        await (0,wps_utils/* wpsCheckLogin */.jJ)();
        return localStorage.getItem("access_token") || "";
    }
    if (!window.account) {
        await initAccount();
    }
    // 打开登录弹窗
    await openAccount();
    // 等待登录结果
    return await new Promise((resolve)=>processingLogin = resolve);
};
const handleLogout = async ()=>{
    var // 清楚埋点中的uid
    ref, ref1;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.logout();
    // 清空用户信息和美豆信息
    store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
    store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
    // 清除团队信息
    (0,teamInfo/* clearTeamInfo */.bl)();
    // 移除身份切换监听
    (0,teamInfo/* disableIdentityChangeListener */.t2)();
    const { STORAGE_KEY_LOGIN_BY_WEB  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(6881), __webpack_require__.e(5257), __webpack_require__.e(5112), __webpack_require__.e(9713), __webpack_require__.e(3999), __webpack_require__.e(1275)]).then(__webpack_require__.bind(__webpack_require__, 91275));
    window.sessionStorage.removeItem(STORAGE_KEY_LOGIN_BY_WEB);
    !window.account && await initAccount();
    // HACK 退登问题
    let options = {};
    if (accessToken) {
        options = {
            headers: {
                "Access-Token": accessToken
            }
        };
    }
    (ref1 = window.account) === null || ref1 === void 0 ? void 0 : ref1.logout({}, options);
};
// 打开VIP会员弹窗
const openVipModal = async function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, closeCallback = arguments.length > 1 ? arguments[1] : void 0, payCallback = arguments.length > 2 ? arguments[2] : void 0, initVipModalOptions = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    // WPS 场景：走 WPS 支付弹窗
    if ((0,wps_utils/* isFromWPS */.ji)()) {
        await (0,wps_utils/* openWpsPayModal */.kS)(params);
        return;
    }
    vipModalCloseCallback = closeCallback;
    vipModalPayCallback = payCallback;
    if (!window.instanceVipModal) {
        await initVipModal(initVipModalOptions);
    }
    if (params === null || params === void 0 ? void 0 : params.oid) {
        // 如果场景透传了oid，则需要实时根据最新的oid去透传对应的app_key
        params.app_key = (0,constants/* getAppKey */.AJ)(params.oid);
    }
    (ref = window.instanceVipModal) === null || ref === void 0 ? void 0 : ref.open(params);
};
/**
 * 获取用户信息
 */ const getUserInfo = async ()=>{
    const res = await fetchUserInfo();
    const data = res.data.data;
    if (res.data.code === code/* default.OK */.Z.OK && data) {
        var ref;
        window.localStorage.setItem("access_token", data.access_token);
        (0,uidKit/* setLocalUid */.Tc)(data.userInfo.id);
        (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.login(String(data.userInfo.id));
        updateLogoutAccessToken(data.access_token);
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo({
            id: data.userInfo.id,
            screen_name: data.userInfo.screen_name,
            avatar: data.userInfo.avatar,
            is_vip: data.vipInfo.is_vip,
            vip_level: data.vipInfo.vip_level,
            vip_end_time: data.vipInfo.vip_end_time,
            vip_days: data.vipInfo.vip_days,
            available_amount: data.coinInfo.available_amount
        });
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(data.coinInfo);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(data.cutoutInfo);
        // 开启身份切换监听
        (0,teamInfo/* enableIdentityChangeListener */.sr)();
    } else {
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(null);
    }
    store/* default.getActions */.ZP.getActions().userModel.setIsRequested(true);
};


/***/ }),

/***/ 32711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SF": () => (/* binding */ statTrack),
/* harmony export */   "hP": () => (/* binding */ getOperateSource),
/* harmony export */   "jt": () => (/* binding */ initMtstat),
/* harmony export */   "xT": () => (/* binding */ setUserCommonParams)
/* harmony export */ });
/* unused harmony export getParameterValue */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);
/* harmony import */ var _gid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83353);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10275);
/* harmony import */ var _meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30106);
/* harmony import */ var _meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46718);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3269);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25344);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82345);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40313);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31955);










const getParameterValue = (inputString, key)=>{
    // 构造正则表达式，匹配 "key=值" 的模式
    const regex = new RegExp("".concat(key, "=([^&]*)"));
    // 使用正则表达式查找匹配项
    const match = inputString.match(regex);
    // 如果匹配成功，返回匹配的值，否则返回 null
    return match ? decodeURIComponent(match[1]) : "";
};
const initMtstat = async (callback)=>{
    const sdkAppId = (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? _sdk__WEBPACK_IMPORTED_MODULE_4__/* .getAppId */ .r : ()=>Promise.resolve({
            app_id: ""
        });
    Promise.all([
        (0,_gid__WEBPACK_IMPORTED_MODULE_1__/* .waitUntilGetGid */ .S)(),
        sdkAppId()
    ]).then(async (param)=>{
        let [wgid, { app_id  }] = param;
        var ref;
        ;
        // 团队id
        const oid = String(((ref = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || ref === void 0 ? void 0 : ref.oid) || "");
        const query = (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)();
        const tool_url = decodeURIComponent(decodeURIComponent(query.tool_url || ""));
        const is = await __webpack_require__.e(/* import() */ 128).then(__webpack_require__.bind(__webpack_require__, 60128));
        if (app_id) {
            if (_constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id]) {
                if (true) {
                    window._appId = app_id;
                }
            }
        }
        const mtxxWebGid = js_cookie__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("mtxx_web_gid".concat( false ? 0 :  false ? 0 : ""));
        const jumpQuery = (0,_meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__/* .getJumpQuery */ .H)();
        // 埋点信息配置
        const statConfig = {
            appKey: (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAppKey */ .AJ)(),
            env:  true ? "release" : 0,
            moduleId: _constants__WEBPACK_IMPORTED_MODULE_0__/* .MODULE_ID */ .ce,
            app_id: app_id,
            is_sdk: query.origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SdkModuleName.aippt */ .sB.aippt && (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? query.origin : "",
            company_key: _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id] || query.platform || "",
            channel: query.hb_position || query.hb_operation ? "app" : query.channel && decodeURIComponent(query.channel) || window.sessionStorage.getItem("channel") || "",
            hb_position: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_position || getParameterValue(tool_url, "hb_position") || "",
            hb_operation: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_operation || getParameterValue(tool_url, "hb_operation") || "",
            indtool_source: query.indtool_source || "",
            operate_source: await getOperateSource(),
            from_app: is.isMobile && is.isXiuXiu ? "mtxx_app" : is.isMobile && is.isPoster ? "mtsjs_app" : "browser",
            funcEnter: "",
            abTestKey: "",
            sdkModuleName: "",
            customizedStatsMarker: false,
            oid,
            user_mode: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() ? "1" : "",
            enterprise_id: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() || "",
            mtxx_web_gid: mtxxWebGid || "",
            initAbTest: ()=>{
                callback === null || callback === void 0 ? void 0 : callback();
            },
            successCallback: ()=>{
                _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getActions */ .ZP.getActions().setFinishTrack(true);
            },
            ...jumpQuery
        };
        if (is.isMobile && (is.isXiuXiu || is.isPoster)) {
            try {
                const hogger = await Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(2991), __webpack_require__.e(7982)]).then(__webpack_require__.bind(__webpack_require__, 50228));
                const [appInfo] = await hogger.getAppInfo();
                statConfig.gid = appInfo.gid;
            } catch (e) {
                ;
            }
        }
        // 实例化埋点
        __webpack_require__.e(/* import() */ 9741).then(__webpack_require__.bind(__webpack_require__, 59741)).then((res)=>{
            new res.SaasMTStat(statConfig);
        });
    });
};
const getOperateSource = async ()=>{
    const is = await __webpack_require__.e(/* import() */ 128).then(__webpack_require__.bind(__webpack_require__, 60128));
    if (is.isMobile) return "h5";
    const clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    let operate_source = "web";
    if (clientInfo.isClient) {
        operate_source = clientInfo.isMac ? "macos" : "windows";
    }
    return operate_source;
};
/**
 * 埋点上报函数
 * @param eventName 事件名
 * @param args 参数
 */ function statTrack(eventName, args) {
    if (!window._stat_track) {
        if (!window.__stat_stack) {
            window.__stat_stack = [];
        }
        window.__stat_stack.push({
            name: eventName,
            options: args
        });
    } else {
        var ref;
        (ref = window._stat_track) === null || ref === void 0 ? void 0 : ref.call(window, eventName, args);
    }
}
/**
 * 设置用户公共参数
 * @param userInfo
 */ const setUserCommonParams = (param)=>{
    let { isVip , availableAmount  } = param;
    var // 1）user_type（用户vip类型）：0非会员，1svip，2未登陆
    // 2) residual_meidou：剩余美豆数，未登陆上报no_login
    ref;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setCommonParams({
        user_type: isVip == null ? "2" : isVip ? "1" : "0",
        residual_meidou: availableAmount == null ? "no_login" : String(availableAmount)
    });
};


/***/ }),

/***/ 3269:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": () => (/* binding */ appendQueryParams),
/* harmony export */   "Ow": () => (/* binding */ deleteQueryParams),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam),
/* harmony export */   "pm": () => (/* binding */ getQuery)
/* harmony export */ });
/* unused harmony exports stringifyQuery, parseQueryString */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

/**
 * 获取地址参数对象
 * @return
 */ const getQuery = ()=>{
    if (false) {}
    return parseQueryString(window.location.search);
};
function stringifyQuery(params) {
    let sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return qs.stringify(params, sort ? {
        sort: (a, b)=>a.localeCompare(b)
    } : undefined);
}
function parseQueryString(query) {
    // Remove any leading '?' from the query string
    if (query.startsWith("?")) {
        query = query.slice(1);
    }
    return qs__WEBPACK_IMPORTED_MODULE_0___default().parse(query);
}
/**
 * 获取指定的参数
 * @param key
 * @param defaultValue
 * @param query
 * @return
 */ const getQueryParam = (key, defaultValue, query)=>{
    const q = query || getQuery();
    return q[key] || defaultValue;
};
const appendQueryParams = function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const url = new URL(window.location.href);
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        if (value !== undefined && value !== null) {
            url.searchParams.set(key, value);
        }
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};
const deleteQueryParams = (keys)=>{
    const url = new URL(window.location.href);
    const keyList = Array.isArray(keys) ? keys : [
        keys
    ];
    keyList.forEach((key)=>{
        url.searchParams.delete(key);
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};


/***/ }),

/***/ 31738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ request)
});

// UNUSED EXPORTS: genMtccHeader, getCommonParams

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./src/constants/code.ts
var constants_code = __webpack_require__(90480);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/query.ts
var utils_query = __webpack_require__(3269);
// EXTERNAL MODULE: ./src/utils/sdk.ts
var sdk = __webpack_require__(82345);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./src/utils/gid.ts
var utils_gid = __webpack_require__(83353);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
// EXTERNAL MODULE: ./src/constants/workbench.ts
var workbench = __webpack_require__(40313);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var dist_utils = __webpack_require__(16197);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({ randomUUID });

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
    if (esm_browser_native.randomUUID && !buf && !options) {
        return esm_browser_native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
        for (let i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return unsafeStringify(rnds);
}
/* harmony default export */ const esm_browser_v4 = (v4);

;// CONCATENATED MODULE: ./node_modules/web-vitals/dist/web-vitals.js
var e,n,t,r,i,o=-1,a=function(e){addEventListener("pageshow",(function(n){n.persisted&&(o=n.timeStamp,e(n))}),!0)},c=function(){var e=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),r="navigate";o>=0?r="back-forward-cache":t&&(document.prerendering||u()>0?r="prerender":document.wasDiscarded?r="restore":t.type&&(r=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return r.observe(Object.assign({type:e,buffered:!0},t||{})),r}}catch(e){}},d=function(e,n,t,r){var i,o;return function(a){n.value>=0&&(a||r)&&((o=n.value-(i||0))||void 0===i)&&(i=n.value,n.delta=o,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&e()}))},v=function(e){var n=!1;return function(){n||(e(),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),a((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},b=[1800,3e3],S=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("FCP"),o=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(o.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries.push(e),t(!0)))}))}));o&&(t=d(e,i,b,n.reportAllChanges),a((function(r){i=f("FCP"),t=d(e,i,b,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,t(!0)}))})))}))},L=[.1,.25],w=function(e,n){n=n||{},S(v((function(){var t,r=f("CLS",0),i=0,o=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=o[0],t=o[o.length-1];i&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(i+=e.value,o.push(e)):(i=e.value,o=[e])}})),i>r.value&&(r.value=i,r.entries=o,t())},u=s("layout-shift",c);u&&(t=d(e,r,L,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),a((function(){i=0,r=f("CLS",0),t=d(e,r,L,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A=0,I=1/0,P=0,M=function(e){e.forEach((function(e){e.interactionId&&(I=Math.min(I,e.interactionId),P=Math.max(P,e.interactionId),A=P?(P-I)/7+1:0)}))},k=function(){return e?A:performance.interactionCount||0},F=function(){"interactionCount"in performance||e||(e=s("event",M,{type:"event",buffered:!0,durationThreshold:0}))},D=[],x=new Map,R=0,B=function(){var e=Math.min(D.length-1,Math.floor((k()-R)/50));return D[e]},H=[],q=function(e){if(H.forEach((function(n){return n(e)})),e.interactionId||"first-input"===e.entryType){var n=D[D.length-1],t=x.get(e.interactionId);if(t||D.length<10||e.duration>n.latency){if(t)e.duration>t.latency?(t.entries=[e],t.latency=e.duration):e.duration===t.latency&&e.startTime===t.entries[0].startTime&&t.entries.push(e);else{var r={id:e.interactionId,latency:e.duration,entries:[e]};x.set(r.id,r),D.push(r)}D.sort((function(e,n){return n.latency-e.latency})),D.length>10&&D.splice(10).forEach((function(e){return x.delete(e.id)}))}}},O=function(e){var n=self.requestIdleCallback||self.setTimeout,t=-1;return e=v(e),"hidden"===document.visibilityState?e():(t=n(e),p(e)),t},N=[200,500],j=function(e,n){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(n=n||{},C((function(){var t;F();var r,i=f("INP"),o=function(e){O((function(){e.forEach(q);var n=B();n&&n.latency!==i.value&&(i.value=n.latency,i.entries=n.entries,r())}))},c=s("event",o,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});r=d(e,i,N,n.reportAllChanges),c&&(c.observe({type:"first-input",buffered:!0}),p((function(){o(c.takeRecords()),r(!0)})),a((function(){R=k(),D.length=0,x.clear(),i=f("INP"),r=d(e,i,N,n.reportAllChanges)})))})))},_=[2500,4e3],z={},G=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("LCP"),o=function(e){n.reportAllChanges||(e=e.slice(-1)),e.forEach((function(e){e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries=[e],t())}))},c=s("largest-contentful-paint",o);if(c){t=d(e,i,_,n.reportAllChanges);var m=v((function(){z[i.id]||(o(c.takeRecords()),c.disconnect(),z[i.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return O(m)}),{once:!0,capture:!0})})),p(m),a((function(r){i=f("LCP"),t=d(e,i,_,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,z[i.id]=!0,t(!0)}))}))}}))},J=[800,1800],K=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Q=function(e,n){n=n||{};var t=f("TTFB"),r=d(e,t,J,n.reportAllChanges);K((function(){var i=c();i&&(t.value=Math.max(i.responseStart-u(),0),t.entries=[i],r(!0),a((function(){t=f("TTFB",0),(r=d(e,t,J,n.reportAllChanges))(!0)})))}))},U={passive:!0,capture:!0},V=new Date,W=function(e,i){n||(n=i,t=e,r=new Date,Z(removeEventListener),X())},X=function(){if(t>=0&&t<r-V){var e={entryType:"first-input",name:n.type,target:n.target,cancelable:n.cancelable,startTime:n.timeStamp,processingStart:n.timeStamp+t};i.forEach((function(n){n(e)})),i=[]}},Y=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){W(e,n),i()},r=function(){i()},i=function(){removeEventListener("pointerup",t,U),removeEventListener("pointercancel",r,U)};addEventListener("pointerup",t,U),addEventListener("pointercancel",r,U)}(n,e):W(n,e)}},Z=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,Y,U)}))},$=(/* unused pure expression or super */ null && ([100,300])),ee=function(e,r){r=r||{},C((function(){var o,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),o(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);o=d(e,u,$,r.reportAllChanges),h&&(p(v((function(){m(h.takeRecords()),h.disconnect()}))),a((function(){var a;u=f("FID"),o=d(e,u,$,r.reportAllChanges),i=[],t=-1,n=null,Z(addEventListener),a=l,i.push(a),X()})))}))};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LOCALSTORAGE_COUNTRYCODE_KEY = "xdesign-utils__country-code";
// 是否更新过本地国家码缓存
var hasUpdateLocalCountryCode = false;
// 正在请求状态
var fetchLoading = false;
var processingFetch = function () { };
var instanceFetch = null;
var getRequestUrl = function () {
    if (window.isIntl && window.deployApp === 'designkit') {
        return 'designkit-webapi.designkit.com';
    }
    return window.isIntl ? "www.x-design.com/api" : "webapi.designkit.cn";
};
var fetchRequest = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultCode, res, data, info, code;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                defaultCode = window.isIntl ? "SG" : "CN";
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                fetchLoading = true;
                return [4 /*yield*/, (0,axios/* default */.Z)("https://".concat(getRequestUrl(), "/common/ip_location"), {
                        params: { ts_random_id: esm_browser_v4() },
                        timeout: timeout,
                    })];
            case 2:
                res = _b.sent();
                data = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || {};
                info = Object.values(data)[0] || {};
                code = info === null || info === void 0 ? void 0 : info.nation_code;
                if (code) {
                    hasUpdateLocalCountryCode = true;
                    // 更新缓存
                    window.localStorage.setItem(LOCALSTORAGE_COUNTRYCODE_KEY, code);
                }
                processingFetch(code || defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 3:
                _b.sent();
                processingFetch(defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var handleGetCodeProcess = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fetchRequest(timeout || 200);
                return [4 /*yield*/, new Promise(function (resolve) { return (processingFetch = resolve); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * 获取云储存分摊埋点透传值
 * @param timeout ip_location接口超时时间
 * @returns
 */
var getCountryCode = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var country_code, country_code_local, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                country_code_local = (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem(LOCALSTORAGE_COUNTRYCODE_KEY);
                if (!!country_code_local) return [3 /*break*/, 5];
                if (!instanceFetch) return [3 /*break*/, 2];
                return [4 /*yield*/, instanceFetch];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (instanceFetch = handleGetCodeProcess(timeout))];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                // 处理并发情况
                country_code = _a;
                // 成功后释放实例
                instanceFetch = null;
                return [3 /*break*/, 6];
            case 5:
                country_code = country_code_local;
                _c.label = 6;
            case 6:
                // 如果还没请求过接口，异步更新本地缓存
                if (!hasUpdateLocalCountryCode && !fetchLoading) {
                    fetchRequest(3000);
                }
                return [2 /*return*/, country_code];
        }
    });
}); };

/**
 * 获取云储存分摊埋点透传值
 * @param options
 * @returns
 */
var getMTCCClient = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var gid, functionInfo, positionInfo, isToB, virtualId, uid, osType, app_id, isIntl, isTeam, isPcPlatform, mediaType, resMediaType, country_code, appId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gid = options.gid, functionInfo = options.functionInfo, positionInfo = options.positionInfo, isToB = options.isToB, virtualId = options.virtualId, uid = options.uid, osType = options.osType, app_id = options.app_id, isIntl = options.isIntl, isTeam = options.isTeam, isPcPlatform = options.isPcPlatform, mediaType = options.mediaType, resMediaType = options.resMediaType;
                return [4 /*yield*/, getCountryCode()];
            case 1:
                country_code = _a.sent();
                appId = '';
                if (app_id) {
                    // 业务自定义
                    appId = app_id;
                }
                else if (isPcPlatform) {
                    // pc内嵌下
                    appId = '8045';
                }
                else if (isIntl || window.isIntl) {
                    // designKit 全球化 / 海外 x-design
                    appId = window.deployApp === 'designkit' ? '227' : '2000010';
                }
                else {
                    // web国内
                    appId = '178';
                }
                return [2 /*return*/, btoa(JSON.stringify({
                        app_id: appId,
                        os_type: osType,
                        country_code: country_code,
                        gnum: gid,
                        function: functionInfo,
                        position: positionInfo,
                        media_type: mediaType,
                        res_media_type: resMediaType,
                        ext_info: {
                            biz_type: isTeam ? 'team' : isToB ? 'api' : '',
                            virtual_id: virtualId,
                        },
                        uid: uid || '',
                    }))];
        }
    });
}); };

var num = 0;
var getDemo = function () {
    num++;
    return num;
};

/**
 * 初始化访问两个页面上报代码
 * @param callback
 */
var initViewMoreThan2Pages = function (callback) {
    var pageViewCount = Number(localStorage.getItem("gaPageViewCount"));
    pageViewCount++;
    if (pageViewCount === 3) {
        // 广告转化
        callback("conversion", {
            send_to: "AW-871914325/YIzgCInN5ssZENW24Z8D",
        });
        // ga 事件
        callback("view_more_than_2_pages", {});
    }
    localStorage.setItem("gaPageViewCount", String(pageViewCount));
};
/**
 * 初始化访问超过1分钟页面上报代码
 * @param callback
 */
var initViewMoreThan1Min = function (callback) {
    var currentTotalTime = Number(localStorage.getItem("gaTotalTime")) || 0;
    var timer;
    if (currentTotalTime < 60) {
        var totalTime_1 = 0;
        timer = setInterval(function () {
            if (localStorage.getItem("gaTotalTime") != null) {
                totalTime_1 = Number(localStorage.getItem("gaTotalTime")) || 0;
                totalTime_1++;
                if (totalTime_1 > 60) {
                    clearInterval(timer);
                    return;
                }
                localStorage.setItem("gaTotalTime", String(totalTime_1));
                if (totalTime_1 == 60) {
                    // 广告转化
                    callback("conversion", {
                        send_to: "AW-871914325/mF1GCIbN5ssZENW24Z8D",
                    });
                    //GA4
                    callback("view_more_than_1_min", {});
                }
            }
            else {
                totalTime_1 = 0;
                localStorage.setItem("gaTotalTime", String(totalTime_1));
            }
        }, 1000);
    }
};
/**
 * @description 轮询获取gtag 是否已经动态插入
 * @returns
 */
var checkGtagLoaded = function () {
    var count = 0;
    return new Promise(function (res, rej) {
        // 如果 gtag 未定义，轮询检查,超过1分钟直接暂停
        var interval = setInterval(function () {
            if (window.dataLayer && window.gtag) {
                clearInterval(interval);
                res(true);
            }
            count++;
            // 超过60秒 放弃轮询
            if (count > 30) {
                clearInterval(interval);
                rej({ message: "not gtag" });
            }
        }, 2000); // 每2秒检查一次
    });
};
/**
 * @description 初始化基础分析
 * @param param
 */
var initBasicAnalysis = function (_a) {
    var hasViewMoreThan2Pages = _a.hasViewMoreThan2Pages, hasViewMoreThan1Min = _a.hasViewMoreThan1Min, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, checkGtagLoaded()];
                case 1:
                    _b.sent();
                    hasViewMoreThan2Pages && initViewMoreThan2Pages(callback);
                    hasViewMoreThan1Min && initViewMoreThan1Min(callback);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};

// 埋点文档 https://dayu.starii-rover.com/requirement/requirement?sso_code=7218504577643970560_1721025604
var DEFAULT_CONFIG = {
    debug_mode: true,
    traffic_type: "internal",
};
/**
 * @description GAEventTracker 类 谷歌自定义事件埋点
 */
var GAEventTracker = /** @class */ (function () {
    function GAEventTracker() {
        this.entrance = null;
        this.isStopGa = false; // 默认收集 ga 自定义事件
        this.env = "pre"; // 默认为pre环境
    }
    /**
     * @description 获取当前埋点入口
     * @returns
     */
    GAEventTracker.prototype.getEntrance = function () {
        return this.entrance;
    };
    /**
     * @description 设置当前埋点入口
     * @param newEntrance
     * @example
     *     比如用户在导航登录按钮点击之后需要设置当前埋点入口为 TopNav
     *     gaEventTracker.setEntrance('TopNav')
     */
    GAEventTracker.prototype.setEntrance = function (newEntrance) {
        this.entrance = newEntrance;
    };
    /**
     * @description 获取是否暂停ga 收集 状态
     * @returns
     */
    GAEventTracker.prototype.getIsStopGa = function () {
        return this.isStopGa;
    };
    /**
     * @description 设置是否暂停ga 收集
     * @param {boolean} bool     是否暂停
     * @example
     *     setStopGa(true)   // 停止收集
     *     setStopGa(false)  // 开始收集
     */
    GAEventTracker.prototype.setStopGa = function (bool) {
        this.isStopGa = bool;
    };
    /**
     * @description 设置配置
     * @param {"pre"|"beta"|"release"}  pre                          环境
     * @param {boolean} [isStopGa = false] isStopGa                  是否暂停ga 收集 默认为false
     * @example
     *     setConfig({env:'pre'}) // 设置环境为pre
     *     setConfig({env:'pre',isStopGa: true}) // 设置环境为pre,暂停ga 自定义事件收集
     */
    GAEventTracker.prototype.setConfig = function (config) {
        var _this = this;
        var env = config.env, _a = config.isStopGa, isStopGa = _a === void 0 ? false : _a, _b = config.hasViewMoreThan1Min, hasViewMoreThan1Min = _b === void 0 ? true : _b, _c = config.hasViewMoreThan2Pages, hasViewMoreThan2Pages = _c === void 0 ? true : _c;
        this.env = env;
        this.isStopGa = isStopGa;
        // 默认添加 网页浏览超过2页面 & 网页浏览超过1分钟 统计
        if (typeof window !== "undefined") {
            initBasicAnalysis({
                hasViewMoreThan2Pages: hasViewMoreThan2Pages,
                hasViewMoreThan1Min: hasViewMoreThan1Min,
                callback: function (eventName, eventParams) {
                    _this.sendGaEvent(eventName, eventParams);
                },
            });
        }
    };
    /**
     * @description 获取当前环境
     * @returns
     */
    GAEventTracker.prototype.getEnv = function () {
        return this.env;
    };
    /**
     * @description 获取GAEventTracker实例
     * @returns
     */
    GAEventTracker.getInstance = function () {
        if (!GAEventTracker.instance) {
            GAEventTracker.instance = new GAEventTracker();
        }
        return GAEventTracker.instance;
    };
    /**
     * @description 发送GA事件
     * @param {string} eventName
     * @param {any} eventParams
     * @example
     *     目前之封装了注册|登录、购买成功的、保存成功的事件（都是基于 sendGaEvent 事件来的），如果其他事件需要发送，可以直接调用sendGaEvent方法
     */
    GAEventTracker.prototype.sendGaEvent = function (eventName, eventParams) {
        var _a;
        if (this.isStopGa) {
            // 暂停事件收集，直接退出
            return;
        }
        // 发送GA事件
        // debug_mode 模式打开可在谷歌分析后台debugview 里查看实时事件
        // traffic_type = internal 区分内部测试数据，beta|pre 环境都是内部测试数据，release 环境是正式数据
        if (window.dataLayer && window.gtag) {
            var params = eventParams;
            if (this.env !== "release") {
                params = __assign(__assign({}, params), DEFAULT_CONFIG);
            }
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName, params);
        }
    };
    /**
     * @description 发送登录/注册结果GA事件
     * @param {boolean} isRegister                          是否注册  MeituAccount里的 onLoginSuccess 第二个参数可以区分是否注册
     * @param {string|undefined} [platform='email']         平台（登录方式） MeituAccount里的 onLoginSuccess 第一个参数的platform属性 可以区分平台，
     * @param {string} pageName                             页面名称
     * @param {string|undefined} [entrance]                 入口名称
     * @example
     *     MeituAccount({
     *            ......
     *            onLoginSuccess: (result, isRegister) => {
     *                    //result.platform 是存在undefined 的情况的
     *                    const pageName = 'home'
     *                    const entrance = 'xxxxx' // 入口名称
     *                    gaEventTracker.sendLoginGaTrack(isRegister, result.platform, pageName, entrance)
     *            }
     *            ....
     *    })
     * @see MeituAccount 登录注册接口文档 https://f2er.meitu.com/account/api/account-alipay-mini-program/function/onLoginSuccess
     */
    GAEventTracker.prototype.sendLoginGaTrack = function (isRegister, platform, pageName, entrance) {
        if (platform === void 0) { platform = "email"; }
        // ads转化代码
        if (isRegister) {
            this.sendGaEvent("conversion", {
                send_to: "AW-871914325/fpXBCIPN5ssZENW24Z8D",
            });
        }
        this.sendGaEvent(isRegister ? "register_result" : "login_result", {
            page_name: pageName,
            method: platform,
            entrance: entrance || this.entrance || "topnav",
        });
    };
    /**
     * @description 发送购买结果GA事件
     * @param {OrderTradeProgress[]} tradeProgress        订单交易数据
     * @param {boolean} isVip                             是否是会员
     * @param {string} funcSource                         功能来源
     * @param {string|undefined} [entrance]               入口名称
     * @example
     *    openSubscribePopup({
     *            ......
     *            onTradeFinish(tradeProgress) {
     *                const isVip = true // 假设是会员
     *                const funcSource = 'home' // 假设是首页
     *                const entrance = 'xxxxx' // 入口名称
     *                gaEventTracker.sendPurchaseGaTrack(tradeProgress, isVip, funcSource,entrance)
     *            }
     *            ......
     *    })
     * @see tradeProgress 交易接口文档 https://f2er.meitu.com/subscribe/api/subscribe-core/interface/OrderTradeProgressProduct
     */
    GAEventTracker.prototype.sendPurchaseGaTrack = function (tradeProgress, isVip, funcSource, entrance) {
        var _this = this;
        tradeProgress.forEach(function (v, i) {
            var _a = v.product, productId = _a.productId, moneyUnit = _a.moneyUnit, price = _a.price, isProbation = _a.isProbation, payChannel = v.payChannel, transactionId = v.transactionId;
            var gaData = {
                value: price,
                currency: moneyUnit,
                transaction_id: transactionId,
                user_type: isVip ? 1 : 0,
                item_id: productId,
                payment_type: payChannel,
                is_try: isProbation ? 0 : 1,
                func_source: funcSource,
                entrance: entrance || _this.entrance || "topnav",
            };
            // ads转化代码
            _this.sendGaEvent("conversion", {
                send_to: "AW-871914325/CMpSCIzN5ssZENW24Z8D",
            });
            // ga
            _this.sendGaEvent("purchase", gaData);
        });
    };
    /**
     * @description     发送保存成功GA事件
     * @param {string} from                               来源
     * @param {string} func                               功能名称
     * @example
     *      const from = 'home';// 假设是home, 可以调用 getFrom() 方法获取来源，如果有的话
     *      const func = 'create_now';// 假设是create_now
     *      sendSaveSuccessGaTrack(from, func)
     */
    GAEventTracker.prototype.sendSaveSuccessGaTrack = function (from, func) {
        if (func === void 0) { func = "create_now"; }
        // 获取链接from参数
        this.sendGaEvent("save_success", {
            source: from || "other",
            func: func,
        });
    };
    GAEventTracker.prototype.sendUploadClickGaTrack = function () {
        // 获取链接from参数
        this.sendGaEvent("upload_click", {});
    };
    return GAEventTracker;
}());
var gaEventTracker = GAEventTracker.getInstance();

/**
 * @description 弹窗弹出管理器，目前支持登录和下载 时机时主动弹出订阅弹窗
 */
var PopupManager = /** @class */ (function () {
    // 私有构造函数，防止外部实例化
    function PopupManager() {
        this.maxLoginPopupCount = 1;
        this.maxDownloadPopupCount = 1;
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
        if (typeof window !== "undefined") {
            // 仅在客户端环境中访问 localStorage
            var savedState = localStorage.getItem("popupState");
            if (savedState) {
                this.state = JSON.parse(savedState);
            }
            else {
                this.updateState();
            }
        }
    }
    // 获取单例实例
    PopupManager.getInstance = function () {
        if (!PopupManager.instance) {
            PopupManager.instance = new PopupManager();
        }
        return PopupManager.instance;
    };
    // 设置配置方法
    /**
     * @description 设置配置方法
     * @param config PopupConfig
     * @example
     *
     *      //项目初始化的时候
     *      setConfig({
     *        maxLoginPopupCount: 1, // 最大登录弹窗次数
              maxDownloadPopupCount: 1, // 最大下载弹窗次数
     *      })
     */
    PopupManager.prototype.setConfig = function (config) {
        var maxLoginPopupCount = config.maxLoginPopupCount, maxDownloadPopupCount = config.maxDownloadPopupCount;
        if (maxLoginPopupCount !== undefined) {
            this.maxLoginPopupCount = maxLoginPopupCount;
        }
        if (maxDownloadPopupCount !== undefined) {
            this.maxDownloadPopupCount = maxDownloadPopupCount;
        }
    };
    // 更新并保存状态到 localStorage
    PopupManager.prototype.updateState = function () {
        localStorage.setItem("popupState", JSON.stringify(this.state));
    };
    /**
     * @description 弹出处理方法
     * @param popupType
     * @param callback
     * @example
     *     在需要主动弹出订阅时调用
     *     popupManager.handlePopup("login", () => {
     *        // 弹出订阅窗口 逻辑，比如 (openVipModal 是业务方打开订阅窗口公共方法)
     *        openVipModal({
                entrance: xxxx,
                source: xxxx,
                trackEntrance: xxxxx,
              })
     *     })
     */
    PopupManager.prototype.handlePopup = function (popupType, callback) {
        if (popupType === "login") {
            if (this.state.currentLoginPopupCount < this.maxLoginPopupCount) {
                this.state.currentLoginPopupCount++;
                this.updateState();
                callback();
            }
        }
        else if (popupType === "download") {
            if (this.state.currentDownloadPopupCount < this.maxDownloadPopupCount) {
                this.state.currentDownloadPopupCount++;
                this.updateState();
                callback();
            }
        }
    };
    /**
     * @description 退出登录清空数据
     * @example
     *      //退出登录时调用
     *      popupManager.logout()
     */
    PopupManager.prototype.logout = function () {
        if (typeof window !== "undefined") {
            localStorage.removeItem("popupState");
        }
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
    };
    return PopupManager;
}());
var popupManager = PopupManager.getInstance();

var checkDebugConfig = function () {
    var localConfig = window.localStorage.getItem("performanceMonitor");
    if (!localConfig) {
        return false;
    }
    try {
        var debug = JSON.parse(localConfig).debug;
        return !!debug;
    }
    catch (e) {
        return false;
    }
};
var prettyLog = function (title, text, rating) {
    var color = "#00a67d";
    if (rating === "needs-improvement") {
        color = "#ffc92e";
    }
    if (rating === "poor") {
        color = "#f22c3d";
    }
    console.log("%c ".concat(title, " %c ").concat(text, "ms %c"), "background:".concat(color, ";border:1px solid ").concat(color, "; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;"), "border:1px solid ".concat(color, "; padding: 1px; border-radius: 0 2px 2px 0; color: ").concat(color, ";"), "background:transparent");
};
var log = function (name, data) {
    if (!checkDebugConfig()) {
        return;
    }
    var arr = __spreadArray([], (0,lodash.map)(data, function (value, key) { return ({ key: key, value: value }); }), true);
    console.table(arr, ["key", "value"]);
    prettyLog(name, data.value || data.duration, data.rating);
};
/**
 * 获取当前网络信息
 * @returns 网络信息对象
 */
var getNetworkInfo = function () {
    var networkInfo = {};
    // 获取连接类型信息
    if (navigator.connection) {
        var connection = navigator.connection;
        networkInfo.effectiveType = connection.effectiveType || "unknown"; // 有效网络类型：4g、3g、2g、slow-2g
        networkInfo.downlink = connection.downlink || 0; // 下行速度(Mbps)
        networkInfo.rtt = connection.rtt || 0; // 往返时间(ms)
        networkInfo.saveData = connection.saveData || false; // 是否启用省流量模式
        networkInfo.type = connection.type || "unknown"; // 网络类型
    }
    // 获取在线状态
    networkInfo.online = navigator.onLine;
    return networkInfo;
};
/**
 * @description 上报埋点
 * @param data
 */
var handlerWebVitalsTrack = function (data) {
    var metric = data.metric, name = data.name, statTrack = data.statTrack, domInfo = data.domInfo;
    log(name, metric);
    statTrack("tech_metric_web_basic", {
        metric_type: name,
        duration: metric.value,
        score: metric.rating,
        //源数据
        metricData: metric,
        //是否登录, 首页和工作台访问需要区分是否登录
        isLogin: !!window.localStorage.getItem("uid"),
        // 网络情况数据
        networkInfo: getNetworkInfo(),
        // 元素信息
        domInfo: domInfo,
    });
};
/**
 *
 * @param url 获取url参数长度
 * @returns
 */
var getUrlParamsLength = function (url) {
    var queryIndex = url.indexOf("?");
    if (queryIndex === -1)
        return 0; // 没有参数
    return url.length - queryIndex - 1;
};
/**
 * 获取请求参数数据
 * @param response Axios响应对象
 * @returns POST请求返回data数据，GET请求返回params数据
 */
var getUrlParamsData = function (config) {
    var method = config.method;
    if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "POST") {
        return config.data;
    }
    else {
        return config.params;
    }
};
/**
 * 获取请求 status 对应的 code (埋点用), 2xx 都算成功
 * @param status 状态码
 * @returns number 1: 成功，0: 失败
 */
var getRequestSuccess = function (status) {
    return status >= 200 && status < 300 ? 1 : 0;
};
/**
 * @description 获取DOM元素的className
 * @param metric
 * @returns
 */
var getDomInfo = function (metric) {
    var className = "";
    var nodeName = "";
    var innerText = "";
    try {
        var entriesData = metric.entries;
        if (entriesData && entriesData[0]) {
            var target = entriesData[0].target;
            if (target) {
                if (target.className) {
                    className = target.className;
                }
                if (target.nodeName) {
                    nodeName = target.nodeName;
                }
                if (target.innerText) {
                    innerText = target.innerText;
                }
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return {
        className: className,
        nodeName: nodeName,
        innerText: innerText,
    };
};

/**
 * @description 性能监控与埋点工具箱
 * 提供Web性能监控和各类操作耗时统计的能力
 * @link 埋点文档: https://dayu.starii-rover.com/requirement/requirement?id=3096&appId=227&platformAgg=WEB&fullScreen=true
 * @link 需求文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=549555498
 */
var performanceMonitor = {
    utils: {
        getUrlParamsData: getUrlParamsData,
        getUrlParamsLength: getUrlParamsLength,
    },
    setConfig: function (config) {
        window.localStorage.setItem("performanceMonitor", JSON.stringify(config));
    },
    /**
     * @description 监控并上报Web Vitals核心性能指标
     * 包括：TTFB, LCP, FCP, INP, CLS
     * @param statTrack 数据上报函数
     * @param sentry Sentry实例 （预留）
     */
    reportWebVitals: function (statTrack, sentry) {
        /**
         * @description 测量 TTFB (Time to First Byte)
         * 测量从请求开始到收到第一个字节的时间
         * 反映服务器响应速度
         * @example 如果 value 是 200，表示用了 200ms 接收到首字节
         */
        Q(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "TTFB", statTrack: statTrack });
        });
        /**
         * @description  LCP (Largest Contentful Paint)
         * 测量页面最大内容元素的渲染时间
         * 反映页面加载性能
         * @example 如果 value 是 2000，表示最大内容元素渲染了 2000ms
         */
        G(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "LCP", statTrack: statTrack });
        }, { reportAllChanges: true });
        /**
         * @description  FCP (First Contentful Paint)
         * 测量首次内容绘制时间
         * 反映用户首次看到实际内容的时间
         * @example 如果 value 是 1000，表示用户在 1 秒后看到第一个内容
         */
        S(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "FCP", statTrack: statTrack });
        });
        /**
         * @description  INP (Interaction to Next Paint)
         * 测量交互到下一次绘制的时间
         * 反映页面交互响应性能
         * @example 如果 value 是 200，表示用户交互后200ms内完成了视觉更新
         */
        j(function (metric) {
            handlerWebVitalsTrack({
                metric: metric,
                name: "INP",
                statTrack: statTrack,
                domInfo: getDomInfo(metric),
            });
        }, { reportAllChanges: true });
        /**
         * @description  CLS (Cumulative Layout Shift)
         * 测量累积布局偏移
         * 反映页面视觉稳定性
         * @example 如果 value 是 0.1，表示页面的视觉稳定性较好，得分范围通常在 0-1 之间，越接近 0 越好
         */
        w(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "CLS", statTrack: statTrack });
        }, { reportAllChanges: true });
    },
    /**
     * @description 获取操作开始时间戳
     * 用于记录任意操作的开始时间，如API请求、资源下载、计算过程等
     * @example
     * const startTime = performanceMonitor.getStartTime();
     * @returns {number} 当前时间戳（performance.now()）
     */
    getStartTime: function () {
        return performance.now();
    },
    /**
     * @description 上报操作耗时[通用]
     * 计算并上报任意操作的耗时数据，如API请求、资源下载、计算过程等
     * @param data.startTime 操作开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，附加数据
     * @param data.sentry Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @example
     * // API请求耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "api_request",
     *   trackData: { url: "/api/users", method: "GET" }
     * });
     *
     * // 资源加载耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "resource_load",
     *   trackData: { type: "image", url: "https://example.com/image.png" }
     * });
     */
    reportTiming: function (data, callback) {
        var startTime = data.startTime, statTrack = data.statTrack, _a = data.eventName, eventName = _a === void 0 ? "general_timing" : _a, _b = data.trackData, trackData = _b === void 0 ? {} : _b;
        var duration = performance.now() - startTime;
        log(eventName, __assign(__assign({}, trackData), { duration: duration }));
        statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
        callback === null || callback === void 0 ? void 0 : callback();
    },
    /**
     * @description 上报Axios请求耗时
     * 计算并上报 Axios 请求的耗时数据
     * @param data.statTrack 数据上报函数
     * @param data.config Axios请求配置
     * @param data.status 响应状态码
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     * @example
     * @example
     * // 假设在Axios请求拦截器中记录了请求开始时间
     * axios.interceptors.request.use(config => {
     *   config.startTime = performance.now();  // 记录请求开始时间
     *   return config;
     * });
     *
     * // 在响应拦截器中计算并上报耗时
     * axios.interceptors.response.use(response => {
     *   const { startTime, statTrack } = response.config;   // 从请求配置中获取开始时间
     *   performanceMonitor.reportRequestTiming({
     *     statTrack,
     *     status: response.status,  // 响应状态码
     *     config: response.config  // 完整的请求配置
     *   });
     *   return response;  // 继续处理响应
     * })
     */
    reportRequestTiming: function (data, callback) {
        var config = data.config, statTrack = data.statTrack, status = data.status;
        if (!config)
            return;
        var startTime = config.startTime, method = config.method, url = config.url;
        if (!startTime || !url)
            return;
        this.reportTiming({
            startTime: startTime,
            statTrack: statTrack,
            eventName: "tech_metric_api_request_result",
            trackData: {
                is_success: status !== undefined ? getRequestSuccess(status) : 0,
                api_endpoint: url,
                request_method: method ? method.toUpperCase() : undefined,
                request_params: getUrlParamsData(config),
                param_length: getUrlParamsLength(url),
            },
        }, callback);
    },
    /**
     * @description 监控DOM元素渲染时间
     * 使用MutationObserver监听特定DOM元素的变化，计算并上报渲染耗时
     * @param data.startTime 可选，开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.element 要监控的DOM元素引用（例如React的ref.current）
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，额外上报数据
     * @param data.config 可选，MutationObserver配置
     * @param data.timeout 可选，监控超时时间(ms)，默认10000ms
     * @param data.waitForImages 可选，是否要等待src属性的图片加载完成，默认true [大部分都是图片列表，如果只是简单监听dom渲染可以直接设置为false]
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @returns MutationObserver实例，可用于手动断开观察
     * @example
     * // 在React组件中使用
     * const contentRef = useRef(null);
     * useEffect(() => {
     *   // startTime 可选，reportRenderTime 方法里有做自动获取 startTime 处理
     *   const startTime = performanceMonitor.getStartTime();
     *   // 数据加载完成后监控DOM渲染
     *   performanceMonitor.reportRenderTime({
     *     startTime,
     *     element: contentRef.current,
     *     statTrack,
     *     eventName: "list_render",
     *     trackData: { itemsCount: items.length }
     *   });
     * }, [items]);
     */
    reportRenderTime: function (data, callback) {
        var _a = data.startTime, startTime = _a === void 0 ? this.getStartTime() : _a, statTrack = data.statTrack, element = data.element, eventName = data.eventName, _b = data.trackData, trackData = _b === void 0 ? {} : _b, _c = data.config, config = _c === void 0 ? {
            childList: true,
            subtree: true,
            attributes: true,
        } : _c, _d = data.timeout, timeout = _d === void 0 ? 10000 : _d, _e = data.waitForImages, waitForImages = _e === void 0 ? true : _e;
        if (!element) {
            console.warn("reportRenderTime：The element is null.");
            return null;
        }
        // 防止重复上报
        var hasReported = false;
        // 创建MutationObserver实例
        var observer = new MutationObserver(function (mutations) {
            if (hasReported)
                return;
            // 确保DOM渲染后再检查图片
            requestAnimationFrame(function () {
                if (waitForImages) {
                    // 获取容器内所有图片
                    var images_1 = element.querySelectorAll("img");
                    if (images_1.length === 0) {
                        // 没有图片，直接上报DOM渲染时间
                        reportTiming();
                        return;
                    }
                    // 检查所有图片是否已加载
                    var loadedCount_1 = 0;
                    var imageArray = Array.from(images_1);
                    // 已加载的图片计数
                    imageArray.forEach(function (img) {
                        if (img.complete) {
                            loadedCount_1++;
                        }
                        else {
                            // 为未加载完的图片添加事件监听
                            img.addEventListener("load", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                            // 处理图片加载失败情况
                            img.addEventListener("error", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                        }
                    });
                    // 如果所有图片已经加载完成，直接上报
                    if (loadedCount_1 === images_1.length && !hasReported) {
                        // 确保这里也检查hasReported
                        reportTiming();
                    }
                }
                else {
                    // 不等待图片加载，仅监控DOM变化
                    reportTiming();
                }
            });
        });
        // 上报时间的函数
        function reportTiming() {
            if (hasReported)
                return; // 即使被多次调用也不会重复上报
            var duration = performance.now() - startTime;
            log(eventName, __assign(__assign({}, trackData), { duration: duration }));
            statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
            hasReported = true;
            observer.disconnect();
            callback === null || callback === void 0 ? void 0 : callback();
        }
        observer.observe(element, config);
        // 设置超时，防止无限等待
        setTimeout(function () {
            if (!hasReported) {
                var duration = -1;
                statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
                observer.disconnect();
                callback === null || callback === void 0 ? void 0 : callback({ timeout: true });
            }
        }, timeout);
    },
};



;// CONCATENATED MODULE: ./src/utils/request.ts

// import qs from "qs";











// 接口公共参数
const getCommonParams = async ()=>{
    if (false) {}
    const gid = await (0,utils_gid/* waitUntilGetGid */.S)();
    return {
        client_id: (0,constants/* getClientID */.kU)(),
        client_language: (0,dist_utils/* getClientLanguage */.XF)("zh-Hans"),
        country_code: (0,dist_utils/* getCountryCode */.so)(),
        gid,
        enter_source: await (0,utils/* getSource */.b5)(),
        preview_mode: constants/* PREVIEW_MODE */.i4
    };
};
// 成本分摊埋点公共参数
const getMtccCommonParams = async ()=>{
    var ref, ref1;
    const isToB = (0,sdk/* checkIsInSdk */.X)();
    const params = {
        gid: (await getCommonParams()).gid,
        app_id: window._appId || undefined,
        osType: await (0,utils/* getOsType */.fP)(),
        isToB,
        // 设计室web:2
        // 内嵌:6
        virtualId: await (0,utils/* isPcPlatform */.FZ)() ? "6" : "2",
        functionInfo: {
            name: workbench/* MTCCDataScene */.AI[workbench/* Scene.AiPPT */.xs.AiPPT]
        },
        positionInfo: {
            level1: workbench/* MTCCDataScene */.AI[workbench/* Scene.AiPPT */.xs.AiPPT]
        },
        uid: (ref = store/* default.getState */.ZP.getState().userModel.userInfo) === null || ref === void 0 ? void 0 : ref.id,
        isPcPlatform: await (0,utils/* isPcPlatform */.FZ)(),
        isTeam: !!((ref1 = (0,lib/* getLocalIdentity */.u5)()) === null || ref1 === void 0 ? void 0 : ref1.oid),
        preview_mode: constants/* PREVIEW_MODE */.i4
    };
    return params;
};
// 成本分摊埋点 header
const genMtccHeader = async (config)=>{
    var ref;
    if (!config) {
        // 无配置则默认为抠图
        config = {
            key: "plugin-matting"
        };
    }
    const MatchMTCC = Object.keys(workbench/* MTCCData */.gA).find((key)=>{
        var ref;
        return config.key === key || ((ref = config.url) === null || ref === void 0 ? void 0 : ref.indexOf(key)) >= 0;
    });
    const isToB = ((ref = config.headers) === null || ref === void 0 ? void 0 : ref["Enterprise-Access-Key"]) ? true : (0,sdk/* checkIsInSdk */.X)();
    if (MatchMTCC) {
        var ref1;
        // 根据 url 匹配到的 MTCCData 的 key，获取对应的 position
        const findKey = workbench/* MTCCData */.gA[MatchMTCC].positionKey;
        const positionKey = findKey && config.data[findKey];
        const specialPosition = positionKey && ((ref1 = workbench/* MTCCData */.gA[MatchMTCC].position) === null || ref1 === void 0 ? void 0 : ref1[positionKey]) || "";
        const defaultMtccParams = await getMtccCommonParams();
        const params = {
            ...defaultMtccParams,
            isToB,
            mediaType: "",
            resMediaType: "",
            functionInfo: {
                ...defaultMtccParams.functionInfo,
                name: defaultMtccParams.functionInfo.name || workbench/* MTCCData */.gA[MatchMTCC].function || ""
            },
            positionInfo: {
                ...defaultMtccParams.positionInfo,
                level1: specialPosition || workbench/* MTCCData */.gA[MatchMTCC].position.default || workbench/* MTCCData */.gA[MatchMTCC].position[workbench/* Scene.AiPPT */.xs.AiPPT] || ""
            }
        };
        ;
        const headerString = await getMTCCClient(params);
        return headerString;
    }
};
// 全局的 axios 默认值
// ATTENTION: 这里的默认值会导致 x-design-widgets NavVipEntrance 组件请求接口错误
// axios.defaults.baseURL = "";
axios/* default.defaults.withCredentials */.Z.defaults.withCredentials = true;
axios/* default.defaults.headers.post.Content-Type */.Z.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// 接口公共参数
// export const serverCommonParams = {
//   client_id: getClientID(),
//   preview_mode: PREVIEW_MODE,
// } as Record<string, string | number>;
// 添加请求拦截器
axios/* default.interceptors.request.use */.Z.interceptors.request.use(async (config)=>{
    const commonParams = await getCommonParams();
    if (config.method === "post") {
        const data = Object.assign({}, commonParams, config.data || {});
        try {
            const headers = await genMtccHeader(config);
            if (headers) {
                config.headers["x-mtcc-client"] = headers;
            }
        } catch (error) {
            ;
        }
        if (config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
        // config.data = qs.stringify(data);
        } else {
            config.data = data;
        }
        config.params = {
            ...commonParams,
            ...config.params
        };
    } else if (config.method === "get") {
        config.params = Object.assign({
            timestamp: new Date().getTime()
        }, commonParams, config.params || {});
    }
    return config;
}, (error)=>{
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios/* default.interceptors.response.use */.Z.interceptors.response.use(async (response)=>{
    var ref;
    if (![
        "get",
        "post"
    ].includes(((ref = response.config) === null || ref === void 0 ? void 0 : ref.method) || "")) return response;
    // const config: RequestConfig = response.config;
    // const hideErrorToast = config.hideErrorToast;
    // console.log('hideErrorToast: ', hideErrorToast);
    // 只针对get/post请求方式的返回做处理
    const code = response.data.error_code;
    // const msg = response.data.msg;
    // console.log('msg: ', msg);
    if (code !== constants_code/* default.OK */.Z.OK) {
    // if (!hideErrorToast) message.error(msg || '请求出错，请稍后再试');
    }
    // 对响应数据做点什么
    return response;
}, (error)=>{
    var ref, ref1;
    // message.error('您的网络发生异常，无法连接服务器');
    // return Promise.reject("您的网络发生异常，无法连接服务器");
    const res = error.response;
    const msg = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.msg) || "请求出错，请稍后再试";
    ;
    return Promise.reject({
        msg,
        network: true,
        data: (res === null || res === void 0 ? void 0 : res.data) || {}
    });
});
function request(api, config) {
    const requestOptions = Object.assign({
        hideErrorToast: false
    }, {
        url: api
    }, config);
    if (!requestOptions.headers) {
        requestOptions.headers = {};
    }
    // 团队版请求头标识
    requestOptions.headers = Object.assign(requestOptions.headers, (0,lib/* getRequestIdentityHeader */.AW)());
    let token = "";
    if (true) {
        const query = (0,utils_query/* getQuery */.pm)();
        token = query.accessToken || window.localStorage.getItem("access_token") || "";
    }
    requestOptions.headers.access_token = token;
    return (0,axios/* default */.Z)(requestOptions);
}


/***/ }),

/***/ 82345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ checkIsInSdk),
/* harmony export */   "r": () => (/* binding */ getAppId)
/* harmony export */ });
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81167);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40313);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3269);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1880);




const checkIsInSdk = ()=>{
    var ref;
    const origin = (ref = query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].parse */ .Z.parse(window.location.search)) === null || ref === void 0 ? void 0 : ref.origin;
    return origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_0__/* .SdkModuleName.aippt */ .sB.aippt && window.self !== window.top;
};
const getAppId = ()=>{
    const query = (0,_query__WEBPACK_IMPORTED_MODULE_3__/* .getQuery */ .pm)();
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                    const res = JSON.parse(xhr.responseText);
                    if (res.data && res.data.app_id !== void 0) {
                        resolve(res.data);
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            }
        };
        xhr.open("get", "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getIntranetHost */ .Cu)(), "/common/get_app_id?client_id=").concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getClientID */ .kU)()), true);
        xhr.setRequestHeader("access_token", query.accessToken || "");
        xhr.send(null);
    });
};


/***/ }),

/***/ 10275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": () => (/* binding */ getRequestIdentityHeader),
/* harmony export */   "LW": () => (/* binding */ setMemoryIdentity),
/* harmony export */   "Nz": () => (/* binding */ setLocalOriginUid),
/* harmony export */   "Rw": () => (/* binding */ getIdentityFromCookie),
/* harmony export */   "Yb": () => (/* binding */ disableTeamIdentity),
/* harmony export */   "kF": () => (/* binding */ setLocalIdentity),
/* harmony export */   "lD": () => (/* binding */ enableTeamIdentity),
/* harmony export */   "lQ": () => (/* binding */ addStorageChangeListener),
/* harmony export */   "mK": () => (/* binding */ removeLocalIdentity),
/* harmony export */   "pB": () => (/* binding */ getLocalRecentIdentity),
/* harmony export */   "tK": () => (/* binding */ removeLocalRecentIdentity),
/* harmony export */   "u5": () => (/* binding */ getLocalIdentity)
/* harmony export */ });
/* unused harmony exports LOCAL_OUID_KEY, setLocalRecentIdentity */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

// 当前身份的缓存key
var LOCAL_USER_IDENTITY_KEY = "user_identity".concat(getSuffix());
// 最近登录身份的缓存key
var LOCAL_USER_IDENTITY_RECENT_KEY = "user_identity_recent".concat(getSuffix());
// origin_uid缓存key
var LOCAL_ORIGIN_UID_KEY = "origin_uid".concat(getSuffix());
// 当前身份下的uid
var LOCAL_OUID_KEY = "ouid".concat(getSuffix());
var isNode = "object" === "undefined";
// 同步历史身份缓存到cookie中
if (!isNode) {
    try {
        var oldVersionValue = window.localStorage.getItem(LOCAL_USER_IDENTITY_KEY);
        if (oldVersionValue) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, oldVersionValue, {
                domain: getRootDomain(),
                expires: 36500
            });
            window.localStorage.removeItem(LOCAL_USER_IDENTITY_KEY);
        }
    } catch (e) {
        ;
    }
}
var personalIdentity = {
    oid: 0,
    groupId: 0
};
var localInit = isNode ? personalIdentity : getIdentityFromCookie();
var local_oid = (localInit === null || localInit === void 0 ? void 0 : localInit.oid) || 0;
var local_groupId = (localInit === null || localInit === void 0 ? void 0 : localInit.groupId) || 0;
var changeHandle;
if (!isNode) {
    var workerCode = '\n    self.onmessage = function(event) {\n      setInterval(() => {\n        // 向主线程发送消息\n        postMessage("");\n      }, 1000);\n    };\n  ';
    var blob = new Blob([
        workerCode
    ], {
        type: "application/javascript"
    });
    // 创建一个新的 Worker
    var worker = new Worker(URL.createObjectURL(blob));
    // 接收 Worker 发来的消息
    worker.onmessage = function() {
        var curValue = getIdentityFromCookie();
        if (curValue.oid !== local_oid && local_groupId !== curValue.groupId) {
            // 发生变化
            changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(curValue.oid, curValue.groupId);
        }
    };
    // 发送消息给 Worker，启动定时器
    worker.postMessage("");
}
var isDisableTeam = false;
/**
 * 禁用团队功能
 */ function disableTeamIdentity() {
    isDisableTeam = true;
}
/**
 * 开启团队功能
 */ function enableTeamIdentity() {
    isDisableTeam = false;
}
/**
 * 更新内存的身份信息
 * @param oid
 * @param groupId
 */ function setMemoryIdentity(oid, groupId) {
    local_oid = oid;
    local_groupId = groupId;
}
function addStorageChangeListener(cb) {
    changeHandle = cb;
}
/**
 * 获取cookie最新的身份
 * @returns
 */ function getIdentityFromCookie() {
    return JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_KEY) || "".concat(JSON.stringify(personalIdentity)));
}
/**
 * 获取缓存中的身份
 * @returns
 */ function getLocalIdentity() {
    if (isDisableTeam) return personalIdentity;
    return {
        oid: local_oid,
        groupId: local_groupId
    };
}
/**
 * 获取缓存中的最近身份信息
 * @returns
 */ function getLocalRecentIdentity() {
    var _a, _b, _c, _d;
    if (isDisableTeam) return {
        oid: 0,
        groupId: 0,
        ouid: 0,
        originUid: 0
    };
    var localStr = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_RECENT_KEY);
    if (!localStr) {
        return null;
    }
    var list = [];
    try {
        list = JSON.parse(localStr);
    } catch (e) {}
    return {
        oid: (_a = list[0]) === null || _a === void 0 ? void 0 : _a.oid,
        groupId: (_b = list[0]) === null || _b === void 0 ? void 0 : _b.groupId,
        ouid: (_c = list[0]) === null || _c === void 0 ? void 0 : _c.ouid,
        originUid: (_d = list[0]) === null || _d === void 0 ? void 0 : _d.originUid
    };
}
/**
 * 移除缓存
 */ function removeLocalIdentity() {
    local_oid = 0;
    local_groupId = 0;
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 移除最近登录身份信息缓存
 */ function removeLocalRecentIdentity() {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_RECENT_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 写入身份缓存
 * @param oid
 * @param groupId
 * @param shouldUpateRecent 是否需要更新最近登录身份的数据
 */ function setLocalIdentity(oid, groupId, shouldUpateRecent) {
    if (shouldUpateRecent === void 0) {
        shouldUpateRecent = true;
    }
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, JSON.stringify({
        oid: oid,
        groupId: groupId
    }), {
        domain: getRootDomain(),
        expires: 36500
    });
    if (shouldUpateRecent) {
        setLocalRecentIdentity(oid, groupId);
    }
    if (oid !== local_oid && local_groupId !== groupId) {
        // 发生变化
        changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(oid, groupId);
    }
}
/**
 * 写入最近登录身份的缓存
 * @param oid
 * @param groupId
 */ function setLocalRecentIdentity(oid, groupId) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_RECENT_KEY, JSON.stringify([
        {
            oid: oid,
            groupId: groupId,
            ouid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_OUID_KEY) || 0),
            originUid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_ORIGIN_UID_KEY) || 0)
        }
    ]), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 写入origin_uid缓存
 * @param uid
 */ function setLocalOriginUid(uid) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_ORIGIN_UID_KEY, String(uid), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 获取请求头部
 * @returns
 */ function getRequestIdentityHeader() {
    var _a, _b;
    return {
        "Client-OID": ((_a = getLocalIdentity()) === null || _a === void 0 ? void 0 : _a.oid) || 0,
        "Client-OGroupID": ((_b = getLocalIdentity()) === null || _b === void 0 ? void 0 : _b.oid) || 0
    };
}
/**
 * 当前地址的环境: pre/beta/release
 */ function getSuffix() {
    if (false) {}
    if (window.location.origin.includes("//localhost")) {
        return "--local";
    } else if (window.location.origin.includes("//pre")) {
        return "--pre";
    } else if (window.location.origin.includes("//beta")) {
        return "--beta";
    } else {
        return "";
    }
}
/**
 * 获取根域名
 * @returns
 */ function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}


/***/ }),

/***/ 51811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports basicPrefix, getPrefix */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);


var basicPrefix = "mt-design-rc";
var getPrefix = function getPrefix(subPrefix) {
    return "".concat(basicPrefix, "-").concat(subPrefix);
};
var getClsWithPrefix = function getClsWithPrefix(subPrefix) {
    var prefix = getPrefix(subPrefix);
    var cls = function cls() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (args.length === 0) return prefix;
        return classnames__WEBPACK_IMPORTED_MODULE_0___default()(args.map(function(arg) {
            if (typeof arg === "string") {
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            } else if (Array.isArray(arg)) {
                return arg.map(function(a) {
                    return cls(a);
                }).join(" ");
            }
            return Object.entries(arg).filter(function(_ref) {
                var _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, 2), _ = _ref2[0], v = _ref2[1];
                return v;
            }).map(function(_ref3) {
                var _ref4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, 1), arg = _ref4[0];
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            });
        }));
    };
    return cls;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getClsWithPrefix);


/***/ }),

/***/ 40451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56369);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81549);
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73935);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51811);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3965);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);








var subPrefix = "CommonModal";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(subPrefix);
var CommonModal = function CommonModal(_ref) {
    var _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$wrapClassName = _ref.wrapClassName, wrapClassName = _ref$wrapClassName === void 0 ? "" : _ref$wrapClassName, wrapProps = _ref.wrapProps, metaNode = _ref.metaNode, children = _ref.children, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, _ref$maskClosable = _ref.maskClosable, maskClosable = _ref$maskClosable === void 0 ? false : _ref$maskClosable, _ref$destroyOnClose = _ref.destroyOnClose, destroyOnClose = _ref$destroyOnClose === void 0 ? false : _ref$destroyOnClose, onClose = _ref.onClose, _ref$lockScroll = _ref.lockScroll, lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (open && lockScroll) {
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }
    }, [
        open,
        lockScroll
    ]);
    if (!open && destroyOnClose) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, wrapProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$(), wrapClassName),
        style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            "--zindex": zIndex,
            display: open ? undefined : "none"
        }, wrapProps === null || wrapProps === void 0 ? void 0 : wrapProps.style)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: cls$("mask"),
        onClick: function onClick(e) {
            // 阻止蒙层点击透传到后面的dom
            e.stopPropagation();
            e.preventDefault();
            if (maskClosable) onClose === null || onClose === void 0 || onClose();
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$("inner"), className)
    }, children), metaNode), document.body);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonModal);


/***/ }),

/***/ 20134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export MESSAGE_LIST_CLASS_NAME */
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33641);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73009);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29372);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24996);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74107);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51811);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77477);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_5__);




var _excluded = [
    "key"
];








var subPrefix = "Message";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(subPrefix);
var MESSAGE_LIST_CLASS_NAME = cls$("list");
var defaultDuration = 3;
var MessageUI = function MessageUI(_ref) {
    var _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? defaultDuration : _ref$duration, icon = _ref.icon, content = _ref.content;
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (duration === 0) return;
        var timer = setTimeout(function() {
            setOpen(false);
        }, duration * 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        duration
    ]);
    var edgeCss = {
        padding: 0,
        height: 0,
        opacity: 0
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(rc_motion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        motionName: cls$("move"),
        visible: open,
        onAppearStart: function onAppearStart() {
            return edgeCss;
        },
        onEnterStart: function onEnterStart() {
            return edgeCss;
        },
        onLeaveActive: function onLeaveActive() {
            return edgeCss;
        }
    }, function(_ref2) {
        var style = _ref2.style, motionClassName = _ref2.className;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(cls$(), motionClassName),
            style: style
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("inner")
        }, !!icon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("icon")
        }, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("content")
        }, content)));
    });
};
var MessageListWrapper = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.forwardRef(function(_, ref) {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useState3, 2), messageList = _useState4[0], setMessageList = _useState4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            open: function open(_ref3) {
                var _ref3$key = _ref3.key, key = _ref3$key === void 0 ? "".concat(Date.now()) : _ref3$key, cfg = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref3, _excluded);
                setMessageList((0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)([].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(messageList), [
                    {
                        key: key,
                        cfg: cfg
                    }
                ]), "key"));
            }
        };
    }, [
        setMessageList
    ]);
    if (!messageList.length) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        className: MESSAGE_LIST_CLASS_NAME
    }, messageList.map(function(_ref4) {
        var key = _ref4.key, _ref4$cfg = _ref4.cfg, icon = _ref4$cfg.icon, content = _ref4$cfg.content, _ref4$cfg$duration = _ref4$cfg.duration, duration = _ref4$cfg$duration === void 0 ? defaultDuration : _ref4$cfg$duration;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageUI, {
            key: key,
            icon: icon,
            content: content,
            duration: duration
        });
    }));
});
var messageWrapperEl;
var commonMessage = function commonMessage(cfg) {
    if (!messageWrapperEl || !document.contains(messageWrapperEl)) {
        messageWrapperEl = document.createElement("div");
        document.body.appendChild(messageWrapperEl);
    }
    (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageListWrapper, {
        ref: function ref(_ref5) {
            return _ref5 === null || _ref5 === void 0 ? void 0 : _ref5.open(cfg);
        }
    }), messageWrapperEl);
};
var getSuccessLikeFn = function getSuccessLikeFn(_ref6) {
    var defaultIconName = _ref6.defaultIconName, defaultIconColor = _ref6.defaultIconColor;
    return function(config) {
        var defaultIcon = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            name: defaultIconName,
            fontSize: 20,
            color: defaultIconColor
        });
        commonMessage(typeof config === "string" ? {
            icon: defaultIcon,
            content: config
        } : (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            icon: defaultIcon
        }, config));
    };
};
var message = {
    config: commonMessage,
    success: getSuccessLikeFn({
        defaultIconName: "CheckCircleFillBold",
        defaultIconColor: "var(--content-system-info-icon-success, #4FC62B)"
    }),
    info: getSuccessLikeFn({
        defaultIconName: "InfoCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-regular, #8CC0FF)"
    }),
    error: getSuccessLikeFn({
        defaultIconName: "ExclamationMarkCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-warning, #F74640)"
    })
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (message);


/***/ }),

/***/ 97303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "ZR": () => (/* binding */ useConfig),
/* harmony export */   "iE": () => (/* binding */ getConfig),
/* harmony export */   "qK": () => (/* binding */ setConfigPartial),
/* harmony export */   "v6": () => (/* binding */ setConfig)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69222);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81549);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1798);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var ConfigUpdateEvent = "xdesign-widgets__config-update-event";
var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
var _configState = {
    theme: "light",
    env: ENV_ENUM.release,
    client_id: "",
    gid: "",
    device_id: "",
    channel: "",
    country_code: "",
    app_key: "",
    module_id: "",
    silent_token_key: "access_token",
    lang: "zh-Hans",
    isIntl: false,
    isTeam: false,
    isCutoutGlobal: false,
    appName: "x-design",
    colorGroupCommonConfig: {
        openVipModal: lodash__WEBPACK_IMPORTED_MODULE_0__.noop,
        ifNoOnToggleBizTabProp: lodash__WEBPACK_IMPORTED_MODULE_0__.noop
    },
    loginIdentitySwitchModalConfig: {
        /** 编辑器都需要加这个提示 */ showEditorSaveTip: false
    },
    meituAccountInstance: null,
    userInfo: {
        screen_name: "",
        id: 0
    },
    isWpsUser: false
};
var getConfig = function getConfig() {
    return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _configState);
};
var setConfig = function setConfig(key, value) {
    _configState[key] = value;
    if (key === "env" && value === ENV_ENUM.dev) {
        _configState["env"] = ENV_ENUM.pre;
    }
    pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().publish(ConfigUpdateEvent);
};
var setConfigPartial = function setConfigPartial(params) {
    for(var key in params){
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            // @ts-expect-error TS suppress
            setConfig(key, params[key]);
        }
    }
};
var useConfig = function useConfig() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_configState), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useState, 2), ctx = _useState2[0], setCtx = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var onSub = function onSub() {
            setCtx((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _configState));
        };
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().subscribe(ConfigUpdateEvent, onSub);
        return function() {
            pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().unsubscribe(onSub);
        };
    }, []);
    return ctx;
};
var ConfigProvider = function ConfigProvider(_ref) {
    var value = _ref.value, children = _ref.children;
    var isFirst = useRef(true);
    if (isFirst.current) {
        setConfigPartial(value);
        isFirst.current = false;
    }
    useEffect(function() {
        setConfigPartial(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ConfigProvider)));


/***/ }),

/***/ 128:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IK": () => (/* binding */ getLocaleStore),
  "bU": () => (/* binding */ useLocale),
  "Ee": () => (/* binding */ useLocaleStore)
});

// UNUSED EXPORTS: SUPPORT_LOCALES, initLocaleStore, localeTextMap

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/en.json
const en_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfaction","noWarn":"Don\'t show again","dissatisfied":"Dissatisfied","normal":"Neutral","satisfied":"Satisfied","placeholder":"Enter feedback (200 character limit)","submitBtn":"Submit"},"userInfo":{"notVipTip":"Zawa Pro subscription grants access to extensive copyrighted elements and features.","notLoginText":"You are not yet a member","businessText":"Online consultation","feedbackText":"Feedback","downloadText":"Download App","settingText":"Settings","loginText":"Log in","copyText":"Copy","svipExpires":"Zawa Pro expiration date: ${0}","renewalText":"Renew","openText":"Subscribe","tips":"Enjoy worry-free commercial use of copyrighted works during your membership period.","logoutText":"Log out","lightText":"Light","dartText":"Dark","teamExpires":"Team membership expires on: ${0}","teamNotVipTitle":"Subscribe to Team Membership","teamNotVipTip":"Enjoy exclusive membership benefits and team collaboration","teamExpiresDays":"Your team membership expired ${0} days ago","copySuccess":"Copied!","notVipTipTitle":"Become a member to access all design resources and tools","notVipTipSubscript":"Commercial rights covered","teamVersion":"Team","personalVersion":"Personal","vipExpiresDays":"Your subscription expired ${0} days ago","countAmount":"Cutout amount","meidouAmount":"Credits","owner":"Super Admin","admin":"Administrator","vipValidUntil":"Expires on: ${0}","teamNotVipTip2":"Experience SVIP benefits and exclusive features","enterpriseVersion":"Enterprise","freeTeamVersion":"Free","initialFreeDesc":"Become a member to access all design resources and tools","initialFreeTeamDesc":"Subscribe to share team resources and tools","languageSwitch":"Language","pro":"Pro Plan","plus":"Plus Plan","renewOn":"Renew on","tryProForFree":"Try Pro For Free","expiresOn":"Expires on","upgradeToPro":"Upgrade to Pro","credit":"Credit","manageSubscriptions":"Manage Subscriptions","termsAndPolicies":"Terms and Policies","benefitsUpgraded":"Benefits Upgraded","basic":"Basic","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Network error. Unable to connect to the server."},"upload":{"errorText":"Failed to upload","cancelText":"Cancel","uploadingText":"Uploading...","fileText":"File","picText":"Images","blockText":"Upload canceled","cancelUploadText":"Cancel upload","maxLengthTips":"You can upload up to 20 images at the same time","formatFailTips":"Upload of ${0} images failed. Currently, only images in ${1} formats are supported.","formatFailTips1":"Only supports images in ${0} format for now","formatFailTips2":"Upload of ${0} images failed. Currently, only images in JPG, JPEG and PNG formats are supported.","sizeFailTips":"Upload of ${0} images failed. Please ensure each image is under 20 MB and no larger than 8000×8000 pixels.","sizeFailTips1":"Please ensure each image is under 20 MB and no larger than 8000×8000 pixels.","widthHeightFailTips":"Only supports images no larger than 8000×8000 pixels","sizeFailTips2":"Only supports images up to ${0} MB"},"meidouInfo":{"emptyText":"Top up","buyText":"Purchase credits plan","openText":"Subscribe","rechargeText":"Top up","remainingText":"My credits","tips1":"Prioritize expiring credits for consumption.","tips2":"Your purchased credits will never expire","tips3":"Including ${0} permanently-valid paid credits.","tips4":"Credits will be automatically deducted with each generation.","detailText":"Details","whatIsMeidou":"What are credits?","giftTips":"40 credits added to your account!","giftTips1":"Expires at the end of today. Don’t forget to use them!","genText":"Generate","deductionTips":"${0} credits will be deducted for this generation. Do you want to continue?","genBtnText":"Generate","inadequateTips":"Insufficient credits. Please top up at least ${0} credits first.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Trial times ${0} /${1}","meidouCountModalTitle":"Remaining credits","meidouCountModalTips":"Expiring credits will be used first.","meidouCountModalTips1":"About Credits","meidouCountModalEmpty":"No credits. Purchase now!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Permanently valid","meidouCountModalExpired":"Expire in ${0} day(s)","creditTransactionDetails":"Credit Overview","deductionTipsIntl":"Need to consume ${0} credits","deductionTips2Intl":"${0} credits will be deducted for this generation. Do you want to continue?","autoDeductCredits":"Automatically deduct credits","generate":"Generate","close":"Close","creditsBalance":"Credits Balance","whatAreCredits":"What are credits?","usageDetail":"Usage details","getMoreCredits":"Get More Credits"},"floatHelp":{"modalTitle":"Meitu Assistant","businessTitle":"Online Consultation","communityText1":"Use WeChat or Wecom to scan the QR code to join","communityText2":"Join [Zawa User Group]","communityText3":"As an early beta user, your feedback is crucial. Share your thoughts with us.","feedbackTitle":"Feedback"},"designCreater":{"tab1":"Create","tab2":"Upload","uploadFail":"Failed to upload","uploadDragTips":"Click the \\"Upload\\" button or drag and drop here","uploadBtn":"Upload","uploadTips":"Tips: We recommend uploading JPG or PNG images within 20 MB.","unitPxText":"Pixels","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Smaller than the required size of ${0} * ${1}","sizeMaxText":"Exceeds the required size of ${0} * ${1}","createBtn":"Create","widthText":"W","widthText1":"W","heightText":"H","heightText1":"H","customText":"Custom","uploadDragTips_v2":"Upload or drop images here","uploadBtn_v2":"Upload","uploadTips_v2":"JPG and PNG images within 20 MB are supported","sizeMinText_v2":"Smaller than the required size of ${0} * ${1} ${2}","sizeMaxText_v2":"Exceeds the required size of ${0} * ${1} ${2}","canvasSize":"Canvas size","canvasBackground":"Background"},"space":{"onlyU":"Only you","anyone":"Anyone with the link","viewAble":"View","editAble":"Edit","viewAble2":"Visit","shareTitle":"Share your creation","copyLink":"Copy link","copied":"Copied"},"imageBatchUpload":{"buttonText":"Upload","uploadDirText":"Upload folder >","buttonDescription":"Paste or drag an image or URL here.","buttonDescription1":"Batch process up to ${0} images","batchButtonText":"Batch upload","upperUploadLimit":"You can upload up to ${0} images","errTipTitle":"Files exceed upload limits or are out of format","errTipSubTitle":"Please upload ${1} images within ${0} MB.","maxValueAndSize":"Only supports images with a maximum file size of ${0} MB","maxWidthAndHeight":"Only supports images no larger than ${0} pixels","errTipUpload":"Upload","errTipConfirm":"Got it","getFormatText":"Only supports images in ${0} format for now","heicResolveFailed":"The HEIC image failed to load. We recommend converting it to another image format before uploading.","imageUploadFailed":"Failed to upload","cvDescription":"Paste image","demoDesc":"Try one of these"},"logo":{"homeTip":"Click to navigate to the homepage","toolTip":"Drag Zawa\\\\\'s logo to the bookmarks bar for convenient access in the future."},"cutoutInfo":{"remainingText":"Remaining number of cutouts","openText":"Subscribe","rechargeText":"Top up","emptyText":"Top up"},"textFontFamily":{"empty":"No content","changeSearchWord":"Try using a different search term","fontFamily":"Font","searchFont":"Search font","buyVipEnjoyFontFamily":"Free for commercial use","currentFontFamily":"Fonts used in this template"},"infiniteScroll":{"loading":"Loading..."},"colorGroup":{"emptyText":"Empty","upgradeTeamEdition":"Upgrade","systemColor":"System color","teamColor":"Brand color card","cover":"Fill","repeat":"Tiling","fillingMode":"Display mode","recommendedTexture":"Recommended","uploadImage":"Upload","replaceImage":"Replace"},"downloadBtn":{"downloadBtnTxt":"Download","modalTitle":"Download","editMoreTitle":"Advanced Editing","downloadNow":"Download","addTxt":"Add Text","addMaterial":"Add Element","eraser":"Eraser","cutout":"Background Remover","quality":"Image Enhancer","editMore":"Photo Editor","customSize":"Custom","customSizeInputTips":"Enter size limit","customSizeError":"Please fill in file size","processing":"Processing...","aicp":"AI Background Generator","upscale":"Image Upscaler"},"interceptModal":{"title":"Allow pop-up windows for Zawa.","desc":"Authorize Zawa to open multiple windows in your browser.","stepTitle":"Step ${0}","btnText":"Got it","firstStep":"Click the blocking alert that appears in the top right of your browser","secondStep":"Click \\"Always allow pop-ups and redirects\\".","thirdStep":"Click \\"Done\\" to start using Zawa.","xDesignTitle":"Allow pop-up windows for Zawa.","xDesignDesc":"Authorize Zawa to open multiple windows in your browser.","xDesignThirdStep":"Click \\"Done\\" to start using Zawa.","safariFirstStep":"Click the menu bar on the left > Safari, then select designkit.com.","safariSecondStep":"In the pop-up window, select “Pop-ups” > “Allow” to access Zawa features smoothly."},"workListPanel":{"history":"Creations","upload":"Upload","failed":"Failed","pending":"Loading...","cancelText":"Cancel","confirmText":"Confirm","deleteText":"After deletion, the generated results will be lost. Are you sure you want to delete?","generating":"Generating"},"feedbackVoting":{"defaultText":"Rate the result","thanks":"Thanks for your feedback.","modalTitle":"Feedback","modalDesc":"Your feedback will help us improve our service.","modalIpt":"Please describe which part you are not satisfied with","iptMaxLength":"Content exceeds the limit. Please keep it under ${0} characters or contact customer service.","cancel":"Close","submit":"Submit","other":"Other"},"newDesignCreater":{"title":"Create blank canvas","allCategory":"All","openImage":"Upload","openFile":"File","pleaseInputSize":"Enter the size","categorySection":{"lookMore":"More","canvasSize":{"create":"Create"}},"create":"Create","commonSize":"Common size"},"psdModal":{"uploadTemplate":"Upload","uploadFile":"Upload","uploadSuccess":"Uploaded","uploadFailed":"Failed to upload","uploadPSD":"Upload PSD"},"userPolicy":{"btnTomorrow":"Not now","btnVip":"Update now","btnMy":"Get More Credits","buyVip":"Daily trial limit reached. Go VIP for unlimited access!","buyMy":"You’ve reached your trial limit. Get more credits to keep going!","buyVipOrBackTomorrow":"Daily trial limit reached. Go VIP for unlimited access!","backTomorrow":"Daily trial limit reached. Go VIP for unlimited access!","trialLimitReached":"Trial Limit Reached"},"batchTaskList":{"loading":"Loading","fail":"Generation failed","batchEdit":"Batch edit","upload":"Upload More"},"navVipEntrance":{"getFreePro":"Get Free Pro","unlockPro":"Unlock Pro","renewNow":"Renew Now","upgradeToPro":"Upgrade to Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Describe your brand concept, industry, and style preference."},"brandCard":{"nameLimitTip":"Enter a name (up to 10 characters)"},"delBrandSureModal":{"okText":"Confirm","cancelText":"Cancel","title":"Delete this brand kit?","message":"Applied designs will not be affected."},"brandList":{"createBrandText":"Add","emptyText":"Empty"},"logoCard":{"coverCornerText1":"Cover","coverCornerText2":"Main logo","delSureModal":{"okText":"Confirm","cancelText":"Cancel","title":"Delete this logo?"},"nameLimitTip":"Enter a name (up to ${0} characters)","replaceText":"Replace"},"colorList":{"countLimitTip":"Add up to ${0} color(s) to each color palette"},"colorCard":{"colorCountLimitTip":"Add up to ${0} color(s) to each color palette","nameLimitTip":"Enter a name (up to ${0} characters)","nameInputPlaceholder":"Enter a name (up to ${0} characters)","colorEmptyText":"Empty"},"page":{"brandStandards":"Brand Kit","createStandard":"Add","createBrand":"Brand Kit"},"editBrand":{"sections":{"logo":"Logos","colorCard":"Color systems","textStyle":"Text styles","template":"Templates","reference":"Reference","primaryColor":"Main color","secondaryColor":"Secondary color"},"brandBackground":"Brand description","nameLimitTip":"Enter a name (up to 10 characters)","saveLastStyle":"Save changes to continue","saveLastColorCard":"Save changes to continue","saveLastElement":"Save changes to continue","addColorCard":"Add new","addStyle":"Add new","addPrimaryColor":"Add main color","addSecondaryColor":"Add secondary color","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expand","foldBtnText":"Collapse","title":"Style Guide"},"addPrimaryLogo":"Add main logo"},"textCard":{"nameLimitTip":"Enter a name (up to ${0} characters)","selectFont":"Select a font","selectFontSize":"Select font size","fontSizePlaceholder":"Size","save":"Save","fontSize":"号","bold":"Bold","standard":"Standard","italic":"Italic","defaultCategoryName":"General"},"templateCard":{"delSureModal":{"title":"Delete this item?","okText":"Confirm","cancelText":"Cancel"},"nameLimitTip":"Enter a name (up to ${0} characters)","defaultName":"Templates"},"selectBrandElementModal":{"brandAssets":"Brand Kit","localUpload":"Upload from Device","brandLogo":"Logos","brandTemplate":"Templates","reference":"Reference","uploadImage":"Upload","uploadDragTips":"Upload or drop images here","uploadTips":"Upload up to ${1} JPG or PNG images (max ${0} MB each)"},"tooltip":{"message":"The Brand Poster feature is now live!","desc":"Upload your brand posters and let AI Agent take a peek. It’ll learn your vibe and create future visuals that match your brand’s style!"}},"userReviews":{"hello":"Hi ${0},","wordsOfThanks":"Thanks for being part of Zawa!","desc":"Your feedback means the world to us. If you’re enjoying Zawa, we’d love it if you could leave us a review on Trustpilot — it really helps us grow and improve.","leave":"Leave a Review"},"aih5DownloadBtn":{"signInText":"Sign in","fullQualityText":"Full Quality","previewText":"Preview","freeText":"Free","downloadText":"Download","fullQualityLimitReached":"Full-quality limit reached. Please come back tomorrow.","todayLimitReached":"Today\'s limit reached. Come back tomorrow or upgrade now."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/es.json
const es_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfacción","noWarn":"No mostrar de nuevo","dissatisfied":"Insatisfecho","normal":"Neutral","satisfied":"Satisfecho","placeholder":"Ingresa tus comentarios (límite 200 caracteres)","submitBtn":"Enviar"},"userInfo":{"notVipTip":"La suscripción a Zawa Pro te da acceso a numerosos elementos y funciones con derechos de autor.","notLoginText":"Aún no eres miembro","businessText":"Consulta en línea","feedbackText":"Comentarios","downloadText":"Descarga la app","settingText":"Configuración","loginText":"Iniciar sesión","copyText":"Copiar","svipExpires":"Fecha de expiración de Zawa Pro: ${0}","renewalText":"Renovar","openText":"Suscríbete","tips":"Usa obras con derechos de autor de manera comercial sin preocupaciones durante el periodo de tu membresía.","logoutText":"Cerrar sesión","lightText":"Claro","dartText":"Oscuro","teamExpires":"La membresía equipo expira el: ${0}","teamNotVipTitle":"Suscríbete a la membresía de equipo","teamNotVipTip":"Disfruta beneficios exclusivos de tu membresía y colaboración en equipo","teamExpiresDays":"Tu membresía de equipo expiró hace ${0} días","copySuccess":"¡Copiado!","notVipTipTitle":"Conviértete en miembro para acceder a todos los recursos y herramientas de diseño","notVipTipSubscript":"Derechos comerciales cubiertos","teamVersion":"Equipo","personalVersion":"Personal","vipExpiresDays":"Tu suscripción expiró hace ${0} días","countAmount":"Cantidad de recorte","meidouAmount":"Créditos","owner":"Súper Administrador","admin":"Administrador","vipValidUntil":"Expira el: ${0}","teamNotVipTip2":"Disfruta beneficios SVIP y funciones exclusivas","enterpriseVersion":"Grandes empresas","freeTeamVersion":"Gratis","initialFreeDesc":"Conviértete en miembro para acceder a todos los recursos y herramientas de diseño","initialFreeTeamDesc":"Suscríbete para compartir recursos y herramientas con tu equipo","languageSwitch":"Idioma","pro":"Pro","plus":"Plus Plan","renewOn":"Renovación el","tryProForFree":"Prueba Pro gratis","expiresOn":"Expira el","upgradeToPro":"Actualizar a Pro","credit":"Crédito","manageSubscriptions":"Administrar suscripciones","termsAndPolicies":"Términos y políticas","benefitsUpgraded":"Beneficios mejorados","basic":"Básico","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Error de red. No se pudo conectar con el servidor."},"upload":{"errorText":"Error al subir","cancelText":"Cancelar","uploadingText":"Subiendo…","fileText":"Archivo","picText":"Imágenes","blockText":"Carga cancelada","cancelUploadText":"Cancelar carga","maxLengthTips":"Puedes subir hasta 20 imágenes a la vez","formatFailTips":"Error al subir ${0} imágenes. Por el momento, solo se admiten imágenes en formato${1}.","formatFailTips1":"Solo se admiten imágenes en formato ${0} por ahora","formatFailTips2":"Error al subir ${0} imágenes. Por el momento, solo se admiten imágenes en formato JPG, JPEG y PNG.","sizeFailTips":"Error al subir ${0} imágenes. Asegúrate de que cada imagen sea menor a 20 MB y no mayor a 8,000×8,000 pixeles.","sizeFailTips1":"Asegúrate de que cada imagen sea menor a 20 MB y no mayor a 8,000×8,000 pixeles.","widthHeightFailTips":"Solo se admiten imágenes de hasta 8000 px (alto × ancho)","sizeFailTips2":"Solo se admiten imágenes de hasta ${0} MB"},"meidouInfo":{"emptyText":"Recargar","buyText":"Compra un plan de créditos","openText":"Suscríbete","rechargeText":"Recargar","remainingText":"Mis créditos","tips1":"Prioriza los créditos próximos a expirar para su consumo.","tips2":"Tus créditos comprados nunca expiran","tips3":"Incluye ${0} créditos pagados con validez permanente.","tips4":"Los créditos se descontarán automáticamente con cada generación.","detailText":"Detalles","whatIsMeidou":"¿Qué son los créditos?","giftTips":"Se agregaron 40 créditos a tu cuenta.","giftTips1":"Expira al final del día. ¡No olvides usarlos!","genText":"Generar","deductionTips":"Se descontarán ${0} créditos para esta generación. ¿Deseas continuar?","genBtnText":"Generar","inadequateTips":"Créditos insuficientes. Primero recarga al menos ${0} créditos.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Tiempos de prueba ${0}/${1}","meidouCountModalTitle":"Créditos restantes","meidouCountModalTips":"Los créditos próximos a expirar se usarán primero.","meidouCountModalTips1":"Acerca de los créditos","meidouCountModalEmpty":"No tienes créditos. Compra ahora.","meidouCountModalBtn":"Aceptar","meidouCountModalPermanent":"Validez permanente","meidouCountModalExpired":"Expira en ${0} día(s)","creditTransactionDetails":"Resumen de los créditos","deductionTipsIntl":"Necesita consumir ${0} créditos","deductionTips2Intl":"Se descontarán ${0} créditos para esta generación. ¿Deseas continuar?","autoDeductCredits":"Descontar créditos automáticamente","generate":"Generar","close":"Cerrar","creditsBalance":"Saldo de créditos","whatAreCredits":"¿Qué son los créditos?","usageDetail":"Detalles de uso","getMoreCredits":"Obtén más créditos"},"floatHelp":{"modalTitle":"Asistente de Meitu","businessTitle":"Consulta en línea","communityText1":"Usa WeChat o WeCom para escanear el código QR y unirte","communityText2":"Únete al [grupo de usuarios de Zawa]","communityText3":"Como usuario beta, tus comentarios son cruciales. Comparte tus opiniones con nosotros.","feedbackTitle":"Comentarios"},"designCreater":{"tab1":"Crear","tab2":"Subir","uploadFail":"Error al subir","uploadDragTips":"Haz clic en el botón “Subir” o arrastra y suelta aquí","uploadBtn":"Subir","uploadTips":"Sugerencias: te recomendamos subir imágenes JPG o PNG de menos de 20 MB.","unitPxText":"Pixeles","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Más pequeño que el tamaño requerido de ${0} * ${1}","sizeMaxText":"Supera el tamaño requerido de ${0} * ${1}","createBtn":"Crear","widthText":"Ancho","widthText1":"Ancho","heightText":"Alto","heightText1":"Alto","customText":"Personalizado","uploadDragTips_v2":"Sube tu imagen o suéltala aquí","uploadBtn_v2":"Subir","uploadTips_v2":"Se admiten imágenes JPG y PNG de menos de 20 MB","sizeMinText_v2":"Más pequeño que el tamaño requerido de ${0} * ${1} ${2}","sizeMaxText_v2":"Supera el tamaño requerido de ${0} * ${1} ${2}","canvasSize":"Tamaño del lienzo","canvasBackground":"Fondo"},"space":{"onlyU":"Solo tú","anyone":"Cualquier persona que tenga el enlace","viewAble":"Ver","editAble":"Editar","viewAble2":"Visitar","shareTitle":"Comparte tu creación","copyLink":"Copiar enlace","copied":"Copiado"},"imageBatchUpload":{"buttonText":"Subir","uploadDirText":"Subir carpeta >","buttonDescription":"Pega o arrastra una imagen o URL aquí.","buttonDescription1":"Procesa por lotes hasta ${0} imágenes","batchButtonText":"Carga por lotes","upperUploadLimit":"Puedes subir hasta ${0} imágenes","errTipTitle":"Los archivos superan los límites de carga o no tienen el formato correcto","errTipSubTitle":"Sube ${1} imágenes de menos de ${0} MB.","maxValueAndSize":"Solo se admiten imágenes con un tamaño de archivo máximo de ${0} MB","maxWidthAndHeight":"Solo se admiten imágenes de hasta ${0} px de ambos lados","errTipUpload":"Subir","errTipConfirm":"Entendido","getFormatText":"Solo se admiten imágenes en formato ${0} por ahora","heicResolveFailed":"Error al cargar la imagen HEIC. Te recomendamos convertirla a otro formato de imagen antes de subirla.","imageUploadFailed":"Error al subir","cvDescription":"Pegar imagen","demoDesc":"Prueba uno de estos"},"logo":{"homeTip":"Haz clic para navegar a la página de inicio","toolTip":"Arrastra el logotipo de Zawa a la barra de favoritos para tener un acceso conveniente en el futuro."},"cutoutInfo":{"remainingText":"Cantidad restante de recortes","openText":"Suscríbete","rechargeText":"Recargar","emptyText":"Recargar"},"textFontFamily":{"empty":"Sin contenido","changeSearchWord":"Prueba un término de búsqueda diferente","fontFamily":"Fuente","searchFont":"Buscar fuente","buyVipEnjoyFontFamily":"Gratis para uso comercial","currentFontFamily":"Fuentes usadas en esta plantilla"},"infiniteScroll":{"loading":"Cargando…"},"colorGroup":{"emptyText":"Vacío","upgradeTeamEdition":"Actualizar","systemColor":"Color del sistema","teamColor":"Tarjeta de colores de marca","cover":"Rellenar","repeat":"Mosaico","fillingMode":"Modo de visualización","recommendedTexture":"Recomendado","uploadImage":"Subir","replaceImage":"Reemplazar"},"downloadBtn":{"downloadBtnTxt":"Descargar","modalTitle":"Descargar","editMoreTitle":"Edición avanzada","downloadNow":"Descargar","addTxt":"Agregar texto","addMaterial":"Agregar elemento","eraser":"Borrador","cutout":"Eliminador de fondo","quality":"Mejorador de imagen","editMore":"Editor de fotos","customSize":"Personalizado","customSizeInputTips":"Ingresa el límite de tamaño","customSizeError":"Llena el tamaño del archivo","processing":"Procesando…","aicp":"Generador de fondos con IA","upscale":"Ampliador de imagen"},"interceptModal":{"title":"Permite ventanas emergentes para Zawa.","desc":"Autoriza que Zawa abra múltiples ventanas en tu navegador.","stepTitle":"Paso ${0}","btnText":"Entendido","firstStep":"Haz clic en la alerta de bloqueo que aparece en la esquina superior derecha de tu navegador","secondStep":"Haz clic en “Siempre permitir ventanas emergentes y redireccionamientos”.","thirdStep":"Haz clic en “Listo” para comenzar a usar Zawa.","xDesignTitle":"Permite ventanas emergentes para Zawa.","xDesignDesc":"Autoriza que Zawa abra múltiples ventanas en tu navegador.","xDesignThirdStep":"Haz clic en “Listo” para comenzar a usar Zawa.","safariFirstStep":"Haz clic en la barra de menú de la izquierda > Safari, luego selecciona designkit.com.","safariSecondStep":"En la ventana emergente, selecciona Ventanas emergentes > Permitir para acceder fácilmente a las funciones de Zawa."},"workListPanel":{"history":"Creaciones","upload":"Subir","failed":"Error","pending":"Cargando…","cancelText":"Cancelar","confirmText":"Confirmar","deleteText":"Después de eliminarlos, los resultados generados se perderán. ¿Desear borrarlos?","generating":"Generando"},"feedbackVoting":{"defaultText":"Califica el resultado","thanks":"Gracias por tus comentarios.","modalTitle":"Comentarios","modalDesc":"Tus comentarios nos ayudarán a mejorar nuestro servicio.","modalIpt":"Describe qué parte no te pareció satisfactoria","iptMaxLength":"El contenido excede el límite. Sigue el límite de ${0} caracteres o comunícate con el servicio de atención al cliente.","cancel":"Cerrar","submit":"Enviar","other":"Otro"},"newDesignCreater":{"title":"Crear lienzo en blanco","allCategory":"Todo","openImage":"Subir","openFile":"Archivo","pleaseInputSize":"Ingresa el tamaño","categorySection":{"lookMore":"Más","canvasSize":{"create":"Crear"}},"create":"Crear","commonSize":"Tamaño común"},"psdModal":{"uploadTemplate":"Subir","uploadFile":"Subir","uploadSuccess":"Subido","uploadFailed":"Error al subir","uploadPSD":"Subir PSD"},"userPolicy":{"btnTomorrow":"Ahora no","btnVip":"Actualizar ahora","btnMy":"Obtén más créditos","buyVip":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","buyMy":"Llegaste a tu límite de prueba. Obtén más créditos para continuar.","buyVipOrBackTomorrow":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","backTomorrow":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","trialLimitReached":"Alcanzaste el límite de prueba"},"batchTaskList":{"loading":"Cargando","fail":"Error al generar","batchEdit":"Edición por lotes","upload":"Subir más"},"navVipEntrance":{"getFreePro":"Obtén Pro gratis","unlockPro":"Desbloquear Pro","renewNow":"Renovar ahora","upgradeToPro":"Actualizar a Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Describe el concepto de tu marca, industria y preferencia de estilo."},"brandCard":{"nameLimitTip":"Ingresa un nombre (hasta 10 caracteres)"},"delBrandSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"¿Deseas borrar este kit de marca?","message":"Los diseños aplicados no se verán afectados."},"brandList":{"createBrandText":"Agregar","emptyText":"Vacío"},"logoCard":{"coverCornerText1":"Portada","coverCornerText2":"Logotipo principal","delSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"¿Deseas eliminar este logotipo?"},"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","replaceText":"Reemplazar"},"colorList":{"countLimitTip":"Agrega hasta ${0} color(es) a cada paleta de color"},"colorCard":{"colorCountLimitTip":"Agrega hasta ${0} color(es) a cada paleta de color","nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","nameInputPlaceholder":"Ingresa un nombre (hasta ${0} caracteres)","colorEmptyText":"Vacío"},"page":{"brandStandards":"Kit de marca","createStandard":"Agregar","createBrand":"Kit de marca"},"editBrand":{"sections":{"logo":"Logotipos","colorCard":"Paleta de colores","textStyle":"Estilos de texto","template":"Plantillas","reference":"Reference","primaryColor":"Color principal","secondaryColor":"Color secundario"},"brandBackground":"Descripción de marca","nameLimitTip":"Ingresa un nombre (hasta 10 caracteres)","saveLastStyle":"Guarda los cambios para continuar","saveLastColorCard":"Guarda los cambios para continuar","saveLastElement":"Guarda los cambios para continuar","addColorCard":"Agregar nuevo","addStyle":"Agregar nuevo","addPrimaryColor":"Agregar color principal","addSecondaryColor":"Agregar color secundario","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expandir","foldBtnText":"Contraer","title":"Guía de estilo"},"addPrimaryLogo":"Agregar logotipo principal"},"textCard":{"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","selectFont":"Selecciona una fuente","selectFontSize":"Seleccionar tamaño de fuente","fontSizePlaceholder":"Tamaño","save":"Guardar","fontSize":"号","bold":"Negrita","standard":"Estándar","italic":"Cursiva","defaultCategoryName":"General"},"templateCard":{"delSureModal":{"title":"¿Deseas borrar esta plantilla?","okText":"Confirmar","cancelText":"Cancelar"},"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","defaultName":"Plantillas"},"selectBrandElementModal":{"brandAssets":"Kit de marca","localUpload":"Subir desde dispositivo","brandLogo":"Logotipos","brandTemplate":"Plantillas","reference":"Reference","uploadImage":"Subir","uploadDragTips":"Sube tu imagen o suéltala aquí","uploadTips":"Sube hasta ${1} imágenes JPG o PNG (máx. ${0} MB cada una)"},"tooltip":{"message":"¡La función Póster de marca ya está disponible!","desc":"Sube tus pósters de marca y permite que el Agente de IA eche un vistazo. Aprenderá tus gustos y en el futuro creará recursos visuales que coincidan con el estilo de tu marca."}},"userReviews":{"hello":"Hola ${0}","wordsOfThanks":"¡Gracias por ser parte de Zawa!","desc":"Tus comentarios son muy importantes para nosotros. Si estás disfrutando Zawa, nos encantaría que dejaras una reseña en Trustpilot. Nos ayuda mucho a crecer y mejorar.","leave":"Deja una reseña"},"aih5DownloadBtn":{"signInText":"Iniciar sesión","fullQualityText":"Calidad total","previewText":"Vista previa","freeText":"Gratis","downloadText":"Descargar","fullQualityLimitReached":"Se alcanzó el límite de calidad total. Vuelve mañana.","todayLimitReached":"Se alcanzó el límite de hoy. Vuelve mañana o actualiza ahora."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/id.json
const id_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Kepuasan","noWarn":"Jangan tampilkan lagi","dissatisfied":"Tidak puas","normal":"Netral","satisfied":"Puas","placeholder":"Berikan masukan (maksimal 200 karakter)","submitBtn":"Kirim"},"userInfo":{"notVipTip":"Langganan Zawa Pro memberikan akses ke berbagai elemen dan fitur yang memiliki hak cipta.","notLoginText":"Anda belum jadi anggota","businessText":"Konsultasi online","feedbackText":"Masukan","downloadText":"Unduh Aplikasi","settingText":"Pengaturan","loginText":"Login","copyText":"Salin","svipExpires":"Tanggal kedaluwarsa Zawa Pro: ${0}","renewalText":"Perpanjang","openText":"Berlangganan","tips":"Nikmati penggunaan komersial karya berhak cipta sepuasnya selama periode keanggotaan.","logoutText":"Logout","lightText":"Terang","dartText":"Gelap","teamExpires":"Keanggotaan tim berakhir pada: ${0}","teamNotVipTitle":"Berlangganan Keanggotaan Tim","teamNotVipTip":"Dapatkan manfaat keanggotaan eksklusif dan kolaborasi tim","teamExpiresDays":"Keanggotaan tim Anda berakhir ${0} hari lalu","copySuccess":"Disalin!","notVipTipTitle":"Daftar anggota untuk mengakses semua sumber daya dan alat desain","notVipTipSubscript":"Termasuk hak komersial","teamVersion":"Tim","personalVersion":"Personal","vipExpiresDays":"Langganan Anda berakhir ${0} hari lalu","countAmount":"Jumlah pemotongan","meidouAmount":"Kredit","owner":"Admin Super","admin":"Administrator","vipValidUntil":"Berakhir pada: ${0}","teamNotVipTip2":"Nikmati manfaat SVIP dan fitur eksklusif","enterpriseVersion":"Perusahaan","freeTeamVersion":"Gratis","initialFreeDesc":"Daftar anggota untuk mengakses semua sumber daya dan alat desain","initialFreeTeamDesc":"Berlangganan untuk berbagi sumber daya dan alat tim","languageSwitch":"Bahasa","pro":"Pro","plus":"Plus Plan","renewOn":"Perpanjang pada","tryProForFree":"Coba Pro Gratis","expiresOn":"Berakhir pada","upgradeToPro":"Upgrade ke Pro","credit":"Kredit","manageSubscriptions":"Kelola Langganan","termsAndPolicies":"Ketentuan dan Kebijakan","benefitsUpgraded":"Manfaat Diupgrade","basic":"Dasar","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Kesalahan jaringan. Tidak dapat terhubung ke server."},"upload":{"errorText":"Gagal mengunggah","cancelText":"Batal","uploadingText":"Mengunggah...","fileText":"File","picText":"Gambar","blockText":"Unggahan dibatalkan","cancelUploadText":"Batalkan unggahan","maxLengthTips":"Anda dapat mengunggah maksimal 20 foto sekaligus","formatFailTips":"Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar ${1}.","formatFailTips1":"Saat ini hanya mendukung format gambar ${0}","formatFailTips2":"Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar JPG, JPEG, dan PNG.","sizeFailTips":"Unggahan ${0} gambar gagal. Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000×8000 piksel.","sizeFailTips1":"Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000×8000 piksel.","widthHeightFailTips":"Hanya mendukung gambar maks 8000px (P&L)","sizeFailTips2":"Hanya mendukung gambar maks ${0} MB"},"meidouInfo":{"emptyText":"Isi ulang","buyText":"Beli paket kredit","openText":"Berlangganan","rechargeText":"Isi ulang","remainingText":"Kredit saya","tips1":"Prioritaskan penggunaan kredit yang akan segera kedaluwarsa.","tips2":"Kredit yang dibeli tidak akan pernah kedaluwarsa","tips3":"Termasuk ${0} kredit berbayar yang berlaku permanen.","tips4":"Kredit akan otomatis berkurang setiap kali memproses.","detailText":"Detail","whatIsMeidou":"Apa itu kredit?","giftTips":"40 kredit ditambahkan ke akun Anda!","giftTips1":"Kedaluwarsa di penghujung hari ini. Jangan lupa untuk menggunakannya!","genText":"Proses","deductionTips":"${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?","genBtnText":"Proses","inadequateTips":"Kredit tidak cukup. Harap isi ulang dahulu minimal ${0} kredit.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Waktu uji coba ${0} /${1}","meidouCountModalTitle":"Kredit tersisa","meidouCountModalTips":"Kredit yang akan kedaluwarsa digunakan terlebih dahulu.","meidouCountModalTips1":"Tentang Kredit","meidouCountModalEmpty":"Tidak ada kredit. Beli sekarang!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Valid permanen","meidouCountModalExpired":"Berakhir dalam ${0} hari","creditTransactionDetails":"Gambaran Umum Kredit","deductionTipsIntl":"Perlu menggunakan ${0} kredit","deductionTips2Intl":"${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?","autoDeductCredits":"Otomatis potong kredit","generate":"Proses","close":"Tutup","creditsBalance":"Saldo Kredit","whatAreCredits":"Apa itu kredit?","usageDetail":"Detail penggunaan","getMoreCredits":"Dapatkan Lebih Banyak Kredit"},"floatHelp":{"modalTitle":"Asisten Meitu","businessTitle":"Konsultasi online","communityText1":"Gunakan WeChat atau Wecom untuk memindai kode QR dan bergabung","communityText2":"Bergabung [Grup Pengguna Zawa]","communityText3":"Sebagai pengguna versi beta awal, masukan Anda sangat penting. Sampaikan pendapat Anda kepada kami.","feedbackTitle":"Masukan"},"designCreater":{"tab1":"Buat","tab2":"Unggah","uploadFail":"Gagal mengunggah","uploadDragTips":"Klik tombol \\"Unggah\\" atau seret dan lepaskan di sini","uploadBtn":"Unggah","uploadTips":"Tips: Sebaiknya unggah gambar JPG atau PNG dengan ukuran maks 20 MB.","unitPxText":"Piksel","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Lebih kecil dari ukuran minimal ${0} * ${1}","sizeMaxText":"Melampaui ukuran maksimal ${0} * ${1}","createBtn":"Buat","widthText":"P","widthText1":"P","heightText":"L","heightText1":"L","customText":"Kustom","uploadDragTips_v2":"Unggah atau seret foto di sini","uploadBtn_v2":"Unggah","uploadTips_v2":"Mendukung gambar JPG dan PNG berukuran maks 20 MB","sizeMinText_v2":"Lebih kecil dari ukuran minimal ${0} * ${1} ${2}","sizeMaxText_v2":"Melampaui ukuran maksimal ${0} * ${1} ${2}","canvasSize":"Ukuran kanvas","canvasBackground":"Background"},"space":{"onlyU":"Hanya Anda","anyone":"Semua yang punya tautan","viewAble":"Lihat","editAble":"Edit","viewAble2":"Kunjungi","shareTitle":"Bagikan kreasi Anda","copyLink":"Salin tautan","copied":"Disalin"},"imageBatchUpload":{"buttonText":"Unggah","uploadDirText":"Folder unggahan >","buttonDescription":"Rekatkan atau seret gambar atau URL di sini.","buttonDescription1":"Proses massal hingga ${0} foto","batchButtonText":"Unggah massal","upperUploadLimit":"Anda dapat mengunggah maksimal ${0} foto","errTipTitle":"Unggahan melebihi batas ukuran atau format file salah","errTipSubTitle":"Unggah ${1} gambar maks ${0} MB.","maxValueAndSize":"Hanya mendukung gambar berukuran maks ${0} MB","maxWidthAndHeight":"Hanya mendukung gambar berukuran maks ${0} px PxL","errTipUpload":"Unggah","errTipConfirm":"Mengerti","getFormatText":"Saat ini hanya mendukung format gambar ${0}","heicResolveFailed":"Gagal memuat gambar HEIC. Sebaiknya konversi ke format lain sebelum mengunggah.","imageUploadFailed":"Gagal mengunggah","cvDescription":"Rekatkan gambar","demoDesc":"Cobalah salah satu"},"logo":{"homeTip":"Klik untuk kembali ke beranda","toolTip":"Seret logo Zawa ke bilah bookmark untuk memudahkan akses."},"cutoutInfo":{"remainingText":"Jumlah pemotongan tersisa","openText":"Berlangganan","rechargeText":"Isi ulang","emptyText":"Isi ulang"},"textFontFamily":{"empty":"Tidak ada konten","changeSearchWord":"Coba istilah pencarian lain","fontFamily":"Fon","searchFont":"Cari fon","buyVipEnjoyFontFamily":"Gratis untuk penggunaan komersial","currentFontFamily":"Fon yang digunakan di templat ini"},"infiniteScroll":{"loading":"Memuat..."},"colorGroup":{"emptyText":"Kosong","upgradeTeamEdition":"Upgrade","systemColor":"Warna sistem","teamColor":"Kartu warna merek","cover":"Isi","repeat":"Ubin","fillingMode":"Mode tampilan","recommendedTexture":"Disarankan","uploadImage":"Unggah","replaceImage":"Ganti"},"downloadBtn":{"downloadBtnTxt":"Unduh","modalTitle":"Unduh","editMoreTitle":"Editing Lanjutan","downloadNow":"Unduh","addTxt":"Tambah Teks","addMaterial":"Tambah Elemen","eraser":"Penghapus","cutout":"Penghapus Background","quality":"Penyempurna Foto","editMore":"Editor Foto","customSize":"Kustom","customSizeInputTips":"Masukkan batasan ukuran","customSizeError":"Masukkan ukuran file","processing":"Memproses...","aicp":"AI Background","upscale":"Upscale"},"interceptModal":{"title":"Izinkan jendela pop-up untuk Zawa.","desc":"Izinkan Zawa membuka beberapa jendela di browser.","stepTitle":"Langkah ${0}","btnText":"Mengerti","firstStep":"Klik peringatan pemblokiran yang muncul di kanan atas browser","secondStep":"Klik \\"Always allow pop-ups and redirects\\" (Selalu izinkan pop-up dan pengalihan).","thirdStep":"Klik \\"Done\\" (Selesai) untuk mulai menggunakan Zawa.","xDesignTitle":"Izinkan jendela pop-up untuk Zawa.","xDesignDesc":"Izinkan Zawa membuka beberapa jendela di browser.","xDesignThirdStep":"Klik \\"Done\\" (Selesai) untuk mulai menggunakan Zawa.","safariFirstStep":"Klik bilah menu di kiri > Safari, lalu pilih designkit.com.","safariSecondStep":"Di jendela pop-up, pilih “Pop-up” > “Allow” (Izinkan) untuk mengakses fitur Zawa."},"workListPanel":{"history":"Kreasi","upload":"Unggah","failed":"Gagal","pending":"Memuat...","cancelText":"Batal","confirmText":"Konfirmasi","deleteText":"Setelah dihapus, hasil yang dibuat akan hilang. Anda yakin ingin menghapus?","generating":"Memproses"},"feedbackVoting":{"defaultText":"Nilai hasil","thanks":"Terima kasih atas masukan Anda.","modalTitle":"Masukan","modalDesc":"Masukan Anda akan membantu meningkatkan layanan kami.","modalIpt":"Jelaskan pada bagian mana Anda tidak puas","iptMaxLength":"Konten melampaui batas. Dibatasi maksimal ${0} karakter atau hubungi layanan pelanggan.","cancel":"Tutup","submit":"Kirim","other":"Lainnya"},"newDesignCreater":{"title":"Buat kanvas kosong","allCategory":"Semua","openImage":"Unggah","openFile":"File","pleaseInputSize":"Masukkan ukuran","categorySection":{"lookMore":"Lainnya","canvasSize":{"create":"Buat"}},"create":"Buat","commonSize":"Ukuran umum"},"psdModal":{"uploadTemplate":"Unggah","uploadFile":"Unggah","uploadSuccess":"Diunggah","uploadFailed":"Gagal mengunggah","uploadPSD":"Unggah PSD"},"userPolicy":{"btnTomorrow":"Lain kali","btnVip":"Perbarui Sekarang","btnMy":"Dapatkan Lebih Banyak Kredit","buyVip":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","buyMy":"Uji coba sudah maksimal. Dapatkan lebih banyak kredit untuk melanjutkan!","buyVipOrBackTomorrow":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","backTomorrow":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","trialLimitReached":"Uji Coba Sudah Maksimal"},"batchTaskList":{"loading":"Memuat","fail":"Pemrosesan gagal","batchEdit":"Teks massal","upload":"Unggah Lainnya"},"navVipEntrance":{"getFreePro":"Dapatkan Pro Gratis","unlockPro":"Dapatkan Pro","renewNow":"Perpanjang Sekarang","upgradeToPro":"Upgrade ke Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Jelaskan konsep merek, industri, dan preferensi gayamu."},"brandCard":{"nameLimitTip":"Masukkan nama (maksimal 10 karakter)"},"delBrandSureModal":{"okText":"Konfirmasi","cancelText":"Batal","title":"Hapus kit merek ini?","message":"Desain yang diterapkan tidak terpengaruh."},"brandList":{"createBrandText":"Tambah","emptyText":"Kosong"},"logoCard":{"coverCornerText1":"Kover","coverCornerText2":"Logo utama","delSureModal":{"okText":"Konfirmasi","cancelText":"Batal","title":"Hapus logo ini?"},"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","replaceText":"Ganti"},"colorList":{"countLimitTip":"Tambahkan maksimal ${0} warna ke setiap palet warna"},"colorCard":{"colorCountLimitTip":"Tambahkan maksimal ${0} warna ke setiap palet warna","nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","nameInputPlaceholder":"Masukkan nama (maksimal ${0} karakter)","colorEmptyText":"Kosong"},"page":{"brandStandards":"Kit Merek","createStandard":"Tambah","createBrand":"Kit Merek"},"editBrand":{"sections":{"logo":"Logo","colorCard":"Sistem warna","textStyle":"Gaya teks","template":"Templat","reference":"Reference","primaryColor":"Warna primer","secondaryColor":"Warna sekunder"},"brandBackground":"Deskripsi merek","nameLimitTip":"Masukkan nama (maksimal 10 karakter)","saveLastStyle":"Simpan perubahan untuk melanjutkan","saveLastColorCard":"Simpan perubahan untuk melanjutkan","saveLastElement":"Simpan perubahan untuk melanjutkan","addColorCard":"Tambahkan baru","addStyle":"Tambahkan baru","addPrimaryColor":"Tambahkan warna primer","addSecondaryColor":"Tambahkan warna sekunder","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Perluas","foldBtnText":"Susutkan","title":"Panduan Gaya"},"addPrimaryLogo":"Tambahkan logo utama"},"textCard":{"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","selectFont":"Pilih fon","selectFontSize":"Pilih ukuran fon","fontSizePlaceholder":"Ukuran","save":"Simpan","fontSize":"号","bold":"Tebal","standard":"Standar","italic":"Miring","defaultCategoryName":"Umum"},"templateCard":{"delSureModal":{"title":"Hapus templat ini?","okText":"Konfirmasi","cancelText":"Batal"},"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","defaultName":"Templat"},"selectBrandElementModal":{"brandAssets":"Kit Merek","localUpload":"Unggah dari Perangkat","brandLogo":"Logo","brandTemplate":"Templat","reference":"Reference","uploadImage":"Unggah","uploadDragTips":"Unggah atau seret foto di sini","uploadTips":"Unggah maksimal ${1} gambar JPG atau PNG (masing-masing maks ${0} MB)"},"tooltip":{"message":"Fitur Poster Merek kini sudah tersedia!","desc":"Unggah poster merek sebagai referensi Agen AI. AI akan mempelajari gaya dan membuat visual yang sesuai dengan gaya merekmu!"}},"userReviews":{"hello":"Hai ${0},","wordsOfThanks":"Terima kasih telah menggunakan Zawa!","desc":"Masukan Anda sangat berarti bagi kami. Jika Anda suka Zawa, kami akan sangat berterima kasih jika Anda bisa memberikan ulasan di Trustpilot untuk membantu kami memperbaiki dan meningkatkan layanan.","leave":"Tulis Ulasan"},"aih5DownloadBtn":{"signInText":"Masuk","fullQualityText":"Kualitas Penuh","previewText":"Pratinjau","freeText":"Bebas","downloadText":"Unduh","fullQualityLimitReached":"Kualitas penuh sudah maksimal. Silakan kembali besok.","todayLimitReached":"Batasan harian tercapai. Kembali lagi besok atau upgrade sekarang."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/pt.json
const pt_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfação","noWarn":"Não mostrar novamente","dissatisfied":"Insatisfação","normal":"Neutral","satisfied":"Satisfeito/a","placeholder":"Insira o feedback (limite de 200 caracteres)","submitBtn":"Enviar"},"userInfo":{"notVipTip":"A assinatura do Zawa Pro concede acesso a diversos elementos e recursos protegidos por direitos autorais.","notLoginText":"Você ainda não é assinante","businessText":"Consulta online","feedbackText":"Feedback","downloadText":"Baixar aplicativo","settingText":"Configurações","loginText":"Entrar","copyText":"Copiar","svipExpires":"Data de expiração do Zawa Pro: ${0}","renewalText":"Renovar","openText":"Assinar","tips":"Aproveite o uso comercial sem preocupações de obras protegidas por direitos autorais durante o período de sua assinatura.","logoutText":"Sair","lightText":"Claro","dartText":"Escuro","teamExpires":"A assinatura de equipe expira em: ${0}","teamNotVipTitle":"Inscreva-se na Assinatura de equipe","teamNotVipTip":"Aproveite os benefícios exclusivos da associação e a colaboração em equipe","teamExpiresDays":"Sua assinatura de equipe expirou há ${0} dias","copySuccess":"Copiado!","notVipTipTitle":"Torne-se membro para acessar todos os recursos e ferramentas de design","notVipTipSubscript":"Direitos comerciais cobertos","teamVersion":"Equipe","personalVersion":"Pessoal","vipExpiresDays":"Sua assinatura expirou há ${0} dias.","countAmount":"Valor de recorte ","meidouAmount":"Créditos","owner":"Superadministrador ","admin":"Administrador","vipValidUntil":"Expira em: ${0}","teamNotVipTip2":"Experimente os benefícios SVIP e recursos exclusivos","enterpriseVersion":"Empresa","freeTeamVersion":"Gratuito","initialFreeDesc":"Torne-se membro para acessar todos os recursos e ferramentas de design","initialFreeTeamDesc":"Assine para compartilhar recursos e ferramentas de equipe","languageSwitch":"Idioma","pro":"Pro","plus":"Plus Plan","renewOn":"Renovar agora","tryProForFree":"Experimente a versão Pro gratuitamente","expiresOn":"Expira em","upgradeToPro":"Atualizar para Pro","credit":"Crédito","manageSubscriptions":"Gerenciar Assinaturas","termsAndPolicies":"Termos e Políticas","benefitsUpgraded":"Benefícios atualizados","basic":"Básico","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Erro de rede. Não foi possível conectar-se ao servidor."},"upload":{"errorText":"Falha ao carregar","cancelText":"Cancelar","uploadingText":"Carregando...","fileText":"Arquivo","picText":"Imagens","blockText":"Carregamento cancelado","cancelUploadText":"Cancelar carregamento","maxLengthTips":"Você pode carregar até 20 imagens ao mesmo tempo.","formatFailTips":"Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos ${1} são suportadas.","formatFailTips1":"Por enquanto, só suporta imagens no formato ${0}","formatFailTips2":"Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos JPG, JPEG e PNG são suportadas.","sizeFailTips":"Falha ao carregar ${0}imagens. Certifique-se de que cada imagem tenha menos de 20 MB e não exceda 8000×8000 pixels.","sizeFailTips1":"Certifique-se de que cada imagem tenha menos de 20 MB e não exceda 8000×8000 pixels.","widthHeightFailTips":"Suporta apenas imagens com 8000 px (altura e largura)","sizeFailTips2":"Suporta apenas imagens até ${0} MB"},"meidouInfo":{"emptyText":"Recarregar","buyText":"Comprar plano de créditos","openText":"Assinar","rechargeText":"Recarregar","remainingText":"Meus créditos","tips1":"Priorize o consumo dos créditos que estão prestes a expirar.","tips2":"Os créditos adquiridos nunca expiram","tips3":"Incluindo ${0} créditos pagos com validade permanente.","tips4":"Os créditos serão deduzidos automaticamente a cada geração.","detailText":"Detalhes","whatIsMeidou":"O que são os créditos?","giftTips":"40 créditos adicionados à sua conta!","giftTips1":"Expira no final do dia de hoje. Não se esqueça de usá-los!","genText":"Gerar","deductionTips":"${0} créditos serão deduzidos para esta geração. Deseja continuar?","genBtnText":"Gerar","inadequateTips":"Créditos insuficientes. Por favor, recarregue pelo menos ${0} créditos primeiro.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Períodos de avaliação ${0} /${1}","meidouCountModalTitle":"Créditos restantes","meidouCountModalTips":"Os créditos que estiverem expirando serão usados primeiro.","meidouCountModalTips1":"Sobre os créditos","meidouCountModalEmpty":"Sem créditos. Compre agora mesmo!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Validade permanente","meidouCountModalExpired":"Expira em ${0} dia(s)","creditTransactionDetails":"Visão geral do crédito","deductionTipsIntl":"Precisa consumir ${0} créditos","deductionTips2Intl":"${0} créditos serão deduzidos por esta geração. Deseja continuar?","autoDeductCredits":"Deduzir créditos automaticamente","generate":"Gerar","close":"Fechar","creditsBalance":"Balanço de créditos","whatAreCredits":"O que são os créditos?","usageDetail":"Detalhes de uso","getMoreCredits":"Obter mais créditos"},"floatHelp":{"modalTitle":"Assistente Meitu","businessTitle":"Consulta online","communityText1":"Use WeChat ou Wecom para escanear o código QR e ingressar","communityText2":"Junte-se ao [Grupo de Usuários Zawa]","communityText3":"Como um dos primeiros usuários beta, sua opinião é fundamental. Compartilhe suas ideias conosco.","feedbackTitle":"Feedback"},"designCreater":{"tab1":"Criar","tab2":"Carregar","uploadFail":"Falha ao carregar","uploadDragTips":"Clique no botão “Carregar” ou arraste e solte aqui","uploadBtn":"Carregar","uploadTips":"Dicas: Recomendamos enviar imagens JPG ou PNG com tamanho inferior a 20 MB.","unitPxText":"Pixels","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Menor que o tamanho exigido de ${0} * ${1}","sizeMaxText":"Excede o tamanho exigido de ${0} * ${1}","createBtn":"Criar","widthText":"b","widthText1":"b","heightText":"h","heightText1":"h","customText":"Personalizar","uploadDragTips_v2":"Carregue ou solte imagens aqui","uploadBtn_v2":"Carregar","uploadTips_v2":"Imagens JPG e PNG com tamanho inferior a 20 MB são suportadas","sizeMinText_v2":"Menor que o tamanho exigido de ${0} * ${1} ${2}","sizeMaxText_v2":"Excede o tamanho exigido de ${0} * ${1} ${2}","canvasSize":"Tamanho da tela","canvasBackground":"Fundo"},"space":{"onlyU":"Somente você","anyone":"Qualquer pessoa com o link","viewAble":"Visualizar","editAble":"Editar","viewAble2":"Visitar","shareTitle":"Compartilhar sua criação  ","copyLink":"Copiar link","copied":"Copiado"},"imageBatchUpload":{"buttonText":"Carregar","uploadDirText":"Carregar pasta >","buttonDescription":"Cole ou arraste uma imagem ou URL aqui.","buttonDescription1":"Processe em lote até ${0} imagens","batchButtonText":"Carregar em lote","upperUploadLimit":"Você pode carregar até ${0} imagens","errTipTitle":"Os arquivos excedem os limites de carregamento ou estão fora do formato","errTipSubTitle":"Por favor, carregue ${1} imagens com tamanho máximo de ${0} MB.","maxValueAndSize":"Suporta apenas imagens com tamanho máximo de arquivo de ${0} MB","maxWidthAndHeight":"Suporta apenas imagens com até ${0} px em ambos os lados","errTipUpload":"Carregar","errTipConfirm":"Entendi","getFormatText":"Por enquanto, só suporta imagens no formato ${0}","heicResolveFailed":"Falha ao carregar a imagem HEIC. Recomendamos convertê-la para outro formato antes de fazer o upload.","imageUploadFailed":"Falha ao carregar","cvDescription":"Colar imagem","demoDesc":"Experimente uma destas opções"},"logo":{"homeTip":"Clique para ir para a página inicial","toolTip":"Arraste o logotipo do Zawa para a barra de favoritos a fim de facilitar o acesso no futuro."},"cutoutInfo":{"remainingText":"Número restante de recortes","openText":"Assinar","rechargeText":"Recarregar","emptyText":"Recarregar"},"textFontFamily":{"empty":"Nenhum conteúdo","changeSearchWord":"Tente usar um termo de busca diferente","fontFamily":"Fonte","searchFont":"Procurar fonte","buyVipEnjoyFontFamily":"Gratuito para uso comercial","currentFontFamily":"Fontes utilizadas neste modelo"},"infiniteScroll":{"loading":"Carregando..."},"colorGroup":{"emptyText":"Vazio","upgradeTeamEdition":"Atualizar","systemColor":"Cor do sistema","teamColor":"Cartão de cores da marca","cover":"Preencher","repeat":"Aplicação de azulejos","fillingMode":"Modo de exibição","recommendedTexture":"Recomendado","uploadImage":"Carregar","replaceImage":"Substituir"},"downloadBtn":{"downloadBtnTxt":"Baixar","modalTitle":"Baixar","editMoreTitle":"Edição avançada","downloadNow":"Baixar","addTxt":"Adicionar texto","addMaterial":"Adicionar elemento","eraser":"Borracha","cutout":"Removedor de fundo","quality":"Aprimorador de imagens","editMore":"Editor de fotos","customSize":"Personalizado","customSizeInputTips":"Insira o limite de tamanho","customSizeError":"Insira o tamanho do arquivo","processing":"Processando...","aicp":"Gerador de fundo com IA","upscale":"Aumentador de resolução de imagem"},"interceptModal":{"title":"Permitir janelas pop-up para o Zawa.","desc":"Autorize o Zawa a abrir várias janelas no seu navegador.","stepTitle":"Passo ${0}","btnText":"Entendi","firstStep":"Clique no alerta de bloqueio que aparece no canto superior direito do seu navegador","secondStep":"Clique em “Sempre permitir pop-ups e redirecionamentos”.","thirdStep":"Clique em “Concluído” para começar a usar o Zawa.","xDesignTitle":"Permitir janelas pop-up para o Zawa.","xDesignDesc":"Autorize o Zawa a abrir várias janelas no seu navegador.","xDesignThirdStep":"Clique em “Concluído” para começar a usar o Zawa.","safariFirstStep":"Clique na barra de menus à esquerda > Safari e selecione designkit.com.","safariSecondStep":"Na janela pop-up, selecione “Pop-ups” > “Permitir” para acessar os recursos do Zawa sem problemas."},"workListPanel":{"history":"Criações","upload":"Carregar","failed":"Falhou","pending":"Carregando...","cancelText":"Cancelar","confirmText":"Confirmar","deleteText":"Após a exclusão, os resultados gerados serão perdidos. Tem certeza de que deseja excluir?","generating":"Gerando"},"feedbackVoting":{"defaultText":"Avalie o resultado","thanks":"Agradecemos pelo seu feedback.","modalTitle":"Feedback","modalDesc":"Seus comentários nos ajudarão a melhorar nosso serviço.","modalIpt":"Descreva qual parte você não está satisfeito.","iptMaxLength":"O conteúdo excede o limite. Mantenha-o abaixo de ${0} caracteres ou entre em contato com o atendimento ao cliente.","cancel":"Fechar","submit":"Enviar","other":"Outros"},"newDesignCreater":{"title":"Criar tela em branco","allCategory":"Tudo","openImage":"Carregar","openFile":"Arquivo","pleaseInputSize":"Insira o tamanho","categorySection":{"lookMore":"Mais","canvasSize":{"create":"Criar"}},"create":"Criar","commonSize":"Tamanho padrão"},"psdModal":{"uploadTemplate":"Carregar","uploadFile":"Carregar","uploadSuccess":"Carregado","uploadFailed":"Falha ao carregar","uploadPSD":"Carregar PSD"},"userPolicy":{"btnTomorrow":"Agora não","btnVip":"Atualizar agora","btnMy":"Obter mais créditos","buyVip":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","buyMy":"Você atingiu o limite da sua versão de teste. Adquira mais créditos para continuar!","buyVipOrBackTomorrow":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","backTomorrow":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","trialLimitReached":"Limite de avaliação atingido"},"batchTaskList":{"loading":"Carregando","fail":"Falha na geração","batchEdit":"Editar lote","upload":"Carregar mais"},"navVipEntrance":{"getFreePro":"Obtenha o Pro gratuitamente","unlockPro":"Desbloquear Pro","renewNow":"Renovar Agora","upgradeToPro":"Atualizar para Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Descreva o conceito da sua marca, o setor e suas preferências de estilo."},"brandCard":{"nameLimitTip":"Insira um nome (até 10 caracteres)"},"delBrandSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"Apagar este kit de marca?","message":"Os projetos aplicados não serão afetados."},"brandList":{"createBrandText":"Adicionar","emptyText":"Vazio"},"logoCard":{"coverCornerText1":"Capa","coverCornerText2":"Logotipo principal","delSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"Excluir este logotipo?"},"nameLimitTip":"Insira um nome (até ${0} caracteres)","replaceText":"Substituir"},"colorList":{"countLimitTip":"Adicione até ${0} cor(es) a cada paleta de cores"},"colorCard":{"colorCountLimitTip":"Adicione até ${0} cor(es) a cada paleta de cores","nameLimitTip":"Insira um nome (até ${0} caracteres)","nameInputPlaceholder":"Insira um nome (até ${0} caracteres)","colorEmptyText":"Vazio"},"page":{"brandStandards":"Kit de marca","createStandard":"Adicionar","createBrand":"Kit de marca"},"editBrand":{"sections":{"logo":"Logotipos","colorCard":"Sistemas de cores","textStyle":"Estilos de texto","template":"Modelos","reference":"Reference","primaryColor":"Cor principal","secondaryColor":"Cor secundária"},"brandBackground":"Descrição da marca","nameLimitTip":"Insira um nome (até 10 caracteres)","saveLastStyle":"Salve as alterações para continuar","saveLastColorCard":"Salve as alterações para continuar","saveLastElement":"Salve as alterações para continuar","addColorCard":"Adicionar novo","addStyle":"Adicionar novo","addPrimaryColor":"Adicionar cor principal","addSecondaryColor":"Adicionar cor secundária","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expandir","foldBtnText":"Recolher","title":"Guia de estilo"},"addPrimaryLogo":"Adicionar logotipo principal"},"textCard":{"nameLimitTip":"Insira um nome (até ${0} caracteres)","selectFont":"Selecione uma fonte","selectFontSize":"Selecione o tamanho da fonte","fontSizePlaceholder":"Tamanho","save":"Salvar","fontSize":"号","bold":"Negrito","standard":"Padrão","italic":"Itálico","defaultCategoryName":"Geral"},"templateCard":{"delSureModal":{"title":"Excluir este modelo?","okText":"Confirmar","cancelText":"Cancelar"},"nameLimitTip":"Insira um nome (até ${0} caracteres)","defaultName":"Modelos"},"selectBrandElementModal":{"brandAssets":"Kit de marca","localUpload":"Carregar a partir do dispositivo","brandLogo":"Logotipos","brandTemplate":"Modelos","reference":"Reference","uploadImage":"Carregar","uploadDragTips":"Carregue ou solte a imagem aqui","uploadTips":"Carregue até ${1} imagens JPG ou PNG (máximo de ${0} MB cada)"},"tooltip":{"message":"O recurso Cartaz da Marca já está disponível!","desc":"Carregue os cartazes da sua marca e deixe o Agente de IA dar uma olhada. Ele aprenderá o seu estilo e criará visuais futuros que combinam com a sua marca!"}},"userReviews":{"hello":"Olá ${0},","wordsOfThanks":"Agradecemos por fazer parte do Zawa!","desc":"A sua opinião é muito importante para nós. Se você está gostando do Zawa, adoraríamos que deixasse uma avaliação no Trustpilot — isso nos ajuda muito a crescer e melhorar.","leave":"Deixe uma avaliação"},"aih5DownloadBtn":{"signInText":"Fazer login","fullQualityText":"Qualidade total","previewText":"Pré-visualizar","freeText":"Gratuito","downloadText":"Baixar","fullQualityLimitReached":"Limite de qualidade total atingido. Volte amanhã.","todayLimitReached":"Limite diário atingido. Volte amanhã ou faça um upgrade agora."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/zh-Hans.json
const zh_Hans_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"效果满意度","noWarn":"不再提醒","dissatisfied":"不满意","normal":"一般","satisfied":"满意","placeholder":"请输入您的建议(200字内)","submitBtn":"提交"},"userInfo":{"notVipTip":"开通会员SVIP享海量版权素材和功能权益","notLoginText":"您还未开通会员","businessText":"在线咨询","feedbackText":"意见反馈","downloadText":"下载客户端","settingText":"设置","loginText":"立即登录","copyText":"复制","svipExpires":"SVIP到期: ${0}","renewalText":"立即续费","openText":"立即开通","tips":"会员期间享作品商用版权无忧","logoutText":"退出登录","lightText":"浅色","dartText":"深色","teamExpires":"团队会员到期: ${0}","teamNotVipTitle":"开通团队版会员","teamNotVipTip":"畅享会员权益与团队协作","teamExpiresDays":"团队会员已过期${0}天","copySuccess":"复制成功","notVipTipTitle":"开通会员畅享全站设计资源和工具","notVipTipSubscript":"商用版权无忧","teamVersion":"团队版","personalVersion":"个人版","vipExpiresDays":"会员已过期${0}天","countAmount":"张数","meidouAmount":"美豆","owner":"超级管理员","admin":"管理员","vipValidUntil":"有效期至: ${0}","teamNotVipTip2":"畅享SVIP权益与团队专属功能","enterpriseVersion":"企业版","freeTeamVersion":"免费版","initialFreeDesc":"开通会员畅享全站设计资源和工具","initialFreeTeamDesc":"开通会员共享团队资源和协作工具","languageSwitch":"语言","pro":"Pro Plan","plus":"Plus Plan","renewOn":"续费","tryProForFree":"免费体验pro版本","expiresOn":"到期","upgradeToPro":"升级到pro版本","credit":"积分","manageSubscriptions":"管理订阅","termsAndPolicies":"条款与政策","benefitsUpgraded":"权益已升级","basic":"Basic","startFreeTrial":"开始免费试用","upgradeNow":"立即升级"},"utils":{"requestErrorText":"您的网络发生异常，无法连接服务器"},"upload":{"errorText":"图片上传失败","cancelText":"取消","uploadingText":"上传中","fileText":"文件","picText":"图片","blockText":"上传过程中取消了上传","cancelUploadText":"取消上传","maxLengthTips":"最多允许同时上传20张图片","formatFailTips":"${0}张图片上传失败，暂时只支持${1}格式的图片","formatFailTips1":"暂时只支持${0}格式的图片","formatFailTips2":"${0}张图片上传失败，暂时只支持JPG/JPEG/PNG格式的图片","sizeFailTips":"${0}张图片上传失败，仅支持20M，宽高均为8000px以内的图片","sizeFailTips1":"仅支持20M，宽高均为8000px以内的图片","widthHeightFailTips":"仅支持宽高均为8000px以内的图片","sizeFailTips2":"仅支持${0}M以内的图片"},"meidouInfo":{"emptyText":"充值","buyText":"购买美豆套餐","openText":"开通会员送美豆","rechargeText":"立即充值","remainingText":"我的美豆","tips1":"优先消耗临期的美豆","tips2":"付费美豆永久有效","tips3":"含${0}个付费美豆，永久有效","tips4":"每次生成后自动扣除美豆","detailText":"美豆消耗明细","whatIsMeidou":"什么是美豆","giftTips":"Hi! 今日登录奖励40美豆已到账~","giftTips1":"当天有效，尽快使用吧！","genText":"生成","deductionTips":"生成将扣除${0}美豆，是否生成？","genBtnText":"去生成","inadequateTips":"您的美豆数不足，请先至少充值${0}个美豆","inadequateTipsForNoVip":"您的美豆数不足，可开通会员送美豆","inadequateTipsForVip":"您的美豆数不足，请充值","tryTimes":"试用次数${0}/${1}","meidouCountModalTitle":"剩余美豆","meidouCountModalTips":"优先消耗临期美豆","meidouCountModalTips1":"美豆介绍 &gt;","meidouCountModalEmpty":"没有美豆哦～请前往购买吧","meidouCountModalBtn":"好的","meidouCountModalPermanent":"永久有效","meidouCountModalExpired":"${0}天过期","creditTransactionDetails":"积分交易详情","deductionTipsIntl":"需要消耗${0}积分","deductionTips2Intl":"本次生成需要消耗${0}积分，您是否还要继续？","autoDeductCredits":"自动扣除积分","generate":"生成","close":"关闭","creditsBalance":"积分余额","whatAreCredits":"什么是积分","usageDetail":"使用详情","getMoreCredits":"获取更多积分"},"floatHelp":{"modalTitle":"美图小助手","businessTitle":"在线咨询","communityText1":"使用微信或企业微信扫码加入","communityText2":"加入【美图设计室AI用户群】","communityText3":"作为首批内测用户，你的使用体验和反馈对我们非常重要，欢迎与我们交流你的想法或需求。","feedbackTitle":"意见反馈"},"designCreater":{"tab1":"创建设计","tab2":"打开图片","uploadFail":"上传失败","uploadDragTips":"点击“上传文件”按钮或拖放到这里","uploadBtn":"上传文件","uploadTips":"Tips:建议上传 200M以内 jpg、png 图片","unitPxText":"像素","unitMmText":"毫米","unitCmText":"厘米","sizeMinText":"低于画布尺寸${0} * ${1}","sizeMaxText":"超出画布尺寸${0} * ${1}","createBtn":"创建","widthText":"宽度","widthText1":"宽","heightText":"高度","heightText1":"高","customText":"自定义尺寸","uploadDragTips_v2":"点击/拖拽图片至此处","uploadBtn_v2":"上传图片","uploadTips_v2":"支持上传 20M以内 jpg、png 图片","sizeMinText_v2":"低于画布尺寸限制：${0} * ${1} ${2}","sizeMaxText_v2":"超出画布尺寸限制：${0} * ${1} ${2}","canvasSize":"画布尺寸","canvasBackground":"画布背景"},"space":{"onlyU":"仅你自己获得链接","anyone":"任何获得链接的人","viewAble":"可查看","editAble":"可编辑","viewAble2":"可访问","shareTitle":"分享你的作品","copyLink":"复制链接","copied":"已复制"},"imageBatchUpload":{"buttonText":"上传图片","uploadDirText":"上传文件夹 >","buttonDescription":"粘贴图片、网址，或拖拽图片至此。","buttonDescription1":"支持批量处理${0}张图片。","batchButtonText":"批量上传","upperUploadLimit":"批量模式最多支持${0}张图片","errTipTitle":"以下文件超过上传限制或不符合格式","errTipSubTitle":"请上传${0}M以内的${1}格式图片","maxValueAndSize":"仅支持${0}M以内的图片","maxWidthAndHeight":"仅支持宽高均为${0}px以内的图片","errTipUpload":"上传图片","errTipConfirm":"我知道了","getFormatText":"暂时只支持${0}格式的图片","heicResolveFailed":"HEIC图片解析失败，建议您转换为其他图片格式上传","imageUploadFailed":"图片上传失败","cvDescription":"粘贴图片","demoDesc":"试试这些"},"logo":{"homeTip":"点击可以前往首页","toolTip":"拖动Logo到书签栏，收藏美图设计室，打开更便捷～"},"cutoutInfo":{"remainingText":"剩余抠图张数","openText":"立即开通","rechargeText":"充值张数","emptyText":"充值"},"textFontFamily":{"empty":"暂无内容","changeSearchWord":"换个搜索词再试试","fontFamily":"字体","searchFont":"搜索字体","buyVipEnjoyFontFamily":"开通会员，可免费商用该字体","currentFontFamily":"当前模版使用的字体"},"infiniteScroll":{"loading":"玩命加载中..."},"colorGroup":{"emptyText":"空","upgradeTeamEdition":"升级团队版","systemColor":"系统颜色","teamColor":"品牌色卡","cover":"充满图框","repeat":"平铺","fillingMode":"填充方式","recommendedTexture":"推荐图案","uploadImage":"上传图片","replaceImage":"替换图片"},"downloadBtn":{"downloadBtnTxt":"下载","modalTitle":"下载","editMoreTitle":"去更多功能中使用","downloadNow":"立即下载","addTxt":"添加文字","addMaterial":"添加素材","eraser":"消除笔","cutout":"智能抠图","quality":"变清晰","editMore":"图片编辑","customSize":"自定义大小","customSizeInputTips":"输入限定大小","customSizeError":"请填写文件大小","processing":"处理中…","aicp":"AI换背景","upscale":"无损放大"},"interceptModal":{"title":"允许显示美图设计室弹出窗口","desc":"你需要授权美图设计室在浏览器打开多个窗口。","stepTitle":"第${0}步","btnText":"我知道啦","firstStep":"点击浏览器右侧顶部弹出的阻止程序图标。","secondStep":"点击始终允许显示弹出式窗口和进行重定向。","thirdStep":"点击完成按钮，即可正常使用美图设计室的功能啦～","xDesignTitle":"允许显示美图设计室弹出窗口","xDesignDesc":"你需要授权美图设计室在浏览器打开多个窗口。","xDesignThirdStep":"点击完成按钮，即可正常使用美图设计室的功能啦～","safariFirstStep":"点击左侧菜单栏-Safari浏览器, 选择designkit.com设置","safariSecondStep":"在弹窗中选择【弹出式窗口】，点击【允许】即可正常使用美图设计室的功能啦~"},"workListPanel":{"history":"历史记录","upload":"上传","failed":"失败","pending":"生成中","cancelText":"取消","confirmText":"确定","deleteText":"删除后，此次生成结果将会丢失，确定删除吗？","generating":"处理中"},"feedbackVoting":{"defaultText":"给这个结果评分","thanks":"感谢您的反馈。","modalTitle":"反馈详情","modalDesc":"您的反馈将会帮助我们进一步优化美图设计室的AI功能","modalIpt":"请详细描述您对结果不满意的原因","iptMaxLength":"内容超出长度限制，输入字数最多为${0}。如需更多帮助，请联系客服。","cancel":"关闭","submit":"提交","other":"其他"},"newDesignCreater":{"title":"创建设计","allCategory":"全部","openImage":"打开图片","openFile":"打开文件","pleaseInputSize":"请输入尺寸","categorySection":{"lookMore":"查看更多","canvasSize":{"create":"创建"}},"create":"创建","commonSize":"常用尺寸"},"psdModal":{"uploadTemplate":"上传模板","uploadFile":"上传文件","uploadSuccess":"上传成功","uploadFailed":"上传失败","uploadPSD":"上传PSD"},"userPolicy":{"btnTomorrow":"明日再来","btnVip":"立即开通","btnMy":"立即获取","buyVip":"今日试用次数已达上限，开通会员不受限。","buyMy":"试用次数已达上限，充值美豆获得更多使用机会。","buyVipOrBackTomorrow":"今日试用次数已达上限，开通会员不受限。","backTomorrow":"今日试用次数已达上限，开通会员不受限。","trialLimitReached":"试用已达上限"},"batchTaskList":{"loading":"加载中","fail":"生成失败","batchEdit":"批量编辑","upload":"上传"},"navVipEntrance":{"getFreePro":"免费体验Pro版本","unlockPro":"解锁Pro版本","renewNow":"立即续费","upgradeToPro":"升级到Pro版本","upgradeForFree":"免费升级"},"brandSDK":{"bgInput":{"placeholder":"请简短描述你的品牌理念、服务行业、偏好风格"},"brandCard":{"nameLimitTip":"请输入10字内的名称"},"delBrandSureModal":{"okText":"确定","cancelText":"取消","title":"确认删除这个品牌资产吗？","message":"已应用的作图记录不会受到影响"},"brandList":{"createBrandText":"创建品牌规范","emptyText":"空"},"logoCard":{"coverCornerText1":"封面","coverCornerText2":"主Logo","delSureModal":{"okText":"确定","cancelText":"取消","title":"确定要删除该logo吗？"},"nameLimitTip":"请输入${0}字以内的名称","replaceText":"替换"},"colorList":{"countLimitTip":"每套色卡仅支持添加${0}个色块"},"colorCard":{"colorCountLimitTip":"每套色卡仅支持添加${0}个色块","nameLimitTip":"请输入${0}字以内的名称","nameInputPlaceholder":"请输入${0}字以内的名称","colorEmptyText":"空"},"page":{"brandStandards":"品牌规范","createStandard":"创建规范","createBrand":"品牌规范"},"editBrand":{"sections":{"logo":"logo","colorCard":"色卡","textStyle":"文字样式","template":"模板","reference":"Reference","primaryColor":"主色","secondaryColor":"辅助色"},"brandBackground":"你的品牌背景是？","nameLimitTip":"请输入10字内的名称","saveLastStyle":"请保存上个样式","saveLastColorCard":"请保存上个色卡","saveLastElement":"请先保存上个元素","addColorCard":"新建色卡","addStyle":"新建样式","addPrimaryColor":"新建主色","addSecondaryColor":"新建辅助色","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"展开","foldBtnText":"收起","title":"设计指导"},"addPrimaryLogo":"新建主Logo"},"textCard":{"nameLimitTip":"请输入${0}字以内的名称","selectFont":"请选择字体","selectFontSize":"请选择字号大小","fontSizePlaceholder":"字号","save":"保存","fontSize":"号","bold":"粗体","standard":"标准","italic":"斜体","defaultCategoryName":"通用"},"templateCard":{"delSureModal":{"title":"确认删除此项吗？","okText":"确定","cancelText":"取消"},"nameLimitTip":"请输入${0}字以内的名称","defaultName":"品牌模板"},"selectBrandElementModal":{"brandAssets":"品牌资产","localUpload":"本地上传","brandLogo":"品牌logo","brandTemplate":"品牌模板","reference":"Reference","uploadImage":"上传图片","uploadDragTips":"点击/拖拽图片至此处","uploadTips":"支持上传 ${0}M以内 jpg、png 图片，最多支持${1}张"},"tooltip":{"message":"品牌海报上线啦！","desc":"上传你的海报，Agent将学习你的品牌调性，后续在对话中调用品牌库时可生成与品牌风格契合的海报～"}},"userReviews":{"hello":"你好${0}，","wordsOfThanks":"感谢加入zawa","desc":"你的反馈对我们非常重要。如果你喜欢zawa，欢迎您在Trustpilot上留下评论，我们将不胜感激。这可以帮助我们提升和成长","leave":"去评价"},"aih5DownloadBtn":{"signInText":"登录","fullQualityText":"大图","previewText":"小图","freeText":"免费","downloadText":"下载","fullQualityLimitReached":"今日高清图下载次数已用完","todayLimitReached":"今日次数已用完，立即升级"}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-next/en.json
const x_design_locales_next_en_namespaceObject = JSON.parse('{"Tab_Design":"Design","Button_Send":"Send","Input_Describe_Workspace":"Describe your image and I will create it for you","Tab_AgentCase":"Agent case","Tab_RecentCreations":"Recents","Tag_Hot":"Trending","Tag_BrandDesign":"Brand Design","Tag_Logo":"Logos","Tag_Posters":"Posters","Tab_Agent":"Agent","Tool_AiPhotoEditor":"Image Editor","Button_Upload":"Upload","Tool_Designer":"Designer","Title_AiTool":"AI Tools","Tool_ImageBackgroundRemover":"AI Background Remover","Tool_AiBackgroundGenerator":"AI Background Generator","Tool_ImageEnhancer":"Image Enhancer","Tool_AiObjectsRemover":"AI Object Remover","Tool_AiModelMannequin":"AI Model - Mannequin","Tool_AiModelFlatlay":"AI Model - Flatlay","Tool_AiImageRecolor":"AI Image Recolor","Tool_AiImageExtender":"AI Image Extender","Tool_ImageUpscaler":"AI Image Upscaler","Tool_AiLogo":"AI Logo Generator","Button_BlankCanvas":"Create","Sidebar_Create":"Home","Sidebar_Tools":"AI Tools","Sidebar_Batch":"Bulk Editor","Sidebar_MyDesigns":"My Designs","Sidebar_Inspire":"Inspire Me","Sidebar_Brand":"Brand Kit","Sidebar_PackUp":"Close sidebar","Tag_All":"All","Tag_Design":"Design","Sidebar_Unfold":"Open sidebar","Menu_Edit":"Edit","Menu_Download":"Download","Menu_Delete":"Delete","Tab_RecentlyCreated":"Recents","Tab_GenerateRecords":"Creations","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"For AI Agent only and will be used first.","Menu_DueToday":"Daily bonus credits","Menu_DueToday_Explain":"Valid until the end of the day.","Menu_Else_AgentCredits":"Other credits","Button_GoPro_GetMore":"Get more credits","Menu_Total_Explain_PaidCredits":"For all features and valid through membership period.","Menu_Pro":"Subscription credits","Menu_Pro_Explain":"Valid through membership period.","Menu_Else":"Other credits","Menu_Else_Explain_PaidCredits":"Credits from other sources. Each type may have its own expiration.","Menu_Else_Explain_AgentCredits":"Credits from other sources. Valid for a longer period.","Menu_UsageDetail":"Usage details","Menu_Total_Explain_SuspendCredits":"Unavailable until your membership is reactivated.","Tab_Invite":"Invite","Menu_InviteReward":"Invite Friends Reward","Tab_Reward":"Rewards","Title_AgentCreditForRewards":"Agent credit rewards: ","Table_Time":"Time","Table_Invitee":"Invitee","Title_ShareWithFriends":"Share with your friends","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Invite a friend and both of you will receive </span><span style=\\"color:#2D990C;\\">${0} Agent Credits!</span>","Title_InvitationLink":"Share this link with your friends","Button_Copy":"Copy","Title_Tips":"Tips","Title_Tips_ExplainOne":"1. Agent Credits can only be used to access AI Agent features. Reward credits are valid for two years.","Title_Tips_ExplainTwo":"2. New friends will receive a reward after successful registration. If you have any questions, please contact our support team.","Title_GetRewarded":"Successful invitation!","Title_GetRewarded_Explain":"Credits can only be used for AI Agent features and are valid for two years.","Button_Ok":"Got it","Title_FailedToReceiveReward":"Operation failed","Title_FailedToReceiveReward_Explain":"If you have any questions, please contact our support team.","Input_Describe_workspace":"Describe your image and I will create it for you","Tool_AiBackgroundGenrator":"AI Background Generator","Title_YouCannotUseYourOwnLink":"Private links are not allowed","Table_AgentCredit":"Agent Credits","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">You can invite up to </span><span style=\\"color:#2D990C;\\">${0} new friends</span><span style=\\"color:#616266;\\"> and earn a maximum of ${1} Agent Credits!</span>","Button_Invite":"Invite","Menu_Title_Invite":"Refer a Friend","Text_Button_Invite":"Earn Credits","Title_Dialog_Invite":"Refer a Friend","Desc_Dialog_Invite":"Share your link with friends or on social media. When a friend signs up via your link, both you and your friend will receive ${0} credits. If they subscribe, you will each receive up to ${1} extra credits.    ","Detail_Dialog_Invite":"Details","Text_Copy_Invite":"Copy link","Title_Rewards_Invite":"Rewards","SubTitle_Rewards1_Invite":"Total earned credits","SubTitle_Rewards2_Invite":"Referred free users","SubTitle_Rewards3_Invite":"Referred paid users","Success_Copy_Invite":"Link copied","Title1_Invited_Invite":"You\'ve been invited!","Text_Rule1_Invite":"For every friend who signs up using your link, you both earn <strong>${0} credits</strong>.","Text_Rule2_Invite":"If your friend subscribes, you each get extra credits (<strong>${0} for Plus, ${1} for Pro</strong>).","Text_Rule3_Invite":"Purchased subscriptions cannot be refunded if the plan has been used or any granted credits have been spent. Also, free credits cannot be revoked once used.","Text_Rule4_Invite":"Each user can invite up to ${0} friends.","Text_Rule5_Invite":"Rewards are not granted for referrals with existing accounts, self-referrals, duplicate accounts, or fraudulent activity.","Text_Rule6_Invite":"${0} reserves the right to adjust the program and revoke rewards from abnormal accounts.","Text_Divider_Invite":"or share the link","Title2_Invited_Invite":"Join ${0} and claim your rewards","SubTitle1_Invited_Invite":"A friend invited you to try our professional brand Al agent. Create high-quality brand marketing designs such as logos, posters, menus, and social media assets with ease.  ","SubTitle2_Invited_Invite":"<strong>Sign up now</strong> and both you and your friend will <strong>receive ${0} credits</strong>.<strong> If you subscribe,</strong> you will each receive additional credits based on the plan you choose (<strong>${1} credits with Plus or ${2} credits with Pro</strong>). Sign up now to claim your rewards.","Button_Invited_Invite":"Sign up to claim your rewards","Success_Invited_Invite":"You joined via a referral and received ${0} credits.","Error_Invited_Invite":"You already have an account.","Text_Share_Invite":"I’ve been using ${0} to create logos, visuals, and videos really fast. Sign up with my link and we’ll both get bonus credits.","Title_Share_Invite":"Join ${0} and earn credits together!","Share_Email_Invite":"Email","Text_Rule7_Invite":"You can use the credits for AI Agent. Credits expire after one month.  ","Title_AgentCredits":"+50 Agent Credits","Input_Models":"Model","Button_TryItNow":"Try it now","Account_Pricing":"Pricing","Account_Language":"Language","Account_Language_English":"English","Account_Language_Chinese":"Chinese","Tips_Adding":"Processing...","Tips_Loading":"Loading...","Tips_Creating":"Processing...","Tips_Downloading":"Downloading…","Tips_Sending":"Sending…","Tips_AddSuccess":"Added successfully","Tips_MakeSameError":"Unable to recreate","Tips_UnsupportedGradientColor":"Gradients are not supported","Tips_CanNotAdding":"Failed to add","Tips_Uninitialized":"Failed to send messages","Tips_UploadFailed":"Upload failed. Please try again.","Tips_UploadMaxCountLimit":"Upload up to ${n} ${type} file(s)","Tips_UploadMaxFileSize":"Unable to upload file ${file}. Please use a file up to ${n} MB.","Tips_UploadImageAndVideoLimit":"You can upload 1 image and 1 video at the same time","Tips_UnsupportedSvgFile":"SVG files are not supported","Tips_UnsupportedUploadFileFormats":"The format of your file ${files} is not supported","Tips_CanNotAddSameFileTips":"This file already exists","Tips_TextMinLengthTips":"Enter at least ${n} characters","Tips_TextMaxLengthTips":"Enter up to ${n} characters. Each Chinese character or emoji counts as 2.","Tips_AccessDenied":"Access denied","Tips_CreateFailed":"Chat initiation failed","Tips_Error":"An error occurred","Tips_NotFound":"Chat does not exist","Tips_RequestAgentModelListError":"Failed to request the Agent model list","Desc_Ended":"End","Button_PeopleUse_Agent":"${n} users tried","Dropdown_AddToChat":"Add to Chat","Dropdown_AddToBrandKit":"Add to Brand Kit","Dropdown_SaveToBrandKit":"Save as brand logo","Dropdown_SaveToBrandTemplate":"Save as brand template","Title_Design_Agent":"Design","Title_MainColor":"Main color","Title_SecondaryColor":"Secondary color","Bitton_ViewTheBrandKit":"Click to view the brand kit","Dropdown_InportImages":"Import images","Title_Upgrade_Pro":"Upgrade","Desc_SubscribeToUnlock_Pro":"Subscribe to unlock more!","Desc_RunOutOfFreeUses_Pro":"You\'ve run out of free uses.","Desc_RunOutOfUsesForToday_Pro":"You\'ve run out of free uses for today. Come back tomorrow.","Desc_PurchaseCompleted_Pro":"Purchase complete","Desc_ContinueDesign_Pro":"Now you can continue your design!","Button_UnlockNow":"Subscribe","Tips_Copied":"Copied!","Tips_Credit_Explain_Paid":"What are purchased credits?","Title_Total_InactiveCredits":"Total inactive credits","Title_Total_PaidCredits":"Total purchased credits","Menu_SuspendCredits":"Inactive credits","Menu_Credits":"Credits","Tab_RecentCreations_Agent":"Agent","Tab_RecentCreations_Design":"Smart Tools","Menu_FunctionalPricing":"Agent Pricing","Title_Total_AgentCredits":"Total - Agent credits","Tips_Credit_Explain_Agent":"What are Agent credits?","Title_FeaturePricing":"Agent Pricing","Tab_Category":"Category","Tab_TaskType":"Task","Tab_Consume":"Price (Credits)","Tab_ExampleContent":"Examples","Tips_CreditExplain_Inactive":"What are inactive credits?","langding_more_bg_remover":"Background Remover","langding_more_enhancer":"Image Enhancer","langding_more_objects_remover":"AI Object Remover","langding_more_bg_generator":"AI Background Generator","Title_More1_Home":"Image Enhancer","Title_More2_Home":"AI Object Remover","Title_More3_Home":"AI Background Generator","Title_More4_Home":"AI Background Remover","Title_More5_Home":"Batch Image Tools","Title_Home":"Your <span>E-Commerce</span> Design AI Agent","Placeholder_Input_Home":"Describe your image and I will create it for you.","Title_Card4_Home":"Visuals for Amazon","Title_Card1_Home":"Apparel & Accessory Try-on Images","Title_Card3_Home":"Product Detail Page Images","Title_Card2_Home":"Background Generator","Desc_Features1_Home":"AI automatically extracts product features and style preferences to determine the ideal design solutions.","Desc_Features2_Home":"Just enter one sentence, and the AI will generate a complete collection of e-commerce images, including the main image, supporting visuals, and a full product detail page.","Text_Btn_Home":"Get Started for Free","Desc_Features3_Home":"Automatically create platform-ready visuals tailored to Amazon, Etsy, TEMU, eBay, and more, ensuring images are always optimized to attract the right audience.","Desc_Features4_Home":"Just enter your request, and the AI will adapt the language, style, tone, and cultural elements to produce localized versions for each target market.","Desc_Features5_Home":"Save your design workflow as a reusable template, and let the AI automatically generate images for all your SKUs in bulk.","Desc_Features6_Home":"Whether you’re working with 10 products or 1,000, you can quickly produce a complete, consistent visual suite with ease.","Title_Qualification_Home":"Trusted by Over 5 Million E-commerce Sellers!","Text_Btn_Qualification_Home":"View Certification","Title_Carousel_Home":"More AI tools","Title_Footer_Home":"Your E-Commerce Design AI Agent","Title_Footer1_Home":"Social Media Account","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Help & Legal","Subtitle_Footer5_Home":"Terms of Service","Subtitle_Footer6_Home":"Privacy Policy","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Love Designkit! The AI lifestyle images are natural — cozy and Nordic, perfect for my candle shop. My listings look polished and sales have increased. Worth it.","Job_Evaluation5_Home":"TEMU seller in Mexico","Job_Evaluation6_Home":"Amazon operations specialist","Job_Evaluation12_Home":"Store manager of a multi-SKU Amazon shop in Indonesia","Job_Evaluation2_Home":"Amazon & Mercado Libre store owner ","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"The lifestyle scene images look really natural, almost like they were professionally shot. My customers seem to love them too, and I’ve actually seen my conversion rates go up.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Cross-border store owner on Lazada & Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"DTC E-commerce Designer","Job_Evaluation8_Home":"Walmart Outdoor Products store owner in America ","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Mercado Libre seller in Argentina","Desc_Evaluation7_Home":"The pet product scenes the AI generates are super cute! The cats and dogs look perfectly proportioned and natural. Plus, the size and scale fit platform requirements, so the images are really easy to use right away.","Job_Evaluation7_Home":"Mercado Libre store owner in Brazil","Desc_Evaluation8_Home":"The camping scenes for my tents look really realistic. The lighting and angles feel natural, and the proportions are spot on. It saves me so much time compared to shooting everything myself.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"The tool is really fast, and the images it generates can basically be uploaded straight to Mercado Libre and Amazon without any extra tweaks.","Desc_Evaluation6_Home":"I used to worry that AI would mess up the fabric textures, but they barely look different from the original. Knitwear looks like knitwear, denim like denim, and it even meets Amazon\'s image requirements. Launching new products has become so much faster.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"The AI-generated product images are really accurate. The cable length and connector shapes are spot on, and they even match TEMU’s style. It’s a huge time-saver compared to taking the photos myself.","Desc_Evaluation12_Home":"With just one prompt, I can get usable graphics instantly, which is way faster than waiting for a designer. It’s honestly super convenient.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"The metallic textures and structural details are really clear, which makes the images look professional. I can use them straight away without any edits.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"Batch generation is super convenient. I can process dozens of SKUs at once, and it’s way faster than doing everything manually like before.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"I sell clothing, and I was worried that AI might mess up the colors or fabric textures,but it actually did great! The model poses look natural, and the images are basically ready to use right away.","Job_Evaluation1_Home":"SHEIN store operations specialist","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Amazon Operations Specialist","Desc_Evaluation2_Home":"The tool is super fast, and the images are basically ready to upload to Mercado Libre or Amazon. It even adapts backgrounds and models to local tastes, and the results look totally professional.","Job_Evaluation4_Home":"eBay seller in Germany","Title_Evaluation_Home":"Their Stories","Title_Introduction_Home":"Premium AI design that drives stronger sales","Desc_Qualification_Home":"Amazon SPN Certified Service Provider","Title_Seo_Home":"AI Product Image & Video Generator for E-commerce","Desc_Seo_Home":"Instantly generate product images, posters, and videos for Amazon, TikTok, and more online shops with Designkit\'s AI Agent. Start designing for free today!<br>","Keywords_Seo_Home":"AI Agent for E-commerce, E-commerce AI tools, AI Product Image Generator, AI Product Video Generator, AI Product Photo Editor, AI Background Remover","Title_Features1_Home":"From a single request to a complete set of visuals","Title_Features2_Home":"Fully automated localization to sell your products globally across multiple platforms","Title_Features3_Home":"Automatically generate images in bulk for multiple SKUs and beat competitors to market!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Scroll to explore","Tips_Material1_Home":"Listing image set","Tips_Material2_Home":"Virtual try-on","Tips_Material3_Home":"A+ content","Tips_Material4_Home":"Background generator","Free_Button_Home":"Try for free","Title_Header1_Home":"Product","Title_Header2_Home":"solution","Title_Header3_Home":"Inspiration","Title_Header4_Home":"Learn","Title_Header5_Home":"Pricing","SecondTitle_Header1_Home":"AI E-Commerce Agent","SecondTitle_Header2_Home":"AI Image Tools","SecondTitle_Header3_Home":"AI Video Tools","SecondTitle_Header4_Home":"Amazon Design Solution","SecondTitle_Header5_Home":"Social Media E-Commerce Solution","SecondTitle_Header6_Home":"AI Product Image Generator","SecondTitle_Header7_Home":"AI Fashion Model Generator","SecondTitle_Header8_Home":"Clothes Color Changer","SecondTitle_Header9_Home":"Product Video Generator","SecondTitle_Header10_Home":"AI Tools","SecondTitle_Header11_Home":"AI Photo Editor","SecondTitle_Header12_Home":"AI Photo Editor Online","SecondTitle_Header13_Home":"Bulk Photo Editor","SecondTitle_Header14_Home":"Bulk AI Photo Editor","SecondTitle_Header15_Home":"Batch Image Enhancer","SecondTitle_Header16_Home":"Bulk Watermark Remover","SecondTitle_Header17_Home":"Bulk Background Generator","SecondTitle_Header18_Home":"Batch Image Background Remover","Title_Footer3_Home":"Design Tools","Subtitle_Footer8_Home":"AI Photo Editor","Subtitle_Footer7_Home":"AI Background Changer","Subtitle_Footer9_Home":"Transparent Background","Subtitle_Footer10_Home":"Change Background Color","Subtitle_Footer11_Home":"Image Watermark Remover","Subtitle_Footer12_Home":"Remove Text from Image","Subtitle_Footer13_Home":"Add Stickers to Photos","Subtitle_Footer14_Home":"Add Watermark to Photos","Title_Footer4_Home":"Image Models","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Download for Free","Subtitle_Footer16_Home":"iOS APP","Subtitle_Footer17_Home":"Android APP","Title_Footer6_Home":"Follow Us","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Video Models","Button_Export":"Download","Title_Layer":"Layers","InputNumber_Opacity":"Opacity","Buttom_Comfirm":"Confirm","Button_Share":"Share","Button_Delete":"Delete","Title_LoginPopup":"  Log in to start trial","SubTitle_LoginPopup":"Start creating with Zawa today","Tip_ModalTitle":"Reminder","TipContent_HistoryDelete":"Once deleted, this record cannot be restored. Confirm deletion?","Title_Logo":"Logo","Title_BrandKit":"Templates","Tab_BrandKit":"Brand Kit","Tab_UploadLocal":"Choose from album","Button_UploadImage":"Upload Images","Button_UploadProductImage":"Upload Product Image","Button_UploadReferImage":"References","Tip_ClickDragParseImage":"Upload, drop or paste images here.","Tip_UploadMax":"Upload JPG, JPEG, or PNG files up to ${0} MB, with a maximum of N images.","Tooltip_SwitchBrandKit":"Switch brand kit","Discribe_BrandKitSelect":"Select a brand style as the reference for this design.","Title_Models":"Models","Switch_Auto":"Auto","Tab_Image":"Image","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Save as brand logo","MenuItem_AddToBrandTemplate":"Save as brand template","Button_ExportImage":"Import images","Button_ExportMedia":"Import videos","Button_ExportFromBrandkit":"Import from Brand Kit","Dropdown_AddFromBrandkit":"Add from Brand Kit","Placeholder_ChatInput":"Let\'s get started!","MenuItem_AiChange":"AI Editing","MenuItem_AiExpend":"AI Extender","MenuItem_AiHD":"AI Clarity","MenuItem_Eliminate":"AI Removal","MenuItem_SplitLayers":"Split Layers","MenuItem_Cutout":"BG Remover","MenuItem_ChangeText":"Replace Text","MenuItem_Crop":"Image Size","MenuItem_AddToChat":"Add to Chat","MenuItem_AddToBrand":"Add to Brand Kit","Tooltip_Layer":"Layers","Tooltip_Grab":"Hand tool","Tooltip_Select":"Select","Tooltip_Redo":"Redo","Tooltip_Undo":"Undo","Tooltip_Add":"Add","Tooltip_ShowAll":"Show all","Tip_UploadType":"Unsupported file format","Tip_UploadSize":"Only files up to ${0} MB are supported","Tip_UploadWH":"Please ensure each image is no larger than ${0}×${1} pixels","Tip_UploadTypeTranslate":"Failed to change file format","Tip_UploadFail":"Upload failed","Tooltip_AddText":"Add text","Text_AddDefault":"This is sample text.","Tooltip_OverflowImageSize":"Please resize your image to within ${0} pixels","Placeholder_ImageFusion":"Let me know how you\'d like the images blended","Button_ImageFusion":"Blend","Button_Cancel":"Cancel","Button_AiChange":"Edit","Placeholder_AiChange":"Let me know what you want to change","Button_Eliminate":"Eraser","Label_OriginSize":"Original","Label_CropRadio":"Aspect ratio","Button_Free":"Free","Button_Origin":"Original","Button_Crop":"Crop","Placeholder_ChangeText":"Enter text. Example: Hello","Button_ChangeText":"Confirm","InputNumber_PanSize":"Brush size","Label_TargetSize":"Target","Tooltip_ImageFusion":"You can blend ${0}-${1} images","Title_Workspace":"Your Creative AI Agent for Branding","Button_Pro":"Get Free Pro","Title_NanoPro":"🍌🍌Nano Banana Pro is now available on Zawa.","Dropdown_AdvancedFeatures_Title":"Advanced Features","Dropdown_AdvancedFeatures_Conent":"Full access to all AI-powered tools to enhance your efficiency.","Dropdown_MassiveContent_Title":"Extensive Content","Dropdown_MassiveContent_Content":"Unlimited access to premium templates and a vast array of Plus stock assets.","Dropdown_CommercialRights_Title":"Commercial Rights","Dropdown_CommercialRights_Content":"Use your personal creations with confidence, backed by guaranteed copyright protection.","Popup_SubscribeIntl_Desc":"Get the most from Zawa with Pro","Popup_SubscribeIntl_Desc1":"Unlock more creations with credits","Popup_SubscribeIntl_Detail":"View plan details & Help","Popup_StripeCheckout":"Stripe checkout","Popup_LiveSupport":"Live support","Popup_CancelAnytime":"Cancel anytime","Menu_Language":"Language","Menu_ManageSubscription":"Manage Subscriptions","Menu_TermsPolices":"Terms and Policies","Menu_ManageSubscriptions":"Manage Subscriptions","Menu_ReferralLink":"Referral Link","Menu_BenefitsUpgraded":"Benefits","Menu_TermsPolicies":"Terms and Policies","Menu_AccountManagement":"Account","Title_ReferralCode":"Referral Code","Title_ReferralLink":"Referral Link","Desc_NoActiveSubscription":"No active subscription","Button_ClickToSubscibe":"Click here to subscribe","Title_SubscriptionCancel":"Your subscription has been cancelled","Title_SeeYou":"Sorry to see you go...😭","Desc_NextBillingDate":"Renews on","Desc_EstimatedAmount":"Estimated total","Button_CancelSubscription":"Cancel subscription","Button_StaySubscribed":"Keep subscription","Title_ReasonCancelling":"Please select a reason for cancelling:","Desc_BenefitsContinue":"You can still enjoy your membership benefits until the end of the subscription.","Desc_GiftedCredits":"After your subscription expires, the gifted credits","Desc_SeeYou":"Thanks for being with us. We\'re sorry to see you go.","Desc_NoNoreCharges":"You won\'t be charged again, and your membership remains active until","Desc_MayBeRevoked":"may be revoked.","Desc_CancelingNoRefund":"Cancellation does <span>not include a refund<span>. For refund inquiries, please contact online support.","Button_ClearSelection":"Unselect","Button_Confirm":"Confirm","Message_Processing":"Processing...","Title_Opacity":"Opacity","Button_ExpandImage":"Extender","Button_ExpandRadio":"Aspect ratio","Title_NoDesigns":"No designs yet.","Title_NoGenerations":"No generations yet.","Desc_NoDesigns":"Your designs will show up here.","Desc_NoGenerations":"Your generations will show up here.","Title_DeleteDesign":"Delete this design","Popup_DeleteDesign":"Are you sure you want to delete this design permanently? This action can\'t be undone.","Message_SaveFail":"Failed to save","Title_Pricing":"Choose the Right Plan for You","Title_Tags1_Pricing":"Monthly","Text_Discount_Pricing":"${0} off","Title_Tags2_Pricing":"Yearly","Title_Plan1_Pricing":"Free","Current_Plan_Pricing":"Current plan","Title_Instruction1_Pricing":"Get 20 credits for first login","Title_Instruction2_Pricing":"Generate up to 20 images with AI Agent","Title_Instruction3_Pricing":"Generate up to 10 images with AI Background Generator","Title_Rights1_Pricing":"Limited background or object removal","Title_Rights3_Pricing":"Limited HD image enhancement","Title_Plan2_Pricing":"Basic Plan","Month_Plan_Pricing":"month","Title_Button1_Pricing":"Subscribe","Title_Instruction4_Pricing":"500 credits/mo","Title_Instruction5_Pricing":"Generate up to 500 images with AI Agent","Title_Instruction6_Pricing":"Generate up to 250 images with AI Background Generator","Title_Plan3_Pricing":"Pro Plan","Desc_Plan_Pricing":"7-day free trial. Then ${0}/year.","Title_Button2_Pricing":"7-day free trial","Title_Instruction7_Pricing":"1,500 credits/mo","Title_Instruction8_Pricing":"Generate up to 1,500 images with AI Agent","Title_Instruction9_Pricing":"Generate up to 750 images with AI Background Generator","Title_Rights4_Pricing":"Unlimited background or object removal","Title_Rights5_Pricing":"Unlimited use of AI removal feature","Title_Rights6_Pricing":"Unlimited UHD image enhancement","Title_Rights7_Pricing":"Batch processing tools","Title_Best_Pricing":"Chosen by 90% of users","Title_AllFeatures_Pricing":"Compare Free and Paid Plans","Desc_AllFeatures_Pricing":"Unlock Premium to create stunning designs effortlessly with advanced AI tools","Month_AllFeatures_Pricing":"month","Title_Features1_Pricing":"AI Agent","SubTitle_Features1_Pricing":"Image Editing","SubTitle_Features15_Pricing":"Generate up to ${0} images","SubTitle_Features16_Pricing":"Generate up to ${0} images/mo","SubTitle_Features2_Pricing":"Image Generation","SubTitle_Features3_Pricing":"E-commerce Image Generation","SubTitle_Features4_Pricing":"Poster Generation","Title_Features2_Pricing":"AI Image Tools","SubTitle_Features5_Pricing":"AI Background Remover","SubTitle_Features17_Pricing":"Limited use","SubTitle_Features19_Pricing":"Unlimited use","SubTitle_Features6_Pricing":"AI Object Remover","SubTitle_Features7_Pricing":"Image Enhancer","SubTitle_Features18_Pricing":"Limited use (HD)","SubTitle_Features20_Pricing":"Unlimited use (HD/UHD)","SubTitle_Features8_Pricing":"AI Image Upscaler","SubTitle_Features9_Pricing":"AI Image Extender","SubTitle_Features10_Pricing":"AI Background Generator","Title_Features3_Pricing":"More Design Features","SubTitle_Features11_Pricing":"Advanced Features and Templates","SubTitle_Features12_Pricing":"Remove Watermark","SubTitle_Features13_Pricing":"Bulk AI Image Tools","SubTitle_Features14_Pricing":"Basic Design Features","Title_Credits_Pricing":"Running low on credits? We\'ve got you covered.","Desc_Credits_Pricing":"One-time purchase, no subscription needed.","TransactionPrice_Credits_Pricing":"Price: ${0}","Credit_Credits_Pricing":"Credits","Popular_Credits_Pricing":"Most Popular","Buy_Credits_Pricing":"Purchase Now","Title_FAQ_Pricing":"FAQs","Title_Button4_Pricing":"Upgrade now for a 7-day free trial","SubTitle_FAQ1_Pricing":"What are credits?","Content_FAQ1_Pricing":"Credits allow you to continue accessing AI tools. The number of credits required varies depending on the specific tool.","Content_FAQ2_Pricing":"Purchased credits are valid for one year.","Content_FAQ3_Pricing":"Membership credits are valid during the membership period.","SubTitle_FAQ2_Pricing":"How do I cancel my subscription and what happens to my credits after cancellation?","Content_FAQ4_Pricing":"After canceling your subscription,","Content_FAQ5_Pricing":"your membership credits will remain valid until your membership expires. Any credits you\'ve purchased separately will not be affected.","Content_FAQ6_Pricing":"If you need to cancel your subscription, please follow the steps below at least 24 hours before the next billing cycle begins:","Content_FAQ7_Pricing":"1. Go to Designkit and log in.","Content_FAQ8_Pricing":"2. Enter the subscription pop-up window.","Content_FAQ9_Pricing":"3. Select \\"Manage Subscriptions\\".","Content_FAQ10_Pricing":"4. Select your current plan and click \\"Cancel Subscription\\".","Content_FAQ11_Pricing":"Your subscription will remain active until the end of the current billing cycle. If you are unable to cancel, please take a screenshot and contact our online support as soon as possible.","SubTitle_FAQ3_Pricing":"What is your refund policy?","Content_FAQ12_Pricing":"1. 7-Day Money-Back Guarantee:","SubTitle_FAQ4_Pricing":"How can I upgrade or downgrade my subscription?","Content_FAQ25_Pricing":"1. Upgrade: You can simply subscribe to a higher-tier plan, and it will take effect immediately. Your old subscription will be cancelled, and any remaining balance will be refunded.","SubTitle_FAQ5_Pricing":"Can I get a copy of my invoice?","Content_FAQ27_Pricing":"Yes! After a successful payment, you will receive an email from the payment provider containing an electronic invoice. If you do not receive an invoice, please contact our support team.","SubTitle_FAQ6_Pricing":"What payment methods do you support?","Content_FAQ28_Pricing":"We use Stripe to manage payments and subscriptions. We accept all major credit cards, PayPal, and Google Pay.","SubTitle_FAQ7_Pricing":"How can I contact support?","Content_FAQ29_Pricing":"Email: support@designkit.com. Response time: 3-10 business days.","Content_FAQ13_Pricing":"If you purchased subscriptions and have not used them within 7 days, you may be eligible for a full refund.","Content_FAQ14_Pricing":"If you purchased credits, you may be eligible for a refund for any unused credits within 7 days.","Content_FAQ15_Pricing":"2. Dissatisfaction with Service","Content_FAQ16_Pricing":"If you\'re unsatisfied with the results, please contact our online support team. We may provide compensation or a refund depending on the circumstances.","Content_FAQ17_Pricing":"3. Purchases via Google Play or App Store","Content_FAQ18_Pricing":"If you subscribed through Google Play Store or the App Store, you need to request a refund directly from Google or Apple.","Content_FAQ19_Pricing":"Important Notes:","Content_FAQ20_Pricing":"This refund policy does not apply to API users. If you use our API, please contact us for refund eligibility.","Content_FAQ21_Pricing":"We reserve the right to deny refunds in cases of misuse, abuse, or violations of our terms.","Content_FAQ22_Pricing":"Refunds may take several business days to process, depending on your payment method.","Content_FAQ23_Pricing":"We may update this refund policy from time to time. Please check it periodically for any changes.","Content_FAQ24_Pricing":"For further assistance, please contact our support team.","Content_FAQ26_Pricing":"2. Downgrade: First, cancel your current subscription. Once your current billing period ends, subscribe to a new plan.","Content_Modal_Pricing":"Thank you for your support! Get ready to take your creativity to the next level.","Tip_Modal_Pricing":"Tips: If your membership isn\'t showing up yet, please refresh the page.","Title_Modal_Pricing":"Successfully purchased","Title_Rights2_Pricing":"Limited use of AI Removal feature","Title_Button3_Pricing":"Available benefits","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Background Remover","Tool_AiBgGenerator":"AI Background Generator","Tool_AiLogoGenerator":"AI LOGO Generator","Tool_FootwearModel":"Footwear Model","Tool_ImageTranslation":"Image Translation","Tool_BatchImageBgRemover":"Batch Image Background Remover","Tool_BatchImageEnhancer":"Batch Image Enhancer","Tool_BatchAiObjectsRemover":"Batch AI Object Remover","Tool_VideoEnhancer":"Video Enhancer","Tool_VideoBgRemover":"Video Background Remover","Tool_VideoWatermarkRemover":"Video Watermark Remover","Title_Models_Dropdown":"Models","Tips_Uninitialized_Chat":"Failed to send messages","Tips_Uninitialized_chat":"Failed to send messages","Dropdown_AddImage":"Add image","Action_SeeAll":"See all","Desc_Seedream":"Realistic and detailed image creation.","Dropdown_AddVideo":"Add video","Tips_NotFound_Chat":"Chat does not exist","Desc_Seedance":"Realistic and expressive video creation.","Dropdown_SupportedFormatFile":"Supports Word, Excel, Text and PDF files.","Dropdown_Example_Option":"Example","Dropdown_NoReference_Option":"No reference available","Menu_AgentCredits":"Agent Credits","Desc_SeedEdit":"Precise and natural image editing.","Dropdown_BrandKit_Title":"Brand Kit","Desc_GeminiNanoBanana":"Fast, editable, and consistent image generation.","Dropdown_Models_Title":"Models","Dropdown_AddDocument":"Add document","Dropdown_BrandKit_Desc":"Select a brand style as the reference for this design.","Desc_MidjourneyVideo":"Creative and artistic video generation.","Desc_MidjourneyImage":"Artistic and imaginative image generation.","Dropdown_SaveAsBrandTemplate":"Save as brand template","Dropdown_SaveAsBrandLogo":"Save as brand logo","BatchProcessTable_ImageType":"Image type","BatchProcessTable_PictureRequirement":"Design details","BatchProcessTable_CopywritingRequirements":"Product description","BatchProcessTable_Proportion":"Aspect ratio","BatchProcessTable_Actions":"Action","BatchProcessTable_AddOneRow":"Add","BatchProcessList_DeleteError":"Deletion failed","BatchProcessList_SurePrompt":"Delete this guideline?","BatchProcessList_SurePrompt_SureText":"Confirm","BatchProcessList_SurePrompt_CancelText":"Cancel","BatchProcessList_EmptyText":"Empty","EditBatchProcess_NameLimitTip":"Enter a name (up to 10 characters)","EditBatchProcess_Tip":"Any changes to the guidelines will affect the generated results.","EditBatchProcess_Start":"Start with a guideline","EditBatchProcess_GenerateTip":"Upload your product images, and designs will be generated based on the guidelines.","Text_AdvanceSetting":"Expert","Text_MainImage":"Main image","Text_ProductAgentUploadGuide1":"1. Upload multiple images of the same product from different angles to help AI better capture product details.","Text_ProductAgentUploadGuide2":"2. Up to 10 images. The first image will be used as the primary reference, so please choose the most best angle.","Text_Optional":"  (Optional)","Tip_ClickDragImageWithSize":"Upload or drop JPEG, JPG, or PNG images up to ${0} MB.","Button_AddReferenceImage":"Upload","Title_ReferenceImage":"Reference image","Input_Placeholder":"Please select","Radio_ReferenceColor":"Reference color","Radio_ReferenceLayout":"Reference layout","Tag_FirstImage":"First image","Tag_FirstImageNoPartial":"Partial first image","Tag_Blur":"Blurry","Tag_Jigsaw":"Collage","Button_Understood":"Got it","Text_ReferenceImageIndex":"Image ${0} is for reference","Text_ReferenceDimensions":"Use ${0} from reference","Tag_Cropped":"Cropped","Tag_Underexposed":"Underexposed","Tag_Blurry":"Blurry","SelectOption_ColorPalette":"Color Palette","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fonts","SelectOption_Style":"Style","SelectOption_ShapeElements":"Shape Elements","Text_SocialMediaAgentUploadGuide":"Upload your featured product first. Ensure the picture is clear and complete.","Video_SR_Success":"Video clarity enhanced","Video_Desubtitle_Success":"Subtitle removed","Video_Dewatermark_Success":"Watermark removed","Video_Process_Failed":"Processing failed. The credits will be refunded to your account.","Video_SR":"AI Clarity","Video_Dewatermark":"Remove Watermark","Video_Desubtitle":"Remove Subtitle","Video_Task_Price_Estimate":"${0} credits required","Video_SR_Start":"Enhancing clarity... ${0} credits will be used.","Video_Dewatermark_Start":"Removing watermarks... ${0} credits will be used.","Video_Desubtitle_Start":"Removing subtitles... ${0} credits will be used.","Video_Desubtitle_Start_VIP":"Removing subtitles...","Video_Dewatermark_Start_VIP":"Removing watermarks...","Video_SR_Start_VIP":"Enhancing clarity...","Text_Help_Center":"Help Center","Title_Request":"Chat","Button_Continue":"Continue","Button_EditContent":"Edit message","Title_ChooseImageType":"Select generated image type (Multiple options)","Button_BatchGenerate":"Confirmed. Run the template now.","Text_ChatCancelStatus":"Task terminated","Text_ChatRespondedStatus":"Task processing","BatchProcess_SaveSuccessTip":"Your workflow kits are saved here.","Button_GotIt":"Got it","Title_Congrats":"Congrats","SubTitle_BrandCreate":"You\'ve built your first brand kit—time to explore its potential!","Button_CheckUse":"Check it out now","Chat_Prompt_Brand":"Create a promo poster","Tooltip_UseBrand":"You can switch or add your brand kit here!","Tooltip_PosterBrand":"Tap to create your first poster based on your brand kit","Popup_CreateBrand":"Create a brand from scratch","Desc_CreateBrand":"Create stunning, original logos with our AI Agent.","Popup_UploadBrand":"Upload your brand information","Desc_UploadBrand":"Upload it and Zawa will keep every design aligned.","Title_BrandEntry":"Get a tailored brand system now","Desc_BrandEntry":"Let our Al be your stylist. Answer a few questions and receive a complete brand system tailored to your vision.","Tooltip_UseBrand_Agent":"Once the brand kit is applied, the design will automatically reference the logo, color palette, and overall style.","Tooltip_PosterBrand_Agent":"You\'re all set to design with your brand kit","BatchProcess_createText":"Workflow Kit","Label_NormalMode":"Basic:","Label_AdvancedMode":"Advanced:","Text_NormalMode":"Basic","Text_AdvancedMode":"Advanced","BatchProcess_DefaultPrompt":"Generate Images","Title_CreateBrand":"Don\'t have a brand?","Title_UploadBrand":"Already have a logo?","Button_CreateBrand":"Create a brand","BatchProcess_EditContent":"Edit content","BatchProcess_PleaseSelect":"Select a workflow kit","BatchProcess_SelectTip":"All uploaded images will be generated in batch using the selected workflow kit.","BatchProcess_ListEmptyTip":"Save workflow kit after generating to instantly create similar sets in batches.","BatchProcess_Tip":"Workflow Kit","BatchProcess_Generate":"Use it now","BatchProcess_Save":"Save","BatchProcess_GeneratingFormula":"Generating workflow kit...","BatchProcess_GenerateCancel":"Cancel","BatchProcess_WorkFlowCreateError":"Creation Failed","ProductInfo_PleaseUploadImage":"Upload product images","BatchProcess_IntelligenceGenerate":"Create workflow kit","BatchProcess_CreateWorkflow":"Create","BatchProcess_Formula":"Workflow Kit","BatchProcess_WorkFlowSaveSuccess":"Workflow kit saved","ProductInfo_ImageSizeLimit":"Images within ${0} MB are supported","ProductInfo_ImageUpload":"Add product image","ProductInfo_UploadDemo":"Example photos","ProductInfo_ECPlatform":"Platform","ProductInfo_PleaseSelect":"Please select","ProductInfo_InputCustomize":"Custom","ProductInfo_CountryAndLanguage":"Target region/language","ProductInfo_Name":"Product name","ProductInfo_Desc":"Product details (Features/Size/Usage scenarios)","ProductInfo_DescPlaceholder":"Enter product information including features, size, usage scenarios, target audience, etc.","ProductInfo_NamePrompt":"The product name is ${0};","ProductInfo_ECPlatformPrompt":"The target platform is ${0};","ProductInfo_CountryAndLanguagePrompt":"The language is ${0};","ProductInfo_DescPrompt":"The product details are ${0}.","ProductInfo_PleaseInput":"Please enter","Button_UnlockPro":"Unlock Pro","Button_UpgradeToPro":"Upgrade to Pro","Button_RenewNow":"Renew Now","AgentEmpty_CaseUseBtn":"Use","AgentEmpty_CaseRefreshBtn":"Refresh","MenuItem_Effect":"Effects","MenuItem_Shadow":"Shadows","MenuItem_Stroke":"Stroke","Title_ChangeText":"Replace Text","Button_Logout":"Log out","Message_ExtractText":"Extracting text","Message_ExtractTextError":"Failed to extract the text. Please try again.","Tip_CreditConsume":"This generation uses ${0} credits","Tip_EstimatedTime":"Ready in about ${0} minutes","BatchProcess_SaveSuccessTip_GotIt":"Got it","BatchProcess_SaveSuccessTip_Title":"Using Workflow Kits","BatchProcess_SaveSuccessTip_Desc":"Your workflow kits are saved here. Choose one to quickly generate images using the saved templates.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Hand tool","Text_Function":"Function","Text_WindowsSystem":"Windows system","Text_MacSystem":"Mac system","Menu_KeyboardShortcuts":"Shortcuts","Title_KeyboardShortcuts":"Shortcuts","Text_Undo":"Undo","Text_MouseLeft":"Left mouse button","Text_Redo":"Redo","Text_Delete":"Delete","Text_Cut":"Cut","Text_Copy":"Copy","Text_Paste":"Paste","Text_PasteFixed":"Paste in place","Text_CreateCopy":"Create a copy","Text_SelectAll":"Select all","Text_SelectMultiple":"Multi-select","Text_Group":"Group","Text_Ungroup":"Ungroup","Text_LockLayer":"Lock","Text_Save":"Save","Text_Move":"Move","Text_MoveWithCombinedKeys":"Quick move","Text_TouchEditFastMode":"Quick Point to Edit","Text_Pan":"Pan","Title_Canvas":"Canvas","Title_Edit":"Edit","Title_Elements":"Elements","Title_Tools":"Tools","Title_Blogs":"Blog","Text_NewText":"New text","Text_NewLine":"New line","Text_NewRectangle":"New rectangle","Text_NewCircle":"New circle","Text_ExitFullScreen":"Exit full screen","Text_MoveUpOneLayer":"Bring forward","Text_MoveDownOneLayer":"Send backward","Text_Top":"Bring to front","Text_Bottom":"Send to back","Text_CanvasZoom":"Zoom in/Zoom out","Text_ToggleReferenceLine":"Show/hide guides","Text_ToggleRulerBar":"Show/hide rulers","Text_ArrowKey":"Arrow keys","Text_CanvasShowAll":"Show all canvas","Title_Unsupported_Multilayer":"This feature works with a single layer only.","Btn_CreateBatchProcessFormula":"Create","Button_Hide_Otherlayers":"Keep first layer and continue","Button_Merge_Alllayers":"Merge all layers and continue","Checkbox_Disable_Remind":"Don\'t show again","Button_Tool":"Tools","Button_Custom_Ratio":"Custom","Label_Spacing":"Spacing","Button_Download_Whole":"Export as Image","Button_Download_Layer":"Export by Layer","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Point to Edit","Text_TouchEdit_Description":"Point to an object and describe your changes. The image will be edited exactly as you specify.  ","Tooltip_TouchEdit_Max_Count":"You can point out up to ${0} areas","Tooltip_TouchEdit_Usage":"Point to Edit shortcut: ${0} + click","Text_TouchEdit_Recognition_Custom":"Custom","Text_TouchEdit_Recognition_Title1":"Detect and recognize","Text_TouchEdit_Recognition_Title2":"No target found. Enter the object\'s name.","Text_TouchEdit_Name":"Point to Edit","Btn_LoginToViewBatchProcess":"Log in to view the workflow kit","Btn_Login":"Log in","Menu_Main_Beautify":"Refine","Text_Model_Pricing":"Model Pricing","Text_Pro_discount":"Pro Plan: Half-Price Video Generation","Text_TemplatePrompt":"Let’s start with inspirations","Text_Hi":"Hi, ${0}!","Text_Account_Popup_Left":"Meet your dedicated AI design assistant for e-commerce. Crafted for professionals who seek faster launches, stronger presentation, and higher profitability.","Text_PleaseWaitImageUploaded":"Please proceed after the upload is complete","Menu_Redeem_Rights":"Redeem","Text_Redeem_Now":"Redeem Now","Text_Redeem_Placeholder":"Enter the redemption code, case sensitive","Text_Redeem_Success":"Redeemed successfully!","Text_Redeem_Use":"Redeem your code","Tooltip_BrandAutoUse":"Your new brand kit is applied!","Redeem_Redeem_Note":"Note: \\nPlease log in and enter the redemption code.\\nOnce the redemption is successful, you can enjoy the corresponding benefits and services.\\nPlease use the redemption code within its validity period. Expired codes will be invalidated and are non-refundable.\\nPlease protect your code. We are not responsible for lost, leaked, or incorrectly used codes. \\nThis code may not be resold or transferred, cannot be exchanged for cash, and is not eligible for invoicing.","Tooltip_Color_Fill":"Color","Tootip_StartPoint":"Start","Tootip_ChangePoint":"Switch","Tootip_EndPoint":"End","Sidebar_NewDesign":"New chat","Retouch_Filter_Clear":"Clear","Retouch_Filter_Enhance":"Vivid","Retouch_Filter_Dehaze":"Dehaze","Retouch_Filter_Texture":"Texture","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Fade","Modal_Button_Known":"OK","Modal_Button_GotIt":"Accept","Modal_Button_Later":"Later","Text_Appeal_Confirm":"Yes","Text_Vip_Open":"Subscribe","Text_Appeal_ReGenerate":"Edited results are not eligible for review.","Text_Appeal_Left":"Attempts left this month\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"The credits have been refunded to your account.","MenuItem_Appeal":"Result Review","Tooltip_Downloading":"Downloading…","Tooltip_Download_Video":"Download videos separately, one at a time.","Tooltip_Download_NoneSelected":"Please select the content you want to download","Text_AI_Thinking":"AI is working on it...","Text_Server_Busy":"The server is busy. Please try again later.","Text_Prompt_Help_Placeholder":"Type your keywords, and I\'ll turn them into a ready-to-use prompt.","Text_Prompt_Helping":"Processing... Please wait.","Button_Retry":"Retry","Button_Rewrite":"Try again","Button_Start_Prompt_Help":"Start writing","Title_Prompt_Helper":"AI Writing","Menu_Text_Subscriptions":"Subscriptions","Menu_View_Subscriptions":"View Subscriptions","Text_Download_XdesignApp":"Please download the <span>Zawa</span> app to use features","Text_Free_Trial":"Download for a 7-day Free Trial","Text_Install_App":"Install App","Text_Scan_Download":"Scan to download","Text_Download_the":"Download on the","Text_Available_On":"Available on","Desc_ExpireDate":"Expires on","DownloadApp_Title_Widgets":"Please download the ${0} app to use features","DownloadApp_SubTitle_Widgets":"Download for a ${0}-day Free Trial","InstallApp_Title_Widgets":"Install App","InstallApp_Desc_Widgets":"Scan to download","AppStore_Desc_Widgets":"Download on the App Store","GooglePlay_Desc_Widgets":"Get it on Google Play","Text_Tips_GetFree":"You\'ve got one free use","Text_AgentLib":"Assets","Tip_ModelSetSaveSuccess":"Your model image is saved! Tap to use it.","Text_BatchProcess":"Workflow Kit","Button_Add":"Add","Tab_Recent":"Recently saved","Tab_Models":"My Models","Prompt_Model":"Image ${0} is my model","Tip_SaveSuccess":"Saved","Text_ModelsLogin":"Log in to view your models","Loading_CheckFace":"Detecting face...","Name_InitialModelName":"My Models","EmptyTip_ModelList":"No model yet. Let’s create one!","Text_UploadModel":"Upload model","Text_Model":"Model","Tips_UnsupportedFormat":"Unsupported file format","Tips_InputModelName":"Enter a name","Tips_UploadModelImage":"Upload model images","Title_CreateModel":"Create your model","Text_ModelName":"Name","Placeholder_Input":"Please enter","Text_UploadModelHint":"Tap to upload or drag images here\\nJPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Upload","Tips_NameLengthLimit":"Enter a name (up to ${0} characters)","Tips_DeleteFailed":"Deletion failed","Title_ConfirmDeleteModel":"Delete this model?","Tips_CreateSuccess":"Model created","Tab_BatchTemplate":"Workflow Kit","Tab_MyModel":"My Models","Placeholder_InputContent":"Enter content","Title_ChooseSceneType_VideoGenerateCard":"Select a content type and storyboard structure:","Button_ConfirmGenerate_VideoGenerateCard":"Start video generation","Title_ShotType_VideoGenerateModal":"Storyboard type","Title_ShotRequirement_VideoGenerateModal":"Storyboard description","Title_Duration_VideoGenerateModal":"Duration","Btn_AddOneTableRow":"Add","Label_Gender_ModelModal":"Gender","Label_Appearance_ModelModal":"Appearance","Label_AgeGroup_ModelModal":"Age group","Label_Persona_ModelModal":"Role","Label_BodyType_ModelModal":"Body type","Tips_GenerateModelFailed_ModelModal":"Generation failed. Please try again later.","Tips_NetworkError_ModelModal":"Network error. Try again later.","Tab_CustomModel_ModelModal":"Custom","Tab_OfficialModel_ModelModal":"Official","Tab_UploadModel_ModelModal":"Upload","Text_ModelPreview_ModelModal":"Preview","Button_Generating_ModelModal":"Generating...","Button_Regenerate_ModelModal":"Retry","Button_Generate_ModelModal":"Generate","Button_Saving_ModelModal":"Saving…","Button_SaveAndUse_ModelModal":"Save and use","Button_CreateNewModel_AgentLibList":"New model","Message_NotFilled_RequiredField":"${0} information is required","Title_ChooseSceneType2_VideoGenerateCard":"Select a storyboard structure","Title_ContentType_VideoGenerateCard":"Content type","Title_StoryboardStructure_VideoGenerateCard":"Storyboard structure","Text_Offical":"Official","Title_AboveTheFold_Main_HomeV2":"Make every product <br /> image <span>ready to sell</span>","Title_Designkit_Slogan":"Make every product image ready to sell","Button_StartFree_HomeV2":"Start Free","Title_AboveTheFoldMobile_Main_HomeV2":"Make every product <br /><span>ready to sell</span>  ","SubTitle_AboveTheFoldMobile_HomeV2":"From pro photo editing to automated listing generation, everything you need in one place.","Text_TopBanner_HomeV2":"Seedance 2.0 is coming soon with unlimited access","Title_ModuleCard_HomeV2":"First, Generate Winning Assets","SubTitle_ModuleCard_HomeV2":"No more empty canvases. Use our Intelligent Creative Suite of AI Agents to generate complete <br /> listing stacks, dynamic videos, virtual try-ons, and global adaptations in seconds.","Title_Faq_Q1_HomeV2":"Do you offer a free trial?","Text_Faq_A1_HomeV2":"Yes! New users receive 20 free credits instantly upon sign-up. Plus, you can claim 10 free credits every day just by logging in. This allows you to continually test all core features, including image and video generation, before upgrading to a paid plan.  ","Title_Faq_Q2_HomeV2":"Are the images compliant with Amazon/Shopify guidelines?","Text_Faq_A2_HOMEV2":"Absolutely. For main hero shots, our AI strictly outputs the pure white backgrounds (RGB 255,255,255) required by Amazon and Shopify. For lifestyle and social media images, it ensures perfect dimensions and high-resolution quality to keep your listings fully compliant and professional.","Title_Faq_Q3_HomeV2":"Can I use generated assets for commercial purposes?","Text_Faq_A3_HomeV2":"Yes. All images and videos generated on our paid plans are 100% royalty-free and fully cleared for commercial use. You own the rights to use these assets across your Shopify store, Amazon listings, social media ads, and any other marketing channels without restrictions.","Title_Faq_Q4_HomeV2":"How does batch generation and editing work?","Text_Faq_A4_HomeV2":"Batch processing is natively built into every feature of Designkit. Simply upload multiple images directly into the workspace. Whether you are generating new lifestyle backgrounds, removing original backgrounds, erasing unwanted objects, or upscaling resolution, you can apply your chosen action to the entire batch with a single click. This ensures perfectly consistent assets for your store while saving you hours of manual work.","Title_Faq_Q5_HomeV2":"What file formats do you support?","Text_Faq_A5_HomeV2":"Video outputs are available in MP4 format, optimized for social media and e-commerce websites.","Title_Questions_Main_HomeV2":"Frequently Asked Questions","Title_Scale_Main_HomeV2":"Ready to Scale?","SubTitle_Scale_HomeV2":"Join 10,000+ sellers automating their design workflow with Designkit.","Title_Evaluation_HomeV2":"Finally, Launch Faster & Sell More","SubTitle_Evaluation_HomeV2":"Cut production time by 90%. Get verified listings live on Amazon and Shopify before your competitors do.","Tab_Module_ProductImage_HomeV2":"AI Product Image","Desc_Module_ProductImage_HomeV2":"Turn one supplier photo into a complete listing stack instantly. Generate white-bg hero shots, lifestyle scenes, and infographics, while effortlessly batch-processing hundreds of SKUs and auto-translating text for global markets.","Tip_Module_ProductImage_HomeV2":"Generate an Amazon listing set for the pink headphone.","Tab_Module_ModelImage_HomeV2":"AI Fashion Model","Desc_Module_ModelImage_HomeV2":"No models? No problem. Visualize apparel on diverse AI models to boost click-through rates without booking expensive photoshoots.","Tip_Module_ModelImage_HomeV2":"Show this yellow-and-green suit on a 25-year-old female model.","Tab_Module_Video_HomeV2":"AI Product Video","Desc_Module_Video_HomeV2":"Bring your products to life. Generate dynamic product showcases, engaging AI spokesperson videos, and high-converting ads from just a text prompt or a single image. Capture attention and drive sales across e-commerce platforms and your social media.","Tip_Module_Video_HomeV2":"Generate a product video for this blue vase.","Tab_Module_DetailPage_HomeV2":"AI Product Detail Page","Desc_Module_DetailPage_HomeV2":"Create premium A+ content and seamless promotional banners for your online store in just minutes, no design skills required. Transform basic product photos into highly engaging layouts, and differentiate your listings from competitors effortlessly.","Tip_Module_DetailPage_HomeV2":"Generate a product detail page for the orange sofa.","Tab_Module_Photography_HomeV2":"AI Product Photography","Desc_Module_Photography_HomeV2":"Ditch generic stock photos. Place your products in unique, on-brand settings that resonate with US and EU markets.","Tip_Module_Photography_HomeV2":"Generate a photography background for this perfume.","Title_Module_SecondTitle_HomeV2":"Then, Perfect Details with AI Precision","SubTitle_Module_SecondSubTitle_HomeV2":"Assets generated? Now make them perfect. Use our AI Photo Editor to remove backgrounds, clean up defects, and upscale low-res images in bulk.","Text_Upload_HomeV2":"Upload","Text_TopBannerMobile_HomeV2":"Seedance 2.0 is coming soon","Text_Prompt1_HomeV2":"Generate a full Amazon listing image set.","Text_Prompt2_HomeV2":"Generate a model wearing this outfit.","Text_Prompt3_HomeV2":"Generate a product marketing video.","Text_Prompt4_HomeV2":"Generate an A+ Content product details page.","Text_Prompt5_HomeV2":"Generate appropriate backgrounds for product images.","Desc_Evaluation1_HomeV2":"Super fast! Images are instantly ready for Mercado Libre and Amazon. It adapts backgrounds and models to local tastes perfectly. Totally professional results.","Desc_Evaluation2_HomeV2":"Love Designkit! The AI lifestyle images are natural, cozy, and Nordic—perfect for my candle shop. My listings look polished and sales have increased. Worth it.  ","Desc_Evaluation3_HomeV2":"I sell clothing and was worried AI would ruin the textures. Designkit nailed it! Colors are perfect, model poses look natural, and images are instantly ready.","Header_products_socialMediaPostGenerator":"Social Media Post Generator","Pricing_Seedance_UnlockLimited":"Unlock Unlimited Access","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Early Access","Pricing_Seedance_SeedanceDesc":"Be the first to experience the power of Seedance 2.0. Subscribe to any Pro plan now and get exclusive unlimited access to our next-generation AI model.","Pricing_Seedance_Monthly":"Monthly Plan Bonus","Pricing_Seedance_DaysUnLimit":"  7 Days <span>Unlimited</span>","Pricing_Seedance_SeedanceV2":"Seedance 2.0 Access","Pricing_Seedance_BestValue":"BEST VALUE","Pricing_Seedance_Yearly":"Yearly Plan Bonus","Pricing_Seedance_MonthUnLimit":"1 Month <span>Unlimited</span>","Title_AIBrand_Tools":"✨AI Branding Tools","Title_AISocialMediaPosts":"AI Social Media Posts","Title_AILogoMaker":"AI LOGO Generator","Option_Child_Age":"Child","Option_Infant_Age":"Baby","Option_MiddleAged_Age":"Adult","Option_Senior_Age":"Elderly","Option_Teen_Age":"Teenager","Option_YoungAdult_Age":"Young adult","Button_GenerateImages_DetailPageAction":"Generate","Text_GenerateImagesCount_DetailPageAction":"(${0} images)","Text_GenerateImagesCount_DetailPageAction1":"(${0} image)","Option_MercadoLivre_Platform":"Mercado Livre ","Option_Etsy_Platform":"Etsy ","Option_Walmart_Platform":"Walmart ","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Create Product Page Design","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Mobile)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Accessories/Gifts","Option_ServiceSupport_DetailSection":"Warranty","Option_BeforeAfter_DetailSection":"Before & After","Option_BrandStory_DetailSection":"Brand Story","Option_KeyHighlights_DetailSection":"Key Selling Points","Option_CraftProcess_DetailSection":"Exploded View","Option_HeroVisual_DetailSection":"Key Art","Option_Composition_DetailSection":"Components","Option_MultiAngle_DetailSection":"Multi-Angle","Option_DetailCloseups_DetailSection":"Product Details","Option_SceneMood_DetailSection":"Lifestyle/Mood","Option_SeriesShowcase_DetailSection":"Product Series","Option_SizeCapacity_DetailSection":"Dimensions","Option_Specifications_DetailSection":"Spec Sheet","Option_UsageScenario_DetailSection":"Use Cases","Option_UsageTips_DetailSection":"Usage Guidelines","Paragraph_ServicePolicy_DetailSection":"Warranty, returns and exchange policy","Paragraph_BeforeAfter_DetailSection":"Results before and after use","Paragraph_BrandConcept_DetailSection":"Brand concepts and values","Paragraph_CoreValue_DetailSection":"Core value showcase","Paragraph_CraftProcess_DetailSection":"From drawing to reality","Paragraph_Differentiators_DetailSection":"Key advantage highlights","Paragraph_Composition_DetailSection":"Materials and components that go into the product","Paragraph_MaterialAndCraft_DetailSection":"Material and process highlights","Paragraph_MultiAngleAppearance_DetailSection":"Product looks from different angles","Paragraph_MultiOptionDisplay_DetailSection":"Multiple colors or SKUs","Paragraph_IncludedItems_DetailSection":"Everything included in the package","Paragraph_DetailData_DetailSection":"Detailed specifications","Paragraph_RealUsageScene_DetailSection":"Real-life use references","Paragraph_Specifications_DetailSection":"Size guide at a glance","Paragraph_UsageNotes_DetailSection":"Usage notes and precautions","Paragraph_UsageScenario_DetailSection":"Product in context","Title_Nav_DetailPage":"A+ Product Details","Title_ImageSet_DetailPage":"A+ Product Detail Image Set","Input_TaskName_Batch":"Enter task name","Paragraph_FullAssetSetDescription_Batch":"Includes a full set of marketing assets such as key art, use case images, and white-background images that can be used across multiple platforms.","Paragraph_LongFormVisualDescription_Batch":"Creates visual storytelling for long-form product images, A+ product detail pages, and comparison images.","Message_JsonGenerated_Batch":"Form verified. JSON generated.","Message_JsonCopied_Batch":"JSON copied.","Message_IncompleteRequiredFields_Batch":"Missing required fields. Please complete the form to submit.","Message_PleaseUploadSourceImage_Batch":"Please upload product images.","Message_PleaseCompleteStrategySettings_Batch":"Please complete strategy configuration","Message_TaskValidationFailed_Batch":"Please review and complete unverified tasks.","Message_CopyJsonFailed_Batch":"Copy failed. Please check JSON in the dashboard.","Message_PleaseEnterTitle_Batch":"Please enter title.","Message_PleaseEnterKeyHighlights_Batch":"Please enter product key selling points.","Message_PleaseGenerateJsonFirst_Batch":"Please submit to generate JSON.","Title_DetailPage_Batch":"Product Page A+","Title_DetailTask_Batch":"A+ Task ${0}","Title_IndependentParameters_Batch":"Configure individually","Title_ImageSet_Batch":"Ecommerce Image Set","Title_ItemTask_Batch":"Product Task","Option_Curvy_BodyType":"Curvy","Option_Muscular_BodyType":"Muscular","Option_PlusSize_BodyType":"Full-figured","Option_Slim_BodyType":"Slim","Option_Standard_BodyType":"Average","Button_Reset_Common":"Reset","Button_Back_Common":"Back","Button_Collapse_Common":"Collapse","Button_Expand_Common":"Expand","Button_Generate_Common":"Generate","Button_PreviousStep_Common":"Undo","Button_RemoveFavorite_Common":"Unfavorite","Button_StartNow_Common":"Try now","Paragraph_ExitWarning_Common":"Data will be lost if you exit.","Paragraph_Content1_VirtualModelDisclaimer":"2. Please understand what to expect from AI-generated content. AI-generated content is produced based on algorithms and data learning, and results may vary. The facial appearance generated by AI may differ from the original assets provided, and imperfections and unsatisfactory results may occur. Our platform does not guarantee the accuracy, visual quality, or suitability of the generated content.","Paragraph_Content2_VirtualModelDisclaimer":"3. Please acknowledge user responsibilities. You are responsible for the images containing faces and the content generated. You must ensure that your use does not infringe upon any third party\'s legal rights, including but not limited to rights of publicity, privacy, and reputation, and that it complies with all applicable laws and regulations. You shall not use the generated content for any purpose that is unlawful, infringing (such as defamation or fraud), or in violation of public order and morals or the dignity of others.","Paragraph_Content3_VirtualModelDisclaimer":"Please confirm that you fully understand and accept the terms above before uploading.","Title_Notice_VirtualModelDisclaimer":"Before using the AI Product Image-Virtual Try-On feature, please read and understand the following:","Message_FailedRetry_Download":"Download failed. Please try again later.","Message_Failed_Download":"Download failed.","Message_Success_Download":"Download complete.","Message_NoImagesAvailable_Download":"No image available.","Option_Asian_Ethnicity":"Asian","Option_Black_Ethnicity":"African","Option_Chinese_Ethnicity":"Chinese","Option_Latino_Ethnicity":"Hispanic or Latino","Option_MiddleEastern_Ethnicity":"Middle Eastern","Option_SoutheastAsian_Ethnicity":"Southeast Asian","Option_White_Ethnicity":"White","Option_Female_Gender":"Female","Option_Male_Gender":"Male","FormLabel_Ethnicity_Common":"Race and Ethnicity","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Language","FormLabel_TargetMarket_Common":"Market","FormLabel_TargetPlatform_Common":"Platform","Option_German_Language":"German","Option_Japanese_Language":"Japanese","Option_None_Language":"None","Option_Portuguese_Language":"Portuguese","Option_Russian_Language":"Russian","Option_Spanish_Language":"Spanish","Option_Thai_Language":"Thai","Option_Brazil_Market":"Brazil","Option_China_Market":"China","Option_Europe_Market":"Europe","Option_Germany_Market":"Germany","Option_Japan_Market":"Japan","Option_Russia_Market":"Russia","Option_SoutheastAsia_Market":"Southeast Asia","Option_Spain_Market":"Spain","Option_UnitedStates_Market":"USA","Message_MaxLimit_DetailSectionSelection":"Select up to ${0} sections","Option_FollowGlobalSettings_Common":"Use global settings","Text_MaxTasks_Batch":"Add up to ${0} task(s)","Text_MinTasks_Batch":"Keep at least one task","Text_MaxImagesPerTask_Batch":"Upload up to ${0} images per task","Text_SupportedImageFormats_Batch":"Supported image formats: JPG, JPEG, PNG, HEIC, and WebP.","Input_AppearanceDetailsExample_TryOn":"For example: tanned skin, straight-across bangs, a beauty mark near the corner of the eye...","Input_SourceInfoGuide_Batch":"For more accurate results, please include the following information:\\n1. Product name\\n2. Key selling points\\n3. Target audience\\n4. Intended use cases\\n5. Detailed specifications","Tooltip_OutputStyleConsistent_Clone":" Enabling it keeps all generated images consistent in color and style. Disabling it allows each image to follow the style of its own reference image.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa Indonesia","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Generate Image Set","Title_Nav_ImageSet":"Product Listing Images","Message_GenerateFailedRetry_ImageSet":"Generation failed. Please try again.","Message_PleaseSelectStyleFirst_ImageSet":"Please choose a style first.","Message_CreateTaskFailed_ImageSet":"Failed to create task","Title_StyleAnalysis_ImageSet":"Trending style analysis","Option_TrafficMaximization_TitleStrategy":"Maximize traffic","Option_ConversionPriority_TitleStrategy":"Conversion first","Option_SceneImmersion_TitleStrategy":"Immersive scenes","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extracting key features from assets...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Generating high-conversion keywords based on selling points...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Matching the best SEO strategies...","Text_GeneratingOptions_TitleGenerationStatus":"Generating multiple captions from different perspectives...","Message_TaskFailedWithStatus_TitleGeneration":"Task failed (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Request timed out. Please try again.","Message_GenerateFailed_TitleGeneration":"Failed to generate title. Please try again.","Message_QueryResultFailed_TitleGeneration":"Failed to retrieve task","Paragraph_Content_VirtualModelConsent":"1. Portrait rights authorization: This feature uses the images you upload that contain faces to generate virtual model faces using AI. You must ensure that you have the right of portrait of the images uploaded or have acquired explicit, valid written consent from the rights holder to use their portraits for this purpose and any generated content. If the image contains a minor, consent from their legal guardian is required.","Button_ConfirmTextChange_TextEdit":"Update","Input_ModifyText_TextEdit":"Edit Captions","Message_NoImagesAvailable_ResultDownload":"No images available for download","Message_Failed_TextRecognition":"Failed to recognize text","Text_Generating_ResultStatus":"Generating...","Option_CustomColor_SceneSetting":"Custom","Option_UseOriginalBackground_SceneSetting":"Use original background","Text_InsufficientCredits_Common":"Insufficient coins","Button_LoadMore_Common":"Load More","Text_ImageUploadLimit_Common":"Upload up to ${0} images","Text_AnalyzingTrend_Common":"Analyzing trends on ${0}","Text_ChineseOutputProOnly_Common":"Chinese text generation is available on Pro only. Text has been removed from the current result.","Text_SourceImageUploadLimit_Common":"Upload up to ${0} images","Text_WritingInProgress_AiWriting":"Processing...","Text_DeepThinking_AiWriting":"Deep thinking...","Text_ThinkingProcess_AiWriting":"Thought Process:","Text_ImageSelectionLimit_Common":"Select up to ${0} images","Message_RegenerationSubmitted_Regeneration":"Regeneration submitted. Please refresh to view the results later.","Button_MoreEditOptions_ResultEditor":"More","FormLabel_DetailSection_DetailPage":"Product Detail Section","Message_GeneratePlanFailed_DetailPagePlan":"Failed to generate plan","Message_PlanGenerationFailed_DetailPagePlan":"Failed to generate plan","Text_PlanUnavailable_DetailPagePlan":"No plan available","Message_SourceImageMissing_Common":"Product image missing","Message_GenerationFailed_Common":"Generation failed","Paragraph_ConfirmDiscardChanges_Common":"Your changes will be lost if you go back. Are you sure you want to go back?","Message_ProcessFailed_Common":"Failed","Text_GeneratingEllipsis_Common":"Generating...","Text_StyleGenerationInProgress_ImageSet":"Generating trending styles...","Message_FavoriteAdded_Common":"Added to Favorites","Message_FavoriteRemoved_Common":"Removed from Favorites","Text_LoadingPlain_Common":"Loading","Text_MultiSelectAvailable_Common":"Select multiple","Text_NoData_Common":"No data available","Text_NoDataAvailable_Common":"No data","Text_NoMoreResults_Common":"No more content","Message_PleaseEnterKeyHighlights_DetailPage":"Please enter key selling points","Message_PleaseSelectAiModel_TryOn":"Please select an AI model","Message_SelectSectionMin_DetailPage":"Please select at least ${0} sections","Message_SelectScenePoseMin_TryOn":"Please select at least ${0} scenes and postures","Message_PleaseSelectBaseModel_TryOn":"Please select a base model","Message_PleaseSelectCustomModel_TryOn":"Please select a custom model","Message_PleaseSelectModel_TryOn":"Please select a model first","Message_PleaseSelectSection_DetailPage":"Please select a section","Message_SelectUploadCustomModel_TryOn":"Please select or upload a model image","Message_PleaseSelectScene_TryOn":"Select a scenario","Message_PleaseSelectStrategy_DetailPage":"Please select a strategy","Message_PleaseUploadGarmentImage_TryOn":"Please upload a clothing image","Message_UploadGarmentFile_TryOn":"Please upload a clothing image","Message_PleaseUploadSourceImage_Common":"Please upload product pictures first","Message_PleaseUploadItemImage_Common":"Please upload a product image","Message_UploadItemFirst_Common":"Please upload product pictures first","Message_RegenerateFailedWithReason_Regeneration":"Failed to regenerate:","Message_SelectResultImages_Result":"Please select an image with generated results","Text_ReleaseToRefresh_Common":"Release to refresh","Message_TextRecognitionFormatInvalid_TextRecognition":"Invalid format recognized","Message_TextRecognitionParseFailed_TextRecognition":"Failed to parse recognition results","Message_TextRecognitionTaskFailed_TextRecognition":"Failed to recognize text","Message_QueryTaskStatusFailed_TextRecognition":"Failed to retrieve task status","Message_SubmitTaskFailed_TextRecognition":"Failed to submit text recognition task","Text_RegenerationProcessing_Regeneration":"Regeneration request submitted. Processing...","Message_RegenerateFailedRetry_Regeneration":"Failed to regenerate. Please try again later.","Message_OpenEditorFailed_ResultEditor":"Failed to open editor","Message_RegenerateFailed_Regeneration":"Failed to regenerate","Message_RefreshFailedRetry_Common":"Failed to refresh. Please try again.","Message_UploadGarmentSelectModel_TryOn":"Please upload a clothing image and select a model","Message_PollingTimedOut_Common":"Query timed out","Title_KeyHighlights_DetailPage":"Key Selling Points","Title_FullStrategyGuide_DetailPage":"Full Strategy & Design Guidelines","Title_IncludedSections_DetailPage":"Sections","Title_IncludedSectionsMultiple_DetailPage":"Sections (Select multiple)","Title_ModelSelection_TryOn":"Select Model","Title_SectionContent_DetailPage":"Section Content","Title_SectionStrategyGuide_DetailPage":"Section Strategy & Design Guidelines","Title_OutputAspectRatio_Common":"Aspect Ratio","Title_OutputSpecification_Common":"Specifications","Title_SelectModel_TryOn":"Select model","Title_SelectScene_TryOn":"Select a scene","Title_StrategySettings_DetailPage":"Strategy","Title_UploadAssets_Common":"Upload","Button_GenerateBaseModel_TryOn":"Generate base model","Button_GenerateRecommendedScenes_TryOn":"Generate recommended scene","Button_GenerateSceneImages_TryOn":"Generate (${0} images)","Text_GeneratingBaseModel_TryOn":"Generating base model...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Full-body","Option_HalfBody_Framing":"Half-body","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"AI Try-On","Option_Ai_TryOnModelMode":"AI Generated","Title_Nav_TryOn":"Try-On","Option_Back_Perspective":"Back","Option_Front_Perspective":"Front","Option_Side_Perspective":"Side","Option_ThreeQuarterSide_Perspective":"3/4 View","Input_AppearanceDetailsHint_TryOn":"Appearance details: tanned skin, straight across bangs, a beauty mark near the corner of the eye…","Message_SaveToAlbumSuccess_Common":"Saved to album","Text_GeneratingSceneImages_TryOn":"Generating scene images...","Message_RefreshFailed_Common":"Failed to refresh","Message_FailedRefunded_Generation":"AI design failed. The credits have been refunded.","Title_BaseModelImage_TryOn":"Base Model Image","Title_CustomModel_TryOn":"Custom Model","Paragraph_Intro_TryOn":"Upload a clothing image and customize your model to generate a variety of scenes and postures.","Title_UploadGarmentImage_TryOn":"Clothing image","Tips_UploadFailedPure":"Failed to upload","Tips_Uploading":"Uploading...","Text_UploadNewModel":"New model","Text_AllBackgrounds":"All Backgrounds","Text_DefaultTemplateScene":"Default","Text_ColorScene":"Colors","Text_SameProductMax_Common":"Up to ${0} image(s) per product","Text_Max_Common":"Up to ${0} image(s)","Button_Generate_ImageClone":"Start Generating","Button_RefreshStyle_Common":"Refresh","Button_Favorite_Common":"Favorite","Text_PreviewLargeImage":"Full preview","Text_BaseImage":"Benchmark","Button_BatchDownload_Common":"Batch download","Button_BatchEdit_Common":"Batch edit","Button_BatchWatermark_Common":"Add watermark","Text_GeneratedResults":"Results","Button_DownloadAllImages_Common":"Download all","Text_NoGeneratedResults":"No results yet","Text_SameProductMax_TryOn":"A full outfit or multiple angles of the same item, up to ${0} images.","Title_AdvancedImageGenerationModel":"Premium Image Model","Text_SupportChineseOutput_Common":"Supports Chinese output and provide better aesthetic details and greater creative control.","Text_SelectMultipleModules_DetailPage":"Select multiple sections to generate a full product detail page","Button_CollapseAll_Common":"All","Label_AppearanceDetails_TryOn":"Appearance Details (Optional)","Text_WaitingForGeneration_TryOn":"Pending generation","Title_SmartTitleAI_ProductTitle":"Generate Viral Headlines","Message_ResultMissing_TitleGeneration":"${0} missing in AI-generated results","Message_InvalidJSONFormat_TitleGeneration":"Invalid result returned","Message_InvalidJSONFormat_TitleGeneration1":"Invalid JSON format returned","Text_AutoGeneratedTitleScheme_ProductTitle":"Here are the auto-generated titles based on your product","Text_SelectBestTitle_ProductTitle":"Pick a title that sells and click to copy","Button_Copy_Common":"Copy","Message_PleaseUploadImage_Common":"Please upload an image first","Text_DeepThinking1_AiWriting":"DeepSeek is working on it...","Button_Rewrite1":"Retry","Text_TotalImages_Common":"Count: ${0}","Text_EditText_ResultEditor":"Edit text","Text_NoTextRecognition_ResultEditor":"No text detected","Text_PreviewLongImage_ResultGroup":"Long image preview","Text_LimitFree":"Flash Deal","Text_UploadSameProductTip1":"1. Upload multiple images of the same product from different angles to help AI better capture product details.","Text_UploadSameProductTip2":"2. Up to 3 images. The first image will be used as the primary reference, so please choose the most best angle.","Text_UploadProductImage_APlusCase":"Upload product image","Text_GenerateEcommerceLongImage_APlusCase":"Generate long image","Text_MultiPlatform_APlusCase":"Compliant with multiple ecommerce platform standards","Text_MainImage_ProductCase":"01 Header Image (White background/Standard)","Text_SceneDisplay_ProductCase":"02 Use Case Scenarios","Text_ModelSceneImage_ProductCase":"03 Model Images","Text_DetailDescription_ProductCase":"04 Details","Text_FeatureExplanation_ProductCase":"05 Selling Points","Text_UploadProductImage_ProductCase":"Upload product images and AI will instantly generate high-converting image sets <span>that are compliant with multiple ecommerce platform standards</span>.","Text_UploadGarmentImage_TryOn":"Upload clothing images and create your custom model to instantly generate multiple scenes and postures.","Text_UploadProductImage_DetailPage":"Upload product images and AI will instantly generate a professional product detail page <span>that are compliant with multiple ecommerce platform standards</span>.","Title_DetailPage_ProductCase":"A+/Product Detail Page","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Log in to unlock your free trial","Login_DK_Title":"Create stunning designs for Free","Login_Zawa_Des":"Start creating with Zawa today","Login_DK_Des":"Sign up or log in to keep designing. Start now!","Tab_Module_ProductImage_TryOn_MultiMix":"Style pieces into one outfit","Tab_Module_ProductImage_TryOn_SingleHero":"From one piece to a complete look","Tab_Module_ProductImage_TryOn_Accessories":"Perfect accessory styling","Text_ShowAdvancedModelTip":"Show premium model tips","Text_HideAdvancedModelTip":"Hide premium model tips","Text_DeepSeekR1HelpWrite":"Help me write (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Exceeded maximum attempts ${0}","Title_StandardEdition":"Standard","Text_FastAndEfficient_Common":"Fast and Efficient","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Enhanced Quality and Details","Text_PremiumEngineActivated":"<strong>Premium engine activated:</strong> Supports Chinese output and provide better aesthetic details and greater creative control.","Text_EditBrand_DropTitle1":"Drag and drop JPG, PNG, or WEBP files here,","Text_EditBrand_DropTitle2":"or <>browse</> from your computer.","Text_BaseToolbar_AlignTop":"Top Align","Text_BaseToolbar_AlignBottom":"Bottom Align","Text_LayerSort":"Order","Text_BaseToolbar_AlignCenter":"Center","Text_Attr_Strong":"Bold","Text_GeneratingPlan_DetailPagePlan":"Generating plan...","Text_PlanGenerationFailed_ReTry":"Failed to generate plan. Please try again later.","Button_StartAnalyze_ProductCase":"Let\'s Start","Message_SubmitSuccessTip_Batch":"Submitted","Button_ClickAnalyze_ProductCase":"Analyze bestseller styles","Button_StartAnalyzing_ProductCase":"Analyzing","Title_ModelImage":"Model","Text_Cookie_Title":"First things first, cookies 🍪","Text_Cookie_Content":"We would like to use cookies on this website to ensure security, efficient performance, and service optimization. To learn more about how we use cookies, please click ","Text_Cookie_LearnMore":"Details","Button_Cookie_Manage":"Manage Cookies ","Button_Cookie_Accept":"Accept","Text_CookieModal_Title1":"Cookie Settings","Text_CookieModal_Desc1":"Cookies are small text files that websites store on your device to help us remember your preferences, track website traffic, and improve our services. Your privacy is important to us, and we want you to be in control of your data. Here, you can customize your cookie preferences to optimize your browsing experience. Please note that changing cookie settings may affect the functionality and services of our website.","Text_CookieModal_Title2":"Necessary Cookies","Text_CookieModal_Desc2":"These cookies are essential for the website\'s functionality, security, and core performance. Without them, key features and security measures of Zawa will not function properly, which may adversely affect your experience.","Text_CookieModal_Title3":"Optional Cookies","Text_CookieModal_Desc3":"These cookies help us understand the number of Zawa users, where they come from, and how they use the website. If you choose to disable these cookies, we will not be able to collect feedback to improve Zawa or to provide better services for you and other users.","Button_CookieModal_Save":"Save","Text_CookieModal":"Always Active","Text_Agent_Chat_DK":"Type your idea…","Text_Agent_Chat_XD":"What would you like to design","Radio_Color":"Palette","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Background","Language_Banner_Message":"Would you like to switch to ${0}?","Language_Banner_Change":"Yes","Language_Banner_Other":"More languages","Title_ItemTaskWithIndex_Batch":"Product Task ${0}","Title_DetailTaskPrefix_Batch":"A+ Task","Text_CopiedTaskTitle_Batch":"${0} (Copy)","Message_SelectSectionMin_Batch":"Please select at least one section.","Title_GlobalBatchSettings_Batch":"Global settings (Apply to the following tasks)","Text_Parameters_Batch":"Parameters","Text_Modules_Batch":"Sections","Title_KeyHighlights_Batch":"Selling Points","Text_ModulesFollowGlobal_Batch":"Sections - Use Global Settings","Title_SelectManagedBusinessType_Batch":"Select Task Type","Button_SubmitTask_Batch":"Submit","Text_NewTaskCurrentCount_Batch":"Create Task","Title_NotificationSettings_Batch":"Notifications","Title_ManagedMode_Batch":"Scheduler","Button_SaveSettings_Batch":"Save settings","Button_SaveAndContinueSubmit_Batch":"Save & submit","Message_PhoneFormatInvalid_Batch":"Please enter a valid 11-digit phone number.","Message_VerificationCodeSent_Batch":"Verification code sent. The code is valid for 5 minutes.","Message_VerificationCodeSendFailed_Batch":"Failed to send. Please try again later.","Message_PleaseEnterCode_Batch":"Please enter the verification code.","Message_GetCodeFirst_Batch":"Please first get a verification code.","Message_VerificationCodeExpired_Batch":"Verification code expired. Please request a new one.","Message_SaveNotificationSettingsFailed_Batch":"Failed to save notification settings. Please try again later.","Text_WebMessageNotification_Batch":"Web Notifications","Title_AppPushRecommended_Batch":"App Notifications (Recommended)","Paragraph_AppPushDesc_Batch":"Track progress and see results on your phone in real time. Keep your designs at your fingertips and never miss out on any opportunity.","Text_AppDownloadQrCode_Batch":"Scan to download the app","Title_SmsNotification_Batch":"SMS Notifications","Placeholder_Phone11Digits_Batch":"An 11-digit phone number","Placeholder_VerificationCode5Min_Batch":"Verification code (valid for 5 minutes)","Text_SendingEllipsis_Batch":"Sending...","Text_RetryAfterSeconds_Batch":"Try again in ${0}s","Button_GetVerificationCode_Batch":"Send Code","Message_SubmitSuccess_Batch":"Submitted","Message_SubmitFailedRetry_Batch":"Failed to submit. Please try again later.","Message_FormValidationPassed_Batch":"Valid content","Message_CompleteNotificationSettingsFirst_Batch":"Please set up notifications before submitting the task.","Paragraph_CancelManagedTaskWarning_Record":"The scheduled task will be removed permanently if you cancel now.","Button_ConfirmCancel_Record":"Cancel anyway","Message_CancelManagedTaskFailed_Record":"Failed to cancel. Please try again later.","Text_WaitingManagedGeneration_Batch":"Scheduling task...","Text_WaitingManagedSubmit_Batch":"In queue","Message_NoExtendableImages_Result":"No images available","Text_IntelligentMultiSizeAdaptation_Result":"Smart resize your images to fit every screen","Button_IntelligentResize_Result":"Smart Resize","Option_CustomSize_DetailPageMode":"Custom","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Scheduler is ready to help!","Text_ManagedModeSlogan_Batch":"Works overnight to have your designs ready when you wake up.","Title_BatchProduction_Batch":"Batch Generation","Paragraph_BatchProductionDesc_Batch":"Runs up to ${0} tasks simultaneously and boosts your productivity by ${1}×.","Title_AiIntelligentExtraction_Batch":"AI Analysis","Paragraph_AiIntelligentExtractionDesc_Batch":"Analyzes your images and automatically generates high-converting selling points.","Title_SaveCost20_Batch":"Save ${0}% on credits","Paragraph_SaveCost20Desc_Batch":"You can schedule tasks at night and enjoy discounted credit usage.","重写":"Batch Download","Brand_AutoExtract_Button":"Palette Extractor","Brand_AutoExtract_Success":"Palette extracted","Brand_AutoExtract_Failure":"Failed to extract color palette. Please try again.","Brand_AutoExtract_Unavailable":"Unable to extract color palette.","Brand_AutoExtract_ConfirmTitle":"Extract color palette from logo?","Title_ImageSetConfig_ImageSet":"Listing Design","Title_DefaultConfig_ImageSet":"AI Design","Desc_DefaultConfig_ImageSet":"Let AI generate the best listing design for your product.","Title_CustomConfig_ImageSet":"Custom Design","Desc_CustomConfig_ImageSet":"Customize the number of images for each type. Please select at least ${0} images.","Label_WhiteBackground_ImageSet":"White Background Images","Desc_WhiteBackground_ImageSet":"Showcase your product from multiple angles on a white background.","Label_Scene_ImageSet":"Lifestyle Scenes","Desc_Scene_ImageSet":"Present your product in real-life scenarios.","Label_SellingPoint_ImageSet":"Selling Point Highlights","Desc_SellingPoint_ImageSet":"Emphasize the key features that make your product stand out.","Label_Other_ImageSet":"Other","Desc_Other_ImageSet":"Auto-curated content for your product, including comparisons, specs, and more.","Tip_MinTotal_ImageSet":"At least ${0} images","Text_ManagedBatchEntry_Header":"Scheduler","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Credit Plan","Text_Higher_Plan":"Already on a Higher Plan","Text_Try_Free":"Try Now for $0","Text_Plus_Plan":"Plus Plan","Text_Pro_Plan":"Pro Plan","Button_Generate_Short_Common":"Generate","Message_DuplicateTaskSubmitConfirm_Common":"Results already generated with these settings. Generate again?","Text_CreditUnit_Common":"Credit","Text_NewUserDiscountDesc_Product":"${0} credits for the first listing. ${2} credits for each additional ${1} listings.","Text_NewUserLimitedTag_Product":"New User Discount","Text_OriginalPrice_Product":"Original: ${0} credits","Tip_MaxTotal_ImageSet":"Up to ${0} images","Text_AddDocumentTips":"Word, Excel, Text, PDF and Markdown files are supported","Tab_SolidColor":"Solid Color","Tab_Gradient":"Gradient","Title_PresetGradient":"Presets","Title_PresetSolidColor":"Presets","Title_RecentlyUsed":"Recently used","Title_Patterns":"Pattern","Title_NoFill":"None","Description_Brand_Reference":"Upload your favorite posters or art assets and Zawa will use the style to create designs tailored to your taste.","Text_Generating":"Generating...","Text_ChartSending":"Submitting","Text_PeopleUnSupport":"Portrait mode is not supported yet","Button_CancelManagedBatch_ResultGroup":"Cancel task","Button_DownloadZip_ResultGroup":"Download ZIP","Button_DownloadLongImage_ResultGroup":"Download combined","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"Submitted task cannot be canceled","Button_GlobalAiWriting_Batch":"AI Writing","Text_StandardModel_DistributionBatch":"Standard Model (Bulk Listing)","Text_StandardModelDescription_Batch":"Best for high-volume SKUs to maximize market reach.","Text_AdvancedModel_PremiumBatch":"Advanced Model (Targeted Listing)","Text_AdvancedModelDescription_Batch":"Premium quality images that are best for precision-driven profitability.","Message_MinSubmitTasks_Batch":"Submit at least ${0} tasks.","Message_OverwriteSellingPointsConfirm_Batch":"The selling point section has been filled in ${0} tasks. How would you like to apply AI writing results?","Button_OverwriteAll_Batch":"Replace all","Button_FillEmptyOnly_Batch":"Incomplete only","Message_NoEmptySellingPointsToFill_Batch":"Selling points for all tasks are already complete.","Message_AiWritingFailedRetry_Batch":"AI writing failed. Please try again later.","Button_NewTask_Common":"New task","Message_Generating_Time":"Your tasks will run overnight (${0}-${1}). Come back tomorrow to check the results.","Title_Total_Credits":"Total credits","Text_Used_AllFeatures":"Applicable to all features","Daily_Present_Credits":"Use-today credits","Daily_Credits_Desc":"Claim daily. Valid till the end of the day.","Text_Inactive":"Inactive","Text_Inactive_Monthly":"${0} credits will expire within the next 30 days","TITLE_GUIDE_CUTOUT_LITE":"Stamps or logos detected","GUIDE_DESC_CUTOUT_LITE":"Use Stamp/Logo Cutout for precise cutout","GUIDE_ACTION_CUTOUT_LITE":"Stamp/Logo Cutout","TITLE_CUTOUT_LITE":"Stamp/Logo Cutout","TIP_CUTOUT_LITE":"Accurate cutouts of stamps or logos","PROCESSING_CUTOUT_LITE":"Generating images...","AFTER_CUTOUT_LITE":"Results","Button_Previous":"Previous","Button_Next":"Next","Button_Skip":"Skip","Button_Apply":"Apply","Text_AgentExpert":"Expert","Message_PleaseEnterLinkOrAsin_Clone":"Enter a link or ASIN","Message_LinkAnalyzeFailed_Clone":"Link analysis failed","Message_UploadProductImageFirst_Clone":"Please upload product images first","Message_ProductImageThumbGenerateFailed_Clone":"Thumbnail generation failed. Upload again.","Message_UploadProductImageFirst_ProductCase":"Please upload a reference image or paste a product link","Message_ReferenceImageThumbGenerateFailed_Clone":"Thumbnail generation failed. Upload again.","Title_ReferenceSource_Clone":"Reference","Option_LinkAsin_Clone":"Link","Input_PasteProductLinkOrAsin_Clone":"Paste an Amazon link","Button_Parsing_Clone":"Analyzing...","Button_Parse_Clone":"Analyze","Text_SupportAmazonTiktokLinks_Clone":"Amazon and TikTok links are supported","Text_Cloning_ResultStatus":"Processing...","Input_CloneRequirementOptional_Clone":"Requirements (Optional)","Title_ProductOriginalImage_Clone":"Product Image","Title_CloneLevel_Clone":"Fidelity","Option_CompositionReference_Clone":"Style","Desc_CompositionReference_Clone":"Use the style and composition to automatically adjust colors and rebuild the scene.","Option_HighFidelityClone_Clone":"Overall Visual","Desc_HighFidelityClone_Clone":"Use the overall visual composition. Replace only the product and text while allowing for subtle variations in the scene.","Label_OutputStyleConsistent_Clone":"Consistent Style","Title_SupplementaryNotesOptional_Clone":"General Requirements (Optional)","Input_SupplementaryNotesExample_Clone":"Example: Generate English product copy, keep the same model, and replace only the product.","Title_HotClone_Welcome":"Clone and Create","Text_HotCloneDescription_Welcome":"Winning Layouts + Your Products = Your Next Bestseller","Text_DefaultTaskName_Clone":"Image Clone Strategy","Label_ProductImage_CloneCase":"Product Image","Label_ReferenceComposition_CloneCase":"Style","Label_HighFidelityClone_CloneCase":"Overall Visual","Tag_AiSmartMatch_ImageSet":"AI intelligent matching","Title_Date":"Date","Title_Topic":"Theme","Button_Replace":"Replace","Title_SingleCloneRequirement_Clone":"Individual Requirements","Text_UploadedReferenceImagesTip_Clone":"Individual requirements for each reference image. Default settings will be applied if requirements are not specified.","Label_ReferenceImageIndex_Clone":"Reference image ${0}","Option_Mexico_Market":"Mexico","Text_ParsingReferenceImages_Clone":"Analyzing...","Text_ParseReferenceImagesSuccess_Clone":"Analysis complete. ${0} reference images obtained.","Text_Renew_Restore":"The credits will be restored once your subscription is renewed.","Title_UsageNotice_Clone":"User Guide","Text_UsageNoticeDescription_Clone":"Please confirm that you have the legal right to use the content of this link. Generated results are based on AI style analysis and are for creative reference only.","Label_ReadAndAgreeUsageNotice_Clone":"I accept the above terms","Label_DoNotShowAgain_Clone":"Do not show this again","Brand_StatusPopup_ProcessingTitle":"Zawa is learning your brand style...","Brand_StatusPopup_FailedTitle":"Failed to extract data from Square. Try again later.","Brand_StatusPopup_Retry":"Try again","SecondTitle_Header19_Home":"Clone Video Ads","SquareBrandGuide_BrandKitCreatedTip":"Your brand kit has been created based on Square data","SquareBrandGuide_DefaultPrompt":"Design a product poster for social media promotion","SquareBrandGuide_SendTip":"Click Send to get started!","Paragraph_BatchProductionDescUnlimited_Batch":"Handles multiple tasks simultaneously, drastically cutting down your project timelines.","Menu_ViewDetail":"Details","Menu_CopyFullText":"Copy all","Tip_CopiedToClipboard":"Copied to clipboard","Tip_CopyFailed":"Copy failed","Menu_DownloadImage":"Download","Tip_NoImage":"No images","Tip_DownloadStarted":"Download in progress","Menu_CopyText":"Copy","Tip_NoTextToCopy":"No text available","Message_LinkImageFetchFailed_Clone":"We couldn\'t load images from this link. Try a different link or upload the images instead.","Tab_Chat":"Chat","Tab_Files":"Files","Button_Create_New_Chat":"New chat","Tip_Agent_Team_Chat_Shared":"Viewing read-only version","RoboNeo_Web_input_default_content":"Chat with RoboNeo","RoboNeo_Web_chatbox_maximum":"Chat limit reached","RoboNeo_Web_chatbox_maximum_text":"Chat limit reached. Create a new task.","RoboNeo_Web_chatbox_new_task":"New project","RoboNeo_Web_history_share_text":"Share","RoboNeo_Web_history_delete_text":"Delete","RoboNeo_Web_history_delete_hint_text":"Note","RoboNeo_Web_history_delete_main_text":"Project will be permanently deleted. Continue?","RoboNeo_Web_history_delete_hint_confirm":"Delete","RoboNeo_Web_history_delete_hint_cancel":"Cancel","RoboNeo_Web_studio_download":"Download","RoboNeo_Web_toast_share_text":"Share this chat","RoboNeo_Web_toast_share_main_text":"Anyone with the chat link can view your chat history","RoboNeo_Web_toast_share_copy":"Copy link","RoboNeo_Web_toast_cancel":"Cancel","RoboNeo_Web_toast_confirm":"Confirm","RoboNeo_Web_studio_changing_toast":"No free uses left for today. This will reset by midnight. You can also feed \\"Cyber Carrots\\" to Neo to continue.","RoboNeo_Web_studio_changing_toast2":"No free uses left for today.","RoboNeo_Web_new_studio":"New chat","RoboNeo_Web_sidebar_close":"Collapse","RoboNeo_Web_history_text":"History","RoboNeo_Web_sidebar_open":"Expand","RoboNeo_Web_upload_warning_text":"Cannot upload pictures and videos at the same time.","RoboNeo_Web_upload_format_text":"Supported image formats: JPG, PNG, and JPEG. Supported video formats: MP4 and MOV.","RoboNeo_Web_upload_fail_text":"Failed to upload","RoboNeo_Web_upload_image_maximum":"You can upload up to {max_num} images ","RoboNeo_Web_upload_video_size_maximum":"Videos larger than {max_size} MB are not supported.","RoboNeo_Web_upload_image_size_maximum":"Images above {max_size} MB are not supported.","RoboNeo_Web_upload_video_maximum":"You can upload up to {max_num} videos","RoboNeo_Web_history_dafult_text":"No history found, chat now.","RoboNeo_Web_upload_content_warning_text":"Files with potentially inappropriate content will not be imported.","RoboNeo_Web_chat_send_fail":"Sending failed, please try again later.","RoboNeo_Web_network_fail":"Connection failed or timed out, please try again. ","RoboNeo_Web_studio_layer_fail":"Failed to split layers.","RoboNeo_Web_studio_layer_success":"Completed","RoboNeo_Web_network_error":"Network error","RoboNeo_Web_delete_success":"Deleted","RoboNeo_Web_delete_fail":"Delete failed","RoboNeo_Web_copy_success":"Copied","RoboNeo_Web_file_uploading":"Uploading {num} files","RoboNeo_Web_file_upload_fail":"Error uploading {num} files","RoboNeo_Web_file_upload_single_fail":"Error uploading 1 file","RoboNeo_Web_file_uploading_single":"Uploading 1 file","RoboNeo_Web_upload_video_maximum_one":"You can upload up to 1 video","RoboNeo_Web_sharepage_wanna_try":"Try Now","RoboNeo_Web_sharepage_load_to_end":"Go to Results","RoboNeo_Web_studio_loading_text":"Loading canvas...","RoboNeo_Web_chatbox_add_image":"Add images","RoboNeo_Web_chatbox_add_video":"Add video","RoboNeo_Web_image_editor_max":"Max 10MB with 4096px on the longest side","RoboNeo_Web_unlimited_pass_expired":"Unlimited Pass expired. Using available free uses now.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - completed ","RoboNeo_Web_studio_ai_image_failed":"AI UHD - failed","RoboNeo_Web_studio_cutout_successful":"Cutout successful","RoboNeo_Web_studio_cutout_failed":"Cutout failed","RoboNeo_Web_studio_ai_edit_failed":"AI Editing - failed","RoboNeo_Web_studio_ai_edit_successful":"AI Editing - completed","RoboNeo_Web_AI_generated":"AI Result","RoboNeo_Web_loading":"Loading","RoboNeo_Web_view_creative_process":"View Creative Process","RoboNeo_Web_try_now":"Try Now","RoboNeo_web_extender_successful":"AI Extender - completed","RoboNeo_web_extender_failed":"AI Extender - failed","RoboNeo_web_eliminate_successful":"AI Removal - completed","RoboNeo_web_eliminate_failed":"AI Removal - failed","roboneo_web_continue":"Continue","roboneo_web_video":"Video","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"This chat cannot be shared, try starting a new one.","roboneo_web_open_the_APP_experience":"Try in app","roboneo_web_AI_generated_logo":"This AI-generated content is for reference only.","roboneo_web_change_word_success":"Replace Text - completed","roboneo_web_change_word_fail":"Replace Text - failed","roboneo_web_canvas_loading_failed":"Loading canvas failed","roboneo_web_export_failed":"Export failed","roboneo_web_export_tips2":"Only supports exporting one image (up to {width}px*{height}px).","roboneo_web_new_topic":"New chat","roboneo_web_waiting_reply":"Waiting for response","roboneo_web_file_saving_preferences":"File preference","roboneo_web_includes_AI_watermark":"Include AI watermarks","roboneo_web_no_remind":"Don\'t show again","roboneo_web_agree_continue":"Agree and continue","roboneo_web_AI_generated":"Content generated by AI","roboneo_web_watermark_protocol":"You may choose to save the images with or without \\"AI result\\" watermarks. Choosing to save without the watermark means you agree to: 1. Not use RoboNeoAI to create, publish, or spread false information. 2. Ensure law compliance and clearly indicate such content as AI-generated when using or sharing it.","roboneo_web_rectangle":"Square","roboneo_web_circle":"Round","roboneo_web_arrow":"Arrow","roboneo_web_image_fusion_success":"Completed","roboneo_web_image_fusion_failure":"Failed","roboneo_chat_resources_num_limit_tips":"You can add up to {img_num} video and {video_num} images.","RoboNeo_Web_export_confirm_tip_popup_title":"You can choose whether to export with an \\"AI-generated\\" watermark.","RoboNeo_Web_export_confirm_tip_popup_btn":"Got it."}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-next/es.json
const x_design_locales_next_es_namespaceObject = JSON.parse('{"Tab_Design":"Diseño","Button_Send":"Enviar","Input_Describe_Workspace":"Describe tu imagen y la crearé por ti","Tab_AgentCase":"Caso de Agente","Tab_RecentCreations":"Recientes","Tag_Hot":"Tendencias","Tag_BrandDesign":"Diseño de marca","Tag_Logo":"Logotipos","Tag_Posters":"Pósteres","Tab_Agent":"Agente","Tool_AiPhotoEditor":"Editor de imagen","Button_Upload":"Subir","Tool_Designer":"Diseñador","Title_AiTool":"Herramientas de IA","Tool_ImageBackgroundRemover":"Eliminador de fondos con IA","Tool_AiBackgroundGenerator":"Generador de fondos con IA","Tool_ImageEnhancer":"Mejorador de imagen","Tool_AiObjectsRemover":"Borrador de objetos con IA","Tool_AiModelMannequin":"Modelo de IA: Maniquí","Tool_AiModelFlatlay":"Modelo de IA: Flatlay","Tool_AiImageRecolor":"Recolorear imágenes con IA","Tool_AiImageExtender":"Ampliador de imagen con IA","Tool_ImageUpscaler":"Refinador de imágenes con IA","Tool_AiLogo":"Generador de logotipos con IA","Button_BlankCanvas":"Crear","Sidebar_Create":"Inicio","Sidebar_Tools":"Herramientas de IA","Sidebar_Batch":"Editor por lotes","Sidebar_MyDesigns":"Mis diseños","Sidebar_Inspire":"Inspírame","Sidebar_Brand":"Kit de marca","Sidebar_PackUp":"Cerrar barra lateral","Tag_All":"Todo","Tag_Design":"Diseño","Sidebar_Unfold":"Abrir barra lateral","Menu_Edit":"Editar","Menu_Download":"Descargar","Menu_Delete":"Eliminar","Tab_RecentlyCreated":"Recientes","Tab_GenerateRecords":"Creaciones","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Solo para el Agente de IA y se usarán primero.","Menu_DueToday":"Créditos de bonificación diarios","Menu_DueToday_Explain":"Válidos hasta el final del día.","Menu_Else_AgentCredits":"Otros créditos","Button_GoPro_GetMore":"Obtén más créditos","Menu_Total_Explain_PaidCredits":"Para todas las funciones, válidos durante la vigencia de la membresía.","Menu_Pro":"Créditos de suscripción","Menu_Pro_Explain":"Válido durante la vigencia de la membresía.","Menu_Else":"Otros créditos","Menu_Else_Explain_PaidCredits":"Créditos de otras fuentes. Cada tipo puede tener su propio vencimiento.","Menu_Else_Explain_AgentCredits":"Créditos de otras fuentes. Válidos por más tiempo.","Menu_UsageDetail":"Detalles de uso","Menu_Total_Explain_SuspendCredits":"No estarán disponibles hasta que se reactive tu membresía.","Tab_Invite":"Invitar","Menu_InviteReward":"Recompensa por invitar amigos","Tab_Reward":"Recompensas","Title_AgentCreditForRewards":"Recompensas de créditos de Agente: ","Table_Time":"Fecha y hora","Table_Invitee":"Invitado","Title_ShareWithFriends":"Comparte con tus amigos","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">¡Invita a un amigo y ambos recibirán </span><span style=\\"color:#2D990C;\\">${0} créditos de Agente!</span>","Title_InvitationLink":"Comparte este enlace con tus amigos","Button_Copy":"Copiar","Title_Tips":"Consejos","Title_Tips_ExplainOne":"1. Los créditos de Agente solo se pueden usar para acceder a las funciones del Agente de IA. Los créditos de recompensa son válidos por dos años.","Title_Tips_ExplainTwo":"2. Los amigos nuevos recibirán una recompensa después de completar su registro. Si tienes preguntas, comunícate con nuestro equipo de asistencia.","Title_GetRewarded":"¡Invitación exitosa!","Title_GetRewarded_Explain":"Los créditos solo se pueden usar para las funciones del Agente de IA y son válidos por dos años.","Button_Ok":"Entendido","Title_FailedToReceiveReward":"Error en la operación","Title_FailedToReceiveReward_Explain":"Si tienes preguntas, comunícate con nuestro equipo de asistencia.","Input_Describe_workspace":"Describe tu imagen y la crearé por ti","Tool_AiBackgroundGenrator":"Generador de fondos con IA","Title_YouCannotUseYourOwnLink":"No se permiten los enlaces privados","Table_AgentCredit":"Créditos de Agente","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">¡Puedes invitar hasta </span><span style=\\"color:#2D990C;\\">${0} amigos nuevos </span><span style=\\"color:#616266;\\"> y obtener un máximo de ${1} créditos de Agente!</span>","Button_Invite":"Invitar","Menu_Title_Invite":"Refiere a un amigo","Text_Button_Invite":"Obtener créditos","Title_Dialog_Invite":"Refiere a un amigo","Desc_Dialog_Invite":"Comparte tu enlace con amigos o en redes sociales. Cuando un amigo se registre mediante tu enlace, ambos recibirán ${0} créditos. Si se suscribe, ambos recibirán hasta ${1} créditos adicionales.","Detail_Dialog_Invite":"Detalles","Text_Copy_Invite":"Copiar enlace","Title_Rewards_Invite":"Recompensas","SubTitle_Rewards1_Invite":"Créditos totales obtenidos","SubTitle_Rewards2_Invite":"Usuarios gratuitos referidos","SubTitle_Rewards3_Invite":"Usuarios de pago referidos","Success_Copy_Invite":"Enlace copiado","Title1_Invited_Invite":"¡Recibiste una invitación!","Text_Rule1_Invite":"Por cada amigo que se registre con tu enlace, ambos ganarán <strong>${0} créditos</strong>.","Text_Rule2_Invite":"Si tu amigo se suscribe, ambos obtendrán créditos adicionales (<strong>${0} para Plus, ${1} para Pro</strong>).","Text_Rule3_Invite":"Las suscripciones de pago no se pueden reembolsar si el plan se usó o se consumieron los créditos concedidos, en todo o en parte. Además, los créditos gratuitos no se pueden revocar una vez que se usan.","Text_Rule4_Invite":"Cada usuario puede invitar a hasta ${0} amigos.","Text_Rule5_Invite":"No se concederán recompensas por referencias a cuentas existentes, autorreferencias, cuentas duplicadas o actividad fraudulenta.","Text_Rule6_Invite":"${0} se reserva el derecho de ajustar el programa y revocar las recompensas de cuentas anormales.","Text_Divider_Invite":"o comparte el enlace","Title2_Invited_Invite":"Únete a ${0} y reclama tus recompensas","SubTitle1_Invited_Invite":"Un amigo te invitó a probar nuestro agente profesional de IA para marcas. Crea fácilmente diseños para marketing de marca de alta calidad, como logos, posters, menús y recursos para redes sociales.","SubTitle2_Invited_Invite":"<strong>Regístrate ahora</strong> y tanto tú como tu amigo <strong>recibirán ${0} créditos</strong>. <strong>Si te suscribes</strong>, cada uno recibirá créditos adicionales según el plan que elijas (<strong>${1} créditos con Plus o ${2} créditos con Pro</strong>). ¡Regístrate ahora para reclamar tus recompensas!","Button_Invited_Invite":"Regístrate para reclamar tus recompensas","Success_Invited_Invite":"Te uniste mediante una referencia y recibiste ${0} créditos.","Error_Invited_Invite":"Ya tienes una suscripción activa.","Text_Share_Invite":"Estoy usando ${0} para crear rápidamente logos, elementos visuales y videos. Regístrate con mi enlace y ambos obtendremos créditos adicionales.","Title_Share_Invite":"¡Únete a ${0} y obtengamos créditos juntos!","Share_Email_Invite":"Correo","Text_Rule7_Invite":"Puedes usar los créditos para el Agente de IA. Los créditos expiran después de un mes.","Title_AgentCredits":"+50 créditos de Agente","Input_Models":"Modelo","Button_TryItNow":"Pruébalo ahora","Account_Pricing":"Precios","Account_Language":"Idioma","Account_Language_English":"Inglés","Account_Language_Chinese":"Chino","Tips_Adding":"Procesando…","Tips_Loading":"Cargando…","Tips_Creating":"Procesando…","Tips_Downloading":"Descargando…","Tips_Sending":"Enviando…","Tips_AddSuccess":"Se agregó correctamente","Tips_MakeSameError":"No se puede volver a crear","Tips_UnsupportedGradientColor":"No se admiten gradientes","Tips_CanNotAdding":"Error al agregar","Tips_Uninitialized":"Error al enviar el mensajes","Tips_UploadFailed":"Error al cargar. Inténtalo de nuevo.","Tips_UploadMaxCountLimit":"Sube hasta ${n} archivo(s) ${type}","Tips_UploadMaxFileSize":"No se pudo subir el archivo ${file}. Usa un archivo de hasta ${n} MB.","Tips_UploadImageAndVideoLimit":"Puedes subir 1 imagen y 1 video a la vez","Tips_UnsupportedSvgFile":"No se admiten archivos SVG","Tips_UnsupportedUploadFileFormats":"No se admite el formato de tu archivo ${files}","Tips_CanNotAddSameFileTips":"Este archivo ya existe","Tips_TextMinLengthTips":"Ingresa al menos ${n} caracteres","Tips_TextMaxLengthTips":"Ingresa hasta ${n} caracteres. Cada carácter chino o emoji cuenta por 2.","Tips_AccessDenied":"Acceso denegado","Tips_CreateFailed":"Error al iniciar el chat","Tips_Error":"Ocurrió un error","Tips_NotFound":"El chat no existe","Tips_RequestAgentModelListError":"Error al solicitar la lista de modelos de Agente","Desc_Ended":"Fin","Button_PeopleUse_Agent":"${n} usuarios lo probaron","Dropdown_AddToChat":"Agregar al chat","Dropdown_AddToBrandKit":"Agregar al Kit de marca","Dropdown_SaveToBrandKit":"Guardar como logotipo de marca","Dropdown_SaveToBrandTemplate":"Guardar como plantilla de marca","Title_Design_Agent":"Diseño","Title_MainColor":"Color principal","Title_SecondaryColor":"Color secundario","Bitton_ViewTheBrandKit":"Haz clic para ver el kit de marca","Dropdown_InportImages":"Importar imágenes","Title_Upgrade_Pro":"Actualizar","Desc_SubscribeToUnlock_Pro":"¡Suscríbete para desbloquear más!","Desc_RunOutOfFreeUses_Pro":"Se te acabaron los usos gratuitos.","Desc_RunOutOfUsesForToday_Pro":"Te has quedado sin usos gratuitos por hoy. Regresa mañana.","Desc_PurchaseCompleted_Pro":"Compra completada","Desc_ContinueDesign_Pro":"¡Ahora puedes continuar con tu diseño!","Button_UnlockNow":"Suscríbete","Tips_Copied":"¡Copiado!","Tips_Credit_Explain_Paid":"¿Qué son los créditos comprados?","Title_Total_InactiveCredits":"Créditos inactivos totales","Title_Total_PaidCredits":"Créditos totales comprados","Menu_SuspendCredits":"Créditos inactivos","Menu_Credits":"Créditos","Tab_RecentCreations_Agent":"Agente","Tab_RecentCreations_Design":"Herramientas inteligentes","Menu_FunctionalPricing":"Precios del Agente","Title_Total_AgentCredits":"Total: créditos de Agente","Tips_Credit_Explain_Agent":"¿Qué son los créditos de Agente?","Title_FeaturePricing":"Precios del Agente","Tab_Category":"Categoría","Tab_TaskType":"Tarea","Tab_Consume":"Precio (créditos)","Tab_ExampleContent":"Ejemplos","Tips_CreditExplain_Inactive":"¿Qué son los créditos inactivos?","langding_more_bg_remover":"Eliminador de fondo","langding_more_enhancer":"Mejorador de imagen","langding_more_objects_remover":"Borrador de objetos con IA","langding_more_bg_generator":"Generador de fondos con IA","Title_More1_Home":"Mejorador de imagen","Title_More2_Home":"Borrador de objetos con IA","Title_More3_Home":"Generador de fondos con IA","Title_More4_Home":"Eliminador de fondos con IA","Title_More5_Home":"Herramientas de imágenes por lotes","Title_Home":"Tu Agente de IA para el diseño de <span>e-commerce</span>","Placeholder_Input_Home":"Describe tu imagen y la crearé por ti.","Title_Card4_Home":"Recursos visuales para Amazon","Title_Card1_Home":"Imágenes de prueba de ropa y accesorios","Title_Card3_Home":"Imágenes de la página de detalles del producto","Title_Card2_Home":"Generador de fondos","Desc_Features1_Home":"La IA extrae automáticamente las características del producto y las preferencias de estilo para determinar las soluciones ideales de diseño.","Desc_Features2_Home":"Solo ingresa una oración y la IA generará una colección completa de imágenes para e-commerce, incluyendo la imagen principal, recursos visuales de apoyo y una página completa de detalles del producto.","Text_Btn_Home":"Comienza gratis","Desc_Features3_Home":"Crea automáticamente recursos visuales listos para distintas plataformas, como Amazon, Etsy, TEMU, eBay y más. Esto garantiza que las imágenes siempre estén optimizadas para atraer al público adecuado.","Desc_Features4_Home":"Solo ingresa tu solicitud y la IA adaptará el lenguaje, estilo, tono y los elementos culturales para producir versiones localizadas para cada mercado objetivo.","Desc_Features5_Home":"Guarda el flujo de trabajo de tu diseño como una plantilla reutilizable y deja que la IA genere automáticamente imágenes por lotes para todos tus SKU.","Desc_Features6_Home":"Sin importar si trabajas con 10 o 1,000 productos, puedes producir rápidamente un conjunto visual completo y uniforme.","Title_Qualification_Home":"¡Avalado por más de 5 millones de vendedores de e-commerce!","Text_Btn_Qualification_Home":"Ver certificación","Title_Carousel_Home":"Más herramientas de IA","Title_Footer_Home":"Tu Agente de IA para el diseño de e-commerce","Title_Footer1_Home":"Cuenta de redes sociales","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Ayuda y legal","Subtitle_Footer5_Home":"Términos de servicio","Subtitle_Footer6_Home":"Política de privacidad","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"¡Me encanta Designkit! Las imágenes de estilo de vida generadas con IA son naturales: cálidas y de estilo nórdico, perfectas para mi tienda de velas. Mis publicaciones se ven increíbles y las ventas aumentaron. Vale la pena.","Job_Evaluation5_Home":"Vendedora de TEMU en México","Job_Evaluation6_Home":"Especialista de operaciones de Amazon","Job_Evaluation12_Home":"Gerente de una tienda de Amazon con múltiples SKU en Indonesia","Job_Evaluation2_Home":"Dueño de tienda en Amazon y Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"Las imágenes de estilo de vida se ven muy naturales, casi como si las hubiera tomado un profesional. A mis clientes también les encantan, pues he notado que mis tasas de conversión están subiendo.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Propietario de una tienda transfronteriza en Lazada y Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Diseñador de e-commerce DTC","Job_Evaluation8_Home":"Propietario de una tienda de productos de exteriores para Walmart en Estados Unidos","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Vendedor de Mercado Libre en Argentina","Desc_Evaluation7_Home":"¡Las escenas de los productos para mascotas que genera la IA son súper lindas! Los perros y gatos se ven perfectamente proporcionados y naturales. Además, el tamaño y la escala coinciden con los requisitos de la plataforma, por lo que las imágenes son realmente fáciles de usar de inmediato.","Job_Evaluation7_Home":"Propietario de una tienda de Mercado Libre en Brasil","Desc_Evaluation8_Home":"Las escenas que uso para mis tiendas de campaña son muy realistas. La iluminación y los ángulos se ven naturales, y las proporciones son exactas. Me ahorra muchísimo tiempo en comparación con hacerlo todo por mi cuenta.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"La herramienta es realmente rápida y las imágenes que genera pueden subirse casi directamente a Mercado Libre y Amazon sin modificaciones.","Desc_Evaluation6_Home":"Antes me preocupaba que la IA hiciera un desastre con las texturas de la tela, pero apenas se ven diferentes del original. Los tejidos parecen tejidos, la mezclilla parece mezclilla e incluso cumple los requisitos de imagen de Amazon. Lanzar productos nuevos ahora es mucho más rápido.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"Las imágenes de producto generadas con IA son realmente precisas. La longitud del cable y la forma de los conectores son exactas, e incluso coinciden con el estilo de TEMU. Es un gran ahorro de tiempo en comparación con tomar las fotos yo mismo.","Desc_Evaluation12_Home":"Con una sola indicación, puedo obtener gráficos utilizables al instante, lo cual es mucho más rápido que esperar al diseñador. Honestamente, es súper conveniente.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"Las texturas metálicas y los detalles estructurales son muy claros, así que las imágenes se ven profesionales. Puedo usarlas al instante sin editarlas.","Name_Evaluation4_Home":"León","Desc_Evaluation10_Home":"La generación por lotes es súper conveniente. Puedo procesar decenas de SKU a la vez, y es mucho más rápido que hacer todo manualmente como antes.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Vendo ropa y me preocupaba que la IA hiciera un desastre con los colores o las texturas de las telas, pero de hecho lo hizo muy bien. Las poses de la modelo se ven naturales y las imágenes quedan prácticamente listas para usarse al instante.","Job_Evaluation1_Home":"Especialista de operaciones de una tienda de SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Especialista de operaciones de Amazon","Desc_Evaluation2_Home":"La herramienta es súper rápida y las imágenes quedan prácticamente listas para subir a Mercado Libre o Amazon. Incluso adapta los fondos y los modelos a los gustos locales, y los resultados se ven totalmente profesionales.","Job_Evaluation4_Home":"Vendedor de eBay en Alemania","Title_Evaluation_Home":"Sus historias","Title_Introduction_Home":"Diseño premium con IA que impulsa las ventas","Desc_Qualification_Home":"Proveedor certificado de servicios SPN de Amazon","Title_Seo_Home":"Generador de imagen y video de producto con IA para e-commerce","Desc_Seo_Home":"Genera instantáneamente imágenes de producto, pósteres y videos para Amazon, TikTok y otras tiendas en línea con el Agente de IA de Designkit. ¡Comienza a diseñar sin costo hoy!<br>","Keywords_Seo_Home":"Agente de IA para e-commerce, Herramientas de IA para e-commerce, Generador de imagen de producto con IA, Generador de video de producto con IA, Editor de foto de producto con IA, Eliminador fondo con IA","Title_Features1_Home":"De una sola solicitud a un conjunto completo de recursos visuales","Title_Features2_Home":"Localización completamente automatizada para vender tus productos a nivel global en múltiples plataformas","Title_Features3_Home":"Genera automáticamente imágenes por lotes para múltiples SKU, ¡y vence a la competencia!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Desplázate para explorar","Tips_Material1_Home":"Conjunto de imágenes para publicaciones","Tips_Material2_Home":"Prueba virtual","Tips_Material3_Home":"Contenido A+","Tips_Material4_Home":"Generador de fondos","Free_Button_Home":"Probar gratis","Title_Header1_Home":"Producto","Title_Header2_Home":"solución","Title_Header3_Home":"Inspiración","Title_Header4_Home":"Aprender","Title_Header5_Home":"Precios","SecondTitle_Header1_Home":"Agente de e-commerce con IA","SecondTitle_Header2_Home":"Herramientas de imagen con IA","SecondTitle_Header3_Home":"Herramientas de video con IA","SecondTitle_Header4_Home":"Solución de diseño de Amazon","SecondTitle_Header5_Home":"Solución de e-commerce para redes sociales","SecondTitle_Header6_Home":"Generador de imagen de producto con IA","SecondTitle_Header7_Home":"Generador de modelos de moda con IA","SecondTitle_Header8_Home":"Cambiador de color de ropa","SecondTitle_Header9_Home":"Generador de video de producto","SecondTitle_Header10_Home":"Herramientas de IA","SecondTitle_Header11_Home":"Editor de fotos con IA","SecondTitle_Header12_Home":"Editor de fotos con IA en línea","SecondTitle_Header13_Home":"Editor de fotos masivo","SecondTitle_Header14_Home":"Editor de fotos masivo con IA","SecondTitle_Header15_Home":"Mejorador de imágenes por lotes","SecondTitle_Header16_Home":"Eliminador de marcas de agua masivo","SecondTitle_Header17_Home":"Generador de fondos masivo","SecondTitle_Header18_Home":"Eliminador de fondos de imagen por lotes","Title_Footer3_Home":"Herramientas de diseño","Subtitle_Footer8_Home":"Editor de fotos con IA","Subtitle_Footer7_Home":"Cambiador de fondos con IA","Subtitle_Footer9_Home":"Fondo transparente","Subtitle_Footer10_Home":"Cambiar el color de fondo","Subtitle_Footer11_Home":"Eliminador de marcas de agua de imagen","Subtitle_Footer12_Home":"Eliminar texto de la imagen","Subtitle_Footer13_Home":"Agregar stickers a fotos","Subtitle_Footer14_Home":"Agregar marca de agua en la foto","Title_Footer4_Home":"Modelos de imagen","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Descargar gratis","Subtitle_Footer16_Home":"Aplicación para iOS","Subtitle_Footer17_Home":"Aplicación para Android","Title_Footer6_Home":"Síguenos","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Modelos de video","Button_Export":"Descargar","Title_Layer":"Capas","InputNumber_Opacity":"Opacidad","Buttom_Comfirm":"Confirmar","Button_Share":"Compartir","Button_Delete":"Borrar","Title_LoginPopup":"Inicia sesión para comenzar la prueba","SubTitle_LoginPopup":"Comienza a crear con Zawa hoy","Tip_ModalTitle":"Recordatorio","TipContent_HistoryDelete":"Después de borrarlo, no se podrá restablecer este registro. ¿Confirmas que deseas borrarlo?","Title_Logo":"Logotipo","Title_BrandKit":"Plantillas","Tab_BrandKit":"Kit de marca","Tab_UploadLocal":"Elegir del álbum","Button_UploadImage":"Subir imágenes","Button_UploadProductImage":"Subir imagen de producto","Button_UploadReferImage":"Referencias","Tip_ClickDragParseImage":"Sube, suelta o pega imágenes aquí.","Tip_UploadMax":"Sube archivos JPG, JPEG o PNG de hasta ${0} MB, con un máximo de N imágenes.","Tooltip_SwitchBrandKit":"Cambiar el kit de marca","Discribe_BrandKitSelect":"Selecciona un estilo de marca como referencia para este diseño.","Title_Models":"Modelos","Switch_Auto":"Automático","Tab_Image":"Imagen","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Guardar como logotipo de marca","MenuItem_AddToBrandTemplate":"Guardar como plantilla de marca","Button_ExportImage":"Importar imágenes","Button_ExportMedia":"Importar videos","Button_ExportFromBrandkit":"Importar desde el kit de marca","Dropdown_AddFromBrandkit":"Añadir desde el kit de marca","Placeholder_ChatInput":"¡Comencemos!","MenuItem_AiChange":"Edición con IA","MenuItem_AiExpend":"Ampliador con IA","MenuItem_AiHD":"Claridad con IA","MenuItem_Eliminate":"Eliminación con IA","MenuItem_SplitLayers":"Dividir capas","MenuItem_Cutout":"Eliminador de fondos","MenuItem_ChangeText":"Reemplazar texto","MenuItem_Crop":"Tamaño de la imagen","MenuItem_AddToChat":"Agregar al chat","MenuItem_AddToBrand":"Agregar al Kit de marca","Tooltip_Layer":"Capas","Tooltip_Grab":"Herramienta de mano","Tooltip_Select":"Seleccionar","Tooltip_Redo":"Rehacer","Tooltip_Undo":"Deshacer","Tooltip_Add":"Agregar","Tooltip_ShowAll":"Mostrar todo","Tip_UploadType":"Formato de archivo no admitido","Tip_UploadSize":"Solo se admiten archivos de hasta ${0} MB","Tip_UploadWH":"Asegúrate de que cada imagen tenga menos de ${0}×${1} píxeles","Tip_UploadTypeTranslate":"Error al cambiar el formato de archivo","Tip_UploadFail":"Error al subir","Tooltip_AddText":"Agregar texto","Text_AddDefault":"Esto es un texto de muestra.","Tooltip_OverflowImageSize":"Cambia el tamaño de tu imagen a menos de ${0} píxeles","Placeholder_ImageFusion":"Dime cómo te gustaría que se fusionen las imágenes","Button_ImageFusion":"Fusionar","Button_Cancel":"Cancelar","Button_AiChange":"Editar","Placeholder_AiChange":"Dime qué quieres cambiar","Button_Eliminate":"Borrador","Label_OriginSize":"Original","Label_CropRadio":"Relación de aspecto","Button_Free":"Gratis","Button_Origin":"Original","Button_Crop":"Recortar","Placeholder_ChangeText":"Ingresa texto. Ejemplo: Hola","Button_ChangeText":"Confirmar","InputNumber_PanSize":"Tamaño del pincel","Label_TargetSize":"Objetivo","Tooltip_ImageFusion":"Puedes fusionar de ${0} a ${1} imágenes","Title_Workspace":"Tu Agente creativo de IA para el branding","Button_Pro":"Obtén Pro gratis","Title_NanoPro":"🍌🍌Nano Banana Pro ya está disponible en Zawa.","Dropdown_AdvancedFeatures_Title":"Funciones avanzadas","Dropdown_AdvancedFeatures_Conent":"Acceso total a todas las herramientas potenciadas por IA para mejorar tu eficiencia.","Dropdown_MassiveContent_Title":"Gran cantidad de contenido","Dropdown_MassiveContent_Content":"Acceso ilimitado a plantillas premium y a una gran colección de recursos de stock Plus.","Dropdown_CommercialRights_Title":"Derechos comerciales","Dropdown_CommercialRights_Content":"Usa tus creaciones personales con confianza, con protección de derechos de autor garantizada.","Popup_SubscribeIntl_Desc":"Aprovecha al máximo Zawa con Pro","Popup_SubscribeIntl_Desc1":"Desbloquea más creaciones con créditos","Popup_SubscribeIntl_Detail":"Consulta los detalles de los planes y Ayuda","Popup_StripeCheckout":"Pago con Stripe","Popup_LiveSupport":"Asistencia en vivo","Popup_CancelAnytime":"Cancela en cualquier momento","Menu_Language":"Idioma","Menu_ManageSubscription":"Administrar suscripciones","Menu_TermsPolices":"Términos y políticas","Menu_ManageSubscriptions":"Administrar suscripciones","Menu_ReferralLink":"Enlace de referencia","Menu_BenefitsUpgraded":"Beneficios","Menu_TermsPolicies":"Términos y políticas","Menu_AccountManagement":"Cuenta","Title_ReferralCode":"Código de referencia","Title_ReferralLink":"Enlace de referencia","Desc_NoActiveSubscription":"No hay una suscripción activa","Button_ClickToSubscibe":"Haz clic aquí para suscribirte","Title_SubscriptionCancel":"Tu suscripción ha sido cancelada","Title_SeeYou":"Lamentamos que te vayas…😭","Desc_NextBillingDate":"Se renueva el","Desc_EstimatedAmount":"Total estimado","Button_CancelSubscription":"Cancelar suscripción","Button_StaySubscribed":"Mantener suscripción","Title_ReasonCancelling":"Selecciona un motivo para cancelar:","Desc_BenefitsContinue":"Puedes seguir disfrutando de los beneficios de tu membresía hasta el fin de la suscripción.","Desc_GiftedCredits":"Una vez que venza tu suscripción, los créditos de regalo","Desc_SeeYou":"Gracias por acompañarnos. Lamentamos que te vayas.","Desc_NoNoreCharges":"No se te volverá a cobrar, tu membresía se mantendrá activa hasta el","Desc_MayBeRevoked":"podrían revocarse.","Desc_CancelingNoRefund":"Cancelar <span>no incluye un reembolso</span>. Para realizar consultas sobre reembolsos, comunícate con el servicio de asistencia en línea.","Button_ClearSelection":"Deseleccionar","Button_Confirm":"Confirmar","Message_Processing":"Procesando…","Title_Opacity":"Opacidad","Button_ExpandImage":"Ampliador","Button_ExpandRadio":"Relación de aspecto","Title_NoDesigns":"Aún no hay diseños.","Title_NoGenerations":"Aún no hay generaciones.","Desc_NoDesigns":"Tus diseños aparecerán aquí.","Desc_NoGenerations":"Tus generaciones aparecerán aquí.","Title_DeleteDesign":"Borrar este diseño","Popup_DeleteDesign":"¿Deseas borrar este diseño de forma permanente? Esta acción no se puede deshacer.","Message_SaveFail":"Error al guardar","Title_Pricing":"Elige el plan adecuado para ti","Title_Tags1_Pricing":"Mensual","Text_Discount_Pricing":"${0} de descuento","Title_Tags2_Pricing":"Anual","Title_Plan1_Pricing":"Gratis","Current_Plan_Pricing":"Plan actual","Title_Instruction1_Pricing":"Obtén 20 créditos por el primer inicio de sesión","Title_Instruction2_Pricing":"Genera hasta 20 imágenes con el Agente de IA","Title_Instruction3_Pricing":"Genera hasta 10 imágenes con el Generador de fondos con IA","Title_Rights1_Pricing":"Eliminación limitada de fondos u objetos","Title_Rights3_Pricing":"Mejora limitada de imágenes en HD","Title_Plan2_Pricing":"Plan Básico","Month_Plan_Pricing":"mes","Title_Button1_Pricing":"Suscríbete","Title_Instruction4_Pricing":"500 créditos/mes","Title_Instruction5_Pricing":"Genera hasta 500 imágenes con el Agente de IA","Title_Instruction6_Pricing":"Genera hasta 250 imágenes con el Generador de fondos con IA","Title_Plan3_Pricing":"Plan Pro","Desc_Plan_Pricing":"Prueba gratuita de 7 días. Luego ${0}/año.","Title_Button2_Pricing":"Prueba gratuita de 7 días","Title_Instruction7_Pricing":"1,500 créditos/mes","Title_Instruction8_Pricing":"Genera hasta 1,500 imágenes con el Agente de IA","Title_Instruction9_Pricing":"Genera hasta 750 imágenes con el Generador de fondos con IA","Title_Rights4_Pricing":"Eliminación ilimitada de fondos u objetos","Title_Rights5_Pricing":"Uso ilimitado de la función Eliminación con IA","Title_Rights6_Pricing":"Mejora de imágenes en UHD ilimitada","Title_Rights7_Pricing":"Herramientas de procesamiento por lotes","Title_Best_Pricing":"Elegido por el 90 % de los usuarios","Title_AllFeatures_Pricing":"Compara los planes Gratuito y Pago","Desc_AllFeatures_Pricing":"Desbloquea Premium para crear diseños sorprendentes sin esfuerzo con herramientas avanzadas de IA","Month_AllFeatures_Pricing":"mes","Title_Features1_Pricing":"Agente de IA","SubTitle_Features1_Pricing":"Edición de imágenes","SubTitle_Features15_Pricing":"Genera hasta ${0} imágenes","SubTitle_Features16_Pricing":"Genera hasta ${0} imágenes/mes","SubTitle_Features2_Pricing":"Generación de imágenes","SubTitle_Features3_Pricing":"Generación de imágenes para e-commerce","SubTitle_Features4_Pricing":"Generación de pósteres","Title_Features2_Pricing":"Herramientas de imagen con IA","SubTitle_Features5_Pricing":"Eliminador de fondos con IA","SubTitle_Features17_Pricing":"Uso limitado","SubTitle_Features19_Pricing":"Uso ilimitado","SubTitle_Features6_Pricing":"Borrador de objetos con IA","SubTitle_Features7_Pricing":"Mejorador de imagen","SubTitle_Features18_Pricing":"Uso limitado (HD)","SubTitle_Features20_Pricing":"Uso ilimitado (HD/UHD)","SubTitle_Features8_Pricing":"Refinador de imágenes con IA","SubTitle_Features9_Pricing":"Ampliador de imágenes con IA","SubTitle_Features10_Pricing":"Generador de fondos con IA","Title_Features3_Pricing":"Más funciones de diseño","SubTitle_Features11_Pricing":"Funciones avanzadas y plantillas","SubTitle_Features12_Pricing":"Eliminar marca de agua","SubTitle_Features13_Pricing":"Herramientas de imágenes con IA por lotes","SubTitle_Features14_Pricing":"Funciones de diseño básicas","Title_Credits_Pricing":"¿Te estás quedando sin créditos? Nosotros nos encargamos.","Desc_Credits_Pricing":"Compra única, no se requiere suscripción.","TransactionPrice_Credits_Pricing":"Precio: ${0}","Credit_Credits_Pricing":"Créditos","Popular_Credits_Pricing":"Más popular","Buy_Credits_Pricing":"Comprar ahora","Title_FAQ_Pricing":"Preguntas frecuentes","Title_Button4_Pricing":"Actualiza ahora y obtén una prueba gratuita de 7 días","SubTitle_FAQ1_Pricing":"¿Qué son los créditos?","Content_FAQ1_Pricing":"Los créditos te permiten seguir accediendo a las herramientas de IA. La cantidad de créditos necesaria varía dependiendo de la herramienta específica.","Content_FAQ2_Pricing":"Los créditos comprados son válidos por un año.","Content_FAQ3_Pricing":"Los créditos de membresía son válidos durante el período de la membresía.","SubTitle_FAQ2_Pricing":"¿Cómo cancelo mi suscripción y qué sucederá con mis créditos después de la cancelación?","Content_FAQ4_Pricing":"Después de cancelar tu suscripción,","Content_FAQ5_Pricing":"los créditos de tu membresía seguirán siendo válidos hasta que expire tu membresía. Los créditos que hayas comprado por separado no se verán afectados.","Content_FAQ6_Pricing":"Si necesitas cancelar tu suscripción, sigue estos pasos al menos 24 horas antes de que comience el siguiente ciclo de facturación:","Content_FAQ7_Pricing":"1. Inicia sesión en Designkit.","Content_FAQ8_Pricing":"2. Ingresa a la ventana emergente de suscripción.","Content_FAQ9_Pricing":"3. Selecciona \\"Administrar suscripciones\\".","Content_FAQ10_Pricing":"4. Selecciona tu plan actual y haz clic en \\"Cancelar suscripción\\".","Content_FAQ11_Pricing":"Tu suscripción seguirá activa hasta el final del ciclo de facturación actual. Si no puedes cancelarla, toma una captura de pantalla y comunícate con nuestro en servicio de asistencia en línea lo antes posible","SubTitle_FAQ3_Pricing":"¿Cuál es su política de reembolsos?","Content_FAQ12_Pricing":"1. Garantía de devolución del dinero de 7 días:","SubTitle_FAQ4_Pricing":"¿Cómo puedo aumentar o disminuir mi suscripción?","Content_FAQ25_Pricing":"1. Mejora: puedes suscribirte fácilmente a un plan de nivel superior, que entrará en vigor inmediatamente. Tu suscripción anterior se cancelará y se reembolsará el saldo restante.","SubTitle_FAQ5_Pricing":"¿Puedo obtener una copia de mi factura?","Content_FAQ27_Pricing":"¡Sí! Una vez realizado el pago, recibirás un correo electrónico del proveedor de pago con una factura electrónica. Si no la recibes, comunícate con nuestro equipo de asistencia.","SubTitle_FAQ6_Pricing":"¿Qué métodos de pago aceptan?","Content_FAQ28_Pricing":"Usamos Stripe para administrar pagos y suscripciones. Aceptamos las principales tarjetas de crédito, PayPal y Google Pay.","SubTitle_FAQ7_Pricing":"¿Cómo me comunico con el servicio de asistencia?","Content_FAQ29_Pricing":"Correo electrónico: support@designkit.com; tiempo de respuesta: de 3 a 10 días hábiles.","Content_FAQ13_Pricing":"Si compraste suscripciones y no las utilizaste en un plazo de 7 días, podrías recibir un reembolso total.","Content_FAQ14_Pricing":"Si compraste créditos, podrías recibir un reembolso por los créditos no utilizados en un plazo de 7 días.","Content_FAQ15_Pricing":"2. Disconformidad con el servicio","Content_FAQ16_Pricing":"Si no te satisfacen los resultados, comunícate con nuestro equipo de asistencia en línea. Podríamos ofrecerte una compensación o un reembolso dependiendo de las circunstancias.","Content_FAQ17_Pricing":"3. Compras mediante Google Play o App Store","Content_FAQ18_Pricing":"Si te suscribiste mediante Google Play Store o App Store, debes solicitar un reembolso directamente a Google o Apple.","Content_FAQ19_Pricing":"Notas importantes:","Content_FAQ20_Pricing":"Esta política de reembolso no aplica para usuarios de la API. Si usas nuestra API, comunícate con nosotros para saber si cumples con los requisitos para un reembolso.","Content_FAQ21_Pricing":"Nos reservamos el derecho a denegar reembolsos en casos de mal uso, abuso o incumplimiento de nuestros términos.","Content_FAQ22_Pricing":"Los reembolsos pueden tomar varios días hábiles en procesarse, dependiendo de tu método de pago.","Content_FAQ23_Pricing":"Es posible que actualicemos esta política de reembolso de vez en cuando. Consúltala periódicamente para conocer los cambios.","Content_FAQ24_Pricing":"Para recibir ayuda adicional, comunícate con nuestro equipo de asistencia.","Content_FAQ26_Pricing":"2. Disminución: primero, cancela tu suscripción actual. Cuando termine tu período de facturación actual, suscríbete al plan nuevo.","Content_Modal_Pricing":"¡Gracias por tu apoyo! Prepárate para llevar tu creatividad al siguiente nivel.","Tip_Modal_Pricing":"Sugerencias: si tu membresía aún no aparece, actualiza la página.","Title_Modal_Pricing":"Compra realizada con éxito","Title_Rights2_Pricing":"Uso limitado de la función Eliminación con IA","Title_Button3_Pricing":"Beneficios disponibles","Title_Button5_Pricing":"Mejorar","Tool_ImageBgRemover":"Eliminador de fondo","Tool_AiBgGenerator":"Generador de fondos con IA","Tool_AiLogoGenerator":"Generador de logotipos con IA","Tool_FootwearModel":"Modelo de calzado","Tool_ImageTranslation":"Traducción de imágenes","Tool_BatchImageBgRemover":"Borrador de fondos de imagen por lotes","Tool_BatchImageEnhancer":"Mejorador de imágenes por lotes","Tool_BatchAiObjectsRemover":"Borrador de objetos IA por lotes","Tool_VideoEnhancer":"Mejorar el video","Tool_VideoBgRemover":"Borrador de fondos de video","Tool_VideoWatermarkRemover":"Borrador de marca de agua en video","Title_Models_Dropdown":"Modelos","Tips_Uninitialized_Chat":"Error al enviar mensajes","Tips_Uninitialized_chat":"Error al enviar mensajes","Dropdown_AddImage":"Agregar imagen","Action_SeeAll":"Ver todo","Desc_Seedream":"Creación de imagen realista y detallada.","Dropdown_AddVideo":"Agregar video","Tips_NotFound_Chat":"El chat no existe","Desc_Seedance":"Creación de video realista y expresiva.","Dropdown_SupportedFormatFile":"Admite archivos de Word, Excel, texto y PDF.","Dropdown_Example_Option":"Ejemplo","Dropdown_NoReference_Option":"No hay referencia disponible","Menu_AgentCredits":"Créditos de Agente","Desc_SeedEdit":"Edición de imagen precisa y natural.","Dropdown_BrandKit_Title":"Kit de marca","Desc_GeminiNanoBanana":"Generación de imagen rápida, editable y uniforme.","Dropdown_Models_Title":"Modelos","Dropdown_AddDocument":"Agregar documento","Dropdown_BrandKit_Desc":"Selecciona un estilo de marca como referencia para este diseño.","Desc_MidjourneyVideo":"Generación de video creativa y artística.","Desc_MidjourneyImage":"Generación de imagen artística e imaginativa.","Dropdown_SaveAsBrandTemplate":"Guardar como plantilla de marca","Dropdown_SaveAsBrandLogo":"Guardar como logotipo de marca","BatchProcessTable_ImageType":"Tipo de imagen","BatchProcessTable_PictureRequirement":"Detalles de diseño","BatchProcessTable_CopywritingRequirements":"Descripción del producto","BatchProcessTable_Proportion":"Relación de aspecto","BatchProcessTable_Actions":"Acción","BatchProcessTable_AddOneRow":"Agregar","BatchProcessList_DeleteError":"Error al borrar","BatchProcessList_SurePrompt":"¿Deseas borrar esta directriz?","BatchProcessList_SurePrompt_SureText":"Confirmar","BatchProcessList_SurePrompt_CancelText":"Cancelar","BatchProcessList_EmptyText":"Vacío","EditBatchProcess_NameLimitTip":"Ingresa un nombre (hasta 10 caracteres)","EditBatchProcess_Tip":"Cualquier cambio a las directrices afectará los resultados generados.","EditBatchProcess_Start":"Comienza con una directriz","EditBatchProcess_GenerateTip":"Sube tus imágenes de producto y se generarán diseños basados en las directrices.","Text_AdvanceSetting":"Especialista","Text_MainImage":"Imagen principal","Text_ProductAgentUploadGuide1":"1. Sube múltiples imágenes del mismo producto desde diferentes ángulos para ayudar a que la IA capture mejor los detalles del producto.","Text_ProductAgentUploadGuide2":"2. Hasta 10 imágenes. La primera imagen se usará como la referencia principal, por lo que te sugerimos que elijas el mejor ángulo.","Text_Optional":"(Opcional)","Tip_ClickDragImageWithSize":"Sube o arrastra imágenes JPEG, JPG o PNG de hasta ${0}MB.","Button_AddReferenceImage":"Subir","Title_ReferenceImage":"Imagen de referencia","Input_Placeholder":"Selecciona","Radio_ReferenceColor":"Color de referencia","Radio_ReferenceLayout":"Composición de referencia","Tag_FirstImage":"Primera imagen","Tag_FirstImageNoPartial":"La primera foto está incompleta","Tag_Blur":"Desenfocado","Tag_Jigsaw":"Collage","Button_Understood":"Entendido","Text_ReferenceImageIndex":"La foto ${0}  es de referencia","Text_ReferenceDimensions":"Usar ${0} a partir de referencia","Tag_Cropped":"Recortado","Tag_Underexposed":"Subexpuesto","Tag_Blurry":"Desenfocado","SelectOption_ColorPalette":"Paleta de colores","SelectOption_Layout":"Composición","SelectOption_Fonts":"Fuentes","SelectOption_Style":"Estilo","SelectOption_ShapeElements":"Figuras geométricas","Text_SocialMediaAgentUploadGuide":"Sube primero tu producto destacado. Asegúrate de que la foto sea nítida y esté completa.","Video_SR_Success":"Claridad de video mejorada","Video_Desubtitle_Success":"Subtítulo eliminado","Video_Dewatermark_Success":"Marca de agua eliminada","Video_Process_Failed":"Error al procesar. Los créditos se reembolsarán a tu cuenta.","Video_SR":"Claridad con IA","Video_Dewatermark":"Eliminar marca de agua","Video_Desubtitle":"Eliminar subtítulos","Video_Task_Price_Estimate":"Se requieren ${0} créditos","Video_SR_Start":"Mejorando la claridad… Se usarán ${0} créditos.","Video_Dewatermark_Start":"Eliminando marcas de agua… Se usarán ${0} créditos.","Video_Desubtitle_Start":"Eliminando subtítulos… Se usarán ${0} créditos.","Video_Desubtitle_Start_VIP":"Eliminando subtítulos…","Video_Dewatermark_Start_VIP":"Eliminando marcas de agua…","Video_SR_Start_VIP":"Mejorando la claridad…","Text_Help_Center":"Centro de ayuda","Title_Request":"Chat","Button_Continue":"Continuar","Button_EditContent":"Editar mensaje","Title_ChooseImageType":"Selecciona el tipo de imagen generada (múltiples opciones)","Button_BatchGenerate":"Confirmado. Ejecuta la plantilla ahora.","Text_ChatCancelStatus":"Tarea terminada","Text_ChatRespondedStatus":"Procesamiento de tarea","BatchProcess_SaveSuccessTip":"Tus kits de flujo de trabajo se guardan aquí.","Button_GotIt":"Entendido","Title_Congrats":"Felicitaciones","SubTitle_BrandCreate":"Creaste tu primer kit de marca: ¡es hora de explorar su potencial!","Button_CheckUse":"Echa un vistazo ahora","Chat_Prompt_Brand":"Crea un póster promocional","Tooltip_UseBrand":"¡Aquí puedes cambiar o agregar tu kit de marca!","Tooltip_PosterBrand":"Toca para crear tu primer póster a partir de tu kit de marca","Popup_CreateBrand":"Crea una marca desde cero","Desc_CreateBrand":"Crea sorprendentes logotipos originales con nuestro Agente de IA.","Popup_UploadBrand":"Sube la información de tu marca","Desc_UploadBrand":"Súbelo y Zawa mantendrá todos los diseños alineados.","Title_BrandEntry":"Obtén un sistema de marca personalizado ahora","Desc_BrandEntry":"Deja que nuestra IA se encargue del estilo. Responde unas cuantas preguntas y recibe un sistema de marca completo que se adapte a tu visión.","Tooltip_UseBrand_Agent":"Una vez que se aplique el kit de marca, el diseño se remitirá automáticamente al logotipo, la paleta de color y el estilo general.","Tooltip_PosterBrand_Agent":"Todo listo para que diseñes con tu kit de marca","BatchProcess_createText":"Kit de flujo de trabajo","Label_NormalMode":"Básico:","Label_AdvancedMode":"Avanzado:","Text_NormalMode":"Básico","Text_AdvancedMode":"Avanzado","BatchProcess_DefaultPrompt":"Generar imágenes","Title_CreateBrand":"¿No tienes una marca?","Title_UploadBrand":"¿Ya tienes un logotipo?","Button_CreateBrand":"Crear una marca","BatchProcess_EditContent":"Editar contenido","BatchProcess_PleaseSelect":"Selecciona un kit de flujo de trabajo","BatchProcess_SelectTip":"Todas las imágenes subidas se generarán en lote usando el kit de flujo de trabajo seleccionado.","BatchProcess_ListEmptyTip":"Guarda el kit de flujo de trabajo después de generarlo para crear conjuntos similares en lotes al instante.","BatchProcess_Tip":"Kit de flujo de trabajo","BatchProcess_Generate":"Úsalo ahora","BatchProcess_Save":"Guardar","BatchProcess_GeneratingFormula":"Generando kit de flujo de trabajo…","BatchProcess_GenerateCancel":"Cancelar","BatchProcess_WorkFlowCreateError":"Error al crear","ProductInfo_PleaseUploadImage":"Sube imágenes de producto","BatchProcess_IntelligenceGenerate":"Crea un kit de flujo de trabajo","BatchProcess_CreateWorkflow":"Crear","BatchProcess_Formula":"Kit de flujo de trabajo","BatchProcess_WorkFlowSaveSuccess":"Kit de flujo de trabajo guardado","ProductInfo_ImageSizeLimit":"Se admiten imágenes de menos de ${0} MB","ProductInfo_ImageUpload":"Agrega imagen de producto","ProductInfo_UploadDemo":"Fotos de ejemplo","ProductInfo_ECPlatform":"Plataforma","ProductInfo_PleaseSelect":"Selecciona","ProductInfo_InputCustomize":"Personalizado","ProductInfo_CountryAndLanguage":"Región/idioma de destino","ProductInfo_Name":"Nombre del producto","ProductInfo_Desc":"Detalles del producto (características/tamaño/escenarios de uso)","ProductInfo_DescPlaceholder":"Ingresa información del producto como características, tamaño, escenarios de uso, público objetivo, etc.","ProductInfo_NamePrompt":"El nombre del producto es ${0};","ProductInfo_ECPlatformPrompt":"La plataforma de destino es ${0};","ProductInfo_CountryAndLanguagePrompt":"El idioma es ${0};","ProductInfo_DescPrompt":"Los detalles del producto son ${0}.","ProductInfo_PleaseInput":"Por favor, ingresa","Button_UnlockPro":"Desbloquear Pro","Button_UpgradeToPro":"Actualizar a Pro","Button_RenewNow":"Renovar ahora","AgentEmpty_CaseUseBtn":"Usar","AgentEmpty_CaseRefreshBtn":"Actualizar","MenuItem_Effect":"Efectos","MenuItem_Shadow":"Sombras","MenuItem_Stroke":"Trazo","Title_ChangeText":"Reemplazar texto","Button_Logout":"Cerrar sesión","Message_ExtractText":"Extrayendo texto","Message_ExtractTextError":"Error al extraer texto. Por favor, inténtalo de nuevo.","Tip_CreditConsume":"Esta generación usa ${0} créditos","Tip_EstimatedTime":"Estará listo en alrededor de ${0} minutos","BatchProcess_SaveSuccessTip_GotIt":"Entendido","BatchProcess_SaveSuccessTip_Title":"Usando kits de flujo de trabajo","BatchProcess_SaveSuccessTip_Desc":"Aquí se guardan tus kits de flujo de trabajo. Elige uno para generar imágenes rápidamente usando las plantillas guardadas.","BatchProcess_tutorial":"Tutoriales","Text_HandTool":"Herramienta de mano","Text_Function":"Función","Text_WindowsSystem":"Sistema de Windows","Text_MacSystem":"Sistema de Mac","Menu_KeyboardShortcuts":"Combinaciones de teclas","Title_KeyboardShortcuts":"Combinaciones de teclas","Text_Undo":"Deshacer","Text_MouseLeft":"Botón izquierdo del mouse","Text_Redo":"Rehacer","Text_Delete":"Borrar","Text_Cut":"Cortar","Text_Copy":"Copiar","Text_Paste":"Pegar","Text_PasteFixed":"Pegar en su lugar","Text_CreateCopy":"Crear una copia","Text_SelectAll":"Seleccionar todo","Text_SelectMultiple":"Selección múltiple","Text_Group":"Agrupar","Text_Ungroup":"Desagrupar","Text_LockLayer":"Bloquear","Text_Save":"Guardar","Text_Move":"Mover","Text_MoveWithCombinedKeys":"Mover rápido","Text_TouchEditFastMode":"Apuntar para editar rápidamente","Text_Pan":"Paneo","Title_Canvas":"Lienzo","Title_Edit":"Editar","Title_Elements":"Elementos","Title_Tools":"Herramientas","Title_Blogs":"Blog","Text_NewText":"Texto nuevo","Text_NewLine":"Línea nueva","Text_NewRectangle":"Rectángulo nuevo","Text_NewCircle":"Círculo nuevo","Text_ExitFullScreen":"Salir de pantalla completa","Text_MoveUpOneLayer":"Traer adelante","Text_MoveDownOneLayer":"Enviar atrás","Text_Top":"Traer al frente","Text_Bottom":"Enviar al fondo","Text_CanvasZoom":"Acercar/alejar","Text_ToggleReferenceLine":"Mostrar/ocultar guías","Text_ToggleRulerBar":"Mostrar/ocultar reglas","Text_ArrowKey":"Teclas de flecha","Text_CanvasShowAll":"Mostrar todo el lienzo","Title_Unsupported_Multilayer":"Esta función solo funciona con una sola capa.","Btn_CreateBatchProcessFormula":"Crear","Button_Hide_Otherlayers":"Mantener la primera capa y continuar","Button_Merge_Alllayers":"Combinar todas las capas y continuar","Checkbox_Disable_Remind":"No mostrar de nuevo","Button_Tool":"Herramientas","Button_Custom_Ratio":"Personalizado","Label_Spacing":"Espacio","Button_Download_Whole":"Exportar como imagen","Button_Download_Layer":"Exportar como capa","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Apuntar para editar","Text_TouchEdit_Description":"Apunta a un objeto y describe tus cambios. La imagen se editará exactamente como lo especifiques.","Tooltip_TouchEdit_Max_Count":"Puedes apuntar hasta ${0} áreas","Tooltip_TouchEdit_Usage":"Combinación de teclas de Apuntar para editar: ${0} + clic","Text_TouchEdit_Recognition_Custom":"Personalizado","Text_TouchEdit_Recognition_Title1":"Detectar y reconocer","Text_TouchEdit_Recognition_Title2":"No se encontró un objetivo. Ingresa el nombre del objeto.","Text_TouchEdit_Name":"Apuntar para editar","Btn_LoginToViewBatchProcess":"Inicia sesión para ver el kit de flujo de trabajo","Btn_Login":"Iniciar sesión","Menu_Main_Beautify":"Refinar","Text_Model_Pricing":"Precios de modelos","Text_Pro_discount":"Plan pro: generación de videos a mitad de precio","Text_TemplatePrompt":"Empecemos con inspiraciones","Text_Hi":"¡Hola {0}!","Text_Account_Popup_Left":"Conoce a tu asistente de diseño de IA dedicado al comercio electrónico. Creado para profesionales que buscan lanzamientos más rápidos, presentaciones más sólidas y mayor rentabilidad.","Text_PleaseWaitImageUploaded":"Continúa después de que se complete la carga","Menu_Redeem_Rights":"Canjear","Text_Redeem_Now":"Canjea ahora","Text_Redeem_Placeholder":"Ingresa el código de canje, respetando las mayúsculas y minúsculas","Text_Redeem_Success":"¡Canje exitoso!","Text_Redeem_Use":"Canjea tu código","Tooltip_BrandAutoUse":"¡Se aplicó tu kit nuevo!","Redeem_Redeem_Note":"Nota: \\nInicia sesión e ingresa el código de canje.\\nCuando se complete el canje, podrás disfrutar los beneficios y servicios correspondientes.\\nUsa el código de canje durante su periodo de validez. Los códigos expirados no serán válidos y no son reembolsables.\\nProtege tu código. No nos haremos responsables por códigos perdidos, divulgados o usados de manera incorrecta. \\nEste código no es transferible ni se puede revender, intercambiar por dinero en efectivo ni es elegible para la emisión de facturas.","Tooltip_Color_Fill":"Color","Tootip_StartPoint":"Comenzar","Tootip_ChangePoint":"Cambiar","Tootip_EndPoint":"Fin","Sidebar_NewDesign":"Nuevo chat","Retouch_Filter_Clear":"Nítido","Retouch_Filter_Enhance":"Vívido","Retouch_Filter_Dehaze":"Borrar neblina","Retouch_Filter_Texture":"Textura","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Desvanecer","Modal_Button_Known":"Aceptar","Modal_Button_GotIt":"Aceptar","Modal_Button_Later":"Más tarde","Text_Appeal_Confirm":"Sí","Text_Vip_Open":"Suscríbete","Text_Appeal_ReGenerate":"Los resultados editados no son cumplen las condiciones para su revisión.","Text_Appeal_Left":"Intentos restantes este mes\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Los créditos fueron reembolsados a tu cuenta.","MenuItem_Appeal":"Revisión de resultados","Tooltip_Downloading":"Descargando…","Tooltip_Download_Video":"Descarga videos por separado, uno a la vez.","Tooltip_Download_NoneSelected":"Selecciona el contenido que quieres descargar","Text_AI_Thinking":"La IA está trabajando en ello…","Text_Server_Busy":"El servidor está ocupado. Intenta de nuevo más tarde.","Text_Prompt_Help_Placeholder":"Escribe tus palabras clave y las convertiré en una indicación lista para usar.","Text_Prompt_Helping":"Procesando… Espera un momento.","Button_Retry":"Intentar de nuevo","Button_Rewrite":"Intenta de nuevo","Button_Start_Prompt_Help":"Comienza a escribir","Title_Prompt_Helper":"Escritura con IA","Menu_Text_Subscriptions":"Suscripciones","Menu_View_Subscriptions":"Ver suscripciones","Text_Download_XdesignApp":"Descarga la aplicación de <span>Zawa</span> para usar las funciones","Text_Free_Trial":"Descarga para obtener una prueba gratuita por 7 días","Text_Install_App":"Instalar la app","Text_Scan_Download":"Escanea para descargar","Text_Download_the":"Descargar en la","Text_Available_On":"Disponible en","Desc_ExpireDate":"Expira el","DownloadApp_Title_Widgets":"Descarga la aplicación de ${0} para usar las funciones","DownloadApp_SubTitle_Widgets":"Descarga para obtener una prueba gratuita por ${0} días","InstallApp_Title_Widgets":"Instalar la app","InstallApp_Desc_Widgets":"Escanea para descargar","AppStore_Desc_Widgets":"Descargar en la App Store","GooglePlay_Desc_Widgets":"Disponible en Google Play","Text_Tips_GetFree":"Tienes un uso gratuito","Text_AgentLib":"Recursos","Tip_ModelSetSaveSuccess":"¡Se guardó la imagen de tu modelo! Toca para usarla.","Text_BatchProcess":"Kit de flujo de trabajo","Button_Add":"Agregar","Tab_Recent":"Recientemente guardado","Tab_Models":"Mis modelos","Prompt_Model":"La imagen ${0} es mi modelo","Tip_SaveSuccess":"Guardado","Text_ModelsLogin":"Inicia sesión para ver tus modelos","Loading_CheckFace":"Detectando rostro…","Name_InitialModelName":"Mis modelos","EmptyTip_ModelList":"Todavía no tienes un modelo. ¡Vamos a crear uno!","Text_UploadModel":"Subir modelo","Text_Model":"Modelo","Tips_UnsupportedFormat":"Formato de archivo no admitido","Tips_InputModelName":"Ingresa un nombre","Tips_UploadModelImage":"Sube imágenes del modelo","Title_CreateModel":"Crea tu modelo","Text_ModelName":"Nombre","Placeholder_Input":"Ingresa","Text_UploadModelHint":"Toca para subir o arrastra imágenes aquí\\n<br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Subir","Tips_NameLengthLimit":"Ingresa un nombre (hasta ${0} caracteres)","Tips_DeleteFailed":"Error al borrar","Title_ConfirmDeleteModel":"¿Deseas borrar este modelo?","Tips_CreateSuccess":"Modelo creado","Tab_BatchTemplate":"Kit de flujo de trabajo","Tab_MyModel":"Mis modelos","Placeholder_InputContent":"Introduce contenido","Title_ChooseSceneType_VideoGenerateCard":"Selecciona un tipo de contenido y una estructura de storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Iniciar generación de video","Title_ShotType_VideoGenerateModal":"Tipo de storyboard","Title_ShotRequirement_VideoGenerateModal":"Descripción del storyboard","Title_Duration_VideoGenerateModal":"Duración","Btn_AddOneTableRow":"Agregar","Label_Gender_ModelModal":"Sexo","Label_Appearance_ModelModal":"Apariencia","Label_AgeGroup_ModelModal":"Grupo de edad","Label_Persona_ModelModal":"Función","Label_BodyType_ModelModal":"Tipo de cuerpo","Tips_GenerateModelFailed_ModelModal":"Error de generación. Intenta de nuevo más tarde.","Tips_NetworkError_ModelModal":"Error de red. Intenta de nuevo más tarde.","Tab_CustomModel_ModelModal":"Personalizado","Tab_OfficialModel_ModelModal":"Oficial","Tab_UploadModel_ModelModal":"Subir","Text_ModelPreview_ModelModal":"Vista previa","Button_Generating_ModelModal":"Generando…","Button_Regenerate_ModelModal":"Intentar de nuevo","Button_Generate_ModelModal":"Generar","Button_Saving_ModelModal":"Guardando…","Button_SaveAndUse_ModelModal":"Guardar y usar","Button_CreateNewModel_AgentLibList":"Modelo nuevo","Message_NotFilled_RequiredField":"Se requiere información de ${0}","Title_ChooseSceneType2_VideoGenerateCard":"Selecciona una estructura de storyboard","Title_ContentType_VideoGenerateCard":"Tipo de contenido","Title_StoryboardStructure_VideoGenerateCard":"Estructura de storyboard","Text_Offical":"Oficial","Title_AboveTheFold_Main_HomeV2":"Haz que cada foto <br /> de producto quede <span>lista para vender</span>","Title_Designkit_Slogan":"Haz que cada foto de producto quede lista para vender","Button_StartFree_HomeV2":"Comienza gratis","Title_AboveTheFoldMobile_Main_HomeV2":"Haz que cada producto quede <br /><span>listo para vender</span>","SubTitle_AboveTheFoldMobile_HomeV2":"Desde edición profesional de fotos hasta generación automatizada de listados, todo lo que necesitas en un solo lugar.","Text_TopBanner_HomeV2":"Seedance 2.0 pronto estará disponible con acceso ilimitado","Title_ModuleCard_HomeV2":"Primero, genera recursos ganadores","SubTitle_ModuleCard_HomeV2":"No más lienzos vacíos. Usa nuestra Suite Creativa Inteligente de Agentes de IA para generar <br /> pilas de listado completas, videos dinámicos, pruebas virtuales de ropa y adaptaciones globales en segundos.","Title_Faq_Q1_HomeV2":"¿Ofrecen una prueba gratuita?","Text_Faq_A1_HomeV2":"¡Sí! Los usuarios nuevos reciben 20 créditos gratuitos al registrarse. Además, puedes reclamar 10 créditos gratuitos todos los días con tan solo iniciar sesión. Esto te permite probar todas las funciones principales, como generación de imagen y video, antes de adquirir un plan pagado.","Title_Faq_Q2_HomeV2":"¿Las imágenes cumplen con los lineamientos de Amazon o Shopify?","Text_Faq_A2_HOMEV2":"Sin duda. Para las fotografías principales, las salidas de nuestra IA son estrictamente los fondos blancos (RGB 255,255,255) que exigen Amazon y Shopify. Para las imágenes de estilo de vida y redes sociales, garantiza dimensiones perfectas y calidad de alta resolución para que tus listados cumplan con todos los lineamientos y sean profesionales.","Title_Faq_Q3_HomeV2":"¿Puedo usar recursos generados para fines comerciales?","Text_Faq_A3_HomeV2":"Sí. Todas las imágenes y videos que se generen en nuestros planes de pago están 100% libres de regalías y totalmente autorizados para su uso uso comercial. Los derechos son tuyos para usar estos recursos en tu tienda de Shopify, listados de Amazon, anuncios de redes sociales y cualquier otro canal de marketing, sin restricciones.","Title_Faq_Q4_HomeV2":"¿Cómo funcionan la generación y edición por lotes?","Text_Faq_A4_HomeV2":"El procesamiento por lotes está integrado de manera nativa en todas las funciones de Designkit. Tan solo sube múltiples imágenes directamente al espacio de trabajo. Ya sea que generes fondos nuevos de estilo de vida, elimines fondos originales, borres objetos no deseados o aumentes la resolución, puedes aplicar la acción que elijas al lote completo con un solo clic. Esto garantiza recursos perfectamente uniformes para tu tienda que te ahorrarán horas de trabajo manual.","Title_Faq_Q5_HomeV2":"¿Qué formatos de archivo admiten?","Text_Faq_A5_HomeV2":"Las salidas de video están disponibles en formato MP4, optimizadas para redes sociales y sitios web de comercio electrónico.","Title_Questions_Main_HomeV2":"Preguntas frecuentes","Title_Scale_Main_HomeV2":"¿Todo listo para escalar?","SubTitle_Scale_HomeV2":"Únete a más de 10,000 vendedores que automatizaron su flujo de trabajo de diseño con Designkit.","Title_Evaluation_HomeV2":"Finalmente, lanza más rápido y vende más","SubTitle_Evaluation_HomeV2":"Reduce el tiempo de producción en un 90%. Lanza listados verificados en Amazon y Shopify antes que tus competidores.","Tab_Module_ProductImage_HomeV2":"Imagen de producto con IA","Desc_Module_ProductImage_HomeV2":"Convierte una foto de proveedor en una pila de listado completa. Genera fotos principales con fondo blanco, escenas de estilo de vida e infografías, procesa sin esfuerzo lotes de cientos de SKU y traduce automáticamente texto para mercados globales.","Tip_Module_ProductImage_HomeV2":"Genera un conjunto de listados de Amazon para los audífonos rosas.","Tab_Module_ModelImage_HomeV2":"Modelo de moda con IA","Desc_Module_ModelImage_HomeV2":"¿No tienes modelos? No hay problema. Visualiza prendas en distintos modelos de IA para aumentar las tasas de clics sin necesidad de costosas sesiones de fotografía.","Tip_Module_ModelImage_HomeV2":"Muestra este traje amarillo con verde en una modelo de 25 años.","Tab_Module_Video_HomeV2":"Video de producto con IA","Desc_Module_Video_HomeV2":"Dales vida a tus productos. Genera exhibidores dinámicos de producto, atractivos videos de portavoces con IA y anuncios con una alta tasa de conversión a partir de una indicación de texto o una sola imagen. Capta la atención y aumenta las ventas en distintas plataformas de comercio electrónico y tus redes sociales.","Tip_Module_Video_HomeV2":"Genera un video de producto para este florero azul.","Tab_Module_DetailPage_HomeV2":"Página de detalle de productos con IA","Desc_Module_DetailPage_HomeV2":"Crea contenido premium A+ y banners promocionales perfectos para tu tienda en línea en unos cuantos minutos: no necesitas habilidades de diseño. Transforma fotos básicas de producto en layouts altamente atractivos y diferencia tus listados de tu competencia sin esfuerzo.","Tip_Module_DetailPage_HomeV2":"Genera una página de detalles de producto para el sillón naranja.","Tab_Module_Photography_HomeV2":"Fotografía de producto con IA","Desc_Module_Photography_HomeV2":"Deshazte de las fotos de stock genéricas. Coloca tus productos en entornos únicos y relevantes para tu marca que resuenen con el mercado estadounidense y europeo.","Tip_Module_Photography_HomeV2":"Genera un fondo de fotografía para este perfume.","Title_Module_SecondTitle_HomeV2":"Luego, perfecciona los detalles con la precisión de la IA","SubTitle_Module_SecondSubTitle_HomeV2":"¿Ya generaste los recursos? Ahora perfecciónalos. Usa nuestro Editor de fotos con IA para eliminar fondos, limpiar defectos y mejorar en masa imágenes en baja resolución.","Text_Upload_HomeV2":"Subir","Text_TopBannerMobile_HomeV2":"Seedance 2.0 pronto estará disponible","Text_Prompt1_HomeV2":"Genera un conjunto completo de imágenes para listados de Amazon.","Text_Prompt2_HomeV2":"Genera una modelo que use este outfit.","Text_Prompt3_HomeV2":"Genera un video de marketing para un producto.","Text_Prompt4_HomeV2":"Genera una página de detalles de producto de contenido A+.","Text_Prompt5_HomeV2":"Genera fondos adecuados para imágenes de producto.","Desc_Evaluation1_HomeV2":"¡Súper rápido! Las imágenes están listas al instante para Mercado Libre y Amazon. Adapta a la perfección fondos y modelos según el gusto local. Resultados totalmente profesionales.","Desc_Evaluation2_HomeV2":"¡Me encanta Designkit! Las imágenes de estilo de vida generadas con IA son naturales, cálidas y de estilo nórdico: perfectas para mi tienda de velas. Mis listados se ven increíbles y las ventas aumentaron. Vale la pena.","Desc_Evaluation3_HomeV2":"Vendo ropa y me preocupaba que la IA arruinara las texturas. ¡Designkit lo hizo increíble! Los colores son perfectos, las poses de la modelo se ven naturales y las imágenes están listas al instante.","Header_products_socialMediaPostGenerator":"Generador de publicaciones para redes sociales","Pricing_Seedance_UnlockLimited":"Obtén acceso ilimitado","Pricing_Seedance_SeedanceV1":"Acceso anticipado a <span>Seedance 2.0</span>","Pricing_Seedance_SeedanceDesc":"Sé de los primeros en experimentar la potencia de Seedance 2.0. Suscríbete a cualquier plan Pro ahora y obtén acceso ilimitado exclusivo a nuestro modelo de IA de próxima generación.","Pricing_Seedance_Monthly":"Bono de plan mensual","Pricing_Seedance_DaysUnLimit":"7 días <span>ilimitado</span>","Pricing_Seedance_SeedanceV2":"Acceso a Seedance 2.0","Pricing_Seedance_BestValue":"MEJOR OFERTA","Pricing_Seedance_Yearly":"Bono de plan anual","Pricing_Seedance_MonthUnLimit":"1 mes <span> ilimitado</span>","Title_AIBrand_Tools":"✨Herramientas de branding con IA","Title_AISocialMediaPosts":"Publicaciones de redes sociales con IA","Title_AILogoMaker":"Generador de logotipos con IA","Option_Child_Age":"Niño","Option_Infant_Age":"Bebé","Option_MiddleAged_Age":"Adulto","Option_Senior_Age":"Adulto mayor","Option_Teen_Age":"Juvenil","Option_YoungAdult_Age":"Adulto joven","Button_GenerateImages_DetailPageAction":"Generar","Text_GenerateImagesCount_DetailPageAction":"(${0} imágenes)","Text_GenerateImagesCount_DetailPageAction1":"(${0} imagen)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Crear diseño de Página de producto","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Móvil)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Accesorios/Regalos","Option_ServiceSupport_DetailSection":"Garantía","Option_BeforeAfter_DetailSection":"Antes y después","Option_BrandStory_DetailSection":"Historia de marca","Option_KeyHighlights_DetailSection":"Puntos clave de venta","Option_CraftProcess_DetailSection":"Vista explosionada","Option_HeroVisual_DetailSection":"Arte principal","Option_Composition_DetailSection":"Componentes","Option_MultiAngle_DetailSection":"Múltiples ángulos","Option_DetailCloseups_DetailSection":"Detalle de producto","Option_SceneMood_DetailSection":"Estilo / Vibras","Option_SeriesShowcase_DetailSection":"Series de producto","Option_SizeCapacity_DetailSection":"Dimensiones","Option_Specifications_DetailSection":"Ficha técnica","Option_UsageScenario_DetailSection":"Casos de uso","Option_UsageTips_DetailSection":"Guía de uso","Paragraph_ServicePolicy_DetailSection":"Políticas de garantía, cambios y devoluciones","Paragraph_BeforeAfter_DetailSection":"Resultados antes y después del uso","Paragraph_BrandConcept_DetailSection":"Conceptos y valores de la marca","Paragraph_CoreValue_DetailSection":"Muestra de valores clave","Paragraph_CraftProcess_DetailSection":"Del boceto a la realidad","Paragraph_Differentiators_DetailSection":"Principales beneficios","Paragraph_Composition_DetailSection":"Materiales y componentes del producto","Paragraph_MaterialAndCraft_DetailSection":"Materiales y procesos del producto","Paragraph_MultiAngleAppearance_DetailSection":"El producto desde distintos ángulos","Paragraph_MultiOptionDisplay_DetailSection":"Múltiples colores o SKUs","Paragraph_IncludedItems_DetailSection":"Contenido del paquete","Paragraph_DetailData_DetailSection":"Especificaciones detalladas","Paragraph_RealUsageScene_DetailSection":"Referencias reales de uso","Paragraph_Specifications_DetailSection":"Guía de tallas resumida","Paragraph_UsageNotes_DetailSection":"Notas de uso y precauciones","Paragraph_UsageScenario_DetailSection":"El producto en contexto","Title_Nav_DetailPage":"Detalles del producto A+","Title_ImageSet_DetailPage":"Set de imágenes detalladas del producto A+","Input_TaskName_Batch":"Ingresa el nombre de la tarea","Paragraph_FullAssetSetDescription_Batch":"Incluye un set completo de recursos de marketing, como imágenes principales, imágenes de uso real e imágenes con fondo blanco, que puedes usar en múltiples plataformas.","Paragraph_LongFormVisualDescription_Batch":"Crea una narrativa visual para imágenes de producto en formato largo, páginas de detalles de producto A+ e imágenes comparativas.","Message_JsonGenerated_Batch":"Formato verificado. JSON generado.","Message_JsonCopied_Batch":"JSON copiado.","Message_IncompleteRequiredFields_Batch":"Faltan campos obligatorios. Por favor completa el formulario para poder enviarlo.","Message_PleaseUploadSourceImage_Batch":"Sube las imágenes del producto","Message_PleaseCompleteStrategySettings_Batch":"Por favor, completa la configuración de la estrategia.","Message_TaskValidationFailed_Batch":"Por favor, revisa y completa las tareas sin verificar.","Message_CopyJsonFailed_Batch":"La copia falló. Por favor, revisar el JSON en el panel de control.","Message_PleaseEnterTitle_Batch":"Por favor, ingresa el título.","Message_PleaseEnterKeyHighlights_Batch":"Por favor, ingresa los puntos fuertes del producto.","Message_PleaseGenerateJsonFirst_Batch":"Por favor, envíar para generar el JSON.","Title_DetailPage_Batch":"Página de producto A+","Title_DetailTask_Batch":"Tarea A+ ${0}","Title_IndependentParameters_Batch":"Configurar individualmente","Title_ImageSet_Batch":"Set de imágenes para e-commerce","Title_ItemTask_Batch":"Tarea de producto","Option_Curvy_BodyType":"Curvilíneo","Option_Muscular_BodyType":"Musculoso","Option_PlusSize_BodyType":"Complexión robusta","Option_Slim_BodyType":"Delgado","Option_Standard_BodyType":"Promedio","Button_Reset_Common":"Restablecer","Button_Back_Common":"Atrás","Button_Collapse_Common":"Plegar","Button_Expand_Common":"Expandir","Button_Generate_Common":"Generar","Button_PreviousStep_Common":"Deshacer","Button_RemoveFavorite_Common":"Quitar favorito","Button_StartNow_Common":"Probar ahora","Paragraph_ExitWarning_Common":"Si sales, se perderán los datos.","Paragraph_Content1_VirtualModelDisclaimer":"2. Por favor, sea consciente de lo que puede esperar del contenido generado por IA. El contenido que se genera con IA se produce mediante algoritmos y aprendizaje de datos, por lo que los resultados pueden variar. El aspecto facial generado por la IA puede diferir de los recursos originales proporcionados, y pueden producirse imperfecciones o resultados no satisfactorios. Nuestra plataforma no garantiza la precisión, la calidad visual ni la idoneidad del contenido generado.","Paragraph_Content2_VirtualModelDisclaimer":"3. Por favor, considere sus responsabilidades como usuario. Usted es responsable de las imágenes que contienen rostros y del contenido que genere. Debe asegurarse de que su uso no infrinja los derechos legales de terceros, incluidos, entre otros, los derechos de imagen, privacidad y reputación, y que cumpla con todas las leyes y normativas aplicables. No debe usar el contenido generado con fines ilegales, de infracción (como difamación o fraude), o que atenten contra el orden público, la moral o la dignidad de otras personas. ","Paragraph_Content3_VirtualModelDisclaimer":"Confirma que comprendes y aceptas los términos anteriores antes de subir tu contenido.","Title_Notice_VirtualModelDisclaimer":"Antes de usar el Probador Virtual con IA, lee detenidamente lo siguiente:","Message_FailedRetry_Download":"Error al descargar. Por favor, inténtalo de nuevo más tarde.","Message_Failed_Download":"Error al descargar.","Message_Success_Download":"Descarga completada.","Message_NoImagesAvailable_Download":"No hay imágenes disponibles.","Option_Asian_Ethnicity":"Asiática/Asiático","Option_Black_Ethnicity":"Africana/Africano","Option_Chinese_Ethnicity":"China","Option_Latino_Ethnicity":"Hispano o Latino","Option_MiddleEastern_Ethnicity":"Medio Oriente","Option_SoutheastAsian_Ethnicity":"Sudeste asiático","Option_White_Ethnicity":"Blanca/o","Option_Female_Gender":"Mujer","Option_Male_Gender":"Hombre","FormLabel_Ethnicity_Common":"Raza y etnicidad","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Idioma","FormLabel_TargetMarket_Common":"Mercado","FormLabel_TargetPlatform_Common":"Plataforma","Option_German_Language":"Alemán","Option_Japanese_Language":"Japonés","Option_None_Language":"Ninguno","Option_Portuguese_Language":"Portugués","Option_Russian_Language":"Ruso","Option_Spanish_Language":"Español","Option_Thai_Language":"Tailandés","Option_Brazil_Market":"Brasil","Option_China_Market":"China ","Option_Europe_Market":"Europa","Option_Germany_Market":"Alemania","Option_Japan_Market":"Japón","Option_Russia_Market":"Rusia","Option_SoutheastAsia_Market":"Sudeste asiático","Option_Spain_Market":"España","Option_UnitedStates_Market":"Estados Unidos","Message_MaxLimit_DetailSectionSelection":"Seleccionar hasta ${0} secciones","Option_FollowGlobalSettings_Common":"Usar ajustes globales","Text_MaxTasks_Batch":"Añadir hasta ${0} tarea(s)","Text_MinTasks_Batch":"Mantener al menos una tarea","Text_MaxImagesPerTask_Batch":"Cargar hasta ${0} imágenes por tarea","Text_SupportedImageFormats_Batch":"Formatos de imagen compatibles: JPG, JPEG, PNG, HEIC y WebP.","Input_AppearanceDetailsExample_TryOn":"Por ejemplo: piel bronceada, flequillo recto, un lunar cerca del ojo...","Input_SourceInfoGuide_Batch":"Para obtener resultados más precisos, incluye la siguiente información: 1. Nombre del producto 2. Puntos clave de venta 3. Público objetivo 4. Casos de uso 5. Especificaciones detalladas","Tooltip_OutputStyleConsistent_Clone":"Al activarlo, todas las imágenes generadas mantendrán un color y estilo consistentes. Al desactivarlo, cada imagen seguirá el estilo de su propia imagen de referencia.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Indonesio","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Generar set de imágenes","Title_Nav_ImageSet":"Fotos para listados","Message_GenerateFailedRetry_ImageSet":"Error al generar. Intenta de nuevo.","Message_PleaseSelectStyleFirst_ImageSet":"Primero elige un estilo.","Message_CreateTaskFailed_ImageSet":"Error al crear la tarea","Title_StyleAnalysis_ImageSet":"Análisis de estilos en tendencia","Option_TrafficMaximization_TitleStrategy":"Maximizar tráfico","Option_ConversionPriority_TitleStrategy":"Prioridad a las conversiones","Option_SceneImmersion_TitleStrategy":"Escenas inmersivas","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extrayendo características clave de los recursos…","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Generando palabras clave con tasas de conversión altas a partir de los puntos de venta…","Text_MatchingSeoStrategy_TitleGenerationStatus":"Aplicando las mejores estrategias de SEO…","Text_GeneratingOptions_TitleGenerationStatus":"Generando múltiples subtítulos desde diferentes perspectivas…","Message_TaskFailedWithStatus_TitleGeneration":"Error en la tarea (estado: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Se agotó el tiempo de espera de la solicitud. Intenta de nuevo.","Message_GenerateFailed_TitleGeneration":"Error al generar título. Intenta de nuevo.","Message_QueryResultFailed_TitleGeneration":"Error al recuperar tarea","Paragraph_Content_VirtualModelConsent":"1. Autorización de derechos de imagen: Esta función usa las imágenes que subes que contengan rostros para generar modelos virtuales con IA. Debes asegurarte de tener los derechos sobre las imágenes que subas o de adquirir el consentimiento explícito, válido y por escrito del propietario de los derechos para usar su imagen con este fin y cualquier contenido generado. Si imagen contiene a un menor de edad, se requiere el consentimiento de su tutor legal.","Button_ConfirmTextChange_TextEdit":"Actualizar","Input_ModifyText_TextEdit":"Editar subtítulos","Message_NoImagesAvailable_ResultDownload":"No hay imágenes disponibles para descargar","Message_Failed_TextRecognition":"Error al reconocer texto","Text_Generating_ResultStatus":"Generando…","Option_CustomColor_SceneSetting":"Personalizado","Option_UseOriginalBackground_SceneSetting":"Usar fondo original","Text_InsufficientCredits_Common":"Monedas insuficientes","Button_LoadMore_Common":"Cargar más","Text_ImageUploadLimit_Common":"Sube hasta ${0} imágenes","Text_AnalyzingTrend_Common":"Analizando tendencias sobre ${0}","Text_ChineseOutputProOnly_Common":"La generación de texto en chino es solo está disponible en Pro. Se eliminó el texto del resultado actual.","Text_SourceImageUploadLimit_Common":"Sube hasta ${0} imágenes","Text_WritingInProgress_AiWriting":"Procesando…","Text_DeepThinking_AiWriting":"Analizando a fondo…","Text_ThinkingProcess_AiWriting":"Proceso de pensamiento:","Text_ImageSelectionLimit_Common":"Selecciona hasta ${0} imágenes","Message_RegenerationSubmitted_Regeneration":"Regeneración enviada. Actualiza en unos momentos para ver el resultado.","Button_MoreEditOptions_ResultEditor":"Más","FormLabel_DetailSection_DetailPage":"Sección de detalles del producto","Message_GeneratePlanFailed_DetailPagePlan":"Error al generar plan","Message_PlanGenerationFailed_DetailPagePlan":"Error al generar plan","Text_PlanUnavailable_DetailPagePlan":"No hay planes disponibles","Message_SourceImageMissing_Common":"Falta la imagen del producto","Message_GenerationFailed_Common":"Error al generar","Paragraph_ConfirmDiscardChanges_Common":"Si regresas, se perderán tus cambios. ¿Deseas regresar?","Message_ProcessFailed_Common":"Error","Text_GeneratingEllipsis_Common":"Generando…","Text_StyleGenerationInProgress_ImageSet":"Generando estilos en tendencia…","Message_FavoriteAdded_Common":"Agregado a Favoritos","Message_FavoriteRemoved_Common":"Eliminado de Favoritos","Text_LoadingPlain_Common":"Cargando","Text_MultiSelectAvailable_Common":"Selección múltiple","Text_NoData_Common":"Sin datos disponibles","Text_NoDataAvailable_Common":"Sin datos","Text_NoMoreResults_Common":"No hay más contenido","Message_PleaseEnterKeyHighlights_DetailPage":"Ingresa los puntos clave de venta","Message_PleaseSelectAiModel_TryOn":"Selecciona un modelo de IA","Message_SelectSectionMin_DetailPage":"Selecciona al menos ${0} secciones","Message_SelectScenePoseMin_TryOn":"Selecciona al menos ${0} escenas y poses","Message_PleaseSelectBaseModel_TryOn":"Selecciona un modelo de base","Message_PleaseSelectCustomModel_TryOn":"Selecciona un modelo personalizado","Message_PleaseSelectModel_TryOn":"Primero selecciona un modelo","Message_PleaseSelectSection_DetailPage":"Selecciona una sección","Message_SelectUploadCustomModel_TryOn":"Selecciona o sube una imagen de modelo","Message_PleaseSelectScene_TryOn":"Selecciona una situación","Message_PleaseSelectStrategy_DetailPage":"Selecciona una estrategia","Message_PleaseUploadGarmentImage_TryOn":"Sube una imagen de ropa","Message_UploadGarmentFile_TryOn":"Sube una imagen de ropa","Message_PleaseUploadSourceImage_Common":"Sube primero imágenes del producto","Message_PleaseUploadItemImage_Common":"Sube una imagen de producto","Message_UploadItemFirst_Common":"Sube primero imágenes del producto","Message_RegenerateFailedWithReason_Regeneration":"Error al regenerar:","Message_SelectResultImages_Result":"Selecciona una imagen con resultados generados","Text_ReleaseToRefresh_Common":"Suelta para actualizar","Message_TextRecognitionFormatInvalid_TextRecognition":"Formato no válido reconocido","Message_TextRecognitionParseFailed_TextRecognition":"Error al procesar los resultados de reconocimiento","Message_TextRecognitionTaskFailed_TextRecognition":"Error al reconocer texto","Message_QueryTaskStatusFailed_TextRecognition":"Error al recuperar el estado de la tarea","Message_SubmitTaskFailed_TextRecognition":"Error al enviar la solicitud de reconocimiento","Text_RegenerationProcessing_Regeneration":"Solicitud de regeneración enviada. Procesando…","Message_RegenerateFailedRetry_Regeneration":"Error al regenerar. Intenta de nuevo más tarde.","Message_OpenEditorFailed_ResultEditor":"Error al abrir el editor","Message_RegenerateFailed_Regeneration":"Error al regenerar","Message_RefreshFailedRetry_Common":"Error al actualizar. Intenta de nuevo.","Message_UploadGarmentSelectModel_TryOn":"Sube una imagen de la prenda y selecciona un modelo","Message_PollingTimedOut_Common":"La consulta caducó","Title_KeyHighlights_DetailPage":"Puntos clave de venta","Title_FullStrategyGuide_DetailPage":"Lineamientos completos de estrategia y diseño","Title_IncludedSections_DetailPage":"Secciones","Title_IncludedSectionsMultiple_DetailPage":"Secciones (selección múltiple)","Title_ModelSelection_TryOn":"Seleccionar modelo","Title_SectionContent_DetailPage":"Contenido de la sección","Title_SectionStrategyGuide_DetailPage":"Lineamientos de estrategia y diseño por sección","Title_OutputAspectRatio_Common":"Relación de aspecto","Title_OutputSpecification_Common":"Especificaciones","Title_SelectModel_TryOn":"Seleccionar modelo","Title_SelectScene_TryOn":"Selecciona una escena","Title_StrategySettings_DetailPage":"Estrategia","Title_UploadAssets_Common":"Subir","Button_GenerateBaseModel_TryOn":"Generar modelo de base","Button_GenerateRecommendedScenes_TryOn":"Generar escena recomendada","Button_GenerateSceneImages_TryOn":"Generar (${0} imágenes)","Text_GeneratingBaseModel_TryOn":"Generando modelo de base…","Option_CloseUp_Framing":"Primer plano","Option_FullBody_Framing":"Cuerpo completo","Option_HalfBody_Framing":"Medio cuerpo","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"Probador con IA","Option_Ai_TryOnModelMode":"Generado con IA","Title_Nav_TryOn":"Probador","Option_Back_Perspective":"Atrás","Option_Front_Perspective":"Frente","Option_Side_Perspective":"Lado","Option_ThreeQuarterSide_Perspective":"Vista en 3/4","Input_AppearanceDetailsHint_TryOn":"Detalles de apariencia: piel bronceada, flequillo recto, un lunar cerca del ojo…","Message_SaveToAlbumSuccess_Common":"Guardado en el álbum","Text_GeneratingSceneImages_TryOn":"Generando imágenes de escenas…","Message_RefreshFailed_Common":"Error al actualizar","Message_FailedRefunded_Generation":"Error de diseño con IA. Los créditos fueron reembolsados.","Title_BaseModelImage_TryOn":"Imagen de modelo de base","Title_CustomModel_TryOn":"Modelo personalizado","Paragraph_Intro_TryOn":"Sube una imagen de la prenda y personaliza tu modelo para generar diversas escenas y poses.","Title_UploadGarmentImage_TryOn":"Imagen de ropa","Tips_UploadFailedPure":"Error al subir","Tips_Uploading":"Subiendo…","Text_UploadNewModel":"Modelo nuevo","Text_AllBackgrounds":"Todos los fondos","Text_DefaultTemplateScene":"Predeterminado","Text_ColorScene":"Colores","Text_SameProductMax_Common":"Hasta ${0} imágenes por producto","Text_Max_Common":"Hasta ${0} imagen/imágenes","Button_Generate_ImageClone":"Comenzar a generar","Button_RefreshStyle_Common":"Actualizar","Button_Favorite_Common":"Favoritos","Text_PreviewLargeImage":"Vista previa completa","Text_BaseImage":"Comparativa de referencia","Button_BatchDownload_Common":"Descarga por lotes","Button_BatchEdit_Common":"Edición por lotes","Button_BatchWatermark_Common":"Añadir marca de agua","Text_GeneratedResults":"Resultados","Button_DownloadAllImages_Common":"Descargar todo","Text_NoGeneratedResults":"Sin resultados","Text_SameProductMax_TryOn":"Un outfit completo o varios ángulos de la misma prenda, hasta $ {0} imágenes.","Title_AdvancedImageGenerationModel":"Modelo de imagen premium","Text_SupportChineseOutput_Common":"Admite resultados en chino para proporcionar una estética superior y mayor control creativo.","Text_SelectMultipleModules_DetailPage":"Selecciona varias secciones para generar una página completa de detalles del producto","Button_CollapseAll_Common":"Todo","Label_AppearanceDetails_TryOn":"Detalles de apariencia (opcional)","Text_WaitingForGeneration_TryOn":"Por generar","Title_SmartTitleAI_ProductTitle":"Generar título del listado","Message_ResultMissing_TitleGeneration":"Faltan ${0} resultados generados con IA","Message_InvalidJSONFormat_TitleGeneration":"Resultado no válido","Message_InvalidJSONFormat_TitleGeneration1":"Formato de JSON no válido","Text_AutoGeneratedTitleScheme_ProductTitle":"Aquí tienes los títulos generados automáticamente a partir de tu producto","Text_SelectBestTitle_ProductTitle":"Elige el título que venda más y haz clic para copiar","Button_Copy_Common":"Copiar","Message_PleaseUploadImage_Common":"Sube una foto primero","Text_DeepThinking1_AiWriting":"DeepSeek está trabajando en ello…","Button_Rewrite1":"Reintentar","Text_TotalImages_Common":"Recuento: ${0}","Text_EditText_ResultEditor":"Editar texto","Text_NoTextRecognition_ResultEditor":"No se ha detectado texto","Text_PreviewLongImage_ResultGroup":"Vista previa de imagen larga","Text_LimitFree":"Oferta relámpago","Text_UploadSameProductTip1":"1.Subir varias fotos del mismo producto desde diferentes ángulos para que la IA capte mejor cada detalle.","Text_UploadSameProductTip2":"2. Hasta 3 imágenes. La primera imagen se usará como la referencia principal, por lo que te sugerimos que elijas el mejor ángulo.","Text_UploadProductImage_APlusCase":"Sube una imagen de producto","Text_GenerateEcommerceLongImage_APlusCase":"Generar imagen larga","Text_MultiPlatform_APlusCase":"Cumple con los estándares de múltiples plataformas de e-commerce","Text_MainImage_ProductCase":"01 Imagen principal (Fondo blanco / Estándar)","Text_SceneDisplay_ProductCase":"02 Situaciones de uso","Text_ModelSceneImage_ProductCase":"03 Imágenes de modelos","Text_DetailDescription_ProductCase":"04 Detalles","Text_FeatureExplanation_ProductCase":"05 Puntos de venta","Text_UploadProductImage_ProductCase":"Sube imágenes de producto y la IA generará al instante sets de imágenes con altas tasas de conversión <span>que cumplen con los estándares de múltiples plataformas de e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Sube imágenes de tus prendas y crea un modelo personalizado para generar al instante distintas escenas y poses.","Text_UploadProductImage_DetailPage":"Sube imágenes de producto y la IA generará al instante una página profesional de detalles del producto <span>que cumple con los estándares de múltiples plataformas de e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Página de detalles del producto","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Inicia sesión para desbloquear tu prueba gratuita","Login_DK_Title":"Crea sorprendentes diseños gratis","Login_Zawa_Des":"Comienza a crear con Zawa hoy","Login_DK_Des":"Regístrate o inicia sesión para seguir diseñando. ¡Comienza ahora!","Tab_Module_ProductImage_TryOn_MultiMix":"Combina tus prendas en un outfit","Tab_Module_ProductImage_TryOn_SingleHero":"De una sola prenda a un look completo","Tab_Module_ProductImage_TryOn_Accessories":"El toque perfecto con accesorios","Text_ShowAdvancedModelTip":"Mostrar tips de modelos premium","Text_HideAdvancedModelTip":"Ocultar tips de modelos premium","Text_DeepSeekR1HelpWrite":"Ayúdame a escribir (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Superaste el máximo de ${0} intentos","Title_StandardEdition":"Estándar","Text_FastAndEfficient_Common":"Rápido y eficiente","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Mejora de calidad y detalles","Text_PremiumEngineActivated":"<strong>Motor premium activado:</strong> admite resultados en chino y ofrece detalles estéticos superiores con un mayor control creativo.","Text_EditBrand_DropTitle1":"Arrastra y suelta aquí archivos JPG, PNG o WEBP,","Text_EditBrand_DropTitle2":"o <>navega</> desde tu computadora.","Text_BaseToolbar_AlignTop":"Alinear arriba","Text_BaseToolbar_AlignBottom":"Alinear abajo","Text_LayerSort":"Ordenar","Text_BaseToolbar_AlignCenter":"Centro","Text_Attr_Strong":"Negrita","Text_GeneratingPlan_DetailPagePlan":"Generando plan…","Text_PlanGenerationFailed_ReTry":"Error al generar plan. Intenta de nuevo más tarde.","Button_StartAnalyze_ProductCase":"Comencemos","Message_SubmitSuccessTip_Batch":"Enviado. Puedes consultar los resultados en ${0} minutos.","Button_ClickAnalyze_ProductCase":"Analiza los estilos más vendidos","Button_StartAnalyzing_ProductCase":"Analizando","Title_ModelImage":"Modelo","Text_Cookie_Title":"Primero lo primero, las cookies 🍪","Text_Cookie_Content":"Nos gustaría usar cookies en este sitio web para garantizar la seguridad, un rendimiento eficiente y la optimización del servicio. Para saber más sobre cómo usamos las cookies, haz clic ","Text_Cookie_LearnMore":"Detalles","Button_Cookie_Manage":"Administrar cookies","Button_Cookie_Accept":"Aceptar","Text_CookieModal_Title1":"Configuración de cookies","Text_CookieModal_Desc1":"Las cookies son pequeños archivos de texto que los sitios web guardan en tu dispositivo para ayudarnos a recordar tus preferencias, analizar el tráfico y mejorar nuestros servicios. Tu privacidad es importante para nosotros y queremos que tengas el control de tus datos. Aquí puedes personalizar tus preferencias de cookies para optimizar tu experiencia de navegación. Ten en cuenta que cambiar esta configuración podría afectar el funcionamiento y los servicios de nuestro sitio web.","Text_CookieModal_Title2":"Cookies necesarias","Text_CookieModal_Desc2":"Estas cookies son esenciales para el funcionamiento, la seguridad y el rendimiento básico del sitio web. Sin ellas, las funciones clave y las medidas de seguridad de Zawa no funcionarán correctamente, lo que podría afectar negativamente tu experiencia.","Text_CookieModal_Title3":"Cookies opcionales","Text_CookieModal_Desc3":"Estas cookies nos ayudan a entender la cantidad de usuarios de Zawa, de dónde vienen y cómo usan el sitio web. Si decides desactivar estas cookies, no podremos recopilar información para mejorar Zawa ni ofrecerles un mejor servicio a ti y a otros usuarios.","Button_CookieModal_Save":"Guardar","Text_CookieModal":"Siempre activado","Text_Agent_Chat_DK":"Escribe tu idea...","Text_Agent_Chat_XD":"¿Qué te gustaría diseñar?","Radio_Color":"Paleta","Radio_Layout":"Diseño","Radio_Reference":"${0}","Radio_Posture":"Posar","Radio_Background":"Fondo","Language_Banner_Message":"¿Te gustaría cambiar a ${0}?","Language_Banner_Change":"Sí","Language_Banner_Other":"Más idiomas","Title_ItemTaskWithIndex_Batch":"Tarea de producto ${0}","Title_DetailTaskPrefix_Batch":"Tarea A+","Text_CopiedTaskTitle_Batch":"${0} (copia)","Message_SelectSectionMin_Batch":"Selecciona al menos una sección.","Title_GlobalBatchSettings_Batch":"Configuración global (se aplica a las siguientes tareas)","Text_Parameters_Batch":"Parámetros","Text_Modules_Batch":"Secciones","Title_KeyHighlights_Batch":"Puntos de venta","Text_ModulesFollowGlobal_Batch":"Secciones: usar configuración global","Title_SelectManagedBusinessType_Batch":"Seleccionar tipo de tarea","Button_SubmitTask_Batch":"Enviar","Text_NewTaskCurrentCount_Batch":"Crear tarea","Title_NotificationSettings_Batch":"Notificaciones","Title_ManagedMode_Batch":"Planificador","Button_SaveSettings_Batch":"Guardar configuración","Button_SaveAndContinueSubmit_Batch":"Guardar y enviar","Message_PhoneFormatInvalid_Batch":"Ingresa un número de teléfono válido de 11 dígitos.","Message_VerificationCodeSent_Batch":"Código de verificación enviado. El código es válido por 5 minutos.","Message_VerificationCodeSendFailed_Batch":"Error al enviar. Inténtalo de nuevo más tarde.","Message_PleaseEnterCode_Batch":"Ingresa el código de verificación.","Message_GetCodeFirst_Batch":"Primero, obtén un código de verificación.","Message_VerificationCodeExpired_Batch":"El código de verificación ha caducado. Solicita uno nuevo.","Message_SaveNotificationSettingsFailed_Batch":"Error al guardar la configuración de las notificaciones. Inténtalo de nuevo más tarde.","Text_WebMessageNotification_Batch":"Notificaciones web","Title_AppPushRecommended_Batch":"Notificaciones de la aplicación (recomendado)","Paragraph_AppPushDesc_Batch":"Haz seguimiento del progreso y consulta los resultados en tu teléfono en tiempo real. Mantén tus diseños siempre a mano y no pierdas ninguna oportunidad.","Text_AppDownloadQrCode_Batch":"Escanea para descargar la aplicación","Title_SmsNotification_Batch":"Notificaciones por SMS","Placeholder_Phone11Digits_Batch":"Un número de teléfono de 11 dígitos","Placeholder_VerificationCode5Min_Batch":"Código de verificación (válido por 5 minutos)","Text_SendingEllipsis_Batch":"Enviando...","Text_RetryAfterSeconds_Batch":"Inténtalo de nuevo en ${0}s","Button_GetVerificationCode_Batch":"Enviar código","Message_SubmitSuccess_Batch":"Enviado","Message_SubmitFailedRetry_Batch":"Error al enviar. Inténtalo de nuevo más tarde.","Message_FormValidationPassed_Batch":"Contenido válido","Message_CompleteNotificationSettingsFirst_Batch":"Configura las notificaciones antes de enviar la tarea.","Paragraph_CancelManagedTaskWarning_Record":"La tarea programada se eliminará permanentemente si cancelas ahora.","Button_ConfirmCancel_Record":"Cancelar de todas formas","Message_CancelManagedTaskFailed_Record":"Error al cancelar. Inténtalo de nuevo más tarde.","Text_WaitingManagedGeneration_Batch":"Programando tarea...","Text_WaitingManagedSubmit_Batch":"En fila","Message_NoExtendableImages_Result":"No hay imágenes disponibles","Text_IntelligentMultiSizeAdaptation_Result":"Redimensiona tus imágenes de forma inteligente para adaptarlas a cualquier pantalla","Button_IntelligentResize_Result":"Redimensionado inteligente","Option_CustomSize_DetailPageMode":"Personalizado","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"¡El planificador está listo para ayudarte!","Text_ManagedModeSlogan_Batch":"Trabaja por la noche para tener tus diseños listos cuando te despiertes.","Title_BatchProduction_Batch":"Generación por lotes","Paragraph_BatchProductionDesc_Batch":"Ejecuta hasta ${0} tareas simultáneamente y aumenta tu productividad en ${1}×.","Title_AiIntelligentExtraction_Batch":"Análisis con IA","Paragraph_AiIntelligentExtractionDesc_Batch":"Analiza tus imágenes y genera automáticamente puntos de ventas de alto impacto.","Title_SaveCost20_Batch":"Ahorra ${0}% en créditos","Paragraph_SaveCost20Desc_Batch":"Puedes programar tareas por la noche y disfrutar de un menor consumo de créditos.","重写":"Descarga por lotes","Brand_AutoExtract_Button":"Extraer colores","Brand_AutoExtract_Success":"Colores extraídos","Brand_AutoExtract_Failure":"No se pudieron extraer los colores. Inténtalo de nuevo.","Brand_AutoExtract_Unavailable":"No es posible extraer la paleta de colores.","Brand_AutoExtract_ConfirmTitle":"¿Extraer paleta de colores del logo?","Title_ImageSetConfig_ImageSet":"Diseño de publicación de productos","Title_DefaultConfig_ImageSet":"Diseño con IA","Desc_DefaultConfig_ImageSet":"Deja que la IA genere el mejor diseño para la publicación de tus productos.","Title_CustomConfig_ImageSet":"Diseño personalizado","Desc_CustomConfig_ImageSet":"Personaliza el número de imágenes para cada tipo. Selecciona al menos ${0} imágenes.","Label_WhiteBackground_ImageSet":"Imágenes con fondo blanco","Desc_WhiteBackground_ImageSet":"Muestra tu producto desde múltiples ángulos sobre un fondo blanco.","Label_Scene_ImageSet":"Escenarios de estilo de vida","Desc_Scene_ImageSet":"Presenta tu producto en escenarios de la vida real.","Label_SellingPoint_ImageSet":"Puntos de venta destacados","Desc_SellingPoint_ImageSet":"Destaca las características claves que hacen que tu producto se destaque.","Label_Other_ImageSet":"Otro","Desc_Other_ImageSet":"Contenido seleccionado automáticamente para tu producto, incluyendo comparativas, especificaciones y más.","Tip_MinTotal_ImageSet":"Al menos ${0} imágenes","Text_ManagedBatchEntry_Header":"Planificador","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Plan de créditos","Text_Higher_Plan":"Ya estás en un plan superior","Text_Try_Free":"Pruébalo ahora por $ 0","Text_Plus_Plan":"Plan Plus","Text_Pro_Plan":"Plan Pro","Button_Generate_Short_Common":"Generar","Message_DuplicateTaskSubmitConfirm_Common":"Los resultados ya fueron generados con estos ajustes. ¿Quieres generarlos de nuevo?","Text_CreditUnit_Common":"Crédito","Text_NewUserDiscountDesc_Product":"${0} créditos por la primera publicación de producto. ${2} créditos por cada {1} publicación(es) de producto adicional.","Text_NewUserLimitedTag_Product":"Descuento por nuevo usuario","Text_OriginalPrice_Product":"Original: ${0} créditos","Tip_MaxTotal_ImageSet":"Hasta ${0} imágenes","Text_AddDocumentTips":"Se admiten archivos Word, Excel, texto, PDF y Markdown","Tab_SolidColor":"Color liso","Tab_Gradient":"Degradado","Title_PresetGradient":"Ajustes preestablecidos","Title_PresetSolidColor":"Ajustes preestablecidos","Title_RecentlyUsed":"Recientemente utilizado","Title_Patterns":"Patrón","Title_NoFill":"Ninguno","Description_Brand_Reference":"Sube tus pósteres o tus recursos artísticos favoritos y Zawa usará ese estilo para crear diseños adaptados a tu estilo.","Text_Generating":"Generando…","Text_ChartSending":"Enviando","Text_PeopleUnSupport":"Aún no se admiten retratos","Button_CancelManagedBatch_ResultGroup":"Eliminar tarea","Button_DownloadZip_ResultGroup":"Descargar ZIP","Button_DownloadLongImage_ResultGroup":"Descarga combinada","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"No se puede cancelar una tarea ya esta enviada.","Button_GlobalAiWriting_Batch":"Escritura con IA","Text_StandardModel_DistributionBatch":"Modelo Estándar (Por lote)","Text_StandardModelDescription_Batch":"Ideal para inventarios extensos; maximiza tu alcance en el mercado.","Text_AdvancedModel_PremiumBatch":"Modelo Pro (Enfoque Específico)","Text_AdvancedModelDescription_Batch":"Imágenes de calidad superior, ideales para una rentabilidad basada en la precisión.","Message_MinSubmitTasks_Batch":"Envía al menos ${0} tareas.","Message_OverwriteSellingPointsConfirm_Batch":"Se ha completado la sección de puntos clave en ${0} tareas. ¿Cómo te gustaría aplicar los resultados de redacción por IA?","Button_OverwriteAll_Batch":"Reemplazar todo","Button_FillEmptyOnly_Batch":"Incompletas","Message_NoEmptySellingPointsToFill_Batch":"Los puntos clave de todas las tareas ya están completos.","Message_AiWritingFailedRetry_Batch":"Error en la redacción por IA. Inténtalo de nuevo más tarde.","Button_NewTask_Common":"Nueva tareas","Message_Generating_Time":"Tus tareas se realizarán durante la noche（${0}-${1}）. Vuelve mañana para revisar los resultados","Title_Total_Credits":"Créditos totales","Text_Used_AllFeatures":"Disponible para todas las funciones","Daily_Present_Credits":"Créditos del día","Daily_Credits_Desc":"Reclama a diario. Válido solo hasta el final del día.","Text_Inactive":"Inactivo","Text_Inactive_Monthly":"${0} créditos vencerán en los próximos 30 días.","TITLE_GUIDE_CUTOUT_LITE":"Se detectaron sellos o logos","GUIDE_DESC_CUTOUT_LITE":"Usa \\"Recorte de Sello/Logo\\" para un resultado más preciso.","GUIDE_ACTION_CUTOUT_LITE":"Recorte de Sello/Logo","TITLE_CUTOUT_LITE":"Recorte de Sello/Logo","TIP_CUTOUT_LITE":"Recortes precisos de sellos o logos","PROCESSING_CUTOUT_LITE":"Creando imágenes...","AFTER_CUTOUT_LITE":"Resultados","Button_Previous":"Anterior","Button_Next":"Siguiente","Button_Skip":"Omitir","Button_Apply":"Aplicar","Text_AgentExpert":"Especialista","Message_PleaseEnterLinkOrAsin_Clone":"Ingresa un enlace o un ASIN","Message_LinkAnalyzeFailed_Clone":"Error al analizar enlace","Message_UploadProductImageFirst_Clone":"Sube primero las imágenes del producto","Message_ProductImageThumbGenerateFailed_Clone":"Error al generar la miniatura. Vuelve a subirla.","Message_UploadProductImageFirst_ProductCase":"Sube una imagen de referencia o pega un enlace de producto","Message_ReferenceImageThumbGenerateFailed_Clone":"Error al generar la miniatura. Vuelve a subirla.","Title_ReferenceSource_Clone":"Referencia","Option_LinkAsin_Clone":"Enlace","Input_PasteProductLinkOrAsin_Clone":"Pega un enlace de Amazon","Button_Parsing_Clone":"Analizando…","Button_Parse_Clone":"Analiza","Text_SupportAmazonTiktokLinks_Clone":"Se admiten enlaces de Amazon y TikTok","Text_Cloning_ResultStatus":"Procesando…","Input_CloneRequirementOptional_Clone":"Requisitos (opcional)","Title_ProductOriginalImage_Clone":"Imagen de producto","Title_CloneLevel_Clone":"Fidelidad","Option_CompositionReference_Clone":"Estilo","Desc_CompositionReference_Clone":"Usa el estilo y la composición para ajustar automáticamente los colores y reconstruir la escena.","Option_HighFidelityClone_Clone":"Apariencia general","Desc_HighFidelityClone_Clone":"Usa la composición visual general. Reemplaza solo el producto y el texto, permitiendo ligeras variaciones en la escena.","Label_OutputStyleConsistent_Clone":"Estilo consistente","Title_SupplementaryNotesOptional_Clone":"Requisitos generales (opcional)","Input_SupplementaryNotesExample_Clone":"Ejemplo: genera textos de producto en inglés, mantén el mismo modelo y reemplaza solo el producto.","Title_HotClone_Welcome":"Clonar y crear","Text_HotCloneDescription_Welcome":"Diseños ganadores + tus productos = Tu próximo producto más vendido","Text_DefaultTaskName_Clone":"Estrategia de clonación de imágenes","Label_ProductImage_CloneCase":"Imagen de producto","Label_ReferenceComposition_CloneCase":"Estilo","Label_HighFidelityClone_CloneCase":"Apariencia general","Tag_AiSmartMatch_ImageSet":"Ajuste inteligente con IA","Title_Date":"Fecha","Title_Topic":"Tema","Button_Replace":"Reemplazar","Title_SingleCloneRequirement_Clone":"Requisitos individuales","Text_UploadedReferenceImagesTip_Clone":"Requisitos individuales para cada imagen de referencia. Se aplicarán los ajustes predeterminados si no se especifican requisitos.","Label_ReferenceImageIndex_Clone":"Imagen de referencia ${0}","Option_Mexico_Market":"México","Text_ParsingReferenceImages_Clone":"Analizando…","Text_ParseReferenceImagesSuccess_Clone":"Análisis completo. ${0} imágenes de referencia obtenidas.","Text_Renew_Restore":"Los créditos se restablecerán cuando se renueve tu suscripción.","Title_UsageNotice_Clone":"Guía del usuario","Text_UsageNoticeDescription_Clone":"Confirma que tienes el derecho legal para usar el contenido de este enlace. Los resultados generados se basan en un análisis de estilo realizado con IA y son solo de referencia creativa.","Label_ReadAndAgreeUsageNotice_Clone":"Acepto los términos anteriores","Label_DoNotShowAgain_Clone":"No volver a mostrar","Brand_StatusPopup_ProcessingTitle":"Zawa está analizando el estilo de tu marca...","Brand_StatusPopup_FailedTitle":"Error al extraer datos de Square. Inténtalo de nuevo más tarde.","Brand_StatusPopup_Retry":"Inténtalo de nuevo","SecondTitle_Header19_Home":"Clonar anuncios de video","SquareBrandGuide_BrandKitCreatedTip":"Tu kit de marca ha sido creado a partir de los datos de Square","SquareBrandGuide_DefaultPrompt":"Diseña un póster de producto para promocionarlo en redes sociales","SquareBrandGuide_SendTip":"¡Haz clic en Enviar para comenzar!","Paragraph_BatchProductionDescUnlimited_Batch":"Maneja múltiples tareas a la vez, lo que reduce drásticamente el cronograma de tus proyectos.","Menu_ViewDetail":"Detalles","Menu_CopyFullText":"Copiar todo","Tip_CopiedToClipboard":"Copiado en el portapapeles","Tip_CopyFailed":"Error al copiar","Menu_DownloadImage":"Descargar","Tip_NoImage":"Sin imágenes","Tip_DownloadStarted":"Descarga en curso","Menu_CopyText":"Copiar","Tip_NoTextToCopy":"No hay texto disponible","Message_LinkImageFetchFailed_Clone":"No pudimos cargar imágenes desde este enlace. Prueba con un enlace diferente o sube las imágenes.","Tab_Chat":"Chat","Tab_Files":"Files","Button_Create_New_Chat":"New chat","Tip_Agent_Team_Chat_Shared":"Viewing read-only version","RoboNeo_Web_input_default_content":"Chatear con RoboNeo","RoboNeo_Web_chatbox_maximum":"Límite de chat alcanzado","RoboNeo_Web_chatbox_maximum_text":"Límite de chat alcanzado. Crea una nueva tarea.","RoboNeo_Web_chatbox_new_task":"Nuevo proyecto","RoboNeo_Web_history_share_text":"Compartir","RoboNeo_Web_history_delete_text":"Eliminar","RoboNeo_Web_history_delete_hint_text":"Nota","RoboNeo_Web_history_delete_main_text":"El proyecto se eliminará permanentemente. ¿Deseas continuar?","RoboNeo_Web_history_delete_hint_confirm":"Eliminar","RoboNeo_Web_history_delete_hint_cancel":"Cancelar","RoboNeo_Web_studio_download":"Descargar","RoboNeo_Web_toast_share_text":"Compartir este chat","RoboNeo_Web_toast_share_main_text":"Cualquiera con el enlace del chat puede ver tu historial de chat","RoboNeo_Web_toast_share_copy":"Copiar enlace","RoboNeo_Web_toast_cancel":"Cancelar","RoboNeo_Web_toast_confirm":"Confirmar","RoboNeo_Web_studio_changing_toast":"No quedan usos gratuitos hoy, se restablecerán a medianoche. También puedes darle \\"ciberzanahorias\\" a Neo para continuar.","RoboNeo_Web_studio_changing_toast2":"No quedan usos gratuitos hoy.","RoboNeo_Web_new_studio":"Nuevo chat","RoboNeo_Web_sidebar_close":"Contraer","RoboNeo_Web_history_text":"Historial","RoboNeo_Web_sidebar_open":"Expandir","RoboNeo_Web_upload_warning_text":"No se pueden subir fotos y videos al mismo tiempo.","RoboNeo_Web_upload_format_text":"Formatos de imagen compatibles: JPG, PNG y JPEG. Formatos de video compatibles: MP4 y MOV.","RoboNeo_Web_upload_fail_text":"Error de carga","RoboNeo_Web_upload_image_maximum":"Puedes subir hasta {max_num} imágenes","RoboNeo_Web_upload_video_size_maximum":"Los videos que superen los {max_size} MB no son compatibles.","RoboNeo_Web_upload_image_size_maximum":"Las imágenes que superen los {max_size} MB no son compatibles.","RoboNeo_Web_upload_video_maximum":"Puedes subir hasta {max_num} videos","RoboNeo_Web_history_dafult_text":"No se encontró historial, chatea ahora.","RoboNeo_Web_upload_content_warning_text":"Los archivos con contenido potencialmente inapropiado no serán importados.","RoboNeo_Web_chat_send_fail":"Envío fallido, por favor, inténtalo de nuevo más tarde.","RoboNeo_Web_network_fail":"Error de conexión o tiempo de espera agotado, por favor inténtalo de nuevo.","RoboNeo_Web_studio_layer_fail":"Error al dividir capas.","RoboNeo_Web_studio_layer_success":"Completado","RoboNeo_Web_network_error":"Error de red","RoboNeo_Web_delete_success":"Eliminado","RoboNeo_Web_delete_fail":"Error al borrar","RoboNeo_Web_copy_success":"Copiado","RoboNeo_Web_file_uploading":"Cargando {num} archivos","RoboNeo_Web_file_upload_fail":"Error al cargar {num} archivos","RoboNeo_Web_file_upload_single_fail":"Error al subir 1 archivo","RoboNeo_Web_file_uploading_single":"Subiendo 1 archivo","RoboNeo_Web_upload_video_maximum_one":"Puedes subir hasta 1 video","RoboNeo_Web_sharepage_wanna_try":"Probar ahora","RoboNeo_Web_sharepage_load_to_end":"Ir a Resultados","RoboNeo_Web_studio_loading_text":"Cargando lienzo...","RoboNeo_Web_chatbox_add_image":"Añadir imágenes","RoboNeo_Web_chatbox_add_video":"Añadir video","RoboNeo_Web_image_editor_max":"Máximo 10 MB con 4096 px en el lado más largo","RoboNeo_Web_unlimited_pass_expired":"El Pase ilimitado ha expirado. Ahora estás utilizando los usos gratuitos disponibles.","RoboNeo_Web_studio_ai_image_successful":"UHD de IA: completado","RoboNeo_Web_studio_ai_image_failed":"UHD de IA: fallido","RoboNeo_Web_studio_cutout_successful":"Recorte exitoso","RoboNeo_Web_studio_cutout_failed":"Recorte fallido","RoboNeo_Web_studio_ai_edit_failed":"Edición con IA - fallida","RoboNeo_Web_studio_ai_edit_successful":"Edición con IA: completada","RoboNeo_Web_AI_generated":"Generado con IA","RoboNeo_Web_loading":"Cargando","RoboNeo_Web_view_creative_process":"Ver proceso creativo","RoboNeo_Web_try_now":"Probar ahora","RoboNeo_web_extender_successful":"Ampliador con IA: completado","RoboNeo_web_extender_failed":"Ampliador con IA: fallido","RoboNeo_web_eliminate_successful":"Eliminación con IA: completada","RoboNeo_web_eliminate_failed":"Eliminación con IA: fallida","roboneo_web_continue":"Continuar","roboneo_web_video":"Video","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"Este chat no se puede compartir, intenta iniciar uno nuevo.","roboneo_web_open_the_APP_experience":"Probar en la aplicación","roboneo_web_AI_generated_logo":"Este contenido generado por IA es solo de referencia.","roboneo_web_change_word_success":"Reemplazar texto: completado","roboneo_web_change_word_fail":"Reemplazar texto: fallido","roboneo_web_canvas_loading_failed":"Error al cargar el lienzo","roboneo_web_export_failed":"Error en la exportación","roboneo_web_export_tips2":"Solo admite exportar una imagen (hasta {width} px*{height} px).","roboneo_web_new_topic":"Nuevo chat","roboneo_web_waiting_reply":"Esperando respuesta","roboneo_web_file_saving_preferences":"Preferencia de archivo","roboneo_web_includes_AI_watermark":"Incluir marcas de agua con IA","roboneo_web_no_remind":"No mostrar de nuevo","roboneo_web_agree_continue":"Aceptar y continuar","roboneo_web_AI_generated":"Contenido generado por IA","roboneo_web_watermark_protocol":"Puedes elegir guardar las imágenes con o sin marcas de agua de \\"Generado con IA\\". Elegir guardar sin la marca de agua significa que aceptas: 1. No usar RoboNeoAI para crear, publicar o difundir información falsa. 2. Asegurar el cumplimiento de la ley e indicar claramente que dicho contenido fue generado con IA al usarlo o compartirlo.","roboneo_web_rectangle":"Cuadrado","roboneo_web_circle":"Redondo","roboneo_web_arrow":"Flecha","roboneo_web_image_fusion_success":"Completado","roboneo_web_image_fusion_failure":"Error","roboneo_chat_resources_num_limit_tips":"Puedes agregar hasta {img_num} videos y {video_num} imágenes.","RoboNeo_Web_export_confirm_tip_popup_title":"Opción para exportar con o sin una marca de agua de «Generado por IA».","RoboNeo_Web_export_confirm_tip_popup_btn":"Veo"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-next/id.json
const x_design_locales_next_id_namespaceObject = JSON.parse('{"Tab_Design":"Desain","Button_Send":"Kirim","Input_Describe_Workspace":"Tuliskan deskripsi gambar dan aku akan membuatnya","Tab_AgentCase":"Kasus agen","Tab_RecentCreations":"Terbaru","Tag_Hot":"Hits","Tag_BrandDesign":"Desain Merek","Tag_Logo":"Logo","Tag_Posters":"Poster","Tab_Agent":"Agen","Tool_AiPhotoEditor":"Editor Foto","Button_Upload":"Unggah","Tool_Designer":"Poster","Title_AiTool":"Alat AI","Tool_ImageBackgroundRemover":"AI Penghapus Background","Tool_AiBackgroundGenerator":"AI Background","Tool_ImageEnhancer":"Penyempurna Foto","Tool_AiObjectsRemover":"AI Penghapus Objek","Tool_AiModelMannequin":"AI Model - Manekin","Tool_AiModelFlatlay":"AI Model - Flatlay","Tool_AiImageRecolor":"AI Mewarnai Foto","Tool_AiImageExtender":"AI Perluas Gambar","Tool_ImageUpscaler":"AI Zoom Foto","Tool_AiLogo":"AI Pembuat Logo","Button_BlankCanvas":"Buat","Sidebar_Create":"Beranda","Sidebar_Tools":"Alat AI","Sidebar_Batch":"Editor Massal","Sidebar_MyDesigns":"Desain Saya","Sidebar_Inspire":"Berikan Inspirasi","Sidebar_Brand":"Kit Merek","Sidebar_PackUp":"Tutup bar samping","Tag_All":"Semua","Tag_Design":"Desain","Sidebar_Unfold":"Buka bar samping","Menu_Edit":"Edit","Menu_Download":"Unduh","Menu_Delete":"Hapus","Tab_RecentlyCreated":"Terbaru","Tab_GenerateRecords":"Kreasi","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Hanya untuk Agen AI dan akan digunakan terlebih dahulu.","Menu_DueToday":"Kredit bonus harian","Menu_DueToday_Explain":"Berlaku satu hari hingga pukul 24.00.","Menu_Else_AgentCredits":"Kredit lainnya","Button_GoPro_GetMore":"Dapatkan lebih banyak kredit","Menu_Total_Explain_PaidCredits":"Untuk semua fitur dan berlaku selama periode keanggotaan.","Menu_Pro":"Kredit langganan","Menu_Pro_Explain":"Berlaku selama periode keanggotaan.","Menu_Else":"Kredit lainnya","Menu_Else_Explain_PaidCredits":"Kredit dari sumber lain. Setiap jenis mungkin memiliki masa berlaku sendiri.","Menu_Else_Explain_AgentCredits":"Kredit dari sumber lain. Berlaku untuk jangka waktu lebih lama.","Menu_UsageDetail":"Detail penggunaan","Menu_Total_Explain_SuspendCredits":"Tidak tersedia hingga keanggotaan kembali aktif.","Tab_Invite":"Undang","Menu_InviteReward":"Hadiah Undang Teman","Tab_Reward":"Hadiah","Title_AgentCreditForRewards":"Hadiah kredit agen:","Table_Time":"Waktu","Table_Invitee":"Undangan","Title_ShareWithFriends":"Bagikan dengan teman","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Undang teman dan kalian berdua akan menerima </span><span style=\\"color:#2D990C;\\">${0} Kredit Agen!</span>","Title_InvitationLink":"Bagikan tautan ini dengan teman","Button_Copy":"Salin","Title_Tips":"Tips","Title_Tips_ExplainOne":"1. Kredit Agen hanya dapat digunakan untuk mengakses fitur Agen AI. Kredit hadiah berlaku selama dua tahun.","Title_Tips_ExplainTwo":"2. Teman baru akan menerima hadiah setelah pendaftaran berhasil. Jika ada pertanyaan, silakan hubungi tim dukungan kami.","Title_GetRewarded":"Undangan berhasil!","Title_GetRewarded_Explain":"Kredit hanya dapat digunakan untuk fitur Agen AI dan berlaku selama dua tahun.","Button_Ok":"Mengerti","Title_FailedToReceiveReward":"Operasi gagal","Title_FailedToReceiveReward_Explain":"Jika ada pertanyaan, silakan hubungi tim dukungan kami.","Input_Describe_workspace":"Tuliskan deskripsi gambar dan aku akan membuatnya","Tool_AiBackgroundGenrator":"AI Background","Title_YouCannotUseYourOwnLink":"Tautan pribadi tidak diizinkan","Table_AgentCredit":"Kredit Agen","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">Undang maksimal </span><span style=\\"color:#2D990C;\\">${0} teman baru</span><span style=\\"color:#616266;\\"> dan dapatkan maksimal ${1} Kredit Agen!</span>","Button_Invite":"Undang","Menu_Title_Invite":"Ajak Teman","Text_Button_Invite":"Dapatkan Kredit","Title_Dialog_Invite":"Ajak Teman","Desc_Dialog_Invite":"Bagikan tautan dengan teman atau posting di media sosial. Ketika ada yang mendaftar setelah mengklik tautan tersebut, Anda dan teman tadi akan menerima ${0} kredit. Jika mereka berlangganan, maka masing-masing akan menerima hingga ${1} kredit lagi.    ","Detail_Dialog_Invite":"Detail","Text_Copy_Invite":"Salin tautan","Title_Rewards_Invite":"Hadiah","SubTitle_Rewards1_Invite":"Total kredit diperoleh","SubTitle_Rewards2_Invite":"Pengguna gratis dari referal","SubTitle_Rewards3_Invite":"Pengguna berbayar dari referal","Success_Copy_Invite":"Tautan disalin","Title1_Invited_Invite":"Anda diundang!","Text_Rule1_Invite":"Untuk setiap teman yang mendaftar menggunakan tautan tersebut, masing-masing akan mendapatkan <strong>${0} kredit</strong>.","Text_Rule2_Invite":"Jika teman berlangganan, masing-masing akan mendapatkan kredit tambahan (<strong>${0} untuk Plus, ${1} untuk Pro</strong>).","Text_Rule3_Invite":"Langganan yang telah dibeli tidak dapat direfund jika paket atau kredit yang diberikan telah digunakan. Selain itu, kredit gratis tidak dapat dikembalikan setelah digunakan.","Text_Rule4_Invite":"Setiap pengguna dapat mengundang maksimal ${0} teman.","Text_Rule5_Invite":"Hadiah tidak akan diberikan untuk referal yang sudah punya akun, referensi ke diri sendiri, akun ganda, atau aktivitas penipuan.","Text_Rule6_Invite":"${0} berhak menyesuaikan program dan mencabut hadiah dari akun yang teridentifikasi tidak wajar.","Text_Divider_Invite":"atau bagikan tautan","Title2_Invited_Invite":"Bergabunglah ke ${0} dan klaim hadiahnya","SubTitle1_Invited_Invite":"Seorang teman mengundangmu untuk mencoba agen Al merek profesional kami. Buat desain pemasaran merek berkualitas tinggi seperti logo, poster, menu, dan aset media sosial dengan mudah.  ","SubTitle2_Invited_Invite":"<strong>Daftar sekarang</strong> dan masing-masing akan <strong> mendapatkan ${0} kredit</strong>.<strong> Jika berlangganan,</strong> masing-masing akan mendapatkan kredit tambahan sesuai dengan paket yang dipilih (<strong>${1} kredit untuk Plus atau ${2} kredit untuk Pro</strong>). Daftar sekarang dan klaim hadiahnya.","Button_Invited_Invite":"Daftar dan klaim hadiahnya","Success_Invited_Invite":"Anda bergabung melalui referal dan mendapatkan ${0} kredit.","Error_Invited_Invite":"Anda sudah punya akun.","Text_Share_Invite":"Aku menggunakan ${0} untuk membuat logo, visual, dan video dengan cepat dan mudah. Daftar melalui tautan ini dan kita berdua akan mendapatkan bonus kredit.","Title_Share_Invite":"Bergabunglah ke ${0} dan dapatkan bonus kredit!","Share_Email_Invite":"Email","Text_Rule7_Invite":"Kamu bisa menggunakan kredit untuk Agen AI. Kredit akan kedaluwarsa setelah satu bulan.  ","Title_AgentCredits":"+50 Kredit Agen","Input_Models":"Model","Button_TryItNow":"Coba sekarang","Account_Pricing":"Harga","Account_Language":"Bahasa","Account_Language_English":"Inggris","Account_Language_Chinese":"Mandarin","Tips_Adding":"Memproses...","Tips_Loading":"Memuat...","Tips_Creating":"Memproses...","Tips_Downloading":"Mengunduh...","Tips_Sending":"Mengirim…","Tips_AddSuccess":"Berhasil ditambahkan","Tips_MakeSameError":"Tidak dapat membuat ulang","Tips_UnsupportedGradientColor":"Gradien tidak didukung","Tips_CanNotAdding":"Gagal ditambahkan","Tips_Uninitialized":"Gagal mengirim pesan","Tips_UploadFailed":"Gagal mengunggah. Harap coba lagi.","Tips_UploadMaxCountLimit":"Unggah maksimal ${n} ${type} file","Tips_UploadMaxFileSize":"Tidak dapat mengunggah file ${file}. Gunakan file maksimal ${n} MB.","Tips_UploadImageAndVideoLimit":"Bisa mengunggah 1 foto dan 1 video sekaligus","Tips_UnsupportedSvgFile":"File SVG tidak didukung","Tips_UnsupportedUploadFileFormats":"Format file ${files} tidak didukung","Tips_CanNotAddSameFileTips":"File sudah ada","Tips_TextMinLengthTips":"Masukkan maksimal ${n} karakter","Tips_TextMaxLengthTips":"Masukkan maksimal ${n} karakter. Setiap karakter Mandarin atau emoji dihitung sebagai 2.","Tips_AccessDenied":"Akses ditolak","Tips_CreateFailed":"Inisiasi obrolan gagal","Tips_Error":"Terjadi kesalahan","Tips_NotFound":"Obrolan tidak ada","Tips_RequestAgentModelListError":"Gagal meminta daftar model Agen","Desc_Ended":"Selesai","Button_PeopleUse_Agent":"${n} pengguna mencoba","Dropdown_AddToChat":"Tambah ke Obrolan","Dropdown_AddToBrandKit":"Tambah ke Kit Merek","Dropdown_SaveToBrandKit":"Simpan sebagai logo merek","Dropdown_SaveToBrandTemplate":"Simpan sebagai templat merek","Title_Design_Agent":"Desain","Title_MainColor":"Warna primer","Title_SecondaryColor":"Warna sekunder","Bitton_ViewTheBrandKit":"Klik untuk melihat kit merek","Dropdown_InportImages":"Impor foto","Title_Upgrade_Pro":"Upgrade","Desc_SubscribeToUnlock_Pro":"Berlangganan dan dapatkan lebih banyak!","Desc_RunOutOfFreeUses_Pro":"Penggunaan gratis sudah habis.","Desc_RunOutOfUsesForToday_Pro":"Penggunaan gratis untuk hari ini sudah habis. Silakan kembali lagi besok.","Desc_PurchaseCompleted_Pro":"Pembelian selesai","Desc_ContinueDesign_Pro":"Sekarang desain bisa dilanjutkan!","Button_UnlockNow":"Berlangganan","Tips_Copied":"Disalin!","Tips_Credit_Explain_Paid":"Apa itu kredit yang dibeli?","Title_Total_InactiveCredits":"Total kredit tidak aktif","Title_Total_PaidCredits":"Total kredit yang dibeli","Menu_SuspendCredits":"Kredit tidak aktif","Menu_Credits":"Kredit","Tab_RecentCreations_Agent":"Agen","Tab_RecentCreations_Design":"Alat Pintar","Menu_FunctionalPricing":"Harga Agen","Title_Total_AgentCredits":"Total - Kredit agen","Tips_Credit_Explain_Agent":"Apa itu Kredit agen?","Title_FeaturePricing":"Harga Agen","Tab_Category":"Kategori","Tab_TaskType":"Tugas","Tab_Consume":"Harga (Kredit)","Tab_ExampleContent":"Contoh","Tips_CreditExplain_Inactive":"Apa itu kredit tidak aktif?","langding_more_bg_remover":"Penghapus Background","langding_more_enhancer":"Penyempurna Foto","langding_more_objects_remover":"AI Penghapus Objek","langding_more_bg_generator":"AI Background","Title_More1_Home":"Penyempurna Foto","Title_More2_Home":"AI Penghapus Objek","Title_More3_Home":"AI Background","Title_More4_Home":"AI Penghapus Background","Title_More5_Home":"Alat Foto Banyak","Title_Home":"Agen AI Desain <span>E-Commerce</span>","Placeholder_Input_Home":"Tuliskan deskripsi gambar dan aku akan membuatnya.","Title_Card4_Home":"Visual untuk Amazon","Title_Card1_Home":"Gambar Coba Pakaian & Aksesori","Title_Card3_Home":"Gambar Halaman Detail Produk","Title_Card2_Home":"Pembuat Background","Desc_Features1_Home":"AI secara otomatis mengekstrak fitur produk dan preferensi gaya untuk menentukan solusi desain yang ideal.","Desc_Features2_Home":"Cukup masukkan satu kalimat, dan AI akan menghasilkan koleksi foto untuk e-commerce, termasuk foto utama, visual pendukung, dan halaman detail produk lengkap.","Text_Btn_Home":"Mulai Gratis","Desc_Features3_Home":"Secara otomatis membuat visual platform yang disesuaikan untuk Amazon, Etsy, TEMU, eBay, dan lainnya, memastikan foto selalu dioptimalkan untuk menarik audiens yang tepat.","Desc_Features4_Home":"Cukup masukkan prompt, dan AI akan menyesuaikan bahasa, gaya, dan elemen budaya untuk menghasilkan versi lokal untuk setiap pasar target.","Desc_Features5_Home":"Simpan alur kerja desain sebagai templat yang dapat digunakan ulang, dan AI akan otomatis membuat foto untuk semua SKU secara massal.","Desc_Features6_Home":"Menghasilkan rangkaian visual yang lengkap dan konsisten untuk 10 atau 1.000 produk dengan cepat dan mudah.","Title_Qualification_Home":"Dipercaya oleh Lebih dari 5 Juta Online Seller!","Text_Btn_Qualification_Home":"Lihat Sertifikasi","Title_Carousel_Home":"Alat AI lainnya","Title_Footer_Home":"Agen AI Desain E-Commerce","Title_Footer1_Home":"Akun Media Sosial","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Bantuan & Hukum","Subtitle_Footer5_Home":"Ketentuan Layanan","Subtitle_Footer6_Home":"Kebijakan Privasi","Copyright_Footer_Home":"Hak Cipta ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Aku suka Designkit! Hasil fotonya terkesan real dan alami, nyaman dan bernuansa Nordik, cocok untuk toko lilinku. Daftar produk jadi terlihat rapi dan penjualan meningkat. Sangat sepadan.","Job_Evaluation5_Home":"Seller TEMU di Meksiko","Job_Evaluation6_Home":"Spesialis operasional Amazon","Job_Evaluation12_Home":"Manajer toko dari toko Amazon di Indonesia dengan berbagai SKU","Job_Evaluation2_Home":"Penilik toko Amazon & Mercado Libre ","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"Gambar suasana lifestylenya terlihat sangat natural, mirip seperti hasil pemotretan profesional. Pelanggan saya sepertinya juga menyukainya, dan saya bahkan melihat pembelian makin meningkat.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Pemilik toko lintas batas di Lazada & Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Desainer E-commerce DTC","Job_Evaluation8_Home":"Pemilik toko Produk Outdoor Walmart di Amerika","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Seller Mercado Libre di Argentina","Desc_Evaluation7_Home":"Foto produk hewan peliharaan yang dibuat AI itu sangat lucu! Kucing dan anjingnya terlihat proporsional dan alami. Selain itu, ukuran dan skalanya sesuai dengan persyaratan platform, jadi gambarnya bisa langsung digunakan.","Job_Evaluation7_Home":"Pemilik toko Mercado Libre di Brasil","Desc_Evaluation8_Home":"Foto berkemah untuk produk tenda saya terlihat sangat realistis. Pencahayaan dan sudutnya terasa natural, dan proporsinya tepat sekali. Benar-benar menghemat banyak waktu dibandingkan kalau memotret semuanya sendiri.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"Alat ini sangat cepat, dan foto yang dihasilkan pada dasarnya bisa langsung diunggah ke Mercado Libre dan Amazon tanpa perlu penyesuaian tambahan.","Desc_Evaluation6_Home":"Dulu saya khawatir AI tidak bisa menampilkan tekstur kain, tetapi ternyata teksturnya hampir tidak berbeda dari aslinya. Pakaian rajutan terlihat seperti aslinya, bahan denim juga, dan bahkan memenuhi persyaratan foto untuk Amazon. Saya bisa meluncurkan produk baru jauh lebih cepat.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"Foto produk yang dibuat AI sangat akurat. Panjang kabel dan bentuk konektornya tepat, bahkan sesuai dengan ketentuan TEMU. Sangat menghemat waktu dibandingkan kalau memotret sendiri.","Desc_Evaluation12_Home":"Hanya dengan satu prompt, saya mendapatkan grafis yang bisa digunakan secara instan, jauh lebih cepat daripada menunggu desainer. Jujur saja, ini sangat praktis.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"Tekstur metalik dan detail strukturalnya sangat jelas, sehingga membuat foto terlihat profesional. Saya bisa langsung menggunakannya tanpa perlu mengedit lagi.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"Pemrosesan massal sangat praktis. Saya bisa memproses puluhan SKU sekaligus, dan jauh lebih cepat daripada melakukannya secara manual.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Aku menjual pakaian, dan aku takut AI tidak bisa menampilkan warna atau tekstur kain dengan benar, tapi ternyata hasilnya luar biasa! Pose modelnya terlihat natural, dan pada dasarnya semua foto langsung siap digunakan.","Job_Evaluation1_Home":"Spesialis operasional toko SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Spesialis Operasional Amazon","Desc_Evaluation2_Home":"Alat ini sangat cepat, dan pada dasarnya hasil fotonya sudah siap diunggah ke Mercado Libre atau Amazon. Bahkan, alat ini bisa menyesuaikan latar belakang dan model dengan selera lokal, dan hasilnya terlihat sangat profesional.","Job_Evaluation4_Home":"Seller eBay di Jerman","Title_Evaluation_Home":"Kisah Pengguna","Title_Introduction_Home":"Desain AI premium yang meningkatkan penjualan lebih tinggi","Desc_Qualification_Home":"Penyedia Layanan Bersertifikasi SPN Amazon","Title_Seo_Home":"AI Pembuat Foto & Video Produk untuk E-commerce","Desc_Seo_Home":"Buat foto produk, poster, dan video secara instan untuk Amazon, TikTok, dan toko online lainnya dengan Agen AI Designkit. Mulai desain secara gratis sekarang!<br>","Keywords_Seo_Home":"Agen AI untuk E-commerce, Alat AI E-commerce, AI Pembuat Foto Produk, AI Pembuat Video Produk, AI Editor Foto Produk, AI Penghapus Background","Title_Features1_Home":"Dari satu permintaan menjadi satu rangkaian visual lengkap","Title_Features2_Home":"Lokalisasi sepenuhnya otomatis untuk menjual produk secara global di berbagai platform","Title_Features3_Home":"Buat foto otomatis dalam jumlah besar untuk beberapa SKU dan kalahkan para kompetitor!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Gulir untuk mengeksplorasi","Tips_Material1_Home":"Set foto daftar","Tips_Material2_Home":"Coba pakaian virtual","Tips_Material3_Home":"Konten A+","Tips_Material4_Home":"Pembuat background","Free_Button_Home":"Coba gratis","Title_Header1_Home":"Produk","Title_Header2_Home":"solusi","Title_Header3_Home":"Inspirasi","Title_Header4_Home":"Pelajari","Title_Header5_Home":"Harga","SecondTitle_Header1_Home":"AI Agen E-Commerce","SecondTitle_Header2_Home":"AI Alat Foto","SecondTitle_Header3_Home":"AI Alat Video","SecondTitle_Header4_Home":"Solusi Desain Amazon","SecondTitle_Header5_Home":"Solusi E-Commerce Media Sosial","SecondTitle_Header6_Home":"AI Pembuat Foto Produk","SecondTitle_Header7_Home":"AI Pembuat Model Fashion","SecondTitle_Header8_Home":"Ganti Warna Baju","SecondTitle_Header9_Home":"Pembuat Video Produk","SecondTitle_Header10_Home":"Alat AI","SecondTitle_Header11_Home":"AI Editor Foto","SecondTitle_Header12_Home":"AI Editor Foto Online","SecondTitle_Header13_Home":"Editor Foto Massal","SecondTitle_Header14_Home":"AI Editor Foto Massal","SecondTitle_Header15_Home":"Restorasi Foto Banyak","SecondTitle_Header16_Home":"Penghapus Watermark Massal","SecondTitle_Header17_Home":"Pembuat Background Massal","SecondTitle_Header18_Home":"Penghapus Background Foto Banyak","Title_Footer3_Home":"Alat Desain","Subtitle_Footer8_Home":"AI Editor Foto","Subtitle_Footer7_Home":"AI Ganti Background","Subtitle_Footer9_Home":"Background Transparan","Subtitle_Footer10_Home":"Ganti Warna Background","Subtitle_Footer11_Home":"Penghapus Watermark Foto","Subtitle_Footer12_Home":"Hapus Teks di Foto","Subtitle_Footer13_Home":"Tambah Stiker di Foto","Subtitle_Footer14_Home":"Tambah Watermark di Foto","Title_Footer4_Home":"Model Foto","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Unduh Gratis","Subtitle_Footer16_Home":"APP iOS","Subtitle_Footer17_Home":"APP Android","Title_Footer6_Home":"Follow Kami","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Model Video","Button_Export":"Unduh","Title_Layer":"Layer","InputNumber_Opacity":"Keburaman","Buttom_Comfirm":"Konfirmasi","Button_Share":"Bagikan","Button_Delete":"Hapus","Title_LoginPopup":"Login untuk memulai uji coba","SubTitle_LoginPopup":"Mulai berkarya dengan Zawa sekarang","Tip_ModalTitle":"Pengingat","TipContent_HistoryDelete":"Data yang telah dihapus tidak dapat dikembalikan. Konfirmasikan penghapusan?","Title_Logo":"Logo","Title_BrandKit":"Templat","Tab_BrandKit":"Kit Merek","Tab_UploadLocal":"Pilih dari album","Button_UploadImage":"Unggah Foto","Button_UploadProductImage":"Unggah Foto Produk","Button_UploadReferImage":"Referensi","Tip_ClickDragParseImage":"Unggah, seret, atau rekatkan foto di sini.","Tip_UploadMax":"Unggah file JPG, JPEG, atau PNG berukuran maks ${0} MB, maksimal N gambar.","Tooltip_SwitchBrandKit":"Ganti kit merek","Discribe_BrandKitSelect":"Pilih gaya merek sebagai referensi untuk desain ini.","Title_Models":"Model","Switch_Auto":"Otomatis","Tab_Image":"Foto","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Simpan sebagai logo merek","MenuItem_AddToBrandTemplate":"Simpan sebagai templat merek","Button_ExportImage":"Impor foto","Button_ExportMedia":"Impor video","Button_ExportFromBrandkit":"Impor dari Kit Merek","Dropdown_AddFromBrandkit":"Tambahkan dari Kit Merek","Placeholder_ChatInput":"Mari mulai!","MenuItem_AiChange":"AI Pengeditan","MenuItem_AiExpend":"AI Perluas","MenuItem_AiHD":"AI Kejernihan","MenuItem_Eliminate":"AI Penghapus","MenuItem_SplitLayers":"Pisahkan Layer","MenuItem_Cutout":"Penghapus BG","MenuItem_ChangeText":"Ganti Teks","MenuItem_Crop":"Ukuran Gambar","MenuItem_AddToChat":"Tambah ke Obrolan","MenuItem_AddToBrand":"Tambah ke Kit Merek","Tooltip_Layer":"Layer","Tooltip_Grab":"Alat tangan","Tooltip_Select":"Pilih","Tooltip_Redo":"Ulangi","Tooltip_Undo":"Batalkan","Tooltip_Add":"Tambah","Tooltip_ShowAll":"Tampilkan semua","Tip_UploadType":"Format file tidak didukung","Tip_UploadSize":"Hanya mendukung file berukuran maks ${0} MB","Tip_UploadWH":"Pastikan setiap gambar tidak lebih dari ${0}×${1} piksel","Tip_UploadTypeTranslate":"Gagal mengubah format file","Tip_UploadFail":"Unggahan gagal","Tooltip_AddText":"Tambah teks","Text_AddDefault":"Ini adalah teks contoh.","Tooltip_OverflowImageSize":"Ubah ukuran gambar sehingga maks ${0} piksel","Placeholder_ImageFusion":"Jelaskan bagaimana foto tersebut harus digabungkan","Button_ImageFusion":"Gabungkan","Button_Cancel":"Batal","Button_AiChange":"Edit","Placeholder_AiChange":"Jelaskan apa yang ingin diubah","Button_Eliminate":"Penghapus","Label_OriginSize":"Original","Label_CropRadio":"Rasio aspek","Button_Free":"Bebas","Button_Origin":"Original","Button_Crop":"Pangkas","Placeholder_ChangeText":"Masukkan teks. Contoh: Halo","Button_ChangeText":"Konfirmasi","InputNumber_PanSize":"Ukuran kuas","Label_TargetSize":"Target","Tooltip_ImageFusion":"${0}-${1} gambar bisa digabungkan","Title_Workspace":"Agen AI Kreatif untuk Branding","Button_Pro":"Dapatkan Pro Gratis","Title_NanoPro":"🍌🍌Nano Banana Pro kini tersedia di Zawa.","Dropdown_AdvancedFeatures_Title":"Fitur Lanjutan","Dropdown_AdvancedFeatures_Conent":"Akses penuh ke semua alat yang didukung AI untuk meningkatkan efisiensi.","Dropdown_MassiveContent_Title":"Konten Lengkap","Dropdown_MassiveContent_Content":"Akses premium sepuasnya ke templat dan jajaran aset stok Plus.","Dropdown_CommercialRights_Title":"Hak Komersial","Dropdown_CommercialRights_Content":"Gunakan kreasi pribadi dengan percaya diri, didukung oleh jaminan perlindungan hak cipta.","Popup_SubscribeIntl_Desc":"Dapatkan manfaat maksimal dari Zawa dengan Pro","Popup_SubscribeIntl_Desc1":"Lebih banyak berkreasi dengan kredit","Popup_SubscribeIntl_Detail":"Lihat detail paket & Bantuan","Popup_StripeCheckout":"Checkout Stripe","Popup_LiveSupport":"Dukungan langsung","Popup_CancelAnytime":"Bisa dibatalkan sewaktu-waktu","Menu_Language":"Bahasa","Menu_ManageSubscription":"Kelola Langganan","Menu_TermsPolices":"Ketentuan dan Kebijakan","Menu_ManageSubscriptions":"Kelola Langganan","Menu_ReferralLink":"Tautan Referral","Menu_BenefitsUpgraded":"Manfaat","Menu_TermsPolicies":"Ketentuan dan Kebijakan","Menu_AccountManagement":"Akun","Title_ReferralCode":"Kode Referral","Title_ReferralLink":"Tautan Referral","Desc_NoActiveSubscription":"Tidak ada langganan aktif","Button_ClickToSubscibe":"Klik di sini untuk berlangganan","Title_SubscriptionCancel":"Langganan telah dibatalkan","Title_SeeYou":"Sedih sekali Anda pergi...😭","Desc_NextBillingDate":"Perpanjangan pada","Desc_EstimatedAmount":"Estimasi total","Button_CancelSubscription":"Batalkan langganan","Button_StaySubscribed":"Tetap berlangganan","Title_ReasonCancelling":"Harap pilih alasan pembatalan:","Desc_BenefitsContinue":"Anda masih bisa menikmati manfaat keanggotaan hingga akhir periode langganan.","Desc_GiftedCredits":"Setelah langganan berakhir, kredit yang diberikan","Desc_SeeYou":"Terima kasih telah memilih kami. Kami sedih melihat Anda pergi.","Desc_NoNoreCharges":"Anda tidak akan lagi ditagih biaya, dan keanggotaan akan tetap aktif hingga","Desc_MayBeRevoked":"dapat ditarik kembali.","Desc_CancelingNoRefund":"Pembatalan <span>tidak termasuk refund<span>. Untuk pertanyaan terkait refund, silakan hubungi layanan dukungan online.","Button_ClearSelection":"Batal pilih","Button_Confirm":"Konfirmasi","Message_Processing":"Memproses...","Title_Opacity":"Keburaman","Button_ExpandImage":"Perluasan","Button_ExpandRadio":"Rasio aspek","Title_NoDesigns":"Belum ada desain.","Title_NoGenerations":"Belum membuat apa pun.","Desc_NoDesigns":"Desain Anda akan ditampilkan di sini.","Desc_NoGenerations":"Pemrosesan akan ditampilkan di sini.","Title_DeleteDesign":"Hapus desain ini","Popup_DeleteDesign":"Yakin ingin menghapus desain ini secara permanen? Tindakan ini tidak dapat dibatalkan.","Message_SaveFail":"Gagal menyimpan","Title_Pricing":"Pilih Paket yang Tepat","Title_Tags1_Pricing":"Bulanan","Text_Discount_Pricing":"Diskon ${0}","Title_Tags2_Pricing":"Tahunan","Title_Plan1_Pricing":"Bebas","Current_Plan_Pricing":"Paket saat ini","Title_Instruction1_Pricing":"Dapatkan 20 kredit untuk login perdana","Title_Instruction2_Pricing":"Buat maksimal 20 foto dengan Agen AI","Title_Instruction3_Pricing":"Buat maksimal 10 foto dengan AI Background","Title_Rights1_Pricing":"Penghapusan background atau objek terbatas","Title_Rights3_Pricing":"Penyempurnaan gambar HD terbatas","Title_Plan2_Pricing":"Paket Dasar","Month_Plan_Pricing":"bulan","Title_Button1_Pricing":"Berlangganan","Title_Instruction4_Pricing":"500 kredit/bln","Title_Instruction5_Pricing":"Buat maksimal 500 foto dengan Agen AI","Title_Instruction6_Pricing":"Buat maksimal 250 foto dengan AI Background","Title_Plan3_Pricing":"Paket Pro","Desc_Plan_Pricing":"Uji coba gratis 7 hari. Lalu ${0}/tahun.","Title_Button2_Pricing":"Uji coba gratis 7 hari","Title_Instruction7_Pricing":"1.500 kredit/bln","Title_Instruction8_Pricing":"Buat maksimal 1.500 foto dengan Agen AI","Title_Instruction9_Pricing":"Buat maksimal 750 foto dengan AI Background","Title_Rights4_Pricing":"Penghapusan background atau objek sepuasnya","Title_Rights5_Pricing":"Gunakan fitur AI penghapus sepuasnya","Title_Rights6_Pricing":"Penyempurnaan gambar UHD sepuasnya","Title_Rights7_Pricing":"Alat pemrosesan massal","Title_Best_Pricing":"Dipilih oleh 90% pengguna","Title_AllFeatures_Pricing":"Bandingkan Paket Gratis dan Berbayar","Desc_AllFeatures_Pricing":"Beli Premium untuk membuat desain menakjubkan dengan mudah menggunakan alat AI canggih","Month_AllFeatures_Pricing":"bulan","Title_Features1_Pricing":"Agen AI","SubTitle_Features1_Pricing":"Pengeditan Gambar","SubTitle_Features15_Pricing":"Buat maks ${0} gambar","SubTitle_Features16_Pricing":"Buat maks ${0} gambar/bln","SubTitle_Features2_Pricing":"Pembuatan Gambar","SubTitle_Features3_Pricing":"Pembuatan Gambar E-commerce","SubTitle_Features4_Pricing":"Pembuatan Poster","Title_Features2_Pricing":"AI Alat Foto","SubTitle_Features5_Pricing":"AI Penghapus Background","SubTitle_Features17_Pricing":"Penggunaan terbatas","SubTitle_Features19_Pricing":"Penggunaan sepuasnya","SubTitle_Features6_Pricing":"AI Penghapus Objek","SubTitle_Features7_Pricing":"Penyempurna Foto","SubTitle_Features18_Pricing":"Penggunaan terbatas (HD)","SubTitle_Features20_Pricing":"Penggunaan sepuasnya (HD/UHD)","SubTitle_Features8_Pricing":"AI Zoom Foto","SubTitle_Features9_Pricing":"AI Perluas Gambar","SubTitle_Features10_Pricing":"AI Background","Title_Features3_Pricing":"Fitur Desain Lainnya","SubTitle_Features11_Pricing":"Fitur dan Templat Lanjutan","SubTitle_Features12_Pricing":"Hapus Watermark","SubTitle_Features13_Pricing":"AI Alat Foto Massal","SubTitle_Features14_Pricing":"Fitur Desain Dasar","Title_Credits_Pricing":"Kredit habis? Kami siap membantu.","Desc_Credits_Pricing":"Pembelian satu kali, tanpa harus berlangganan.","TransactionPrice_Credits_Pricing":"Harga: ${0}","Credit_Credits_Pricing":"Kredit","Popular_Credits_Pricing":"Terpopuler","Buy_Credits_Pricing":"Beli Sekarang","Title_FAQ_Pricing":"Tanya-Jawab","Title_Button4_Pricing":"Upgrade sekarang untuk uji coba gratis 7 hari","SubTitle_FAQ1_Pricing":"Apa itu kredit?","Content_FAQ1_Pricing":"Kredit digunakan untuk mengakses alat AI. Jumlah kredit yang dibutuhkan bervariasi tergantung jenis alatnya.","Content_FAQ2_Pricing":"Kredit yang dibeli berlaku selama satu tahun.","Content_FAQ3_Pricing":"Kredit keanggotaan berlaku selama periode keanggotaan.","SubTitle_FAQ2_Pricing":"Bagaimana cara membatalkan langganan dan bagaimana dengan kredit saya setelah pembatalan?","Content_FAQ4_Pricing":"Setelah membatalkan langganan,","Content_FAQ5_Pricing":"Kredit keanggotaan Anda akan tetap berlaku hingga masa keanggotaan berakhir. Kredit yang dibeli secara terpisah tidak akan terpengaruh.","Content_FAQ6_Pricing":"Jika Anda perlu membatalkan langganan, silakan ikuti langkah-langkah di bawah ini setidaknya 24 jam sebelum siklus penagihan berikutnya dimulai:","Content_FAQ7_Pricing":"1. Buka Designkit dan login.","Content_FAQ8_Pricing":"2. Masuk ke jendela pop-up langganan.","Content_FAQ9_Pricing":"3. Pilih \\"Kelola Langganan\\".","Content_FAQ10_Pricing":"4. Pilih paket saat ini dan klik \\"Batalkan Langganan\\".","Content_FAQ11_Pricing":"Langganan akan tetap aktif hingga akhir siklus penagihan saat ini. Jika Anda tidak dapat membatalkannya, harap ambil tangkapan layar dan segera hubungi dukungan online kami.","SubTitle_FAQ3_Pricing":"Apakah ada kebijakan refund?","Content_FAQ12_Pricing":"1. Garansi Uang Kembali 7 Hari:","SubTitle_FAQ4_Pricing":"Bagaimana cara mengupgrade atau mendowngrade langganan?","Content_FAQ25_Pricing":"1. Upgrade: Anda bisa langsung berlangganan ke paket yang lebih tinggi, dan akan berlaku segera. Langganan lama akan dibatalkan, dan sisa saldo yang ada akan direfund.","SubTitle_FAQ5_Pricing":"Apakah akan ada salinan invoice?","Content_FAQ27_Pricing":"Ada! Setelah pembayaran berhasil, Anda akan menerima email dari layanan penyedia pembayaran yang berisi invoice elektronik. Jika Anda tidak menerima email invoice, silakan hubungi tim dukungan kami.","SubTitle_FAQ6_Pricing":"Apa saja metode pembayaran yang didukung?","Content_FAQ28_Pricing":"Kami menggunakan Stripe untuk mengelola pembayaran dan langganan. Kami menerima semua kartu kredit utama, PayPal, dan Google Pay.","SubTitle_FAQ7_Pricing":"Bagaimana cara menghubungi dukungan?","Content_FAQ29_Pricing":"Email: support@designkit.com. Waktu respons: 3-10 hari kerja.","Content_FAQ13_Pricing":"Jika Anda membeli langganan dan belum menggunakannya dalam 7 hari, Anda mungkin memenuhi syarat untuk refund penuh.","Content_FAQ14_Pricing":"Jika Anda membeli kredit, Anda mungkin berhak mendapatkan refund untuk kredit yang tidak digunakan dalam waktu 7 hari.","Content_FAQ15_Pricing":"2. Ketidakpuasan terhadap Layanan","Content_FAQ16_Pricing":"Jika Anda tidak puas dengan hasilnya, silakan hubungi tim dukungan online kami. Kami mungkin memberikan kompensasi atau refund bergantung pada situasinya.","Content_FAQ17_Pricing":"3. Pembelian via Google Play atau App Store","Content_FAQ18_Pricing":"Jika Anda berlangganan melalui Google Play Store atau App Store, Anda perlu mengajukan refund langsung dari Google atau Apple.","Content_FAQ19_Pricing":"Catatan Penting:","Content_FAQ20_Pricing":"Kebijakan refund ini tidak berlaku untuk pengguna API. Jika Anda menggunakan API kami, silakan hubungi kami untuk kelayakan refund.","Content_FAQ21_Pricing":"Kami berhak menolak refund dalam kasus penyalahgunaan atau pelanggaran terhadap ketentuan kami.","Content_FAQ22_Pricing":"Refund dapat memerlukan beberapa hari kerja untuk diproses, tergantung metode pembayaran Anda.","Content_FAQ23_Pricing":"Kami dapat memperbarui kebijakan refund dari waktu ke waktu. Harap periksa secara berkala untuk melihat adanya perubahan.","Content_FAQ24_Pricing":"Untuk bantuan lebih lanjut, silakan hubungi tim dukungan kami.","Content_FAQ26_Pricing":"2. Downgrade: Pertama, batalkan langganan saat ini. Setelah periode penagihan selesai, silakan berlangganan paket baru.","Content_Modal_Pricing":"Terima kasih atas dukungan Anda! Bersiaplah untuk mengasah kreativitas Anda.","Tip_Modal_Pricing":"Tips: Jika keanggotaan Anda belum muncul, silakan muat ulang halaman.","Title_Modal_Pricing":"Berhasil dibeli","Title_Rights2_Pricing":"Penggunaan terbatas fitur AI Penghapus","Title_Button3_Pricing":"Manfaat yang tersedia","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Penghapus Background","Tool_AiBgGenerator":"AI Background","Tool_AiLogoGenerator":"AI Pembuat LOGO","Tool_FootwearModel":"Model Alas Kaki","Tool_ImageTranslation":"Penerjemah Gambar","Tool_BatchImageBgRemover":"Penghapus Background Foto Banyak","Tool_BatchImageEnhancer":"Penyempurna Foto Banyak","Tool_BatchAiObjectsRemover":"AI Penghapus Objek Massal","Tool_VideoEnhancer":"Penyempurna Video","Tool_VideoBgRemover":"Penghapus Background Video","Tool_VideoWatermarkRemover":"Penghapus Watermark Video","Title_Models_Dropdown":"Model","Tips_Uninitialized_Chat":"Gagal mengirim pesan","Tips_Uninitialized_chat":"Gagal mengirim pesan","Dropdown_AddImage":"Tambah foto","Action_SeeAll":"Lihat semua","Desc_Seedream":"Pembuatan gambar yang realistis dan detail.","Dropdown_AddVideo":"Tambah video","Tips_NotFound_Chat":"Obrolan tidak ada","Desc_Seedance":"Pembuatan video yang realistis dan ekspresif.","Dropdown_SupportedFormatFile":"Mendukung file Word, Excel, Teks, dan PDF.","Dropdown_Example_Option":"Contoh","Dropdown_NoReference_Option":"Tidak ada referensi tersedia","Menu_AgentCredits":"Kredit Agen","Desc_SeedEdit":"Pengeditan foto yang presisi dan natural.","Dropdown_BrandKit_Title":"Kit Merek","Desc_GeminiNanoBanana":"Pembuatan gambar yang cepat, dapat diedit, dan konsisten.","Dropdown_Models_Title":"Model","Dropdown_AddDocument":"Tambah dokumen","Dropdown_BrandKit_Desc":"Pilih gaya merek sebagai referensi untuk desain ini.","Desc_MidjourneyVideo":"Pembuatan video yang kreatif dan artistik.","Desc_MidjourneyImage":"Pembuatan gambar yang artistik dan imajinatif.","Dropdown_SaveAsBrandTemplate":"Simpan sebagai templat merek","Dropdown_SaveAsBrandLogo":"Simpan sebagai logo merek","BatchProcessTable_ImageType":"Jenis gambar","BatchProcessTable_PictureRequirement":"Detail desain","BatchProcessTable_CopywritingRequirements":"Deskripsi produk","BatchProcessTable_Proportion":"Rasio aspek","BatchProcessTable_Actions":"Tindakan","BatchProcessTable_AddOneRow":"Tambah","BatchProcessList_DeleteError":"Gagal menghapus","BatchProcessList_SurePrompt":"Hapus panduan ini?","BatchProcessList_SurePrompt_SureText":"Konfirmasi","BatchProcessList_SurePrompt_CancelText":"Batal","BatchProcessList_EmptyText":"Kosong","EditBatchProcess_NameLimitTip":"Masukkan nama (maksimal 10 karakter)","EditBatchProcess_Tip":"Perubahan pada panduan akan memengaruhi hasil yang dibuat.","EditBatchProcess_Start":"Mulai dengan panduan","EditBatchProcess_GenerateTip":"Unggah foto produk dan desain akan dibuat berdasarkan panduan yang diberikan.","Text_AdvanceSetting":"Ahli","Text_MainImage":"Gambar utama","Text_ProductAgentUploadGuide1":"1. Unggah beberapa foto dari berbagai sudut untuk sebuah produk agar AI bisa menangkap detail produk dengan lebih baik.","Text_ProductAgentUploadGuide2":"2. Maksimal 10 foto. Foto pertama akan digunakan sebagai referensi utama, jadi harap pilih angle yang terbaik.","Text_Optional":"  (Opsional)","Tip_ClickDragImageWithSize":"Unggah foto format JPEG, JPG, atau PNG berukuran maks ${0} MB.","Button_AddReferenceImage":"Unggah","Title_ReferenceImage":"Gambar referensi","Input_Placeholder":"Harap pilih","Radio_ReferenceColor":"Warna referensi","Radio_ReferenceLayout":"Layout referensi","Tag_FirstImage":"Gambar pertama","Tag_FirstImageNoPartial":"Gambar pertama parsial","Tag_Blur":"Blur","Tag_Jigsaw":"Kolase","Button_Understood":"Mengerti","Text_ReferenceImageIndex":"Gambar ${0} sebagai referensi","Text_ReferenceDimensions":"Gnakan ${0} dari referensi","Tag_Cropped":"Dipangkas","Tag_Underexposed":"Kurang terang","Tag_Blurry":"Blur","SelectOption_ColorPalette":"Palet Warna","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fon","SelectOption_Style":"Gaya","SelectOption_ShapeElements":"Elemen Bentuk","Text_SocialMediaAgentUploadGuide":"Unggah produk unggulan terlebih dahulu. Pastikan foto jelas dan lengkap.","Video_SR_Success":"Memperjelas video","Video_Desubtitle_Success":"Menghapus subtitle","Video_Dewatermark_Success":"Menghapus watermark","Video_Process_Failed":"Pemrosesan gagal. Kredit akan dikembalikan ke akun.","Video_SR":"AI Penjernih","Video_Dewatermark":"Hapus Watermark","Video_Desubtitle":"Hapus Subtitle","Video_Task_Price_Estimate":"Diperlukan ${0} kredit","Video_SR_Start":"Sedang mempertajam... ${0} kredit akan digunakan.","Video_Dewatermark_Start":"Menghapus watermark... ${0} kredit akan digunakan.","Video_Desubtitle_Start":"Menghapus subtitle... ${0} kredit akan digunakan.","Video_Desubtitle_Start_VIP":"Menghapus subtitle...","Video_Dewatermark_Start_VIP":"Menghapus watermark...","Video_SR_Start_VIP":"Sedang mempertajam...","Text_Help_Center":"Pusat Bantuan","Title_Request":"Obrolan","Button_Continue":"Lanjutkan","Button_EditContent":"Edit pesan","Title_ChooseImageType":"Pilih jenis gambar yang dihasilkan (Beberapa opsi)","Button_BatchGenerate":"Dikonfirmasi. Jalankan templat sekarang.","Text_ChatCancelStatus":"Tugas dihentikan","Text_ChatRespondedStatus":"Pemrosesan tugas","BatchProcess_SaveSuccessTip":"Kit alur kerja Anda disimpan di sini.","Button_GotIt":"Mengerti","Title_Congrats":"Selamat","SubTitle_BrandCreate":"Kit merek perdana telah dibuat, saatnya mengeksplorasi potensinya!","Button_CheckUse":"Lihat sekarang","Chat_Prompt_Brand":"Buat poster promo","Tooltip_UseBrand":"Ganti atau tambahkan kit merek di sini!","Tooltip_PosterBrand":"Ketuk untuk membuat poster pertama berdasarkan kit merek","Popup_CreateBrand":"Buat merek dari awal","Desc_CreateBrand":"Buat logo yang menarik dan original dengan Agen AI kami.","Popup_UploadBrand":"Unggah informasi merek","Desc_UploadBrand":"Unggah info dan Zawa akan mempertahankan konsistensi setiap desain.","Title_BrandEntry":"Dapatkan personalisasi sistem merek sekarang","Desc_BrandEntry":"AI juga bisa menjadi penata gaya. Jawab beberapa pertanyaan dan dapatkan sistem merek lengkap sesuai visi Anda.","Tooltip_UseBrand_Agent":"Setelah kit merek diterapkan, desain akan secara otomatis mengacu pada logo, palet warna, dan gaya secara keseluruhan.","Tooltip_PosterBrand_Agent":"Siap mendesain dengan kit merek Anda sendiri","BatchProcess_createText":"Kit Alur Kerja","Label_NormalMode":"Dasar:","Label_AdvancedMode":"Lanjutan:","Text_NormalMode":"Dasar","Text_AdvancedMode":"Lanjutan","BatchProcess_DefaultPrompt":"Buat Gambar","Title_CreateBrand":"Tidak punya merek?","Title_UploadBrand":"Sudah punya logo?","Button_CreateBrand":"Buat merek","BatchProcess_EditContent":"Edit konten","BatchProcess_PleaseSelect":"Pilih kit alur kerja","BatchProcess_SelectTip":"Semua gambar yang diunggah akan diproses secara massal menggunakan kit alur kerja yang dipilih.","BatchProcess_ListEmptyTip":"Simpan kit alur kerja setelah dibuat untuk langsung membuat set serupa secara massal.","BatchProcess_Tip":"Kit Alur Kerja","BatchProcess_Generate":"Gunakan sekarang","BatchProcess_Save":"Simpan","BatchProcess_GeneratingFormula":"Membuat kit alur kerja...","BatchProcess_GenerateCancel":"Batal","BatchProcess_WorkFlowCreateError":"Gagal Membuat","ProductInfo_PleaseUploadImage":"Unggah foto produk","BatchProcess_IntelligenceGenerate":"Buat kit alur kerja","BatchProcess_CreateWorkflow":"Buat","BatchProcess_Formula":"Kit Alur Kerja","BatchProcess_WorkFlowSaveSuccess":"Kit alur kerja disimpan","ProductInfo_ImageSizeLimit":"Mendukung gambar maks ${0} MB","ProductInfo_ImageUpload":"Tambah foto produk","ProductInfo_UploadDemo":"Foto contoh","ProductInfo_ECPlatform":"Platform","ProductInfo_PleaseSelect":"Harap pilih","ProductInfo_InputCustomize":"Kustom","ProductInfo_CountryAndLanguage":"Wilayah/bahasa target","ProductInfo_Name":"Nama produk","ProductInfo_Desc":"Detail produk (Fitur/Ukuran/Skenario penggunaan)","ProductInfo_DescPlaceholder":"Masukkan informasi produk termasuk fitur, ukuran, skenario penggunaan, target audiens, dan lain-lain.","ProductInfo_NamePrompt":"Nama produk adalah ${0};","ProductInfo_ECPlatformPrompt":"Platform target adalah ${0};","ProductInfo_CountryAndLanguagePrompt":"Bahasanya adalah ${0};","ProductInfo_DescPrompt":"Detail produk adalah ${0}.","ProductInfo_PleaseInput":"Masukkan","Button_UnlockPro":"Dapatkan Pro","Button_UpgradeToPro":"Upgrade ke Pro","Button_RenewNow":"Perpanjang Sekarang","AgentEmpty_CaseUseBtn":"Gunakan","AgentEmpty_CaseRefreshBtn":"Segarkan","MenuItem_Effect":"Efek","MenuItem_Shadow":"Bayangan","MenuItem_Stroke":"Coretan","Title_ChangeText":"Ganti Teks","Button_Logout":"Logout","Message_ExtractText":"Mengekstrak teks","Message_ExtractTextError":"Gagal mengekstrak teks. Coba lagi.","Tip_CreditConsume":"Pemrosesan ini menggunakan ${0} kredit","Tip_EstimatedTime":"Siap dalam ${0} menit","BatchProcess_SaveSuccessTip_GotIt":"Mengerti","BatchProcess_SaveSuccessTip_Title":"Menggunakan Kit Alur Kerja","BatchProcess_SaveSuccessTip_Desc":"Kit alur kerja Anda disimpan di sini. Pilih salah satu kit untuk membuat gambar dengan cepat menggunakan templat yang disimpan.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Alat tangan","Text_Function":"Fungsi","Text_WindowsSystem":"Sistem Windows","Text_MacSystem":"Sistem Mac","Menu_KeyboardShortcuts":"Pintasan","Title_KeyboardShortcuts":"Pintasan","Text_Undo":"Batalkan","Text_MouseLeft":"Tombol mouse kiri","Text_Redo":"Ulangi","Text_Delete":"Hapus","Text_Cut":"Potong","Text_Copy":"Salin","Text_Paste":"Tempel","Text_PasteFixed":"Tempel di tempat","Text_CreateCopy":"Buat salinan","Text_SelectAll":"Pilih semua","Text_SelectMultiple":"Pilih banyak","Text_Group":"Grup","Text_Ungroup":"Pisahkan","Text_LockLayer":"Kunci","Text_Save":"Simpan","Text_Move":"Pindahkan","Text_MoveWithCombinedKeys":"Gerak cepat","Text_TouchEditFastMode":"Tunjuk untuk Mengedit Cepat","Text_Pan":"Geser Horizontal","Title_Canvas":"Kanvas","Title_Edit":"Edit","Title_Elements":"Elemen","Title_Tools":"Alat","Title_Blogs":"Blog","Text_NewText":"Teks baru","Text_NewLine":"Baris baru","Text_NewRectangle":"Kotak baru","Text_NewCircle":"Lingkaran baru","Text_ExitFullScreen":"Keluar layar penuh","Text_MoveUpOneLayer":"Majukan","Text_MoveDownOneLayer":"Mundurkan","Text_Top":"Letakkan di depan","Text_Bottom":"Letakkan di belakang","Text_CanvasZoom":"Perbesar/Perkecil","Text_ToggleReferenceLine":"Tampilkan/sembunyikan panduan","Text_ToggleRulerBar":"Tampilkan/sembunyikan penggaris","Text_ArrowKey":"Tombol panah","Text_CanvasShowAll":"Tampilkan semua kanvas","Title_Unsupported_Multilayer":"Fitur ini hanya berfungsi pada satu layer.","Btn_CreateBatchProcessFormula":"Buat","Button_Hide_Otherlayers":"Pertahankan layer pertama dan lanjutkan","Button_Merge_Alllayers":"Gabungkan semua layer dan lanjutkan","Checkbox_Disable_Remind":"Jangan tampilkan lagi","Button_Tool":"Alat","Button_Custom_Ratio":"Kustom","Label_Spacing":"Jarak","Button_Download_Whole":"Ekspor sebagai Gambar","Button_Download_Layer":"Ekspor Menurut Layer","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Tunjuk untuk Mengedit","Text_TouchEdit_Description":"Tunjuk objek dan jelaskan perubahan yang diinginkan. Foto akan diedit persis sesuai prompt.  ","Tooltip_TouchEdit_Max_Count":"Bisa menunjuk maksimal ${0} area","Tooltip_TouchEdit_Usage":"Pintasan Tunjuk untuk Mengedit: ${0} + klik","Text_TouchEdit_Recognition_Custom":"Kustom","Text_TouchEdit_Recognition_Title1":"Deteksi dan kenali","Text_TouchEdit_Recognition_Title2":"Target tidak ditemukan. Masukkan nama objek.","Text_TouchEdit_Name":"Tunjuk untuk Mengedit","Btn_LoginToViewBatchProcess":"Login untuk melihat kit alur kerja","Btn_Login":"Login","Menu_Main_Beautify":"Sempurnakan","Text_Model_Pricing":"Harga Model","Text_Pro_discount":"Paket Pro: Pembuatan Video Setengah Harga","Text_TemplatePrompt":"Mari awali dengan inspirasi","Text_Hi":"Hai, ${0}!","Text_Account_Popup_Left":"Gunakan asisten AI desain khusus untuk e-commerce. Dirancang untuk para profesional yang menginginkan peluncuran lebih cepat, presentasi yang lebih kuat, dan profit yang lebih tinggi.","Text_PleaseWaitImageUploaded":"Lanjutkan setelah unggahan selesai","Menu_Redeem_Rights":"Tukarkan","Text_Redeem_Now":"Tukarkan Sekarang","Text_Redeem_Placeholder":"Masukkan kode penukaran, huruf besar dan kecil harus benar","Text_Redeem_Success":"Penukaran berhasil","Text_Redeem_Use":"Tukarkan kode","Tooltip_BrandAutoUse":"Kit merek baru telah diterapkan!","Redeem_Redeem_Note":"Catatan: \\nSilakan login dan masukkan kode penukaran.\\nSetelah penukaran berhasil, selamat menikmati manfaat dan layanan terkait.\\nGunakan kode penukaran selama masih berlaku. Kode yang telah kedaluwarsa akan dibatalkan dan tidak dapat direfund.\\nHarap simpan kode. Kami tidak bertanggung jawab jika kode hilang, bocor, atau digunakan tanpa izin. \\nKode ini tidak dapat dijual kembali atau ditransfer kepada orang lain, tidak dapat ditukar dengan uang tunai, dan tidak bisa digunakan untuk faktur.","Tooltip_Color_Fill":"Warna","Tootip_StartPoint":"Mulai","Tootip_ChangePoint":"Ganti","Tootip_EndPoint":"Selesai","Sidebar_NewDesign":"Obrolan baru","Retouch_Filter_Clear":"Bening","Retouch_Filter_Enhance":"Nyata","Retouch_Filter_Dehaze":"Hilangkan Kabut","Retouch_Filter_Texture":"Tekstur","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Pudar","Modal_Button_Known":"OK","Modal_Button_GotIt":"Terima","Modal_Button_Later":"Lain kali","Text_Appeal_Confirm":"Ya","Text_Vip_Open":"Berlangganan","Text_Appeal_ReGenerate":"Hasil editan tidak memenuhi syarat untuk ditinjau.","Text_Appeal_Left":"Sisa percobaan bulan ini\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Kredit telah dikembalikan ke akun.","MenuItem_Appeal":"Tinjauan Hasil","Tooltip_Downloading":"Mengunduh...","Tooltip_Download_Video":"Unduh video secara terpisah, satu per satu.","Tooltip_Download_NoneSelected":"Pilih konten yang ingin diunduh","Text_AI_Thinking":"AI sedang bekerja...","Text_Server_Busy":"Server sedang sibuk. Harap coba lagi nanti.","Text_Prompt_Help_Placeholder":"Ketikkan kata kunci, saya akan mengubahnya menjadi prompt yang siap digunakan.","Text_Prompt_Helping":"Sedang memproses... Harap tunggu.","Button_Retry":"Coba lagi","Button_Rewrite":"Coba lagi","Button_Start_Prompt_Help":"Mulai menulis","Title_Prompt_Helper":"AI Penulis","Menu_Text_Subscriptions":"Langganan","Menu_View_Subscriptions":"Lihat Langganan","Text_Download_XdesignApp":"Unduh aplikasi <span>Zawa</span> untuk menggunakan fitur","Text_Free_Trial":"Unduh Uji Coba Gratis 7 Hari","Text_Install_App":"Instal Aplikasi","Text_Scan_Download":"Pindai untuk mengunduh","Text_Download_the":"Unduh di","Text_Available_On":"Tersedia di","Desc_ExpireDate":"Berakhir pada: ","DownloadApp_Title_Widgets":"Unduh aplikasi ${0} untuk menggunakan fitur","DownloadApp_SubTitle_Widgets":"Unduh Uji Coba Gratis ${0} Hari","InstallApp_Title_Widgets":"Instal Aplikasi","InstallApp_Desc_Widgets":"Pindai untuk mengunduh","AppStore_Desc_Widgets":"Unduh di App Store","GooglePlay_Desc_Widgets":"Tersedia di","Text_Tips_GetFree":"Kamu punya 1 kesempatan gratis","Text_AgentLib":"Aset","Tip_ModelSetSaveSuccess":"Gambar model telah disimpan! Ketuk untuk menggunakannya.","Text_BatchProcess":"Kit Alur Kerja","Button_Add":"Tambah","Tab_Recent":"Terakhir disimpan","Tab_Models":"Model Saya","Prompt_Model":"Gambar ${0} adalah model saya","Tip_SaveSuccess":"Disimpan","Text_ModelsLogin":"Login untuk melihat model","Loading_CheckFace":"Mendeteksi wajah...","Name_InitialModelName":"Model Saya","EmptyTip_ModelList":"Belum ada model. Mari buat model!","Text_UploadModel":"Unggah model","Text_Model":"Model","Tips_UnsupportedFormat":"Format file tidak didukung","Tips_InputModelName":"Masukkan nama","Tips_UploadModelImage":"Unggah gambar model","Title_CreateModel":"Buat model","Text_ModelName":"Nama","Placeholder_Input":"Masukkan","Text_UploadModelHint":"Klik untuk mengunggah atau letakkan gambar di sini<br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Unggah","Tips_NameLengthLimit":"Masukkan nama (maksimal ${0} karakter)","Tips_DeleteFailed":"Gagal menghapus","Title_ConfirmDeleteModel":"Hapus model ini?","Tips_CreateSuccess":"Model dibuat","Tab_BatchTemplate":"Kit Alur Kerja","Tab_MyModel":"Model Saya","Placeholder_InputContent":"Masukkan konten","Title_ChooseSceneType_VideoGenerateCard":"Pilih jenis konten dan struktur storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Mulai membuat video","Title_ShotType_VideoGenerateModal":"Jenis storyboard","Title_ShotRequirement_VideoGenerateModal":"Deskripsi storyboard","Title_Duration_VideoGenerateModal":"Durasi","Btn_AddOneTableRow":"Tambah","Label_Gender_ModelModal":"Gender","Label_Appearance_ModelModal":"Penampilan","Label_AgeGroup_ModelModal":"Kelompok usia","Label_Persona_ModelModal":"Peran","Label_BodyType_ModelModal":"Bentuk tubuh","Tips_GenerateModelFailed_ModelModal":"Gagal membuat. Harap coba lagi nanti.","Tips_NetworkError_ModelModal":"Kesalahan jaringan. Coba lagi nanti.","Tab_CustomModel_ModelModal":"Kustom","Tab_OfficialModel_ModelModal":"Resmi","Tab_UploadModel_ModelModal":"Unggah","Text_ModelPreview_ModelModal":"Pratinjau","Button_Generating_ModelModal":"Memproses...","Button_Regenerate_ModelModal":"Coba lagi","Button_Generate_ModelModal":"Buat","Button_Saving_ModelModal":"Menyimpan...","Button_SaveAndUse_ModelModal":"Simpan dan gunakan","Button_CreateNewModel_AgentLibList":"Model baru","Message_NotFilled_RequiredField":"Informasi ${0} wajib diisi","Title_ChooseSceneType2_VideoGenerateCard":"Pilih struktur storyboard","Title_ContentType_VideoGenerateCard":"Jenis konten","Title_StoryboardStructure_VideoGenerateCard":"Struktur storyboard","Text_Offical":"Resmi","Title_AboveTheFold_Main_HomeV2":"Buat setiap <br />foto produk <span>yang siap jual</span>","Title_Designkit_Slogan":"Buat foto produk yang siap jual","Button_StartFree_HomeV2":"Mulai Gratis","Title_AboveTheFoldMobile_Main_HomeV2":"Buat setiap produk <br /><span>yang siap jual</span>  ","SubTitle_AboveTheFoldMobile_HomeV2":"Dari pengeditan foto profesional hingga pembuatan daftar otomatis, semua yang kamu butuhkan ada di sini.","Text_TopBanner_HomeV2":"Seedance 2.0 segera hadir dengan akses unlimited","Title_ModuleCard_HomeV2":"Pertama, Hasilkan Aset Juara","SubTitle_ModuleCard_HomeV2":"Tiada lagi kanvas kosong. Gunakan Intelligent Creative Suite Agen AI kami untuk membuat rangkaian <br /> daftar lengkap, video dinamis, coba virtual, dan adaptasi global dalam hitungan detik.","Title_Faq_Q1_HomeV2":"Apakah tersedia uji coba gratis?","Text_Faq_A1_HomeV2":"Benar! Pengguna baru menerima 20 kredit gratis secara instan saat mendaftar. Selain itu, dapatkan 10 kredit gratis setiap hari dengan cara login. Pengguna bisa menguji semua fitur inti, termasuk pembuatan foto dan video, sebelum membeli paket berbayar.  ","Title_Faq_Q2_HomeV2":"Apakah hasil fotonya mematuhi pedoman Amazon/Shopify?","Text_Faq_A2_HOMEV2":"Jelas dong. Untuk foto produk unggulan, AI kami membuat background putih (RGB 255,255,255) yang diwajibkan oleh Amazon dan Shopify. Untuk foto lifestyle dan media sosial, AI ini memastikan dimensi yang sempurna dan kualitas resolusi tinggi agar produk memenuhi syarat dan tetap profesional.","Title_Faq_Q3_HomeV2":"Bisakah aset yang dihasilkan digunakan untuk tujuan komersial?","Text_Faq_A3_HomeV2":"Bisa. Semua foto dan video yang dibuat menggunakan paket berbayar 100% bebas royalti dan aman untuk penggunaan komersial. Pengguna berhak menggunakan aset ini di toko online Shopify, Amazon, iklan media sosial, dan kanal pemasaran lainnya tanpa batasan.","Title_Faq_Q4_HomeV2":"Bagaimana cara kerja pemrosesan dan pengeditan massal?","Text_Faq_A4_HomeV2":"Pemrosesan massal sudah terintegrasi dalam setiap fitur Designkit. Cukup unggah beberapa foto langsung ke workspace. Baik untuk membuat background lifestyle baru, menghapus background asli, menghapus objek yang menganggu, atau meningkatkan resolusi, terapkan tindakan yang dipilih ke seluruh foto dengan mudah. Ini memastikan aset yang konsisten untuk toko online sekaligus menghemat banyak waktu dibandingkan editing manual.","Title_Faq_Q5_HomeV2":"Apa saja format file yang didukung?","Text_Faq_A5_HomeV2":"Output video tersedia dalam format MP4, yang dioptimalkan untuk media sosial dan situs web e-commerce.","Title_Questions_Main_HomeV2":"Tanya-Jawab","Title_Scale_Main_HomeV2":"Siap Berkembang?","SubTitle_Scale_HomeV2":"Bergabunglah dengan 10.000+ seller yang mengotomatiskan alur kerja desain dengan Designkit.","Title_Evaluation_HomeV2":"Luncurkan Lebih Cepat & Jual Lebih Banyak","SubTitle_Evaluation_HomeV2":"Percepat waktu produksi hingga 90%. Dapatkan daftar yang terverifikasi tayang di Amazon dan Shopify lebih awal dibandingkan kompetitor.","Tab_Module_ProductImage_HomeV2":"AI Foto Produk","Desc_Module_ProductImage_HomeV2":"Ubah satu foto pemasok menjadi rangkaian daftar lengkap secara instan. Buat foto produk unggulan dengan background putih, foto lifestyle, dan infografis, sambil memproses ratusan SKU secara massal dengan mudah dan fitur terjemahan teks secara otomatis untuk pasar global.","Tip_Module_ProductImage_HomeV2":"Buat set daftar Amazon untuk headphone warna pink.","Tab_Module_ModelImage_HomeV2":"AI Model Fashion","Desc_Module_ModelImage_HomeV2":"Tidak punya model? Tidak masalah. Visualisasikan pakaian pada berbagai model buatan AI untuk meningkatkan rasio klik-tayang tanpa harus menjadwalkan sesi pemotretan mahal.","Tip_Module_ModelImage_HomeV2":"Pajang setelan kuning-hijau ini pada model wanita berusia 25 tahun.","Tab_Module_Video_HomeV2":"AI Video Produk","Desc_Module_Video_HomeV2":"Realisasikan produk. Buat tampilan produk yang dinamis, buat video penjelasan AI yang menarik, dan iklan yang menghasilkan konversi tinggi hanya dari sebuah teks atau satu foto. Tingkatkan minat dan dorong penjualan di berbagai platform e-commerce dan media sosial.","Tip_Module_Video_HomeV2":"Buat video produk untuk vas biru ini.","Tab_Module_DetailPage_HomeV2":"AI Halaman Detail Produk","Desc_Module_DetailPage_HomeV2":"Buat konten premium A+ dan banner promosi keren untuk toko online dalam beberapa menit saja, tanpa memerlukan keterampilan desain. Ubah foto produk dasar menjadi layout yang sangat menarik, dan dapatkan daftar produk unik yang berbeda dari kompetitor.","Tip_Module_DetailPage_HomeV2":"Buat halaman detail produk untuk sofa oranye ini.","Tab_Module_Photography_HomeV2":"AI Fotografi Produk","Desc_Module_Photography_HomeV2":"Buang foto stok umum. Pajang produk dengan pengaturan khusus sesuai merek dan selera pasar di Indonesia.","Tip_Module_Photography_HomeV2":"Buat background fotografi untuk parfum ini.","Title_Module_SecondTitle_HomeV2":"Sempurnakan Detailnya dengan AI yang Presisi","SubTitle_Module_SecondSubTitle_HomeV2":"Aset sudah dibuat? Sekarang sempurnakan. Gunakan AI Editor Foto kami untuk menghapus background, memoles kekurangan, dan meningkatkan resolusi foto secara massal.","Text_Upload_HomeV2":"Unggah","Text_TopBannerMobile_HomeV2":"Seedance 2.0 segera hadir","Text_Prompt1_HomeV2":"Buat set foto daftar lengkap Amazon.","Text_Prompt2_HomeV2":"Buat model yang mengenakan pakaian ini.","Text_Prompt3_HomeV2":"Buat video pemasaran produk.","Text_Prompt4_HomeV2":"Buat halaman detail produk Konten A+.","Text_Prompt5_HomeV2":"Buat background yang sesuai untuk foto produk.","Desc_Evaluation1_HomeV2":"Super cepat! Foto langsung siap diunggah ke Mercado Libre dan Amazon. Background dan model foto menyesuaikan selera lokal. Hasilnya benar-benar profesional.","Desc_Evaluation2_HomeV2":"Aku suka Designkit! Hasil fotonya terkesan nyata dan natural, nyaman dan bernuansa Nordik, cocok untuk toko lilinku. Daftar produk jadi terlihat rapi dan penjualan meningkat. Sangat sepadan.  ","Desc_Evaluation3_HomeV2":"Aku menjual pakaian dan khawatir foto AI tidak bisa menampilkan teksturnya dengan benar. Tapi Designkit top banget! Warnanya sempurna, pose modelnya terlihat natural, dan fotonya langsung siap dipakai.","Header_products_socialMediaPostGenerator":"Pembuat Postingan Media Sosial","Pricing_Seedance_UnlockLimited":"Dapatkan Akses Unlimited","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Akses Lebih Awal","Pricing_Seedance_SeedanceDesc":"Jadilah yang pertama membuktikan kecanggihan Seedance 2.0. Berlangganan salah satu paket Pro sekarang juga dan dapatkan akses unlimited eksklusif ke model AI generasi baru.","Pricing_Seedance_Monthly":"Bonus Paket Bulanan","Pricing_Seedance_DaysUnLimit":"  7 Hari <span>Unlimited</span>","Pricing_Seedance_SeedanceV2":"Akses Seedance 2.0","Pricing_Seedance_BestValue":"PROMO TERBAIK","Pricing_Seedance_Yearly":"Bonus Paket Tahunan","Pricing_Seedance_MonthUnLimit":"1 Bulan <span>Unlimited</span>","Title_AIBrand_Tools":"✨Alat AI Branding","Title_AISocialMediaPosts":"AI Postingan Media Sosial","Title_AILogoMaker":"AI Pembuat LOGO","Option_Child_Age":"Anak","Option_Infant_Age":"Bayi","Option_MiddleAged_Age":"Dewasa","Option_Senior_Age":"Lansia","Option_Teen_Age":"Remaja","Option_YoungAdult_Age":"Dewasa muda","Button_GenerateImages_DetailPageAction":"Buat","Text_GenerateImagesCount_DetailPageAction":"(${0} foto)","Text_GenerateImagesCount_DetailPageAction1":"(${0} foto)","Option_MercadoLivre_Platform":"Mercado Livre ","Option_Etsy_Platform":"Etsy ","Option_Walmart_Platform":"Walmart ","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Buat Desain Halaman Produk","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Seluler)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standar A+","Option_Accessories_DetailSection":"Aksesori/ Hadiah","Option_ServiceSupport_DetailSection":"Garansi","Option_BeforeAfter_DetailSection":"Sebelum & Sesudah","Option_BrandStory_DetailSection":"Kisah Merek","Option_KeyHighlights_DetailSection":"Poin Penjualan Utama","Option_CraftProcess_DetailSection":"Tampilan Detail","Option_HeroVisual_DetailSection":"Foto Utama","Option_Composition_DetailSection":"Komponen","Option_MultiAngle_DetailSection":"Multisudut","Option_DetailCloseups_DetailSection":"Detail Produk","Option_SceneMood_DetailSection":"Gaya Hidup/Suasana Hati","Option_SeriesShowcase_DetailSection":"Seri Produk","Option_SizeCapacity_DetailSection":"Dimensi","Option_Specifications_DetailSection":"Lembar Spesifikasi","Option_UsageScenario_DetailSection":"Skenario Penggunaan","Option_UsageTips_DetailSection":"Panduan Penggunaan","Paragraph_ServicePolicy_DetailSection":"Kebijakan garansi, retur, dan penukaran","Paragraph_BeforeAfter_DetailSection":"Hasil sebelum dan sesudah penggunaan","Paragraph_BrandConcept_DetailSection":"Konsep dan nilai merek","Paragraph_CoreValue_DetailSection":"Menunjukkan nilai inti","Paragraph_CraftProcess_DetailSection":"Dari ilustrasi menjadi kenyataan","Paragraph_Differentiators_DetailSection":"Sorotan manfaat utama","Paragraph_Composition_DetailSection":"Bahan dan komponen yang digunakan dalam produk","Paragraph_MaterialAndCraft_DetailSection":"Sorotan bahan dan proses","Paragraph_MultiAngleAppearance_DetailSection":"Produk dilihat dari berbagai sudut","Paragraph_MultiOptionDisplay_DetailSection":"Variasi warna atau SKU","Paragraph_IncludedItems_DetailSection":"Semua sudah termasuk dalam paket","Paragraph_DetailData_DetailSection":"Detail spesifikasi","Paragraph_RealUsageScene_DetailSection":"Referensi penggunaan di kehidupan nyata","Paragraph_Specifications_DetailSection":"Panduan ukuran singkat","Paragraph_UsageNotes_DetailSection":"Catatan penggunaan dan pencegahan","Paragraph_UsageScenario_DetailSection":"Produk dalam konteks","Title_Nav_DetailPage":"Detail Produk A+","Title_ImageSet_DetailPage":"Set Foto Detail Produk A+","Input_TaskName_Batch":"Masukkan nama tugas","Paragraph_FullAssetSetDescription_Batch":"Termasuk satu set lengkap aset pemasaran seperti foto utama, foto skenario penggunaan, dan foto dengan background putih yang dapat digunakan di berbagai platform.","Paragraph_LongFormVisualDescription_Batch":"Membuat storytelling visual untuk foto produk format panjang, halaman detail produk, dan foto perbandingan.","Message_JsonGenerated_Batch":"Formulir diverifikasi. JSON dibuat.","Message_JsonCopied_Batch":"JSON disalin.","Message_IncompleteRequiredFields_Batch":"Kolom wajib belum diisi. Silakan lengkapi formulir sebelum dikirim.","Message_PleaseUploadSourceImage_Batch":"Unggah foto produk.","Message_PleaseCompleteStrategySettings_Batch":"Selesaikan konfigurasi strategi","Message_TaskValidationFailed_Batch":"Tinjau dan selesaikan tugas yang belum diverifikasi.","Message_CopyJsonFailed_Batch":"Gagal menyalin. Harap periksa JSON di dasbor.","Message_PleaseEnterTitle_Batch":"Masukkan judul.","Message_PleaseEnterKeyHighlights_Batch":"Masukkan poin penjualan utama produk.","Message_PleaseGenerateJsonFirst_Batch":"Silakan kirim untuk membuat JSON.","Title_DetailPage_Batch":"Halaman Produk A+","Title_DetailTask_Batch":"Tugas A+ ${0}","Title_IndependentParameters_Batch":"Konfigurasikan secara terpisah","Title_ImageSet_Batch":"Set Foto Ecommerce","Title_ItemTask_Batch":"Tugas Produk","Option_Curvy_BodyType":"Gemuk","Option_Muscular_BodyType":"Kekar","Option_PlusSize_BodyType":"Padat berisi","Option_Slim_BodyType":"Langsing","Option_Standard_BodyType":"Rata-rata","Button_Reset_Common":"Reset","Button_Back_Common":"Kembali","Button_Collapse_Common":"Susutkan","Button_Expand_Common":"Perluas","Button_Generate_Common":"Buat","Button_PreviousStep_Common":"Batalkan","Button_RemoveFavorite_Common":"Batalkan favorit","Button_StartNow_Common":"Coba sekarang","Paragraph_ExitWarning_Common":"Data akan hilang jika Anda keluar.","Paragraph_Content1_VirtualModelDisclaimer":"2. Harap dipahami bagaimana karakteristik dari konten yang dihasilkan AI. Konten yang dihasilkan AI dibuat berdasarkan algoritma dan pembelajaran data, dan hasilnya bisa bervariasi. Tampilan wajah yang dihasilkan oleh AI mungkin berbeda dari aset asli yang diberikan, dan mungkin ada ketidaksempurnaan serta hasil yang kurang memuaskan. Platform kami tidak menjamin keakuratan, kualitas visual, atau kecocokan dari konten yang dihasilkan.","Paragraph_Content2_VirtualModelDisclaimer":"3. Harap mengonfirmasi tanggung jawab pengguna. Anda bertanggung jawab atas foto berisi wajah dan konten yang dihasilkan. Anda harus memastikan bahwa penggunaan Anda tidak melanggar hak hukum pihak ketiga, termasuk, tetapi tidak terbatas pada hak publikasi, privasi, dan reputasi, serta bahwa penggunaannya mematuhi semua hukum dan peraturan yang berlaku. Anda tidak boleh menggunakan konten yang dihasilkan untuk tujuan yang melanggar hukum, melanggar hak orang lain (seperti pencemaran nama baik atau penipuan), atau melanggar ketertiban umum dan norma kesusilaan atau martabat orang lain.","Paragraph_Content3_VirtualModelDisclaimer":"Harap konfirmasikan bahwa Anda sepenuhnya memahami dan menyetujui ketentuan di atas sebelum mengunggah.","Title_Notice_VirtualModelDisclaimer":"Sebelum menggunakan fitur AI Foto Produk Coba Virtual, harap baca dan pahami berikut ini:","Message_FailedRetry_Download":"Gagal mengunduh. Harap coba lagi nanti.","Message_Failed_Download":"Pengunduhan gagal.","Message_Success_Download":"Pengunduhan selesai.","Message_NoImagesAvailable_Download":"Gambar tidak tersedia.","Option_Asian_Ethnicity":"Asia","Option_Black_Ethnicity":"Afrika","Option_Chinese_Ethnicity":"Tiongkok","Option_Latino_Ethnicity":"Hispanik atau Latino","Option_MiddleEastern_Ethnicity":"Timur Tengah","Option_SoutheastAsian_Ethnicity":"Asia Tenggara","Option_White_Ethnicity":"Putih","Option_Female_Gender":"Wanita","Option_Male_Gender":"Pria","FormLabel_Ethnicity_Common":"Ras dan Etnis","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Bahasa","FormLabel_TargetMarket_Common":"Pasar","FormLabel_TargetPlatform_Common":"Platform","Option_German_Language":"Jerman","Option_Japanese_Language":"Jepang","Option_None_Language":"Tidak ada","Option_Portuguese_Language":"Portugis","Option_Russian_Language":"Rusia","Option_Spanish_Language":"Spanyol","Option_Thai_Language":"Thailand","Option_Brazil_Market":"Brasil","Option_China_Market":"Tiongkok","Option_Europe_Market":"Eropa","Option_Germany_Market":"Jerman","Option_Japan_Market":"Jepang","Option_Russia_Market":"Rusia","Option_SoutheastAsia_Market":"Asia Tenggara","Option_Spain_Market":"Spanyol","Option_UnitedStates_Market":"Amerika Serikat","Message_MaxLimit_DetailSectionSelection":"Pilih maksimal ${0} bagian","Option_FollowGlobalSettings_Common":"Gunakan pengaturan global","Text_MaxTasks_Batch":"Tambahkan maksimal ${0} tugas","Text_MinTasks_Batch":"Pertahankan setidaknya satu tugas","Text_MaxImagesPerTask_Batch":"Unggah maksimal ${0} foto per tugas","Text_SupportedImageFormats_Batch":"Format gambar yang didukung: JPG, JPEG, PNG, HEIC, dan WebP.","Input_AppearanceDetailsExample_TryOn":"Misalnya: kulit gelap, poni lurus menutupi dahi, tahi lalat di dekat sudut mata...","Input_SourceInfoGuide_Batch":"Untuk hasil yang lebih akurat, harap cantumkan informasi berikut:\\n1. Nama produk\\n2. Poin penjualan utama\\n3. Audiens target\\n4. Skenario penggunaan yang dimaksud\\n5. Detail spesifikasi","Tooltip_OutputStyleConsistent_Clone":" Jika diaktifkan, semua foto warna dan gaya yang dihasilkan akan konsisten. Jika dinonaktifkan, setiap foto mengikuti gaya dari foto referensi.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa Indonesia","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Buat Set Foto","Title_Nav_ImageSet":"Gambar Daftar Produk","Message_GenerateFailedRetry_ImageSet":"Gagal memproses. Harap coba lagi.","Message_PleaseSelectStyleFirst_ImageSet":"Pilih gaya terlebih dahulu.","Message_CreateTaskFailed_ImageSet":"Gagal membuat tugas","Title_StyleAnalysis_ImageSet":"Analisis gaya tren","Option_TrafficMaximization_TitleStrategy":"Maksimalkan traffic","Option_ConversionPriority_TitleStrategy":"Utamakan konversi","Option_SceneImmersion_TitleStrategy":"Adegan imersif","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Mengekstrak fitur utama dari aset...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Membuat kata kunci konversi tinggi berdasarkan poin penjualan...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Menyesuaikan strategi SEO terbaik...","Text_GeneratingOptions_TitleGenerationStatus":"Membuat keterangan dari perspektif yang berbeda...","Message_TaskFailedWithStatus_TitleGeneration":"Tugas gagal (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Permintaan melewati batas waktu. Silakan coba lagi.","Message_GenerateFailed_TitleGeneration":"Gagal membuat judul. Silakan coba lagi.","Message_QueryResultFailed_TitleGeneration":"Gagal mengambil tugas","Paragraph_Content_VirtualModelConsent":"1. Otorisasi hak potret: Fitur ini menggunakan foto wajah yang diunggahuntuk membuat model wajah virtual menggunakan AI. Harap pastikan bahwa Anda memiliki hak atas foto yang diunggah atau telah memperoleh persetujuan tertulis yang sah dan jelas dari pemegang hak, untuk menggunakan potret tersebut dan konten yang dihasilkan untuk tujuan ini. Jika foto berisi anak di bawah umur, persetujuan dari wali mereka yang sah diperlukan.","Button_ConfirmTextChange_TextEdit":"Perbarui","Input_ModifyText_TextEdit":"Edit Keterangan","Message_NoImagesAvailable_ResultDownload":"Tidak ada foto yang tersedia untuk diunduh","Message_Failed_TextRecognition":"Gagal mengenali teks","Text_Generating_ResultStatus":"Memproses...","Option_CustomColor_SceneSetting":"Kustom","Option_UseOriginalBackground_SceneSetting":"Gunakan background original","Text_InsufficientCredits_Common":"Koin tidak cukup","Button_LoadMore_Common":"Muat Lainnya","Text_ImageUploadLimit_Common":"Unggah maksimal ${0} foto","Text_AnalyzingTrend_Common":"Menganalisis teks pada ${0}","Text_ChineseOutputProOnly_Common":"Pemrosesan teks Mandarin hanya tersedia di Pro. Teks telah dihapus dari hasil saat ini.","Text_SourceImageUploadLimit_Common":"Unggah maksimal ${0} foto","Text_WritingInProgress_AiWriting":"Memproses...","Text_DeepThinking_AiWriting":"Berpikir...","Text_ThinkingProcess_AiWriting":"Proses Berpikir:","Text_ImageSelectionLimit_Common":"Pilih maksimal ${0} foto","Message_RegenerationSubmitted_Regeneration":"Pembuatan ulang telah dikirim. Harap segarkan untuk melihat hasilnya nanti.","Button_MoreEditOptions_ResultEditor":"Lainnya","FormLabel_DetailSection_DetailPage":"Bagian Detail Produk","Message_GeneratePlanFailed_DetailPagePlan":"Gagal membuat rencana","Message_PlanGenerationFailed_DetailPagePlan":"Gagal membuat rencana","Text_PlanUnavailable_DetailPagePlan":"Tidak ada rencana yang tersedia","Message_SourceImageMissing_Common":"Foto produk tidak ada","Message_GenerationFailed_Common":"Pemrosesan gagal","Paragraph_ConfirmDiscardChanges_Common":"Perubahan akan hilang jika Anda kembali. Yakin ingin kembali?","Message_ProcessFailed_Common":"Gagal","Text_GeneratingEllipsis_Common":"Memproses...","Text_StyleGenerationInProgress_ImageSet":"Membuat gaya trending...","Message_FavoriteAdded_Common":"Ditambahkan ke Favorit","Message_FavoriteRemoved_Common":"Dihapus dari Favorit","Text_LoadingPlain_Common":"Memuat","Text_MultiSelectAvailable_Common":"Pilih banyak","Text_NoData_Common":"Tidak ada data tersedia","Text_NoDataAvailable_Common":"Tidak ada data","Text_NoMoreResults_Common":"Tidak ada konten lainnya","Message_PleaseEnterKeyHighlights_DetailPage":"Harap masukkan poin penjualan utama","Message_PleaseSelectAiModel_TryOn":"Pilih model AI","Message_SelectSectionMin_DetailPage":"Pilih minimal ${0} bagian","Message_SelectScenePoseMin_TryOn":"Pilih minimal ${0} pose dan postur","Message_PleaseSelectBaseModel_TryOn":"Pilih model dasar","Message_PleaseSelectCustomModel_TryOn":"Pilih model kustom","Message_PleaseSelectModel_TryOn":"Pilih model terlebih dulu","Message_PleaseSelectSection_DetailPage":"Pilih bagian","Message_SelectUploadCustomModel_TryOn":"Pilih atau unggah gambar model","Message_PleaseSelectScene_TryOn":"Pilih skenario","Message_PleaseSelectStrategy_DetailPage":"Pilih strategi","Message_PleaseUploadGarmentImage_TryOn":"Unggah foto pakaian","Message_UploadGarmentFile_TryOn":"Unggah foto pakaian","Message_PleaseUploadSourceImage_Common":"Unggah foto produk terlebih dulu","Message_PleaseUploadItemImage_Common":"Unggah foto produk","Message_UploadItemFirst_Common":"Unggah foto produk terlebih dulu","Message_RegenerateFailedWithReason_Regeneration":"Gagal membuat ulang:","Message_SelectResultImages_Result":"Pilih foto dengan hasil yang dibuat","Text_ReleaseToRefresh_Common":"Lepas untuk menyegarkan","Message_TextRecognitionFormatInvalid_TextRecognition":"Format tidak valid terdeteksi","Message_TextRecognitionParseFailed_TextRecognition":"Gagal memparsing hasil pengenalan","Message_TextRecognitionTaskFailed_TextRecognition":"Gagal mengenali teks","Message_QueryTaskStatusFailed_TextRecognition":"Gagal mengambil status tugas","Message_SubmitTaskFailed_TextRecognition":"Gagal mengirim tugas pengenalan teks","Text_RegenerationProcessing_Regeneration":"Permintaan pembuatan ulang telah dikirim. Sedang memproses...","Message_RegenerateFailedRetry_Regeneration":"Gagal membuat ulang. Harap coba lagi nanti.","Message_OpenEditorFailed_ResultEditor":"Gagal membuka editor","Message_RegenerateFailed_Regeneration":"Gagal membuat ulang","Message_RefreshFailedRetry_Common":"Gagal menyegarkan. Silakan coba lagi.","Message_UploadGarmentSelectModel_TryOn":"Unggah foto pakaian dan pilih model","Message_PollingTimedOut_Common":"Waktu kueri habis","Title_KeyHighlights_DetailPage":"Poin Penjualan Utama","Title_FullStrategyGuide_DetailPage":"Panduan Strategi & Desain Lengkap","Title_IncludedSections_DetailPage":"Bagian","Title_IncludedSectionsMultiple_DetailPage":"Bagian (Pilih beberapa)","Title_ModelSelection_TryOn":"Pilih Model","Title_SectionContent_DetailPage":"Konten Bagian","Title_SectionStrategyGuide_DetailPage":"Panduan Strategi & Desain Bagian","Title_OutputAspectRatio_Common":"Rasio Aspek","Title_OutputSpecification_Common":"Spesifikasi","Title_SelectModel_TryOn":"Pilih model","Title_SelectScene_TryOn":"Pilih adegan","Title_StrategySettings_DetailPage":"Strategi","Title_UploadAssets_Common":"Unggah","Button_GenerateBaseModel_TryOn":"Buat model dasar","Button_GenerateRecommendedScenes_TryOn":"Buat adegan yang direkomendasikan","Button_GenerateSceneImages_TryOn":"Buat (${0} foto)","Text_GeneratingBaseModel_TryOn":"Membuat model dasar...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Seluruh badan","Option_HalfBody_Framing":"Separuh badan","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"AI Coba Online","Option_Ai_TryOnModelMode":"Buatan AI","Title_Nav_TryOn":"Coba Online","Option_Back_Perspective":"Kembali","Option_Front_Perspective":"Depan","Option_Side_Perspective":"Samping","Option_ThreeQuarterSide_Perspective":"Tampak 3/4","Input_AppearanceDetailsHint_TryOn":"Detail penampilan: kulit kecokelatan, poni lurus menutupi dahi, tahi lalat di dekat sudut mata…","Message_SaveToAlbumSuccess_Common":"Disimpan ke album","Text_GeneratingSceneImages_TryOn":"Membuat foto adegan...","Message_RefreshFailed_Common":"Gagal menyegarkan","Message_FailedRefunded_Generation":"AI desain gagal. Kredit telah direfund.","Title_BaseModelImage_TryOn":"Gambar Model Dasar","Title_CustomModel_TryOn":"Model Kustom","Paragraph_Intro_TryOn":"Unggah foto pakaian dan sesuaikan model untuk menghasilkan berbagai adegan dan pose.","Title_UploadGarmentImage_TryOn":"Foto pakaian","Tips_UploadFailedPure":"Gagal mengunggah","Tips_Uploading":"Mengunggah...","Text_UploadNewModel":"Model baru","Text_AllBackgrounds":"Semua Background","Text_DefaultTemplateScene":"Default","Text_ColorScene":"Warna","Text_SameProductMax_Common":"Maksimal ${0} foto per produk","Text_Max_Common":"Maksimal ${0} foto","Button_Generate_ImageClone":"Mulai Buat","Button_RefreshStyle_Common":"Segarkan","Button_Favorite_Common":"Favorit","Text_PreviewLargeImage":"Pratinjau lengkap","Text_BaseImage":"Tolok ukur","Button_BatchDownload_Common":"Unduh massal","Button_BatchEdit_Common":"Edit massal","Button_BatchWatermark_Common":"Tambahkan watermark","Text_GeneratedResults":"Hasil","Button_DownloadAllImages_Common":"Unduh semua","Text_NoGeneratedResults":"Belum ada hasil","Text_SameProductMax_TryOn":"Pakaian lengkap atau foto sebuah item dari beberapa sudut, maksimal ${0} foto.","Title_AdvancedImageGenerationModel":"Model Foto Premium","Text_SupportChineseOutput_Common":"Mendukung output bahasa Mandarin dan detail dengan estetika serta kontrol kreatif yang lebih baik.","Text_SelectMultipleModules_DetailPage":"Pilih beberapa bagian untuk membuat halaman detail produk lengkap","Button_CollapseAll_Common":"Semua","Label_AppearanceDetails_TryOn":"Details Penampilan (Opsional)","Text_WaitingForGeneration_TryOn":"Pemrosesan ditunda","Title_SmartTitleAI_ProductTitle":"Buat Judul Daftar","Message_ResultMissing_TitleGeneration":"${0} hasil yang dibuat AI tidak ada","Message_InvalidJSONFormat_TitleGeneration":"Hasil yang dikembalikan tidak valid","Message_InvalidJSONFormat_TitleGeneration1":"Format JSON yang dikembalikan tidak valid","Text_AutoGeneratedTitleScheme_ProductTitle":"Berikut adalah judul yang dibuat secara otomatis berdasarkan produk Anda","Text_SelectBestTitle_ProductTitle":"Pilih judul yang menarik dan klik untuk menyalin","Button_Copy_Common":"Salin","Message_PleaseUploadImage_Common":"Silakan unggah gambar terlebih dahulu","Text_DeepThinking1_AiWriting":"DeepSeek sedang bekerja...","Button_Rewrite1":"Coba lagi","Text_TotalImages_Common":"Jumlah: ${0}","Text_EditText_ResultEditor":"Edit teks","Text_NoTextRecognition_ResultEditor":"Teks tidak terdeteksi","Text_PreviewLongImage_ResultGroup":"Pratinjau foto panjang","Text_LimitFree":"Promo Kilat","Text_UploadSameProductTip1":"1. Unggah beberapa foto dari berbagai sudut untuk sebuah produk agar AI bisa menangkap detail produk dengan lebih baik.","Text_UploadSameProductTip2":"2. Maksimal 3 foto. Foto pertama akan digunakan sebagai referensi utama, jadi harap pilih angle yang terbaik.","Text_UploadProductImage_APlusCase":"Unggah foto produk","Text_GenerateEcommerceLongImage_APlusCase":"Buat foto panjang","Text_MultiPlatform_APlusCase":"Mematuhi berbagai standar platform e-commerce","Text_MainImage_ProductCase":"01 Foto Header (Background Putih/Standar)","Text_SceneDisplay_ProductCase":"02 Skenario Penggunaan","Text_ModelSceneImage_ProductCase":"03 Gambar Model","Text_DetailDescription_ProductCase":"04 Detail","Text_FeatureExplanation_ProductCase":"05 Poin Penjualan","Text_UploadProductImage_ProductCase":"Unggah foto produk dan AI akan langsung membuat set foto yang memiliki konversi tinggi <span>dan sesuai dengan standar berbagai platform e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Unggah foto pakaian dan buat model kustom untuk langsung menghasilkan berbagai adegan dan pose.","Text_UploadProductImage_DetailPage":"Unggah foto produk dan AI akan langsung membuat halaman detail produk profesional <span>yang sesuai dengan berbagai standar platform e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Halaman Detail Produk","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":" Login dan dapatkan uji coba gratis","Login_DK_Title":"Buat desain keren secara Gratis","Login_Zawa_Des":"Mulai berkarya dengan Zawa sekarang","Login_DK_Des":"Daftar atau login untuk terus mendesain. Mulai sekarang!","Tab_Module_ProductImage_TryOn_MultiMix":"Padukan beberapa pakaian menjadi satu gaya","Tab_Module_ProductImage_TryOn_SingleHero":"Dari satu pakaian menjadi tampilan lengkap","Tab_Module_ProductImage_TryOn_Accessories":"Gaya aksesori yang sempurna","Text_ShowAdvancedModelTip":"Tampilkan tips model premium","Text_HideAdvancedModelTip":"Sembunyikan tips model premium","Text_DeepSeekR1HelpWrite":"Bantu saya menulis (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Percobaan sudah melebihi maksimum ${0}","Title_StandardEdition":"Standar","Text_FastAndEfficient_Common":"Cepat dan Efisien","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Kualitas dan Detail Ditingkatkan","Text_PremiumEngineActivated":"<strong>Mesin premium diaktifkan:</strong> Mendukung output bahasa Mandarin dan detail dengan estetika serta kontrol kreatif yang lebih baik.","Text_EditBrand_DropTitle1":"Seret dan lepaskan file JPG, PNG, arau WEBP di sini,","Text_EditBrand_DropTitle2":"atau <>cari</> di komputer.","Text_BaseToolbar_AlignTop":"Rata Atas","Text_BaseToolbar_AlignBottom":"Rata Bawah","Text_LayerSort":"Urutkan","Text_BaseToolbar_AlignCenter":"Tengah","Text_Attr_Strong":"Tebal","Text_GeneratingPlan_DetailPagePlan":"Membuat rencana...","Text_PlanGenerationFailed_ReTry":"Gagal membuat rencana. Harap coba lagi nanti.","Button_StartAnalyze_ProductCase":"Mari Mulai","Message_SubmitSuccessTip_Batch":"Dikirim. Cek hasilnya dalam ${0} menit.","Button_ClickAnalyze_ProductCase":"Analisis gaya bestseller","Button_StartAnalyzing_ProductCase":"Menganalisis","Title_ModelImage":"Model","Text_Cookie_Title":"Yang pertama, cookie 🍪","Text_Cookie_Content":"Kami ingin menggunakan cookie di situs web ini untuk memastikan keamanan, kinerja yang efisien, dan optimalisasi layanan. Untuk mempelajari lebih lanjut tentang bagaimana kami menggunakan cookie, silakan klik","Text_Cookie_LearnMore":"Detail","Button_Cookie_Manage":"Kelola Cookie ","Button_Cookie_Accept":"Setuju","Text_CookieModal_Title1":"Pengaturan Cookie","Text_CookieModal_Desc1":"Cookie adalah file teks kecil yang disimpan situs web di perangkat untuk membantu kami mengingat preferensi Anda, melacak lalu lintas situs web, dan meningkatkan layanan kami. Privasi Anda penting bagi kami, dan kami ingin Anda mengontrol data Anda. Di sini, Anda dapat menyesuaikan preferensi cookie untuk mengoptimalkan pengalaman browsing Anda. Harap dicatat bahwa mengubah pengaturan cookie dapat memengaruhi fungsionalitas dan layanan situs web kami.","Text_CookieModal_Title2":"Cookie Penting","Text_CookieModal_Desc2":"Cookie ini penting untuk fungsionalitas, keamanan, dan kinerja inti situs web. Tanpa cookie ini, fitur utama dan langkah keamanan Zawa tidak akan berfungsi dengan baik, dan dapat berdampak negatif pada pengalaman Anda.","Text_CookieModal_Title3":"Cookie Opsional","Text_CookieModal_Desc3":"Cookie ini membantu kami memahami jumlah pengguna Zawa, dari mana mereka berasal, dan bagaimana mereka menggunakan situs web. Jika Anda memilih untuk menonaktifkan cookie ini, kami tidak akan dapat mengumpulkan kritik dan saran untuk meningkatkan Zawa atau memberikan layanan yang lebih baik untuk Anda dan pengguna lainnya.","Button_CookieModal_Save":"Simpan","Text_CookieModal":"Selalu Aktif","Text_Agent_Chat_DK":"Masukkan ide di sini…","Text_Agent_Chat_XD":"Ingin mendesain apa","Radio_Color":"Palet","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Background","Language_Banner_Message":"Ingin berganti ke ${0}?","Language_Banner_Change":"Ya","Language_Banner_Other":"Bahasa lainnya","Title_ItemTaskWithIndex_Batch":"Tugas Produk ${0}","Title_DetailTaskPrefix_Batch":"Tugas A+","Text_CopiedTaskTitle_Batch":"${0} (Salin)","Message_SelectSectionMin_Batch":"Pilih minimal satu bagian.","Title_GlobalBatchSettings_Batch":"Pengaturan global (Terapkan ke tugas berikut)","Text_Parameters_Batch":"Parameter","Text_Modules_Batch":"Bagian","Title_KeyHighlights_Batch":"Poin Penjualan","Text_ModulesFollowGlobal_Batch":"Bagian - Gunakan Pengaturan Global","Title_SelectManagedBusinessType_Batch":"Pilih Jenis Tugas","Button_SubmitTask_Batch":"Kirim","Text_NewTaskCurrentCount_Batch":"Buat Tugas","Title_NotificationSettings_Batch":"Pemberitahuan","Title_ManagedMode_Batch":"Penjadwal","Button_SaveSettings_Batch":"Simpan pengaturan","Button_SaveAndContinueSubmit_Batch":"Simpan & kirim","Message_PhoneFormatInvalid_Batch":"Masukkan 11 angka nomor telepon yang valid.","Message_VerificationCodeSent_Batch":"Kode verifikasi dikirim. Kode ini berlaku selama 5 menit.","Message_VerificationCodeSendFailed_Batch":"Gagal mengirim. Harap coba lagi nanti.","Message_PleaseEnterCode_Batch":"Masukkan kode verifikasi.","Message_GetCodeFirst_Batch":"Dapatkan kode verifikasi terlebih dahulu.","Message_VerificationCodeExpired_Batch":"Kode verifikasi kedaluwarsa. Ajukan kode baru.","Message_SaveNotificationSettingsFailed_Batch":"Gagal menyimpan pengaturan pemberitahuan. Harap coba lagi nanti.","Text_WebMessageNotification_Batch":"Pemberitahuan Web","Title_AppPushRecommended_Batch":"Pemberitahuan Aplikasi (Disarankan)","Paragraph_AppPushDesc_Batch":"Lacak progres dan lihat hasil di ponsel secara real time. Simpan desain dalam genggaman dan jangan lewatkan kesempatan yang datang.","Text_AppDownloadQrCode_Batch":"Pindai untuk mengunduh aplikasi","Title_SmsNotification_Batch":"Pemberitahuan SMS","Placeholder_Phone11Digits_Batch":"11 angka nomor telepon","Placeholder_VerificationCode5Min_Batch":"Kode verifikasi (berlaku selama 5 menit)","Text_SendingEllipsis_Batch":"Mengirim...","Text_RetryAfterSeconds_Batch":"Coba lagi dalam ${0} dtk","Button_GetVerificationCode_Batch":"Kirim Kode","Message_SubmitSuccess_Batch":"Dikirim","Message_SubmitFailedRetry_Batch":"Gagal mengirim. Harap coba lagi nanti.","Message_FormValidationPassed_Batch":"Konten valid","Message_CompleteNotificationSettingsFirst_Batch":"Harap atur pemberitahuan sebelum mengirim tugas.","Paragraph_CancelManagedTaskWarning_Record":"Tugas yang dijadwalkan akan dihapus permanen jika Anda membatalkannya sekarang.","Button_ConfirmCancel_Record":"Tetap batalkan","Message_CancelManagedTaskFailed_Record":"Gagal membatalkan. Harap coba lagi nanti.","Text_WaitingManagedGeneration_Batch":"Menjadwalkan tugas...","Text_WaitingManagedSubmit_Batch":"Mengantre","Message_NoExtendableImages_Result":"Gambar tidak tersedia","Text_IntelligentMultiSizeAdaptation_Result":"Ubah ukuran gambar agar pas dengan setiap layar","Button_IntelligentResize_Result":"Ubah Ukuran Pintar","Option_CustomSize_DetailPageMode":"Kustom","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Penjadwal siap membantu!","Text_ManagedModeSlogan_Batch":"Bekerja semalaman agar desain siap di pagi hari.","Title_BatchProduction_Batch":"Pemrosesan Massal","Paragraph_BatchProductionDesc_Batch":"Jalankan maksimal ${0} tugas bersamaan dan tingkatkan produktivitas dengan ${1}×.","Title_AiIntelligentExtraction_Batch":"AI Analisis","Paragraph_AiIntelligentExtractionDesc_Batch":"Menganalisis gambar dan otomatis membuat poin penjualan yang menghasilkan konversi tinggi.","Title_SaveCost20_Batch":"Hemat ${0}% kredit","Paragraph_SaveCost20Desc_Batch":"Anda dapat menjadwalkan tugas di malam hari dan menikmati penggunaan kredit dengan diskon.","重写":"Unduh Massal","Brand_AutoExtract_Button":"Ekstraktor Palet","Brand_AutoExtract_Success":"Palet diekstrak","Brand_AutoExtract_Failure":"Gagal mengekstrak palet. Harap coba lagi.","Brand_AutoExtract_Unavailable":"Tidak dapat mengekstrak palet warna.","Brand_AutoExtract_ConfirmTitle":"Ekstrak palet warna dari logo?","Title_ImageSetConfig_ImageSet":"Desain Daftar","Title_DefaultConfig_ImageSet":"AI Desain","Desc_DefaultConfig_ImageSet":"AI akan membuat desain daftar terbaik untuk produk Anda.","Title_CustomConfig_ImageSet":"Desain Kustom","Desc_CustomConfig_ImageSet":"Sesuaikan jumlah gambar untuk setiap jenis. Pilih setidaknya ${0} gambar.","Label_WhiteBackground_ImageSet":"Gambar Background Putih","Desc_WhiteBackground_ImageSet":"Pamerkan produk dari berbagai sudut dengan background putih.","Label_Scene_ImageSet":"Adegan Gaya Hidup","Desc_Scene_ImageSet":"Tampilkan produk dalam skenario kehidupan nyata.","Label_SellingPoint_ImageSet":"Sorotan Poin Penjualan","Desc_SellingPoint_ImageSet":"Tekankan fitur utama yang akan membuat produk diminati.","Label_Other_ImageSet":"Lainnya","Desc_Other_ImageSet":"Konten disortir otomatis untuk produk Anda, termasuk perbandingan, spesifikasi, dan aspek lainnya.","Tip_MinTotal_ImageSet":"Minimal ${0} gambar","Text_ManagedBatchEntry_Header":"Penjadwal","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Paket Kredit","Text_Higher_Plan":"Sudah Paket Tinggi","Text_Try_Free":"Coba Sekarang hanya $0","Text_Plus_Plan":"Paket Plus","Text_Pro_Plan":"Paket Pro","Button_Generate_Short_Common":"Buat","Message_DuplicateTaskSubmitConfirm_Common":"Hasil sudah dibuat dengan pengaturan ini. Buat lagi?","Text_CreditUnit_Common":"Kredit","Text_NewUserDiscountDesc_Product":"${0} kredit untuk daftar pertama. ${2} kredit untuk setiap ${1} daftar tambahan.","Text_NewUserLimitedTag_Product":"Diskon Pengguna Baru","Text_OriginalPrice_Product":"Original: ${0} kredit","Tip_MaxTotal_ImageSet":"Maksimal ${0} gambar","Text_AddDocumentTips":"Mendukung file Word, Excel, Text, PDF dan Markdown","Tab_SolidColor":"Warna Solid","Tab_Gradient":"Gradien","Title_PresetGradient":"Preset","Title_PresetSolidColor":"Preset","Title_RecentlyUsed":"Baru saja digunakan","Title_Patterns":"Pola","Title_NoFill":"Tidak ada","Description_Brand_Reference":"Unggah poster atau aset seni favorit dan Zawa akan menggunakan gaya tersebut untuk membuat desain sesuai selera Anda.","Text_Generating":"Memproses...","Text_ChartSending":"Sedang mengirim","Text_PeopleUnSupport":"Belum mendukung mode potret","Button_CancelManagedBatch_ResultGroup":"Batalkan tugas","Button_DownloadZip_ResultGroup":"Unduh ZIP","Button_DownloadLongImage_ResultGroup":"Unduh kombinasi","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"Tugas yang dikirim tidak dapat dibatalkan","Button_GlobalAiWriting_Batch":"AI Penulisan","Text_StandardModel_DistributionBatch":"Model Standar (Daftar Massal)","Text_StandardModelDescription_Batch":"Ideal untuk SKU dengan volume tinggi guna memaksimalkan jangkauan pasar.","Text_AdvancedModel_PremiumBatch":"Model Lanjutan (Daftar Tertarget)","Text_AdvancedModelDescription_Batch":"Gambar berkualitas premium yang ideal untuk profitabilitas berbasis presisi.","Message_MinSubmitTasks_Batch":"Kirimkan minimal ${0} tugas.","Message_OverwriteSellingPointsConfirm_Batch":"Bagian poin penjualan telah diisi dalam ${0} tugas. Bagaimana Anda ingin menerapkan hasil AI penulisan?","Button_OverwriteAll_Batch":"Ganti semua","Button_FillEmptyOnly_Batch":"Tidak lengkap saja","Message_NoEmptySellingPointsToFill_Batch":"Poin penjualan untuk semua tugas sudah selesai.","Message_AiWritingFailedRetry_Batch":"AI penulisan gagal. Harap coba lagi nanti.","Button_NewTask_Common":"Tugas baru","Message_Generating_Time":"Tugas akan berjalan semalaman (${0}-${1}). Cek lagi besok untuk melihat hasilnya.","Title_Total_Credits":"Total kredit","Text_Used_AllFeatures":"Berlaku untuk semua fitur","Daily_Present_Credits":"Gunakan kredit hari ini","Daily_Credits_Desc":"Klaim setiap hari. Berlaku sampai penghujung hari.","Text_Inactive":"Tidak aktif","Text_Inactive_Monthly":"${0} kredit akan kedaluwarsa dalam 30 hari ke depan","TITLE_GUIDE_CUTOUT_LITE":"Stempel atau logo terdeteksi","GUIDE_DESC_CUTOUT_LITE":"Gunakan Potong Stempel/Logo untuk pemotongan yang presisi","GUIDE_ACTION_CUTOUT_LITE":"Potong Stempel/Logo","TITLE_CUTOUT_LITE":"Potong Stempel/Logo","TIP_CUTOUT_LITE":"Memotong stempel atau logo secara akurat","PROCESSING_CUTOUT_LITE":"Membuat gambar...","AFTER_CUTOUT_LITE":"Hasil","Button_Previous":"Sebelumnya","Button_Next":"Selanjutnya","Button_Skip":"Lewati","Button_Apply":"Terapkan","Text_AgentExpert":"Ahli","Message_PleaseEnterLinkOrAsin_Clone":"Masukkan tautan atau ASIN","Message_LinkAnalyzeFailed_Clone":"Analisis tautan gagal","Message_UploadProductImageFirst_Clone":"Unggah foto produk terlebih dahulu","Message_ProductImageThumbGenerateFailed_Clone":"Gagal membuat thumbnail. Unggah lagi.","Message_UploadProductImageFirst_ProductCase":"Unggah gambar referensi atau tempelkan tautan produk","Message_ReferenceImageThumbGenerateFailed_Clone":"Gagal membuat thumbnail. Unggah lagi.","Title_ReferenceSource_Clone":"Referensi","Option_LinkAsin_Clone":"Tautan","Input_PasteProductLinkOrAsin_Clone":"Tempelkan tautan Amazon","Button_Parsing_Clone":"Menganalisis...","Button_Parse_Clone":"Analisis","Text_SupportAmazonTiktokLinks_Clone":"Mendukung tautan Amazon dan TikTok","Text_Cloning_ResultStatus":"Memproses...","Input_CloneRequirementOptional_Clone":"Requirements (Optional)","Title_ProductOriginalImage_Clone":"Foto Produk","Title_CloneLevel_Clone":"Ketajaman","Option_CompositionReference_Clone":"Gaya","Desc_CompositionReference_Clone":"Gunakan gaya dan komposisi untuk otomatis menyesuaikan warna dan membuat adegan.","Option_HighFidelityClone_Clone":"Visual Keseuruhan","Desc_HighFidelityClone_Clone":"Gunakan komposisi visual secara keseluruhan. Ganti hanya produk dan teks sekaligus memfasilitasi variasi halus dalam adegan.","Label_OutputStyleConsistent_Clone":"Gaya Konsisten","Title_SupplementaryNotesOptional_Clone":"Persyaratan Umum (Opsional)","Input_SupplementaryNotesExample_Clone":"Contoh: Buat salinan produk dalam bahasa Inggris, pertahankan model yang sama, dan ganti hanya produknya.","Title_HotClone_Welcome":"Kloning dan Buat","Text_HotCloneDescription_Welcome":"Layout Terbaik + Produk Anda = Best Seller","Text_DefaultTaskName_Clone":"Strategi Kloning Foto","Label_ProductImage_CloneCase":"Foto Produk","Label_ReferenceComposition_CloneCase":"Gaya","Label_HighFidelityClone_CloneCase":"Visual Keseuruhan","Tag_AiSmartMatch_ImageSet":"AI pencocokan pintar","Title_Date":"Tanggal","Title_Topic":"Tema","Button_Replace":"Ganti","Title_SingleCloneRequirement_Clone":"Persyaratan Individu","Text_UploadedReferenceImagesTip_Clone":"Persyaratan individu untuk setiap gambar referensi. Pengaturan default akan diterapkan jika persyaratan tidak ditentukan.","Label_ReferenceImageIndex_Clone":"Gambar referensi ${0}","Option_Mexico_Market":"Meksiko","Text_ParsingReferenceImages_Clone":"Menganalisis...","Text_ParseReferenceImagesSuccess_Clone":"Analisis selesai. ${0} gambar referensi diperoleh.","Text_Renew_Restore":"Kredit akan dipulihkan setelah langganan diperpanjang.","Title_UsageNotice_Clone":"Panduan Penggunaan","Text_UsageNoticeDescription_Clone":"Pastikan bahwa Anda memiliki hak resmi untuk menggunakan konten dari tautan ini. Hasil yang dibuat didasarkan pada analisis gaya AI dan hanya untuk referensi kreatif.","Label_ReadAndAgreeUsageNotice_Clone":"Saya menerima ketentuan di atas","Label_DoNotShowAgain_Clone":"Jangan tampilkan lagi","Brand_StatusPopup_ProcessingTitle":"Zawa sedang mempelajari gaya merek Anda...","Brand_StatusPopup_FailedTitle":"Gagal mengekstrak data dari Square. Coba lagi nanti.","Brand_StatusPopup_Retry":"Coba lagi","SecondTitle_Header19_Home":"Kloning Iklan Video","SquareBrandGuide_BrandKitCreatedTip":"Kit merek Anda telah dibuat berdasarkan data Square","SquareBrandGuide_DefaultPrompt":"Desain poster produk untuk promosi di media sosial","SquareBrandGuide_SendTip":"Klik Kirim untuk memulai!","Paragraph_BatchProductionDescUnlimited_Batch":"Menangani beberapa tugas sekaligus, sehingga mempersingkat waktu proyek.","Menu_ViewDetail":"Detail","Menu_CopyFullText":"Salin semua","Tip_CopiedToClipboard":"Disalin ke clipboard","Tip_CopyFailed":"Gagal menyalin","Menu_DownloadImage":"Unduh","Tip_NoImage":"Tidak ada gambar","Tip_DownloadStarted":"Sedang mengunduh","Menu_CopyText":"Salin","Tip_NoTextToCopy":"Teks tidak tersedia","Message_LinkImageFetchFailed_Clone":"Tidak dapat memuat gambar dari tautan ini. Coba tautan lain atau unggah langsung gambar.","Tab_Chat":"Chat","Tab_Files":"Files","Button_Create_New_Chat":"New chat","Tip_Agent_Team_Chat_Shared":"Viewing read-only version","RoboNeo_Web_input_default_content":"Mengobrol dengan RoboNeo","RoboNeo_Web_chatbox_maximum":"Obrolan sudah maksimal","RoboNeo_Web_chatbox_maximum_text":"Obrolan sudah maksimal. Buat tugas baru untuk melanjutkan.","RoboNeo_Web_chatbox_new_task":"Proyek baru","RoboNeo_Web_history_share_text":"Bagikan","RoboNeo_Web_history_delete_text":"Hapus","RoboNeo_Web_history_delete_hint_text":"Catatan","RoboNeo_Web_history_delete_main_text":"Proyek akan dihapus permanen. Lanjutkan?","RoboNeo_Web_history_delete_hint_confirm":"Hapus","RoboNeo_Web_history_delete_hint_cancel":"Batal","RoboNeo_Web_studio_download":"Unduh","RoboNeo_Web_toast_share_text":"Bagikan obrolan ini","RoboNeo_Web_toast_share_main_text":"Orang yang punya tautan obrolan dapat melihat riwayat obrolan","RoboNeo_Web_toast_share_copy":"Salin tautan","RoboNeo_Web_toast_cancel":"Batal","RoboNeo_Web_toast_confirm":"Konfirmasi","RoboNeo_Web_studio_changing_toast":"Tidak ada penggunaan gratis tersisa untuk hari ini. Penggunaan akan diatur ulang pada tengah malam. Berikan \\"Cyber Carrots\\" pada Neo untuk melanjutkan.","RoboNeo_Web_studio_changing_toast2":"Tidak ada penggunaan gratis tersisa hari ini.","RoboNeo_Web_new_studio":"Obrolan baru","RoboNeo_Web_sidebar_close":"Susutkan","RoboNeo_Web_history_text":"Riwayat","RoboNeo_Web_sidebar_open":"Perluas","RoboNeo_Web_upload_warning_text":"Tidak dapat mengunggah foto dan video sekaligus.","RoboNeo_Web_upload_format_text":"Mendukung format gambar: JPG, PNG, dan JPEG. Mendukung format video: MP4 dan MOV.","RoboNeo_Web_upload_fail_text":"Unggahan gagal","RoboNeo_Web_upload_image_maximum":"Pengguna bisa mengunggah maksimal {max_num} foto","RoboNeo_Web_upload_video_size_maximum":"Tidak mendukung video berukuran lebih dari {max_size} MB.","RoboNeo_Web_upload_image_size_maximum":"Tidak mendukung foto berukuran lebih dari {max_size} MB.","RoboNeo_Web_upload_video_maximum":"Pengguna bisa mengunggah maksimal {max_num} video","RoboNeo_Web_history_dafult_text":"Tidak ada riwayat, mulai obrolan sekarang.","RoboNeo_Web_upload_content_warning_text":"File dengan konten yang diduga tidak pantas tidak akan diimpor.","RoboNeo_Web_chat_send_fail":"Pengiriman gagal, harap coba lagi nanti.","RoboNeo_Web_network_fail":"Koneksi gagal atau waktu habis, harap coba lagi.","RoboNeo_Web_studio_layer_fail":"Gagal memisahkan layer.","RoboNeo_Web_studio_layer_success":"Selesai","RoboNeo_Web_network_error":"Kesalahan jaringan","RoboNeo_Web_delete_success":"Dihapus","RoboNeo_Web_delete_fail":"Gagal menghapus","RoboNeo_Web_copy_success":"Disalin","RoboNeo_Web_file_uploading":"Mengunggah {num} file","RoboNeo_Web_file_upload_fail":"Kesalahan mengunggah {num} file","RoboNeo_Web_file_upload_single_fail":"Kesalahan mengunggah 1 file","RoboNeo_Web_file_uploading_single":"Mengunggah 1 file","RoboNeo_Web_upload_video_maximum_one":"Pengguna bisa mengunggah maksimal 1 video","RoboNeo_Web_sharepage_wanna_try":"Coba Sekarang","RoboNeo_Web_sharepage_load_to_end":"Buka Hasil","RoboNeo_Web_studio_loading_text":"Memuat kanvas...","RoboNeo_Web_chatbox_add_image":"Tambah foto","RoboNeo_Web_chatbox_add_video":"Tambahkan video","RoboNeo_Web_image_editor_max":"Maks 10 MB dengan 4096 px pada sisi terpanjang","RoboNeo_Web_unlimited_pass_expired":"Voucher Unlimited telah berakhir. Sekarang memanfaatkan penggunaan gratis yang tersedia.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - selesai ","RoboNeo_Web_studio_ai_image_failed":"AI UHD - gagal","RoboNeo_Web_studio_cutout_successful":"Berhasil dipotong","RoboNeo_Web_studio_cutout_failed":"Gagal dipotong","RoboNeo_Web_studio_ai_edit_failed":"AI Pengeditan - gagal","RoboNeo_Web_studio_ai_edit_successful":"AI Pengeditan - selesai","RoboNeo_Web_AI_generated":"Hasil AI","RoboNeo_Web_loading":"Memuat","RoboNeo_Web_view_creative_process":"Lihat Proses Kreatif","RoboNeo_Web_try_now":"Coba Sekarang","RoboNeo_web_extender_successful":"AI Perluasan - selesai","RoboNeo_web_extender_failed":"AI Perluasan - gagal","RoboNeo_web_eliminate_successful":"AI Penghapus - selesai","RoboNeo_web_eliminate_failed":"AI Penghapus - gagal","roboneo_web_continue":"Lanjutkan","roboneo_web_video":"Video","roboneo_web_HTML":"Halaman web","roboneo_web_shared_error_message":"Obrolan ini tidak dapat dibagikan, coba mulai obrolan baru.","roboneo_web_open_the_APP_experience":"Coba di aplikasi","roboneo_web_AI_generated_logo":"Konten yang dibuat oleh AI ini hanya sebagai referensi.","roboneo_web_change_word_success":"Ganti Teks - selesai","roboneo_web_change_word_fail":"Ganti Teks - gagal","roboneo_web_canvas_loading_failed":"Gagal memuat kanvas","roboneo_web_export_failed":"Ekspor gagal","roboneo_web_export_tips2":"Ekspor hanya mendukung satu foto (maks {width}px*{height}px).","roboneo_web_new_topic":"Obrolan baru","roboneo_web_waiting_reply":"Menunggu respons","roboneo_web_file_saving_preferences":"Preferensi file","roboneo_web_includes_AI_watermark":"Cantumkan watermark AI","roboneo_web_no_remind":"Jangan tampilkan lagi","roboneo_web_agree_continue":"Setujui dan lanjutkan","roboneo_web_AI_generated":"Konten dibuat oleh AI","roboneo_web_watermark_protocol":"Pengguna bisa memilih untuk menyimpan foto dengan atau tanpa watermark \\"Buatan AI\\". Dengan menyimpan tanpa watermark, berarti pengguna setuju untuk: 1. Tidak menggunakan RoboNeoAI untuk membuat, memublikasikan, atau menyebarkan informasi palsu. 2. Memastikan kepatuhan terhadap hukum dan dengan jelas menunjukkan bahwa konten tersebut dibuat oleh AI saat digunakan atau dibagikan.","roboneo_web_rectangle":"Persegi","roboneo_web_circle":"Bulat","roboneo_web_arrow":"Panah","roboneo_web_image_fusion_success":"Selesai","roboneo_web_image_fusion_failure":"Gagal","roboneo_chat_resources_num_limit_tips":"Pengguna dapat menambahkan maksimal {img_num} video dan {video_num} foto.","RoboNeo_Web_export_confirm_tip_popup_title":"Opsi untuk mengekspor dengan atau tanpa tanda air “AI Generated”.","RoboNeo_Web_export_confirm_tip_popup_btn":"Jadi begitu"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/x-design-locales-next/pt.json
const x_design_locales_next_pt_namespaceObject = JSON.parse('{"Tab_Design":"Design","Button_Send":"Enviar","Input_Describe_Workspace":"Descreva sua imagem e eu a criarei para você","Tab_AgentCase":"Caso do agente","Tab_RecentCreations":"Recentes","Tag_Hot":"Tendência","Tag_BrandDesign":"Design de marca","Tag_Logo":"Logotipos","Tag_Posters":"Pôsteres","Tab_Agent":"Agente","Tool_AiPhotoEditor":"Editor de imagem","Button_Upload":"Carregar","Tool_Designer":"Designer","Title_AiTool":"Ferramentas de IA","Tool_ImageBackgroundRemover":"Removedor de fundo com IA","Tool_AiBackgroundGenerator":"Gerador de fundo com IA","Tool_ImageEnhancer":"Aprimorador de imagem","Tool_AiObjectsRemover":"Removedor de objeto com IA","Tool_AiModelMannequin":"Modelo de IA - Manequim","Tool_AiModelFlatlay":"Modelo de IA - Flatlay","Tool_AiImageRecolor":"Recolorir imagem com IA","Tool_AiImageExtender":"Extensor de imagem com IA","Tool_ImageUpscaler":"Ampliador de imagem com IA","Tool_AiLogo":"Gerador de logotipo com IA","Button_BlankCanvas":"Criar","Sidebar_Create":"Início","Sidebar_Tools":"Ferramentas de IA","Sidebar_Batch":"Editor em lote","Sidebar_MyDesigns":"Meus designs","Sidebar_Inspire":"Me inspire","Sidebar_Brand":"Kit de marca","Sidebar_PackUp":"Fechar barra lateral","Tag_All":"Tudo","Tag_Design":"Design","Sidebar_Unfold":"Abrir barra lateral ","Menu_Edit":"Editar","Menu_Download":"Baixar","Menu_Delete":"Excluir","Tab_RecentlyCreated":"Recentes","Tab_GenerateRecords":"Criações","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Apenas para o agente de IA e serão usados primeiro.","Menu_DueToday":"Créditos de bônus diários","Menu_DueToday_Explain":"Válidos até o final do dia.","Menu_Else_AgentCredits":"Outros créditos","Button_GoPro_GetMore":"Obtenha mais créditos","Menu_Total_Explain_PaidCredits":"Para todos os recursos e válidos durante o período de assinatura.","Menu_Pro":"Créditos de assinatura","Menu_Pro_Explain":"Válidos durante o período de assinatura.","Menu_Else":"Outros créditos","Menu_Else_Explain_PaidCredits":"Créditos obtidos de outras fontes. Cada tipo pode ter seu próprio prazo de validade.","Menu_Else_Explain_AgentCredits":"Créditos de outras fontes. Válidos por um período mais longo.","Menu_UsageDetail":"Detalhes de uso","Menu_Total_Explain_SuspendCredits":"Indisponíveis até que sua assinatura seja reativada.","Tab_Invite":"Convidar","Menu_InviteReward":"Recompensa por convidar amigos","Tab_Reward":"Recompensas","Title_AgentCreditForRewards":"Recompensas de Créditos de Agente:","Table_Time":"Hora","Table_Invitee":"Convidado","Title_ShareWithFriends":"Compartilhe com seus amigos","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Convide um amigo e ambos receberão </span><span style=\\"color:#2D990C;\\">${0} Créditos de Agente!</span>","Title_InvitationLink":"Compartilhe este link com seus amigos","Button_Copy":"Copiar","Title_Tips":"Dicas","Title_Tips_ExplainOne":"1. Os Créditos de Agente só podem ser usados para acessar os recursos do Agente de IA. Créditos de recompensa são válidos por dois anos.","Title_Tips_ExplainTwo":"2. Novos amigos receberão uma recompensa após se registrarem com sucesso. Se você tiver alguma dúvida, entre em contato com nossa equipe de suporte.","Title_GetRewarded":"Convite bem-sucedido!","Title_GetRewarded_Explain":"Os créditos só podem ser usados para recursos do Agente de IA e são válidos por dois anos.","Button_Ok":"Entendi","Title_FailedToReceiveReward":"Falha na operação","Title_FailedToReceiveReward_Explain":"Se você tiver alguma dúvida, entre em contato com nossa equipe de suporte.","Input_Describe_workspace":"Descreva a sua ideia de imagem e vou criá-la para você","Tool_AiBackgroundGenrator":"Gerador de fundo com IA","Title_YouCannotUseYourOwnLink":"Links privados não são permitidos","Table_AgentCredit":"Créditos de Agente","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">Você pode convidar até </span><span style=\\"color:#2D990C;\\">${0} novos amigos</span><span style=\\"color:#616266;\\"> e ganhar no máximo ${1} Créditos de Agente!</span>","Button_Invite":"Convidar","Menu_Title_Invite":"Indicar um amigo","Text_Button_Invite":"Ganhar créditos","Title_Dialog_Invite":"Indicar um amigo","Desc_Dialog_Invite":"Compartilhe seu link com amigos ou nas redes sociais. Quando alguém usar seu link para se inscrever, você e essa pessoa receberão ${0} créditos. Se ela assinar, vocês receberão até ${1} créditos extras.    ","Detail_Dialog_Invite":"Detalhes","Text_Copy_Invite":"Copiar link","Title_Rewards_Invite":"Recompensas","SubTitle_Rewards1_Invite":"Total de créditos ganhos","SubTitle_Rewards2_Invite":"Usuários não pagantes indicados","SubTitle_Rewards3_Invite":"Usuários pagantes indicados","Success_Copy_Invite":"Link copiado","Title1_Invited_Invite":"Você recebeu um convite!","Text_Rule1_Invite":"Para cada pessoa que assinar usando seu link, você e essa pessoa ganham <strong>${0} créditos</strong>.","Text_Rule2_Invite":"Se seu amigo assinar, cada um de vocês receberá créditos extras (<strong>${0} para o plano Plus, ${1} para o Pro</strong>).","Text_Rule3_Invite":"As assinaturas adquiridas não poderão ser reembolsadas se o plano tiver sido usado ou se algum crédito concedido tiver sido gasto. Além disso, créditos gratuitos não podem ser revogados depois de utilizados.","Text_Rule4_Invite":"Cada usuário pode convidar até ${0} amigos.","Text_Rule5_Invite":"Recompensas por indicações não são concedidas no caso de contas existentes, auto-indicações, contas duplicadas ou atividades fraudulentas.","Text_Rule6_Invite":"${0} se reserva o direito de ajustar o programa e revogar recompensas de contas anormais.","Text_Divider_Invite":"ou compartilhe o link","Title2_Invited_Invite":"Participe de ${0} e reivindique suas recompensas","SubTitle1_Invited_Invite":"Um amigo convidou você para experimentar nosso agente de IA profissional. Crie designs de marketing com alta qualidade para marcas, como logotipos, cartazes, cardápios e materiais de mídias sociais com facilidade.  ","SubTitle2_Invited_Invite":"<strong>Cadastre-se agora</strong> e você e seu amigo <strong>receberão ${0} créditos</strong>. <strong>Se você assinar,</strong> cada um receberá créditos adicionais de acordo com o plano escolhido: <strong>${1} créditos com o Plus ou ${2} créditos com o Pro</strong>. Cadastre-se agora para resgatar suas recompensas.","Button_Invited_Invite":"Inscreva-se para reivindicar suas recompensas","Success_Invited_Invite":"Você entrou por meio de uma indicação e recebeu ${0} créditos.","Error_Invited_Invite":"Você já tem uma conta.","Text_Share_Invite":"Tenho usado o ${0} para criar logotipos, visuais e vídeos de modo realmente muito rápido. Inscreva-se com meu link e nós dois receberemos créditos de bônus.","Title_Share_Invite":"Faça parte de ${0} e ganhem créditos juntos!","Share_Email_Invite":"E-mail","Text_Rule7_Invite":"Você pode usar os créditos com o Agente de IA. Eles expiram depois de um mês.  ","Title_AgentCredits":"+50 Créditos de Agente","Input_Models":"Modelo","Button_TryItNow":"Experimente agora","Account_Pricing":"Preços","Account_Language":"Idioma","Account_Language_English":"Inglês","Account_Language_Chinese":"Chinês","Tips_Adding":"Processando...","Tips_Loading":"Carregando...","Tips_Creating":"Processando...","Tips_Downloading":"Baixando...","Tips_Sending":"Enviando...","Tips_AddSuccess":"Adicionado com sucesso","Tips_MakeSameError":"Não é possível recriar","Tips_UnsupportedGradientColor":"Os gradientes não são suportados","Tips_CanNotAdding":"Falha ao adicionar","Tips_Uninitialized":"Falha ao enviar mensagens","Tips_UploadFailed":"Falha no carregamento. Por favor, tente novamente.","Tips_UploadMaxCountLimit":"Carregue até ${n} arquivo(s) ${type}","Tips_UploadMaxFileSize":"Não foi possível carregar o arquivo ${file}. Por favor, use um arquivo com tamanho máximo de ${n} MB.","Tips_UploadImageAndVideoLimit":"Você pode carregar 1 imagem e 1 vídeo ao mesmo tempo","Tips_UnsupportedSvgFile":"Arquivos SVG não são suportados","Tips_UnsupportedUploadFileFormats":"O formato do seu arquivo ${files} não é compatível","Tips_CanNotAddSameFileTips":"Este arquivo já existe","Tips_TextMinLengthTips":"Insira pelo menos ${n} caracteres","Tips_TextMaxLengthTips":"Insira até ${n} caracteres. Cada caractere chinês ou emoji conta como 2.","Tips_AccessDenied":"Acesso negado","Tips_CreateFailed":"Falha ao iniciar o chat","Tips_Error":"Ocorreu um erro","Tips_NotFound":"O chat não existe","Tips_RequestAgentModelListError":"Falha ao solicitar a lista de modelos do agente","Desc_Ended":"Fim","Button_PeopleUse_Agent":"${n} usuários experimentaram","Dropdown_AddToChat":"Adicionar ao chat","Dropdown_AddToBrandKit":"Adicionar ao kit de marca","Dropdown_SaveToBrandKit":"Salvar como logotipo de marca","Dropdown_SaveToBrandTemplate":"Salvar como modelo de marca","Title_Design_Agent":"Design","Title_MainColor":"Cor principal","Title_SecondaryColor":"Cor secundária","Bitton_ViewTheBrandKit":"Clique para ver o kit de marca","Dropdown_InportImages":"Importar imagens","Title_Upgrade_Pro":"Atualizar","Desc_SubscribeToUnlock_Pro":"Assine para desbloquear mais!","Desc_RunOutOfFreeUses_Pro":"Você esgotou suas utilizações gratuitas.","Desc_RunOutOfUsesForToday_Pro":"Você esgotou seus usos gratuitos de hoje. Volte amanhã.","Desc_PurchaseCompleted_Pro":"Compra concluída","Desc_ContinueDesign_Pro":"Agora você pode continuar seu projeto!","Button_UnlockNow":"Assinar","Tips_Copied":"Copiado!","Tips_Credit_Explain_Paid":"O que são créditos comprados?","Title_Total_InactiveCredits":"Total de créditos inativos","Title_Total_PaidCredits":"Créditos totais adquiridos","Menu_SuspendCredits":"Créditos inativos","Menu_Credits":"Créditos","Tab_RecentCreations_Agent":"Agente","Tab_RecentCreations_Design":"Ferramentas inteligentes","Menu_FunctionalPricing":"Preços do agente","Title_Total_AgentCredits":"Total - Créditos de Agente","Tips_Credit_Explain_Agent":"O que são Créditos de Agente?","Title_FeaturePricing":"Preços do agente","Tab_Category":"Categoria","Tab_TaskType":"Tarefa","Tab_Consume":"Preço (Créditos)","Tab_ExampleContent":"Exemplos","Tips_CreditExplain_Inactive":"O que são os créditos inativos?","langding_more_bg_remover":"Removedor de fundo","langding_more_enhancer":"Aprimorador de imagem","langding_more_objects_remover":"Removedor de objeto com IA","langding_more_bg_generator":"Gerador de fundo com IA","Title_More1_Home":"Aprimorador de imagem","Title_More2_Home":"Removedor de objeto com IA","Title_More3_Home":"Gerador de fundo com IA","Title_More4_Home":"Removedor de fundo com IA","Title_More5_Home":"Ferramentas de imagens em lote","Title_Home":"Seu agente de design com IA para <span>e-commerce</span>","Placeholder_Input_Home":"Descreva sua imagem e vou criá-la para você.","Title_Card4_Home":"Elementos visuais para a Amazon","Title_Card1_Home":"Provador virtual de roupas e acessórios","Title_Card3_Home":"Imagens para a página de detalhes de produto","Title_Card2_Home":"Gerador de fundo","Desc_Features1_Home":"A IA extrai automaticamente as características do produto e as preferências de estilo para determinar as soluções ideais de design.","Desc_Features2_Home":"Basta inserir uma frase e a IA gerará uma coleção completa de imagens de e-commerce, incluindo a imagem principal, elementos visuais de apoio e uma página com detalhes completos sobre o produto.","Text_Btn_Home":"Comece gratuitamente","Desc_Features3_Home":"Crie automaticamente elementos personalizados prontos para plataformas como Amazon, Etsy, TEMU, eBay e muito mais, garantindo que as imagens sempre sejam otimizadas para atrair o público certo.","Desc_Features4_Home":"Basta inserir seu pedido, e a IA adaptará a linguagem, o estilo, o tom e os elementos culturais para produzir versões localizadas para cada mercado-alvo.","Desc_Features5_Home":"Salve o fluxo de trabalho do seu design como um modelo reutilizável, e deixe que a IA gere imagens em lote automaticamente para todas as SKUs.","Desc_Features6_Home":"Não faz diferença se você está trabalhando com 10 ou 1.000 produtos; gere rapidamente um conjunto visual completo e consistente com facilidade.","Title_Qualification_Home":"Mais de 5 milhões de vendedores de e-commerce confiam!","Text_Btn_Qualification_Home":"Exibir certificado","Title_Carousel_Home":"Mais ferramentas de IA","Title_Footer_Home":"Seu agente de design com IA para e-commerce","Title_Footer1_Home":"Conta de mídia social","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Ajuda e informações legais","Subtitle_Footer5_Home":"Termos de Serviço","Subtitle_Footer6_Home":"Política de Privacidade","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Adoro Designkit! As imagens de estilo de vida da IA são naturais, e o estilo nórdico aconchegante é perfeito para a minha loja de velas. As minhas publicações têm um visual elegante e as vendas têm aumentado. Vale muito a pena.","Job_Evaluation5_Home":"Vendedor da TEMU no México","Job_Evaluation6_Home":"Especialista em operações da Amazon","Job_Evaluation12_Home":"Gerente de uma loja com várias SKUs na Amazon da Indonésia","Job_Evaluation2_Home":"Proprietário de loja na Amazon e no Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"As imagens de estilo de vida são bem naturais, parecendo até fotos tiradas por um profissional. Meus clientes também parecem adorá-las, e notei um aumento real nas vendas.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Proprietário de loja internacional na Lazada e na Shopee (Indonésia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Designer de e-commerce DTC","Job_Evaluation8_Home":"Proprietário de loja de produtos para áreas externas do Walmart na América","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Vendedor do Mercado Livre da Argentina","Desc_Evaluation7_Home":"As cenas de produtos para pets geradas por IA são muito fofas! Cães e gatos parecem perfeitamente proporcionais e naturais. Além disso, o tamanho e a escala das imagens se adaptam aos requisitos de cada plataforma, facilitando o uso imediato.","Job_Evaluation7_Home":"Proprietário de loja no Mercado Livre do Brasil","Desc_Evaluation8_Home":"As cenas de acampamento com as minhas barracas ficaram muito realistas. A iluminação e os ângulos parecem naturais, e as proporções estão perfeitas. Eu economizo tanto tempo por não precisar tirar as fotos!","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"A ferramenta é bem rápida, e as imagens que ela gera são enviadas diretamente ao Mercado Livre e à Amazon sem nenhum outro ajuste.","Desc_Evaluation6_Home":"Minha preocupação era que a IA estragasse as texturas dos tecidos, mas é difícil perceber qualquer diferença em comparação com o original. As malhas continuam parecendo malhas, o jeans parece jeans, e tudo atende aos requisitos de imagem da Amazon. Lançar novos produtos nunca foi tão fácil.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"As imagens dos produtos geradas por IA são muito precisas. O comprimento dos cabos e os formatos dos conectores são perfeitos e seguem o estilo da TEMU. Eu economizo muito tempo agora que não preciso tirar as fotos.","Desc_Evaluation12_Home":"Com apenas um prompt, consigo gerar gráficos prontos para usar imediatamente, o que é muito mais rápido do que esperar por um designer. É realmente superprático.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"As texturas metálicas e os detalhes estruturais são muito nítidos e deixam as imagens ainda mais profissionais. Posso usar tudo imediatamente, sem fazer nenhuma edição.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"A geração em lote é muito útil. Posso processar dezenas de SKUs de uma vez; é muito mais rápido do que fazer tudo manualmente como fazia antes.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Eu vendo roupas e tinha medo que a IA estragasse as cores ou as texturas dos tecidos, mas tudo ficou ótimo! As poses das modelos são naturais e as imagens vêm basicamente prontas para uso imediato.","Job_Evaluation1_Home":"Especialista em operações de loja da SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Especialista em operações da Amazon","Desc_Evaluation2_Home":"A ferramenta é super-rápida, e as imagens já vêm praticamente prontas para serem enviadas ao Mercado Livre ou à Amazon. Ela até adapta os fundos e os modelos à cultura local, e os resultados têm um aspecto totalmente profissional.","Job_Evaluation4_Home":"Vendedor do eBay na Alemanha","Title_Evaluation_Home":"Suas histórias","Title_Introduction_Home":"Design premium com IA que gera mais vendas","Desc_Qualification_Home":"Provedor de Serviços certificado pela SPN da Amazon","Title_Seo_Home":"Gerador de imagens e vídeos de produtos com IA para e-commerce","Desc_Seo_Home":"Gere instantaneamente imagens, pôsteres e vídeos de produtos para a Amazon, o TikTok e muitas outras lojas online com o Agente de IA do Designkit. Comece hoje mesmo a criar designs sem custos!<br>","Keywords_Seo_Home":"Agente de IA para e-commerce, Ferramentas de IA para e-commerce, Gerador de imagens de produtos com IA, Gerador de vídeos de produtos com IA, Editor de fotos de produtos com IA, Removedor de fundos com IA","Title_Features1_Home":"De uma única solicitação a um conjunto completo de elementos visuais","Title_Features2_Home":"Localização totalmente automatizada para vender seus produtos globalmente em várias plataformas.","Title_Features3_Home":"Gere imagens em lote automaticamente para vários SKUs e supere a concorrência!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Role para explorar","Tips_Material1_Home":"Conjunto de imagens para venda","Tips_Material2_Home":"Provador virtual","Tips_Material3_Home":"Conteúdo A+","Tips_Material4_Home":"Gerador de fundos","Free_Button_Home":"Experimente gratuitamente","Title_Header1_Home":"Produto","Title_Header2_Home":"solução","Title_Header3_Home":"Inspiração","Title_Header4_Home":"Aprender","Title_Header5_Home":"Preços","SecondTitle_Header1_Home":"Agente de e-commerce com IA","SecondTitle_Header2_Home":"Ferramentas de imagem com IA","SecondTitle_Header3_Home":"Ferramentas de vídeo com IA","SecondTitle_Header4_Home":"Solução de design da Amazon","SecondTitle_Header5_Home":"Soluções de e-commerce para redes sociais","SecondTitle_Header6_Home":"Gerador de imagens de produtos com IA","SecondTitle_Header7_Home":"Gerador de modelos de moda com IA","SecondTitle_Header8_Home":"Modificador de cor de roupas","SecondTitle_Header9_Home":"Gerador de vídeos de produtos","SecondTitle_Header10_Home":"Ferramentas de IA","SecondTitle_Header11_Home":"Editor de fotos com IA","SecondTitle_Header12_Home":"Editor de fotos com IA online","SecondTitle_Header13_Home":"Editor de fotos em lote","SecondTitle_Header14_Home":"Editor de fotos com IA em lote","SecondTitle_Header15_Home":"Aprimorador de imagens em lote","SecondTitle_Header16_Home":"Removedor de marcas d\'água em lote","SecondTitle_Header17_Home":"Gerador de fundos em lote","SecondTitle_Header18_Home":"Removedor de fundo de imagens em lote","Title_Footer3_Home":"Ferramentas de design","Subtitle_Footer8_Home":"Editor de fotos com IA","Subtitle_Footer7_Home":"Alterador de fundo com IA","Subtitle_Footer9_Home":"Fundo transparente","Subtitle_Footer10_Home":"Alterar a cor do fundo","Subtitle_Footer11_Home":"Removedor de marcas d\'água em imagens","Subtitle_Footer12_Home":"Remover texto da imagem","Subtitle_Footer13_Home":"Adicione adesivos às fotos","Subtitle_Footer14_Home":"Adicionar marca d\'água às fotos","Title_Footer4_Home":"Modelos de imagem","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Baixe gratuitamente","Subtitle_Footer16_Home":"APP iOS","Subtitle_Footer17_Home":"APP Android","Title_Footer6_Home":"Siga-nos","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Modelos de vídeo","Button_Export":"Baixar","Title_Layer":"Camadas","InputNumber_Opacity":"Opacidade","Buttom_Comfirm":"Confirmar","Button_Share":"Compartilhar","Button_Delete":"Excluir","Title_LoginPopup":"Faça login para iniciar o período de teste","SubTitle_LoginPopup":"Comece a criar com o Zawa hoje","Tip_ModalTitle":"Lembrete","TipContent_HistoryDelete":"Depois de excluído, esse registro não poderá ser restaurado. Confirmar a exclusão?","Title_Logo":"Logotipo","Title_BrandKit":"Modelos","Tab_BrandKit":"Kit de marca","Tab_UploadLocal":"Escolher do álbum","Button_UploadImage":"Enviar imagens","Button_UploadProductImage":"Carregar imagem de produto","Button_UploadReferImage":"Referências","Tip_ClickDragParseImage":"Carregue, solte ou cole imagens aqui.","Tip_UploadMax":"Carregue arquivos JPG, JPEG ou PNG de até ${0} MB, com um máximo de N imagens.","Tooltip_SwitchBrandKit":"Trocar kit de marca","Discribe_BrandKitSelect":"Selecione um estilo de marca como referência para este design.","Title_Models":"Modelos","Switch_Auto":"Auto","Tab_Image":"Imagem","Tab_Video":"Vídeo","MenuItem_AddToBrandLogo":"Salvar logo de marca","MenuItem_AddToBrandTemplate":"Salvar modelo de marca","Button_ExportImage":"Importar imagens","Button_ExportMedia":"Importar vídeos","Button_ExportFromBrandkit":"Importar do Kit de marca","Dropdown_AddFromBrandkit":"Adicionar do Kit de marca","Placeholder_ChatInput":"Vamos começar!","MenuItem_AiChange":"Edição com IA","MenuItem_AiExpend":"Extensor com IA","MenuItem_AiHD":"Nitidez com IA","MenuItem_Eliminate":"Remoção com IA","MenuItem_SplitLayers":"Camadas divididas","MenuItem_Cutout":"Removedor de fundo","MenuItem_ChangeText":"Substituir texto","MenuItem_Crop":"Tamanho da imagem","MenuItem_AddToChat":"Adicionar ao chat","MenuItem_AddToBrand":"Adicionar ao kit de marca","Tooltip_Layer":"Camadas","Tooltip_Grab":"Ferramenta mão","Tooltip_Select":"Selecionar","Tooltip_Redo":"Refazer","Tooltip_Undo":"Desfazer","Tooltip_Add":"Adicionar","Tooltip_ShowAll":"Mostrar tudo","Tip_UploadType":"Formato de arquivo não suportado","Tip_UploadSize":"Apenas arquivos com até ${0} MB são suportados","Tip_UploadWH":"Certifique-se de que cada imagem não tenha mais de ${0}×${1} pixels","Tip_UploadTypeTranslate":"Não foi possível alterar o formato do arquivo","Tip_UploadFail":"O envio falhou","Tooltip_AddText":"Adicionar texto","Text_AddDefault":"Este texto é um exemplo.","Tooltip_OverflowImageSize":"Redimensione sua imagem para menos de ${0} pixels","Placeholder_ImageFusion":"Me diga como você gostaria que as imagens fossem mescladas","Button_ImageFusion":"Mesclar","Button_Cancel":"Cancelar","Button_AiChange":"Editar","Placeholder_AiChange":"Diga o que você quer mudar","Button_Eliminate":"Borracha","Label_OriginSize":"Original","Label_CropRadio":"Proporção","Button_Free":"Grátis","Button_Origin":"Original","Button_Crop":"Cortar","Placeholder_ChangeText":"Digite o texto. Exemplo: Olá","Button_ChangeText":"Confirmar","InputNumber_PanSize":"Tamanho do pincel","Label_TargetSize":"Alvo","Tooltip_ImageFusion":"Você pode mesclar de ${0} a ${1} imagens","Title_Workspace":"Seu agente criativo de IA para branding","Button_Pro":"Obtenha o Pro gratuitamente","Title_NanoPro":"🍌🍌Agora, o Nano Banana Pro está disponível no Zawa.","Dropdown_AdvancedFeatures_Title":"Recursos avançados","Dropdown_AdvancedFeatures_Conent":"Acesso total a todas as ferramentas com tecnologia de IA para aumentar sua eficiência.","Dropdown_MassiveContent_Title":"Conteúdo extensivo","Dropdown_MassiveContent_Content":"Acesso ilimitado a modelos premium e a uma ampla gama de recursos Plus.","Dropdown_CommercialRights_Title":"Direitos comerciais","Dropdown_CommercialRights_Content":"Use suas criações pessoais com confiança, respaldadas pela proteção garantida de copyright.","Popup_SubscribeIntl_Desc":"Aproveite ao máximo o Zawa com a versão Pro","Popup_SubscribeIntl_Desc1":"Desbloqueie mais criações com créditos","Popup_SubscribeIntl_Detail":"Ver detalhes do plano e Ajuda","Popup_StripeCheckout":"Checkout com Stripe","Popup_LiveSupport":"Suporte ao vivo","Popup_CancelAnytime":"Cancele a qualquer momento","Menu_Language":"Idioma","Menu_ManageSubscription":"Gerenciar assinaturas","Menu_TermsPolices":"Termos e Políticas","Menu_ManageSubscriptions":"Gerenciar assinaturas","Menu_ReferralLink":"Link de referência","Menu_BenefitsUpgraded":"Benefícios","Menu_TermsPolicies":"Termos e Políticas","Menu_AccountManagement":"Conta","Title_ReferralCode":"Código de referência","Title_ReferralLink":"Link de referência","Desc_NoActiveSubscription":"Nenhuma assinatura ativa","Button_ClickToSubscibe":"Clique aqui para assinar","Title_SubscriptionCancel":"Sua assinatura foi cancelada","Title_SeeYou":"Lamentamos sua partida...😭","Desc_NextBillingDate":"Renova em","Desc_EstimatedAmount":"Total estimado","Button_CancelSubscription":"Cancelar assinatura","Button_StaySubscribed":"Manter assinatura","Title_ReasonCancelling":"Selecione um motivo para cancelar:","Desc_BenefitsContinue":"Você ainda pode aproveitar os benefícios da sua assinatura até ela terminar.","Desc_GiftedCredits":"Depois que a assinatura expirar, os créditos concedidos","Desc_SeeYou":"Agradecemos por estar conosco. Lamentamos sua partida.","Desc_NoNoreCharges":"Não haverá outra cobrança, e sua assinatura permanecerá ativa até","Desc_MayBeRevoked":"pode ser revogada.","Desc_CancelingNoRefund":"O cancelamento <span>não inclui reembolso</span>. Se você tiver dúvidas sobre reembolsos, entre em contato com o suporte online.","Button_ClearSelection":"Deselecionar","Button_Confirm":"Confirmar","Message_Processing":"Processando...","Title_Opacity":"Opacidade","Button_ExpandImage":"Extensor","Button_ExpandRadio":"Proporção","Title_NoDesigns":"Ainda não há designs.","Title_NoGenerations":"Ainda não há gerações.","Desc_NoDesigns":"Seus designs aparecerão aqui.","Desc_NoGenerations":"Suas gerações aparecerão aqui.","Title_DeleteDesign":"Excluir este design","Popup_DeleteDesign":"Você tem certeza de que deseja excluir este design permanentemente? Esta ação não pode ser desfeita.","Message_SaveFail":"Falha ao salvar","Title_Pricing":"Escolha o plano ideal para você","Title_Tags1_Pricing":"Mensal","Text_Discount_Pricing":"${0} de desconto","Title_Tags2_Pricing":"Anual","Title_Plan1_Pricing":"Gratuito","Current_Plan_Pricing":"Plano atual","Title_Instruction1_Pricing":"Ganhe 20 créditos pelo primeiro login","Title_Instruction2_Pricing":"Gere até 20 imagens com o Agente de IA","Title_Instruction3_Pricing":"Gere até 10 imagens com o Gerador de fundos com IA","Title_Rights1_Pricing":"Remoção limitada de fundos ou objetos","Title_Rights3_Pricing":"Aprimoramento limitado de imagens HD","Title_Plan2_Pricing":"Plano Básico","Month_Plan_Pricing":"mês","Title_Button1_Pricing":"Assinar","Title_Instruction4_Pricing":"500 créditos/mês","Title_Instruction5_Pricing":"Gere até 500 imagens com o Agente de IA","Title_Instruction6_Pricing":"Gere até 250 imagens com o Gerador de fundos com IA","Title_Plan3_Pricing":"Plano Profissional","Desc_Plan_Pricing":"Teste gratuito por 7 dias. Depois, ${0}/ano.","Title_Button2_Pricing":"Teste grátis de 7 dias","Title_Instruction7_Pricing":"1.500 créditos/mês","Title_Instruction8_Pricing":"Gere até 1.500 imagens com o Agente de IA","Title_Instruction9_Pricing":"Gere até 750 imagens com o Gerador de fundos com IA","Title_Rights4_Pricing":"Remoção ilimitada de fundos ou objetos","Title_Rights5_Pricing":"Uso ilimitado do recurso de remoção com IA","Title_Rights6_Pricing":"Aprimoramento ilimitado de imagens UHD","Title_Rights7_Pricing":"Ferramentas de processamento em lote","Title_Best_Pricing":"Escolhido por 90% dos usuários","Title_AllFeatures_Pricing":"Compare planos gratuitos e pagos","Desc_AllFeatures_Pricing":"Desbloqueie o Premium para criar designs impressionantes e sem esforço com ferramentas avançadas de IA","Month_AllFeatures_Pricing":"mês","Title_Features1_Pricing":"Agente de IA","SubTitle_Features1_Pricing":"Edição de imagens","SubTitle_Features15_Pricing":"Gere até ${0} imagens","SubTitle_Features16_Pricing":"Gere até ${0} imagens/mês","SubTitle_Features2_Pricing":"Geração de imagens","SubTitle_Features3_Pricing":"Geração de imagens para e-commerce","SubTitle_Features4_Pricing":"Geração de cartaz","Title_Features2_Pricing":"Ferramentas de imagem com IA","SubTitle_Features5_Pricing":"Removedor de fundo com IA","SubTitle_Features17_Pricing":"Uso limitado","SubTitle_Features19_Pricing":"Uso ilimitado","SubTitle_Features6_Pricing":"Removedor de objeto com IA","SubTitle_Features7_Pricing":"Aprimorador de imagem","SubTitle_Features18_Pricing":"Uso limitado (HD)","SubTitle_Features20_Pricing":"Uso ilimitado (HD/UHD)","SubTitle_Features8_Pricing":"Upscaler de imagem com IA","SubTitle_Features9_Pricing":"Extensor de imagem com IA","SubTitle_Features10_Pricing":"Gerador de fundo com IA","Title_Features3_Pricing":"Mais recursos de design","SubTitle_Features11_Pricing":"Recursos avançados e modelos","SubTitle_Features12_Pricing":"Remover marca d\'água","SubTitle_Features13_Pricing":"Ferramentas de imagens em lote com IA","SubTitle_Features14_Pricing":"Características básicas de design","Title_Credits_Pricing":"Está ficando sem créditos? Nós ajudamos você.","Desc_Credits_Pricing":"Compra única, sem necessidade de assinatura.","TransactionPrice_Credits_Pricing":"Preço: ${0}","Credit_Credits_Pricing":"Créditos","Popular_Credits_Pricing":"Mais popular","Buy_Credits_Pricing":"Comprar agora","Title_FAQ_Pricing":"Perguntas frequentes","Title_Button4_Pricing":"Atualize agora para obter um teste gratuito de 7 dias","SubTitle_FAQ1_Pricing":"O que são os créditos?","Content_FAQ1_Pricing":"Os créditos permitem que você continue acessando as ferramentas de IA. O número de créditos necessários varia de acordo com a ferramenta específica.","Content_FAQ2_Pricing":"Os créditos comprados são válidos por um ano.","Content_FAQ3_Pricing":"Os créditos de assinatura são válidos durante o período de duração da mesma.","SubTitle_FAQ2_Pricing":"Como cancelo minha assinatura e o que acontece com meus créditos após o cancelamento?","Content_FAQ4_Pricing":"Após cancelar sua assinatura,","Content_FAQ5_Pricing":"seus créditos de membro permanecerão válidos até ao fim do seu período de assinatura. Quaisquer créditos que tenha adquirido separadamente não serão afetados.","Content_FAQ6_Pricing":"Se você precisar cancelar sua assinatura, siga as etapas abaixo pelo menos 24 horas antes do início do próximo ciclo de cobrança:","Content_FAQ7_Pricing":"1. Acesse o Designkit e faça login.","Content_FAQ8_Pricing":"2. Abra a janela pop-up de assinatura.","Content_FAQ9_Pricing":"3. Selecione “Gerenciar assinaturas”.","Content_FAQ10_Pricing":"4. Selecione seu plano atual e clique em “Cancelar assinatura”.","Content_FAQ11_Pricing":"Sua assinatura permanecerá ativa até o fim do ciclo de faturamento atual. Se não conseguir cancelar, faça uma captura de tela e entre em contato com nosso suporte online o mais rápido possível.","SubTitle_FAQ3_Pricing":"Qual é a sua política de reembolso?","Content_FAQ12_Pricing":"1. Garantia de reembolso de 7 dias:","SubTitle_FAQ4_Pricing":"Como posso mudar o plano da minha assinatura?","Content_FAQ25_Pricing":"1. Upgrade: basta assinar um plano de nível superior, e ele entrará em vigor imediatamente. Sua assinatura antiga será cancelada e qualquer saldo restante será reembolsado.","SubTitle_FAQ5_Pricing":"Posso obter uma cópia da minha fatura?","Content_FAQ27_Pricing":"Sim! Após um pagamento bem-sucedido, você receberá um e-mail do provedor de pagamentos contendo uma fatura eletrônica. Se você não receber a fatura, entre em contato com nossa equipe de suporte.","SubTitle_FAQ6_Pricing":"Quais métodos de pagamento vocês aceitam?","Content_FAQ28_Pricing":"Utilizamos o Stripe para gerenciar pagamentos e assinaturas. Aceitamos todos os principais cartões de crédito, PayPal e Google Pay.","SubTitle_FAQ7_Pricing":"Como posso entrar em contato com o suporte?","Content_FAQ29_Pricing":"E-mail: support@designkit.com. Prazo de resposta: 3 a 10 dias úteis.","Content_FAQ13_Pricing":"Se você adquiriu assinaturas e não as utilizou dentro de 7 dias, poderá ter direito a um reembolso total.","Content_FAQ14_Pricing":"Se você comprou créditos, poderá ter direito a um reembolso por quaisquer créditos não utilizados dentro de 7 dias.","Content_FAQ15_Pricing":"2. Insatisfação com o serviço","Content_FAQ16_Pricing":"Se você não estiver satisfeito(a) com os resultados, entre em contato com nossa equipe de suporte online. Podemos oferecer uma compensação ou reembolso, dependendo das circunstâncias.","Content_FAQ17_Pricing":"3. Compras através do Google Play ou da App Store","Content_FAQ18_Pricing":"Se você assinou através da Google Play Store ou da App Store, você precisa solicitar um reembolso diretamente ao Google ou à Apple.","Content_FAQ19_Pricing":"Observações importantes:","Content_FAQ20_Pricing":"Esta política de reembolso não se aplica a usuários da API. Se você utiliza nossa API, entre em contato conosco para saber se tem direito a um reembolso.","Content_FAQ21_Pricing":"Nos reservamos o direito de recusar reembolsos em casos de uso indevido, abuso ou violação dos nossos termos.","Content_FAQ22_Pricing":"Reembolsos podem levar vários dias úteis para serem processados, dependendo do seu método de pagamento.","Content_FAQ23_Pricing":"Podemos atualizar esta política de reembolso periodicamente. Por favor, verifique-a regularmente para saber se houve alguma alteração.","Content_FAQ24_Pricing":"Para obter mais assistência, entre em contato com nossa equipe de suporte.","Content_FAQ26_Pricing":"2. Downgrade: primeiro, cancele sua assinatura atual. Quando o período de cobrança atual terminar, assine um novo plano de nível inferior.","Content_Modal_Pricing":"Agradecemos seu apoio! Prepare-se para levar sua criatividade a um novo nível.","Tip_Modal_Pricing":"Dicas: Se a sua assinatura ainda não parecer ativa, atualize a página.","Title_Modal_Pricing":"Compra realizada com sucesso","Title_Rights2_Pricing":"Uso limitado do recurso de remoção por IA","Title_Button3_Pricing":"Benefícios disponíveis","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Removedor de fundo","Tool_AiBgGenerator":"Gerador de fundo com IA","Tool_AiLogoGenerator":"Gerador de logotipo com IA","Tool_FootwearModel":"Modelo de calçado","Tool_ImageTranslation":"Tradução de imagem","Tool_BatchImageBgRemover":"Removedor de fundo de imagens em lote","Tool_BatchImageEnhancer":"Aprimorador de imagens em lote","Tool_BatchAiObjectsRemover":"Removedor de objetos em lote com IA","Tool_VideoEnhancer":"Aprimorador de vídeo","Tool_VideoBgRemover":"Removedor de fundo de vídeo","Tool_VideoWatermarkRemover":"Removedor de marca d\'água de vídeo","Title_Models_Dropdown":"Modelos","Tips_Uninitialized_Chat":"Falha ao enviar mensagens","Tips_Uninitialized_chat":"Falha ao enviar mensagens","Dropdown_AddImage":"Adicionar imagem","Action_SeeAll":"Ver tudo","Desc_Seedream":"Geração de imagens realistas e detalhadas.","Dropdown_AddVideo":"Adicionar vídeo","Tips_NotFound_Chat":"O chat não existe","Desc_Seedance":"Criação de vídeos realistas e expressivos.","Dropdown_SupportedFormatFile":"Suporta arquivos do Word, Excel, PDF e de texto.","Dropdown_Example_Option":"Exemplo","Dropdown_NoReference_Option":"Sem referências disponíveis","Menu_AgentCredits":"Créditos de Agente","Desc_SeedEdit":"Edição precisa e natural de imagens.","Dropdown_BrandKit_Title":"Kit de marca","Desc_GeminiNanoBanana":"Geração rápida, editável e consistente de imagens.","Dropdown_Models_Title":"Modelos","Dropdown_AddDocument":"Adicionar documento","Dropdown_BrandKit_Desc":"Selecione um estilo de marca como referência para este design.","Desc_MidjourneyVideo":"Geração de vídeos artísticos e criativos.","Desc_MidjourneyImage":"Geração de imagens artísticas e criativas.","Dropdown_SaveAsBrandTemplate":"Salvar como modelo de marca","Dropdown_SaveAsBrandLogo":"Salvar como logotipo de marca","BatchProcessTable_ImageType":"Tipo de imagem","BatchProcessTable_PictureRequirement":"Detalhes do design","BatchProcessTable_CopywritingRequirements":"Descrição do produto","BatchProcessTable_Proportion":"Proporção","BatchProcessTable_Actions":"Ação","BatchProcessTable_AddOneRow":"Adicionar","BatchProcessList_DeleteError":"Falha ao excluir","BatchProcessList_SurePrompt":"Excluir esta diretriz?","BatchProcessList_SurePrompt_SureText":"Confirmar","BatchProcessList_SurePrompt_CancelText":"Cancelar","BatchProcessList_EmptyText":"Vazio","EditBatchProcess_NameLimitTip":"Insira um nome (até 10 caracteres)","EditBatchProcess_Tip":"As alterações feitas nas diretrizes afetarão os resultados gerados.","EditBatchProcess_Start":"Comece com uma diretriz","EditBatchProcess_GenerateTip":"Envie as imagens do seu produto, e os designs serão gerados com base nas diretrizes.","Text_AdvanceSetting":"Especialista","Text_MainImage":"Imagem principal","Text_ProductAgentUploadGuide1":"1. Carregue várias imagens do mesmo produto de diferentes ângulos para ajudar a IA a capturar melhor os detalhes do produto.","Text_ProductAgentUploadGuide2":"2. Até 10 imagens. A primeira imagem será usada como referência primária, portanto, escolha o melhor ângulo.","Text_Optional":"  (Opcional)","Tip_ClickDragImageWithSize":"Carregue ou solte imagens JPEG, JPG ou PNG de até ${0} MB.","Button_AddReferenceImage":"Carregar","Title_ReferenceImage":"Imagem de referência","Input_Placeholder":"Selecione","Radio_ReferenceColor":"Cor de referência","Radio_ReferenceLayout":"Layout de referência","Tag_FirstImage":"Primeira imagem","Tag_FirstImageNoPartial":"Primeira imagem parcial","Tag_Blur":"Desfoque","Tag_Jigsaw":"Colagem","Button_Understood":"Entendi","Text_ReferenceImageIndex":"A imagem ${0} deve ser usada como referência","Text_ReferenceDimensions":"Usar ${0} da referência","Tag_Cropped":"Cortada","Tag_Underexposed":"Subexposta","Tag_Blurry":"Desfoque","SelectOption_ColorPalette":"Paleta de cores","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fontes","SelectOption_Style":"Estilo","SelectOption_ShapeElements":"Elementos de forma","Text_SocialMediaAgentUploadGuide":"Carregue o produto em destaque primeiro. Verifique se a imagem está nítida e completa.","Video_SR_Success":"Nitidez de vídeo aprimorada","Video_Desubtitle_Success":"Legenda removida","Video_Dewatermark_Success":"Marca d\'água removida","Video_Process_Failed":"Falha no processamento. Os créditos serão reembolsados na sua conta.","Video_SR":"Nitidez com IA","Video_Dewatermark":"Remover a marca d\'água","Video_Desubtitle":"Remover legenda","Video_Task_Price_Estimate":"${0} créditos necessários","Video_SR_Start":"Aprimorando a nitidez... Serão usados ${0} créditos.","Video_Dewatermark_Start":"Removendo marcas d\'água... Serão usados ${0} créditos.","Video_Desubtitle_Start":"Removendo legendas... Serão usados ${0} créditos.","Video_Desubtitle_Start_VIP":"Removendo legendas...","Video_Dewatermark_Start_VIP":"Removendo marcas d\'água...","Video_SR_Start_VIP":"Aprimorando a nitidez...","Text_Help_Center":"Centro de ajuda","Title_Request":"Chat","Button_Continue":"Continuar","Button_EditContent":"Editar mensagem","Title_ChooseImageType":"Selecionar o tipo de imagem gerada (várias opções)","Button_BatchGenerate":"Confirmado. Execute o modelo agora.","Text_ChatCancelStatus":"Tarefa concluída","Text_ChatRespondedStatus":"Processamento de tarefas","BatchProcess_SaveSuccessTip":"Seus kits de fluxo de trabalho são salvos aqui.","Button_GotIt":"Entendi","Title_Congrats":"Parabéns","SubTitle_BrandCreate":"Você criou seu primeiro kit de marca. Chegou a hora de explorar seu potencial!","Button_CheckUse":"Confira agora mesmo","Chat_Prompt_Brand":"Crie um cartaz promocional","Tooltip_UseBrand":"Você pode trocar ou adicionar seu kit de marca aqui!","Tooltip_PosterBrand":"Toque para criar seu primeiro cartaz com base no kit da sua marca","Popup_CreateBrand":"Crie uma marca do zero","Desc_CreateBrand":"Crie logos originais incríveis com o nosso Agente de IA.","Popup_UploadBrand":"Carregue as informações da sua marca","Desc_UploadBrand":"Faça o upload, e o Zawa manterá todos os designs alinhados.","Title_BrandEntry":"Obtenha agora um projeto de identidade visual personalizado","Desc_BrandEntry":"Deixe que a nossa IA seja a sua especialista. Responda a algumas perguntas e receba um projeto de marca completo, personalizado de acordo com a sua visão.","Tooltip_UseBrand_Agent":"Uma vez aplicado o kit de marca, o design fará referência automática ao logo, à paleta de cores e ao estilo geral.","Tooltip_PosterBrand_Agent":"Você já pode começar a criar com seu kit de marca","BatchProcess_createText":"Kit de fluxo de trabalho","Label_NormalMode":"Básico:","Label_AdvancedMode":"Avançado:","Text_NormalMode":"Básico","Text_AdvancedMode":"Avançado","BatchProcess_DefaultPrompt":"Gerar imagens","Title_CreateBrand":"Não tem uma marca?","Title_UploadBrand":"Já tem um logotipo?","Button_CreateBrand":"Criar uma marca","BatchProcess_EditContent":"Editar conteúdo","BatchProcess_PleaseSelect":"Selecione um kit de fluxo de trabalho","BatchProcess_SelectTip":"Todas as imagens carregadas serão geradas em lote usando o kit de fluxo de trabalho selecionado.","BatchProcess_ListEmptyTip":"Salve o kit de fluxo de trabalho após a geração para criar instantaneamente conjuntos similares em lote.","BatchProcess_Tip":"Kit de fluxo de trabalho","BatchProcess_Generate":"Use agora","BatchProcess_Save":"Salvar","BatchProcess_GeneratingFormula":"Gerando kit de fluxo de trabalho...","BatchProcess_GenerateCancel":"Cancelar","BatchProcess_WorkFlowCreateError":"Falha na criação","ProductInfo_PleaseUploadImage":"Carregar imagens de produto","BatchProcess_IntelligenceGenerate":"Criar kit de fluxo de trabalho","BatchProcess_CreateWorkflow":"Criar","BatchProcess_Formula":"Kit de fluxo de trabalho","BatchProcess_WorkFlowSaveSuccess":"Kit de fluxo de trabalho salvo","ProductInfo_ImageSizeLimit":"Imagens com tamanho inferior a ${0} MB são suportadas","ProductInfo_ImageUpload":"Adicionar imagem do produto","ProductInfo_UploadDemo":"Fotos de exemplo","ProductInfo_ECPlatform":"Plataforma","ProductInfo_PleaseSelect":"Por favor, selecione","ProductInfo_InputCustomize":"Personalizado","ProductInfo_CountryAndLanguage":"Região/idioma-alvo","ProductInfo_Name":"Nome do produto","ProductInfo_Desc":"Detalhes do produto (características/tamanho/cenários de uso)","ProductInfo_DescPlaceholder":"Insira informações sobre o produto, incluindo características, tamanho, cenários de uso, público-alvo, etc.","ProductInfo_NamePrompt":"O nome do produto é ${0};","ProductInfo_ECPlatformPrompt":"A plataforma de destino é ${0};","ProductInfo_CountryAndLanguagePrompt":"O idioma é ${0};","ProductInfo_DescPrompt":"Os detalhes do produto são ${0}.","ProductInfo_PleaseInput":"Insira, por favor","Button_UnlockPro":"Desbloquear Pro","Button_UpgradeToPro":"Atualizar para Pro","Button_RenewNow":"Renovar agora","AgentEmpty_CaseUseBtn":"Usar","AgentEmpty_CaseRefreshBtn":"Atualizar","MenuItem_Effect":"Efeitos","MenuItem_Shadow":"Sombras","MenuItem_Stroke":"Contorno","Title_ChangeText":"Substituir texto","Button_Logout":"Sair","Message_ExtractText":"Extraindo texto","Message_ExtractTextError":"Falha ao extrair o texto. Tente novamente.","Tip_CreditConsume":"Essa geração usa ${0} créditos","Tip_EstimatedTime":"Pronto em cerca de ${0} minutos","BatchProcess_SaveSuccessTip_GotIt":"Entendi","BatchProcess_SaveSuccessTip_Title":"Usando kits de fluxo de trabalho","BatchProcess_SaveSuccessTip_Desc":"Seus kits de fluxo de trabalho são salvos aqui. Escolha uma opção para gerar imagens rapidamente utilizando os modelos salvos.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Ferramenta mão","Text_Function":"Função","Text_WindowsSystem":"Sistema Windows","Text_MacSystem":"Sistema Mac","Menu_KeyboardShortcuts":"Atalhos","Title_KeyboardShortcuts":"Atalhos","Text_Undo":"Desfazer","Text_MouseLeft":"Botão esquerdo do mouse","Text_Redo":"Refazer","Text_Delete":"Excluir","Text_Cut":"Cortar","Text_Copy":"Copiar","Text_Paste":"Colar","Text_PasteFixed":"Colar no lugar","Text_CreateCopy":"Criar uma cópia","Text_SelectAll":"Selecionar tudo","Text_SelectMultiple":"Multisseleção","Text_Group":"Grupo","Text_Ungroup":"Desagrupar","Text_LockLayer":"Travar","Text_Save":"Salvar","Text_Move":"Mover","Text_MoveWithCombinedKeys":"Movimento rápido","Text_TouchEditFastMode":"Edição rápida","Text_Pan":"Texto panorâmico","Title_Canvas":"Tela","Title_Edit":"Editar","Title_Elements":"Elementos","Title_Tools":"Ferramentas","Title_Blogs":"Blog","Text_NewText":"Novo texto","Text_NewLine":"Nova linha","Text_NewRectangle":"Novo retângulo","Text_NewCircle":"Novo círculo","Text_ExitFullScreen":"Sair da tela inteira","Text_MoveUpOneLayer":"Trazer para a frente","Text_MoveDownOneLayer":"Enviar para trás","Text_Top":"Trazer para frente","Text_Bottom":"Enviar para trás","Text_CanvasZoom":"Aumentar/Diminuir","Text_ToggleReferenceLine":"Mostrar/ocultar guias","Text_ToggleRulerBar":"Mostrar/ocultar réguas","Text_ArrowKey":"Teclas de seta","Text_CanvasShowAll":"Mostrar todas as telas","Title_Unsupported_Multilayer":"Esse recurso funciona com uma única camada apenas.","Btn_CreateBatchProcessFormula":"Criar","Button_Hide_Otherlayers":"Manter a primeira camada e continuar","Button_Merge_Alllayers":"Mesclar todas as camadas e continuar","Checkbox_Disable_Remind":"Não mostrar novamente","Button_Tool":"Ferramentas","Button_Custom_Ratio":"Personalizado","Label_Spacing":"Espaçamento","Button_Download_Whole":"Exportar como imagem","Button_Download_Layer":"Exportar por camada","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Apontar para editar","Text_TouchEdit_Description":"Aponte para um objeto e descreva suas alterações. A imagem será editada exatamente como você especificar.  ","Tooltip_TouchEdit_Max_Count":"Você pode apontar para até ${0} áreas","Tooltip_TouchEdit_Usage":"Aponte para o atalho Editar: ${0} + clique","Text_TouchEdit_Recognition_Custom":"Personalizado","Text_TouchEdit_Recognition_Title1":"Detectar e reconhecer","Text_TouchEdit_Recognition_Title2":" Nenhum destino encontrado. Insira o nome do objeto.","Text_TouchEdit_Name":"Apontar para editar","Btn_LoginToViewBatchProcess":"Entre para visualizar o kit de fluxo de trabalho","Btn_Login":"Entrar","Menu_Main_Beautify":"Refinar","Text_Model_Pricing":"Preços de modelos","Text_Pro_discount":"Plano Pro: geração de vídeos pela metade do preço","Text_TemplatePrompt":"Vamos começar com inspirações","Text_Hi":"Olá, ${0}!","Text_Account_Popup_Left":"Conheça seu assistente de design dedicado com IA para e-commerce. Desenvolvido para profissionais que buscam lançamentos mais rápidos, apresentações mais sólidas e lucratividade mais alta.","Text_PleaseWaitImageUploaded":"Continue após a conclusão do carregamento","Menu_Redeem_Rights":"Resgatar","Text_Redeem_Now":"Resgatar agora","Text_Redeem_Placeholder":"Insira o código de resgate, diferenciando maiúsculas e minúsculas","Text_Redeem_Success":"Resgate bem-sucedido.","Text_Redeem_Use":"Resgatar seu código","Tooltip_BrandAutoUse":"Seu novo kit de marca foi aplicado.","Redeem_Redeem_Note":"Nota: \\nFaça login e digite o código de resgate.\\nApós a realização do resgate, você poderá aproveitar os benefícios e serviços correspondentes.\\nUse o código de resgate no período de validade. Códigos expirados serão invalidados e não são reembolsáveis.\\nProteja seu código. Não somos responsáveis por códigos perdidos, vazados ou usados incorretamente. \\nEsse código não poderá ser revendido ou transferido, nem trocado por dinheiro, e não é elegível para faturamento.","Tooltip_Color_Fill":"Cor","Tootip_StartPoint":"Iniciar","Tootip_ChangePoint":"Mudar","Tootip_EndPoint":"Fim","Sidebar_NewDesign":"Novo chat","Retouch_Filter_Clear":"Limpar","Retouch_Filter_Enhance":"Vívido","Retouch_Filter_Dehaze":"Desembaçar","Retouch_Filter_Texture":"Textura","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Desvanecer","Modal_Button_Known":"OK","Modal_Button_GotIt":"Aceitar","Modal_Button_Later":"Mais tarde","Text_Appeal_Confirm":"Sim","Text_Vip_Open":"Assinar","Text_Appeal_ReGenerate":"Resultados editados não estão qualificados para revisão.","Text_Appeal_Left":"Tentativas restantes esse mês\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Os créditos foram reembolsados na sua conta.","MenuItem_Appeal":"Revisão de resultado","Tooltip_Downloading":"Baixando...","Tooltip_Download_Video":"Baixe os vídeos separadamente, um de cada vez.","Tooltip_Download_NoneSelected":"Por favor, selecione o conteúdo que deseja baixar","Text_AI_Thinking":"A IA está trabalhando nisso.","Text_Server_Busy":"O servidor está ocupado. Por favor, tente novamente mais tarde.","Text_Prompt_Help_Placeholder":"Digite suas palavras-chave e eu as transformarei em um prompt pronto para uso.","Text_Prompt_Helping":"Processando... Por favor, aguarde.","Button_Retry":"Tentar de novo","Button_Rewrite":"Tente novamente","Button_Start_Prompt_Help":"Comece a escrever","Title_Prompt_Helper":"Redação com IA","Menu_Text_Subscriptions":"Assinaturas","Menu_View_Subscriptions":"Ver assinaturas","Text_Download_XdesignApp":"Baixe o aplicativo <span>Zawa</span> para usar os recursos","Text_Free_Trial":"Faça o download para um teste gratuito de 7 dias","Text_Install_App":"Instalar app","Text_Scan_Download":"Escaneie para baixar","Text_Download_the":"Baixar na","Text_Available_On":"Disponível em","Desc_ExpireDate":"Expira em:","DownloadApp_Title_Widgets":"Para usar os recursos, baixe o aplicativo ${0}","DownloadApp_SubTitle_Widgets":"Baixe para uma avaliação gratuita de ${0} dias","InstallApp_Title_Widgets":"Instalar app","InstallApp_Desc_Widgets":"Escaneie para baixar","AppStore_Desc_Widgets":"Baixe na App Store","GooglePlay_Desc_Widgets":"Baixe no Google Play","Text_Tips_GetFree":"Você ganhou um uso gratuito","Text_AgentLib":"Recursos","Tip_ModelSetSaveSuccess":"Sua imagem modelo foi salva! Toque para usá-la.","Text_BatchProcess":"Kit de fluxo de trabalho","Button_Add":"Adicionar","Tab_Recent":"Salvo recentemente","Tab_Models":"Meus modelos","Prompt_Model":"Imagem ${0} é o meu modelo","Tip_SaveSuccess":"Salvo","Text_ModelsLogin":"Faça login para visualizar seus modelos","Loading_CheckFace":"Detectando rosto...","Name_InitialModelName":"Meus modelos","EmptyTip_ModelList":"Ainda não há nenhum modelo. Vamos criar um!","Text_UploadModel":"Carregar modelo","Text_Model":"Modelo","Tips_UnsupportedFormat":"Formato de arquivo não suportado","Tips_InputModelName":"Insira um nome","Tips_UploadModelImage":"Carregar imagens do modelo","Title_CreateModel":"Crie seu modelo","Text_ModelName":"Nome","Placeholder_Input":"Insira, por favor","Text_UploadModelHint":"Toque para fazer upload ou arraste imagens para aqui <br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Carregar","Tips_NameLengthLimit":"Insira um nome (até ${0} caracteres)","Tips_DeleteFailed":"Falha ao excluir","Title_ConfirmDeleteModel":"Excluir este modelo?","Tips_CreateSuccess":"Modelo criado","Tab_BatchTemplate":"Kit de fluxo de trabalho","Tab_MyModel":"Meus modelos","Placeholder_InputContent":"Inserir conteúdo","Title_ChooseSceneType_VideoGenerateCard":"Selecione um tipo de conteúdo e uma estrutura de storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Iniciar geração de vídeo","Title_ShotType_VideoGenerateModal":"Tipo de storyboard","Title_ShotRequirement_VideoGenerateModal":"Descrição de storyboard","Title_Duration_VideoGenerateModal":"Duração","Btn_AddOneTableRow":"Adicionar","Label_Gender_ModelModal":"Sexo","Label_Appearance_ModelModal":"Aparência","Label_AgeGroup_ModelModal":"Faixa etária","Label_Persona_ModelModal":"Função","Label_BodyType_ModelModal":"Tipo de corpo","Tips_GenerateModelFailed_ModelModal":"Falha na geração. Tente novamente mais tarde.","Tips_NetworkError_ModelModal":"Erro de rede. Tente novamente mais tarde.","Tab_CustomModel_ModelModal":"Personalizado","Tab_OfficialModel_ModelModal":"Oficial","Tab_UploadModel_ModelModal":"Carregar","Text_ModelPreview_ModelModal":"Prévia","Button_Generating_ModelModal":"Gerando...","Button_Regenerate_ModelModal":"Tente novamente","Button_Generate_ModelModal":"Gerar","Button_Saving_ModelModal":"Salvando...","Button_SaveAndUse_ModelModal":"Salvar e usar","Button_CreateNewModel_AgentLibList":"Novo modelo","Message_NotFilled_RequiredField":"${0} informações necessárias","Title_ChooseSceneType2_VideoGenerateCard":"Selecione a estrutura de storyboard","Title_ContentType_VideoGenerateCard":"Tipo de conteúdo","Title_StoryboardStructure_VideoGenerateCard":"Estrutura de storyboard","Text_Offical":"Oficial","Title_AboveTheFold_Main_HomeV2":"Crie <br />imagens perfeitas <span>para que seus produtos sejam vendidos!</span>","Title_Designkit_Slogan":"Crie imagens perfeitas para que seus produtos sejam vendidos!","Button_StartFree_HomeV2":"Comece grátis","Title_AboveTheFoldMobile_Main_HomeV2":"Deixe todos os seus produtos <br /><span>prontos para venda</span> ","SubTitle_AboveTheFoldMobile_HomeV2":"Da edição profissional de fotos à geração automatizada de listas, tudo de que você precisa em um só lugar.","Text_TopBanner_HomeV2":"Seedance 2.0 estará disponível em breve com acesso ilimitado","Title_ModuleCard_HomeV2":"Primeiro, gere ativos vencedores","SubTitle_ModuleCard_HomeV2":"Chega de telas em branco. Use nossa Suíte Criativa Inteligente de Agentes de IA para gerar <br /> pilhas de listagens completas, vídeos dinâmicos, provadores virtuais e adaptações globais em segundos.","Title_Faq_Q1_HomeV2":"Vocês oferecem um período de teste gratuito?","Text_Faq_A1_HomeV2":"Sim! Novos usuários recebem 20 créditos gratuitos instantaneamente após o cadastro. Além disso, você pode resgatar 10 créditos gratuitos todos os dias ao fazer login. Isso permite que você teste continuamente todos os recursos principais, incluindo geração de imagens e vídeos, antes de atualizar para um plano pago.  ","Title_Faq_Q2_HomeV2":"As imagens estão em conformidade com as diretrizes da Amazon/Shopify?","Text_Faq_A2_HOMEV2":"Com certeza. Para fotos de produtos principais, nossa IA produz estritamente os fundos brancos puros (RGB 255,255,255) exigidos pela Amazon e pela Shopify. Para imagens de estilo de vida e mídias sociais, ela garante dimensões perfeitas e qualidade de alta resolução para manter suas listagens totalmente compatíveis e profissionais.","Title_Faq_Q3_HomeV2":"Posso usar os recursos gerados para fins comerciais?","Text_Faq_A3_HomeV2":"Sim. Todas as imagens e vídeos gerados em nossos planos pagos são 100% livres de royalties e totalmente liberados para uso comercial. Você detém os direitos de uso desses recursos em sua loja Shopify, listagens da Amazon, anúncios em mídias sociais e quaisquer outros canais de marketing sem restrições.","Title_Faq_Q4_HomeV2":"Como funciona a geração e edição em lote?","Text_Faq_A4_HomeV2":"O processamento em lote está integrado por padrão em todos os recursos do Designkit. Basta enviar várias imagens diretamente para a área de trabalho. Seja para criar novos planos de fundo de estilo de vida, remover planos de fundo originais, apagar objetos indesejados ou aumentar a resolução, você pode aplicar a ação escolhida a todo o lote com um único clique. Isso garante recursos perfeitamente consistentes para sua loja, além de economizar horas de trabalho manual.","Title_Faq_Q5_HomeV2":"Quais formatos de arquivo são compatíveis?","Text_Faq_A5_HomeV2":"As saídas de vídeo estão disponíveis no formato MP4, otimizadas para redes sociais e sites de e-commerce.","Title_Questions_Main_HomeV2":"Perguntas Frequentes","Title_Scale_Main_HomeV2":"Pronto para aumentar?","SubTitle_Scale_HomeV2":"Junte-se a mais de 10.000 vendedores que automatizam seu fluxo de trabalho de design com o Designkit.","Title_Evaluation_HomeV2":"Por fim, lance mais rápido e venda mais","SubTitle_Evaluation_HomeV2":"Reduza o tempo de produção em 90%. Obtenha listagens verificadas na Amazon e no Shopify antes dos seus concorrentes.","Tab_Module_ProductImage_HomeV2":"Imagem do produto com IA","Desc_Module_ProductImage_HomeV2":"Converta uma foto de um fornecedor em uma lista completa na hora. Gere imagens destacadas com fundo branco, cenas de estilo de vida e infográficos, ao mesmo tempo que processa em lote e sem esforço, centenas de SKUs e traduz automaticamente o texto para os mercados globais.","Tip_Module_ProductImage_HomeV2":"Crie um conjunto de listagens da Amazon para os fones de ouvido cor-de-rosa.","Tab_Module_ModelImage_HomeV2":"Modelo de moda com IA","Desc_Module_ModelImage_HomeV2":"Não tem modelos? Não há problema. Visualize roupas em diversos modelos de IA para aumentar as taxas de cliques sem precisar contratar sessões fotográficas caras.","Tip_Module_ModelImage_HomeV2":"Exiba este conjunto verde e amarelo em uma modelo de 25 anos.","Tab_Module_Video_HomeV2":"Vídeo de produto com IA","Desc_Module_Video_HomeV2":"Dê vida aos seus produtos. Crie apresentações dinâmicas, vídeos envolventes com narração de IA e anúncios de alta conversão a partir de um simples texto ou imagem. Chame a atenção e impulsione as vendas em plataformas de e-commerce e nas suas redes sociais.","Tip_Module_Video_HomeV2":"Crie um vídeo de produto para este vaso azul.","Tab_Module_DetailPage_HomeV2":"Página de detalhes do produto com IA","Desc_Module_DetailPage_HomeV2":"Crie conteúdo premium A+ e banners promocionais perfeitos para sua loja online em apenas alguns minutos e sem precisar de habilidades de design. Transforme fotos básicas de produtos em layouts altamente envolventes e diferencie suas listagens das dos concorrentes facilmente.","Tip_Module_DetailPage_HomeV2":"Gerar uma página de detalhes do produto para o sofá laranja.","Tab_Module_Photography_HomeV2":"Fotografias de produto com IA","Desc_Module_Photography_HomeV2":"Diga adeus às fotos genéricas dos bancos de imagens. Coloque seus produtos em ambientes únicos e alinhados com sua marca, que tenham impacto nos mercados dos EUA e da UE.","Tip_Module_Photography_HomeV2":"Crie um fundo fotográfico para este perfume.","Title_Module_SecondTitle_HomeV2":"Depois, detalhes perfeitos com a precisão da IA","SubTitle_Module_SecondSubTitle_HomeV2":"Recursos gerados? Agora aperfeiçoe-os. Use nosso Editor de fotos com IA para remover fundos, corrigir defeitos e melhorar imagens de baixa resolução em lote.","Text_Upload_HomeV2":"Carregar","Text_TopBannerMobile_HomeV2":"Seedance 2.0 estará disponível em breve","Text_Prompt1_HomeV2":"Gere um conjunto completo de imagens para listas da Amazon.","Text_Prompt2_HomeV2":"Gere um modelo usando essa roupa.","Text_Prompt3_HomeV2":"Gere um vídeo de marketing de produto.","Text_Prompt4_HomeV2":"Gere uma página de detalhes de produto de Conteúdo A+.","Text_Prompt5_HomeV2":"Gere fundos apropriados para imagens de produtos.","Desc_Evaluation1_HomeV2":"É superrápido! As imagens ficam prontas instantaneamente para o Mercado Livre e a Amazon. Os fundos e os modelos são adaptados às preferências locais com perfeição. Os resultados são 100% profissionais.","Desc_Evaluation2_HomeV2":"Adoro o Designkit! As imagens de IA para estilo de vida são naturais,agradáveis e nórdicas: perfeitas para minha loja de velas. Minhas listas ficam incríveis e as vendas aumentaram. Vale a pena.  ","Desc_Evaluation3_HomeV2":"Eu vendo roupas e achei que a IA estragaria as texturas. Mas o Designkit acertou muito! As cores estão perfeitas, as poses dos modelos estão naturais e as imagens ficam prontas bem rápido.","Header_products_socialMediaPostGenerator":"Gerador de publicações em redes sociais","Pricing_Seedance_UnlockLimited":"Desbloqueie acesso ilimitado","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Acesso antecipado","Pricing_Seedance_SeedanceDesc":"Seja o primeiro a experimentar o poder do Seedance 2.0. Assine agora qualquer plano Pro e receba acesso ilimitado e exclusivo ao nosso modelo de IA de última geração.","Pricing_Seedance_Monthly":"Bônus do Plano Mensal","Pricing_Seedance_DaysUnLimit":"  7 dias <span>ilimitados</span>","Pricing_Seedance_SeedanceV2":"Acesso ao Seedance 2.0","Pricing_Seedance_BestValue":"MELHOR CUSTO-BENEFÍCIO","Pricing_Seedance_Yearly":"Bônus do Plano Anual","Pricing_Seedance_MonthUnLimit":"1 mês <span>Ilimitado</span>","Title_AIBrand_Tools":"✨Ferramentas de branding com IA","Title_AISocialMediaPosts":"Postagens nas redes sociais geradas por IA","Title_AILogoMaker":"Gerador de LOGO com IA","Option_Child_Age":"Criança","Option_Infant_Age":"Bebê","Option_MiddleAged_Age":"Adulto","Option_Senior_Age":"Idoso","Option_Teen_Age":"Adolescente","Option_YoungAdult_Age":"Jovem adulto","Button_GenerateImages_DetailPageAction":"Gerar","Text_GenerateImagesCount_DetailPageAction":"(${0} imagens)","Text_GenerateImagesCount_DetailPageAction1":"(${0} imagem)","Option_MercadoLivre_Platform":"Mercado Livre ","Option_Etsy_Platform":"Etsy ","Option_Walmart_Platform":"Walmart ","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Criar design de página de produto","Option_AdvancedMobile_DetailPageMode":"Premium A+ (celular)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Acessórios/Presentes","Option_ServiceSupport_DetailSection":"Garantia","Option_BeforeAfter_DetailSection":"Antes e depois","Option_BrandStory_DetailSection":"História da marca","Option_KeyHighlights_DetailSection":"Principais pontos de venda","Option_CraftProcess_DetailSection":"Vista explodida","Option_HeroVisual_DetailSection":"Arte principal","Option_Composition_DetailSection":"Componentes","Option_MultiAngle_DetailSection":"Multiângulo","Option_DetailCloseups_DetailSection":"Detalhes do produto","Option_SceneMood_DetailSection":"Estilo de vida/vibe","Option_SeriesShowcase_DetailSection":"Série de produtos","Option_SizeCapacity_DetailSection":"Dimensões","Option_Specifications_DetailSection":"Ficha técnica","Option_UsageScenario_DetailSection":"Casos de uso","Option_UsageTips_DetailSection":"Diretrizes de uso","Paragraph_ServicePolicy_DetailSection":"Garantia, devoluções e política de troca","Paragraph_BeforeAfter_DetailSection":"Resultados antes e depois do uso","Paragraph_BrandConcept_DetailSection":"Conceitos e valores de marca","Paragraph_CoreValue_DetailSection":"Demonstração de valor principal","Paragraph_CraftProcess_DetailSection":"Do desenho à realidade","Paragraph_Differentiators_DetailSection":"Destaques de vantagens principais","Paragraph_Composition_DetailSection":"Materiais e componentes do produto","Paragraph_MaterialAndCraft_DetailSection":"Destaques de material e processo","Paragraph_MultiAngleAppearance_DetailSection":"Vistas do produto de ângulos diferentes","Paragraph_MultiOptionDisplay_DetailSection":"Várias cores ou SKUs","Paragraph_IncludedItems_DetailSection":"Tudo incluído no pacote","Paragraph_DetailData_DetailSection":"Especificações detalhadas","Paragraph_RealUsageScene_DetailSection":"Referências de uso reais","Paragraph_Specifications_DetailSection":"Guia de tamanhos em destaque","Paragraph_UsageNotes_DetailSection":"Notas de uso e precauções","Paragraph_UsageScenario_DetailSection":"Produto no contexto","Title_Nav_DetailPage":"Detalhes de produto A+","Title_ImageSet_DetailPage":"Conjunto de imagens de detalhes de produto A+","Input_TaskName_Batch":"Inserir nome da tarefa","Paragraph_FullAssetSetDescription_Batch":"Inclui um conjunto completo de materiais de marketing, como arte principal, imagens de caso de uso e imagens de fundo branco que podem ser usadas em várias plataformas.","Paragraph_LongFormVisualDescription_Batch":"Cria storytelling visual para imagens de produtos, páginas de detalhes de produtos A+ e imagens de comparação.","Message_JsonGenerated_Batch":"Formulário verificado. JSON gerado.","Message_JsonCopied_Batch":"JSON copiado.","Message_IncompleteRequiredFields_Batch":"Campos obrigatórios ausentes. Preencha o formulário para enviar.","Message_PleaseUploadSourceImage_Batch":"Carregue imagens de produto.","Message_PleaseCompleteStrategySettings_Batch":"Conclua a configuração de estratégia","Message_TaskValidationFailed_Batch":"Revise e conclua as tarefas não verificadas.","Message_CopyJsonFailed_Batch":"Falha ao copiar. Verifique o JSON no painel.","Message_PleaseEnterTitle_Batch":"Insira o título.","Message_PleaseEnterKeyHighlights_Batch":"Insira os principais pontos de venda de produto.","Message_PleaseGenerateJsonFirst_Batch":"Envie para gerar o JSON.","Title_DetailPage_Batch":"Página de produto A+","Title_DetailTask_Batch":"Tarefa A+ ${0}","Title_IndependentParameters_Batch":"Configurar separadamente","Title_ImageSet_Batch":"Conjunto de imagens para e-commerce","Title_ItemTask_Batch":"Tarefa de produto","Option_Curvy_BodyType":"Curvilíneo","Option_Muscular_BodyType":"Musculoso","Option_PlusSize_BodyType":"Corpulento","Option_Slim_BodyType":"Magro","Option_Standard_BodyType":"Normal","Button_Reset_Common":"Reiniciar","Button_Back_Common":"Voltar","Button_Collapse_Common":"Recolher","Button_Expand_Common":"Expandir","Button_Generate_Common":"Gerar","Button_PreviousStep_Common":"Desfazer","Button_RemoveFavorite_Common":"Desfavoritar","Button_StartNow_Common":"Experimente agora","Paragraph_ExitWarning_Common":"Os dados serão perdidos se você sair.","Paragraph_Content1_VirtualModelDisclaimer":"2. Entenda o que esperar do conteúdo gerado com IA. Esse tipo de conteúdo é produzido com base em algoritmos e aprendizado de dados, e os resultados podem variar. A aparência facial gerada por IA pode ficar diferente dos materiais originais fornecidos, podendo gerar imperfeições e resultados insatisfatórios. Nossa plataforma não garante a precisão, a qualidade visual ou a adequação do conteúdo gerado.","Paragraph_Content2_VirtualModelDisclaimer":"3. Confirme as responsabilidades do usuário. Você é responsável pelas imagens que contêm rostos e pelo conteúdo gerado. Você deve assegurar que seu uso não viole nenhum direito legal de terceiros, incluindo, sem limitação, direitos de publicidade, privacidade e reputação, e que ele ocorra em conformidade com todas as leis e regulamentos aplicáveis. Você não deve utilizar o conteúdo gerado nenhum fim que seja ilícito, ilegal (por exemplo, difamação ou fraude), ou que viole a ordem pública e a moral ou a dignidade de outras pessoas.","Paragraph_Content3_VirtualModelDisclaimer":"Confirme que você entende e aceita os termos acima antes de carregar.","Title_Notice_VirtualModelDisclaimer":"Antes de usar o recurso de Provedor virtual  de imagem de produto com IA, leia e entenda o seguinte:","Message_FailedRetry_Download":"Falha ao baixar. Tente de novo mais tarde.","Message_Failed_Download":"Falha ao baixar.","Message_Success_Download":"Download concluído.","Message_NoImagesAvailable_Download":"Nenhuma imagem disponível.","Option_Asian_Ethnicity":"Asiático","Option_Black_Ethnicity":"Africano","Option_Chinese_Ethnicity":"Chinês","Option_Latino_Ethnicity":"Hispânico ou latino","Option_MiddleEastern_Ethnicity":"Oriente Médio","Option_SoutheastAsian_Ethnicity":"Sudeste asiático","Option_White_Ethnicity":"Branco","Option_Female_Gender":"Feminino","Option_Male_Gender":"Masculino","FormLabel_Ethnicity_Common":"Raça e etnia","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Idioma","FormLabel_TargetMarket_Common":"Mercado","FormLabel_TargetPlatform_Common":"Plataforma","Option_German_Language":"Alemão","Option_Japanese_Language":"Japonês","Option_None_Language":"Nenhum","Option_Portuguese_Language":"Português","Option_Russian_Language":"Russo","Option_Spanish_Language":"Espanhol","Option_Thai_Language":"Tailandês","Option_Brazil_Market":"Brasil","Option_China_Market":"China","Option_Europe_Market":"Europa","Option_Germany_Market":"Alemanha","Option_Japan_Market":"Japão","Option_Russia_Market":"Rússia","Option_SoutheastAsia_Market":"Sudeste Asiático","Option_Spain_Market":"Espanha","Option_UnitedStates_Market":"EUA","Message_MaxLimit_DetailSectionSelection":"Selecione até ${0} seções","Option_FollowGlobalSettings_Common":"Usar configurações globais","Text_MaxTasks_Batch":"Adicione até ${0} tarefa(s)","Text_MinTasks_Batch":"Mantenha pelo menos uma tarefa","Text_MaxImagesPerTask_Batch":"Carregar até ${0} imagens por tarefa","Text_SupportedImageFormats_Batch":"Formatos de imagem com suporte: JPG, JPEG, PNG, HEIC e WebP.","Input_AppearanceDetailsExample_TryOn":"Por exemplo: pele morena, franja reta, um sinal bonito perto do canto do olho...","Input_SourceInfoGuide_Batch":"Para obter resultados mais precisos, inclua as seguintes informações:\\n1. Nome do produto\\n2. Principais pontos de venda\\n3. Público-alvo\\n4. Casos de uso pretendidos\\n5. Especificações detalhadas","Tooltip_OutputStyleConsistent_Clone":"Ao ativar, todas as imagens geradas mantêm cores e estilo consistentes. Ao desativar, cada imagem segue o estilo da sua própria referência.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa indonésio","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Gerar conjunto de imagens","Title_Nav_ImageSet":"Lista de imagens de produtos","Message_GenerateFailedRetry_ImageSet":"Falha na geração, tente novamente.","Message_PleaseSelectStyleFirst_ImageSet":"Escolha um estilo primeiro.","Message_CreateTaskFailed_ImageSet":"Falha ao criar tarefa","Title_StyleAnalysis_ImageSet":"Análise de estilo de moda","Option_TrafficMaximization_TitleStrategy":"Maximizar tráfego","Option_ConversionPriority_TitleStrategy":"Conversão primeiro","Option_SceneImmersion_TitleStrategy":"Cenas imersivas","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extraindo os recursos principais dos ativos...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Gerando palavras-chave de conversão alta com base nos pontos de venda...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Associando as melhores estratégias de SEO...","Text_GeneratingOptions_TitleGenerationStatus":"Gerando várias legendas de perspectivas diferentes...","Message_TaskFailedWithStatus_TitleGeneration":"Falha na tarefa (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"A solicitação expirou. Tente de novo.","Message_GenerateFailed_TitleGeneration":"Falha ao gerar título. Tente de novo.","Message_QueryResultFailed_TitleGeneration":"Falha ao recuperar tarefa","Paragraph_Content_VirtualModelConsent":"1. Autorização de direitos de retratos: esse recurso usa as imagens que você carrega contendo rostos para gerar faces de modelos virtuais usando IA. Você precisa assegurar que tem os direitos de retrato das imagens carregadas ou que adquiriu o consentimento explícito por escrito válido com o proprietário desses direitos para usar suas fotos para esse fim e qualquer conteúdo gerado. Se a imagem contiver um menor de idade, será necessário obter o consentimento de seu guardião legal.","Button_ConfirmTextChange_TextEdit":"Atualizar","Input_ModifyText_TextEdit":"Editar legendas","Message_NoImagesAvailable_ResultDownload":"Nenhuma imagem disponível para download","Message_Failed_TextRecognition":"Falha ao reconhecer texto","Text_Generating_ResultStatus":"Gerando...","Option_CustomColor_SceneSetting":"Personalizado","Option_UseOriginalBackground_SceneSetting":"Usar fundo original","Text_InsufficientCredits_Common":"Moedas insuficientes","Button_LoadMore_Common":"Carregar mais","Text_ImageUploadLimit_Common":"Carregue até ${0} imagens","Text_AnalyzingTrend_Common":"Analisando tendências em ${0}","Text_ChineseOutputProOnly_Common":"A geração de texto em chinês está disponível somente no Pro. O texto foi removido do resultado atual.","Text_SourceImageUploadLimit_Common":"Carregue até ${0} imagens","Text_WritingInProgress_AiWriting":"Processando...","Text_DeepThinking_AiWriting":"Pensando...","Text_ThinkingProcess_AiWriting":"Raciocínio:","Text_ImageSelectionLimit_Common":"Selecione até ${0} imagens","Message_RegenerationSubmitted_Regeneration":"Regeneração enviada. Atualize para visualizar os resultados depois.","Button_MoreEditOptions_ResultEditor":"Mais","FormLabel_DetailSection_DetailPage":"Seção de detalhes de produto","Message_GeneratePlanFailed_DetailPagePlan":"Falha ao gerar plano","Message_PlanGenerationFailed_DetailPagePlan":"Falha ao gerar plano","Text_PlanUnavailable_DetailPagePlan":"Nenhum plano disponível","Message_SourceImageMissing_Common":"Imagem de produto faltando","Message_GenerationFailed_Common":"Falha na geração","Paragraph_ConfirmDiscardChanges_Common":"Suas alterações serão perdidas se você voltar. Tem certeza de que deseja voltar?","Message_ProcessFailed_Common":"Falhou","Text_GeneratingEllipsis_Common":"Gerando...","Text_StyleGenerationInProgress_ImageSet":"Gerando estilos modernos...","Message_FavoriteAdded_Common":"Adicionado aos Favoritos","Message_FavoriteRemoved_Common":"Removido dos favoritos","Text_LoadingPlain_Common":"Carregando","Text_MultiSelectAvailable_Common":"Selecionar vários","Text_NoData_Common":"Sem dados disponíveis","Text_NoDataAvailable_Common":"Sem dados","Text_NoMoreResults_Common":"Não há mais conteúdo","Message_PleaseEnterKeyHighlights_DetailPage":"Insira os principais pontos de venda","Message_PleaseSelectAiModel_TryOn":"Selecione um modelo de IA","Message_SelectSectionMin_DetailPage":"Selecione pelo menos ${0} seções","Message_SelectScenePoseMin_TryOn":"Selecione pelo menos ${0} cenas e poses","Message_PleaseSelectBaseModel_TryOn":"Selecione um modelo básico","Message_PleaseSelectCustomModel_TryOn":"Selecione um modelo personalizado","Message_PleaseSelectModel_TryOn":"Selecione um modelo primeiro","Message_PleaseSelectSection_DetailPage":"Selecione uma seção","Message_SelectUploadCustomModel_TryOn":"Selecione ou carregue uma imagem de modelo","Message_PleaseSelectScene_TryOn":"Selecione um cenário ","Message_PleaseSelectStrategy_DetailPage":"Selecione uma estratégia","Message_PleaseUploadGarmentImage_TryOn":"Carregue uma imagem de roupa","Message_UploadGarmentFile_TryOn":"Carregue uma imagem de roupa","Message_PleaseUploadSourceImage_Common":"Carregue imagens do produto primeiro","Message_PleaseUploadItemImage_Common":"Carregue uma imagem de produto","Message_UploadItemFirst_Common":"Carregue imagens do produto primeiro","Message_RegenerateFailedWithReason_Regeneration":"Falha ao regenerar:","Message_SelectResultImages_Result":"Selecione uma imagem com os resultados gerados","Text_ReleaseToRefresh_Common":"Liberar para atualizar","Message_TextRecognitionFormatInvalid_TextRecognition":"Formato inválido reconhecido","Message_TextRecognitionParseFailed_TextRecognition":"Falha ao analisar os resultados de reconhecimento","Message_TextRecognitionTaskFailed_TextRecognition":"Falha ao reconhecer texto","Message_QueryTaskStatusFailed_TextRecognition":"Falha ao recuperar o status da tarefa","Message_SubmitTaskFailed_TextRecognition":"Falha ao enviar a tarefa de reconhecimento de texto","Text_RegenerationProcessing_Regeneration":"Solicitação de regeneração enviada. Processando...","Message_RegenerateFailedRetry_Regeneration":"Falha ao regenerar. Tente de novo mais tarde.","Message_OpenEditorFailed_ResultEditor":"Falha ao abrir o editor","Message_RegenerateFailed_Regeneration":"Falha ao regenerar","Message_RefreshFailedRetry_Common":"Falha ao atualizar. Tente de novo.","Message_UploadGarmentSelectModel_TryOn":"Carregue uma imagem de roupa e selecione um modelo","Message_PollingTimedOut_Common":"A consulta expirou","Title_KeyHighlights_DetailPage":"Principais pontos de venda","Title_FullStrategyGuide_DetailPage":"Estratégia completa e diretrizes de design","Title_IncludedSections_DetailPage":"Seções","Title_IncludedSectionsMultiple_DetailPage":"Seções (selecione várias)","Title_ModelSelection_TryOn":"Selecionar modelo","Title_SectionContent_DetailPage":"Conteúdo da seção","Title_SectionStrategyGuide_DetailPage":"Estratégia da seção e diretrizes de design","Title_OutputAspectRatio_Common":"Proporção","Title_OutputSpecification_Common":"Especificações","Title_SelectModel_TryOn":"Selecionar modelo","Title_SelectScene_TryOn":"Selecionar uma cena","Title_StrategySettings_DetailPage":"Estratégia","Title_UploadAssets_Common":"Carregar","Button_GenerateBaseModel_TryOn":"Gerar modelo básico","Button_GenerateRecommendedScenes_TryOn":"Gerar cena recomendada","Button_GenerateSceneImages_TryOn":"Gerar (${0} imagens)","Text_GeneratingBaseModel_TryOn":"Gerando modelo básico...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Corpo inteiro","Option_HalfBody_Framing":"Meio corpo","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"Provador de IA","Option_Ai_TryOnModelMode":"Gerado por IA","Title_Nav_TryOn":"Provador","Option_Back_Perspective":"Traseira","Option_Front_Perspective":"Frontal","Option_Side_Perspective":"Lateral","Option_ThreeQuarterSide_Perspective":"Vista 3/4","Input_AppearanceDetailsHint_TryOn":"Detalhes da aparência: pele morena sfranja reta, um sinal bonito perto do canto do olho…","Message_SaveToAlbumSuccess_Common":"Salvo no álbum","Text_GeneratingSceneImages_TryOn":"Gerando imagens da cena","Message_RefreshFailed_Common":"Falha ao atualizar","Message_FailedRefunded_Generation":"Falha no design com IA. Os créditos foram reembolsados.","Title_BaseModelImage_TryOn":"Imagem de modelo básico","Title_CustomModel_TryOn":"Modelo personalizado","Paragraph_Intro_TryOn":"Carregue uma imagem de roupa e personalize seu modelo para gerar várias cenas e poses.","Title_UploadGarmentImage_TryOn":"Imagem de roupa","Tips_UploadFailedPure":"Falha ao carregar","Tips_Uploading":"Carregando…","Text_UploadNewModel":"Novo modelo","Text_AllBackgrounds":"Todos os fundos","Text_DefaultTemplateScene":"Padrão","Text_ColorScene":"Cores","Text_SameProductMax_Common":"Até ${0} imagens por produto","Text_Max_Common":"Até ${0} imagem(ns)","Button_Generate_ImageClone":"Começar a gerar","Button_RefreshStyle_Common":"Atualizar","Button_Favorite_Common":"Favorito","Text_PreviewLargeImage":"Prévia completa","Text_BaseImage":"Marco","Button_BatchDownload_Common":"Download em lote","Button_BatchEdit_Common":"Editar lote","Button_BatchWatermark_Common":"Adicionar marca d\'água","Text_GeneratedResults":"Resultados","Button_DownloadAllImages_Common":"Baixar tudo","Text_NoGeneratedResults":"Ainda não há resultados","Text_SameProductMax_TryOn":"Um traje completp ou vários ângulos do mesmo item, até ${0} imagens.","Title_AdvancedImageGenerationModel":"Modelo de imagem premium","Text_SupportChineseOutput_Common":"Oferece suporte a saída em chinês e fornece detalhes estéticos melhores e maior controle criativo.","Text_SelectMultipleModules_DetailPage":"Selecione várias seções para gerar uma página de detalhes de produto completa","Button_CollapseAll_Common":"Tudo","Label_AppearanceDetails_TryOn":"Detalhes de aparência (opcional)","Text_WaitingForGeneration_TryOn":"Geração pendente","Title_SmartTitleAI_ProductTitle":"Gerar título de listagem","Message_ResultMissing_TitleGeneration":"${0} ausente nos resultados gerados com IA","Message_InvalidJSONFormat_TitleGeneration":"Resultado inválido retornado","Message_InvalidJSONFormat_TitleGeneration1":"Formato JSON inválido retornado","Text_AutoGeneratedTitleScheme_ProductTitle":"Aqui estão os títulos gerados automaticamente com base no seu produto","Text_SelectBestTitle_ProductTitle":"Escolha um título que venda e clique para copiar","Button_Copy_Common":"Copiar","Message_PleaseUploadImage_Common":"Por favor, carregue uma imagem primeiro","Text_DeepThinking1_AiWriting":"O DeepSeek está trabalhando nisso...","Button_Rewrite1":"Tentar de novo","Text_TotalImages_Common":"Contagem: ${0}","Text_EditText_ResultEditor":"Editar texto","Text_NoTextRecognition_ResultEditor":"Nenhum texto encontrado","Text_PreviewLongImage_ResultGroup":"Prévia de imagem longa","Text_LimitFree":"Oferta relâmpago","Text_UploadSameProductTip1":"1. Carregue várias imagens do mesmo produto de diferentes ângulos para ajudar a IA a capturar melhor os detalhes do produto.","Text_UploadSameProductTip2":"2. Até 3 imagens. A primeira imagem será usada como referência primária, portanto, escolha o melhor ângulo.","Text_UploadProductImage_APlusCase":"Carregar imagem de produto","Text_GenerateEcommerceLongImage_APlusCase":"Gerar imagem longa","Text_MultiPlatform_APlusCase":"Compatível com vários padrões de plataforma de e-commerce","Text_MainImage_ProductCase":"01 imagem de cabeçalho (fundo branco/padrão)","Text_SceneDisplay_ProductCase":"02 cenários de casos de uso","Text_ModelSceneImage_ProductCase":"03 Imagens de modelo","Text_DetailDescription_ProductCase":"04 Detalhes","Text_FeatureExplanation_ProductCase":"05 Pontos de venda","Text_UploadProductImage_ProductCase":"Carregue imagens de produto, e a IA gerará instantaneamente conjuntos de imagens de alta conversão <span>compatíveis com vários padrões de plataforma de e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Carregue imagens de roupas e crie seu modelo personalizado para gerar instantaneamente várias cenas e poses.","Text_UploadProductImage_DetailPage":"Carregue imagens de produto, e a IA gerará instantaneamente uma página de detalhes de produto profissional <span>compatível com vários padrões de plataforma de e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Página de detalhes de produtos","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Faça login para desbloquear seu teste gratuito","Login_DK_Title":"Crie designs deslumbrantes de graça","Login_Zawa_Des":"Comece a criar com o Zawa hoje mesmo","Login_DK_Des":"Crie uma conta ou faça login para continuar criando designs. Comece agora mesmo!","Tab_Module_ProductImage_TryOn_MultiMix":"Organize peças em uma roupa","Tab_Module_ProductImage_TryOn_SingleHero":"De uma peça a um look completo","Tab_Module_ProductImage_TryOn_Accessories":"Combinação perfeita de acessórios","Text_ShowAdvancedModelTip":"Mostrar dicas de modelo premium","Text_HideAdvancedModelTip":"Ocultar dicas de modelo premium","Text_DeepSeekR1HelpWrite":"Ajude-me a escrever (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Máximo de tentativas excedido: ${0}","Title_StandardEdition":"Padrão","Text_FastAndEfficient_Common":"Rápido e eficiente","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Qualidade e detalhes aprimorados","Text_PremiumEngineActivated":"<strong>Mecanismo premium ativado:</strong> oferece suporte a saída em chinês e fornece detalhes estéticos melhores e maior controle criativo.","Text_EditBrand_DropTitle1":"Arraste e solte arquivos JPG, PNG ou WEBP aqui","Text_EditBrand_DropTitle2":"ou <>procure</> no seu computador.","Text_BaseToolbar_AlignTop":"Alinhamento superior","Text_BaseToolbar_AlignBottom":"Alinhamento inferior","Text_LayerSort":"Ordem","Text_BaseToolbar_AlignCenter":"Centro","Text_Attr_Strong":"Negrito","Text_GeneratingPlan_DetailPagePlan":"Gerando plano...","Text_PlanGenerationFailed_ReTry":"Falha ao gerar plano. Tente de novo mais tarde.","Button_StartAnalyze_ProductCase":"Vamos lá!","Message_SubmitSuccessTip_Batch":"Enviado. Você pode verificar os resultados daqui a ${0} minutos.","Button_ClickAnalyze_ProductCase":"Analisar estilos mais vendidos","Button_StartAnalyzing_ProductCase":"Analisando","Title_ModelImage":"Modelo","Text_Cookie_Title":"Primeiramente, os cookies 🍪","Text_Cookie_Content":"Gostaríamos de usar cookies neste site para garantir a segurança, bom desempenho e otimizar nossos serviços. Para saber mais sobre como usamos cookies, é só clicar em","Text_Cookie_LearnMore":"Detalhes","Button_Cookie_Manage":"Gerenciar cookies","Button_Cookie_Accept":"Aceitar","Text_CookieModal_Title1":"Configurações de cookies","Text_CookieModal_Desc1":"Cookies são pequenos arquivos de texto que os sites armazenam no seu dispositivo para nos ajudar a lembrar de suas preferências, acompanhar o tráfego do site e melhorar nossos serviços. Sua privacidade é importante para nós, e queremos que você tenha controle sobre seus dados. Aqui, você pode personalizar suas preferências de cookies para otimizar sua experiência de navegação. Lembre-se de que alterar as configurações de cookies pode afetar a funcionalidade e os serviços do nosso site.","Text_CookieModal_Title2":"Cookies necessários","Text_CookieModal_Desc2":"Esses cookies são essenciais para o funcionamento, a segurança e o desempenho do site. Sem eles, os principais recursos e medidas de segurança do Zawa podem não funcionar corretamente, o que pode afetar negativamente sua experiência.","Text_CookieModal_Title3":"Cookies opcionais","Text_CookieModal_Desc3":"Esses cookies nos ajudam a entender quantos usuários o Zawa tem, de onde eles vêm e como utilizam o site. Se você optar por desativá-los, não poderemos coletar informações para melhorar o Zawa e oferecer serviços melhores para você e outros usuários.","Button_CookieModal_Save":"Salvar","Text_CookieModal":"Sempre ativo","Text_Agent_Chat_DK":"Digite sua ideia...","Text_Agent_Chat_XD":"O que você gostaria de desenhar","Radio_Color":"Paleta","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Fundo","Language_Banner_Message":"Gostaria de trocar para ${0}?","Language_Banner_Change":"Sim","Language_Banner_Other":"Mais idiomas","Title_ItemTaskWithIndex_Batch":"Tarefa de produto ${0}","Title_DetailTaskPrefix_Batch":"Tarefa A+","Text_CopiedTaskTitle_Batch":"${0} (Cópia)","Message_SelectSectionMin_Batch":"Selecione ao menos uma seção.","Title_GlobalBatchSettings_Batch":"Configurações globais (Aplicar às tarefas seguintes)","Text_Parameters_Batch":"Parâmetros","Text_Modules_Batch":"Seções","Title_KeyHighlights_Batch":"Diferenciais","Text_ModulesFollowGlobal_Batch":"Seções - Usar configurações globais","Title_SelectManagedBusinessType_Batch":"Selecione o tipo de tarefa","Button_SubmitTask_Batch":"Enviar","Text_NewTaskCurrentCount_Batch":"Create Task","Title_NotificationSettings_Batch":"Notificações","Title_ManagedMode_Batch":"Agendador","Button_SaveSettings_Batch":"Salvar configurações","Button_SaveAndContinueSubmit_Batch":"Salvar e enviar","Message_PhoneFormatInvalid_Batch":"Insira um número de telefone válido, de 11 dígitos.","Message_VerificationCodeSent_Batch":"Código de verificação enviado. O código é válido por 5 minutos.","Message_VerificationCodeSendFailed_Batch":"Falha ao enviar. Tente novamente mais tarde.","Message_PleaseEnterCode_Batch":"Insira o código de verificação.","Message_GetCodeFirst_Batch":"Obtenha primeiro um código de verificação.","Message_VerificationCodeExpired_Batch":"O código de verificação expirou. Solicite um novo.","Message_SaveNotificationSettingsFailed_Batch":"Falha ao salvar as configurações de notificações. Tente mais tarde.","Text_WebMessageNotification_Batch":"Notificações na web","Title_AppPushRecommended_Batch":"Notificações no app (Recomendado)","Paragraph_AppPushDesc_Batch":"Acompanhe o progresso e veja os resultados no seu celular em tempo real. Mantenha seus designs sempre à mão e não perca nenhuma oportunidade.","Text_AppDownloadQrCode_Batch":"Escaneie para baixar o app","Title_SmsNotification_Batch":"Notificações via SMS","Placeholder_Phone11Digits_Batch":"Número de telefone de 11 dígitos","Placeholder_VerificationCode5Min_Batch":"Código de verificação (válido por 5 minutos)","Text_SendingEllipsis_Batch":"Enviando...","Text_RetryAfterSeconds_Batch":"Tente novamente em ${0} s","Button_GetVerificationCode_Batch":"Enviar código","Message_SubmitSuccess_Batch":"Enviado","Message_SubmitFailedRetry_Batch":"Falha ao enviar. Tente novamente mais tarde.","Message_FormValidationPassed_Batch":"Conteúdo válido","Message_CompleteNotificationSettingsFirst_Batch":"Por favor, configure as notificações antes de enviar a tarefa.","Paragraph_CancelManagedTaskWarning_Record":"Caso cancele agora, a tarefa agendada será removida permanentemente.","Button_ConfirmCancel_Record":"Cancelar mesmo assim","Message_CancelManagedTaskFailed_Record":"Falha ao cancelar. Tente novamente mais tarde.","Text_WaitingManagedGeneration_Batch":"Agendando tarefa...","Text_WaitingManagedSubmit_Batch":"Na fila","Message_NoExtendableImages_Result":"Nenhuma imagem disponível","Text_IntelligentMultiSizeAdaptation_Result":"Com o redimensionamento inteligente, suas imagens cabem em qualquer tela","Button_IntelligentResize_Result":"Redimensionamento inteligente","Option_CustomSize_DetailPageMode":"Personalizado","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Experimente o Agendador!","Text_ManagedModeSlogan_Batch":"Funciona durante a noite para que seus designs estejam prontos pela manhã.","Title_BatchProduction_Batch":"Geração por lote","Paragraph_BatchProductionDesc_Batch":"Executa até ${0} tarefas simultaneamente, aumentando sua produtividade em ${1}×.","Title_AiIntelligentExtraction_Batch":"Análise por IA","Paragraph_AiIntelligentExtractionDesc_Batch":"Analisa suas imagens e cria automaticamente diferenciais com alto poder de conversão.","Title_SaveCost20_Batch":"Economize ${0}% em créditos","Paragraph_SaveCost20Desc_Batch":"Você pode agendar tarefas à noite e aproveitar descontos no uso de créditos.","重写":"Download em lote","Brand_AutoExtract_Button":"Extração de paleta","Brand_AutoExtract_Success":"Paleta extraída","Brand_AutoExtract_Failure":"Falha ao extrair a paleta de cores. Tente novamente.","Brand_AutoExtract_Unavailable":"Não é possível extrair a paleta de cores.","Brand_AutoExtract_ConfirmTitle":"Extrair a paleta de cores do logo?","Title_ImageSetConfig_ImageSet":"Design de anúncios","Title_DefaultConfig_ImageSet":"Design com IA","Desc_DefaultConfig_ImageSet":"Deixe a IA criar o melhor design de anúncio para o seu produto.","Title_CustomConfig_ImageSet":"Design personalizado","Desc_CustomConfig_ImageSet":"Personalize o número de imagens para cada tipo. Selecione pelo menos ${0} imagens.","Label_WhiteBackground_ImageSet":"Imagens com fundo branco","Desc_WhiteBackground_ImageSet":"Apresente seu produto de vários ângulos com um fundo branco.","Label_Scene_ImageSet":"Cenas da vida","Desc_Scene_ImageSet":"Apresente seu produto em cenas realistas.","Label_SellingPoint_ImageSet":"Diferenciais destacados","Desc_SellingPoint_ImageSet":"Destaque as principais características que fazem seu produto se sobressair.","Label_Other_ImageSet":"Outros","Desc_Other_ImageSet":"Conteúdo selecionado automaticamente para seu produto, incluindo comparações e especificações, entre outros.","Tip_MinTotal_ImageSet":"Mínimo de ${0} imagens","Text_ManagedBatchEntry_Header":"Agendador","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Plano de créditos","Text_Higher_Plan":"Já possui um plano superior","Text_Try_Free":"Experimente por $0","Text_Plus_Plan":"Plano Plus","Text_Pro_Plan":"Plano Profissional","Button_Generate_Short_Common":"Gerar","Message_DuplicateTaskSubmitConfirm_Common":"Já foram gerados resultados com essas configurações. Gerar novamente?","Text_CreditUnit_Common":"Crédito","Text_NewUserDiscountDesc_Product":"${0} créditos pelo primeiro anúncio. ${2} créditos por cada ${1} anúncios adicionais.","Text_NewUserLimitedTag_Product":"Desconto de novo usuário","Text_OriginalPrice_Product":"Original: ${0} créditos","Tip_MaxTotal_ImageSet":"Até ${0} imagens","Text_AddDocumentTips":"Compatível com arquivos Word, Excel, Text, PDF e Markdown","Tab_SolidColor":"Cor sólida","Tab_Gradient":"Degradê","Title_PresetGradient":"Predefinições","Title_PresetSolidColor":"Predefinições","Title_RecentlyUsed":"Usado recentemente","Title_Patterns":"Padrão","Title_NoFill":"Nada","Description_Brand_Reference":"Envie seus pôsteres ou artes favoritas e o Zawa usará aqueles estilos para criar designs sob medida para você.","Text_Generating":"Gerando...","Text_ChartSending":"Enviando","Text_PeopleUnSupport":"Ainda não há suporte para retrato","Button_CancelManagedBatch_ResultGroup":"Cancelar tarefa","Button_DownloadZip_ResultGroup":"Baixar ZIP","Button_DownloadLongImage_ResultGroup":"Baixar o arquivo combinado","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"A tarefa enviada não pode ser cancelada","Button_GlobalAiWriting_Batch":"Redação com IA","Text_StandardModel_DistributionBatch":"Modelo Padrão (Lista em massa)","Text_StandardModelDescription_Batch":"Ideal para SKUs de alto volume, a fim de maximizar o alcance no mercado.","Text_AdvancedModel_PremiumBatch":"Modelo Avançado (Listagem direcionada)","Text_AdvancedModelDescription_Batch":"Imagens de qualidade premium, ideais para gerar rentabilidade com alta precisão.","Message_MinSubmitTasks_Batch":"Envie pelo menos ${0} tarefas.","Message_OverwriteSellingPointsConfirm_Batch":"A seção de pontos de venda já contém ${0} tarefas. Como você gostaria de aplicar os resultados da redação com IA?","Button_OverwriteAll_Batch":"Substituir todos","Button_FillEmptyOnly_Batch":"Apenas os incompletos","Message_NoEmptySellingPointsToFill_Batch":"Os pontos de venda para todas as tarefas estão completos.","Message_AiWritingFailedRetry_Batch":"A redação com IA falhou. Tente novamente mais tarde.","Button_NewTask_Common":"Nova tarefa","Message_Generating_Time":"Suas tarefas serão executadas durante a noite (${0}-${1}). Volte amanhã para verificar os resultados.","Title_Total_Credits":"Créditos totais","Text_Used_AllFeatures":"Aplicável a todos os recursos","Daily_Present_Credits":"Créditos para usar hoje","Daily_Credits_Desc":"Resgate diariamente. Válido até o final do dia.","Text_Inactive":"Inativos","Text_Inactive_Monthly":"${0} créditos expirarão nos próximos 30 dias","TITLE_GUIDE_CUTOUT_LITE":"Selos ou logotipos detectados","GUIDE_DESC_CUTOUT_LITE":"Use o recurso Recorte de selo/logotipo para um recorte preciso","GUIDE_ACTION_CUTOUT_LITE":"Recorte de selo/logotipo","TITLE_CUTOUT_LITE":"Recorte de selo/logotipo","TIP_CUTOUT_LITE":"Recortes de selos ou logotipos com precisão","PROCESSING_CUTOUT_LITE":"Gerando imagens...","AFTER_CUTOUT_LITE":"Resultados","Button_Previous":"Anterior","Button_Next":"Próximo","Button_Skip":"Pular","Button_Apply":"Aplicar","Text_AgentExpert":"Especialista","Message_PleaseEnterLinkOrAsin_Clone":"Insira um link ou ASIN","Message_LinkAnalyzeFailed_Clone":"A análise do link falhou","Message_UploadProductImageFirst_Clone":"Carregue imagens do produto primeiro","Message_ProductImageThumbGenerateFailed_Clone":"Falha ao gerar a miniatura. Envie novamente.","Message_UploadProductImageFirst_ProductCase":"Carregue uma imagem de referência ou cole o link de um produto","Message_ReferenceImageThumbGenerateFailed_Clone":"Falha ao gerar a miniatura. Envie novamente.","Title_ReferenceSource_Clone":"Referência","Option_LinkAsin_Clone":"Link","Input_PasteProductLinkOrAsin_Clone":"Cole um link da Amazon","Button_Parsing_Clone":"Analisando...","Button_Parse_Clone":"Analisar","Text_SupportAmazonTiktokLinks_Clone":"Compatível com links da Amazon e do TikTok","Text_Cloning_ResultStatus":"Processando...","Input_CloneRequirementOptional_Clone":"Requisitos (opcional)","Title_ProductOriginalImage_Clone":"Imagem de produto","Title_CloneLevel_Clone":"Fidelidade","Option_CompositionReference_Clone":"Estilo","Desc_CompositionReference_Clone":"Use o estilo e a composição para ajustar as cores e reconstruir a cena automaticamente.","Option_HighFidelityClone_Clone":"Visual geral","Desc_HighFidelityClone_Clone":"Use a composição visual geral. Substitua apenas o produto e o texto, permitindo pequenas variações na cena.","Label_OutputStyleConsistent_Clone":"Estilo consistente","Title_SupplementaryNotesOptional_Clone":"Requisitos gerais (opcional)","Input_SupplementaryNotesExample_Clone":"Exemplo: Gere um texto publicitário em inglês, mantendo o mesmo modelo e substituindo apenas o produto.","Title_HotClone_Welcome":"Clonar e criar","Text_HotCloneDescription_Welcome":"Layouts incríveis + Seus produtos = Sucesso de vendas","Text_DefaultTaskName_Clone":"Estratégia de clonagem de imagem","Label_ProductImage_CloneCase":"Imagem de produto","Label_ReferenceComposition_CloneCase":"Estilo","Label_HighFidelityClone_CloneCase":"Visual geral","Tag_AiSmartMatch_ImageSet":"Correspondência inteligente com IA","Title_Date":"Data","Title_Topic":"Tema","Button_Replace":"Substituir","Title_SingleCloneRequirement_Clone":"Requisitos individuais","Text_UploadedReferenceImagesTip_Clone":"Requisitos individuais para cada imagem de referência. Caso não sejam especificados, as configurações padrão serão aplicadas.","Label_ReferenceImageIndex_Clone":"Imagem de referência ${0}","Option_Mexico_Market":"México","Text_ParsingReferenceImages_Clone":"Analisando...","Text_ParseReferenceImagesSuccess_Clone":"Análise concluída. ${0} imagem(ns) de referência obtida(s).","Text_Renew_Restore":"Os créditos serão reativados assim que sua assinatura for renovada.","Title_UsageNotice_Clone":"Guia do usuário","Text_UsageNoticeDescription_Clone":"Confirme que você detém os direitos legais de uso do conteúdo deste link. Os resultados gerados são fruto de análise de estilo por IA e servem apenas como referência criativa.","Label_ReadAndAgreeUsageNotice_Clone":"Aceito os termos acima","Label_DoNotShowAgain_Clone":"Não mostrar novamente","Brand_StatusPopup_ProcessingTitle":"Zawa está estudando o estilo da sua marca...","Brand_StatusPopup_FailedTitle":"Falha ao extrair dados da Square. Tente novamente mais tarde.","Brand_StatusPopup_Retry":"Tentar novamente","SecondTitle_Header19_Home":"Clonar anúncios de vídeo","SquareBrandGuide_BrandKitCreatedTip":"Seu kit de marca foi criado com base nos dados da Square","SquareBrandGuide_DefaultPrompt":"Crie um pôster de produto para divulgação nas redes sociais","SquareBrandGuide_SendTip":"Clique em \\"Enviar\\" para começar!","Paragraph_BatchProductionDescUnlimited_Batch":"Handles multiple tasks simultaneously, drastically cutting down your project timelines.","Menu_ViewDetail":"Detalhes","Menu_CopyFullText":"Copiar tudo","Tip_CopiedToClipboard":"Copiado para a área de transferência","Tip_CopyFailed":"Falha ao copiar","Menu_DownloadImage":"Baixar","Tip_NoImage":"Sem imagens","Tip_DownloadStarted":"Download in progress","Menu_CopyText":"Copiar","Tip_NoTextToCopy":"No text available","Message_LinkImageFetchFailed_Clone":"We couldn\'t load images from this link. Try a different link or upload the images instead.","Tab_Chat":"Chat","Tab_Files":"Files","Button_Create_New_Chat":"New chat","Tip_Agent_Team_Chat_Shared":"Viewing read-only version","RoboNeo_Web_input_default_content":"Chat com o RoboNeo","RoboNeo_Web_chatbox_maximum":"Limite de chat atingido","RoboNeo_Web_chatbox_maximum_text":"Limite de chat atingido. Crie uma nova tarefa.","RoboNeo_Web_chatbox_new_task":"Novo projeto","RoboNeo_Web_history_share_text":"Compartilhar","RoboNeo_Web_history_delete_text":"Excluir","RoboNeo_Web_history_delete_hint_text":"Atenção","RoboNeo_Web_history_delete_main_text":"O projeto será excluído permanentemente. Deseja continuar?","RoboNeo_Web_history_delete_hint_confirm":"Excluir","RoboNeo_Web_history_delete_hint_cancel":"Cancelar","RoboNeo_Web_studio_download":"Baixar","RoboNeo_Web_toast_share_text":"Compartilhar este chat","RoboNeo_Web_toast_share_main_text":"Qualquer pessoa com o link do chat pode visualizar seu histórico de conversas.","RoboNeo_Web_toast_share_copy":"Copiar link","RoboNeo_Web_toast_cancel":"Cancelar","RoboNeo_Web_toast_confirm":"Confirmar","RoboNeo_Web_studio_changing_toast":"Não há mais usos gratuitos disponíveis hoje. Serão reiniciados à meia-noite. Você também pode alimentar Neo com “Cyber Carrots” para continuar.","RoboNeo_Web_studio_changing_toast2":"Não há mais usos gratuitos disponíveis para hoje.","RoboNeo_Web_new_studio":"Novo chat","RoboNeo_Web_sidebar_close":"Recolher","RoboNeo_Web_history_text":"Histórico","RoboNeo_Web_sidebar_open":"Expandir","RoboNeo_Web_upload_warning_text":"Não é possível carregar fotos e vídeos ao mesmo tempo.","RoboNeo_Web_upload_format_text":"Formatos de imagem suportados: JPG, PNG e JPEG. \\nFormatos de vídeo suportados: MP4 e MOV.","RoboNeo_Web_upload_fail_text":"O envio falhou","RoboNeo_Web_upload_image_maximum":"Você pode carregar até {max_num} imagens","RoboNeo_Web_upload_video_size_maximum":"Vídeos maiores que {max_size} MB não são suportados.","RoboNeo_Web_upload_image_size_maximum":"Imagens acima de {max_size} MB não são suportadas.","RoboNeo_Web_upload_video_maximum":"Você pode enviar até {max_num} vídeos.","RoboNeo_Web_history_dafult_text":"Não foi encontrado nenhum histórico, converse agora.","RoboNeo_Web_upload_content_warning_text":"Arquivos com conteúdo potencialmente inadequado não serão importados.","RoboNeo_Web_chat_send_fail":"Falha no envio, tente novamente mais tarde.","RoboNeo_Web_network_fail":"Falha na conexão ou tempo limite esgotado. Por favor, ente novamente.","RoboNeo_Web_studio_layer_fail":"Falha ao dividir camadas.","RoboNeo_Web_studio_layer_success":"Concluído","RoboNeo_Web_network_error":"Erro de rede","RoboNeo_Web_delete_success":"Excluído","RoboNeo_Web_delete_fail":"Falha ao excluir","RoboNeo_Web_copy_success":"Copiado","RoboNeo_Web_file_uploading":"Carregando {num} arquivos","RoboNeo_Web_file_upload_fail":"Erro ao carregar {num} arquivos","RoboNeo_Web_file_upload_single_fail":"Erro ao carregar 1 arquivo","RoboNeo_Web_file_uploading_single":"Carregando 1 arquivo","RoboNeo_Web_upload_video_maximum_one":"Você pode carregar até 1 vídeo","RoboNeo_Web_sharepage_wanna_try":"Experimente Já","RoboNeo_Web_sharepage_load_to_end":"Ir para os resultados","RoboNeo_Web_studio_loading_text":"Carregando telas...","RoboNeo_Web_chatbox_add_image":"Adicionar imagens","RoboNeo_Web_chatbox_add_video":"Adicionar vídeo","RoboNeo_Web_image_editor_max":"Máximo de 10 MB com 4096 px no lado mais longo","RoboNeo_Web_unlimited_pass_expired":"O Passe Ilimitado expirou. Usar agora os usos gratuitos disponíveis.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - concluído ","RoboNeo_Web_studio_ai_image_failed":"AI UHD - falhou","RoboNeo_Web_studio_cutout_successful":"Recorte realizado com sucesso","RoboNeo_Web_studio_cutout_failed":"Falha no recorte","RoboNeo_Web_studio_ai_edit_failed":"Edição com IA - falhou","RoboNeo_Web_studio_ai_edit_successful":"Edição com IA - concluída","RoboNeo_Web_AI_generated":"Resultado da IA","RoboNeo_Web_loading":"Carregando","RoboNeo_Web_view_creative_process":"Ver processo criativo","RoboNeo_Web_try_now":"Experimente Já","RoboNeo_web_extender_successful":"Extensão com IA - concluído","RoboNeo_web_extender_failed":"Extensão com IA - falhou","RoboNeo_web_eliminate_successful":"Remover com IA - concluído","RoboNeo_web_eliminate_failed":"Remover com IA - falhou","roboneo_web_continue":"Continuar","roboneo_web_video":"Vídeo","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"Este chat não pode ser compartilhado. Tente iniciar um novo.","roboneo_web_open_the_APP_experience":"Experimente no aplicativo","roboneo_web_AI_generated_logo":"Este conteúdo gerado por IA é apenas para referência.","roboneo_web_change_word_success":"Substituir texto - concluído","roboneo_web_change_word_fail":"Substituir texto - falhou","roboneo_web_canvas_loading_failed":"Falha ao carregar a tela","roboneo_web_export_failed":"A exportação falhou","roboneo_web_export_tips2":"Suporta apenas a exportação de uma imagem (até {width}px*{height}px).","roboneo_web_new_topic":"Novo chat","roboneo_web_waiting_reply":"Aguardando resposta","roboneo_web_file_saving_preferences":"Preferências do arquivo","roboneo_web_includes_AI_watermark":"Incluir marcas d\'água de IA","roboneo_web_no_remind":"Não mostrar novamente","roboneo_web_agree_continue":"Aceitar e continuar","roboneo_web_AI_generated":"Conteúdo gerado por IA","roboneo_web_watermark_protocol":"Você pode optar por salvar as imagens com ou sem marcas d\'água “Resultado da IA”. Ao optar por salvar sem a marca d\'água, você concorda em: 1. Não usar o RoboNeoAI para criar, publicar ou divulgar informações falsas. 2. Garantir a conformidade com a lei e indicar claramente que tal conteúdo foi gerado por IA ao usá-lo ou compartilhá-lo.","roboneo_web_rectangle":"Quadrado","roboneo_web_circle":"Redondos","roboneo_web_arrow":"Seta","roboneo_web_image_fusion_success":"Concluído","roboneo_web_image_fusion_failure":"Falhou","roboneo_chat_resources_num_limit_tips":"Pode adicionar até {img_num} vídeo e {video_num} imagens.","RoboNeo_Web_export_confirm_tip_popup_title":"You can choose whether to export with an \\"AI-generated\\" watermark.","RoboNeo_Web_export_confirm_tip_popup_btn":"Got it."}');
// EXTERNAL MODULE: ./node_modules/@meitu/x-design-locales-next/zh-Hans.json
var zh_Hans = __webpack_require__(71951);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/createLocale.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function replacer(template, data) {
  var strTemplate = Array.isArray(template) ? template.join('') : template;
  var arrays = strTemplate.split(/(\${\d+})/);
  var results = [];
  for (var i = 0; i < arrays.length; i += 1) {
    var match = arrays[i].match(/^\$\{(\d+)\}$/);
    if (match) {
      var index = parseInt(match[1], 10);
      results.push(data[index]);
    } else {
      results.push(arrays[i]);
    }
  }
  return results;
}
function nodeReplacer(template, data) {
  return replacer(template, data);
}
function textReplacer(template, data) {
  return replacer(template, data).join('');
}
function textWrapper(template, data) {
  var strTemplate = Array.isArray(template) ? template.join('') : template;
  var arrays = strTemplate.split(/<>|<\/>/);
  var count = Math.floor(arrays.length / 2);
  var results = [];
  for (var i = 0; i < arrays.length; i += 1) {
    if (i % 2 === 1 && i <= count + 1) {
      var wrapper = data[(i - 1) / 2];
      results.push(wrapper ? wrapper(arrays[i]) : arrays[i]);
    } else {
      results.push(arrays[i]);
    }
  }
  return results;
}

/**
 * 解析 HTML 代码字符串为 HTML 节点对象
 *
 * @since 0.1.0
 * @param html - HTML 代码字符串
 */
function parseHtmlString(html) {
  var result = [];
  var regex = /<([a-z]+)([^>]*)\s*(?:>(.*?)<\/\1>|\/>)/gi;
  var match;
  while ((match = regex.exec(html)) !== null) {
    var tagName = match[1].toLowerCase();
    var attributes = match[2];
    var content = match[3];
    var attrsMatch = attributes.match(/([a-zA-Z_:][a-zA-Z0-9:._-]*)(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+))?/g);
    var styleRegex = /style\s*=\s*"([^"]*)"/i;
    var styleMatch = attributes.match(styleRegex);
    var styleObj = {};
    var attrs = attrsMatch === null || attrsMatch === void 0 ? void 0 : attrsMatch.reduce(function (prev, attr) {
      var attrData = attr.replace(/"/g, '').split('=');
      var attrName = attrData[0] === 'class' ? 'className' : attrData[0];
      if (attrName) {
        prev[attrName] = attrData[1];
      }
      return prev;
    }, {});
    if (styleMatch && styleMatch[1]) {
      var styles = styleMatch[1].split(';');
      var _iterator = _createForOfIteratorHelper(styles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var style = _step.value;
          if (style.trim()) {
            var colonIndex = style.indexOf(':');
            if (colonIndex > -1) {
              var key = style.substring(0, colonIndex).trim();
              var value = style.substring(colonIndex + 1).trim();
              if (key && value) {
                styleObj[key] = value;
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    result.push({
      tag: tagName,
      props: _objectSpread(_objectSpread({}, attrs), {}, {
        style: styleObj
      }),
      children: [content]
    });
  }
  return result;
}

/**
 * HTML 标签节点替换方法
 *
 * @since 0.1.0
 * @param template - 模板
 * @param replacer - 替换方法
 */
function htmlReplacer(template, replacer) {
  return replacer(parseHtmlString(template));
}

/**
 * 创建多语言本地化翻译文本数据映射及替换方法
 *
 * @param textResource - 翻译文本源数据
 */
function createLocaleText(textResource) {
  return function (print) {
    if (!textResource) return '';
    try {
      return print(textResource, {
        r: textReplacer,
        w: textWrapper,
        n: nodeReplacer,
        h: htmlReplacer
      });
    } catch (_e) {
      return '';
    }
  };
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/context.js

var context_LocaleTextContext = /*#__PURE__*/(0,react.createContext)('');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/useLocale.js


var localeInstance = '';
var getLocale = function getLocale() {
  return localeInstance;
};
var useLocale_setLocale = function setLocale(_locale) {
  localeInstance = _locale;
};
var useLocaleText = function useLocaleText() {
  var locale = (0,react.useContext)(context_LocaleTextContext) || getLocale();
  return locale;
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/LocaleProvider.js



function LocaleProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  return /*#__PURE__*/_jsx(LocaleTextContext.Provider, {
    value: locale,
    children: children
  });
}
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js












/**
 * 独立发包场景：内置 zh-Hans，保证无外部注入时可用。
 * 业务应用可只走 CDN 注入，不必在业务代码里再 import 语言包 JSON。
 */ var localeTextMap = {
    "zh-Hans": (0,lodash.merge)({}, zh_Hans, zh_Hans_namespaceObject),
    // TODO: 以下语言在全量上线后，可移除
    en: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, en_namespaceObject),
    es: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_es_namespaceObject, en_namespaceObject, es_namespaceObject),
    pt: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_pt_namespaceObject, en_namespaceObject, pt_namespaceObject),
    id: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_id_namespaceObject, en_namespaceObject, id_namespaceObject)
};
var SUPPORT_LOCALES = Object.keys(localeTextMap);
function mergeLocaleText(locale, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap) {
    localeTextMap[locale] = (0,lodash.merge)({}, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap);
}
// 浏览器环境外部注入多语言
if ( true && window.__LOCALE__) {
    var _localeTextMap$locale, _window$__LOCALE_TEXT, _window$__DEV_NEXT_LO, _window$__LOCALE_TEXT2, _window$__LOCALE_TEXT3;
    var locale = window.__LOCALE__;
    var fallback = (_localeTextMap$locale = localeTextMap[locale]) !== null && _localeTextMap$locale !== void 0 ? _localeTextMap$locale : localeTextMap["zh-Hans"];
    var nextLocaleMap = (_window$__LOCALE_TEXT = window.__LOCALE_TEXT_NEXT_MAP__) !== null && _window$__LOCALE_TEXT !== void 0 ? _window$__LOCALE_TEXT : {};
    var devNextOverrides = (_window$__DEV_NEXT_LO = window.__DEV_NEXT_LOCALE_OVERRIDES__) !== null && _window$__DEV_NEXT_LO !== void 0 ? _window$__DEV_NEXT_LO : {};
    var legacyLocaleMap = (_window$__LOCALE_TEXT2 = (_window$__LOCALE_TEXT3 = window.__LOCALE_TEXT_LEGACY_MAP__) === null || _window$__LOCALE_TEXT3 === void 0 ? void 0 : _window$__LOCALE_TEXT3.xDesignWidgets) !== null && _window$__LOCALE_TEXT2 !== void 0 ? _window$__LOCALE_TEXT2 : {};
    mergeLocaleText(locale, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap);
} else if (typeof globalThis !== "undefined") {
    // node.js 环境：__FULL_LOCALE_TEXT_MAP__ 已是 next + legacy 的全量结果
    // 开发态仅会注入一种语言，__DEV_NEXT_LOCALE_OVERRIDES__ 可直接覆盖到所有语言
    var localeGlobal = globalThis;
    var fullLocaleText = localeGlobal.__FULL_LOCALE_TEXT_MAP__;
    if (fullLocaleText) {
        var _localeGlobal$__DEV_N;
        var _devNextOverrides = (_localeGlobal$__DEV_N = localeGlobal.__DEV_NEXT_LOCALE_OVERRIDES__) !== null && _localeGlobal$__DEV_N !== void 0 ? _localeGlobal$__DEV_N : {};
        for(var _i = 0, _Object$keys = Object.keys(fullLocaleText); _i < _Object$keys.length; _i++){
            var loc = _Object$keys[_i];
            mergeLocaleText(loc, fullLocaleText[loc], {}, _devNextOverrides, {});
        }
    }
}
var localStoreCache = {};
var initLocaleStore = function initLocaleStore(locale) {
    setLocale(locale);
};
var getLocaleStore = function getLocaleStore(_locale) {
    var locale = _locale || getLocale() || "zh-Hans";
    var localeText = localeTextMap[locale];
    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale: locale,
            $t: createLocaleText(localeText)
        };
    }
    return localStoreCache[locale];
};
var useLocaleStore = function useLocaleStore() {
    var locale = useLocaleText();
    return getLocaleStore(locale);
};
/**
 * useLocaleStore 的别名，不再推荐使用
 */ var useLocale = useLocaleStore;


/***/ }),

/***/ 85776:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export createLoading */
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81549);
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24996);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30341);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);






var createLoading = function createLoading() {
    var Loading = function Loading(props) {
        var tip = props.tip, _props$allowClickMask = props.allowClickMask, allowClickMask = _props$allowClickMask === void 0 ? false : _props$allowClickMask, className = props.className, style = props.style;
        (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                return (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }, []);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("xdesign-loading", className),
            style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, style), {}, {
                minWidth: tip ? 100 : "auto"
            })
        }, allowClickMask ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("style", {
            dangerouslySetInnerHTML: {
                __html: "html, body {\n                          user-select: none;\n                          pointer-events: none;\n                      }"
            }
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__wrap"
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
            className: "xdesign-loading__content"
        })), tip ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__tip"
        }, tip) : null);
    };
    var el = null;
    var show = function show(tip) {
        if (!el) {
            el = document.createElement("div");
        }
        document.body.appendChild(el);
        (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement(Loading, {
            tip: tip
        }), el);
    };
    var hidden = function hidden() {
        if (el && el.parentNode) {
            (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .unmount */ .vE)(el);
            el.parentNode.removeChild(el);
            el = null;
        }
    };
    Loading.show = show;
    Loading.hidden = hidden;
    return Loading;
};
var Loading = createLoading();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loading);


/***/ }),

/***/ 67890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": () => (/* binding */ modalLocalStorageKey),
/* harmony export */   "Tk": () => (/* binding */ bannerLocalStorageKey),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "rW": () => (/* binding */ modalDomesticLocalStorageKey)
/* harmony export */ });
// 定义功能路径的映射类型
// 功能路径映射表
var pathMappings = [
    {
        accessPath: "/",
        targetPath: "/",
        pageName: "home",
        project: "home"
    },
    // 官网
    {
        accessPath: "/tools",
        targetPath: "/tools",
        pageName: "404",
        project: "home"
    },
    // 工具页
    {
        accessPath: "/templates",
        targetPath: "/templates",
        pageName: "404",
        project: "home"
    },
    // 模版页
    {
        accessPath: "/space",
        targetPath: "/space",
        pageName: "404",
        project: "home"
    },
    // 我的空间
    {
        accessPath: "/share",
        targetPath: "/share",
        pageName: "404",
        project: "home"
    },
    // 与我分享
    {
        accessPath: "/editor",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    },
    // 图片编辑
    {
        accessPath: "/design",
        targetPath: "/design",
        pageName: "hbsj",
        project: "hbsj"
    },
    // 海报编辑
    {
        accessPath: "/aieraser",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    // 消除
    {
        accessPath: "/quality",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    // 变清晰
    {
        accessPath: "/upscale",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    // 无损改尺寸
    {
        accessPath: "/puzzle",
        targetPath: "/puzzle",
        pageName: "404",
        project: "pt"
    },
    // 拼图
    {
        accessPath: "/certified",
        targetPath: "/certified",
        pageName: "404",
        project: "zjzsj"
    },
    // 证件照
    {
        accessPath: "/logo-design",
        targetPath: "/logo-design",
        pageName: "ailogo",
        project: "ailogo"
    },
    // AI logo
    {
        accessPath: "/ppt",
        targetPath: "/ppt",
        pageName: "404",
        project: "home"
    },
    // LivePPT
    {
        accessPath: "/poster",
        targetPath: "/poster",
        pageName: "404",
        project: "aihb"
    },
    // AI海报
    {
        accessPath: "/copywriting",
        targetPath: "/copywriting",
        pageName: "404",
        project: "ai_copywriting_web"
    },
    // AI文案
    {
        accessPath: "/product-shoot",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    // AI商品图
    {
        accessPath: "/person-shoot",
        targetPath: "/person-shoot",
        pageName: "404",
        project: "personbg"
    },
    // 人像背景
    {
        accessPath: "/model",
        targetPath: "/model",
        pageName: "aimodel",
        project: "aimodel"
    },
    // AI模特
    {
        accessPath: "/clothes",
        targetPath: "/clothes",
        pageName: "404",
        project: "znhz"
    },
    // AI试衣
    {
        accessPath: "/recolor",
        targetPath: "/recolor",
        pageName: "ai_color_change",
        project: "ai_color_change"
    },
    // 服装换色
    {
        accessPath: "/rmwrinkle",
        targetPath: "/rmwrinkle",
        pageName: "404",
        project: "ai_rmwrinkle"
    },
    // 服装去皱
    // 海外项目现有网址
    {
        accessPath: "/ai-background-generator/edit",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    {
        accessPath: "/object-remover/edit",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    {
        accessPath: "/image-upscaler/edit",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    {
        accessPath: "/image-enhancer/edit",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    {
        accessPath: "/photo-editor/create",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    }
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (pathMappings);
var modalLocalStorageKey = "xdesign-widgets_overseasAccessModal";
var modalDomesticLocalStorageKey = "xdesign-widgets_overseasDomesticAccessModal";
var bannerLocalStorageKey = "xdesign-widgets_overseasAccessBanner";


/***/ }),

/***/ 30106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ getJumpQuery)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1082);

var jumpQuery = undefined;
/**
 * 获取跳转参数，并删除跳转参数。
 * @param notRemoveJumpParams 传入 true 时，不会删除 URL 参数
 * @returns 跳转参数
 */ var getJumpQuery = function getJumpQuery(notRemoveJumpParams) {
    if (!jumpQuery) {
        jumpQuery = {
            original_referrer: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("referrer"),
            came_from: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("came_from")
        };
        !notRemoveJumpParams && (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeUrlParameterFromAddressBar */ .k4)([
            "referrer",
            "came_from"
        ]);
    }
    return jumpQuery;
};


/***/ }),

/***/ 1082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": () => (/* binding */ getTargetsUrl),
/* harmony export */   "HJ": () => (/* binding */ rebuildForceTargetUrl),
/* harmony export */   "Ht": () => (/* binding */ setBannerShowTimer),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam),
/* harmony export */   "U3": () => (/* binding */ canShow),
/* harmony export */   "_8": () => (/* binding */ setDataInStorage),
/* harmony export */   "cs": () => (/* binding */ canShowBanner),
/* harmony export */   "dI": () => (/* binding */ formatPath),
/* harmony export */   "g7": () => (/* binding */ trackPopupClick),
/* harmony export */   "k4": () => (/* binding */ removeUrlParameterFromAddressBar),
/* harmony export */   "sD": () => (/* binding */ getTargetPath),
/* harmony export */   "vt": () => (/* binding */ trackPopupShow)
/* harmony export */ });
/* unused harmony export getTargetData */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69222);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47708);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84999);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67890);






/**
 * 获取指定localStorage key 是否存在
 */ var canShow = function canShow(key) {
    return localStorage.getItem(key) !== "true";
};
/**
 * 写入 localStorage
 */ var setDataInStorage = function setDataInStorage(key) {
    localStorage.setItem(key, "true");
};
/**
 * 写入 banner 唤醒时间
 */ var setBannerShowTimer = function setBannerShowTimer(key) {
    var expiredTime = new Date().getTime();
    localStorage.setItem(key, String(expiredTime));
};
/**
 * 判断 banner 是否还可以展示，过期时间 3 个月
 */ var canShowBanner = function canShowBanner(key) {
    var expiredTime = localStorage.getItem(key);
    if (!expiredTime) return true;
    // 3个月过期时间，如果 banner 唤醒时间 + 3 个月大于当前时间，则可以展示
    return Number(expiredTime) + 3 * 30 * 24 * 60 * 60 * 1000 > new Date().getTime();
};
var getTargetData = function getTargetData(currentPath) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.find)(_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(item) {
        return item.accessPath === currentPath || currentPath.startsWith(item.accessPath + "/");
    });
};
/**
 * 获取目标路径映射数据
 * @param currentPath
 * @returns
 */ var getTargetPath = function getTargetPath(currentPath) {
    var mapping = getTargetData(currentPath);
    return (mapping === null || mapping === void 0 ? void 0 : mapping.targetPath) || undefined;
};
var getServerJumpURL = function getServerJumpURL(url) {
    return "https://".concat((0,_utils_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)().env), "webapi.designkit.com/v1/designkitcn/redirect?redirect_url=").concat(url, "&referrer=").concat(document.referrer);
};
/**
 * 获取跳转目标连接
 */ var getTargetsUrl = function getTargetsUrl(targetPath) {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), env = _getConfig.env, appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    // 避免和其他的 key 冲突
    var query = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var prefix = env === "release" ? "www" : env;
    var url = "https://".concat(prefix, ".designkit.cn").concat(targetPath, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_4__.stringify)(query));
    return getServerJumpURL(url);
};
/**
 * 获取跳转目标连接
 */ var rebuildForceTargetUrl = function rebuildForceTargetUrl(targetUrl) {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), appName = _getConfig2.appName, isIntl = _getConfig2.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    var extraQuery = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var url = new URL(targetUrl);
    // 合并 query（不覆盖已有的同名参数）
    Object.entries(extraQuery).forEach(function(_ref) {
        var _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (value && !url.searchParams.has(key)) {
            url.searchParams.set(key, value);
        }
    });
    return getServerJumpURL(url.toString());
};
/**
 * 格式化path
 */ var formatPath = function formatPath(path) {
    // 小写
    var newPath = path.toLowerCase();
    // 去掉末尾的斜杠
    return path !== "/" && newPath.endsWith("/") ? newPath.slice(0, -1) : newPath;
};
/**
 * 弹窗曝光
 * @param track
 * @param pageName
 */ var trackPopupShow = function trackPopupShow(_ref3) {
    var track = _ref3.track, pageName = _ref3.pageName, isBanner = _ref3.isBanner, popupType = _ref3.popupType, popupName = _ref3.popupName;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_show", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic"
    });
};
/**
 * 弹窗点击
 * @param track
 * @param isJump
 * @param pageName
 */ var trackPopupClick = function trackPopupClick(_ref4) {
    var track = _ref4.track, isJump = _ref4.isJump, pageName = _ref4.pageName, popupType = _ref4.popupType, popupName = _ref4.popupName, isBanner = _ref4.isBanner;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_click", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic",
        click_type: isJump ? 1 : 0
    });
};
var removeUrlParameterFromAddressBar = function removeUrlParameterFromAddressBar(params) {
    var url = new URL(window.location.href);
    params.forEach(function(p) {
        url.searchParams.delete(p);
    });
    window.history.replaceState(null, "", url.toString());
};
var getQueryParam = function getQueryParam(key) {
    try {
        return new URLSearchParams(decodeURIComponent(window.location.search)).get(key) || "";
    } catch (e) {
        var reg = new RegExp("[?&]".concat(key, "=([^&]*)"));
        var search = decodeURIComponent(window.location.search);
        var match = search.match(reg);
        return (match ? match[1] : null) || "";
    }
};


/***/ }),

/***/ 12749:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": () => (/* binding */ fetchUserInfo),
/* harmony export */   "N1": () => (/* binding */ fetchEnterpriseConfigs),
/* harmony export */   "rm": () => (/* binding */ refreshUserRights),
/* harmony export */   "tH": () => (/* binding */ fetchAccessTokenByCode)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57526);



/**
 * Refresh user rights
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139048
 */ var refreshUserRights = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        url: "/v1/websdk/activate",
                        method: "GET"
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function refreshUserRights() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch access token by code
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139568
 * @param code - meitu account code
 * @returns
 */ var fetchAccessTokenByCode = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2(code) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "POST",
                        url: "/user/get_token_by_code",
                        params: {
                            code: code
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchAccessTokenByCode(_x) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * Check login status (use `/user/info` api)
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/116813
 * @returns - login or not
 */ var fetchUserInfo = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "GET",
                        url: "/user/info",
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchUserInfo() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 企业配置信息
 * @param oid
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/158452
 * @returns
 */ var fetchEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref4 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee4(oid) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    return _context4.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "GET",
                        // url: '/v1/websdk/get_third_authorized_info',
                        url: "/enterprise/config",
                        params: {
                            oid: oid
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchEnterpriseConfigs(_x2) {
        return _ref4.apply(this, arguments);
    };
}();


/***/ }),

/***/ 37057:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Op": () => (/* binding */ copyDirToMyTeamSpace),
  "tH": () => (/* binding */ createTeamApi),
  "bE": () => (/* binding */ fetchMemberPermission),
  "sN": () => (/* binding */ fetchTeamAdminInfo),
  "hc": () => (/* binding */ fetchTeamIdentityList),
  "Ay": () => (/* binding */ fetchTeamMemberInfo),
  "tc": () => (/* binding */ generateInvite),
  "lh": () => (/* binding */ handleDownloadRecord)
});

// UNUSED EXPORTS: fetchTeamMemberList

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(73009);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js + 1 modules
var query_string = __webpack_require__(25431);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var utils_request = __webpack_require__(57526);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/share/api/index.js




/**
 * 分享给指定成员
 * @param param
 * @returns
 */ var createShareToMember = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(_ref) {
        var uids, current_node, node_id, permissionMode, oid, formData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    uids = _ref.uids, current_node = _ref.current_node, node_id = _ref.node_id, permissionMode = _ref.permissionMode, oid = _ref.oid;
                    formData = new FormData();
                    formData.set("uids", uids.join(","));
                    if (oid) {
                        formData.set("oid", "".concat(oid));
                    }
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    _context.next = 9;
                    return request.post("/yunpan/share/to_users", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context.abrupt("return", _context.sent);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function createShareToMember(_x) {
        return _ref2.apply(this, arguments);
    };
}()));
var generateShortUrl = /*#__PURE__*/ function() {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_ref3) {
        var path, parameter, formData, headers;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    path = _ref3.path, parameter = _ref3.parameter;
                    formData = new FormData();
                    formData.set("path", path);
                    formData.set("parameter", parameter);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    _context2.next = 7;
                    return utils_request/* default.post */.ZP.post("/fs/generate_short_url", formData, {
                        headers: headers
                    });
                case 7:
                    return _context2.abrupt("return", _context2.sent);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function generateShortUrl(_x2) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * 管理员创建分享
 * @param node_id
 * @param current_node
 * @returns
 */ var createShareToOther = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(_ref5) {
        var _identity$ouid, _identity$oid;
        var current_node, node_id, oid, type, entrance, _ref5$isPersonalFolde, isPersonalFolderToTeamBiz, teamInfo, identity, formData, headers, res, parameter, _yield$generateShortU, short_url;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid, type = _ref5.type, entrance = _ref5.entrance, _ref5$isPersonalFolde = _ref5.isPersonalFolderToTeamBiz, isPersonalFolderToTeamBiz = _ref5$isPersonalFolde === void 0 ? false : _ref5$isPersonalFolde, teamInfo = _ref5.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === (oid !== null && oid !== void 0 ? oid : teamInfo.identity.oid);
                    });
                    formData = new FormData();
                    if (current_node) {
                        formData.set("current_node", current_node);
                    }
                    formData.set("node_id", node_id);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context3.next = 9;
                    return request.post("/yunpan/share/to_other", formData, {
                        headers: headers
                    });
                case 9:
                    res = _context3.sent;
                    // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key, "&").concat(type === "folder" ? "current_node_type" : "editorType", "=").concat(type, "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context3.next = 14;
                    return generateShortUrl({
                        path: isPersonalFolderToTeamBiz || type !== "folder" ? "design/share" : "share",
                        parameter: parameter
                    });
                case 14:
                    _yield$generateShortU = _context3.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context3.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 17:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function createShareToOther(_x3) {
        return _ref6.apply(this, arguments);
    };
}()));
/** 获取分享详情 */ /** 获取分享详情及短链 */ function fetchShareInfo(_x4) {
    return _fetchShareInfo.apply(this, arguments);
}
/**
 * 协作者列表
 * @param
 * @returns
 */ function _fetchShareInfo() {
    _fetchShareInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee7(arg) {
        var _identity$ouid2, _identity$oid2;
        var res, _ref12, type, entrance, teamInfo, identity, parameter, _yield$generateShortU2, short_url;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return request.get("/yunpan/share/get_share_other", {
                        params: {
                            id: arg.shareOtherId
                        }
                    });
                case 2:
                    res = _context7.sent;
                    if (!(Object.keys(arg).length === 1 && Object.keys(arg)[0] === "shareOtherId")) {
                        _context7.next = 5;
                        break;
                    }
                    return _context7.abrupt("return", res);
                case 5:
                    _ref12 = arg, type = _ref12.type, entrance = _ref12.entrance, teamInfo = _ref12.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    }); // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key).concat(type === "folder" ? "" : "&editorType=".concat(type), "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid2 = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid2 !== void 0 ? _identity$ouid2 : "unknown",
                        oid: (_identity$oid2 = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid2 !== void 0 ? _identity$oid2 : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context7.next = 11;
                    return generateShortUrl({
                        path: type === "folder" ? "share" : "design/share",
                        parameter: parameter
                    });
                case 11:
                    _yield$generateShortU2 = _context7.sent;
                    short_url = _yield$generateShortU2.short_url;
                    return _context7.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 14:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _fetchShareInfo.apply(this, arguments);
}
var fetchCollaborator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(currentNode, nodeId) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return request.get("/yunpan/share/collaborator?current_node=".concat(currentNode, "&node_id=").concat(nodeId));
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchCollaborator(_x5, _x6) {
        return _ref7.apply(this, arguments);
    };
}()));
/**
 * 设置协作者权限
 * @param param
 * @returns
 */ var setCollaboratorPermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee5(_ref8) {
        var nodeId, currentNode, permissionMode, uid, askPermissionId, formData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    nodeId = _ref8.nodeId, currentNode = _ref8.currentNode, permissionMode = _ref8.permissionMode, uid = _ref8.uid, askPermissionId = _ref8.askPermissionId;
                    formData = new FormData();
                    formData.set("node_id", "".concat(nodeId));
                    formData.set("current_node", currentNode);
                    formData.set("uid", "".concat(uid));
                    formData.set("permission_mode", "".concat(permissionMode));
                    if (askPermissionId) {
                        formData.set("ask_permission_id", "".concat(askPermissionId));
                    }
                    _context5.next = 9;
                    return request.post("/yunpan/share/set_collaborator_permission", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context5.abrupt("return", _context5.sent);
                case 10:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function setCollaboratorPermission(_x7) {
        return _ref9.apply(this, arguments);
    };
}()));
/**
 * 设置分享的权限
 * @param param
 * @returns
 */ var setSharePermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee6(_ref10) {
        var current_node, node_id, permissionMode, userType, oid, formData, headers;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    current_node = _ref10.current_node, node_id = _ref10.node_id, permissionMode = _ref10.permissionMode, userType = _ref10.userType, oid = _ref10.oid;
                    formData = new FormData();
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    formData.set("user_type", userType || "");
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context6.next = 10;
                    return request.post("/yunpan/share/set_permission", formData, {
                        headers: headers
                    });
                case 10:
                    return _context6.abrupt("return", _context6.sent);
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function setSharePermission(_x8) {
        return _ref11.apply(this, arguments);
    };
}()));
/** 个人版移除所有人，团队版移除团队之外的人 */ var removeAllCollaborator = function removeAllCollaborator(data) {
    var formData = new FormData();
    formData.set("current_node", data.current_node);
    formData.set("node_id", "".concat(data.node_id));
    return request.post("/yunpan/share/remove_all_collaborator", formData, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js




var _excluded = [
    "teamInfo",
    "entrance"
];



// 多次请求合并成一次
var fetchTeamIdentityListResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/145971
 * [团队]可选身份列表
 */ var fetchTeamIdentityList = function fetchTeamIdentityList() {
    return new Promise(function(resolve, reject) {
        fetchTeamIdentityListResolveList.push(resolve);
        if (fetchTeamIdentityListResolveList.length === 1) {
            utils_request/* default.get */.ZP.get("/enterprise/identity_list", {
                hiddenMessage: true
            }).then(function(data) {
                // 处理个人设计师显示昵称
                data.list.forEach(function(item) {
                    if (!item.oid) {
                        item.alias = "个人设计师";
                    }
                });
                for(var i = 0; i < fetchTeamIdentityListResolveList.length; i++){
                    var element = fetchTeamIdentityListResolveList[i];
                    element(data);
                }
                fetchTeamIdentityListResolveList.length = 0;
            // console.log(
            //   'fetchTeamIdentityList',
            //   fetchTeamIdentityListResolveList.length,
            // );
            }).catch(function(e) {
                fetchTeamIdentityListResolveList.length = 0;
                reject(e);
            });
        }
    });
};
var fetchTeamMemberInfoResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/149033
 * [团队]获取我的成员信息
 */ var fetchTeamMemberInfo = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", new Promise(function(resolve) {
                        fetchTeamMemberInfoResolveList.push(resolve);
                        if (fetchTeamMemberInfoResolveList.length === 1) {
                            utils_request/* default.get */.ZP.get("/enterprise/team/member_info", {
                                hiddenMessage: true
                            }).then(function(res) {
                                for(var i = 0; i < fetchTeamMemberInfoResolveList.length; i++){
                                    var element = fetchTeamMemberInfoResolveList[i];
                                    element(res);
                                }
                                fetchTeamMemberInfoResolveList.length = 0;
                            });
                        }
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchTeamMemberInfo() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 团队信息
 * @returns
 */ var fetchTeamAdminInfo = /*#__PURE__*/ function() {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return utils_request/* default.get */.ZP.get("/enterprise/team/info", {});
                case 2:
                    return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchTeamAdminInfo() {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * [团队]获取我成员列表
 */ var fetchTeamMemberList = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return request.get("/enterprise/team/member_list", {
                        hiddenMessage: true
                    });
                case 2:
                    return _context3.abrupt("return", _context3.sent);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchTeamMemberList() {
        return _ref3.apply(this, arguments);
    };
}()));
/**
 * [团队]创建团队 https://api-mock.meitu-int.com/project/2110/interface/api/145974
 * @param data
 * @returns
 */ var createTeamApi = /*#__PURE__*/ function() {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee4(data) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/create", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function createTeamApi(_x) {
        return _ref4.apply(this, arguments);
    };
}();
/** 复制个人版指定文件到团队版个人空间下 https://api-mock.meitu-int.com/project/2110/interface/api/163078 */ var copyDirToMyTeamSpace = /*#__PURE__*/ function() {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee5(_ref5) {
        var current_node, node_id, oid;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid;
                    _context5.next = 3;
                    return utils_request/* default.post */.ZP.post("/yunpan/node/copy_to_my_space", query_string["default"].stringify({
                        current_node: current_node,
                        id: node_id
                    }), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "client-ogroupid": oid,
                            "client-oid": oid
                        }
                    });
                case 3:
                    return _context5.abrupt("return", _context5.sent);
                case 4:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function copyDirToMyTeamSpace(_x2) {
        return _ref6.apply(this, arguments);
    };
}();
/**
 * [团队]生成邀请码 https://api-mock.meitu-int.com/project/2110/interface/api/146100
 * @returns
 */ var generateInvite = /*#__PURE__*/ function() {
    var _ref8 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee6(_ref7) {
        var _identity$ouid, _identity$oid;
        var teamInfo, entrance, data, res, identity, parameter, _yield$generateShortU, short_url;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    teamInfo = _ref7.teamInfo, entrance = _ref7.entrance, data = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded);
                    _context6.next = 3;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/generate_inviate_key", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 3:
                    res = _context6.sent;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    });
                    parameter = "inviteKey=".concat(res.invite_key, "&channel=member_invite&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    _context6.next = 8;
                    return generateShortUrl({
                        path: "",
                        parameter: parameter
                    });
                case 8:
                    _yield$generateShortU = _context6.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context6.abrupt("return", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function generateInvite(_x3) {
        return _ref8.apply(this, arguments);
    };
}();
/**
 * 接口 [上报下载资源↗](/common/sensitive_check)
 * https://api-mock.meitu-int.com/project/2110/interface/api/175621
 */ var handleDownloadRecord = /*#__PURE__*/ function() {
    var _ref9 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee7(data) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return utils_request/* default.post */.ZP.post("/zhanku/download_record", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context7.abrupt("return", _context7.sent);
                case 3:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return function handleDownloadRecord(_x4) {
        return _ref9.apply(this, arguments);
    };
}();
/**
 * [团队]获取我的权限
 * https://api-mock.meitu-int.com/project/2110/interface/api/146159
 */ var fetchMemberPermission = function fetchMemberPermission() {
    return utils_request/* default.get */.ZP.get("/enterprise/team/member_permissions", {
        hiddenMessage: true
    });
};


/***/ }),

/***/ 6310:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": () => (/* binding */ openCreateTeamModal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(56369);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(73009);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var render = __webpack_require__(24996);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/cls.js
var cls = __webpack_require__(51811);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/button/index.less
var ComUI_button = __webpack_require__(364);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/button/index.js


var _excluded = [
    "className",
    "icon",
    "type",
    "htmlType",
    "size",
    "children"
];




var subPrefix = "Button";
var cls$ = (0,cls/* default */.ZP)(subPrefix);
var Button = /*#__PURE__*/ react.forwardRef(function(_ref, ref) {
    var _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, icon = _ref.icon, _ref$type = _ref.type, type = _ref$type === void 0 ? "default" : _ref$type, _ref$htmlType = _ref.htmlType, htmlType = _ref$htmlType === void 0 ? "button" : _ref$htmlType, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, children = _ref.children, restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
    return /*#__PURE__*/ react.createElement("button", (0,esm_extends/* default */.Z)({
        /* eslint-disable-next-line react/button-has-type */ type: htmlType,
        className: classnames_default()(cls$(), className),
        "data-type": type,
        "data-size": size
    }, restProps, {
        ref: ref
    }), icon, /*#__PURE__*/ react.createElement("div", {
        className: cls$("children")
    }, children));
});
/* harmony default export */ const dist_ComUI_button = (Button);

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js + 44 modules
var utils = __webpack_require__(33989);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/createModal/index.less
var createModal = __webpack_require__(39618);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/createModal/index.js



var createModal_excluded = [
    "onClose"
];











var BannerImage = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/create-modal-banner.png";
var CreateTeamModal = function CreateTeamModal(_ref) {
    var _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, noSwitchIdentity = _ref.noSwitchIdentity, create_team_success_entrance = _ref.create_team_success_entrance, onCreatedComplete = _ref.onCreatedComplete, onClose = _ref.onClose, onTrack = _ref.onTrack;
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), userInfo = _useConfig.userInfo;
    var inputRef = (0,react.useRef)();
    var _useState = (0,react.useState)(""), _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2), teamName = _useState2[0], setTeamName = _useState2[1];
    var isPending = (0,react.useRef)(false);
    var maxTeamNameLength = 21;
    (0,react.useEffect)(function() {
        var _inputRef$current;
        setTeamName("");
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }, []);
    (0,react.useEffect)(function() {
        if (!userInfo.screen_name) return;
        setTeamName("".concat(userInfo.screen_name, "的团队"));
    }, [
        userInfo.screen_name
    ]);
    ;
    var createHandle = function createHandle() {
        if (!teamName) {
            return message/* default.error */.Z.error("请填写完整团队信息");
        }
        if (teamName.length >= maxTeamNameLength) {
            return message/* default.error */.Z.error("请填输入20字内的团队/企业名称");
        }
        if (isPending.current) return;
        isPending.current = true;
        (0,utils/* createTeam */.Cm)({
            teamName: teamName
        }).then(function(res) {
            onTrack === null || onTrack === void 0 || onTrack("create_team_success", {
                entrance: create_team_success_entrance !== null && create_team_success_entrance !== void 0 ? create_team_success_entrance : "create_team_1",
                project: project,
                team_name: teamName,
                newcreate_oid: res.oid,
                newcreate_uid: res.ouid
            });
            onCreatedComplete === null || onCreatedComplete === void 0 || onCreatedComplete({
                group_id: res.groupId,
                oid: res.oid,
                ouid: res.ouid,
                team_name: res.teamName
            });
            message/* default.success */.Z.success("创建成功");
            // 会员弹窗关闭时回调函数
            onClose === null || onClose === void 0 || onClose();
            if (!noSwitchIdentity) {
                (0,teamInfo/* changeIdentity */.vv)({
                    ouid: res.ouid,
                    oid: res.oid,
                    groupId: res.groupId
                });
            }
        }).finally(function() {
            isPending.current = false;
            ;
        });
    };
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        open: true,
        destroyOnClose: true,
        className: "Widget teamSpaceCreateModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-inner"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: onClose
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-banner"
    }, /*#__PURE__*/ react.createElement("img", {
        src: BannerImage,
        alt: ""
    })), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-form"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-formTitle"
    }, "创建团队"), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-formLabel"
    }, "团队名称"), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("teamSpaceCreateModal-input", {
            warn: teamName.length >= maxTeamNameLength
        })
    }, /*#__PURE__*/ react.createElement("input", {
        value: teamName,
        ref: inputRef,
        placeholder: "请输入团队名称",
        type: "text",
        maxLength: maxTeamNameLength,
        onChange: function onChange(e) {
            setTeamName(e.target.value);
        }
    })), /*#__PURE__*/ react.createElement(dist_ComUI_button, {
        type: "primary",
        style: {
            marginTop: 32,
            height: 48,
            fontSize: 16
        },
        onClick: function onClick() {
            createHandle();
        }
    }, "免费创建"), /*#__PURE__*/ react.createElement("p", {
        className: "teamSpaceCreateModal-renameTip"
    }, "团队名称可随时修改"))));
};
CreateTeamModal.displayName = "CreateTeamModal";
var el = null;
CreateTeamModal.open = function(_ref2) {
    var _onClose = _ref2.onClose, restProps = (0,objectWithoutProperties/* default */.Z)(_ref2, createModal_excluded);
    if (!el) {
        el = document.createElement("div");
    }
    document.body.appendChild(el);
    (0,render/* render */.sY)(/*#__PURE__*/ react.createElement(CreateTeamModal, (0,esm_extends/* default */.Z)({}, restProps, {
        onClose: function onClose() {
            if (el && el.parentNode) {
                (0,render/* unmount */.vE)(el);
                el.parentNode.removeChild(el);
                el = null;
            }
            _onClose === null || _onClose === void 0 || _onClose();
        }
    })), el);
};
var openCreateTeamModal = CreateTeamModal.open;


/***/ }),

/***/ 40769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c7": () => (/* binding */ HIDE_EXPIRED_MODAL),
  "e1": () => (/* binding */ SHOW_EXPIRED_MODAL),
  "ZP": () => (/* binding */ teamInfo_expiredModal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var enum_EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var enum_EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
var enum_CloseFromEnum = /*#__PURE__*/function (CloseFromEnum) {
  CloseFromEnum["PAYSUCCESS"] = "pay-success";
  CloseFromEnum["UNLOGIN"] = "unLogin";
  CloseFromEnum["CLOSE"] = "close";
  return CloseFromEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var lib_SaasSubscription = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false, CloseFromEnum.UNLOGIN);
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false, CloseFromEnum.PAYSUCCESS);
        }
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var queryString = Object.keys(params).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(params[key] || "", "&");
      }, "");
      var preHost = "";
      if (/\.meitu\.com/.test(window.location.host) || /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://prepc.meitu.com";
            break;
          case EnvEnum.BETA:
            preHost = "https://beta-pc.meitu.com";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://pc.meitu.com";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://prepc.meitu.com";
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function () {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = "saas-subscription-popup ".concat(_this.theme);
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png";
      eleClose.onclick = function () {
        var _window;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem("uid");
        if (uid) (_window = window) === null || _window === void 0 || (_window = _window.mtstat) === null || _window === void 0 || _window.login(uid);
        _this.close();
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 || _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe = _this.eleIframe) === null || _this$eleIframe === void 0 || (_this$eleIframe = _this$eleIframe.contentWindow) === null || _this$eleIframe === void 0 || _this$eleIframe.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 || _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 || _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      console.log(otherParams, "otherParams=========");
      if (!this.ele) {
        this.createDialog();
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
      }
      if (this.ele) {
        document.body.appendChild(this.ele);
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CloseFromEnum.CLOSE;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler(from);
      }
      if (this.ele) {
        document.body.removeChild(this.ele);
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = "saas-subscription-popup ".concat(this.theme);
      }
    }
  }]);
  return SaasSubscription;
}()));
/* harmony default export */ const lib = ((/* unused pure expression or super */ null && (lib_SaasSubscription)));
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/**
 * 订阅弹窗样式
 */
var constants_dialogCss = "\n  .saas-subscription-popup {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #fff;\n    position: relative;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #1C1D1F;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  @media screen and (max-height: 620px) {\n    .saas-subscription-popup {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n";

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var constants_retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var constants_SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var utils_openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [["智能抠图", false, "1200张/年", "100张*席位数/月"], ["会员美豆", false, "120个/月", "120个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248SVIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5488/\u5E74\u8D77</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = ((/* unused pure expression or super */ null && (SaasSubscription)));
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var xdesign_identity_lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/eventBus.js
var eventBus = __webpack_require__(77724);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.less
var expiredModal = __webpack_require__(48674);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.js














var vipConfig = [
    {
        iconName: "VipBold",
        text: "畅享SVIP权益"
    },
    {
        iconName: "UserGroupBold",
        text: "团队权限管理"
    },
    {
        iconName: "FolderBold",
        text: "成员文件夹协作"
    }
];
var SHOW_EXPIRED_MODAL = "xdesign-widget-show-expired-modal";
var HIDE_EXPIRED_MODAL = "xdesign-widget-hide-expired-modal";
/**
 * 团队过期提示
 */ var ExpiredModal = function ExpiredModal(props) {
    var identityList = props.identityList;
    var showData = (0,react.useRef)({
        entrance: ""
    });
    var _useState = (0,react.useState)(false), _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), isIntl = _useConfig.isIntl, theme = _useConfig.theme;
    var curTeamIdentity = (0,dist_teamInfo/* useCurrentTeamIdentity */.q5)();
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-dark.png
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-light.png
    // https://x-design-static-release.stariicloud.com/xdesign-widgets/expired-modal-light.png
    var domain = isIntl ? "https://x-design-static-release.stariicloud.com/xdesign-widgets/" : "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/";
    function getStatArgs() {
        return {
            popup_type: "expire",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 || _showData$current$onT.call(_showData$current, "popup_click", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        eventBus/* default.addListener */.Z.addListener(SHOW_EXPIRED_MODAL, onShowHandle);
        eventBus/* default.addListener */.Z.addListener(HIDE_EXPIRED_MODAL, onHideHandle);
        return function() {
            eventBus/* default.removeListener */.Z.removeListener(SHOW_EXPIRED_MODAL, onShowHandle);
            eventBus/* default.removeListener */.Z.removeListener(HIDE_EXPIRED_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cancel";
        setOpen(false);
        popupClickTrack(className);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current2;
        setOpen(false);
        (_showData$current$onO = (_showData$current2 = showData.current).onOK) === null || _showData$current$onO === void 0 || _showData$current$onO.call(_showData$current2, "expire_popup");
        popupClickTrack("renew_now");
    };
    (0,react.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current3;
            ;
            (_showData$current$onT2 = (_showData$current3 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 || _showData$current$onT2.call(_showData$current3, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "Widget teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: function onClick() {
            var _showData$current$onC, _showData$current4;
            closeHandle();
            (_showData$current$onC = (_showData$current4 = showData.current).onClose) === null || _showData$current$onC === void 0 || _showData$current$onC.call(_showData$current4, showData.current.entrance);
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular,#8cc0ff)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "title"
    }, "当前团队已过期"), /*#__PURE__*/ react.createElement("div", {
        className: "description"
    }, "若需正常使用请续费升级"), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("card", "card-".concat(theme)),
        style: {
            backgroundImage: "url(".concat("".concat(domain, "expired-bg-").concat(theme, ".png"), ")")
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, "VIP团队版权益", /*#__PURE__*/ react.createElement("span", {
        onClick: function onClick() {
            utils_openVipComparePopup();
        // closeHandle('view');
        }
    }, "查看详细权益", /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 12,
        name: "ChevronRightBold",
        color: "#35395D"
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "body"
    }, vipConfig.map(function(item, key) {
        return /*#__PURE__*/ react.createElement("div", {
            className: "item",
            key: key
        }, /*#__PURE__*/ react.createElement("div", {
            className: "text"
        }, item.text));
    }))), (0,dist_teamInfo/* getEnterpriseID */.DG)() ? null : /*#__PURE__*/ react.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react.createElement("div", {
        className: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "ok" : "cancel",
        onClick: function onClick() {
            var info = identityList === null || identityList === void 0 ? void 0 : identityList.find(function(item) {
                return item.oid === 0;
            });
            if (info) {
                (0,uidKit/* setLocalUid */.Tc)(info.ouid);
            }
            // 标识一定要前置
            (0,dist_teamInfo/* changeIsSwitchIdentityInitiativeState */._U)(true);
            closeHandle();
            (0,xdesign_identity_lib/* setLocalIdentity */.kF)(0, 0);
        },
        style: {
            width: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "100%" : ""
        }
    }, "切换个人版"), (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? null : /*#__PURE__*/ react.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, "立即续费"))));
};
/* harmony default export */ const teamInfo_expiredModal = (/*#__PURE__*/react.memo(ExpiredModal));


/***/ }),

/***/ 72715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "hP": () => (/* binding */ SHOW_FREEZE_MODAL),
/* harmony export */   "sW": () => (/* binding */ HIDE_FREEZE_MODAL)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74107);
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40451);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77724);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50072);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);







var SHOW_FREEZE_MODAL = "xdesign-widget-show-freeze-modal";
var HIDE_FREEZE_MODAL = "xdesign-widget-hide-freeze-modal";
/**
 * 个人冻结
 */ var FreezeModal = function FreezeModal() {
    var showData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        entrance: ""
    });
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    function getStatArgs() {
        return {
            popup_type: "freeze",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 || _showData$current$onT.call(_showData$current, "popup_click", (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_4__/* ["default"].addListener */ .Z.addListener(SHOW_FREEZE_MODAL, onShowHandle);
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_4__/* ["default"].addListener */ .Z.addListener(HIDE_FREEZE_MODAL, onHideHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeListener */ .Z.removeListener(SHOW_FREEZE_MODAL, onShowHandle);
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeListener */ .Z.removeListener(HIDE_FREEZE_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var _showData$current$onC, _showData$current2;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onC = (_showData$current2 = showData.current).onClose) === null || _showData$current$onC === void 0 || _showData$current$onC.call(_showData$current2, showData.current.entrance);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current3;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onO = (_showData$current3 = showData.current).onOK) === null || _showData$current$onO === void 0 || _showData$current$onO.call(_showData$current3, showData.current.entrance);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current4;
            (_showData$current$onT2 = (_showData$current4 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 || _showData$current$onT2.call(_showData$current4, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "Widget teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "close",
        onClick: closeHandle
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary, rgba(147, 149, 153, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular, rgba(140, 192, 255, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "title"
    }, "你已被冻结"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "description"
    }, "当前成员数量超过上限", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null), "若需正常使用请联系团队所有者"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, "我知道了"))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(FreezeModal));


/***/ }),

/***/ 67721:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ getTeamTagType)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32485);
/* harmony import */ var _teamTag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98053);


/** 获取团队标签 */ function getTeamTagType(oid, type) {
    if (oid === 0) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.personal */ .n.personal;
    if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .IdentityType.TEAM */ .Mf.TEAM) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.team */ .n.team;
    if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .IdentityType.ENTERPRISE */ .Mf.ENTERPRISE) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.enterprise */ .n.enterprise;
    return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.free */ .n.free;
}


/***/ }),

/***/ 46718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": () => (/* binding */ getIsSwitchIdentityInitiative),
/* harmony export */   "DG": () => (/* binding */ getEnterpriseID),
/* harmony export */   "Gl": () => (/* binding */ openTeamFreezePopup),
/* harmony export */   "I3": () => (/* binding */ closeTeamFreezePopup),
/* harmony export */   "Iu": () => (/* binding */ getTeamInfo),
/* harmony export */   "O$": () => (/* binding */ checkTeamHadBuyVip),
/* harmony export */   "P3": () => (/* binding */ enterpriseInit),
/* harmony export */   "Qn": () => (/* binding */ closeTeamExpiredPopup),
/* harmony export */   "SN": () => (/* binding */ findTeamIdentity),
/* harmony export */   "Uy": () => (/* binding */ CHANGE_TEAM_OID),
/* harmony export */   "VF": () => (/* binding */ getCurrentTeamIdentity),
/* harmony export */   "VT": () => (/* binding */ closeIdentitySwitchPopup),
/* harmony export */   "Yr": () => (/* binding */ useHasFetchTeamInfoState),
/* harmony export */   "Yt": () => (/* binding */ checkTeamIsEnterprise),
/* harmony export */   "_U": () => (/* binding */ changeIsSwitchIdentityInitiativeState),
/* harmony export */   "b6": () => (/* binding */ isFromZhanKu),
/* harmony export */   "bl": () => (/* binding */ clearTeamInfo),
/* harmony export */   "fM": () => (/* binding */ useTeamInfoState),
/* harmony export */   "gS": () => (/* binding */ checkUserHasSeat),
/* harmony export */   "gm": () => (/* binding */ getIdentityChangeListenerStatus),
/* harmony export */   "hU": () => (/* binding */ checkIsTeam),
/* harmony export */   "hf": () => (/* binding */ checkTeamMemberState),
/* harmony export */   "kA": () => (/* binding */ openTeamExpiredPopup),
/* harmony export */   "lz": () => (/* binding */ openIdentitySwitchPopupAfterLogin),
/* harmony export */   "mP": () => (/* binding */ checkMemberIsResigned),
/* harmony export */   "mR": () => (/* binding */ fetchTeamInfo),
/* harmony export */   "od": () => (/* binding */ openIdentitySwitchPopup),
/* harmony export */   "q5": () => (/* binding */ useCurrentTeamIdentity),
/* harmony export */   "rM": () => (/* binding */ checkTeamStatusIsFree),
/* harmony export */   "sr": () => (/* binding */ enableIdentityChangeListener),
/* harmony export */   "t2": () => (/* binding */ disableIdentityChangeListener),
/* harmony export */   "vn": () => (/* binding */ checkUserSeatIsFreeze),
/* harmony export */   "vv": () => (/* binding */ changeIdentity),
/* harmony export */   "zb": () => (/* binding */ checkTeamStatusIsVip)
/* harmony export */ });
/* unused harmony export __unsafeSetTeamInfoForDemo */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69222);
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87406);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10275);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97303);
/* harmony import */ var _utils_uidKit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83642);
/* harmony import */ var _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32485);
/* harmony import */ var _utils_browserKit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11747);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77724);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37057);
/* harmony import */ var _expiredModal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40769);
/* harmony import */ var _freezeModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72715);
/* harmony import */ var _loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65229);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33989);

















/** @deprecated TODO: 过渡防止其他人本地使用报错, 下个版本去掉 (不需要从这导出, 根目录导出即可) */ 
var teamInfoData = null;
// 标识是否该项目是否用户主动切换身份动作
var isSwitchIdentityInitiative = false;
/** 标识是否该项目是否用户主动切换身份动作 */ var getIsSwitchIdentityInitiative = function getIsSwitchIdentityInitiative() {
    return isSwitchIdentityInitiative;
};
// 用来控制业务是否开启身份变化监听回掉
var identityChangeListenerStatus = false;
/** 用来控制业务是否开启身份变化监听回掉 */ var getIdentityChangeListenerStatus = function getIdentityChangeListenerStatus() {
    return identityChangeListenerStatus;
};
var hasFetchTeamInfo = false;
// 刷新是否获取团队信息状态事件
var REFRESH_FETCH_TEAM_INFO_STATUS = "xdesign-widget-refresh-fetch-team-info-status";
// 刷新团队信息事件
var REFRESH_TEAM_INFO = "xdesign-widget-refresh-team-info";
// 团队身份变更事件
var CHANGE_TEAM_OID = "xdesign-widget-change-team-oid";
// 开启身份变化监听
var enableIdentityChangeListener = function enableIdentityChangeListener() {
    identityChangeListenerStatus = true;
};
// 关闭身份变化监听
var disableIdentityChangeListener = function disableIdentityChangeListener() {
    identityChangeListenerStatus = false;
};
var changeIsSwitchIdentityInitiativeState = function changeIsSwitchIdentityInitiativeState(val) {
    isSwitchIdentityInitiative = val;
};
// 定制企业sso授权相关逻辑初始化
var enterpriseInit = _utils__WEBPACK_IMPORTED_MODULE_3__/* .init */ .S1;
// 获取enterprise企业标识
var getEnterpriseID = function getEnterpriseID() {
    var enterpriseID = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEnterpriseIDKey */ .bo)()) || "";
    return enterpriseID;
};
// 是否来自站酷的团队
var isFromZhanKu = function isFromZhanKu() {
    var _getLocalIdentity;
    return !!((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) !== null && _getLocalIdentity !== void 0 && _getLocalIdentity.oid) && getEnterpriseID() === "zhanku";
};
/** 刷新团队信息 */ var fetchTeamInfo = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee() {
        var local, changeIdentity, _local3, userIdentity, identity, identityPersonal, teamMember, _local4;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                    changeIdentity = false;
                    if (!local) {
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0, false);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    ;
                    _context.prev = 4;
                    _context.next = 7;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .fetchTeamIdentityList */ .hc)();
                case 7:
                    userIdentity = _context.sent;
                    identity = userIdentity.list.find(function(v) {
                        var _local;
                        return v.oid === ((_local = local) === null || _local === void 0 ? void 0 : _local.oid) && !!v.groups.find(function(k) {
                            var _local2;
                            return k.id === ((_local2 = local) === null || _local2 === void 0 ? void 0 : _local2.groupId);
                        });
                    }); // 个人身份数据
                    identityPersonal = userIdentity.list.find(function(v) {
                        return v.oid === 0;
                    });
                    if (!((_local3 = local) !== null && _local3 !== void 0 && _local3.oid)) {
                        _context.next = 14;
                        break;
                    }
                    _context.next = 13;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .fetchTeamMemberInfo */ .Ay)();
                case 13:
                    teamMember = _context.sent;
                case 14:
                    // 离职身份需要停留在当前页面, 不做身份切换
                    if (!identity) {
                        identityPersonal && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .setLocalUid */ .Tc)(identityPersonal.ouid);
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    teamInfoData = {
                        identity: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, local), userIdentity),
                        member: teamMember
                    };
                    _context.next = 28;
                    break;
                case 18:
                    _context.prev = 18;
                    _context.t0 = _context["catch"](4);
                    ;
                    // 页面跳转时, safari会中断请求, 并抛出异常, 这里不能将身份进行切换
                    if (!(0,_utils_browserKit__WEBPACK_IMPORTED_MODULE_9__/* .checkIsBeforeUnload */ .OF)()) {
                        _context.next = 23;
                        break;
                    }
                    return _context.abrupt("return");
                case 23:
                    teamInfoData = null;
                    ;
                    (// 如果团队身份列表接口挂了，当前身份角色非本人的话，需要移除本地uid
                    (_local4 = local) === null || _local4 === void 0 ? void 0 : _local4.oid) && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalUid */ .Yz)();
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setMemoryIdentity */ .LW)(0, 0);
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0, false);
                case 28:
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, teamInfoData);
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_FETCH_TEAM_INFO_STATUS);
                    hasFetchTeamInfo = true;
                    if (changeIdentity && teamInfoData && teamInfoData.identity.list.length >= 2) {
                        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(CHANGE_TEAM_OID);
                    }
                case 32:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                18
            ]
        ]);
    }));
    return function fetchTeamInfo() {
        return _ref.apply(this, arguments);
    };
}();
/** 获取团队信息 */ var getTeamInfo = function getTeamInfo() {
    return teamInfoData;
};
/**
 * 仅供仓库内部 demo / 测试使用，直接注入团队信息状态，避免依赖真实接口返回。
 */ var __unsafeSetTeamInfoForDemo = function __unsafeSetTeamInfoForDemo(data) {
    teamInfoData = data;
    hasFetchTeamInfo = true;
    if (data) {
        setLocalIdentity(data.identity.oid, data.identity.groupId, false);
        var currentIdentity = data.identity.list.find(function(item) {
            var _item$groups$;
            return item.oid === data.identity.oid && ((_item$groups$ = item.groups[0]) === null || _item$groups$ === void 0 ? void 0 : _item$groups$.id) === data.identity.groupId;
        });
        if (typeof (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.ouid) === "number") {
            setLocalUid(currentIdentity.ouid);
        }
    }
    eventBus.emit(REFRESH_TEAM_INFO, teamInfoData);
    eventBus.emit(REFRESH_FETCH_TEAM_INFO_STATUS);
};
/** 获取团队信息hook */ var useTeamInfoState = function useTeamInfoState() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(teamInfoData), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useState, 2), data = _useState2[0], setData = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var refreshHandle = function refreshHandle(e) {
            setData(e);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addListener */ .Z.addListener(REFRESH_TEAM_INFO, refreshHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeListener */ .Z.removeListener(REFRESH_TEAM_INFO, refreshHandle);
        };
    }, []);
    return data;
};
// 是否请求过团队信息接口标识
var useHasFetchTeamInfoState = function useHasFetchTeamInfoState() {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(hasFetchTeamInfo), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleFn = function handleFn() {
            setStatus(true);
            hasFetchTeamInfo = true;
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addListener */ .Z.addListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeListener */ .Z.removeListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        };
    }, []);
    return status;
};
/** 查找指定的团队身份 */ function findTeamIdentity(oid, groupId, teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return usedTeamInfo.identity.list.find(function(v) {
        return v.oid === oid && v.groups[0].id === groupId;
    });
}
/** 获取当前团队的身份信息 */ function useCurrentTeamIdentity() {
    var teamInfo = useTeamInfoState();
    if (!teamInfo) return null;
    return findTeamIdentity(teamInfo.identity.oid, teamInfo.identity.groupId);
}
/** 获取当前团队的身份信息 */ function getCurrentTeamIdentity(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return findTeamIdentity(usedTeamInfo.identity.oid, usedTeamInfo.identity.groupId);
}
/** 打开团队过期弹窗 */ var openTeamExpiredPopup = function openTeamExpiredPopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_12__/* .SHOW_EXPIRED_MODAL */ .e1, args);
};
/** 关闭团队过期弹窗 */ var closeTeamExpiredPopup = function closeTeamExpiredPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_12__/* .HIDE_EXPIRED_MODAL */ .c7);
};
/** 打开团队冻结弹窗 */ var openTeamFreezePopup = function openTeamFreezePopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_FREEZE_MODAL */ .hP, args);
};
/** 关闭团队冻结弹窗 */ var closeTeamFreezePopup = function closeTeamFreezePopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_13__/* .HIDE_FREEZE_MODAL */ .sW);
};
/** 打开身份切换弹窗 */ var openIdentitySwitchPopup = function openIdentitySwitchPopup(opts) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, opts !== null && opts !== void 0 ? opts : {});
};
/** 关闭身份切换弹窗 */ var closeIdentitySwitchPopup = function closeIdentitySwitchPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM);
};
/** 检测当前成员是否已离职 */ var checkMemberIsResigned = function checkMemberIsResigned(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.job_status === 2;
};
/** 检测个人是否冻结 */ function checkUserSeatIsFreeze(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return !checkMemberIsResigned(usedTeamInfo) && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .TeamSeatStatus.Freeze */ .cc.Freeze;
}
/** 检测个人是否有席位 */ function checkUserHasSeat(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.has_seat && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .TeamSeatStatus.Effect */ .cc.Effect;
}
var checkIsTeam = function checkIsTeam(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && usedTeamInfo.identity.oid);
};
var checkTeamIsEnterprise = function checkTeamIsEnterprise(teamInfo) {
    var _getLocalIdentity2;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return false;
    var oid = (_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid;
    if (!oid) return false;
    var identity = usedTeamInfo.identity.list.find(function(item) {
        return item.oid === oid;
    });
    return (identity === null || identity === void 0 ? void 0 : identity.type) === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .IdentityType.ENTERPRISE */ .Mf.ENTERPRISE;
};
/** 检测团队状态是否为vip */ function checkTeamStatusIsVip(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.team.is_vip;
}
var checkTeamStatusIsFree = function checkTeamStatusIsFree(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !checkTeamStatusIsVip(usedTeamInfo) && !checkTeamIsEnterprise(usedTeamInfo);
};
var checkTeamHadBuyVip = function checkTeamHadBuyVip(teamInfo) {
    var _usedTeamInfo$member;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && (_usedTeamInfo$member = usedTeamInfo.member) !== null && _usedTeamInfo$member !== void 0 && _usedTeamInfo$member.team.had_buy);
};
/** 清空团队数据 */ function clearTeamInfo() {
    closeTeamExpiredPopup();
    closeTeamFreezePopup();
    teamInfoData = null;
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, null);
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalIdentity */ .mK)();
}
/** 切换个人/团队身份 */ var changeIdentity = function changeIdentity(identity) {
    var _teamInfo$identity$oi, _teamInfo$identity$gr;
    var teamInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTeamInfo();
    var currentOid = (_teamInfo$identity$oi = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid) !== null && _teamInfo$identity$oi !== void 0 ? _teamInfo$identity$oi : 0;
    var currentGroupId = (_teamInfo$identity$gr = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId) !== null && _teamInfo$identity$gr !== void 0 ? _teamInfo$identity$gr : 0;
    if (currentOid !== identity.oid || currentGroupId !== identity.groupId) {
        // 标识一定要前置
        changeIsSwitchIdentityInitiativeState(true);
    }
    (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .setLocalUid */ .Tc)(identity.ouid);
    // 切换身份同步cookie
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(identity.oid, identity.groupId);
};
/**
 * 登录后打开身份切换弹窗的相关逻辑
 * @param originUid 大账号登录后返回的uid
 * @param accessToken 大账号登录后返回的token
 * @returns
 */ var openIdentitySwitchPopupAfterLogin = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee2(originUid, accessToken) {
        var _teamInfoData;
        var _getConfig, isIntl, isTeam, info, teamIdentity;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_16__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl, isTeam = _getConfig.isTeam;
                    ;
                    // 海外或者非团队版不走以下逻辑
                    if (!(isIntl || !isTeam)) {
                        _context2.next = 4;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 4:
                    if (accessToken) window.localStorage.setItem("access_token", accessToken);
                    // 1、如果本地缓存团队身份对应的原始ID(origin_id)与当前登录账号的ID一致，则自动切换成缓存的身份且刷新页面；
                    // 2、如果本地无缓存团队身份，则唤起身份切换弹窗：
                    //    2.1、如果无团队，则自动走个人身份，无需唤起身份切换弹窗；
                    //    2.2、如果有团队，则唤起身份切换弹窗。
                    // 更新cookie中的origin_uid
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalOriginUid */ .Nz)(originUid);
                    // 获取缓存中的最近身份信息
                    info = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalRecentIdentity */ .pB)();
                    if (!(info && info.originUid === originUid)) {
                        _context2.next = 13;
                        break;
                    }
                    // 最近登录的团队身份和当前账号匹配，直接切成最近登录的身份
                    changeIdentity({
                        oid: info.oid,
                        groupId: info.groupId,
                        ouid: info.ouid || 0
                    });
                    if (!info.oid) {
                        _context2.next = 12;
                        break;
                    }
                    window.location.reload();
                    return _context2.abrupt("return", false);
                case 12:
                    return _context2.abrupt("return", true);
                case 13:
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalRecentIdentity */ .tK)();
                    // 拉取团队数据接口
                    _context2.next = 16;
                    return fetchTeamInfo();
                case 16:
                    // 团队身份数据
                    teamIdentity = ((_teamInfoData = teamInfoData) === null || _teamInfoData === void 0 || (_teamInfoData = _teamInfoData.identity.list) === null || _teamInfoData === void 0 ? void 0 : _teamInfoData.filter(function(v) {
                        return v.oid;
                    })) || [];
                    if (teamIdentity.length) {
                        _context2.next = 19;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 19:
                    return _context2.abrupt("return", new Promise(function(resolve) {
                        openIdentitySwitchPopup({
                            showCloseBtn: false,
                            hideCreateBtn: true,
                            hideSelectedStatus: true,
                            onSwitchComplete: function onSwitchComplete(_ref3) {
                                var oid = _ref3.oid;
                                if (oid) {
                                    // 选择的是团队身份，则刷新页面
                                    window.location.reload();
                                    resolve(false);
                                } else {
                                    // 选择的是个人身份，则继续走业务
                                    resolve(true);
                                }
                            }
                        });
                    }));
                case 20:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function openIdentitySwitchPopupAfterLogin(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();
var checkTeamMemberState = function checkTeamMemberState(_teamInfo) {
    var _teamInfo$identity$li, _teamInfo$identity$li2, _teamInfo$member$team, _teamInfo$member;
    var teamInfo = _teamInfo !== null && _teamInfo !== void 0 ? _teamInfo : getTeamInfo();
    var userCount = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 || (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(item) {
        var _getLocalIdentity3;
        return item.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid);
    })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.member_num) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : 0;
    /** 可操作席位数 (当前成员数+剩余可邀请席位数) */ var operableNum = (_teamInfo$member$team = teamInfo === null || teamInfo === void 0 || (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.team.member_detail.operable_num) !== null && _teamInfo$member$team !== void 0 ? _teamInfo$member$team : 0;
    return {
        isExcess: userCount > operableNum,
        hasSeat: userCount < operableNum
    };
};


/***/ }),

/***/ 48778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74107);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8209);
/* harmony import */ var _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56874);
/* harmony import */ var _identitySwitch_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67721);
/* harmony import */ var _teamLogo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42155);
/* harmony import */ var _teamTag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98053);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38867);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_identityRow_less__WEBPACK_IMPORTED_MODULE_2__);










// eslint-disable-next-line @typescript-eslint/no-unused-vars
var IdentityRow_CheckBox = function IdentityRow_CheckBox(_ref) {
    var isSelected = _ref.isSelected;
    return /*#__PURE__*/ React.createElement("div", {
        className: "IdentityRow_CheckBox",
        "data-active": isSelected
    });
};
var IdentityRow = function IdentityRow(_ref2) {
    var _identity$groups$, _identity$groups$2, _identity$groups$3;
    var identity = _ref2.identity, isSelected = _ref2.isSelected, onClick = _ref2.onClick, _ref2$selectedIcon = _ref2.selectedIcon, selectedIcon = _ref2$selectedIcon === void 0 ? "TickIcon" : _ref2$selectedIcon, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "default" : _ref2$variant;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), isIntl = _useConfig.isIntl;
    var teamType = (0,_identitySwitch_shared__WEBPACK_IMPORTED_MODULE_4__/* .getTeamTagType */ .N)(identity.oid, identity.type);
    var isDropdown = variant === "dropdown";
    // const Icon =
    //   selectedIcon === 'CheckBox'
    //     ? IdentityRow_CheckBox
    //     : selectedIcon === 'TickIcon'
    //     ? IdentityRow_TickIcon
    //     : selectedIcon;
    var Icon = function Icon(_ref3) {
        var active = _ref3.isSelected;
        return active ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: 16,
            name: "CheckBold",
            color: isDropdown ? "var(--content-system-primary, #1C1D1F)" : "var(--content-system-link, #3388FF)"
        }) : null;
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("IdentityRow", {
            "IdentityRow-dropdown": isDropdown
        }),
        "data-identity-type": identity.type,
        "data-active": isSelected,
        onClick: onClick
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-left"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-avatar"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teamLogo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        src: identity.logo,
        size: "medium",
        name: identity.name,
        oid: identity.oid
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-infoBox"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-infoBox-top"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-name"
    }, identity.alias || identity.name), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-teamTag"
    }, ((_identity$groups$ = identity.groups[0]) === null || _identity$groups$ === void 0 ? void 0 : _identity$groups$.is_vip) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: identity.type === 0 ? isIntl ? ((_identity$groups$2 = identity.groups[0]) === null || _identity$groups$2 === void 0 ? void 0 : _identity$groups$2.vip_level) === _types__WEBPACK_IMPORTED_MODULE_7__/* .VipLevel.Pro */ .Dv.Pro ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__/* .userXdesignProVip */ .OY : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__/* .userXdesignPlusVip */ .ZB : ((_identity$groups$3 = identity.groups[0]) === null || _identity$groups$3 === void 0 ? void 0 : _identity$groups$3.vip_level) === _types__WEBPACK_IMPORTED_MODULE_7__/* .VipLevel.ProCn */ .Dv.ProCn ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__/* .userPrpVip */ .PS : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__/* .userVip */ .g : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_8__/* .teamVip */ .vD,
        style: identity.type === 0 ? {
            height: 16
        } : {
            width: 36,
            height: 15
        },
        alt: ""
    }))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-detailInfo"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        name: teamType === _teamTag__WEBPACK_IMPORTED_MODULE_9__/* .TeamTagType.personal */ .n.personal ? "User" : "Enterprise",
        fontSize: 12
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "IdentityRow-memberNum"
    }, teamType === _teamTag__WEBPACK_IMPORTED_MODULE_9__/* .TeamTagType.personal */ .n.personal ? 1 : identity.member_num, "人")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-selectedIcon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Icon, {
        isSelected: isSelected
    })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IdentityRow);


/***/ }),

/***/ 65229:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BM": () => (/* binding */ HIDDEN_IDENTITY_SWITCH_MODAL),
/* harmony export */   "Mg": () => (/* binding */ SHOW_IDENTITY_SWITCH_MODAL),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_custom_scrollbars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31298);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74107);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10275);
/* harmony import */ var _ComUI__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40451);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97303);
/* harmony import */ var _loading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85776);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46718);
/* harmony import */ var _createModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6310);
/* harmony import */ var _identityRow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48778);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76511);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_3__);











// 展示身份切换弹窗事件
var SHOW_IDENTITY_SWITCH_MODAL = "xdesign-widget-show-identity-switch-modal";
// 隐藏身份切换弹窗事件
var HIDDEN_IDENTITY_SWITCH_MODAL = "xdesign-widget-hidden-identity-switch-modal";
/**
 * 登陆后身份选择
 */ var LoginIdentitySwitchModal = function LoginIdentitySwitchModal(_ref) {
    var _teamInfo$identity$li, _getLocalIdentity, _teamInfo$identity$li2;
    var _ref$showCloseBtn = _ref.showCloseBtn, showCloseBtn = _ref$showCloseBtn === void 0 ? false : _ref$showCloseBtn, hideCreateBtn = _ref.hideCreateBtn, create_team_success_entrance = _ref.create_team_success_entrance, _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, _ref$noSwitchIdentity = _ref.noSwitchIdentity, noSwitchIdentity = _ref$noSwitchIdentity === void 0 ? false : _ref$noSwitchIdentity, _ref$filterIdentities = _ref.filterIdentities, filterIdentities = _ref$filterIdentities === void 0 ? function() {
        return true;
    } : _ref$filterIdentities, onSwitchComplete = _ref.onSwitchComplete, onClose = _ref.onClose, onTrack = _ref.onTrack, topTip = _ref.topTip, hideSelectedStatus = _ref.hideSelectedStatus;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_4__/* .useConfig */ .ZR)(), loginIdentitySwitchModalConfig = _useConfig.loginIdentitySwitchModalConfig;
    var teamInfo = (0,___WEBPACK_IMPORTED_MODULE_5__/* .useTeamInfoState */ .fM)();
    // 关闭
    var handleConfirm = function handleConfirm(oid, groupId, ouid) {
        if (!teamInfo) return;
        onSwitchComplete === null || onSwitchComplete === void 0 || onSwitchComplete({
            oid: oid,
            groupId: groupId,
            ouid: ouid
        }, {
            isFromCreate: false
        });
        onClose === null || onClose === void 0 || onClose();
        if (!noSwitchIdentity) {
            (0,___WEBPACK_IMPORTED_MODULE_5__/* .changeIdentity */ .vv)({
                ouid: ouid,
                oid: oid,
                groupId: groupId
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (teamInfo) {
            _loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"].hidden */ .Z.hidden();
        } else {
            _loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"].show */ .Z.show("加载中...");
        }
    }, [
        teamInfo
    ]);
    var displayIdentities = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.filter(filterIdentities)) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : [];
    var personlIsShow = displayIdentities.some(function(it) {
        return it.type === 0;
    });
    if (!teamInfo) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceLoginIdentitySwitchModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "Widget teamSpaceLoginIdentitySwitchModal"
    }, showCloseBtn && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "close",
        onClick: ___WEBPACK_IMPORTED_MODULE_5__/* .closeIdentitySwitchPopup */ .VT
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "title"
    }, personlIsShow ? "选择身份" : "选择团队身份"), loginIdentitySwitchModalConfig.showEditorSaveTip && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "editing-save-tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        style: {
            marginRight: 4
        },
        name: "InfoCircleBoldFill",
        fontSize: 16,
        color: "var(--content-system-info-icon-regular, #8CC0FF)"
    }), topTip !== null && topTip !== void 0 ? topTip : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, "如正在编辑，作图/生成记录将保存在", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, ((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity === void 0 ? void 0 : _getLocalIdentity.oid) === 0 ? "个人设计师" : (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(it) {
        var _getLocalIdentity2;
        return it.oid === ((_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid);
    })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.name), "的空间")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "list",
        style: {
            height: teamInfo.identity.list.length > 3 ? 240 : teamInfo.identity.list.length * 74
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_custom_scrollbars__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbars */ .$B, {
        className: "loginIdentitySwitchModal-scrollbars"
    }, displayIdentities.map(function(identity, key) {
        var _getLocalIdentity3;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: key,
            style: {
                margin: "0 16px"
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_identityRow__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            identity: identity,
            isSelected: !hideSelectedStatus && identity.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid),
            onClick: function onClick() {
                return handleConfirm(identity.oid, identity.groups[0].id, identity.ouid);
            }
        }));
    }))), !hideCreateBtn ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-box",
        onClick: function onClick() {
            (0,___WEBPACK_IMPORTED_MODULE_5__/* .closeIdentitySwitchPopup */ .VT)();
            (0,_createModal__WEBPACK_IMPORTED_MODULE_10__/* .openCreateTeamModal */ .l)({
                onTrack: onTrack,
                create_team_success_entrance: create_team_success_entrance,
                project: project,
                noSwitchIdentity: noSwitchIdentity,
                onCreatedComplete: function onCreatedComplete(data) {
                    return onSwitchComplete === null || onSwitchComplete === void 0 ? void 0 : onSwitchComplete({
                        oid: data.oid,
                        groupId: data.group_id,
                        ouid: data.ouid
                    }, {
                        isFromCreate: true
                    });
                }
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-btn"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-icon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        fontSize: 18,
        name: "PlusBlack",
        color: "var(--content-web-secondary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-text"
    }, "免费创建新团队"))) : null));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(LoginIdentitySwitchModal));


/***/ }),

/***/ 42155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68795);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);



/**
 * 团队 logo
 */ var TeamLogo = function TeamLogo(_ref) {
    var size = _ref.size, src = _ref.src, name = _ref.name, grayscale = _ref.grayscale, oid = _ref.oid;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamLogo", {
            grayscale: grayscale,
            "user-avatar": !oid
        })
    }, src ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: src,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("img", size)
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("name", size)
    }, name.substring(0, 1)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamLogo));


/***/ }),

/***/ 98053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "n": () => (/* binding */ TeamTagType)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81549);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74107);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57926);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);





var TeamTagType = /*#__PURE__*/ function(TeamTagType) {
    TeamTagType["personal"] = "personal";
    TeamTagType["team"] = "team";
    TeamTagType["enterprise"] = "enterprise";
    TeamTagType["free"] = "free";
    return TeamTagType;
}({});
var nameType = {
    personal: "个人版",
    team: "团队版",
    enterprise: "企业版",
    free: "免费版"
};
/**
 * 团队 tag
 */ var TeamTag = function TeamTag(_ref) {
    var size = _ref.size, type = _ref.type, selectIcon = _ref.selectIcon, grayscale = _ref.grayscale, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _onClick = _ref.onClick;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamTag", type, size, {
            grayscale: grayscale,
            selectIcon: !!selectIcon
        }),
        style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, style),
        onClick: function onClick() {
            return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "txt"
    }, nameType[type]), selectIcon ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        style: {
            transform: "translate(1px, -50%) scale(".concat(8 / 12, ")"),
            position: "absolute",
            top: "50%"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        fontSize: 12,
        name: "ChevronDownBlack"
    })) : null);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamTag));


/***/ }),

/***/ 33989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cm": () => (/* binding */ createTeam),
  "W2": () => (/* binding */ getAccessTokenCookieKey),
  "bo": () => (/* binding */ getEnterpriseIDKey),
  "fZ": () => (/* binding */ handleReportDownloadResult),
  "S1": () => (/* binding */ init),
  "yf": () => (/* binding */ isSSO)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(33641);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(19945);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(70072);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/superPropBase.js

function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/get.js

function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,esm_typeof/* default */.Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/enum.js
/**
 * 上传环境
 */
var enum_UploadEnv;
(function (UploadEnv) {
    /**
     * 上传环境：正式环境
     */
    UploadEnv[UploadEnv["Release"] = 0] = "Release";
    /**
     * 上传环境：测试环境
     */
    UploadEnv[UploadEnv["Test"] = 1] = "Test";
})(enum_UploadEnv || (enum_UploadEnv = {}));
/**
 * 上传 Token 请求接口地址
 *
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=48137491
 */
var UploadTokenAPI;
(function (UploadTokenAPI) {
    /**
     * 上传 Token 请求接口地址：正式环境
     */
    UploadTokenAPI["Release"] = "https://strategy.app.meitudata.com/upload/policy";
    /**
     * 上传 Token 请求接口地址：测试环境
     */
    UploadTokenAPI["Test"] = "http://prestrategy.meitubase.com/upload/policy";
})(UploadTokenAPI || (UploadTokenAPI = {}));
/**
 * 云存储服务提供商枚举对象
 */
var enum_Cloud;
(function (Cloud) {
    /**
     * 云存储提供商：未知
     *
     * @since 4.4.0
     */
    Cloud["Unknown"] = "";
    /**
     * 云存储提供商：亚马逊 AWS S3
     */
    Cloud["AWSS3"] = "aws-s3";
    /**
     * 云存储提供商：华为云（实现的 AWS S3 访问协议）
     */
    Cloud["HuaweiS3"] = "hw-s3";
    /**
     * 云存储提供商：七牛云
     */
    Cloud["Qiniu"] = "qiniu";
    /**
     * 云存储提供商：美图云（基于七牛云）
     */
    Cloud["MeituYun"] = "mtyun";
    /**
     * 云存储提供商：阿里云 OSS
     *
     * @since 4.3.0
     */
    Cloud["OSS"] = "oss";
})(enum_Cloud || (enum_Cloud = {}));
/**
 * 云存储提供商列表
 */
const Clouds = Object.values(enum_Cloud).filter((value) => typeof value === 'string');

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/constants.js

/**
 * 控制台日志前缀
 *
 * @since 4.1.0
 */
const LOG_PREFIX = '[@meitu/upload]';
/**
 * 上传 Token 一次最少获取数量
 *
 * @since 4.4.0
 */
const MIN_TOKEN_COUNT = 1;
/**
 * 上传 Token 一次最多获取数量
 *
 * @since 4.4.0
 */
const constants_MAX_TOKEN_COUNT = 20;
/**
 * 默认的上传 Token 接口请求参数
 */
const constants_defaultUploadTokenRequestParams = {
    app: '',
    type: '',
    count: 1,
    suffix: '',
    sig: '',
    sigTime: '',
    sigVersion: '1.3',
    version: '2',
};
/**
 * 获取默认的上传配置选项
 *
 * @since 4.6.1
 * @param options 可选；自定义配置选项
 */
function constants_getDefaultUploaderOptions(options) {
    return Object.assign({ debug: false, env: enum_UploadEnv.Release, accessToken: '', appProxy: false, sign: (params) => params, progress: (data) => data }, options);
}
/**
 * 默认的上传配置选项
 *
 * @deprecated 至 `v4.6.1` 版本起弃用，请改用 `getDefaultUploaderOptions()`
 */
const defaultUploaderOptions = constants_getDefaultUploaderOptions();
/**
 * 默认的文件分片大小
 *
 * @since 4.6.0
 */
const DEFAULT_PART_SIZE = (/* unused pure expression or super */ null && (1024 * 1024 * 4));
/**
 * 默认的错误重试次数
 *
 * @since 4.8.0
 */
const DEFAULT_RETRY_COUNT = 3;
/**
 * 限制最小分片大小
 *
 * @since 4.6.0
 *
 * - 云服务器限制，单个分片不允许小于 100kb
 */
const MIN_PART_SIZE = (/* unused pure expression or super */ null && (1024 * 100));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/utils.js

/**
 * 键值对键名转换为小驼峰命名风格
 *
 * @param obj 键值对或键值对数组
 */
function utils_toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((item) => utils_toCamelCase(item));
    }
    else if (typeof obj === 'object') {
        const temp = {};
        for (const i in obj) {
            const key = i.replace(/_([A-Za-z])/g, (_$0, $1) => $1.toUpperCase());
            temp[key] = typeof obj[i] === 'object' ? utils_toCamelCase(obj[i]) : obj[i];
        }
        return temp;
    }
    else {
        return obj;
    }
}
/**
 * 键值对对象转换为请求字符串
 *
 * @param kv     键值对对象
 * @param filter 自定义过滤方法
 */
function utils_keyValueToQueryStrings(kv, filter) {
    return Object.entries(kv)
        .filter((_) => {
        if (filter) {
            return filter(_);
        }
        return _[1] !== 'undefined' && _[1] !== '';
    })
        .map(([key, value]) => `${key}=${value}`)
        .sort()
        .join('&');
}
/**
 * 判断当前是不是 S3 云存储服务
 *
 * @since 4.2.0
 * @param cloud 云服务名称
 */
function isS3(cloud) {
    return cloud === enum_Cloud.HuaweiS3 || cloud === enum_Cloud.AWSS3 || cloud === enum_Cloud.OSS;
}
/**
 * 获取文件的扩展名
 *
 * @since 4.2.0
 * @param fileName 文件名
 */
function utils_getFileExtension(fileName) {
    var _a;
    return ((_a = fileName.match(/\.(\w+)$/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
}
/**
 * 从 Data URL 中获取文件的扩展名
 *
 * @since 4.2.0
 * @param dataURL Data URL 字符串
 */
function utils_getFileExtensionByDataURL(dataURL) {
    var _a, _b, _c, _d, _e, _f;
    return (((_f = (_e = (_d = (_c = (_b = (_a = dataURL
        .split(',')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /:(.*?);/)) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.split('/')) === null || _f === void 0 ? void 0 : _f[1]) || '');
}
/**
 * 生成 TaskId
 *
 * @since 4.7.0
 */
function generateTaskId() {
    var _a, _b;
    const _generateTaskId = () => {
        return '00000000-0000-4000-1000-000000000000'.replace(/[10]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === '0' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    try {
        if ((_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
            return window.crypto.randomUUID();
        }
        if ((_b = window === null || window === void 0 ? void 0 : window.crypto) === null || _b === void 0 ? void 0 : _b.getRandomValues) {
            const unsafeStringify = (arr) => {
                const byteToHex = [];
                let str = '';
                for (let i = 0; i < 256; ++i) {
                    byteToHex.push((i + 0x100).toString(16).slice(1));
                }
                for (let i = 0; i < 16; i++) {
                    str += byteToHex[arr[i]];
                    if ([3, 5, 7, 9].includes(i)) {
                        str += '-';
                    }
                }
                return str.toLowerCase();
            };
            return unsafeStringify(window.crypto.getRandomValues(new Uint8Array(16)));
        }
        return _generateTaskId();
    }
    catch (e) {
        return _generateTaskId();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/types/upload.js

/**
 * 创建上传结果数据
 *
 * @since 4.4.0
 * @param result 可选；结果数据
 */
function upload_createUploadResult(result = {}) {
    const _result = Object.assign({ data: '', url: '', key: '', etag: '', index: 0, fileSize: '', mimeType: '', type: '', size: 0, storage: enum_Cloud.Unknown }, result);
    return _result;
}
/**
 * 上传错误类
 */
class upload_UploaderError extends Error {
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/types/index.js


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/uploader.js



/**
 * 上传基类
 *
 * - 继承上传基类并实现抽象方法，可用于扩展实现新平台的上传功能；
 */
class UploaderBase {
    /**
     * 上传环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 是否为测试环境
     *
     * @getter
     * @readonly
     */
    get isTest() {
        return this.env === enum_UploadEnv.Test;
    }
    /**
     * 控制台日志前缀
     *
     * @getter
     * @since 4.5.0
     * @readonly
     */
    get logPrefix() {
        return '';
    }
    /**
     * 上传 Token 接口地址
     *
     * @getter
     * @readonly
     * @abstract 从 `v4.3.0` 起，为了支持海外版本（使用海外域名，借助 Tree Shaking，避免构建产出文件中有 `meitu` 域名相关代码），在基类默认返回空字符串，相当于改为 `getter` 抽象属性（并保持版本兼容），要求各端扩展类实现该属性
     */
    get tokenApi() {
        return '';
    }
    /**
     * 美图帐号 Access Token
     *
     * @getter
     * @readonly
     */
    get accessToken() {
        return this.options.accessToken;
    }
    constructor(options) {
        /**
         * 上传配置选项
         *
         * @default getDefaultUploaderOptions()
         */
        this.options = constants_getDefaultUploaderOptions();
        /**
         * 上传 Token 列表
         *
         * @default []
         */
        this.tokenList = [];
        /**
         * 上传重试次数/计数
         *
         * @default 0
         */
        this.retryCount = 0;
        /**
         * 当前 Token 列表序号
         *
         * @default 0
         */
        this.currentTokenIndex = 0;
        /**
         * 当前云厂商列表序号
         *
         * @default 0
         */
        this.currentCloudIndex = 0;
        /**
         * 代理上传类实例对象集合
         *
         * @protected
         * @since 4.5.0
         */
        this.proxies = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.debugLog('options =>', options);
        const { appProxy } = this.options;
        if (!this.tokenApi.trim() && !appProxy) {
            throw new upload_UploaderError('成员属性 tokenApi 不能为空');
        }
        if (!/^https?:\/\//.test(this.tokenApi) && !appProxy) {
            throw new upload_UploaderError('tokenApi 必要是有效的 HTTP(S) 地址');
        }
        const originSign = typeof (options === null || options === void 0 ? void 0 : options.sign) === 'function' ? this.options.sign.bind(this) : null;
        this.options.sign = (params) => (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            if (appProxy) {
                return params;
            }
            // 默认允许不实现，但是在调试模式下，控制台显示警告日志
            if (typeof originSign !== 'function') {
                if (this.debug) {
                    console.warn(this.logPrefix, '检测到目前没有实现参数签名方法选项 sign，存在安全风险，建议实现。');
                }
                return params;
            }
            this.debugLog('开始进行参数签名...');
            params = yield originSign(Object.assign(Object.assign(Object.assign({}, constants_defaultUploadTokenRequestParams), { sigTime: `${Math.floor(new Date().getTime() / 1000)}` }), params));
            if (!(params === null || params === void 0 ? void 0 : params.sig) || ((_a = params === null || params === void 0 ? void 0 : params.sig) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                throw new upload_UploaderError('上传参数签名参数 sig 不能为空');
            }
            if (((_b = params === null || params === void 0 ? void 0 : params.sig) === null || _b === void 0 ? void 0 : _b.length) !== 32) {
                throw new upload_UploaderError('上传参数签名参数 sig 值不正确');
            }
            this.debugLog('参数签名完成！params =>', params);
            return params;
        });
    }
    /**
     * 获取文件扩展名
     *
     * @protected
     * @since 4.4.0
     * @param file 文件
     * @param params 上传请求参数
     */
    getFileSuffix(file, params) {
        let suffix = (params === null || params === void 0 ? void 0 : params.suffix) || '';
        if (typeof (params === null || params === void 0 ? void 0 : params.suffix) === 'undefined') {
            if (typeof file === 'string') {
                // 处理 DataURL 的文件形式
                if (/^data:/.test(file)) {
                    suffix = utils_getFileExtensionByDataURL(file);
                }
                else {
                    suffix = utils_getFileExtension(file);
                }
            }
            else if (file instanceof File) {
                suffix = utils_getFileExtension(file.name);
            }
        }
        return suffix;
    }
    /**
     * 请求接口获取上传 Token
     *
     * @protected
     * @since 4.5.0
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    getUploadToken(params_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (params, options = {}) {
            const { multiple = false } = options;
            this.debugLog('[getUploadToken] options =>', options);
            let currentToken;
            // 获取上传 Token 列表
            if (!multiple) {
                this.tokenList = (options === null || options === void 0 ? void 0 : options.tokenList) || (yield this.requestToken(params));
                currentToken = this.tokenList[this.currentTokenIndex];
            }
            else {
                if (typeof (options === null || options === void 0 ? void 0 : options.uploadToken) !== 'object') {
                    throw new upload_UploaderError('上传 Token 信息不存在');
                }
                currentToken = options.uploadToken;
            }
            return currentToken;
        });
    }
    /**
     * 多文件批量上传方法
     *
     * - 本方法是基于 [`upload()`](https://f2er.meitu.com/meitu-upload/api/upload/class/Uploader#upload) 方法扩展实现的，最多支持一次性上传 20 个文件；
     *
     * @async
     * @since 4.4.0
     * @param files 要批量上传的文件列表；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadMultiple(files_1, params_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (files, params, options = {}) {
            var _a;
            this.debugLog('[uploadMultiple] files =>', files);
            this.debugLog('[uploadMultiple] params =>', params);
            this.debugLog('[uploadMultiple] options =>', options);
            if (files.length > constants_MAX_TOKEN_COUNT) {
                throw new upload_UploaderError('最多只允许一次性上传 20 个文件');
            }
            if ((params === null || params === void 0 ? void 0 : params.count) && (params === null || params === void 0 ? void 0 : params.count) !== files.length) {
                throw new upload_UploaderError('上传 Token 获取数量与文件数量不一致');
            }
            const { appProxy } = this.options;
            const _options = Object.assign(Object.assign({}, options), { multiple: true });
            params.suffix = this.getFileSuffix(files[0], params);
            params.count = (_a = params === null || params === void 0 ? void 0 : params.count) !== null && _a !== void 0 ? _a : files.length;
            this.tokenList = appProxy ? [] : yield this.requestToken(params);
            // 大部分主流浏览器的同一个源最大并发请求数限制为 6 个，多出的请求会自动排队等待，所以这里不需要在手动维护请求队列，直接一起发送，交由浏览器管理请求队列
            const results = yield Promise.allSettled(Array.from({ length: appProxy ? files.length : this.tokenList.length }, (v, i) => i).map((i) => {
                return this.upload(files[i], params, Object.assign(Object.assign({}, _options), { tokenList: this.tokenList, uploadToken: this.tokenList[i], index: i }));
            }));
            this.reset();
            return results.map((result, index) => {
                if (result.status === 'fulfilled') {
                    return result.value;
                }
                else {
                    return upload_createUploadResult({ index });
                }
            });
        });
    }
    /**
     * 请求上传所需的 Token
     *
     * @async
     * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=5313382
     * @param params 请求上传 Token 的参数
     * @returns 上传 Token 列表
     */
    requestToken(params) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const { headers: headersParams = {} } = params, restParams = (0,tslib_es6.__rest)(params, ["headers"]);
            const headers = {};
            // 如果 MAAT 安全策略平台有配置需要登录才能获取 token，则需要传入 accessToken 配置项
            if (this.options.accessToken) {
                headers['Access-Token'] = this.options.accessToken;
            }
            this.debugLog('[requestToken] params =>', restParams);
            if ((restParams === null || restParams === void 0 ? void 0 : restParams.count) > constants_MAX_TOKEN_COUNT) {
                throw new upload_UploaderError(`最多只允许一次性获取 ${constants_MAX_TOKEN_COUNT} 个上传 Token`);
            }
            const signedParams = yield this.options.sign(restParams);
            this.debugLog('[requestToken] signedParams =>', signedParams);
            // 将键值对对象转换为请求字符串
            const queries = utils_keyValueToQueryStrings(signedParams, (_) => {
                return _[1] !== 'undefined';
            });
            const protocol = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) || '';
            // 针对 pre 环境，token 请求地址协议与 location.protocol 同步，仅对 protocol 为 http 或 https 时生效，防止本地包内请求错误
            const tokenApi = /^http(s|):/.test(protocol) ? this.tokenApi.replace('http:', protocol) : this.tokenApi;
            // 请求获取上传 token 的接口
            const result = yield this.request(`${tokenApi}?${queries}`, {
                headers: Object.assign(Object.assign({}, headers), headersParams),
            });
            if (!result) {
                throw result;
            }
            if (result.status !== 200) {
                throw result;
            }
            if (typeof (result === null || result === void 0 ? void 0 : result.json) !== 'function') {
                throw new upload_UploaderError('this.request() 方法的返回结果对象的 json() 方法没有实现');
            }
            // 将接口响应返回的所有字段转换为小驼峰
            const json = utils_toCamelCase(yield result.json());
            this.debugLog('[requestToken] tokenList =>', json);
            return json;
        });
    }
    /**
     * 重置上传状态数据
     *
     * @protected
     * @since 4.5.0
     */
    reset() {
        this.proxies = {};
        this.tokenList = [];
        this.currentTokenIndex = 0;
        this.currentCloudIndex = 0;
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(`${this.logPrefix}[${this.constructor.name}]`, ...args);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/utils.js

/**
 * 获取当前 WebView 版本号
 *
 * @since 4.5.0
 */
function getMeituWebViewVersion() {
    const result = navigator.userAgent.match(/MTWebView\/((\d+)\.(\d+)\.(\d+))/);
    return (result === null || result === void 0 ? void 0 : result[1]) || '';
}
/**
 * HTTP 请求方法（基于 Fetch API 实现）
 *
 * @async
 * @since 4.5.0
 * @param url 请求地址
 * @param options 可选；请求配置项
 */
function utils_request(url_1) {
    return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
        const result = (yield window.fetch(url, Object.assign({ method: 'GET' }, options)));
        return result;
    });
}
/**
 * Data URL 转换为 File 对象的方法
 *
 * @since 4.5.0
 * @link https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * @param dataURL 前缀为 data: 协议的URL
 * @param fileName 自定义文件名
 */
function dataURLToFile(dataURL, fileName) {
    var _a, _b, _c;
    const arr = dataURL.split(',');
    const mime = ((_c = (_b = (_a = arr === null || arr === void 0 ? void 0 : arr[0]) === null || _a === void 0 ? void 0 : _a.match) === null || _b === void 0 ? void 0 : _b.call(_a, /:(.*?);/)) === null || _c === void 0 ? void 0 : _c[1]) || '';
    const bstr = window.atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}
/**
 * 检查或转换要上传的文件类型
 *
 * - 检查文件是否为空；
 * - 检查文件是否为 File 对象；
 * - 如果是 Data URL Base64 编码字符串形式，会自动转换为 File 对象；
 *
 * @since 4.5.0
 * @param file 文件
 * @param suffix 可选；文件扩展名后缀
 */
function checkUploadFileType(file, suffix) {
    if (!file) {
        throw new Error('文件不能为空');
    }
    // 处理 Data URL 的文件形式
    if (typeof file === 'string' && /^data:/.test(file)) {
        const fileName = `${new Date().getTime()}${suffix ? `.${suffix}` : ''}`;
        file = dataURLToFile(file, fileName);
    }
    if (!(file instanceof File)) {
        throw new Error('file 参数值只允许 File 对象或 Data URL (Base64 Encoded) 形式');
    }
    return file;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/app-bridge.js
/**
 * 美图 App 端 WebView JS Bridge 上传协议方法实现
 *
 * 作为基础组件，为了不依赖 @meitu/hogger 模块，避免额外的依赖模块安装，同时减小构建产物的文件大小，在这里简单实现 Hogger 相关上传协议方法
 */

/// <reference types="@meitu/mtjs" />


let t = 0;
/**
 * 通过 MTJs 发起 WebView JS Bridge 协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=29749881
 * @param method 协议方法
 * @param params 可选；协议参数
 * @param options 可选；配置选项
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callWebViewJavaScriptBridge(method, params, options) {
    const logPrefix = `${LOG_PREFIX} callWebViewJavaScriptBridge: `;
    const { debug = false } = options || {};
    t++;
    if (typeof params === 'object' && !Array.isArray(params)) {
        params._t = t; // 解决并发问题，相关文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=320283764
    }
    if (debug) {
        console.log(logPrefix, method, { params, options });
    }
    return new Promise((resolve, reject) => {
        if (typeof (window === null || window === void 0 ? void 0 : window.MTJs) === 'undefined') {
            return reject(new Error('MTJs undefined'));
        }
        window.MTJs.nativeCall({ 'mt-hogger': method }, params || {}, (result) => {
            var _a, _b, _c, _d;
            if ((_a = result === null || result === void 0 ? void 0 : result.meta) === null || _a === void 0 ? void 0 : _a.params) {
                result.meta.params = Object.assign(Object.assign({}, result.meta.params), params);
            }
            if (debug) {
                console.log(logPrefix, method, 'result =>', result);
            }
            const code = (_b = result === null || result === void 0 ? void 0 : result.meta) === null || _b === void 0 ? void 0 : _b.code;
            if (!result || code !== 0) {
                (_c = options === null || options === void 0 ? void 0 : options.onFailure) === null || _c === void 0 ? void 0 : _c.call(options, result);
                return reject(result);
            }
            (_d = options === null || options === void 0 ? void 0 : options.onProgress) === null || _d === void 0 ? void 0 : _d.call(options, result);
            resolve(result);
        }, options);
    });
}
/**
 * 判断是否支持 App 上传协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=303335231
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=297799315
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=296284887
 * @param webViewVersion 可选；WebView 版本号
 */
function isSupportUploadByApp(webViewVersion = getMeituWebViewVersion()) {
    const { userAgent } = navigator;
    const isiOS = /iPhone|iPad|iPod/.test(userAgent);
    const isAndroid = /Android\s/.test(userAgent);
    const versions = webViewVersion.split('.');
    if (versions.length < 3) {
        return false;
    }
    const [major, minor, patch] = versions.map((v) => parseInt(v));
    if (isiOS) {
        return major >= 3;
    }
    else if (isAndroid) {
        if (major === 4) {
            return minor === 9 ? patch >= 1 : minor > 9; // >= 4.9.1
        }
        else {
            return major > 4;
        }
    }
    else {
        return false;
    }
}
/**
 * 发起创建上传任务协议
 *
 * @async
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=303335231
 * @param params 协议参数
 * @param options 可选；配置选项
 */
function createUploadTask(params, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'createUploadTask';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        const { response } = yield callWebViewJavaScriptBridge(method, params, options);
        const { taskId } = response;
        return {
            taskId,
        };
    });
}
/**
 * 发起监听上传任务进度协议
 *
 * @async
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=297799315
 * @param taskId 任务 ID
 * @param onProgress 可选；进度回调处理方法
 * @param options 可选；配置选项
 */
function observeUploadProgress(taskId, onProgress, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'observeUploadProgress';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        return new Promise((resolve, reject) => {
            callWebViewJavaScriptBridge(method, {
                taskId,
            }, Object.assign(Object.assign({}, options), { once: false, onProgress: ({ response }) => {
                    const { progress = 0, data } = response;
                    onProgress === null || onProgress === void 0 ? void 0 : onProgress(Object.assign(Object.assign({}, response), { progress }));
                    if (progress === 100 && typeof data === 'string' && data) {
                        resolve(response);
                    }
                }, onFailure: (res) => {
                    reject(res);
                } })).catch(reject);
        });
    });
}
/**
 * 发起取消上传任务协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=296284887
 * @param taskId 任务 ID
 * @param options 可选；配置选项
 */
function abortUploadTask(taskId, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'abortUploadTask';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        yield callWebViewJavaScriptBridge(method, { taskId }, options);
    });
}
/**
 * App 端文件上传方法 —— 通过当前美图 App 端宿主 JS Bridge 协议
 *
 * @async
 * @since 4.5.0
 * @param file 要上传的文件路径地址；
 * @param params 上传请求参数
 * @param options 可选；上传配置选项
 */
function uploadByApp(file_1, params_1) {
    return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (file, params, options = {}) {
        var _a;
        const { app: appKey, type } = params;
        const { index = 0, multiple = false, debug = false } = options;
        const logPrefix = `${LOG_PREFIX} [uploadByApp]`;
        if (debug) {
            console.log(logPrefix, { params, options });
        }
        if (typeof file !== 'string') {
            throw new upload_UploaderError('只允许传入文件路径地址字符串');
        }
        if (typeof file === 'string' && /^data:/.test(file)) {
            throw new upload_UploaderError('不支持上传 Data URL Base64 编码文件形式');
        }
        const { taskId } = yield createUploadTask({
            appKey,
            type,
            taskId: options === null || options === void 0 ? void 0 : options.taskId,
            filePath: file,
        }, { debug });
        if (debug) {
            console.log(logPrefix, 'taskId =>', taskId);
        }
        (_a = options === null || options === void 0 ? void 0 : options.getTaskId) === null || _a === void 0 ? void 0 : _a.call(options, taskId);
        let percent;
        let result = upload_createUploadResult({ index, type });
        const onProgress = (data) => {
            var _a;
            if (debug) {
                console.log(logPrefix, 'onProgress =>', { index }, data);
            }
            const { progress, totalBytesSent: loaded, totalBytesExpectedToSend: total, data: resultJsonData } = data;
            if (typeof progress !== 'number' || percent === progress || !total) {
                return;
            }
            percent = progress;
            (_a = options === null || options === void 0 ? void 0 : options.progress) === null || _a === void 0 ? void 0 : _a.call(options, {
                index,
                taskId: taskId,
                total: {
                    percent,
                    total,
                    loaded,
                    size: total,
                },
            });
            if (percent === 100 && resultJsonData) {
                const { etag, mimeType, data: url, storage = '', accessUrl = '', key = '' } = JSON.parse(resultJsonData);
                result = Object.assign(Object.assign({}, result), { etag,
                    url,
                    key,
                    mimeType,
                    storage, size: total, fileSize: `${total}`, data: url, previewUrl: accessUrl });
            }
        };
        yield observeUploadProgress(taskId, onProgress, { debug });
        if (!result.url) {
            const error = new upload_UploaderError('上传失败');
            if (!multiple) {
                throw error;
            }
        }
        return result;
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/app-proxy.js



/**
 * App 端代理上传基类
 *
 * - 使用场景：用于平替 `UploaderBase` 类，直接通过美图系 App 端协议代理上传（请求参数签名、获取上传 Token 和上传文件），去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 *
 * @since 4.5.0
 */
class AppProxyUploaderBase extends UploaderBase {
    constructor(options = {}) {
        options.appProxy = true;
        super(options);
        /**
         * 上传任务 ID 列表
         */
        this.taskIds = [];
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            this.debugLog('[request]', { url, options });
            throw new upload_UploaderError('该方法不可用，默认由 App 端代理请求接口获取 Token');
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            const { debug } = this.options;
            const { index = 0 } = options || {};
            let _taskId = '';
            this.debugLog('[upload] file =>', file);
            this.debugLog('[upload] params =>', params);
            this.debugLog('[upload] options =>', options);
            try {
                const result = yield uploadByApp(`${file}`, params, Object.assign(Object.assign({}, options), { debug, getTaskId: (taskId) => {
                        if (!this.taskIds.includes(taskId)) {
                            this.taskIds.push(taskId);
                            _taskId = taskId;
                        }
                    } }));
                this.taskIds = this.taskIds.filter((id) => id !== _taskId); // 移除已上传的任务 ID
                (_a = options === null || options === void 0 ? void 0 : options.complete) === null || _a === void 0 ? void 0 : _a.call(options, result);
                return result;
            }
            catch (error) {
                (_b = options === null || options === void 0 ? void 0 : options.failure) === null || _b === void 0 ? void 0 : _b.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        const { debug } = this.options;
        this.debugLog('[cancel] taskIds =>', this.taskIds);
        if (taskId) {
            abortUploadTask(taskId, { debug });
            return;
        }
        this.taskIds.forEach((_taskId) => {
            abortUploadTask(_taskId, { debug });
        });
    }
    // TODO：支持 App 代理上传时的断点续传
    resume() {
        throw new upload_UploaderError('目前不支持');
    }
}
/**
 * App 端代理上传类
 *
 * - 使用场景：用于平替 `Uploader` 类，直接通过美图系 App 端协议代理上传（请求参数签名、获取上传 Token 和上传文件），去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 *
 * @since 4.5.0
 */
class AppProxyUploader extends AppProxyUploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/base.js




/**
 * Web 端上传基类
 *
 * @since 4.3.0 为了扩展支持海外版本，避免包含美图的域名，从原有的 Web 端上传类拆分出 Web 端上传基类
 */
class UploaderBaseWeb extends UploaderBase {
    /**
     * 美图系 App 端协议代理上传方法
     *
     * @async
     * @protected
     * @since 4.5.0
     * @param file 上传的文件
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    appProxyUpload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            const { multiple = false } = options || {};
            const { appProxy } = this.options;
            if (appProxy) {
                const proxy = new AppProxyUploader(this.options);
                let _taskId = '';
                const result = yield proxy.upload(file, params, Object.assign(Object.assign({}, options), { progress: (res) => {
                        var _a;
                        (_a = options === null || options === void 0 ? void 0 : options.progress) === null || _a === void 0 ? void 0 : _a.call(options, res);
                        if (res.taskId) {
                            _taskId = `${res.taskId}`;
                            this.proxies[_taskId] = proxy;
                        }
                    } }));
                delete this.proxies[_taskId];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
        });
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    /**
     * 代理上传方法
     *
     * @async
     * @since 4.5.0
     * @param proxy 自定义代理上传类实例对象获取方法
     * @param file 要上传的文件；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadProxy(proxy, file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const logTag = '[uploadProxy]';
            const { index = 0, multiple = false } = options || {};
            const { appProxy } = this.options;
            const failure = options === null || options === void 0 ? void 0 : options.failure;
            this.debugLog(logTag, 'file =>', file);
            this.debugLog(logTag, 'params =>', params);
            this.debugLog(logTag, 'options =>', options);
            this.debugLog(logTag, 'appProxy =>', appProxy);
            // 避免重复执行，改成统一在 catch 中执行
            const __opts = Object.assign(Object.assign({}, options), { failure: () => { } });
            try {
                params.suffix = this.getFileSuffix(file, params);
                if (appProxy) {
                    // APP 分片上传无法通过 catch 获取错误 因此需要传入 failure
                    return this.appProxyUpload(file, params, Object.assign(Object.assign({}, __opts), { failure }));
                }
                let tokenList = [];
                if (Array.isArray(__opts === null || __opts === void 0 ? void 0 : __opts.tokenList) && (__opts === null || __opts === void 0 ? void 0 : __opts.tokenList.length) > 0) {
                    tokenList = __opts.tokenList;
                }
                else {
                    tokenList = (__opts === null || __opts === void 0 ? void 0 : __opts.uploadToken) ? [] : yield this.requestToken(params);
                }
                const currentToken = yield this.getUploadToken(params, Object.assign(Object.assign({}, __opts), { tokenList }));
                const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[this.currentCloudIndex];
                const _proxy = proxy(cloud);
                // 非 S3 暂不支持配置分段大小，因此需要过滤掉分段大小配置
                if (!isS3(cloud)) {
                    __opts === null || __opts === void 0 ? true : delete __opts.partSize;
                }
                let _taskId = '';
                const result = yield _proxy.upload(file, params, Object.assign(Object.assign({}, __opts), { progress: (res) => {
                        var _a;
                        (_a = __opts === null || __opts === void 0 ? void 0 : __opts.progress) === null || _a === void 0 ? void 0 : _a.call(__opts, res);
                        if (res.taskId) {
                            _taskId = `${res.taskId}`;
                            this.proxies[_taskId] = _proxy;
                        }
                    }, tokenList }));
                delete this.proxies[_taskId];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                failure === null || failure === void 0 ? void 0 : failure(error, index);
                throw error;
            }
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            this.debugLog('[upload] =>', { file, params, options });
            throw new Error('上传方法未实现');
        });
    }
    cancel(taskId) {
        const _cancel = (i) => {
            const proxy = this.proxies[i];
            if (proxy) {
                proxy.options = this.options;
                proxy.cancel();
            }
        };
        if (taskId) {
            _cancel(taskId);
            return;
        }
        for (const i in this.proxies) {
            _cancel(i);
        }
    }
    resume(taskId) {
        const _resume = (i) => {
            const proxy = this.proxies[i];
            if (proxy) {
                proxy.options = this.options;
                proxy.resume();
            }
        };
        if (taskId) {
            _resume(taskId);
            return;
        }
        for (const i in this.proxies) {
            _resume(i);
        }
    }
}

// EXTERNAL MODULE: ./node_modules/qiniu-js/dist/qiniu.min.js
var qiniu_min = __webpack_require__(42723);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/qiniu.js




/**
 * 基于七牛云 JS SDK 的文件上传类
 *
 * 适用于：七牛云 `qiniu`、美图云 `mtyun`
 *
 * @since 4.5.0
 */
class QiniuUploader extends UploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
    constructor(options) {
        super(options);
        /**
         * 上传任务对象
         */
        this.tasks = {};
        // 注意：仅用于临时解决七牛 X-ReqId 报错问题
        this.fixQiniuXReqIdError();
    }
    /**
     * 通过重写 XMLHttpRequest 的 getResponseHeader 原型方法
     *
     * 临时解决七牛上传时 X-ReqId 报错问题
     */
    fixQiniuXReqIdError() {
        // 在 SSR 服务端渲染场景下，避免在全局初始化时报错
        if (typeof XMLHttpRequest === 'undefined') {
            return;
        }
        const { getResponseHeader } = XMLHttpRequest.prototype;
        XMLHttpRequest.prototype.getResponseHeader = function (name) {
            // 当获取 x-reqId 响应头时，直接返回空字符串
            if (name === 'x-reqId') {
                return '';
            }
            return getResponseHeader.apply(this, [name]);
        };
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    _upload(file, options) {
        var _a;
        const { index = 0, resumable = true, currentToken, maxConcurrent, retryBackupHost = true } = options || {};
        const { currentCloudIndex, retryCount } = this;
        const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[currentCloudIndex];
        const uploadToken = currentToken === null || currentToken === void 0 ? void 0 : currentToken[cloud];
        this.debugLog('[upload] 上传相关参数 =>', { currentCloudIndex, cloud, retryCount });
        if (!uploadToken) {
            throw new upload_UploaderError('上传 Token 数据不存在');
        }
        const { key, token, chunkSize, url: uploadHost, backupUrl: uploadBackupHost } = uploadToken;
        this.debugLog('[upload] 开始上传 =>', { key, uploadHost, uploadBackupHost, chunkSize });
        let errorTime = 0;
        return new Promise((resolve, reject) => {
            var _a;
            const { retryCount } = this;
            const { progress, complete } = options || {};
            if (!uploadHost) {
                return;
            }
            // const qiniu = await import('qiniu-js') // UMD 不支持动态加载
            const forceDirect = resumable ? false : true;
            this.debugLog('[upload] qiniu.upload =>', { uploadHost, errorTime, retryCount, resumable, forceDirect });
            const taskId = generateTaskId();
            const _retryCount = (_a = options === null || options === void 0 ? void 0 : options.retryCount) !== null && _a !== void 0 ? _a : DEFAULT_RETRY_COUNT;
            const _upload = (uphost = uploadHost) => {
                const qiniuUploadOptions = {
                    uphost: uphost.replace(/https?:\/\//, ''),
                    upprotocol: uphost.indexOf('https') >= 0 ? 'https' : 'http',
                    debugLogLevel: 'INFO',
                    disableStatisticsReport: true,
                    retryCount: _retryCount,
                    forceDirect,
                };
                // 值为 undefined 时 不能传入带入配置项内 不然会导致请求无法发出
                if (typeof maxConcurrent !== 'undefined') {
                    qiniuUploadOptions.concurrentRequestLimit = maxConcurrent;
                }
                const putExtra = {};
                /**
                 * 服务端错误的将 .webm 文件识别为 application/x-matroska
                 * 服务端错误的将 svg 文件识别为 text/plain
                 * 所以需要通过拓展配置手动修正 MIME 类型
                 */
                if (file === null || file === void 0 ? void 0 : file.type) {
                    putExtra.mimeType = [file.type];
                }
                const observable = (0,qiniu_min.upload)(file, key, token, putExtra, qiniuUploadOptions);
                const subObject = {
                    /**
                     * 接收上传进度信息的回调函数
                     */
                    next: (result) => {
                        this.debugLog('[upload] qiniu.upload.next =>', result);
                        // 第三方上传进度回调处理
                        if (typeof progress === 'function') {
                            progress(Object.assign(Object.assign({}, result), { taskId,
                                index }));
                        }
                    },
                    /**
                     * 上传错误后触发；自动重试本身并不会触发该错误，而当重试次数到达上限后则可以触发
                     *
                     * 通过在后台 `http://maat0.backstage.meitu.com/` 同时把当前 `app` 的 Access Key 和 Secret Key 加个错误字符来模拟触发上传错误事件，来触发重试操作
                     */
                    error: (err) => {
                        this.debugLog('[upload] qiniu.upload.error =>', err, { errorTime });
                        errorTime += 1;
                        this.retryCount += _retryCount;
                        // 七牛云上传 SDK 本身默认重试 3 次，达到后触发 error 事件回调，再尝试换成备份域名上传，如果再报错就切成另一个云，重复前面的过程一次，总计重试次数= (3 + 1 备份) * N个云
                        // 如果主备地址相同则不进行切换重试
                        if (errorTime === 1 && uploadBackupHost && uploadBackupHost !== uploadHost && retryBackupHost) {
                            this.debugLog('[upload] qiniu.upload.error >> try backup host =>', uploadBackupHost);
                            _upload(uploadBackupHost); // 尝试用备份域名上传
                            return;
                        }
                        // else if (errorTime === 2) {
                        //   // 上传错误超过 2 次时，换另一个云上传
                        //   // 如果已经把所有可用的云都重试了一遍，则直接报错
                        //   if (currentToken.order.length === this.currentCloudIndex - 1) {
                        //     return reject(err);
                        //   }
                        //   this.currentCloudIndex += 1; // 递增云序号，即换另一个云上传
                        //   this.debugLog(
                        //     '[upload] qiniu.upload.error >> try other cloud =>',
                        //     currentToken.order[this.currentCloudIndex]
                        //   );
                        //   this._upload(file, currentToken, resolve, reject);
                        // } else {
                        //   reject(err);
                        // }
                        reject(err);
                    },
                    /**
                     * 接收上传完成后的后端返回信息
                     */
                    complete: (result) => {
                        const _a = result, { url, data, fsize } = _a, rest = (0,tslib_es6.__rest)(_a, ["url", "data", "fsize"]);
                        const finalResult = Object.assign({ url: data, key, previewUrl: url, data,
                            index,
                            fsize, size: parseInt(`${fsize || 0}`), fileSize: fsize }, rest);
                        this.debugLog('[upload] qiniu.upload.complete: result =>', finalResult);
                        // 第三方上传成功回调处理
                        if (typeof complete === 'function') {
                            complete(finalResult);
                        }
                        resolve(finalResult);
                        delete this.tasks[`${taskId}`];
                    },
                };
                const subscription = observable.subscribe(subObject);
                this.tasks[`${taskId}`] = {
                    file,
                    subscription,
                    subObject,
                    observable,
                };
            };
            _upload();
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const { multiple = false, index = 0 } = options || {};
            try {
                params.suffix = this.getFileSuffix(file, params);
                const currentToken = yield this.getUploadToken(params, options);
                const _file = checkUploadFileType(file, params.suffix);
                const result = yield this._upload(_file, Object.assign({ currentToken }, options));
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                (_a = options === null || options === void 0 ? void 0 : options.failure) === null || _a === void 0 ? void 0 : _a.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        const _unsubscribe = (id) => {
            const { subscription } = this.tasks[id];
            subscription.unsubscribe();
        };
        if (taskId) {
            _unsubscribe(taskId);
            return;
        }
        for (const i in this.tasks) {
            _unsubscribe(i);
        }
    }
    resume(taskId) {
        const _subscribe = (id) => {
            var _a;
            const { observable, subObject, subscription: _subscription } = this.tasks[id] || {};
            if (!observable) {
                return;
            }
            // 防止重复触发重新上传
            (_a = _subscription === null || _subscription === void 0 ? void 0 : _subscription.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(_subscription);
            const subscription = observable.subscribe(subObject);
            this.tasks[id].subscription = subscription;
        };
        if (taskId) {
            _subscribe(taskId);
            return;
        }
        for (const i in this.tasks) {
            _subscribe(i);
        }
    }
}

// EXTERNAL MODULE: ./node_modules/crypto-js/enc-hex.js
var enc_hex = __webpack_require__(63465);
var enc_hex_default = /*#__PURE__*/__webpack_require__.n(enc_hex);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__(55743);
var enc_utf8_default = /*#__PURE__*/__webpack_require__.n(enc_utf8);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-base64.js
var enc_base64 = __webpack_require__(98269);
var enc_base64_default = /*#__PURE__*/__webpack_require__.n(enc_base64);
// EXTERNAL MODULE: ./node_modules/crypto-js/hmac-sha256.js
var hmac_sha256 = __webpack_require__(88010);
var hmac_sha256_default = /*#__PURE__*/__webpack_require__.n(hmac_sha256);
;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/enum.js
/**
 * 上传环境
 */
var common_enum_UploadEnv;
(function (UploadEnv) {
    /**
     * 上传环境：正式环境
     */
    UploadEnv[UploadEnv["Release"] = 0] = "Release";
    /**
     * 上传环境：测试环境
     */
    UploadEnv[UploadEnv["Test"] = 1] = "Test";
})(common_enum_UploadEnv || (common_enum_UploadEnv = {}));
/**
 * 上传 Token 请求接口地址
 *
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=48137491
 */
var enum_UploadTokenAPI;
(function (UploadTokenAPI) {
    /**
     * 上传 Token 请求接口地址：正式环境
     */
    UploadTokenAPI["Release"] = "https://strategy.app.meitudata.com/upload/policy";
    /**
     * 上传 Token 请求接口地址：测试环境
     */
    UploadTokenAPI["Test"] = "http://prestrategy.meitubase.com/upload/policy";
})(enum_UploadTokenAPI || (enum_UploadTokenAPI = {}));
/**
 * 云存储服务提供商枚举对象
 */
var common_enum_Cloud;
(function (Cloud) {
    /**
     * 云存储提供商：未知
     *
     * @since 4.4.0
     */
    Cloud["Unknown"] = "";
    /**
     * 云存储提供商：亚马逊 AWS S3
     */
    Cloud["AWSS3"] = "aws-s3";
    /**
     * 云存储提供商：华为云（实现的 AWS S3 访问协议）
     */
    Cloud["HuaweiS3"] = "hw-s3";
    /**
     * 云存储提供商：七牛云
     */
    Cloud["Qiniu"] = "qiniu";
    /**
     * 云存储提供商：美图云（基于七牛云）
     */
    Cloud["MeituYun"] = "mtyun";
    /**
     * 云存储提供商：阿里云 OSS
     *
     * @since 4.3.0
     */
    Cloud["OSS"] = "oss";
})(common_enum_Cloud || (common_enum_Cloud = {}));
/**
 * 云存储提供商列表
 */
const enum_Clouds = Object.values(common_enum_Cloud).filter((value) => typeof value === 'string');

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/constants.js

/**
 * 控制台日志前缀
 *
 * @since 4.1.0
 */
const constants_LOG_PREFIX = '[@meitu/upload]';
/**
 * 上传 Token 一次最少获取数量
 *
 * @since 4.4.0
 */
const constants_MIN_TOKEN_COUNT = 1;
/**
 * 上传 Token 一次最多获取数量
 *
 * @since 4.4.0
 */
const common_constants_MAX_TOKEN_COUNT = 20;
/**
 * 默认的上传 Token 接口请求参数
 */
const common_constants_defaultUploadTokenRequestParams = {
    app: '',
    type: '',
    count: 1,
    suffix: '',
    sig: '',
    sigTime: '',
    sigVersion: '1.3',
    version: '2',
};
/**
 * 获取默认的上传配置选项
 *
 * @since 4.6.1
 * @param options 可选；自定义配置选项
 */
function common_constants_getDefaultUploaderOptions(options) {
    return Object.assign({ debug: false, env: common_enum_UploadEnv.Release, accessToken: '', appProxy: false, sign: (params) => params, progress: (data) => data }, options);
}
/**
 * 默认的上传配置选项
 *
 * @deprecated 至 `v4.6.1` 版本起弃用，请改用 `getDefaultUploaderOptions()`
 */
const constants_defaultUploaderOptions = common_constants_getDefaultUploaderOptions();
/**
 * 默认的文件分片大小
 *
 * @since 4.6.0
 */
const constants_DEFAULT_PART_SIZE = 1024 * 1024 * 4;
/**
 * 默认的错误重试次数
 *
 * @since 4.8.0
 */
const constants_DEFAULT_RETRY_COUNT = 3;
/**
 * 限制最小分片大小
 *
 * @since 4.6.0
 *
 * - 云服务器限制，单个分片不允许小于 100kb
 */
const constants_MIN_PART_SIZE = 1024 * 100;

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/utils.js

/**
 * 键值对键名转换为小驼峰命名风格
 *
 * @param obj 键值对或键值对数组
 */
function common_utils_toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((item) => common_utils_toCamelCase(item));
    }
    else if (typeof obj === 'object') {
        const temp = {};
        for (const i in obj) {
            const key = i.replace(/_([A-Za-z])/g, (_$0, $1) => $1.toUpperCase());
            temp[key] = typeof obj[i] === 'object' ? common_utils_toCamelCase(obj[i]) : obj[i];
        }
        return temp;
    }
    else {
        return obj;
    }
}
/**
 * 键值对对象转换为请求字符串
 *
 * @param kv     键值对对象
 * @param filter 自定义过滤方法
 */
function common_utils_keyValueToQueryStrings(kv, filter) {
    return Object.entries(kv)
        .filter((_) => {
        if (filter) {
            return filter(_);
        }
        return _[1] !== 'undefined' && _[1] !== '';
    })
        .map(([key, value]) => `${key}=${value}`)
        .sort()
        .join('&');
}
/**
 * 判断当前是不是 S3 云存储服务
 *
 * @since 4.2.0
 * @param cloud 云服务名称
 */
function utils_isS3(cloud) {
    return cloud === Cloud.HuaweiS3 || cloud === Cloud.AWSS3 || cloud === Cloud.OSS;
}
/**
 * 获取文件的扩展名
 *
 * @since 4.2.0
 * @param fileName 文件名
 */
function common_utils_getFileExtension(fileName) {
    var _a;
    return ((_a = fileName.match(/\.(\w+)$/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
}
/**
 * 从 Data URL 中获取文件的扩展名
 *
 * @since 4.2.0
 * @param dataURL Data URL 字符串
 */
function common_utils_getFileExtensionByDataURL(dataURL) {
    var _a, _b, _c, _d, _e, _f;
    return (((_f = (_e = (_d = (_c = (_b = (_a = dataURL
        .split(',')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /:(.*?);/)) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.split('/')) === null || _f === void 0 ? void 0 : _f[1]) || '');
}
/**
 * 生成 TaskId
 *
 * @since 4.7.0
 */
function utils_generateTaskId() {
    var _a, _b;
    const _generateTaskId = () => {
        return '00000000-0000-4000-1000-000000000000'.replace(/[10]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === '0' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    try {
        if ((_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
            return window.crypto.randomUUID();
        }
        if ((_b = window === null || window === void 0 ? void 0 : window.crypto) === null || _b === void 0 ? void 0 : _b.getRandomValues) {
            const unsafeStringify = (arr) => {
                const byteToHex = [];
                let str = '';
                for (let i = 0; i < 256; ++i) {
                    byteToHex.push((i + 0x100).toString(16).slice(1));
                }
                for (let i = 0; i < 16; i++) {
                    str += byteToHex[arr[i]];
                    if ([3, 5, 7, 9].includes(i)) {
                        str += '-';
                    }
                }
                return str.toLowerCase();
            };
            return unsafeStringify(window.crypto.getRandomValues(new Uint8Array(16)));
        }
        return _generateTaskId();
    }
    catch (e) {
        return _generateTaskId();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/types/upload.js

/**
 * 创建上传结果数据
 *
 * @since 4.4.0
 * @param result 可选；结果数据
 */
function types_upload_createUploadResult(result = {}) {
    const _result = Object.assign({ data: '', url: '', key: '', etag: '', index: 0, fileSize: '', mimeType: '', type: '', size: 0, storage: Cloud.Unknown }, result);
    return _result;
}
/**
 * 上传错误类
 */
class types_upload_UploaderError extends Error {
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/types/index.js


;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/uploader.js



/**
 * 上传基类
 *
 * - 继承上传基类并实现抽象方法，可用于扩展实现新平台的上传功能；
 */
class uploader_UploaderBase {
    /**
     * 上传环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 是否为测试环境
     *
     * @getter
     * @readonly
     */
    get isTest() {
        return this.env === UploadEnv.Test;
    }
    /**
     * 控制台日志前缀
     *
     * @getter
     * @since 4.5.0
     * @readonly
     */
    get logPrefix() {
        return '';
    }
    /**
     * 上传 Token 接口地址
     *
     * @getter
     * @readonly
     * @abstract 从 `v4.3.0` 起，为了支持海外版本（使用海外域名，借助 Tree Shaking，避免构建产出文件中有 `meitu` 域名相关代码），在基类默认返回空字符串，相当于改为 `getter` 抽象属性（并保持版本兼容），要求各端扩展类实现该属性
     */
    get tokenApi() {
        return '';
    }
    /**
     * 美图帐号 Access Token
     *
     * @getter
     * @readonly
     */
    get accessToken() {
        return this.options.accessToken;
    }
    constructor(options) {
        /**
         * 上传配置选项
         *
         * @default getDefaultUploaderOptions()
         */
        this.options = getDefaultUploaderOptions();
        /**
         * 上传 Token 列表
         *
         * @default []
         */
        this.tokenList = [];
        /**
         * 上传重试次数/计数
         *
         * @default 0
         */
        this.retryCount = 0;
        /**
         * 当前 Token 列表序号
         *
         * @default 0
         */
        this.currentTokenIndex = 0;
        /**
         * 当前云厂商列表序号
         *
         * @default 0
         */
        this.currentCloudIndex = 0;
        /**
         * 代理上传类实例对象集合
         *
         * @protected
         * @since 4.5.0
         */
        this.proxies = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.debugLog('options =>', options);
        const { appProxy } = this.options;
        if (!this.tokenApi.trim() && !appProxy) {
            throw new UploaderError('成员属性 tokenApi 不能为空');
        }
        if (!/^https?:\/\//.test(this.tokenApi) && !appProxy) {
            throw new UploaderError('tokenApi 必要是有效的 HTTP(S) 地址');
        }
        const originSign = typeof (options === null || options === void 0 ? void 0 : options.sign) === 'function' ? this.options.sign.bind(this) : null;
        this.options.sign = (params) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (appProxy) {
                return params;
            }
            // 默认允许不实现，但是在调试模式下，控制台显示警告日志
            if (typeof originSign !== 'function') {
                if (this.debug) {
                    console.warn(this.logPrefix, '检测到目前没有实现参数签名方法选项 sign，存在安全风险，建议实现。');
                }
                return params;
            }
            this.debugLog('开始进行参数签名...');
            params = yield originSign(Object.assign(Object.assign(Object.assign({}, defaultUploadTokenRequestParams), { sigTime: `${Math.floor(new Date().getTime() / 1000)}` }), params));
            if (!(params === null || params === void 0 ? void 0 : params.sig) || ((_a = params === null || params === void 0 ? void 0 : params.sig) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                throw new UploaderError('上传参数签名参数 sig 不能为空');
            }
            if (((_b = params === null || params === void 0 ? void 0 : params.sig) === null || _b === void 0 ? void 0 : _b.length) !== 32) {
                throw new UploaderError('上传参数签名参数 sig 值不正确');
            }
            this.debugLog('参数签名完成！params =>', params);
            return params;
        });
    }
    /**
     * 获取文件扩展名
     *
     * @protected
     * @since 4.4.0
     * @param file 文件
     * @param params 上传请求参数
     */
    getFileSuffix(file, params) {
        let suffix = (params === null || params === void 0 ? void 0 : params.suffix) || '';
        if (typeof (params === null || params === void 0 ? void 0 : params.suffix) === 'undefined') {
            if (typeof file === 'string') {
                // 处理 DataURL 的文件形式
                if (/^data:/.test(file)) {
                    suffix = getFileExtensionByDataURL(file);
                }
                else {
                    suffix = getFileExtension(file);
                }
            }
            else if (file instanceof File) {
                suffix = getFileExtension(file.name);
            }
        }
        return suffix;
    }
    /**
     * 请求接口获取上传 Token
     *
     * @protected
     * @since 4.5.0
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    getUploadToken(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            const { multiple = false } = options;
            this.debugLog('[getUploadToken] options =>', options);
            let currentToken;
            // 获取上传 Token 列表
            if (!multiple) {
                this.tokenList = (options === null || options === void 0 ? void 0 : options.tokenList) || (yield this.requestToken(params));
                currentToken = this.tokenList[this.currentTokenIndex];
            }
            else {
                if (typeof (options === null || options === void 0 ? void 0 : options.uploadToken) !== 'object') {
                    throw new UploaderError('上传 Token 信息不存在');
                }
                currentToken = options.uploadToken;
            }
            return currentToken;
        });
    }
    /**
     * 多文件批量上传方法
     *
     * - 本方法是基于 [`upload()`](https://f2er.meitu.com/meitu-upload/api/upload/class/Uploader#upload) 方法扩展实现的，最多支持一次性上传 20 个文件；
     *
     * @async
     * @since 4.4.0
     * @param files 要批量上传的文件列表；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadMultiple(files_1, params_1) {
        return __awaiter(this, arguments, void 0, function* (files, params, options = {}) {
            var _a;
            this.debugLog('[uploadMultiple] files =>', files);
            this.debugLog('[uploadMultiple] params =>', params);
            this.debugLog('[uploadMultiple] options =>', options);
            if (files.length > MAX_TOKEN_COUNT) {
                throw new UploaderError('最多只允许一次性上传 20 个文件');
            }
            if ((params === null || params === void 0 ? void 0 : params.count) && (params === null || params === void 0 ? void 0 : params.count) !== files.length) {
                throw new UploaderError('上传 Token 获取数量与文件数量不一致');
            }
            const { appProxy } = this.options;
            const _options = Object.assign(Object.assign({}, options), { multiple: true });
            params.suffix = this.getFileSuffix(files[0], params);
            params.count = (_a = params === null || params === void 0 ? void 0 : params.count) !== null && _a !== void 0 ? _a : files.length;
            this.tokenList = appProxy ? [] : yield this.requestToken(params);
            // 大部分主流浏览器的同一个源最大并发请求数限制为 6 个，多出的请求会自动排队等待，所以这里不需要在手动维护请求队列，直接一起发送，交由浏览器管理请求队列
            const results = yield Promise.allSettled(Array.from({ length: appProxy ? files.length : this.tokenList.length }, (v, i) => i).map((i) => {
                return this.upload(files[i], params, Object.assign(Object.assign({}, _options), { tokenList: this.tokenList, uploadToken: this.tokenList[i], index: i }));
            }));
            this.reset();
            return results.map((result, index) => {
                if (result.status === 'fulfilled') {
                    return result.value;
                }
                else {
                    return createUploadResult({ index });
                }
            });
        });
    }
    /**
     * 请求上传所需的 Token
     *
     * @async
     * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=5313382
     * @param params 请求上传 Token 的参数
     * @returns 上传 Token 列表
     */
    requestToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { headers: headersParams = {} } = params, restParams = __rest(params, ["headers"]);
            const headers = {};
            // 如果 MAAT 安全策略平台有配置需要登录才能获取 token，则需要传入 accessToken 配置项
            if (this.options.accessToken) {
                headers['Access-Token'] = this.options.accessToken;
            }
            this.debugLog('[requestToken] params =>', restParams);
            if ((restParams === null || restParams === void 0 ? void 0 : restParams.count) > MAX_TOKEN_COUNT) {
                throw new UploaderError(`最多只允许一次性获取 ${MAX_TOKEN_COUNT} 个上传 Token`);
            }
            const signedParams = yield this.options.sign(restParams);
            this.debugLog('[requestToken] signedParams =>', signedParams);
            // 将键值对对象转换为请求字符串
            const queries = keyValueToQueryStrings(signedParams, (_) => {
                return _[1] !== 'undefined';
            });
            const protocol = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) || '';
            // 针对 pre 环境，token 请求地址协议与 location.protocol 同步，仅对 protocol 为 http 或 https 时生效，防止本地包内请求错误
            const tokenApi = /^http(s|):/.test(protocol) ? this.tokenApi.replace('http:', protocol) : this.tokenApi;
            // 请求获取上传 token 的接口
            const result = yield this.request(`${tokenApi}?${queries}`, {
                headers: Object.assign(Object.assign({}, headers), headersParams),
            });
            if (!result) {
                throw result;
            }
            if (result.status !== 200) {
                throw result;
            }
            if (typeof (result === null || result === void 0 ? void 0 : result.json) !== 'function') {
                throw new UploaderError('this.request() 方法的返回结果对象的 json() 方法没有实现');
            }
            // 将接口响应返回的所有字段转换为小驼峰
            const json = toCamelCase(yield result.json());
            this.debugLog('[requestToken] tokenList =>', json);
            return json;
        });
    }
    /**
     * 重置上传状态数据
     *
     * @protected
     * @since 4.5.0
     */
    reset() {
        this.proxies = {};
        this.tokenList = [];
        this.currentTokenIndex = 0;
        this.currentCloudIndex = 0;
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(`${this.logPrefix}[${this.constructor.name}]`, ...args);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/index.js





// EXTERNAL MODULE: ./node_modules/crypto-js/hmac-sha1.js
var hmac_sha1 = __webpack_require__(68398);
var hmac_sha1_default = /*#__PURE__*/__webpack_require__.n(hmac_sha1);
;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/multipart.js


/**
 * 请求头 Meta 信息前缀
 */
const headerMetaPrefix = 'x-obs-meta-';
/**
 * 请求头信息前缀
 */
const headerPrefix = 'x-amz-';
/**
 * 请求头信息字段列表
 */
const interestHeader = ['Content-MD5', 'Content-Type'];
/**
 * 获取请求头签名信息
 *
 * @since 4.6.0
 * @param options 请求配置
 */
function getHeaderSign(options) {
    let stringToSign = options.method + '\n';
    for (let i = 0; i < interestHeader.length; i++) {
        if (interestHeader[i] in options.headers) {
            stringToSign += options.headers[interestHeader[i]];
        }
        stringToSign += '\n';
    }
    if (!(headerPrefix + 'date' in options.headers)) {
        stringToSign += options.headers['Date'];
    }
    stringToSign += '\n';
    let temp = [];
    for (const originKey in options.headers) {
        if (Object.hasOwnProperty.call(options.headers, originKey)) {
            const lowerKey = originKey.toLowerCase();
            const value = options.headers[originKey];
            if (lowerKey.indexOf(headerPrefix) === 0) {
                temp.push({
                    key: lowerKey,
                    value,
                });
            }
        }
    }
    temp = temp.sort((a, b) => a.key - b.key);
    for (let i = 0; i < temp.length; i++) {
        const key = temp[i].key;
        const val = key.indexOf(headerMetaPrefix) === 0 ? temp[i].value.trim() : temp[i].value;
        stringToSign += key + ':' + val + '\n';
    }
    stringToSign += options.uri;
    return stringToSign;
}
/**
 * 获取请求头签名
 *
 * @since 4.6.0
 * @param ak 亚马逊 AWS S3 Access Key
 * @param sk 亚马逊 AWS S3 密钥
 * @param bucket 存储桶名
 * @param key 上传文件 Key
 * @param headers 请求头信息
 */
function getAuthorization(method, ak, sk, uri, headers) {
    const signString = getHeaderSign({
        method,
        headers,
        uri,
    });
    return `AWS ${ak}:${hmac_sha1_default()(signString, sk).toString((enc_base64_default()))}`;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/request.js
/**
 * S3 上传通用请求类配置
 */
/**
 * S3 上传通用请求
 */
class AjaxRequest {
    /**
     * 获取请求实例
     */
    get request() {
        return this.xhr;
    }
    constructor(options) {
        this.options = {
            method: 'POST',
            url: '',
            headers: {},
        };
        /**
         * XMLHttpRequest 请求实例对象
         */
        this.xhr = null;
        this.options = Object.assign(Object.assign({}, this.options), options);
        return this.createRequest();
    }
    /**
     * 创建请求
     */
    createRequest() {
        var _a;
        const { method, url, params = {}, headers, body, progress, success, failure, timeout } = this.options;
        const xhr = new XMLHttpRequest();
        if (url === '' || url === undefined || url === null) {
            throw new Error(`请求失败: url 不能为空`);
        }
        const paramsString = objectToUrlParams(params);
        const reqUrl = paramsString ? `${url}${url.indexOf('?') > -1 ? '&' : '?'}${paramsString}` : url;
        xhr.open(method, reqUrl, true);
        if (timeout !== undefined) {
            xhr.timeout = timeout;
        }
        this.xhr = xhr;
        if (headers) {
            for (const key in headers) {
                if (Object.prototype.hasOwnProperty.call(headers, key)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
        }
        // 请求进度监听
        (_a = xhr.upload) === null || _a === void 0 ? void 0 : _a.addEventListener('progress', (event) => {
            if (!event.lengthComputable) {
                return;
            }
            const loaded = event.loaded;
            const total = event.total;
            const percent = Math.round((loaded / total) * 100);
            progress === null || progress === void 0 ? void 0 : progress({
                total: {
                    percent,
                    loaded,
                    total,
                    size: total,
                },
            }, xhr);
        });
        xhr.onload = () => {
            try {
                const result = formatResponse(xhr);
                // 状态码 2xx 都认为是成功
                if (xhr.status < 300) {
                    result.ETag = xhr.getResponseHeader('etag') || '';
                    success(result, xhr);
                }
                else {
                    failure(result, xhr);
                }
            }
            catch (e) {
                failure === null || failure === void 0 ? void 0 : failure(e, xhr);
            }
        };
        xhr.onerror = (error) => {
            failure === null || failure === void 0 ? void 0 : failure(error, xhr);
        };
        xhr.onabort = () => {
            failure(new Error('upload abort'), xhr);
        };
        xhr.ontimeout = () => {
            failure(new Error('upload timeout'), xhr);
        };
        xhr.send(body);
        return this;
    }
    /**
     * 取消请求
     */
    abort() {
        var _a, _b;
        (_b = (_a = this.xhr) === null || _a === void 0 ? void 0 : _a.abort) === null || _b === void 0 ? void 0 : _b.call(_a);
        return this;
    }
    /**
     * 恢复请求
     */
    resume() {
        this.createRequest();
        return this;
    }
}
/**
 * 格式化接口返回的信息
 *
 * @param xhr 响应信息对象
 */
function formatResponse(xhr) {
    var _a, _b;
    const xmlToRecord = (xml) => {
        const data = {};
        xml.match(/<(\w+)>.*?<\/\1>/g).forEach((match) => {
            const tagName = match.match(/^<(\w+)>/)[1].replace(/^./, (c) => c.toLowerCase());
            const tagContent = match.replace(/<.*?>/g, '');
            data[tagName] = tagContent;
        });
        return data;
    };
    if (xhr.status !== 200) {
        let errorCode = xhr.status;
        let errorMsg = '';
        let errorMessage = `upload failed! HTTP ${xhr.status} ${xhr.statusText}`;
        // 如果返回的是 XML
        if (xhr.responseXML && xhr.responseText) {
            const xml = xhr.responseText;
            errorCode = ((_a = xml.match(/<Code>([^>]+)<\/Code>/)) === null || _a === void 0 ? void 0 : _a[1]) || '上传错误';
            errorMsg = ((_b = xml.match(/<Message>([^>]+)<\/Message>/)) === null || _b === void 0 ? void 0 : _b[1]) || '未知原因';
            errorMessage = `${errorCode}: ${errorMsg}`;
        }
        return {
            code: xhr.status,
            msg: errorMsg,
            message: errorMessage,
        };
    }
    if (xhr.responseXML) {
        return xmlToRecord(xhr.responseText);
    }
    return JSON.parse(xhr.responseText || '{}');
}
/**
 * 对象转 url params
 *
 * @param obj 要转码的对象
 */
function objectToUrlParams(obj) {
    const params = [];
    if (typeof obj !== 'object') {
        return `${obj}`;
    }
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            let value = obj[key] || '';
            if (typeof value === 'object') {
                value = objectToUrlParams(value);
            }
            if (value !== undefined && value !== null) {
                params.push(`${key}=${encodeURIComponent(`${value}`)}`);
            }
        }
    }
    return params.join('&');
}
/**
 * 将对象抓换成 XML
 *
 * @param obj 要转码的对象
 * @param sentAs 发送方式，消息组容器标签名
 * @param wrapper 外层容器标签名称
 */
function objectToXML(obj, sentAs, wrapper) {
    const tag = '<{T}>{V}</{T}>';
    const replace = (k, v) => tag.replace(/{T}/g, k).replace('{V}', v).replace(/"/g, '&quot;');
    const values = obj.map((item) => {
        let str = '';
        for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
                str += replace(key, item[key]);
            }
        }
        return replace(sentAs, str);
    });
    return replace(wrapper, values.join(''));
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/index.js



;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/multipart.js


/**
 * S3（AWS & 华为云）分段上传类
 *
 * @since 4.6.0
 */
class S3MultipartUploader {
    /**
     * 上传 Token 配置数据
     *
     * @getter
     * @readonly
     */
    get uploadToken() {
        return this.options.uploadToken;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 重试次数
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryCount() {
        var _a;
        return (_a = this.options.retryCount) !== null && _a !== void 0 ? _a : constants_DEFAULT_RETRY_COUNT;
    }
    /**
     * 当上传请求错误达到限定时，是否启用主备切换
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryBackupHost() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryBackupHost) !== null && _b !== void 0 ? _b : true;
    }
    constructor(options) {
        /**
         * XMLHttpRequest 请求实例对象
         *
         * @deprecated
         */
        this.xhr = null;
        /**
         * XMLHttpRequest 请求实例对象列表
         *
         * @since 4.7.0
         */
        this.xhrQueue = [];
        /**
         * 上传 ID
         */
        this.uploadId = '';
        /**
         * 分段缓存信息
         */
        this.cacheParts = {};
        /**
         * 初始化分段上传时的配置信息
         */
        this.formData = null;
        /**
         * 上传的分片
         */
        this.partNumber = 1;
        /**
         * 是否完成上传
         */
        this.isCompleted = true;
        /**
         * 是否有触发过取消上传
         */
        this.isCancel = false;
        /**
         * 分段上传方法配置信息
         */
        this.uploadPartOptions = {};
        /**
         * 缓存已经上传的切片数据
         *
         * @since 4.7.0
         */
        this.updatedPartCache = [];
        /**
         * 缓存已经上传的进度信息
         *
         * @since 4.7.0
         */
        this.updatedPartProgressCache = [];
        /**
         * 配置选项
         *
         * @protected
         */
        this.options = {
            debug: false,
            cloud: common_enum_Cloud.AWSS3,
            expirationSeconds: 600,
            partSize: constants_DEFAULT_PART_SIZE,
            index: 0,
            mimeType: '',
            file: '',
            tokenParams: {},
            uploadToken: {},
        };
        // 单个分片大小不能小于云服务器限制
        const partSize = Math.max((options === null || options === void 0 ? void 0 : options.partSize) || this.options.partSize, constants_MIN_PART_SIZE);
        this.options = Object.assign(Object.assign(Object.assign({ taskId: utils_generateTaskId() }, this.options), options), { partSize });
        this.debugLog('options =>', options);
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(constants_LOG_PREFIX + '[s3-multipart-uploader]', ...args);
    }
    /**
     * 获取分段上传链接
     *
     * @param queryString 额外的请求参数
     * @protected
     */
    getUploadUrl(queryString = '', useBackupHost = false) {
        const { url, bucket, key, backupUrl } = this.uploadToken;
        const uploadHost = useBackupHost && backupUrl ? backupUrl : url;
        return `${uploadHost.replace(/:\/\//, `://${bucket}.`)}/${key}${queryString ? `?${queryString}` : ''}`;
    }
    /**
     * 初始化分段上传
     *
     * 获取分段上传 uploadId
     *
     * @param formData 表单数据
     * @param success 请求成功回调
     * @param failure 请求失败回调
     */
    initMultipartUpload(formData, success, failure) {
        this.formData = formData;
        this.updatedPartCache = [];
        this.updatedPartProgressCache = [];
        this.xhrQueue = [];
        return new Promise((resolve, reject) => {
            try {
                this.request({
                    method: 'POST',
                    url: this.getUploadUrl('uploads'),
                    headers: {
                        'Content-Type': formData['Content-Type'],
                        'x-amz-meta-property': 'property-value',
                        'x-amz-security-token': formData['X-Amz-Security-Token'],
                    },
                    success: (result) => {
                        this.debugLog('initMultipartUpload result =>', result);
                        this.uploadId = result.uploadId;
                        success === null || success === void 0 ? void 0 : success(result);
                        resolve(result);
                    },
                    failure: (err) => {
                        var _a, _b;
                        this.debugLog('initMultipartUpload failure =>', err);
                        failure === null || failure === void 0 ? void 0 : failure(err);
                        (_b = (_a = this.options).failure) === null || _b === void 0 ? void 0 : _b.call(_a, err, this.options.index);
                        reject(err);
                    },
                });
            }
            catch (e) {
                reject(e);
            }
        });
    }
    /**
     * 上传指定的分段信息
     *
     * @param options 配置选项
     * @param retry 重试计数
     * @since 4.7.0
     * @protected
     */
    uploadSpecifiedPart(options) {
        const { url, backupUrl } = this.uploadToken;
        const { file, partNumber, uploadId: _uploadId, success, progress, failure } = options;
        const uploadId = _uploadId || this.uploadId || '';
        return new Promise((resolve, reject) => {
            const _upload = (retry = 0, useBackupHost = false) => {
                this.request({
                    method: 'PUT',
                    url: this.getUploadUrl('', useBackupHost),
                    headers: {
                        'Content-Type': 'binary/octet-stream',
                        'x-amz-security-token': this.formData['X-Amz-Security-Token'],
                    },
                    body: file,
                    params: {
                        partNumber,
                        uploadId,
                    },
                    failure: (err) => {
                        if (!this.isCancel) {
                            if (retry < this.retryCount) {
                                _upload(retry + 1, useBackupHost);
                                return;
                            }
                            // 主备切换并进行错误重试
                            if (!useBackupHost && this.retryBackupHost && backupUrl && url !== backupUrl) {
                                _upload(0, true);
                                return;
                            }
                        }
                        failure === null || failure === void 0 ? void 0 : failure(err, partNumber);
                        reject(err);
                    },
                    progress: ({ total }) => {
                        progress === null || progress === void 0 ? void 0 : progress({
                            index: this.options.index,
                            taskId: this.options.taskId,
                            total,
                        });
                    },
                    success: (result) => {
                        success === null || success === void 0 ? void 0 : success({
                            PartNumber: partNumber,
                            ETag: result.ETag,
                        });
                        resolve(result);
                    },
                });
            };
            _upload();
        });
    }
    /**
     * 上传分段信息
     *
     * @param options 配置选项
     */
    uploadPart(options = {}) {
        const { file, partSize, index, failure, progress, complete: _complete, maxConcurrent } = this.options;
        const { partNumber = 1, uploadId: _uploadId, autoComplete = true, complete } = options;
        const uploadId = _uploadId || this.uploadId || '';
        if (!this.formData || !uploadId) {
            throw new Error('请先执行 initMultipartUpload 获取配置信息');
        }
        this.uploadPartOptions = options;
        this.isCompleted = false;
        this.isCancel = false;
        // 上传的文件大小
        const fileSize = file.size;
        // 分段数量
        const partCount = Math.ceil(fileSize / partSize);
        const partCache = [];
        const _maxConcurrent = Math.max(1, maxConcurrent !== null && maxConcurrent !== void 0 ? maxConcurrent : partCount);
        let count = 0;
        while (count < partCount) {
            // 如果是断点续传 则仅上传未上传成功的内容
            partCache[count] = !this.updatedPartCache[count]
                ? file.slice(partSize * count, partSize * (count + 1))
                : undefined;
            count++;
        }
        const partCacheRequests = [];
        const counts = [...this.updatedPartProgressCache];
        let progressValue = 0;
        partCache.forEach((file, idx) => {
            if (!file || partCacheRequests.length >= _maxConcurrent) {
                return;
            }
            partCacheRequests.push(this.uploadSpecifiedPart({
                file,
                partNumber: idx + 1,
                progress: (result) => {
                    this.updatedPartProgressCache[idx] = counts[idx] = result.total.loaded;
                    progressValue = counts.reduce((a, b) => (a || 0) + (b || 0));
                    progress === null || progress === void 0 ? void 0 : progress({
                        index,
                        taskId: this.options.taskId,
                        total: {
                            total: fileSize,
                            loaded: progressValue,
                            size: fileSize,
                            percent: Math.min(Math.round((progressValue / fileSize) * 100), 100),
                        },
                    });
                },
                success: (res) => {
                    this.updatedPartCache[idx] = res;
                },
                failure: (err) => {
                    var _a;
                    // 失败后需要清除一下当前进度
                    delete this.updatedPartProgressCache[idx];
                    (_a = options.failure) === null || _a === void 0 ? void 0 : _a.call(options, err, partNumber);
                },
            }));
        });
        Promise.all(partCacheRequests)
            .then((...args) => {
            var _a;
            this.debugLog('UploadPart success =>', args);
            const updatedPartCache = [...this.updatedPartCache].filter((d) => !!d);
            if (updatedPartCache.length < partCount) {
                this.uploadPart(options);
                return;
            }
            this.cacheParts[uploadId] = [...this.updatedPartCache];
            this.updatedPartCache = [];
            if (updatedPartCache.length === partCount && autoComplete) {
                this.completeMultipartUpload({
                    success: (result) => {
                        complete === null || complete === void 0 ? void 0 : complete(result);
                        _complete === null || _complete === void 0 ? void 0 : _complete(result);
                    },
                });
            }
            (_a = options.success) === null || _a === void 0 ? void 0 : _a.call(options, this.cacheParts[uploadId]);
        })
            .catch((err) => {
            this.debugLog('UploadPart failure =>', err);
            failure === null || failure === void 0 ? void 0 : failure(err, index);
        });
    }
    /**
     * 完成分段上传
     *
     * @param options
     */
    completeMultipartUpload(options = {}) {
        const { index, cloud, mimeType, tokenParams, file, uploadToken: { data, accessUrl, key }, failure, } = this.options;
        const uploadId = options.uploadId || this.uploadId || '';
        const cacheParts = this.cacheParts[uploadId];
        this.isCancel = false;
        if (!this.formData || !uploadId) {
            throw new Error('请先执行 initMultipartUpload 获取配置信息');
        }
        if (cacheParts === undefined || cacheParts.length === 0) {
            throw new Error('请先上传分段信息');
        }
        this.request({
            method: 'POST',
            url: this.getUploadUrl(),
            exposureXHR: false, // 合并阶段不在允许中断操作
            headers: {
                'Content-Type': 'binary/octet-stream',
                'x-amz-security-token': this.formData['X-Amz-Security-Token'],
            },
            body: objectToXML(cacheParts, 'Part', 'CompleteMultipartUpload'),
            params: {
                uploadId,
            },
            failure: (err) => {
                var _a;
                (_a = options.failure) === null || _a === void 0 ? void 0 : _a.call(options, err);
                failure === null || failure === void 0 ? void 0 : failure(err, index);
            },
            success: () => {
                var _a;
                delete this.cacheParts[uploadId];
                this.isCompleted = true;
                const fileSize = (file === null || file === void 0 ? void 0 : file.size) || 0;
                const result = {
                    data,
                    key,
                    url: data,
                    etag: '',
                    size: fileSize,
                    fileSize: `${fileSize}`,
                    previewUrl: accessUrl,
                    storage: cloud,
                    mimeType,
                    type: tokenParams.type,
                    index,
                };
                this.debugLog('ComputeMultipartUploadRequest Result =>', result);
                (_a = options === null || options === void 0 ? void 0 : options.success) === null || _a === void 0 ? void 0 : _a.call(options, result);
            },
        });
    }
    /**
     * 取消指定桶中的分段上传任务
     */
    abortMultipartUpload(id = '', success, failure) {
        const uploadId = id || this.uploadId;
        if (!uploadId) {
            return;
        }
        this.request({
            method: 'DELETE',
            url: this.getUploadUrl(),
            headers: {
                'Content-Type': 'binary/octet-stream',
                'x-amz-security-token': this.formData['X-Amz-Security-Token'],
            },
            params: {
                uploadId,
            },
            failure: (error) => {
                failure === null || failure === void 0 ? void 0 : failure(error);
            },
            success: () => {
                delete this.cacheParts[uploadId];
                this.xhrQueue = [];
                this.updatedPartCache = [];
                this.partNumber = 1;
                this.uploadId = '';
                this.uploadPartOptions = {};
                success === null || success === void 0 ? void 0 : success();
            },
        });
    }
    /**
     * 取消上传
     */
    cancel() {
        this.isCancel = true;
        if (this.xhrQueue.length) {
            this.xhrQueue.forEach((xhr) => { var _a; return (_a = xhr === null || xhr === void 0 ? void 0 : xhr.abort) === null || _a === void 0 ? void 0 : _a.call(xhr); });
        }
        // 如果没有启用断点续传则需要删除
        if (this.uploadId && this.options.resumable === false) {
            this.abortMultipartUpload();
        }
    }
    /**
     * 同  cancel 用于兼容自定义请求
     */
    abort() {
        this.cancel();
    }
    /**
     * 断点续传
     */
    resume() {
        // 只允许未完成并且触发过取消的任务执行断点续传
        if (this.isCompleted || !this.isCancel) {
            return;
        }
        // 如果没有启用断点续传则不进行任何处理
        if (this.options.resumable === false) {
            this.initMultipartUpload(this.formData).then(() => {
                this.uploadPart();
            });
            return;
        }
        this.uploadPart(this.uploadPartOptions);
    }
    /**
     * 创建分段上传相关请求
     *
     * @param options
     * @protected
     */
    request(options) {
        const { url, method, params, exposureXHR = true } = options;
        const headers = Object.assign({ 'x-amz-date': new Date().toUTCString() }, options === null || options === void 0 ? void 0 : options.headers);
        const settings = Object.assign(Object.assign({}, options), { exposureXHR, headers: Object.assign(Object.assign({}, headers), { Authorization: this.getAuthorization({
                    url,
                    method,
                    params,
                    headers,
                }) }) });
        const xhr = this.options.request ? this.options.request.bind(this)(settings) : new AjaxRequest(settings);
        this.xhr = xhr;
        if (exposureXHR) {
            this.xhrQueue.push(xhr);
        }
    }
    /**
     * 获取请求头签名
     *
     * @param options 获取请求头签名配置
     */
    getAuthorization(options) {
        const { credentials, key, bucket } = this.uploadToken;
        const { url, method, headers, params = {} } = options;
        const paramsString = objectToUrlParams(params);
        const uri = paramsString ? `${url}${url.indexOf('?') > -1 ? '&' : '?'}${paramsString}` : url;
        const urlSearch = uri.split('?')[1];
        return getAuthorization(method, credentials.accessKey, credentials.secretKey, `/${bucket}/${key}${urlSearch ? `?${urlSearch}` : ''}`, headers);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/index.js









/**
 * 获取 S2 参数签名值（v4 版本）
 *
 * @param secretKey 上传 Token 接口下发的密钥
 * @param dateStamp 上传日期（`yyyymmdd`）
 * @param region 云存储区位/位置
 * @param service 可选；云服务名称；默认值为 `s3`
 */
function getSignatureKey(secretKey, dateStamp, region, service = 's3') {
    const dateKey = hmac_sha256_default()(dateStamp, 'AWS4' + secretKey);
    const regionKey = hmac_sha256_default()(region, dateKey);
    const serviceKey = hmac_sha256_default()(service, regionKey);
    const signingKey = hmac_sha256_default()('aws4_request', serviceKey);
    return signingKey;
}
/**
 * S3（AWS & 华为云）表单上传类
 *
 * @since 4.2.0
 * @link https://docs.aws.amazon.com/zh_cn/AmazonS3/latest/API/sigv4-UsingHTTPPOST.html
 * @link https://docs.aws.amazon.com/zh_cn/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
 */
class S3Uploader {
    /**
     * 任务 ID
     *
     * @since 4.7.0
     * @getter
     * @readonly
     */
    get taskId() {
        return this._taskId;
    }
    /**
     * 云存储服务名称
     *
     * @getter
     * @readonly
     */
    get cloud() {
        return this.options.cloud;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 上传的文件
     *
     * @getter
     * @readonly
     */
    get file() {
        return this.options.file;
    }
    /**
     * 上传 Token 配置数据
     *
     * @getter
     * @readonly
     */
    get uploadToken() {
        return this.options.uploadToken;
    }
    /**
     * 上传链接地址
     *
     * @getter
     * @readonly
     */
    get uploadUrl() {
        return this.getUploadUrl();
    }
    /**
     * 错误重试次数
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryCount() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryCount) !== null && _b !== void 0 ? _b : constants_DEFAULT_RETRY_COUNT;
    }
    /**
     * 当上传请求错误达到限定时，是否启用主备切换
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryBackupHost() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryBackupHost) !== null && _b !== void 0 ? _b : true;
    }
    /**
     * 获取上传链接地址
     *
     * @since 4.8.0
     * @param useBackupHost 是否使用备份
     */
    getUploadUrl(useBackupHost = false) {
        const { url, bucket, backupUrl } = this.uploadToken;
        const uploadHost = useBackupHost && backupUrl ? backupUrl : url;
        if (uploadHost.indexOf(`${bucket}.`) >= 0) {
            return uploadHost;
        }
        return uploadHost.replace(/(https?:\/\/)/, `$1${bucket}.`);
    }
    constructor(options) {
        /**
         * 配置选项
         *
         * @protected
         */
        this.options = {
            debug: false,
            cloud: common_enum_Cloud.AWSS3,
            expirationSeconds: 600,
            index: 0,
            file: '',
            tokenParams: {},
            mimeType: '',
            uploadToken: {},
        };
        /**
         * XMLHttpRequest 请求实例对象
         *
         * @since 4.5.0
         */
        this.xhr = null;
        /**
         * 分段上传实例对象
         *
         * @since 4.5.2
         * @protected
         */
        this.multipartUploader = null;
        /**
         * 是否完成上传
         *
         * @since 4.5.2
         * @protected
         */
        this.isCompleted = true;
        /**
         * 是否有触发过取消上传
         *
         * @since 4.6.0
         * @protected
         */
        this.isCancel = false;
        /**
         * 表单上传配置信息缓存
         *
         *  @since 4.8.0
         *  @protected
         */
        this._uploadOptionsCache = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this._taskId = utils_generateTaskId();
        this.debugLog('options =>', options);
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(constants_LOG_PREFIX + '[s3-uploader]', ...args);
    }
    /**
     * 获取 S3 上传凭证标识
     *
     * @param YYYYMMDD 上传日期；格式：`yyyymmdd`
     */
    getCredential(YYYYMMDD) {
        const { credentials, region } = this.uploadToken;
        return `${credentials.accessKey}/${YYYYMMDD}/${region}/s3/aws4_request`;
    }
    /**
     * 参与签名的表单数据
     *
     * 与上传的表单数据顺序要一一对应，否则无法通过参数签名校验
     *
     * @param date 上传日期时间对象
     */
    getSingedFormData(date) {
        const { credentials } = this.uploadToken;
        return {
            // eslint-disable-next-line camelcase
            success_action_status: '200',
            'X-Amz-Credential': this.getCredential(date.YYYYMMDD),
            'X-Amz-Algorithm': 'AWS4-HMAC-SHA256',
            'X-Amz-Security-Token': credentials.sessionToken,
            'X-Amz-Date': date.iso8601,
        };
    }
    /**
     * 获取当前上传及过期日期时间
     */
    getUploadDateTime() {
        const { expirationSeconds } = this.options;
        const now = Date.now();
        const isoDate = new Date(now).toISOString();
        return {
            YYYYMMDD: isoDate.match(/\d+-\d+-\d+/)[0].replace(/-/g, ''),
            iso8601: isoDate.replace(/\.\d{3}Z$/, 'Z').replace(/[:-]|\.\d{3}/g, ''),
            expiration: new Date(now + expirationSeconds * 1000).toISOString(),
        };
    }
    /**
     * 创建上传策略配置
     *
     * 用于创建上传签名数据
     *
     * @param date 上传及过期日期时间数据
     * @param fileKeyPrefix 可选；允许上传的文件名 Key 前缀
     * @param contentType 可选；允许上传的文件内容类型（前缀）
     */
    createPolicy(date, fileKeyPrefix, contentType) {
        const { mimeType = '' } = this.options;
        const { bucket, key } = this.uploadToken;
        const policy = {
            expiration: date.expiration,
            // 在表单中指定的每个表单字段（具有 x-ignore- 前缀的 、file、policy 和 x-amz-signature 字段名称除外）都必须出现在条件列表中。
            conditions: [
                { bucket },
                ['starts-with', '$key', fileKeyPrefix !== null && fileKeyPrefix !== void 0 ? fileKeyPrefix : `${key.indexOf('/') >= 0 ? key.split('/')[0] + '/' : ''}`],
                [
                    'starts-with',
                    '$Content-Type',
                    contentType !== null && contentType !== void 0 ? contentType : `${mimeType.indexOf('/') >= 0 ? mimeType.split('/')[0] + '/' : ''}`,
                ],
                ...Object.entries(this.getSingedFormData(date)).map(([key, value]) => {
                    return { [key]: value };
                }),
            ],
        };
        const policyBase64 = enc_base64_default().stringify(enc_utf8_default().parse(JSON.stringify(policy)));
        this.debugLog('policy =>', JSON.stringify(policy, null, '    '));
        return {
            policy,
            policyBase64,
        };
    }
    /**
     * 获取上传参数签名值
     *
     * @param date 上传日期时间对象
     * @param policyBase64 上传策略（Base64 编码）
     */
    createSignature(date, policyBase64) {
        const { credentials, region } = this.uploadToken;
        const { secretKey } = credentials;
        const signingKey = getSignatureKey(secretKey, date.YYYYMMDD, region);
        const signature = hmac_sha256_default()(policyBase64, signingKey).toString((enc_hex_default()));
        return signature;
    }
    /**
     * 创建上传表单数据键值对对象
     */
    createFormData() {
        const { mimeType } = this.options;
        const { key } = this.uploadToken;
        const date = this.getUploadDateTime();
        const { policyBase64 } = this.createPolicy(date);
        const signature = this.createSignature(date, policyBase64);
        const formData = Object.assign(Object.assign({ key, 'Content-Type': mimeType }, this.getSingedFormData(date)), { Policy: policyBase64, 'X-Amz-Signature': signature });
        this.debugLog('formData =>', JSON.stringify(formData, null, '    '));
        return formData;
    }
    /**
     * POST 表单上传方法
     */
    upload() {
        if (typeof FormData === 'undefined') {
            throw new Error('FormData undefined');
        }
        const formData = new FormData();
        const data = this.createFormData();
        const file = this.file;
        const { index, partSize = constants_DEFAULT_PART_SIZE } = this.options;
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });
        formData.append('file', file);
        if (typeof XMLHttpRequest === 'undefined') {
            throw new Error('XMLHttpRequest undefined');
        }
        this.isCompleted = false;
        this.isCancel = false;
        this.multipartUploader = null;
        return new Promise((resolve, reject) => {
            const onComplete = (result) => {
                var _a, _b;
                this.debugLog('result =>', result);
                this.isCompleted = true;
                this.isCancel = false;
                (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a, result);
                resolve(result);
            };
            const onError = (error) => {
                var _a, _b;
                this.debugLog('upload: error > xhr =>', this.xhr, error);
                (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.failure) === null || _b === void 0 ? void 0 : _b.call(_a, error, index);
                // 非用户主动触发的中止操作才结束任务
                if (!this.isCancel) {
                    reject(error);
                }
            };
            if (typeof file !== 'string' && file.size > constants_MIN_PART_SIZE && file.size > partSize) {
                const multipartUploader = new S3MultipartUploader(Object.assign(Object.assign({}, this.options), { complete: onComplete, failure: (err) => {
                        onError(err);
                    } }));
                this.multipartUploader = multipartUploader;
                multipartUploader.initMultipartUpload(data).then(() => {
                    multipartUploader.uploadPart();
                });
                return;
            }
            this._upload({
                formData,
                onComplete,
                onError,
            });
        });
    }
    /**
     * POST 表单上传方法
     *
     * @since 4.8.0
     * @protected
     */
    _upload(options) {
        const { index } = this.options;
        const { url, backupUrl } = this.uploadToken;
        const { onComplete, onError, useBackupHost = false, retry = 0, formData } = options;
        let fileSize = 0;
        this._uploadOptionsCache = {
            formData,
            onComplete,
            onError,
        };
        if (!formData) {
            return;
        }
        const instance = new AjaxRequest({
            method: 'POST',
            url: this.getUploadUrl(useBackupHost),
            body: formData,
            progress: (result) => {
                var _a, _b, _c;
                if (fileSize === 0) {
                    fileSize = (_a = result.total) === null || _a === void 0 ? void 0 : _a.total;
                }
                (_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.progress) === null || _c === void 0 ? void 0 : _c.call(_b, Object.assign({ index, taskId: this.taskId }, result));
            },
            success: (_res, xhr) => {
                this.debugLog('upload: onload xhr =>', xhr);
                const { tokenParams, mimeType } = this.options;
                const { data, accessUrl, key } = this.uploadToken;
                const result = {
                    data,
                    url: data,
                    key,
                    etag: '',
                    index,
                    size: fileSize,
                    fileSize: `${fileSize}`,
                    previewUrl: accessUrl,
                    storage: this.cloud,
                    mimeType,
                    type: tokenParams.type,
                };
                onComplete(result);
            },
            failure: (error) => {
                // 非用户主动触发的中止操作时进行错误重试
                if (!this.isCancel) {
                    // 进行错误重试
                    if (retry < this.retryCount) {
                        this._upload(Object.assign(Object.assign({}, options), { retry: retry + 1 }));
                        return;
                    }
                    // 主备切换并进行错误重试
                    if (!useBackupHost && this.retryBackupHost && backupUrl && backupUrl !== url) {
                        this._upload(Object.assign(Object.assign({}, options), { retry: 0, useBackupHost: true }));
                        return;
                    }
                }
                onError(error);
            },
        });
        this.xhr = instance.request;
    }
    /**
     * 取消上传
     *
     * @since 4.5.0
     */
    cancel() {
        var _a, _b, _c;
        this.isCancel = true;
        (_a = this.xhr) === null || _a === void 0 ? void 0 : _a.abort();
        (_c = (_b = this.multipartUploader) === null || _b === void 0 ? void 0 : _b.cancel) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * 断点续传
     *
     * @since 4.6.0
     */
    resume() {
        var _a, _b;
        if (this.multipartUploader) {
            (_b = (_a = this.multipartUploader) === null || _a === void 0 ? void 0 : _a.resume) === null || _b === void 0 ? void 0 : _b.call(_a);
            return;
        }
        // 只允许未完成并且触发过取消的任务执行断点续传
        if (this.isCompleted || !this.isCancel) {
            return;
        }
        if (this._uploadOptionsCache.formData) {
            this.isCancel = false;
            this._upload(Object.assign({}, this._uploadOptionsCache));
            return;
        }
        this.upload();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/s3.js




/**
 * S3 上传基类
 *
 * - 使用场景：如果固定配置使用 AWS / 华为云 S3 上传时，可以用于平替 `UploaderBase` 类，去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss`
 *
 * @since 4.5.0
 */
class S3UploaderBase extends UploaderBase {
    constructor() {
        super(...arguments);
        this.tasks = {};
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            const { debug } = this.options;
            const { index = 0, multiple = false } = options || {};
            try {
                params.suffix = this.getFileSuffix(file, params);
                const currentToken = yield this.getUploadToken(params, options);
                const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[this.currentCloudIndex];
                const uploadToken = currentToken === null || currentToken === void 0 ? void 0 : currentToken[cloud];
                const _file = checkUploadFileType(file, params.suffix);
                const uploader = new S3Uploader({
                    file: _file,
                    cloud,
                    debug,
                    index,
                    uploadToken,
                    mimeType: _file.type,
                    progress: options === null || options === void 0 ? void 0 : options.progress,
                    complete: options === null || options === void 0 ? void 0 : options.complete,
                    resumable: options === null || options === void 0 ? void 0 : options.resumable,
                    retryCount: options === null || options === void 0 ? void 0 : options.retryCount,
                    partSize: options === null || options === void 0 ? void 0 : options.partSize,
                    maxConcurrent: options === null || options === void 0 ? void 0 : options.maxConcurrent,
                    retryBackupHost: options === null || options === void 0 ? void 0 : options.retryBackupHost,
                    tokenParams: params,
                });
                this.tasks[`${uploader.taskId}`] = uploader;
                const result = yield uploader.upload();
                delete this.tasks[`${uploader.taskId}}`];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                (_b = options === null || options === void 0 ? void 0 : options.failure) === null || _b === void 0 ? void 0 : _b.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        var _a, _b, _c, _d;
        if (taskId) {
            (_b = (_a = this.tasks) === null || _a === void 0 ? void 0 : _a[taskId]) === null || _b === void 0 ? void 0 : _b.cancel();
            return;
        }
        for (const i in this.tasks) {
            (_d = (_c = this.tasks) === null || _c === void 0 ? void 0 : _c[i]) === null || _d === void 0 ? void 0 : _d.cancel();
        }
    }
    resume(taskId) {
        var _a, _b, _c, _d;
        if (taskId) {
            (_b = (_a = this.tasks) === null || _a === void 0 ? void 0 : _a[taskId]) === null || _b === void 0 ? void 0 : _b.resume();
            return;
        }
        for (const i in this.tasks) {
            (_d = (_c = this.tasks) === null || _c === void 0 ? void 0 : _c[i]) === null || _d === void 0 ? void 0 : _d.resume();
        }
    }
}
/**
 * S3 上传类
 *
 * - 使用场景：如果固定配置使用 AWS / 华为云 S3 上传时，可以用于平替 `Uploader` 类，去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss`
 *
 * @since 4.5.0
 */
class s3_S3Uploader extends S3UploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/uploader.js





/**
 * Web 端上传类
 *
 * 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 */
class Uploader extends UploaderBaseWeb {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            const getProxy = (cloud) => {
                let uploader;
                if (isS3(cloud)) {
                    uploader = new s3_S3Uploader(this.options);
                }
                else {
                    uploader = new QiniuUploader(this.options);
                }
                this.debugLog('[upload] getProxy =>', { cloud, uploader });
                return uploader;
            };
            return this.uploadProxy(getProxy, file, params, options);
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload/dist/esm/index.js
/* eslint-disable import/export */


const $class = Uploader; // 可根据不同环境使用不同平台的上传类实现
class esm_Uploader extends $class {
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var dist_utils_request = __webpack_require__(57526);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/env.js
var env = __webpack_require__(84999);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/services/index.js





var fopCreate = function fopCreate(data) {
    var _getConfig = getConfig(), isIntl = _getConfig.isIntl, env = _getConfig.env, appName = _getConfig.appName;
    var requestConfig = {};
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            requestConfig.baseURL = webApiUrlStariiMap["beta"];
        }
    }
    return request.post("/v1/fop/create", data, requestConfig);
};
var fopQuery = function fopQuery(params) {
    var _getConfig2 = getConfig(), isIntl = _getConfig2.isIntl, env = _getConfig2.env, appName = _getConfig2.appName;
    var baseURL;
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            baseURL = webApiUrlStariiMap["beta"];
        }
    }
    return request.get("/v1/fop/query", {
        params: params,
        baseURL: baseURL
    });
};
/**
 * 获取obs app 配置
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/153151
 * @returns
 */ var fetchObsConfig = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee(params) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,dist_utils_request/* default */.ZP)({
                        method: "GET",
                        url: "/v1/obs_config/get_app",
                        params: params,
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchObsConfig(_x) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/config.js




var config_UploadEnv = /*#__PURE__*/ function(UploadEnv) {
    UploadEnv["Release"] = "Release";
    UploadEnv["Test"] = "Test";
    return UploadEnv;
}({});
var config_DEFAULT_PART_SIZE = 4 * 1024 * 1024;
var defaultConfig = {
    app: "xiuxiu-pro",
    env: config_UploadEnv.Release,
    type: "",
    partSize: config_DEFAULT_PART_SIZE
};
var setUploadConfig = function setUploadConfig(config) {
    Object.assign(defaultConfig, config);
};
var getUploadConfig = function getUploadConfig() {
    return defaultConfig;
};
var getDefaultObsConfig = function getDefaultObsConfig() {
    var _getConfig = (0,configProvider/* getConfig */.iE)(), isIntl = _getConfig.isIntl, appName = _getConfig.appName;
    var obsConfig = {
        sig: false,
        // 是否需要加签
        app: isIntl && appName === "x-design" ? "x-design" : "xiuxiu-pro",
        // 默认非定制版的
        uploadOptions: {}
    };
    return obsConfig;
};
// 异步获取配置信息
var getObsConfigAsync = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee(params) {
        var obsConfig, resObsCfg;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    obsConfig = getDefaultObsConfig();
                    _context.prev = 1;
                    _context.next = 4;
                    return fetchObsConfig(params);
                case 4:
                    resObsCfg = _context.sent;
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig.app = resObsCfg === null || resObsCfg === void 0 ? void 0 : resObsCfg.app;
                        obsConfig.sig = !!(resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.sig);
                        // 上传配置信息
                        if (resObsCfg.config.partSize) obsConfig.uploadOptions.partSize = resObsCfg.config.partSize;
                        if (resObsCfg.config.concurrency) obsConfig.uploadOptions.maxConcurrent = resObsCfg.config.concurrency;
                    }
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                    ;
                case 11:
                    return _context.abrupt("return", obsConfig);
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function getObsConfigAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();
// 分片配置获取, 只获取一次
var sliceConfig;
var sliceConfigPromise = null;
var getSliceConfigAsync = /*#__PURE__*/ function() {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee3() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    if (!sliceConfig) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfig);
                case 2:
                    if (!sliceConfigPromise) {
                        _context3.next = 4;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfigPromise);
                case 4:
                    // 创建新的 Promise 并缓存
                    sliceConfigPromise = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
                        var _getConfig2, module_id, config, resObsCfg;
                        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                            while(1)switch(_context2.prev = _context2.next){
                                case 0:
                                    _getConfig2 = (0,configProvider/* getConfig */.iE)(), module_id = _getConfig2.module_id;
                                    config = {
                                        partSize: config_DEFAULT_PART_SIZE
                                    };
                                    _context2.prev = 2;
                                    _context2.next = 5;
                                    return fetchObsConfig({
                                        project: module_id
                                    });
                                case 5:
                                    resObsCfg = _context2.sent;
                                    if (resObsCfg.config.partSize) config.partSize = resObsCfg.config.partSize;
                                    if (resObsCfg.config.concurrency) config.maxConcurrent = resObsCfg.config.concurrency;
                                    _context2.next = 13;
                                    break;
                                case 10:
                                    _context2.prev = 10;
                                    _context2.t0 = _context2["catch"](2);
                                    ;
                                case 13:
                                    sliceConfig = config;
                                    sliceConfigPromise = null;
                                    return _context2.abrupt("return", config);
                                case 16:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, null, [
                            [
                                2,
                                10
                            ]
                        ]);
                    }))();
                    return _context3.abrupt("return", sliceConfigPromise);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getSliceConfigAsync() {
        return _ref2.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/file-type/index.js
var file_type = __webpack_require__(97769);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/utils/file.js







// 获取文件类型，兼容file.type为空的情况
function getFileType(file) {
    return new Promise(function(resolve, reject) {
        /**
     * TODO，mimeType获取待优化。先默认获取file.type
     * 依赖file-type获取svg的mimeType不同文件也有各种问题，变成application/xml或空的
     */ if (file.type && file.type === "image/svg+xml") return resolve(file.type);
        // ATTENTION: safari < 14 不支持 file.arrayBuffer
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/ function() {
            var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee(e) {
                var _e$target;
                var fileType;
                return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
                    while(1)switch(_context.prev = _context.next){
                        case 0:
                            if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.result) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", reject(new Error("no result")));
                        case 2:
                            _context.next = 4;
                            return (0,file_type.fromBuffer)(new Uint8Array(e.target.result));
                        case 4:
                            fileType = _context.sent;
                            if (fileType !== null && fileType !== void 0 && fileType.mime) {
                                _context.next = 7;
                                break;
                            }
                            return _context.abrupt("return", reject(new Error("getFiletype error")));
                        case 7:
                            return _context.abrupt("return", resolve(fileType.mime));
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }();
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
// blob转file
function blobToFile(blob, name) {
    var type = blob.type;
    return new File([
        blob
    ], name, {
        type: type
    });
}
// 文件转图片
function file2Image(file) {
    return new Promise(function(resolve, reject) {
        if (!file || !file.type.startsWith("image/")) {
            reject(new Error("Please provide a valid image file."));
            return;
        }
        var reader = new FileReader();
        // 读取文件完成后触发
        reader.onload = function() {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = function(err) {
                return reject(err);
            };
            img.src = reader.result;
        };
        // 文件读取失败
        reader.onerror = function() {
            reject(new Error("Error reading file."));
        };
        // 开始读取文件
        reader.readAsDataURL(file);
    });
}
// IOS13.4.1和chrome81版本以上的浏览器不用手动翻转
var __AutoCanvasNormalize;
var autoCanvasNormalize = function autoCanvasNormalize() {
    if (__AutoCanvasNormalize !== undefined) {
        return __AutoCanvasNormalize;
    }
    var ua = navigator.userAgent;
    // 判断 iPhone 操作系统版本
    var iosVersionMatch = ua.match(/iPhone OS (\d+_\d+(_\d+)?)/);
    var iosVersionValid = false;
    if (iosVersionMatch) {
        var versionString = iosVersionMatch[1];
        ;
        var _versionString$split$ = versionString.split("_").map(Number), _versionString$split$2 = _slicedToArray(_versionString$split$, 3), major = _versionString$split$2[0], minor = _versionString$split$2[1], patch = _versionString$split$2[2];
        var currentVersion = major * 10000 + minor * 100 + (patch || 0);
        var targetVersion = 13 * 10000 + 4 * 100 + 1; // 13.4.1 -> 13401
        iosVersionValid = currentVersion > targetVersion;
    }
    // 判断 Chrome 内核版本大于 81
    var chromeVersionMatch = ua.match(/Chrome\/(\d+)/);
    var chromeVersionValid = false;
    if (chromeVersionMatch) {
        var chromeVersion = parseInt(chromeVersionMatch[1], 10);
        ;
        chromeVersionValid = chromeVersion > 81;
    }
    // 判断 Safari 版本
    var safariVersionMatch = ua.match(/Version\/(\d+\.\d+)/);
    var safariVersionValid = false;
    if (safariVersionMatch) {
        var safariVersion = parseFloat(safariVersionMatch[1]);
        ;
        safariVersionValid = safariVersion >= 13.1; // 设定目标版本为 13.1
    }
    // 判断 Firefox 版本
    var firefoxVersionMatch = ua.match(/Firefox\/(\d+)/);
    var firefoxVersionValid = false;
    if (firefoxVersionMatch) {
        var firefoxVersion = parseInt(firefoxVersionMatch[1], 10);
        ;
        firefoxVersionValid = firefoxVersion >= 78; // 设定目标版本为 78
    }
    __AutoCanvasNormalize = iosVersionValid || chromeVersionValid || safariVersionValid || firefoxVersionValid;
    return __AutoCanvasNormalize;
};
// 修改旋转方向
function changeOrientation(file, orientation) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(/*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(resolve) {
            var blobURL, image, width, height, canvas, ctx;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        // 这个在safari16以下 如果有旋转的会有问题
                        // const image = await createImageBitmap(file);
                        blobURL = URL.createObjectURL(file);
                        _context2.next = 3;
                        return urlToImage(blobURL);
                    case 3:
                        image = _context2.sent;
                        URL.revokeObjectURL(blobURL);
                        width = image.width, height = image.height;
                        ;
                        canvas = document.createElement("canvas");
                        ctx = canvas.getContext("2d");
                        if (!autoCanvasNormalize()) {
                            _context2.next = 15;
                            break;
                        }
                        // canvas会自动摆正
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(image, 0, 0, width, height);
                        _context2.next = 37;
                        break;
                    case 15:
                        _context2.t0 = orientation;
                        _context2.next = _context2.t0 === 3 ? 18 : _context2.t0 === 6 ? 23 : _context2.t0 === 8 ? 28 : 33;
                        break;
                    case 18:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.rotate(Math.PI);
                        ctx.drawImage(image, -width, -height, width, height);
                        return _context2.abrupt("break", 37);
                    case 23:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(0.5 * Math.PI);
                        ctx.drawImage(image, 0, -height, width, height);
                        return _context2.abrupt("break", 37);
                    case 28:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(3 * Math.PI / 2);
                        ctx.drawImage(image, -width, 0, width, height);
                        return _context2.abrupt("break", 37);
                    case 33:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(image, 0, 0, width, height);
                        return _context2.abrupt("break", 37);
                    case 37:
                        canvas.toBlob(function(blob) {
                            resolve(blob);
                        }, file.type === "image/png" ? "image/png" : "image/jpeg");
                    case 38:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x2) {
            return _ref2.apply(this, arguments);
        };
    }());
}
// 获取图片旋转信息
function getImageOrientation(_x3) {
    return _getImageOrientation.apply(this, arguments);
}
// 摆正图片
function _getImageOrientation() {
    _getImageOrientation = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(arrayBuffer) {
        var _tags$Orientation, tags, orientation, value, parsedValue, firstValidValue;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return ExifReader.load(arrayBuffer);
                case 3:
                    tags = _context4.sent;
                    orientation = 1;
                    if ((_tags$Orientation = tags.Orientation) !== null && _tags$Orientation !== void 0 && _tags$Orientation.value) {
                        value = tags.Orientation.value;
                        if (typeof value === "number") {
                            // 直接使用数值
                            orientation = value;
                        } else if (typeof value === "string") {
                            // 转数字
                            parsedValue = parseInt(value, 10);
                            if (!isNaN(parsedValue)) {
                                orientation = parsedValue;
                            }
                        } else if (Array.isArray(value)) {
                            // XmpTags[]
                            firstValidValue = value.find(function(v) {
                                return typeof v.value === "number";
                            });
                            if (firstValidValue !== undefined && "value" in firstValidValue && typeof firstValidValue.value === "number") {
                                orientation = firstValidValue.value;
                            }
                        } else if (_typeof(value) === "object" && value !== null) {
                            // XmpTags
                            if ("value" in value && typeof value.value === "number") {
                                orientation = value.value;
                            }
                        }
                    }
                    return _context4.abrupt("return", orientation || 1);
                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4["catch"](0);
                    ;
                    return _context4.abrupt("return", 1);
                case 13:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _getImageOrientation.apply(this, arguments);
}
function normalizeImageFile(file) {
    if (file.type !== "image/jpeg") return file;
    ;
    var orientation = 1;
    return new Promise(function(resolve, reject) {
        // ATTENTION: safari < 14 不支持 file.arrayBuffer
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/ function() {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(e) {
                var _e$target2;
                var arrayBuffer, blob, normalizedFile;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while(1)switch(_context3.prev = _context3.next){
                        case 0:
                            if ((_e$target2 = e.target) !== null && _e$target2 !== void 0 && _e$target2.result) {
                                _context3.next = 2;
                                break;
                            }
                            return _context3.abrupt("return", reject(new Error("no result")));
                        case 2:
                            // 读取文件为 ArrayBuffer
                            arrayBuffer = e.target.result;
                            _context3.next = 5;
                            return getImageOrientation(arrayBuffer);
                        case 5:
                            orientation = _context3.sent;
                            if (!(!orientation || orientation === 1)) {
                                _context3.next = 8;
                                break;
                            }
                            return _context3.abrupt("return", resolve(file));
                        case 8:
                            _context3.next = 10;
                            return changeOrientation(file, orientation);
                        case 10:
                            blob = _context3.sent;
                            // 如果有处理后的 blob，转换为 File 对象并返回
                            normalizedFile = blob ? blobToFile(blob, file.name) : file;
                            return _context3.abrupt("return", resolve(normalizedFile));
                        case 13:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x4) {
                return _ref3.apply(this, arguments);
            };
        }();
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
function readFileAsArrayBuffer(file) {
    if (typeof file.arrayBuffer === "function") {
        return file.arrayBuffer();
    }
    // ATTENTION: safari < 14 不支持 file.arrayBuffer
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function(e) {
            var _e$target3;
            if ((_e$target3 = e.target) !== null && _e$target3 !== void 0 && _e$target3.result) {
                resolve(e.target.result);
            } else {
                reject(new Error("no result"));
            }
        };
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
/**
 * 将 Base64 字符串转换为 ArrayBuffer
 */ function base64ToArrayBuffer(base64) {
    var binaryString = atob(base64); // 解码 Base64
    var length = binaryString.length;
    var bytes = new Uint8Array(length);
    for(var i = 0; i < length; i++){
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
function fileToBase64(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            var base64 = reader.result;
            resolve(base64);
        };
        reader.onerror = function() {
            return reject(new Error("读取文件失败"));
        };
        reader.readAsDataURL(file);
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/utils/stat.js
function getBase64FileSize(base64String) {
    // 去掉 data URL 前缀（如果有的话）
    var base64 = base64String.split(",")[1] || base64String;
    // 计算原始字节大小
    var padding = (base64.match(/=+$/) || [
        ""
    ])[0].length;
    var sizeInBytes = base64.length * 3 / 4 - padding;
    return sizeInBytes;
}
function statUpload(fileData, type, extra) {
    var _window;
    if (!((_window = window) !== null && _window !== void 0 && (_window = _window.mtstat) !== null && _window !== void 0 && _window.track)) return;
    var startTime = extra.startTime, success = extra.success, partSize = extra.partSize, maxConcurrent = extra.maxConcurrent;
    var fileSize = 0;
    if (typeof fileData === "string") {
        fileSize = getBase64FileSize(fileData);
    } else {
        fileSize = fileData.size;
    }
    window.mtstat.track("upload_file_to_obs", {
        type: type,
        file_size: (fileSize / 1024 / 1024).toFixed(2),
        duraction: ((performance.now() - startTime) / 1000).toFixed(2),
        success: success ? 1 : 0,
        file_type: fileData instanceof File ? fileData.type : "base64",
        part_size: partSize || 0,
        max_concurrent: maxConcurrent || 0
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/obs.js
















var uploaderInstance = null;
function requestSignUploadParams(_x) {
    return _requestSignUploadParams.apply(this, arguments);
} // 获取上传实例
function _requestSignUploadParams() {
    _requestSignUploadParams = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee4(params) {
        var result, _ref4, _ref4$sig, sig, _ref4$sig_time, sigTime, _ref4$sig_version, sigVersion;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return dist_utils_request/* default.get */.ZP.get("".concat((0,env/* getApiHost */.G3)(), "/maat/getsign"), {
                        params: (0,lodash.omit)(params, [
                            "sig",
                            "sigVersion",
                            "sigTime"
                        ])
                    });
                case 2:
                    result = _context4.sent;
                    _ref4 = result, _ref4$sig = _ref4.sig, sig = _ref4$sig === void 0 ? "" : _ref4$sig, _ref4$sig_time = _ref4.sig_time, sigTime = _ref4$sig_time === void 0 ? "" : _ref4$sig_time, _ref4$sig_version = _ref4.sig_version, sigVersion = _ref4$sig_version === void 0 ? "" : _ref4$sig_version;
                    return _context4.abrupt("return", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), {}, {
                        sig: sig,
                        sigTime: sigTime,
                        sigVersion: sigVersion
                    }));
                case 5:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return _requestSignUploadParams.apply(this, arguments);
}
var getUploaderInstance = function getUploaderInstance() {
    var _options$debug, _options$accessToken, _options$sign;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (uploaderInstance) return uploaderInstance;
    var _getUploadConfig = getUploadConfig(), _getUploadConfig$debu = _getUploadConfig.debug, debug = _getUploadConfig$debu === void 0 ? false : _getUploadConfig$debu, env = _getUploadConfig.env, signature = _getUploadConfig.signature, accessToken = _getUploadConfig.accessToken;
    var XDUploader = /*#__PURE__*/ function(_Uploader) {
        _inherits(XDUploader, _Uploader);
        var _super = _createSuper(XDUploader);
        function XDUploader() {
            (0,classCallCheck/* default */.Z)(this, XDUploader);
            return _super.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(XDUploader, [
            {
                key: "request",
                value: function() {
                    var _request = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee(url, options) {
                        var res;
                        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
                            while(1)switch(_context.prev = _context.next){
                                case 0:
                                    url = url.indexOf("?") > -1 ? "".concat(url, "&t=1") : "".concat(url, "?t=1");
                                    _context.next = 3;
                                    return _get(_getPrototypeOf(XDUploader.prototype), "request", this).call(this, url, options);
                                case 3:
                                    res = _context.sent;
                                    return _context.abrupt("return", res);
                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function request(_x2, _x3) {
                        return _request.apply(this, arguments);
                    }
                    return request;
                }()
            }
        ]);
        return XDUploader;
    }(esm_Uploader);
    uploaderInstance = new XDUploader((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        debug: (_options$debug = options === null || options === void 0 ? void 0 : options.debug) !== null && _options$debug !== void 0 ? _options$debug : debug,
        accessToken: (_options$accessToken = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _options$accessToken !== void 0 ? _options$accessToken : accessToken,
        sign: (_options$sign = options === null || options === void 0 ? void 0 : options.sign) !== null && _options$sign !== void 0 ? _options$sign : signature ? requestSignUploadParams : undefined,
        env: enum_UploadEnv[env]
    }));
    return uploaderInstance;
};
// 重置上传实例
var resetUploaderInstance = function resetUploaderInstance() {
    uploaderInstance = null;
};
/**
 * @param fileData 文件
 * @returns
 */ var uploadFileToObs = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(fileData, options) {
        var _getUploadConfig2, type, app, partSizeConfig, maxConcurrentConfig, needStat, asyncSliceConfig, _ref2, debug, accessToken, signature, customMaatType, customSuffix, maxConcurrentOption, partSizeOption, onUploadProgress, _ref2$maxRetries, maxRetries, maatType, partSize, maxConcurrent, sliceConfig, suffix, match, fileType, _fileType, uploader, ops, startTime, lastError, attempt, data, url;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _getUploadConfig2 = getUploadConfig(), type = _getUploadConfig2.type, app = _getUploadConfig2.app, partSizeConfig = _getUploadConfig2.partSize, maxConcurrentConfig = _getUploadConfig2.maxConcurrent, needStat = _getUploadConfig2.needStat, asyncSliceConfig = _getUploadConfig2.asyncSliceConfig;
                    _ref2 = options || {}, debug = _ref2.debug, accessToken = _ref2.accessToken, signature = _ref2.signature, customMaatType = _ref2.customMaatType, customSuffix = _ref2.customSuffix, maxConcurrentOption = _ref2.maxConcurrent, partSizeOption = _ref2.partSize, onUploadProgress = _ref2.onUploadProgress, _ref2$maxRetries = _ref2.maxRetries, maxRetries = _ref2$maxRetries === void 0 ? 3 : _ref2$maxRetries;
                    maatType = customMaatType || type;
                    /* 分片配置 */ partSize = partSizeOption || partSizeConfig;
                    maxConcurrent = maxConcurrentOption || maxConcurrentConfig;
                    /**
           * 异步获取分片数据
           * 优先级：入参 > 异步获取 > 全局配置 > 默认值
           */ if (!(asyncSliceConfig && (!partSizeOption || !maxConcurrentOption))) {
                        _context2.next = 11;
                        break;
                    }
                    _context2.next = 8;
                    return getSliceConfigAsync();
                case 8:
                    sliceConfig = _context2.sent;
                    if (!partSizeOption && sliceConfig.partSize) partSize = sliceConfig.partSize;
                    if (!maxConcurrentOption && sliceConfig.maxConcurrent) maxConcurrent = sliceConfig.maxConcurrent;
                case 11:
                    /* 文件后缀 */ suffix = customSuffix || "jpeg";
                    if (customSuffix) {
                        _context2.next = 26;
                        break;
                    }
                    if (!(typeof fileData === "string")) {
                        _context2.next = 19;
                        break;
                    }
                    // 提取 Base64 前缀中的 MIME 类型
                    match = fileData.match(/^data:(.+?);base64,/);
                    fileType = match ? match[1] : "image/jpeg";
                    suffix = fileType === "image/svg+xml" ? "svg" : fileType.split("/")[1];
                    _context2.next = 26;
                    break;
                case 19:
                    _context2.t0 = fileData.type;
                    if (_context2.t0) {
                        _context2.next = 24;
                        break;
                    }
                    _context2.next = 23;
                    return getFileType(fileData);
                case 23:
                    _context2.t0 = _context2.sent;
                case 24:
                    _fileType = _context2.t0;
                    suffix = _fileType === "image/svg+xml" ? "svg" : _fileType === null || _fileType === void 0 ? void 0 : _fileType.split("/")[1];
                case 26:
                    uploader = getUploaderInstance({
                        debug: debug,
                        accessToken: accessToken,
                        sign: signature ? requestSignUploadParams : undefined
                    });
                    ops = {
                        app: app,
                        count: 1,
                        suffix: suffix,
                        type: maatType
                    };
                    startTime = performance.now();
                    attempt = 1;
                case 30:
                    if (!(attempt <= maxRetries)) {
                        _context2.next = 50;
                        break;
                    }
                    _context2.prev = 31;
                    _context2.next = 34;
                    return uploader.upload(fileData, ops, {
                        partSize: partSize,
                        maxConcurrent: maxConcurrent,
                        progress: onUploadProgress
                    });
                case 34:
                    data = _context2.sent;
                    url = data.previewUrl || data.url; // 埋点
                    if (needStat) statUpload(fileData, maatType, {
                        startTime: startTime,
                        success: true,
                        partSize: partSize,
                        maxConcurrent: maxConcurrent
                    });
                    return _context2.abrupt("return", {
                        url: url,
                        previewUrl: data.previewUrl
                    });
                case 40:
                    _context2.prev = 40;
                    _context2.t1 = _context2["catch"](31);
                    lastError = _context2.t1;
                    // 如果还有重试机会，继续尝试
                    if (!(attempt < maxRetries)) {
                        _context2.next = 45;
                        break;
                    }
                    return _context2.abrupt("continue", 47);
                case 45:
                    // 最后一次尝试失败，记录埋点并抛出错误
                    if (needStat) statUpload(fileData, maatType, {
                        startTime: startTime,
                        success: false,
                        partSize: partSize,
                        maxConcurrent: maxConcurrent
                    });
                    throw _context2.t1;
                case 47:
                    attempt++;
                    _context2.next = 30;
                    break;
                case 50:
                    throw lastError;
                case 51:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                31,
                40
            ]
        ]);
    }));
    return function uploadFileToObs(_x4, _x5) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 上传base64到obs
 * @param base64
 * @returns
 */ var uploadBase64ToObs = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(base64, options) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", uploadFileToObs(base64, options));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function uploadBase64ToObs(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}()));
/**
 * 根据obs地址获取宽高信息
 * @param url obs地址
 * @returns
 */ function fetchObsURLWH(url) {
    var reqInfo = new Request(url.includes("?") ? url + "&imageWH" : url + "?imageWH");
    return new Promise(function(resolve, reject) {
        fetch(reqInfo, {
            method: "GET",
            headers: new Headers(),
            mode: "cors",
            cache: "default"
        }).then(function(res) {
            if (res.status < 200 || res.status >= 400) {
                throw new Error("get error");
            }
            return res.json();
        }).then(function(res) {
            resolve(res);
        }).catch(function(e) {
            reject(e);
        });
    });
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var utils = __webpack_require__(16197);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js + 1 modules
var api = __webpack_require__(37057);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/enterprise.js
var enterprise = __webpack_require__(12749);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js















var getEnterpriseIDKey = function getEnterpriseIDKey() {
    return "enterprise_id".concat((0,utils/* getSuffix */._A)());
};
var getAccessTokenCookieKey = function getAccessTokenCookieKey() {
    return "access_token".concat((0,utils/* getSuffix */._A)());
};
// 是否走SSO授权登录方式
var isSSOLogin = false;
var isSSO = function isSSO() {
    return isSSOLogin;
};
var getEnterpriseSearchParams = function getEnterpriseSearchParams() {
    var _getIdentityFromCooki;
    var searchParams = new URLSearchParams(window.location.search);
    var localOid = (_getIdentityFromCooki = (0,lib/* getIdentityFromCookie */.Rw)()) === null || _getIdentityFromCooki === void 0 ? void 0 : _getIdentityFromCooki.oid;
    return {
        code: searchParams.get("code"),
        organizationID: Number(searchParams.get("oid")) || localOid
    };
};
/**
 * Clear redundant url params
 * (remove some params from `meitu account`)
 * @param keys - keys to remove
 */ var clearURL = function clearURL(keys) {
    var searchParams = new URLSearchParams(window.location.search);
    var redundantKeys = [
        "op_type",
        "code",
        "platform",
        "client_from_sdk",
        "redirect_uri",
        "client_referer",
        "client_params"
    ];
    if (keys) {
        redundantKeys.push.apply(redundantKeys, (0,toConsumableArray/* default */.Z)(keys));
    }
    redundantKeys.forEach(function(key) {
        searchParams.delete(key);
    });
    // 构建新的查询字符串
    var newQueryString = searchParams.toString();
    // 获取当前 URL 的路径部分
    var path = window.location.pathname;
    // 更新 URL，不包括被移除的参数
    var newUrl = newQueryString ? "".concat(path, "?").concat(newQueryString) : path;
    window.history.replaceState("", "", newUrl);
};
var checkLoginStatus = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        var _res$userInfo, res, uid;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0,enterprise/* fetchUserInfo */.CS)();
                case 3:
                    res = _context.sent;
                    if (!(res !== null && res !== void 0 && (_res$userInfo = res.userInfo) !== null && _res$userInfo !== void 0 && _res$userInfo.id)) {
                        _context.next = 8;
                        break;
                    }
                    uid = res.userInfo.id; // 非个人版下，利用该接口同步最新ouid，用于埋点上报的uid的准确性
                    (0,uidKit/* setLocalUid */.Tc)(uid);
                    return _context.abrupt("return", true);
                case 8:
                    return _context.abrupt("return", false);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                    return _context.abrupt("return", false);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function checkLoginStatus() {
        return _ref.apply(this, arguments);
    };
}();
var getEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(oid) {
        var res;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0,enterprise/* fetchEnterpriseConfigs */.N1)(oid);
                case 3:
                    res = _context2.sent;
                    return _context2.abrupt("return", {
                        enterpriseID: res.enterprise,
                        authPageURL: res.authorized_redirect_url
                    });
                case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", null);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getEnterpriseConfigs(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var init = /*#__PURE__*/ function() {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee3() {
        var _getEnterpriseSearchP, code, organizationID, obsConfig, TOKEN_KEY_COOKIE, tokenCookie, ENTERPRISE_ID, _tokenCookie, _yield$Promise$all, _yield$Promise$all2, isLogin, resObsCfg, resEnterpriseCfg, res, accessToken, _yield$Promise$all3, _yield$Promise$all4, _, _resObsCfg, _resEnterpriseCfg;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _getEnterpriseSearchP = getEnterpriseSearchParams(), code = _getEnterpriseSearchP.code, organizationID = _getEnterpriseSearchP.organizationID;
                    obsConfig = getDefaultObsConfig();
                    TOKEN_KEY_COOKIE = getAccessTokenCookieKey();
                    ;
                    ;
                    // Check whether it is enterprise client
                    if (!(!organizationID && !code)) {
                        _context3.next = 9;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    tokenCookie = js_cookie/* default.get */.Z.get(TOKEN_KEY_COOKIE) || "";
                    tokenCookie && window.localStorage.setItem("access_token", tokenCookie);
                    return _context3.abrupt("return", obsConfig);
                case 9:
                    ENTERPRISE_ID = getEnterpriseIDKey(); // 更新本地cookie
                    (0,lib/* setLocalIdentity */.kF)(Number(organizationID), Number(organizationID));
                    // 更内存身份
                    (0,lib/* setMemoryIdentity */.LW)(Number(organizationID), Number(organizationID));
                    // If no `code` url param, then checking login status
                    if (code) {
                        _context3.next = 35;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    _tokenCookie = js_cookie/* default.get */.Z.get(TOKEN_KEY_COOKIE) || "";
                    _tokenCookie && window.localStorage.setItem("access_token", _tokenCookie);
                    // check login status
                    _context3.prev = 15;
                    _context3.next = 18;
                    return Promise.all([
                        checkLoginStatus(),
                        getObsConfigAsync({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 18:
                    _yield$Promise$all = _context3.sent;
                    _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 3);
                    isLogin = _yield$Promise$all2[0];
                    resObsCfg = _yield$Promise$all2[1];
                    resEnterpriseCfg = _yield$Promise$all2[2];
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obsConfig), resObsCfg);
                    }
                    isSSOLogin = !!(resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL);
                    if (!isLogin) {
                        // not login, then redirect to auth page
                        window.localStorage.removeItem("access_token");
                        js_cookie/* default.remove */.Z.remove(TOKEN_KEY_COOKIE, {
                            domain: (0,utils/* getRootDomain */.wf)()
                        });
                    }
                    if (resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie/* default.set */.Z.set(ENTERPRISE_ID, resEnterpriseCfg.enterpriseID, {
                            domain: (0,utils/* getRootDomain */.wf)(),
                            expires: 36500 // 100年有效期
                        });
                    } else {
                        js_cookie/* default.remove */.Z.remove(ENTERPRISE_ID, {
                            domain: (0,utils/* getRootDomain */.wf)()
                        });
                    }
                    if (!isLogin && resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL) {
                        // 未登录，跳转去授权登录
                        window.open(resEnterpriseCfg.authPageURL, "_self");
                    }
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.abrupt("return", obsConfig);
                case 32:
                    _context3.prev = 32;
                    _context3.t0 = _context3["catch"](15);
                    return _context3.abrupt("return", obsConfig);
                case 35:
                    _context3.prev = 35;
                    _context3.next = 38;
                    return (0,enterprise/* fetchAccessTokenByCode */.tH)(code);
                case 38:
                    res = _context3.sent;
                    accessToken = res["access_token"];
                    if (accessToken) {
                        _context3.next = 42;
                        break;
                    }
                    throw new Error("Get access token failed.");
                case 42:
                    window.localStorage.setItem("access_token", accessToken);
                    js_cookie/* default.set */.Z.set(TOKEN_KEY_COOKIE, accessToken, {
                        domain: (0,utils/* getRootDomain */.wf)(),
                        expires: 36500 // 100年有效期
                    });
                    // refresh user rights
                    _context3.next = 46;
                    return Promise.all([
                        (0,enterprise/* refreshUserRights */.rm)(),
                        getObsConfigAsync({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 46:
                    _yield$Promise$all3 = _context3.sent;
                    _yield$Promise$all4 = (0,slicedToArray/* default */.Z)(_yield$Promise$all3, 3);
                    _ = _yield$Promise$all4[0];
                    _resObsCfg = _yield$Promise$all4[1];
                    _resEnterpriseCfg = _yield$Promise$all4[2];
                    if (_resObsCfg !== null && _resObsCfg !== void 0 && _resObsCfg.app) {
                        obsConfig.app = _resObsCfg === null || _resObsCfg === void 0 ? void 0 : _resObsCfg.app;
                    }
                    isSSOLogin = !!(_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.authPageURL);
                    if (_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie/* default.set */.Z.set(ENTERPRISE_ID, _resEnterpriseCfg.enterpriseID, {
                            domain: (0,utils/* getRootDomain */.wf)(),
                            expires: 36500 // 100年有效期
                        });
                    }
                    return _context3.abrupt("return", obsConfig);
                case 57:
                    _context3.prev = 57;
                    _context3.t1 = _context3["catch"](35);
                case 59:
                    _context3.prev = 59;
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.finish(59);
                case 62:
                    return _context3.abrupt("return", obsConfig);
                case 63:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                15,
                32
            ],
            [
                35,
                57,
                59,
                62
            ]
        ]);
    }));
    return function init() {
        return _ref3.apply(this, arguments);
    };
}();
// 同步海洛下载结果
var handleReportDownloadResult = /*#__PURE__*/ function() {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee4(blob, options) {
        var url, filesize, file, res;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.prev = 0;
                    url = "";
                    filesize = undefined;
                    if (!(typeof blob === "string" && /^https?:\/\//i.test(blob))) {
                        _context4.next = 7;
                        break;
                    }
                    url = blob;
                    _context4.next = 14;
                    break;
                case 7:
                    if (!(blob instanceof Blob)) {
                        _context4.next = 14;
                        break;
                    }
                    file = new File([
                        blob
                    ], "", {
                        type: blob.type
                    });
                    _context4.next = 11;
                    return uploadFileToObs(file, {
                        customMaatType: "image_tmp",
                        customSuffix: options === null || options === void 0 ? void 0 : options.extension
                    });
                case 11:
                    res = _context4.sent;
                    url = res.url;
                    filesize = blob.size;
                case 14:
                    _context4.next = 16;
                    return (0,api/* handleDownloadRecord */.lh)((0,objectSpread2/* default */.Z)({
                        url: url,
                        filesize: filesize
                    }, options));
                case 16:
                    message/* default.success */.Z.success("已为您保存至海洛数字资产");
                    _context4.next = 22;
                    break;
                case 19:
                    _context4.prev = 19;
                    _context4.t0 = _context4["catch"](0);
                    ;
                case 22:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                0,
                19
            ]
        ]);
    }));
    return function handleReportDownloadResult(_x2, _x3) {
        return _ref4.apply(this, arguments);
    };
}();
var createTeam = /*#__PURE__*/ function() {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee5(params) {
        var _params$teamName;
        var _getConfig, userInfo, res;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    _getConfig = (0,configProvider/* getConfig */.iE)(), userInfo = _getConfig.userInfo;
                    _context5.next = 3;
                    return (0,api/* createTeamApi */.tH)({
                        name: (_params$teamName = params === null || params === void 0 ? void 0 : params.teamName) !== null && _params$teamName !== void 0 ? _params$teamName : "".concat(userInfo.screen_name, "的团队"),
                        rebate_code: params === null || params === void 0 ? void 0 : params.rebateCode
                    });
                case 3:
                    res = _context5.sent;
                    return _context5.abrupt("return", {
                        groupId: res.group_id,
                        oid: res.oid,
                        ouid: res.ouid,
                        teamName: res.team_name
                    });
                case 5:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function createTeam(_x4) {
        return _ref5.apply(this, arguments);
    };
}();


/***/ }),

/***/ 32485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mf": () => (/* binding */ IdentityType),
/* harmony export */   "cc": () => (/* binding */ TeamSeatStatus),
/* harmony export */   "iJ": () => (/* binding */ TeamShareNodeType),
/* harmony export */   "xO": () => (/* binding */ TeamRoleType)
/* harmony export */ });
/* unused harmony exports CollaboratorPermissionType, TeamShareChangeType */
/** 协作者权限 */ var CollaboratorPermissionType = /*#__PURE__*/ function(CollaboratorPermissionType) {
    CollaboratorPermissionType[CollaboratorPermissionType["Views"] = 2] = "Views";
    CollaboratorPermissionType[CollaboratorPermissionType["Edit"] = 3] = "Edit";
    CollaboratorPermissionType[CollaboratorPermissionType["Manage"] = 4] = "Manage";
    CollaboratorPermissionType[CollaboratorPermissionType["Remove"] = 5] = "Remove";
    CollaboratorPermissionType[CollaboratorPermissionType["Reject"] = 6] = "Reject";
    CollaboratorPermissionType[CollaboratorPermissionType["Owner"] = 999999] = "Owner";
    return CollaboratorPermissionType;
}({});
// 身份类型，type: 0-个人版，1-团队版，2-企业版
var IdentityType = /*#__PURE__*/ function(IdentityType) {
    IdentityType[IdentityType["PERSONAL"] = 0] = "PERSONAL";
    IdentityType[IdentityType["TEAM"] = 1] = "TEAM";
    IdentityType[IdentityType["ENTERPRISE"] = 2] = "ENTERPRISE";
    return IdentityType;
}({});
/**
 * 团队身份
 */ /**
 * 团队信息
 */ /**
 * 团队席位状态
 */ /** 席位状态 */ var TeamSeatStatus = /*#__PURE__*/ function(TeamSeatStatus) {
    TeamSeatStatus[TeamSeatStatus["Unbound"] = 0] = "Unbound";
    TeamSeatStatus[TeamSeatStatus["Effect"] = 1] = "Effect";
    TeamSeatStatus[TeamSeatStatus["Pending"] = 2] = "Pending";
    TeamSeatStatus[TeamSeatStatus["Freeze"] = 10] = "Freeze";
    return TeamSeatStatus;
}({});
/**
 * 团队角色
 */ var TeamRoleType = /*#__PURE__*/ function(TeamRoleType) {
    TeamRoleType["owner"] = "owner";
    TeamRoleType["admin"] = "admin";
    TeamRoleType["member"] = "member";
    return TeamRoleType;
}({});
/**
 * 协作列表
 */ /**
 * 团队成员
 */ /**
 * 团队信息
 */ /**
 * 回调的type
 */ var TeamShareChangeType = /*#__PURE__*/ function(TeamShareChangeType) {
    TeamShareChangeType["USER_TYPE"] = "user_type";
    TeamShareChangeType["MODE"] = "mode";
    return TeamShareChangeType;
}({});
/**
 * 分享文件类型
 */ var TeamShareNodeType = /*#__PURE__*/ function(TeamShareNodeType) {
    TeamShareNodeType["RECORD"] = "RECORD";
    TeamShareNodeType["TEMPLATE"] = "TEMPLATE";
    TeamShareNodeType["FOLDER"] = "FOLDER";
    return TeamShareNodeType;
}({}); /**
 * 创建团队
 */  /**
 * [团队]生成邀请码
 */ 


/***/ }),

/***/ 8209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": () => (/* binding */ VipLevel),
/* harmony export */   "FW": () => (/* binding */ UserType),
/* harmony export */   "dE": () => (/* binding */ ListKeyType)
/* harmony export */ });
/* unused harmony export BalanceListKeyType */
/**
 * 用户信息数据类型
 *
 * @see https://api-mock.meitu-int.com/project/2110/interface/api/116813
 */ var VipLevel = /*#__PURE__*/ function(VipLevel) {
    VipLevel[VipLevel["Basic"] = 1] = "Basic";
    VipLevel[VipLevel["Pro"] = 2] = "Pro";
    VipLevel[VipLevel["ProCn"] = 3] = "ProCn";
    return VipLevel;
}({});
var ListKeyType = /*#__PURE__*/ function(ListKeyType) {
    ListKeyType["FEEDBACK"] = "feedBack";
    ListKeyType["BUSINESS"] = "business";
    ListKeyType["DOWNLOAD"] = "download";
    ListKeyType["CREDIT"] = "credit";
    ListKeyType["ManageSubscriptions"] = "manageSubscriptions";
    ListKeyType["Subscription"] = "subscription";
    ListKeyType["TermsPolicies"] = "termsPolicies";
    ListKeyType["Pricing"] = "pricing";
    ListKeyType["ChangeIdentity"] = "changeIdentity";
    ListKeyType["Compensation"] = "compensation";
    ListKeyType["Language"] = "language";
    ListKeyType["Redeem"] = "redeem";
    ListKeyType["Invite"] = "invite";
    ListKeyType["Account"] = "account";
    ListKeyType["DOWNLOAD_APP"] = "downloadApp";
    ListKeyType["TEAM_ADMIN"] = "teamAdmin";
    ListKeyType["InviteCn"] = "inviteCn";
    return ListKeyType;
}({});
var BalanceListKeyType = /*#__PURE__*/ function(BalanceListKeyType) {
    BalanceListKeyType["MEIDOU"] = "meidou";
    BalanceListKeyType["CUTOUT"] = "cutout";
    return BalanceListKeyType;
}({});
/**
 * 用户信息组件属性
 */ /**
 * 用户类型
 */ var UserType = /*#__PURE__*/ function(UserType) {
    UserType["PERSONAL"] = "personal";
    UserType["TEAM"] = "team";
    UserType["COMPANY"] = "company";
    return UserType;
}({});


/***/ }),

/***/ 56874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": () => (/* binding */ userNotVipPc),
/* harmony export */   "CX": () => (/* binding */ CHANGE_IDENTITY_TIP_KEY),
/* harmony export */   "Do": () => (/* binding */ userIntlNotVip),
/* harmony export */   "HT": () => (/* binding */ USER_INFO_SWITCH_IDENTITY_GUIDE_KEY),
/* harmony export */   "Mv": () => (/* binding */ userNotVip),
/* harmony export */   "OY": () => (/* binding */ userXdesignProVip),
/* harmony export */   "PS": () => (/* binding */ userPrpVip),
/* harmony export */   "T8": () => (/* binding */ teamIntlVip),
/* harmony export */   "Um": () => (/* binding */ userProVipDk),
/* harmony export */   "V2": () => (/* binding */ userBasicVipDk),
/* harmony export */   "Vj": () => (/* binding */ teamIntlNotVip),
/* harmony export */   "ZB": () => (/* binding */ userXdesignPlusVip),
/* harmony export */   "ZF": () => (/* binding */ ChangeIdentityTipSourceEnum),
/* harmony export */   "g": () => (/* binding */ userVip),
/* harmony export */   "jU": () => (/* binding */ teamNotVip),
/* harmony export */   "pI": () => (/* binding */ userVipPc),
/* harmony export */   "vD": () => (/* binding */ teamVip)
/* harmony export */ });
/* unused harmony exports userXdesignBasic, changeIdentityTipInfo */
/**
 * ########### 权益图标 ###########
 */ // 国内版 团队vip
var teamVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip.png";
// 海外版 团队vip
var teamIntlVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip.png";
// 国内版 非团队vip
var teamNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-not.png";
// 海外版 非团队vip
var teamIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip-not.png";
// 国内版 个人vip（PC内嵌）
var userVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon.png";
// 国内版 个人vip（web端）
var userVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-web.png";
// 海外版 个人 Basic
var userXdesignBasic = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/basic-icon.png";
// 国内版 个人pro_vip（web端）
var userPrpVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-web.png";
// 海外版 个人vip
var userXdesignProVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/pro-icon.png";
var userXdesignPlusVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/plus-icon.png";
// 国内版 非个人vip（PC内嵌）
var userNotVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon.png";
// 国内版 非个人vip（web端）
var userNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-web.png";
// 海外版 非个人vip
var userIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/not-vip-pro-icon-intl.png";
// designkit 个人 Basic Vip
var userBasicVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/basic-vip-icon-dk.png";
// designkit 个人 Pro Vip
var userProVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-dk.png";
// 身份切换引导提示缓存
var CHANGE_IDENTITY_TIP_KEY = "xdesign-widgets_change-identity-tip";
var USER_INFO_SWITCH_IDENTITY_GUIDE_KEY = "xdesign-widgets_user-info-switch-identity-guide";
var ChangeIdentityTipSourceEnum = /*#__PURE__*/ function(ChangeIdentityTipSourceEnum) {
    ChangeIdentityTipSourceEnum["PROMOTION_MODAL"] = "promotionModal";
    ChangeIdentityTipSourceEnum["MEIDOU_PANEL"] = "meidouPanel";
    return ChangeIdentityTipSourceEnum;
}({});
// 记录强引导提示场景的相关状态
var changeIdentityTipInfo = {
    source: "",
    shouldShowTip: 0,
    hasShowTipMap: {
        promotionModal: 0,
        meidouPanel: 0
    }
};


/***/ }),

/***/ 11747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OF": () => (/* binding */ checkIsBeforeUnload),
/* harmony export */   "uU": () => (/* binding */ copy2Clipboard)
/* harmony export */ });
/* unused harmony exports isSafari, registerStyleSheet, isPad */
var isSafari = function isSafari() {
    var ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|Chromium/.test(ua) && navigator.vendor === "Apple Computer, Inc.";
};
var registerStyleSheet = function registerStyleSheet(styleCode, id) {
    var style = document.createElement("style");
    style.innerHTML = styleCode;
    if (id) {
        style.id = id;
    }
    document.body.appendChild(style);
    var remove = function remove() {
        document.body.removeChild(style);
    };
    return remove;
};
var copy2Clipboard = function copy2Clipboard(text) {
    return new Promise(function(resolve) {
        // safari的复制api不能在promise内部调用
        setTimeout(function() {
            navigator.clipboard.writeText(text).then(function() {
                return resolve({
                    success: true
                });
            }).catch(function(error) {
                ;
                resolve({
                    success: false,
                    error: error
                });
            });
        });
    });
};
/** 检查是否处于beforeunload的时机之后 (防止safari中断请求导致报错并继续执行catch逻辑) */ var checkIsBeforeUnload = function() {
    var isBeforeUnload = false;
    if (true) {
        window.addEventListener("beforeunload", function() {
            isBeforeUnload = true;
        });
    }
    return function() {
        return isBeforeUnload;
    };
}();
/**
 * 判断是否是平板设备（SSR 安全）
 */ var isPad = function isPad() {
    // SSR 环境（无 window/navigator/screen）
    if ( false || typeof navigator === "undefined" || typeof screen === "undefined") {
        return true; // SSR 下默认返回 true
    }
    var ua = navigator.userAgent.toLowerCase();
    var maxTouch = navigator.maxTouchPoints || 0;
    var dpr = window.devicePixelRatio || 1;
    var width = Math.min(window.screen.width, window.screen.height);
    // 1. iPad / iPadOS（iPadOS 13+ 会伪装成 Mac）
    if (/ipad/.test(ua) || /macintosh/.test(ua) && maxTouch > 1) {
        return true;
    }
    // 2. Android 平板（非手机）
    if (/android/.test(ua) && !/mobile/.test(ua)) {
        return true;
    }
    // 3. Windows / Linux / X11 平板（触屏设备）
    if ((/windows/.test(ua) || /linux/.test(ua) || /x11/.test(ua)) && maxTouch > 1) {
        // 增加 DPI 判断：一般平板 >= 1.5，触屏电脑多为 1.0~1.25
        var isHighDPI = dpr >= 1.5;
        // 宽度小于 1280 且高 DPI 视作平板，否则视作触屏电脑
        return width < 1280 && isHighDPI;
    }
    return false;
};


/***/ }),

/***/ 84999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "G3": () => (/* binding */ getApiHost),
/* harmony export */   "HN": () => (/* binding */ getEnvPrefix),
/* harmony export */   "n8": () => (/* binding */ getSubApiHost),
/* harmony export */   "p7": () => (/* binding */ getDomainName)
/* harmony export */ });
/* unused harmony exports webApiUrlDesignKitMap, getWebApiUrlMap, webApiUrlStariiMap, subApiUrlMap, subApiUrlStariiMap */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38389);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97303);


var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
// 判断国际化产品域名后缀,
// 国内为 cn
// designkit 和海外为 com
var getDomainName = function getDomainName() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    return appName === "designkit" && isIntl || isIntl ? "com" : "cn";
};
/**
 * DesignKit全球化api域名
 */ var webApiUrlDesignKitMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://predesignkit-webapi.designkit.com"), ENV_ENUM.pre, "https://predesignkit-webapi.designkit.com"), ENV_ENUM.beta, "https://betadesignkit-webapi.designkit.com"), ENV_ENUM.release, "https://designkit-webapi.designkit.com");
/**
 * 国内api域名
 */ var getWebApiUrlMap = function getWebApiUrlMap() {
    var domainName = getDomainName();
    return (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://prewebapi.designkit.".concat(domainName)), ENV_ENUM.pre, "https://prewebapi.designkit.".concat(domainName)), ENV_ENUM.beta, "https://betawebapi.designkit.".concat(domainName)), ENV_ENUM.release, "https://webapi.designkit.".concat(domainName));
};
/**
 * 海外api域名
 */ var webApiUrlStariiMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre.zawa.ai/api"), ENV_ENUM.pre, "https://pre.zawa.ai/api"), ENV_ENUM.beta, "https://beta.zawa.ai/api"), ENV_ENUM.release, "https://zawa.ai/api");
/**
 * 国内api域名
 */ var subApiUrlMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre-api-h5-sub.meitu.com"), ENV_ENUM.pre, "https://pre-api-h5-sub.meitu.com"), ENV_ENUM.beta, "https://beta-api-h5-sub.meitu.com"), ENV_ENUM.release, "https://api-h5-sub.meitu.com");
/**
 * 海外api域名
 */ var subApiUrlStariiMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre-api-h5-sub.starii.com"), ENV_ENUM.pre, "https://pre-api-h5-sub.starii.com"), ENV_ENUM.beta, "https://beta-api-h5-sub.starii.com"), ENV_ENUM.release, "https://api-h5-sub.starii.com");
var getEnvPrefix = function getEnvPrefix(env) {
    return env === "beta" ? "beta" : env === "release" ? "" : "pre";
};
var getApiHost = function getApiHost() {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl, appName = _getConfig2.appName;
    var baseURL = getWebApiUrlMap()[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    if (isIntl && appName === "x-design") {
        baseURL = webApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    } else if (isIntl && appName === "designkit") {
        baseURL = webApiUrlDesignKitMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    }
    return baseURL;
};
var getSubApiHost = function getSubApiHost() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl, appName = _getConfig3.appName;
    return isIntl && appName === "x-design" ? subApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env] : subApiUrlMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
};


/***/ }),

/***/ 77724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (new events__WEBPACK_IMPORTED_MODULE_0__.EventEmitter());


/***/ }),

/***/ 16197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XF": () => (/* binding */ getClientLanguage),
/* harmony export */   "_A": () => (/* binding */ getSuffix),
/* harmony export */   "_v": () => (/* binding */ sleep),
/* harmony export */   "so": () => (/* binding */ getCountryCode),
/* harmony export */   "wf": () => (/* binding */ getRootDomain)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69222);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97303);


function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}
var getSuffix = function getSuffix() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), env = _getConfig.env;
    var suffix = "--".concat(env);
    if (env === _configProvider__WEBPACK_IMPORTED_MODULE_0__/* .ENV_ENUM.release */ .BD.release) {
        suffix = "";
    }
    return suffix;
};
/**
 * 获取服务端真正需要上报的语言值
 * @param locale 语言
 * @returns
 */ var getClientLanguage = function getClientLanguage(locale) {
    var fankuiLangMap = {
        cn: "zh-Hans",
        tw: "zh-Hant",
        en: "en",
        jp: "ja",
        kr: "ko",
        pt: "pt",
        es: "es",
        de: "de",
        id: "id",
        th: "th",
        "zh-Hant": "zh-Hant",
        "zh-Hans": "zh-Hans"
    };
    return fankuiLangMap[locale] || "";
};
/**
 * 获取country_code
 * @param language  通过navigator.language获取的值
 * @returns
 */ var getCountryCode = function getCountryCode() {
    var language = navigator.language;
    var regionMap = {
        "zh-CN": "CN",
        "zh-TW": "TW",
        "ja-JP": "JP",
        "ko-KR": "KR",
        "en-US": "US",
        "en-AU": "AU",
        "en-CA": "CA",
        "zh-HK": "HK",
        "th-TH": "TH",
        "en-GB": "GB",
        "en-SG": "SG",
        "ms-SG": "SG",
        "zh-SG": "SG",
        "vi-VN": "VN",
        "zh-MO": "MO",
        "pt-MO": "MO",
        "tl-PH": "PH",
        "en-PH": "PH",
        "id-ID": "ID",
        "en-NZ": "NZ",
        "mi-NZ": "NZ",
        fil: "PH"
    };
    if (regionMap[language]) {
        return regionMap[language];
    }
    // 如果有区域代码，格式是 <language>-<region>，
    // 例如：en-US — 英语（美国）、zh-CN — 简体中文（中国）
    if (language && language.includes("-")) {
        var _language$split = language.split("-"), _language$split2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_language$split, 2), _ = _language$split2[0], rg = _language$split2[1];
        if (rg) {
            return rg;
        }
    }
    // 用语言匹配
    var keys = Object.keys(regionMap);
    for(var i = 0; i < keys.length; i++){
        var element = keys[i];
        if (element.includes(language)) {
            return regionMap[element];
        }
    }
    return "";
};
var sleep = function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};


/***/ }),

/***/ 57526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": () => (/* binding */ getCommonParams),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "s6": () => (/* binding */ RESIGNED_CODE)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87406);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81549);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5121);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57632);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var _ComUI_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20134);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97303);
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84999);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16197);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(128);











var getCommonParams = function getCommonParams() {
    var _getConfig$userInfo$e, _getConfig$userInfo;
    return {
        gid: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().gid,
        education_role: (_getConfig$userInfo$e = (_getConfig$userInfo = (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().userInfo) === null || _getConfig$userInfo === void 0 ? void 0 : _getConfig$userInfo.education_role) !== null && _getConfig$userInfo$e !== void 0 ? _getConfig$userInfo$e : "",
        client_id: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().client_id,
        preview_mode: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().env === _env__WEBPACK_IMPORTED_MODULE_2__/* .ENV_ENUM.release */ .BD.release ? 0 : 1,
        client_language: (0,___WEBPACK_IMPORTED_MODULE_3__/* .getClientLanguage */ .XF)((0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleStore */ .IK)().locale),
        country_code: (0,___WEBPACK_IMPORTED_MODULE_3__/* .getCountryCode */ .so)(),
        ts_random_id: (0,uuid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
        client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
};
var request = axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].create */ .Z.create({
    withCredentials: true
});
var getDefaultError = function getDefaultError() {
    var _getLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleStore */ .IK)(), $t = _getLocaleStore.$t;
    return {
        code: 1024,
        message: $t(function(v) {
            return v.utils.requestErrorText;
        })
    };
};
/** 用户被团队移除的状态码 */ var RESIGNED_CODE = 402;
request.interceptors.request.use(function(config) {
    var _config$baseURL, _window$localStorage$;
    config.baseURL = (_config$baseURL = config.baseURL) !== null && _config$baseURL !== void 0 ? _config$baseURL : (0,_env__WEBPACK_IMPORTED_MODULE_2__/* .getApiHost */ .G3)();
    var customHeader =  false ? 0 : (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        access_token: (_window$localStorage$ = window.localStorage.getItem("access_token")) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : ""
    }, (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getRequestIdentityHeader */ .AW)());
    config.headers = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, customHeader), config.headers.common), config.headers);
    config.params = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, getCommonParams()), config.params);
    return config;
}, function() {
    return Promise.reject(getDefaultError());
});
request.interceptors.response.use(/*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().mark(function _callee(response) {
        var _response$config, _response$data;
        var code, messageText, _response$config2;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    if (!((_response$config = response.config) !== null && _response$config !== void 0 && _response$config.directReturn)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", response.data);
                case 2:
                    code = response.data.code;
                    messageText = response.data.message || getDefaultError().message;
                    if (!code) {
                        _context.next = 7;
                        break;
                    }
                    !(response !== null && response !== void 0 && (_response$config2 = response.config) !== null && _response$config2 !== void 0 && _response$config2.hiddenMessage) && _ComUI_message__WEBPACK_IMPORTED_MODULE_10__/* ["default"].error */ .Z.error(messageText);
                    throw {
                        code: code,
                        message: messageText
                    };
                case 7:
                    return _context.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data);
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function(_x) {
        return _ref.apply(this, arguments);
    };
}(), function(error) {
    var _error$response, _error$config;
    var data = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || getDefaultError();
    var code = data.code;
    var messageText = data.message;
    if (!(error !== null && error !== void 0 && (_error$config = error.config) !== null && _error$config !== void 0 && _error$config.hiddenMessage)) {
        _ComUI_message__WEBPACK_IMPORTED_MODULE_10__/* ["default"].error */ .Z.error(messageText);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        code: code,
        message: messageText
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (request);


/***/ }),

/***/ 83642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tc": () => (/* binding */ setLocalUid),
/* harmony export */   "Yz": () => (/* binding */ removeLocalUid),
/* harmony export */   "sw": () => (/* binding */ initLocalUid)
/* harmony export */ });
/* unused harmony export getLocalUid */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16197);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97303);




var getUIDKey = function getUIDKey() {
    return "ouid".concat((0,___WEBPACK_IMPORTED_MODULE_1__/* .getSuffix */ ._A)());
};
/**
 * 海外版本不进行cookie存储
 */ /**
 * 初始化同步uid
 */ var initLocalUid = function initLocalUid() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl;
    if (isIntl) return;
    var uid = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(getUIDKey());
    if (uid) {
        window.localStorage.setItem("uid", String(uid));
    } else {
        window.localStorage.removeItem("uid");
    }
};
/**
 * 更新本地uid缓存和cookie中的uid
 * @param uid
 */ var setLocalUid = function setLocalUid(uid) {
    if (!uid) return;
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(getUIDKey(), String(uid), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)(),
            expires: 36500 // 100年有效期
        });
    }
    window.localStorage.setItem("uid", String(uid));
};
var getLocalUid = function getLocalUid() {
    var data = window.localStorage.getItem("uid");
    return data ? Number(data) : null;
};
/**
 * 移除本地uid缓存和cookie中的uid
 */ var removeLocalUid = function removeLocalUid() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(getUIDKey(), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)()
        });
    }
    window.localStorage.removeItem("uid");
};


/***/ }),

/***/ 54759:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useWpsAnchorIntercept)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11440);


/**
 * WPS 客户端内嵌时在 document capture 阶段拦截带 `href` 且 `target="_blank"` 的 `<a>` 左键点击，
 * 将其改为在当前页打开。
 *
 * - 修饰键（Ctrl / Meta / Shift / Alt）点击不拦截，保留系统行为。
 * - 带 `download` 属性、`javascript:` 的 `<a>` 不拦截。
 */ function useWpsAnchorIntercept() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled || typeof document === "undefined") {
            return;
        }
        if (!(0,_utils_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
            return;
        }
        var onClickCapture = function onClickCapture(event) {
            if (event.defaultPrevented) {
                return;
            }
            if (event.button !== 0) {
                return;
            }
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }
            var el = event.target;
            if (!el || !(el instanceof Element)) {
                return;
            }
            var anchor = el.closest("a[href]");
            if (!(anchor instanceof HTMLAnchorElement)) {
                return;
            }
            // 只拦截 target="_blank"（新窗口打开）的链接；当前页替换的不需要拦截
            if (anchor.getAttribute("target") !== "_blank") {
                return;
            }
            // 声明式下载：不劫持
            if (anchor.hasAttribute("download")) {
                return;
            }
            var rawHref = anchor.getAttribute("href");
            if (!rawHref || !rawHref.trim()) {
                return;
            }
            if (/^javascript:/i.test(rawHref.trim())) {
                return;
            }
            // WPS 场景：所有新开页面直接在当前页打开
            event.preventDefault();
            window.location.href = anchor.href;
        };
        document.addEventListener("click", onClickCapture, true);
        return function() {
            document.removeEventListener("click", onClickCapture, true);
        };
    }, [
        enabled
    ]);
}


/***/ }),

/***/ 1504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ useWpsNavigationIntercept)
/* harmony export */ });
/* harmony import */ var _useWpsAnchorIntercept__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54759);
/* harmony import */ var _useWpsWindowOpenIntercept__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);


/**
 * WPS 客户端内嵌时同时注册 `window.open` 与 `<a href>` 的兜底拦截。
 * @param enabled 为 false 时两者均不注册
 */ function useWpsNavigationIntercept() {
    var enabledWindowOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var enabledAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0,_useWpsWindowOpenIntercept__WEBPACK_IMPORTED_MODULE_0__/* .useWpsWindowOpenIntercept */ .y)(enabledWindowOpen);
    (0,_useWpsAnchorIntercept__WEBPACK_IMPORTED_MODULE_1__/* .useWpsAnchorIntercept */ .t)(enabledAnchor);
}


/***/ }),

/***/ 1120:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ useWpsWindowOpenIntercept)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11440);


/**
 * WPS 客户端内嵌时劫持 `window.open`：将所有新开页面改为在当前页打开。
 * 非 WPS 环境不注册；卸载时恢复进入 effect 时的 `window.open`。
 *
 * @param enabled 为 false 时不注册（便于按路由开关）
 */ function useWpsWindowOpenIntercept() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled || "object" === "undefined") {
            return;
        }
        if (!(0,_utils_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
            return;
        }
        var previousOpen = window.open.bind(window);
        var patchedOpen = function patchedOpen() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args[0], target = args[1];
            if (url === undefined || url === "") {
                return previousOpen.apply(window, args);
            }
            // _self/_parent/_top 本身就在当前页打开，走默认行为
            var normalizedTarget = typeof target === "string" ? target.toLowerCase() : "";
            if (normalizedTarget === "_self" || normalizedTarget === "_parent" || normalizedTarget === "_top") {
                return previousOpen.apply(window, args);
            }
            // WPS 场景：所有新开页面直接在当前页打开
            var urlStr = typeof url === "string" ? url : url.toString();
            window.location.href = urlStr;
            return null;
        };
        window.open = patchedOpen;
        return function() {
            window.open = previousOpen;
        };
    }, [
        enabled
    ]);
}


/***/ }),

/***/ 51115:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": () => (/* binding */ getWPSPayStatus),
/* harmony export */   "Jo": () => (/* binding */ wpsPreOrder),
/* harmony export */   "xj": () => (/* binding */ getWPSUserInfo)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57526);



/**
 * WPS预下单
 * @return
 */ var wpsPreOrder = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee(position, subscribe_type) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    ;
                    _context.next = 3;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/pre_order", {
                        method: "post",
                        data: {
                            position: position,
                            type: subscribe_type === "meidou" ? 2 : 1
                        },
                        hiddenMessage: true
                    });
                case 3:
                    return _context.abrupt("return", _context.sent);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function wpsPreOrder(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 获取WPS绑定的用户信息
 * @return
 */ var getWPSUserInfo = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/meitu_user_info", {
                        method: "get",
                        hiddenMessage: true
                    });
                case 2:
                    return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function getWPSUserInfo() {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * 查询WPS支付状态
 * 接口路径待后端最终确认，当前先按约定占位
 * @return
 */ var getWPSPayStatus = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3(billNo) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/order_status", {
                        method: "get",
                        params: {
                            bill_no: billNo
                        },
                        hiddenMessage: true
                    });
                case 2:
                    return _context3.abrupt("return", _context3.sent);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getWPSPayStatus(_x3) {
        return _ref3.apply(this, arguments);
    };
}();


/***/ }),

/***/ 11440:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ createWPSClientPayOrder),
/* harmony export */   "De": () => (/* binding */ offLoginStatusChanged),
/* harmony export */   "Ku": () => (/* binding */ isFromWPSClient),
/* harmony export */   "QA": () => (/* binding */ redirectToDesignRoomLogin),
/* harmony export */   "XK": () => (/* binding */ getWPSClientUserInfo),
/* harmony export */   "ci": () => (/* binding */ buyMerchandiseByBillno),
/* harmony export */   "g4": () => (/* binding */ onWPSLoginStatusChanged),
/* harmony export */   "k0": () => (/* binding */ openWPSNewTab),
/* harmony export */   "sr": () => (/* binding */ isClientNeedLogin),
/* harmony export */   "tb": () => (/* binding */ callWpsClientLogin),
/* harmony export */   "uw": () => (/* binding */ waitWPSClientReady)
/* harmony export */ });
/* unused harmony exports getLaunchOptions, LaunchPayWindow */
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51115);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19200);
/* harmony import */ var _runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89923);
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27474);






/**
 * 模块加载时绑定的浏览器原生 `window.open`，供 `openWPSNewTab` 跨域分支使用，
 * 避免业务对 `window.open` 的劫持后产生递归调用。
 */ var wpsNativeWindowOpen =  true ? window.open.bind(window) : 0;
/**
 * 获取WPS客户端用户信息，获取授权
 * @returns GetUserInfoResult
 */ var getWPSClientUserInfo = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee() {
        var p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    p = new Promise(function(resolve) {
                        window.wps.getUserInfo({
                            complete: function complete(res) {
                                resolve(res);
                            }
                        });
                    });
                    return _context.abrupt("return", p);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getWPSClientUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var buyMerchandiseByBillno = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2(billno) {
        var p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    p = new Promise(function(resolve) {
                        window.wps.buyMerchandiseByBillno({
                            billno: billno,
                            complete: function complete(res) {
                                resolve(res);
                            }
                        });
                    });
                    return _context2.abrupt("return", p);
                case 2:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function buyMerchandiseByBillno(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var getLaunchOptions = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3() {
        var p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.getLaunchOptions({
                                complete: function complete(res) {
                                    resolve(res);
                                }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    });
                    return _context3.abrupt("return", p);
                case 2:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getLaunchOptions() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 监听WPS登录状态变化事件，登录状态变化时会触发回调函数，并通过`window.wps.isLogin`接口获取当前登录状态
 */ var onWPSLoginStatusChanged = function onWPSLoginStatusChanged(onLoginStatusChanged) {
    window.wps.onLoginStatusChanged(function() {
        ;
        window.wps.isLogin({
            complete: function complete(res) {
                if (res.code === 0) {
                    onLoginStatusChanged(res.data.is_login);
                }
            }
        });
    });
};
/**
 * 唤起WPS自己的登录弹窗
 */ function callWpsClientLogin() {
    return _callWpsClientLogin.apply(this, arguments);
}
/**
 * 关闭登录状态监听
 */ function _callWpsClientLogin() {
    _callWpsClientLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee6() {
        var p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.login({
                                complete: function complete(res) {
                                    resolve(res);
                                    ;
                                }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    });
                    return _context6.abrupt("return", p);
                case 2:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return _callWpsClientLogin.apply(this, arguments);
}
function offLoginStatusChanged() {
    window.wps.offLoginStatusChanged();
}
function normalizeWPSNewTabAction(action) {
    // 如果传入的不是绝对路径，则直接使用原值跳转
    var isAbsoluteUrl = /^(https?:)?\/\//i.test(action);
    if (!isAbsoluteUrl) {
        return {
            action: action,
            shouldUseWindowOpen: false
        };
    }
    try {
        // 如果是同源下的绝对URL，则转换为相对URL
        var parsedUrl = new URL(action, window.location.origin);
        if (parsedUrl.origin === window.location.origin) {
            return {
                action: "".concat(parsedUrl.pathname).concat(parsedUrl.search).concat(parsedUrl.hash),
                shouldUseWindowOpen: false
            };
        }
        // 如果是非同源下的绝对URL，则直接打开新页签
        return {
            action: parsedUrl.toString(),
            shouldUseWindowOpen: true
        };
    } catch (e) {
        return {
            action: action,
            shouldUseWindowOpen: false
        };
    }
}
/**
 * wps打开新的tab页签
 * @returns
 */ var openWPSNewTab = /*#__PURE__*/ function() {
    var _ref4 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee4(action) {
        var _normalizeWPSNewTabAc, normalizedAction, shouldUseWindowOpen, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    // WPS仅允许传入同源下的相对路径
                    _normalizeWPSNewTabAc = normalizeWPSNewTabAction(action), normalizedAction = _normalizeWPSNewTabAc.action, shouldUseWindowOpen = _normalizeWPSNewTabAc.shouldUseWindowOpen;
                    if (!shouldUseWindowOpen) {
                        _context4.next = 4;
                        break;
                    }
                    wpsNativeWindowOpen === null || wpsNativeWindowOpen === void 0 || wpsNativeWindowOpen(normalizedAction, "_blank");
                    return _context4.abrupt("return");
                case 4:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.newAppInstance({
                                action: normalizedAction,
                                complete: function complete(res) {
                                    resolve(res);
                                }
                            });
                        } catch (e) {
                            ;
                            reject(e);
                        }
                    });
                    return _context4.abrupt("return", p);
                case 6:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function openWPSNewTab(_x2) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * 判断是否来自WPS客户端渠道
 * @returns boolean
 */ function isFromWPSClient() {
    return (0,_source__WEBPACK_IMPORTED_MODULE_2__/* .isFromWpsSource */ .Sl)("client");
}
/**
 * 等待WPS客户端初始化完成
 * @returns boolean
 */ function waitWPSClientReady() {
    return _waitWPSClientReady.apply(this, arguments);
}
/**
 * 拼接参数跳转到设计室的登录授权页面
 */ function _waitWPSClientReady() {
    _waitWPSClientReady = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee7() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_3__/* .isWpsServerSide */ .F)()) {
                        _context7.next = 2;
                        break;
                    }
                    return _context7.abrupt("return", false);
                case 2:
                    if (window.wps) {
                        _context7.next = 4;
                        break;
                    }
                    return _context7.abrupt("return", new Promise(function(resolve) {
                        document.addEventListener("WpsofficeSDKReady", function() {
                            if (window.__wpsoffice_environment === "miniprogram") {
                                ;
                                resolve(true);
                            } else {
                                ;
                                resolve(false);
                            }
                        }, false);
                    }));
                case 4:
                    return _context7.abrupt("return", true);
                case 5:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _waitWPSClientReady.apply(this, arguments);
}
var redirectToDesignRoomLogin = /*#__PURE__*/ function() {
    var _ref5 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee5(code) {
        var redirect_url, url;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    redirect_url = _constant__WEBPACK_IMPORTED_MODULE_4__/* .appinfo.redirectURL */ .hm.redirectURL + "?channel=wps_pc&from_wps=client";
                    url = new URL(_constant__WEBPACK_IMPORTED_MODULE_4__/* .appinfo.authorizeURL */ .hm.authorizeURL);
                    url.searchParams.set("code", code);
                    url.searchParams.set("redirect_url", redirect_url);
                    window.location.replace(url.toString());
                case 5:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function redirectToDesignRoomLogin(_x3) {
        return _ref5.apply(this, arguments);
    };
}();
/**
 * 客户端预下单
 */ function createWPSClientPayOrder(_x4) {
    return _createWPSClientPayOrder.apply(this, arguments);
}
/**
 * 客户端调起支付弹窗
 */ function _createWPSClientPayOrder() {
    _createWPSClientPayOrder = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee8(subscribeType) {
        var _options$data;
        var options, position;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee8$(_context8) {
            while(1)switch(_context8.prev = _context8.next){
                case 0:
                    _context8.next = 2;
                    return getLaunchOptions();
                case 2:
                    options = _context8.sent;
                    position = (options === null || options === void 0 || (_options$data = options.data) === null || _options$data === void 0 || (_options$data = _options$data.extraData) === null || _options$data === void 0 ? void 0 : _options$data.position) || "docertest";
                    _context8.next = 6;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .wpsPreOrder */ .Jo)(position, subscribeType);
                case 6:
                    return _context8.abrupt("return", _context8.sent);
                case 7:
                case "end":
                    return _context8.stop();
            }
        }, _callee8);
    }));
    return _createWPSClientPayOrder.apply(this, arguments);
}
function LaunchPayWindow(_x5) {
    return _LaunchPayWindow.apply(this, arguments);
}
function _LaunchPayWindow() {
    _LaunchPayWindow = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee9(subscribeType) {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while(1)switch(_context9.prev = _context9.next){
                case 0:
                    _context9.next = 2;
                    return createWPSClientPayOrder(subscribeType);
                case 2:
                    data = _context9.sent;
                    _context9.next = 5;
                    return buyMerchandiseByBillno(data.bill_no);
                case 5:
                    res = _context9.sent;
                    ;
                    // 为true表示用户支付成功
                    return _context9.abrupt("return", {
                        status: res.data.status,
                        billNo: data.bill_no
                    });
                case 8:
                case "end":
                    return _context9.stop();
            }
        }, _callee9);
    }));
    return _LaunchPayWindow.apply(this, arguments);
}
function isClientNeedLogin() {
    var queryParams = new URLSearchParams(window.location.search);
    return !!queryParams.get("must_login");
}


/***/ }),

/***/ 19200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_CLOSE),
/* harmony export */   "J$": () => (/* binding */ WPS_BIND_INFO_UPDATED),
/* harmony export */   "Om": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS),
/* harmony export */   "RT": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_SHOW),
/* harmony export */   "cb": () => (/* binding */ servers),
/* harmony export */   "hm": () => (/* binding */ appinfo)
/* harmony export */ });
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97303);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84999);


var appinfo = {
    get appid () {
        var isRelease = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env === _utils_env__WEBPACK_IMPORTED_MODULE_1__/* .ENV_ENUM.release */ .BD.release;
        return isRelease ? "AK20260325HJNXLH" : "SX20260325UBKOSX";
    },
    scope: "user_info,vas",
    /** 设计室的登录授权回调地址 */ get authorizeURL () {
        var envPrefix = (0,_utils_env__WEBPACK_IMPORTED_MODULE_1__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env);
        return "https://".concat(envPrefix || "www", ".designkit.cn/v1/wps/oauth2_callback");
    },
    /** 登录授权成功后的回调地址 */ get redirectURL () {
        var envPrefix1 = (0,_utils_env__WEBPACK_IMPORTED_MODULE_1__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env) || "www";
        return "https://".concat(envPrefix1, ".designkit.cn");
    }
};
var servers = {
    authorize: "https://openapi.wps.cn/oauthapi/v2/authorize",
    // web端授权
    webPay: "https://vip.wps.cn/vcl_svr/static/wpspay" // web端支付窗
};
/**
 * wps支付弹窗显示事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_SHOW = "xdesign-wps-pay-modal-listener-event-show";
/**
 * wps支付弹窗关闭事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_CLOSE = "xdesign-wps-pay-modal-listener-event-close";
/**
 * wps支付成功事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS = "xdesign-wps-pay-modal-listener-event-success";
/**
 * wps绑定信息更新事件（getWPSBindInfo 完成后触发，业务方可监听此事件刷新用户信息）
 */ var WPS_BIND_INFO_UPDATED = "xdesign-wps-bind-info-updated";


/***/ }),

/***/ 59391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N0": () => (/* reexport */ source/* appendWpsSourceParamsToUrl */.N0),
  "JB": () => (/* binding */ getWPSBindInfo),
  "ji": () => (/* binding */ isFromWPS),
  "Ku": () => (/* reexport */ client/* isFromWPSClient */.Ku),
  "k0": () => (/* reexport */ client/* openWPSNewTab */.k0),
  "kS": () => (/* binding */ openWpsPayModal),
  "_i": () => (/* reexport */ source/* syncWpsSourceParamsFromUrl */._i),
  "jJ": () => (/* binding */ wpsCheckLogin),
  "cr": () => (/* binding */ wpsClientLogin),
  "Mv": () => (/* binding */ wpsWebLogin)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var utils = __webpack_require__(16197);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/eventBus.js
var eventBus = __webpack_require__(77724);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/api.js
var api = __webpack_require__(51115);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/client.js
var client = __webpack_require__(11440);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/constant.js
var constant = __webpack_require__(19200);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/runtime.js
var runtime = __webpack_require__(89923);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/source.js + 1 modules
var source = __webpack_require__(27474);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/web.js






/**
 * 格式化WPS授权登录URL
 * @return {string} WPS 授权登录链接
 */ function formatWPSOauth2AuthorizeUrl() {
    var redirect_url = constant/* appinfo.redirectURL */.hm.redirectURL + "?channel=wps_web&from_wps=web";
    var authorizeURL = new URL(constant/* appinfo.authorizeURL */.hm.authorizeURL);
    var wpsAuthorizeURL = new URL(constant/* servers.authorize */.cb.authorize);
    authorizeURL.searchParams.set("redirect_url", redirect_url);
    wpsAuthorizeURL.searchParams.set("response_type", "code");
    wpsAuthorizeURL.searchParams.set("appid", constant/* appinfo.appid */.hm.appid);
    wpsAuthorizeURL.searchParams.set("autologin", "true");
    wpsAuthorizeURL.searchParams.set("redirect_uri", authorizeURL.toString());
    wpsAuthorizeURL.searchParams.set("scope", constant/* appinfo.scope */.hm.scope);
    wpsAuthorizeURL.searchParams.set("state", "wps-redirect");
    return wpsAuthorizeURL.toString();
}
/**
 * 判断是否来自WPS web渠道
 * @return {boolean} 是否来自 WPS web 渠道
 */ function isFromWPSWeb() {
    return (0,source/* isFromWpsSource */.Sl)("web");
}
/**
 * 跳转到WPS授权登录
 */ function redirectToWPS() {
    if ((0,runtime/* isWpsServerSide */.F)()) return;
    var authorizeUri = formatWPSOauth2AuthorizeUrl();
    window.location.replace(authorizeUri);
}
/**
 * 获取WPS支付弹窗信息
 */ function getWPSPayInfo(_x) {
    return _getWPSPayInfo.apply(this, arguments);
}
/**
 * 获取WPS支付弹窗URL
 */ function _getWPSPayInfo() {
    _getWPSPayInfo = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee(subscribe_type) {
        var webPayUrl, billNo, queryParams, position, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    webPayUrl = "";
                    billNo = "";
                    if (!(0,runtime/* isWpsServerSide */.F)()) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", {
                        url: "",
                        billNo: ""
                    });
                case 4:
                    queryParams = new URLSearchParams(window.location.search);
                    position = queryParams.get("position") || "docertest";
                    _context.next = 8;
                    return (0,api/* wpsPreOrder */.Jo)(position, subscribe_type);
                case 8:
                    data = _context.sent;
                    if (data.bill_no) {
                        billNo = data.bill_no;
                        // 将合作方的订单号拼接成完整的支付链接，并通过iframe打开
                        webPayUrl = "".concat(constant/* servers.webPay */.cb.webPay, "?billno=").concat(data === null || data === void 0 ? void 0 : data.bill_no, "&platform=pc&isclient=false&hideclosebtn=1&is_large_size=true#/");
                    }
                    return _context.abrupt("return", {
                        url: webPayUrl,
                        billNo: billNo
                    });
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return _getWPSPayInfo.apply(this, arguments);
}
function getWPSPayUrl() {
    return _getWPSPayUrl.apply(this, arguments);
}
function _getWPSPayUrl() {
    _getWPSPayUrl = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
        var _yield$getWPSPayInfo, url;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return getWPSPayInfo();
                case 2:
                    _yield$getWPSPayInfo = _context2.sent;
                    url = _yield$getWPSPayInfo.url;
                    return _context2.abrupt("return", url);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return _getWPSPayUrl.apply(this, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js











var DEFAULT_WPS_PAY_POLL_INTERVAL = 1000;
var DEFAULT_WPS_PAY_POLL_TIMEOUT = 20 * 60 * 1000;
var WPS_CLIENT_PAY_STATUS_SYNC_TIMEOUT = 10 * 1000;
function emitWpsPaySuccess(result, trackParams) {
    eventBus/* default.emit */.Z.emit(constant/* WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS */.Om, {
        result: result,
        trackParams: trackParams
    });
}
function pollWpsWebPayStatus(_x) {
    return _pollWpsWebPayStatus.apply(this, arguments);
}
/**
 * 调用设计室接口获取是否绑定了WPS
 */ function _pollWpsWebPayStatus() {
    _pollWpsWebPayStatus = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(billNo) {
        var _options$pollInterval, _options$pollTimeout;
        var options, pollInterval, pollTimeout, startTime, closed, handleClose, _options$shouldStop, _options$shouldStop2, result, _args2 = arguments;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                    pollInterval = (_options$pollInterval = options.pollInterval) !== null && _options$pollInterval !== void 0 ? _options$pollInterval : DEFAULT_WPS_PAY_POLL_INTERVAL;
                    pollTimeout = (_options$pollTimeout = options.pollTimeout) !== null && _options$pollTimeout !== void 0 ? _options$pollTimeout : DEFAULT_WPS_PAY_POLL_TIMEOUT;
                    startTime = Date.now();
                    closed = false;
                    handleClose = function handleClose() {
                        closed = true;
                    };
                    eventBus/* default.on */.Z.on(constant/* WPS_PAY_MODAL_LISTENER_EVENT_CLOSE */.BO, handleClose);
                    _context2.prev = 7;
                case 8:
                    if (!(!closed && !((_options$shouldStop = options.shouldStop) !== null && _options$shouldStop !== void 0 && _options$shouldStop.call(options)) && Date.now() - startTime <= pollTimeout)) {
                        _context2.next = 20;
                        break;
                    }
                    _context2.next = 11;
                    return (0,api/* getWPSPayStatus */.BL)(billNo);
                case 11:
                    result = _context2.sent;
                    if (!result.status) {
                        _context2.next = 14;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 14:
                    if (!(closed || (_options$shouldStop2 = options.shouldStop) !== null && _options$shouldStop2 !== void 0 && _options$shouldStop2.call(options))) {
                        _context2.next = 16;
                        break;
                    }
                    return _context2.abrupt("break", 20);
                case 16:
                    _context2.next = 18;
                    return (0,utils/* sleep */._v)(pollInterval);
                case 18:
                    _context2.next = 8;
                    break;
                case 20:
                    return _context2.abrupt("return", false);
                case 21:
                    _context2.prev = 21;
                    eventBus/* default.off */.Z.off(constant/* WPS_PAY_MODAL_LISTENER_EVENT_CLOSE */.BO, handleClose);
                    return _context2.finish(21);
                case 24:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                7,
                ,
                21,
                24
            ]
        ]);
    }));
    return _pollWpsWebPayStatus.apply(this, arguments);
}
function getWPSBindInfo() {
    return _getWPSBindInfo.apply(this, arguments);
}
/**
 * WPS web端登录授权流程
 */ function _getWPSBindInfo() {
    _getWPSBindInfo = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee3() {
        var hasWPSUserInfo, wpsUserInfo;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    hasWPSUserInfo = false;
                    _context3.prev = 1;
                    _context3.next = 4;
                    return (0,api/* getWPSUserInfo */.xj)();
                case 4:
                    wpsUserInfo = _context3.sent;
                    ;
                    hasWPSUserInfo = !!wpsUserInfo.access_token;
                    _context3.next = 12;
                    break;
                case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3["catch"](1);
                    ;
                case 12:
                    // 通知业务方刷新用户信息（该接口可能涉及赠送权益，需要业务方重新拉取最新用户数据）
                    eventBus/* default.emit */.Z.emit(constant/* WPS_BIND_INFO_UPDATED */.J$);
                    return _context3.abrupt("return", hasWPSUserInfo);
                case 14:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                1,
                9
            ]
        ]);
    }));
    return _getWPSBindInfo.apply(this, arguments);
}
function wpsWebLogin() {
    return _wpsWebLogin.apply(this, arguments);
}
function _wpsWebLogin() {
    _wpsWebLogin = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee4() {
        var hasWPSUserInfo;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return getWPSBindInfo();
                case 2:
                    hasWPSUserInfo = _context4.sent;
                    if (hasWPSUserInfo) {
                        _context4.next = 6;
                        break;
                    }
                    // 未绑定WPS，跳转到WPS去授权登录
                    redirectToWPS();
                    return _context4.abrupt("return", false);
                case 6:
                    return _context4.abrupt("return", hasWPSUserInfo);
                case 7:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return _wpsWebLogin.apply(this, arguments);
}
var WPS_AUTH_OVERLAY_ID = "wps-auth-retry-overlay";
function removeAuthRetryOverlay() {
    var _document$getElementB;
    (_document$getElementB = document.getElementById(WPS_AUTH_OVERLAY_ID)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
}
function showAuthRetryOverlay(callLogin) {
    ;
    removeAuthRetryOverlay();
    var overlay = document.createElement("div");
    overlay.id = WPS_AUTH_OVERLAY_ID;
    overlay.style.cssText = "position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:99999;background:transparent;";
    overlay.addEventListener("click", /*#__PURE__*/ (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    if (!callLogin) {
                        _context.next = 6;
                        break;
                    }
                    ;
                    _context.next = 4;
                    return (0,client/* callWpsClientLogin */.tb)();
                case 4:
                    _context.next = 9;
                    break;
                case 6:
                    removeAuthRetryOverlay();
                    _context.next = 9;
                    return attemptWPSClientAuth();
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    })));
    document.body.appendChild(overlay);
}
function attemptWPSClientAuth() {
    return _attemptWPSClientAuth.apply(this, arguments);
}
/**
 * WPS端内登录授权流程
 */ function _attemptWPSClientAuth() {
    _attemptWPSClientAuth = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee5() {
        var res;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    ;
                    _context5.next = 3;
                    return (0,client/* getWPSClientUserInfo */.XK)();
                case 3:
                    res = _context5.sent;
                    if (res.code === 0) {
                        (0,client/* redirectToDesignRoomLogin */.QA)(res.login_code);
                    } else {
                        showAuthRetryOverlay();
                    }
                case 5:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return _attemptWPSClientAuth.apply(this, arguments);
}
function wpsClientLogin() {
    return _wpsClientLogin.apply(this, arguments);
}
/**
 * 检查是否登录了WPS，否则进行授权登录
 * 客户端和web端流程不同
 * @return {boolean} 是否已完成 WPS 绑定校验
 */ function _wpsClientLogin() {
    _wpsClientLogin = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee6() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    _context6.next = 2;
                    return (0,client/* waitWPSClientReady */.uw)();
                case 2:
                    (0,client/* offLoginStatusChanged */.De)();
                    // 监听WPS登录状态变化事件，登录状态变化时同步更新设计室登录状态
                    (0,client/* onWPSLoginStatusChanged */.g4)(function(isLogin) {
                        ;
                        if (!isLogin) {
                            ;
                            showAuthRetryOverlay(true);
                        } else {
                            ;
                            getWPSBindInfo();
                            attemptWPSClientAuth();
                        }
                    });
                    // 内嵌的，每次打开都调用一次，同步权益信息等
                    getWPSBindInfo();
                    if (!(0,client/* isClientNeedLogin */.sr)()) {
                        _context6.next = 8;
                        break;
                    }
                    _context6.next = 8;
                    return attemptWPSClientAuth();
                case 8:
                    return _context6.abrupt("return", true);
                case 9:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return _wpsClientLogin.apply(this, arguments);
}
function wpsCheckLogin() {
    return _wpsCheckLogin.apply(this, arguments);
}
function _wpsCheckLogin() {
    _wpsCheckLogin = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee7() {
        var hasBindWPS;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    hasBindWPS = false;
                    if (!(0,client/* isFromWPSClient */.Ku)()) {
                        _context7.next = 5;
                        break;
                    }
                    _context7.next = 4;
                    return wpsClientLogin();
                case 4:
                    hasBindWPS = _context7.sent;
                case 5:
                    if (!isFromWPSWeb()) {
                        _context7.next = 9;
                        break;
                    }
                    _context7.next = 8;
                    return wpsWebLogin();
                case 8:
                    hasBindWPS = _context7.sent;
                case 9:
                    return _context7.abrupt("return", hasBindWPS);
                case 10:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _wpsCheckLogin.apply(this, arguments);
}
function isFromWPS() {
    return isFromWPSWeb() || (0,client/* isFromWPSClient */.Ku)();
}
/**
 * 打开WPS支付弹窗
 */ function openWpsPayModal(_x2) {
    return _openWpsPayModal.apply(this, arguments);
}
function _openWpsPayModal() {
    _openWpsPayModal = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee9(trackParams) {
        var options, stopPayStatusPolling, preOrder, billNo, payStatusPromise, payResult, status, pollStatus, result, _options$onSuccess, _yield$getWPSPayInfo, url, _billNo, _status, _result, _options$onSuccess2, _args9 = arguments;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee9$(_context9) {
            while(1)switch(_context9.prev = _context9.next){
                case 0:
                    options = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                    ;
                    if (!(0,client/* isFromWPSClient */.Ku)()) {
                        _context9.next = 25;
                        break;
                    }
                    stopPayStatusPolling = false;
                    _context9.next = 6;
                    return (0,client/* createWPSClientPayOrder */.A)((trackParams === null || trackParams === void 0 ? void 0 : trackParams.subscribe_type) || "");
                case 6:
                    preOrder = _context9.sent;
                    billNo = preOrder.bill_no; // 内嵌不需要打开弹出，但是需要上报事件
                    eventBus/* default.emit */.Z.emit(constant/* WPS_PAY_MODAL_LISTENER_EVENT_SHOW */.RT, {
                        show: false,
                        url: "",
                        trackParams: trackParams
                    });
                    payStatusPromise = pollWpsWebPayStatus(billNo, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
                        shouldStop: function shouldStop() {
                            return stopPayStatusPolling;
                        }
                    }));
                    payStatusPromise.catch(function(error) {
                        ;
                    });
                    _context9.next = 13;
                    return (0,client/* buyMerchandiseByBillno */.ci)(billNo);
                case 13:
                    payResult = _context9.sent;
                    status = payResult.data.status;
                    ;
                    // 客户端支付接口返回后，最多再给服务端 10 秒同步支付状态；若轮询已成功则立即返回。
                    _context9.t0 = Boolean;
                    _context9.next = 19;
                    return Promise.race([
                        payStatusPromise,
                        (0,utils/* sleep */._v)(WPS_CLIENT_PAY_STATUS_SYNC_TIMEOUT).then(/*#__PURE__*/ (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee8() {
                            return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee8$(_context8) {
                                while(1)switch(_context8.prev = _context8.next){
                                    case 0:
                                        stopPayStatusPolling = true;
                                        return _context8.abrupt("return", payStatusPromise);
                                    case 2:
                                    case "end":
                                        return _context8.stop();
                                }
                            }, _callee8);
                        })))
                    ]);
                case 19:
                    _context9.t1 = _context9.sent;
                    pollStatus = (0, _context9.t0)(_context9.t1);
                    ;
                    result = {
                        status: pollStatus,
                        url: ""
                    };
                    if (pollStatus) {
                        emitWpsPaySuccess(result, trackParams);
                        (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, result);
                    }
                    return _context9.abrupt("return", result);
                case 25:
                    if (!isFromWPSWeb()) {
                        _context9.next = 40;
                        break;
                    }
                    _context9.next = 28;
                    return getWPSPayInfo(trackParams.subscribe_type || "");
                case 28:
                    _yield$getWPSPayInfo = _context9.sent;
                    url = _yield$getWPSPayInfo.url;
                    _billNo = _yield$getWPSPayInfo.billNo;
                    if (url) {
                        _context9.next = 33;
                        break;
                    }
                    return _context9.abrupt("return", {
                        status: false,
                        url: "",
                        billNo: _billNo
                    });
                case 33:
                    eventBus/* default.emit */.Z.emit(constant/* WPS_PAY_MODAL_LISTENER_EVENT_SHOW */.RT, {
                        show: true,
                        url: url,
                        trackParams: trackParams
                    });
                    _context9.next = 36;
                    return pollWpsWebPayStatus(_billNo, options);
                case 36:
                    _status = _context9.sent;
                    _result = {
                        status: _status,
                        url: url,
                        billNo: _billNo
                    };
                    if (_result.status) {
                        emitWpsPaySuccess(_result, trackParams);
                        (_options$onSuccess2 = options.onSuccess) === null || _options$onSuccess2 === void 0 || _options$onSuccess2.call(options, _result);
                    }
                    return _context9.abrupt("return", _result);
                case 40:
                    return _context9.abrupt("return", {
                        status: false,
                        url: ""
                    });
                case 41:
                case "end":
                    return _context9.stop();
            }
        }, _callee9);
    }));
    return _openWpsPayModal.apply(this, arguments);
}


/***/ }),

/***/ 89923:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ isWpsServerSide)
/* harmony export */ });
var isWpsServerSide = function isWpsServerSide() {
    return  false || typeof document === "undefined";
};


/***/ }),

/***/ 27474:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N0": () => (/* binding */ appendWpsSourceParamsToUrl),
  "Sl": () => (/* binding */ isFromWpsSource),
  "_i": () => (/* binding */ syncWpsSourceParamsFromUrl)
});

// UNUSED EXPORTS: getWpsSourceParams, hasWpsSource

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(63915);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = (0,unsupportedIterableToArray/* default */.Z)(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/runtime.js
var runtime = __webpack_require__(89923);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/source.js


var WPS_CHANNELS = new Set([
    "wps_web",
    "wps_pc"
]);
// WPS 来源需要在浏览器会话内跨 Tab 共享：同一浏览器窗口新开标签页也能识别来源。
// 使用不设 expires/max-age 的 session cookie，浏览器关闭时自动清除。
var WPS_SESSION_CHANNEL_KEY = "wps_channel";
var WPS_SESSION_SOURCE_KEY = "wps_from_wps";
var ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;
var setSessionCookie = function setSessionCookie(key, value) {
    if ((0,runtime/* isWpsServerSide */.F)()) return;
    document.cookie = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value), ";path=/;SameSite=Lax");
};
var getSessionCookie = function getSessionCookie(key) {
    if ((0,runtime/* isWpsServerSide */.F)()) return null;
    var name = encodeURIComponent(key);
    var _iterator = _createForOfIteratorHelper(document.cookie.split(";")), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var trimmed = cookie.trim();
            if (trimmed.startsWith("".concat(name, "="))) {
                return decodeURIComponent(trimmed.substring(name.length + 1));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return null;
};
var emptyWpsSourceParams = function emptyWpsSourceParams() {
    return {
        channel: "",
        from_wps: ""
    };
};
var isValidWpsSource = function isValidWpsSource(fromWps) {
    return fromWps === "web" || fromWps === "client";
};
var isValidWpsSourceParams = function isValidWpsSourceParams(_ref) {
    var channel = _ref.channel, from_wps = _ref.from_wps;
    return WPS_CHANNELS.has(channel) && isValidWpsSource(from_wps);
};
/**
 * 修正 WpsSourceParams
 * @param params WpsSourceParams
 * @returns WpsSourceParams
 */ var correctWpsSourceParams = function correctWpsSourceParams(params) {
    var _window;
    if (!window) return params;
    var ua = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
    if (!ua) return params;
    // 如果 params 不合法，则直接返回
    if (!isValidWpsSourceParams(params)) return params;
    var isClient = ua.includes("WpsOfficeApp");
    // 判断是否需要修正
    if (isClient && params.channel === "wps_pc" && params.from_wps === "client") {
        return params;
    }
    if (!isClient && params.channel === "wps_web" && params.from_wps === "web") {
        return params;
    }
    var newParams = params;
    // 加入根据 ua 判断逻辑，对nextParams进行修正，如果 ua 包含WpsOfficeApp，就一定是端内，否则是web
    if (isClient) {
        newParams = {
            channel: "wps_pc",
            from_wps: "client"
        };
    } else {
        newParams = {
            channel: "wps_web",
            from_wps: "web"
        };
    }
    // url 链接修正
    var url = new URL(window.location.href);
    url.searchParams.set("channel", newParams.channel);
    url.searchParams.set("from_wps", newParams.from_wps);
    window.history.replaceState(window.history.state, "", url.toString());
    return newParams;
};
var normalizeWpsSourceParams = function normalizeWpsSourceParams(params) {
    var nextParams = {
        channel: params.channel || "",
        from_wps: params.from_wps || ""
    };
    nextParams = correctWpsSourceParams(nextParams);
    return isValidWpsSourceParams(nextParams) ? nextParams : emptyWpsSourceParams();
};
var getWpsSourceParamsFromSearch = function getWpsSourceParamsFromSearch(search) {
    var queryParams = new URLSearchParams(search);
    return normalizeWpsSourceParams({
        channel: queryParams.get("channel") || "",
        from_wps: queryParams.get("from_wps") || ""
    });
};
var getStoredWpsSourceParams = function getStoredWpsSourceParams() {
    if ((0,runtime/* isWpsServerSide */.F)()) {
        return emptyWpsSourceParams();
    }
    return normalizeWpsSourceParams({
        channel: getSessionCookie(WPS_SESSION_CHANNEL_KEY) || "",
        from_wps: getSessionCookie(WPS_SESSION_SOURCE_KEY) || ""
    });
};
var serializeUrl = function serializeUrl(rawUrl, urlObject) {
    if (ABSOLUTE_URL_PATTERN.test(rawUrl)) {
        return urlObject.toString();
    }
    return "".concat(urlObject.pathname).concat(urlObject.search).concat(urlObject.hash);
};
/**
 * 读取当前生效的 WPS 来源。
 * 优先使用当前 URL 中的显式参数，其次回退到 session cookie，
 * 这样既能支持外部回跳时的最新来源，也能覆盖站内 Link/a 未保留 query 的场景。
 */ var getWpsSourceParams = function getWpsSourceParams() {
    if ((0,runtime/* isWpsServerSide */.F)()) {
        return emptyWpsSourceParams();
    }
    var urlParams = getWpsSourceParamsFromSearch(window.location.search);
    if (isValidWpsSourceParams(urlParams)) {
        return urlParams;
    }
    return getStoredWpsSourceParams();
};
/**
 * 将 URL 里的 WPS 来源同步到当前会话。
 * 首次从 WPS 进入站点时，query 是最可靠的来源标记；
 * 但后续站内切页、手写 a 标签或 react-router Link 往往不会持续保留这两个参数。
 * 因此需要在应用初始化时先把合法来源落到 session cookie，
 * 这样同一会话内继续跳转或刷新页面时，仍然可以识别为 WPS 场景。
 * 如果未来出现“不刷新页面、仅靠前端路由切换就带着 WPS query 进入当前 SPA”的场景，
 * 再考虑在路由变化时补充调用即可。
 */ var syncWpsSourceParamsFromUrl = function syncWpsSourceParamsFromUrl() {
    if ((0,runtime/* isWpsServerSide */.F)()) {
        return emptyWpsSourceParams();
    }
    var urlParams = getWpsSourceParamsFromSearch(window.location.search);
    if (isValidWpsSourceParams(urlParams)) {
        setSessionCookie(WPS_SESSION_CHANNEL_KEY, urlParams.channel);
        setSessionCookie(WPS_SESSION_SOURCE_KEY, urlParams.from_wps);
        return urlParams;
    }
    return getStoredWpsSourceParams();
};
var isFromWpsSource = function isFromWpsSource(source) {
    var params = getWpsSourceParams();
    return WPS_CHANNELS.has(params.channel) && params.from_wps === source;
};
var hasWpsSource = function hasWpsSource() {
    var params = getWpsSourceParams();
    return isValidWpsSourceParams(params);
};
/**
 * 为目标 URL 补齐当前会话中的 WPS 来源。
 * 站内同 tab 页面可直接依赖 sessionStorage；
 * 但跨项目、跨域或新开页面时，对方拿不到当前 tab 的会话态，就需要把来源重新带回 URL。
 */ var appendWpsSourceParamsToUrl = function appendWpsSourceParamsToUrl(url) {
    if ((0,runtime/* isWpsServerSide */.F)() || !url) {
        return url;
    }
    var params = getWpsSourceParams();
    if (!isValidWpsSourceParams(params)) {
        return url;
    }
    var urlObject = new URL(url, window.location.href);
    urlObject.searchParams.set("channel", params.channel);
    urlObject.searchParams.set("from_wps", params.from_wps);
    return serializeUrl(url, urlObject);
};


/***/ }),

/***/ 81167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

// EXTERNAL MODULE: ./node_modules/decode-uri-component/index.js
var decode_uri_component = __webpack_require__(93696);
// EXTERNAL MODULE: ./node_modules/filter-obj/index.js
var filter_obj = __webpack_require__(85252);
// EXTERNAL MODULE: ./node_modules/split-on-first/index.js
var split_on_first = __webpack_require__(33920);
;// CONCATENATED MODULE: ./node_modules/query-string/base.js



const isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>"%".concat(x.charCodeAt(0).toString(16).toUpperCase()));
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            {
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[",
                                    index,
                                    "]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[",
                                encode(index, options),
                                "]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "bracket":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "colon-list-separator":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    ":list="
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                ":list=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSeparator = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) {
                            return [
                                [
                                    encode(key, options),
                                    keyValueSeparator,
                                    encode(value, options)
                                ].join("")
                            ];
                        }
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                encode(key, options)
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            {
                return (key, value, accumulator)=>{
                    result = /\[(\d*)]$/.exec(key);
                    key = key.replace(/\[\d*]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = {};
                    }
                    accumulator[key][result[1]] = value;
                };
            }
        case "bracket":
            {
                return (key, value, accumulator)=>{
                    result = /(\[])$/.exec(key);
                    key = key.replace(/\[]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "colon-list-separator":
            {
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "comma":
        case "separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                    accumulator[key] = newValue;
                };
            }
        case "bracket-separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = /(\[])$/.test(key);
                    key = key.replace(/\[]$/, "");
                    if (!isArray) {
                        accumulator[key] = value ? decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : decode(value, options).split(options.arrayFormatSeparator);
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        ...arrayValue
                    ];
                };
            }
        default:
            {
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [
                        ...[
                            accumulator[key]
                        ].flat(),
                        value
                    ];
                };
            }
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) {
        throw new TypeError("arrayFormatSeparator must be single character string");
    }
}
function encode(value, options) {
    if (options.encode) {
        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }
    return value;
}
function decode(value, options) {
    if (options.decode) {
        return (0,decode_uri_component/* default */.Z)(value);
    }
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) {
        return input.sort();
    }
    if (typeof input === "object") {
        return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    }
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) {
        input = input.slice(0, hashStart);
    }
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) {
        hash = url.slice(hashStart);
    }
    return hash;
}
function parseValue(value, options, type) {
    if (type === "string" && typeof value === "string") {
        return value;
    }
    if (typeof type === "function" && typeof value === "string") {
        return type(value);
    }
    if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
        return value.toLowerCase() === "true";
    }
    if (type === "number" && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    return value;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) {
        return "";
    }
    return input.slice(queryStart + 1);
}
function parse(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") {
        return returnValue;
    }
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) {
        return returnValue;
    }
    for (const parameter of query.split("&")){
        if (parameter === "") {
            continue;
        }
        const parameter_ = options.decode ? parameter.replaceAll("+", " ") : parameter;
        let [key, value] = (0,split_on_first/* default */.Z)(parameter_, "=");
        if (key === undefined) {
            key = parameter_;
        }
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, returnValue);
    }
    for (const [key1, value1] of Object.entries(returnValue)){
        if (typeof value1 === "object" && value1 !== null && options.types[key1] !== "string") {
            for (const [key2, value2] of Object.entries(value1)){
                const type = options.types[key1] ? options.types[key1].replace("[]", "") : undefined;
                value1[key2] = parseValue(value2, options, type);
            }
        } else if (typeof value1 === "object" && value1 !== null && options.types[key1] === "string") {
            returnValue[key1] = Object.values(value1).join(options.arrayFormatSeparator);
        } else {
            returnValue[key1] = parseValue(value1, options, options.types[key1]);
        }
    }
    if (options.sort === false) {
        return returnValue;
    }
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function stringify(object, options) {
    if (!object) {
        return "";
    }
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object)){
        if (!shouldFilter(key)) {
            objectCopy[key] = value;
        }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
        keys.sort(options.sort);
    }
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) {
            return "";
        }
        if (value === null) {
            return encode(key, options);
        }
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") {
                return encode(key, options) + "[]";
            }
            return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function parseUrl(url, options) {
    var ref;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0,split_on_first/* default */.Z)(url, "#");
    if (url_ === undefined) {
        url_ = url;
    }
    var ref1;
    return {
        url: (ref1 = (ref = url_ === null || url_ === void 0 ? void 0 : url_.split("?")) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : "",
        query: parse(extract(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: decode(hash, options)
        } : {}
    };
}
function stringifyUrl(object, options) {
    options = {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true,
        ...options
    };
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = extract(object.url);
    const query = {
        ...parse(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = stringify(query, options);
    queryString && (queryString = "?".concat(queryString));
    let hash = getHash(object.url);
    if (typeof object.fragmentIdentifier === "string") {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : "#".concat(object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
}
function pick(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false,
        ...options
    };
    const { url , query , fragmentIdentifier  } = parseUrl(input, options);
    return stringifyUrl({
        url,
        query: (0,filter_obj/* includeKeys */.T)(query, filter),
        fragmentIdentifier
    }, options);
}
function exclude(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/query-string/index.js

/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 69289:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_createModalComponent)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var React_render = __webpack_require__(24996);
;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/renderPromise.js


var renderPromise = function renderPromise(node, container) {
    return new Promise(function(resolve) {
        var Root = function Root(_ref) {
            var onMount = _ref.onMount, children = _ref.children;
            (0,react.useEffect)(function() {
                onMount();
            }, []);
            return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
        };
        (0,React_render/* render */.sY)(/*#__PURE__*/ react.createElement(Root, {
            onMount: resolve
        }, node), container);
    });
};
/* harmony default export */ const dist_renderPromise = (renderPromise);

;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js
/* module decorator */ module = __webpack_require__.hmd(module);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "onClose"
];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var createRef = function createRef(v) {
    return {
        current: v
    };
};
/**
 * @example
 * // MyModal.tsx
 * const MyModal: React.FC<{ onClose?: () => void; }> = ({
 *   onClose,
 * }) => (
 *   <div>
 *     <button onClick={onClose}>close</button>
 *     MyModal
 *   </div>
 * );
 *
 * export const MyModalComponent = createModalComponent(MyModal);
 *
 * // App.tsx
 * import { MyModalComponent } from './MyModal';
 *
 * (async () => {
 *   const closeMyModal = await MyModalComponent.open();
 *   setTimeout(() => {
 *     closeMyModal();
 *   }, 3000);
 * })();
 */ function createModalComponent(Modal, cfg) {
    var singletonElRef = createRef(null);
    var ModalComponent = Modal;
    ModalComponent.open = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(props) {
            var elRef, _ref2, _onClose, restProps, rmModal, render, _module$hot;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        elRef = cfg !== null && cfg !== void 0 && cfg.singleton ? singletonElRef : createRef(null);
                        _ref2 = props !== null && props !== void 0 ? props : {}, _onClose = _ref2.onClose, restProps = _objectWithoutProperties(_ref2, _excluded);
                        if (!elRef.current) {
                            elRef.current = document.createElement("div");
                        }
                        document.body.appendChild(elRef.current);
                        rmModal = function rmModal() {
                            if (elRef.current && elRef.current.parentNode) {
                                (0,React_render/* unmount */.vE)(elRef.current);
                                elRef.current.parentNode.removeChild(elRef.current);
                                elRef.current = null;
                            }
                        };
                        render = /*#__PURE__*/ function() {
                            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(1)switch(_context.prev = _context.next){
                                        case 0:
                                            if (elRef.current) {
                                                _context.next = 2;
                                                break;
                                            }
                                            return _context.abrupt("return");
                                        case 2:
                                            _context.next = 4;
                                            return dist_renderPromise(/*#__PURE__*/ // @ts-ignore
                                            react.createElement(Modal, _extends({}, restProps, {
                                                onClose: function onClose() {
                                                    setTimeout(function() {
                                                        rmModal();
                                                    });
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                                        args[_key] = arguments[_key];
                                                    }
                                                    return _onClose === null || _onClose === void 0 ? void 0 : _onClose.apply(void 0, args);
                                                }
                                            })), elRef.current);
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function render() {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        render();
                        try {
                            (_module$hot = module.hot) === null || _module$hot === void 0 ? void 0 : _module$hot.addStatusHandler(function(status) {
                                if (status === "idle") {
                                    render();
                                }
                            });
                        } catch (_unused) {
                        /* eslint no-empty:off */ }
                        return _context2.abrupt("return", rmModal);
                    case 9:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    return ModalComponent;
}
/* harmony default export */ const dist_createModalComponent = (createModalComponent);


/***/ }),

/***/ 364:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3965:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77477:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30341:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 91611:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39618:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48674:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50072:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38867:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 76511:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68795:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57926:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 14222:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 70631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 28985:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Deferred = void 0;
class Deferred {
    constructor() {
        this.resolve = () => null;
        this.reject = () => null;
        this.promise = new Promise((resolve, reject) => {
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
exports.Deferred = Deferred;


/***/ }),

/***/ 37279:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EndOfStreamError = exports.defaultMessages = void 0;
exports.defaultMessages = 'End-Of-Stream';
/**
 * Thrown on read operation of the end of file or stream has been reached
 */
class EndOfStreamError extends Error {
    constructor() {
        super(exports.defaultMessages);
    }
}
exports.EndOfStreamError = EndOfStreamError;


/***/ }),

/***/ 56654:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamReader = exports.EndOfStreamError = void 0;
const EndOfFileStream_1 = __webpack_require__(37279);
const Deferred_1 = __webpack_require__(28985);
var EndOfFileStream_2 = __webpack_require__(37279);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return EndOfFileStream_2.EndOfStreamError; } }));
const maxStreamReadSize = 1 * 1024 * 1024; // Maximum request length on read-stream operation
class StreamReader {
    constructor(s) {
        this.s = s;
        /**
         * Deferred used for postponed read request (as not data is yet available to read)
         */
        this.deferred = null;
        this.endOfStream = false;
        /**
         * Store peeked data
         * @type {Array}
         */
        this.peekQueue = [];
        if (!s.read || !s.once) {
            throw new Error('Expected an instance of stream.Readable');
        }
        this.s.once('end', () => this.reject(new EndOfFileStream_1.EndOfStreamError()));
        this.s.once('error', err => this.reject(err));
        this.s.once('close', () => this.reject(new Error('Stream closed')));
    }
    /**
     * Read ahead (peek) from stream. Subsequent read or peeks will return the same data
     * @param uint8Array - Uint8Array (or Buffer) to store data read from stream in
     * @param offset - Offset target
     * @param length - Number of bytes to read
     * @returns Number of bytes peeked
     */
    async peek(uint8Array, offset, length) {
        const bytesRead = await this.read(uint8Array, offset, length);
        this.peekQueue.push(uint8Array.subarray(offset, offset + bytesRead)); // Put read data back to peek buffer
        return bytesRead;
    }
    /**
     * Read chunk from stream
     * @param buffer - Target Uint8Array (or Buffer) to store data read from stream in
     * @param offset - Offset target
     * @param length - Number of bytes to read
     * @returns Number of bytes read
     */
    async read(buffer, offset, length) {
        if (length === 0) {
            return 0;
        }
        if (this.peekQueue.length === 0 && this.endOfStream) {
            throw new EndOfFileStream_1.EndOfStreamError();
        }
        let remaining = length;
        let bytesRead = 0;
        // consume peeked data first
        while (this.peekQueue.length > 0 && remaining > 0) {
            const peekData = this.peekQueue.pop(); // Front of queue
            if (!peekData)
                throw new Error('peekData should be defined');
            const lenCopy = Math.min(peekData.length, remaining);
            buffer.set(peekData.subarray(0, lenCopy), offset + bytesRead);
            bytesRead += lenCopy;
            remaining -= lenCopy;
            if (lenCopy < peekData.length) {
                // remainder back to queue
                this.peekQueue.push(peekData.subarray(lenCopy));
            }
        }
        // continue reading from stream if required
        while (remaining > 0 && !this.endOfStream) {
            const reqLen = Math.min(remaining, maxStreamReadSize);
            const chunkLen = await this.readFromStream(buffer, offset + bytesRead, reqLen);
            bytesRead += chunkLen;
            if (chunkLen < reqLen)
                break;
            remaining -= chunkLen;
        }
        return bytesRead;
    }
    /**
     * Read chunk from stream
     * @param buffer Target Uint8Array (or Buffer) to store data read from stream in
     * @param offset Offset target
     * @param length Number of bytes to read
     * @returns Number of bytes read
     */
    async readFromStream(buffer, offset, length) {
        const readBuffer = this.s.read(length);
        if (readBuffer) {
            buffer.set(readBuffer, offset);
            return readBuffer.length;
        }
        else {
            const request = {
                buffer,
                offset,
                length,
                deferred: new Deferred_1.Deferred()
            };
            this.deferred = request.deferred;
            this.s.once('readable', () => {
                this.readDeferred(request);
            });
            return request.deferred.promise;
        }
    }
    /**
     * Process deferred read request
     * @param request Deferred read request
     */
    readDeferred(request) {
        const readBuffer = this.s.read(request.length);
        if (readBuffer) {
            request.buffer.set(readBuffer, request.offset);
            request.deferred.resolve(readBuffer.length);
            this.deferred = null;
        }
        else {
            this.s.once('readable', () => {
                this.readDeferred(request);
            });
        }
    }
    reject(err) {
        this.endOfStream = true;
        if (this.deferred) {
            this.deferred.reject(err);
            this.deferred = null;
        }
    }
}
exports.StreamReader = StreamReader;


/***/ }),

/***/ 55167:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamReader = exports.EndOfStreamError = void 0;
var EndOfFileStream_1 = __webpack_require__(37279);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return EndOfFileStream_1.EndOfStreamError; } }));
var StreamReader_1 = __webpack_require__(56654);
Object.defineProperty(exports, "StreamReader", ({ enumerable: true, get: function () { return StreamReader_1.StreamReader; } }));


/***/ }),

/***/ 75:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 87236:
/***/ ((module) => {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),

/***/ 34155:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this || __webpack_require__.g, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 42723:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}("undefined"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=58)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.6.9"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(31)("wks"),o=n(22),i=n(0).Symbol,a="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))}).store=r},function(t,e,n){var r=n(8);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){t.exports=!n(10)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(0),o=n(1),i=n(19),a=n(6),s=n(9),u=function(t,e,n){var c,f,l,h=t&u.F,p=t&u.G,d=t&u.S,g=t&u.P,m=t&u.B,v=t&u.W,y=p?o:o[e]||(o[e]={}),b=y.prototype,w=p?r:d?r[e]:(r[e]||{}).prototype;for(c in p&&(n=e),n)(f=!h&&w&&void 0!==w[c])&&s(y,c)||(l=f?w[c]:n[c],y[c]=p&&"function"!=typeof w[c]?n[c]:m&&f?i(l,r):v&&w[c]==l?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):g&&"function"==typeof l?i(Function.call,l):l,g&&((y.virtual||(y.virtual={}))[c]=l,t&u.R&&b&&!b[c]&&a(b,c,l)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,t.exports=u},function(t,e,n){var r=n(7),o=n(21);t.exports=n(4)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(3),o=n(43),i=n(29),a=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(47),o=n(27);t.exports=function(t){return r(o(t))}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){var e=t+864e5;return(new Date).getTime()>e}function i(t){return(0,m.default)(t).filter(function(t){return t.startsWith("x:")}).map(function(e){return[e,t[e].toString()]})}function a(t){return"qiniu_js_sdk_upload_file_"+t.name+"_size_"+t.size}function s(t){try{return JSON.parse(localStorage.getItem(a(t)))||[]}catch(t){return window.console&&window.console.warn&&console.warn("getLocalFileInfo failed"),[]}}function u(t){return{Authorization:"UpToken "+t}}function c(){return window.XMLHttpRequest?new XMLHttpRequest:new window.ActiveXObject("Microsoft.XMLHTTP")}function f(t){return new p.default(function(e,n){var r=new FileReader;r.readAsArrayBuffer(t),r.onload=function(t){var n=t.target.result;e(n)},r.onerror=function(){n(new Error("fileReader 读取错误"))}})}function l(t,e){return new p.default(function(n,r){var o=c();o.open(e.method,t),e.onCreate&&e.onCreate(o),e.headers&&(0,m.default)(e.headers).forEach(function(t){return o.setRequestHeader(t,e.headers[t])}),o.upload.addEventListener("progress",function(t){t.lengthComputable&&e.onProgress&&e.onProgress({loaded:t.loaded,total:t.total})}),o.onreadystatechange=function(){var t=o.responseText;if(4===o.readyState){var e=o.getResponseHeader("x-reqId")||"";if(200!==o.status){var i="xhr request failed, code: "+o.status+";";return t&&(i=i+" response: "+t),void r({code:o.status,message:i,reqId:e,isRequestError:!0})}try{n({data:JSON.parse(t),reqId:e})}catch(t){r(t)}}},o.send(e.body)})}function h(){return"http:"===window.location.protocol?"http:":"https:"}e.__esModule=!0;var p=r(n(18)),d=r(n(34)),g=r(n(86)),m=r(n(36));e.isChunkExpired=o,e.getChunks=function(t,e){for(var n=[],r=Math.ceil(t.size/e),o=0;o<r;o++){var i=t.slice(e*o,o===r-1?t.size:e*(o+1));n.push(i)}return n},e.filterParams=i,e.sum=function(t){return t.reduce(function(t,e){return t+e},0)},e.setLocalFileInfo=function(t,e){try{localStorage.setItem(a(t),(0,g.default)(e))}catch(t){window.console&&window.console.warn&&console.warn("setLocalFileInfo failed")}},e.removeLocalFileInfo=function(t){try{localStorage.removeItem(a(t))}catch(t){window.console&&window.console.warn&&console.warn("removeLocalFileInfo failed")}},e.getLocalFileInfo=s,e.getResumeUploadedSize=function(t){return s(t).filter(function(t){return t&&!o(t.time)}).reduce(function(t,e){return t+e.size},0)},e.createMkFileUrl=function(t,e,n,r){var o=t+"/mkfile/"+e.size;null!=n&&(o+="/key/"+(0,v.urlSafeBase64Encode)(n)),r.mimeType&&(o+="/mimeType/"+(0,v.urlSafeBase64Encode)(e.type));var a=r.fname;return a&&(o+="/fname/"+(0,v.urlSafeBase64Encode)(a)),r.params&&i(r.params).forEach(function(t){return o+="/"+encodeURIComponent(t[0])+"/"+(0,v.urlSafeBase64Encode)(t[1])}),o},e.getHeadersForChunkUpload=function(t){var e=u(t);return(0,d.default)({"content-type":"application/octet-stream"},e)},e.getHeadersForMkFile=function(t){var e=u(t);return(0,d.default)({"content-type":"text/plain"},e)},e.createXHR=c,e.computeMd5=function(t){return f(t).then(function(t){var e=new b.default.ArrayBuffer;return e.append(t),e.end()})},e.readAsArrayBuffer=f,e.request=l,e.getPortFromUrl=function(t){if(t&&t.match){var e=t.match(/(^https?)/);if(!e)return"";var n=e[1];return(e=t.match(/^https?:\/\/([^:^\/]*):(\d*)/))?e[2]:"http"===n?"80":"443"}return""},e.getDomainFromUrl=function(t){if(t&&t.match){var e=t.match(/^https?:\/\/([^:^\/]*)/);return e?e[1]:""}return""},e.getUploadUrl=function(t,e){var n=h();if(null!=t.uphost)return p.default.resolve(n+"//"+t.uphost);if(null!=t.region){var r=y.regionUphostMap[t.region],o=t.useCdnDomain?r.cdnUphost:r.srcUphost;return p.default.resolve(n+"//"+o)}return function(t){try{var e=function(t){var e=t.split(":"),n=e[0],r=JSON.parse((0,v.urlSafeBase64Decode)(e[2]));return r.ak=n,r.bucket=r.scope.split(":")[0],r}(t);return l(h()+"//api.qiniu.com/v2/query?ak="+e.ak+"&bucket="+e.bucket,{method:"GET"})}catch(t){return p.default.reject(t)}}(e).then(function(t){var e=t.data.up.acc.main;return n+"//"+e[0]})},e.isContainFileMimeType=function(t,e){return e.indexOf(t)>-1},e.createObjectURL=function(t){return(window.URL||window.webkitURL||window.mozURL).createObjectURL(t)},e.getTransform=function(t,e){var n=t.width,r=t.height;switch(e){case 1:return{width:n,height:r,matrix:[1,0,0,1,0,0]};case 2:return{width:n,height:r,matrix:[-1,0,0,1,n,0]};case 3:return{width:n,height:r,matrix:[-1,0,0,-1,n,r]};case 4:return{width:n,height:r,matrix:[1,0,0,-1,0,r]};case 5:return{width:r,height:n,matrix:[0,1,1,0,0,0]};case 6:return{width:r,height:n,matrix:[0,1,-1,0,r,0]};case 7:return{width:r,height:n,matrix:[0,-1,-1,0,r,n]};case 8:return{width:r,height:n,matrix:[0,-1,1,0,0,n]}}};var v=n(56),y=n(39),b=r(n(91))},function(t,e){t.exports=!0},function(t,e){t.exports={}},function(t,e,n){var r=n(46),o=n(32);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){t.exports={default:n(59),__esModule:!0}},function(t,e,n){var r=n(20);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(7).f,o=n(9),i=n(2)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(27);t.exports=function(t){return Object(r(t))}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(8),o=n(0).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(8);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(31)("keys"),o=n(22);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(1),o=n(0),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(13)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){"use strict";var r=n(20);t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}(t)}},function(t,e,n){t.exports={default:n(83),__esModule:!0}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){t.exports={default:n(88),__esModule:!0}},function(t,e,n){e.f=n(2)},function(t,e,n){var r=n(0),o=n(1),i=n(13),a=n(37),s=n(7).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:a.f(t)})}},function(t,e,n){"use strict";e.__esModule=!0,e.regionUphostMap={z0:{srcUphost:"up.qiniup.com",cdnUphost:"upload.qiniup.com"},z1:{srcUphost:"up-z1.qiniup.com",cdnUphost:"upload-z1.qiniup.com"},z2:{srcUphost:"up-z2.qiniup.com",cdnUphost:"upload-z2.qiniup.com"},na0:{srcUphost:"up-na0.qiniup.com",cdnUphost:"upload-na0.qiniup.com"},as0:{srcUphost:"up-as0.qiniup.com",cdnUphost:"upload-as0.qiniup.com"}},e.region={z0:"z0",z1:"z1",z2:"z2",na0:"na0",as0:"as0"}},function(t,e){},function(t,e,n){"use strict";var r=n(60)(!0);n(42)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(13),o=n(5),i=n(44),a=n(6),s=n(14),u=n(61),c=n(23),f=n(65),l=n(2)("iterator"),h=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,d,g,m,v){u(n,e,d);var y,b,w,x=function(t){if(!h&&t in C)return C[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",P="values"==g,_=!1,C=t.prototype,U=C[l]||C["@@iterator"]||g&&C[g],F=U||x(g),I=g?P?x("entries"):F:void 0,k="Array"==e&&C.entries||U;if(k&&(w=f(k.call(new t)))!==Object.prototype&&w.next&&(c(w,S,!0),r||"function"==typeof w[l]||a(w,l,p)),P&&U&&"values"!==U.name&&(_=!0,F=function(){return U.call(this)}),r&&!v||!h&&!_&&C[l]||a(C,l,F),s[e]=F,s[S]=p,g)if(y={values:P?F:x("values"),keys:m?F:x("keys"),entries:I},v)for(b in y)b in C||i(C,b,y[b]);else o(o.P+o.F*(h||_),e,y);return y}},function(t,e,n){t.exports=!n(4)&&!n(10)(function(){return 7!=Object.defineProperty(n(28)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){t.exports=n(6)},function(t,e,n){var r=n(3),o=n(62),i=n(32),a=n(30)("IE_PROTO"),s=function(){},u=function(){var t,e=n(28)("iframe"),r=i.length;for(e.style.display="none",n(49).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),u=t.F;r--;)delete u.prototype[i[r]];return u()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=r(t),n=new s,s.prototype=null,n[a]=t):n=u(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(9),o=n(11),i=n(63)(!1),a=n(30)("IE_PROTO");t.exports=function(t,e){var n,s=o(t),u=0,c=[];for(n in s)n!=a&&r(s,n)&&c.push(n);for(;e.length>u;)r(s,n=e[u++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){var r=n(16);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(26),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(0).document;t.exports=r&&r.documentElement},function(t,e,n){n(66);for(var r=n(0),o=n(6),i=n(14),a=n(2)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var c=s[u],f=r[c],l=f&&f.prototype;l&&!l[a]&&o(l,a,c),i[c]=i.Array}},function(t,e,n){var r=n(16),o=n(2)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):"Object"==(a=r(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,n){var r=n(3),o=n(20),i=n(2)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||void 0==(n=r(a)[i])?e:o(n)}},function(t,e,n){var r,o,i,a=n(19),s=n(75),u=n(49),c=n(28),f=n(0),l=f.process,h=f.setImmediate,p=f.clearImmediate,d=f.MessageChannel,g=f.Dispatch,m=0,v={},y=function(){var t=+this;if(v.hasOwnProperty(t)){var e=v[t];delete v[t],e()}},b=function(t){y.call(t.data)};h&&p||(h=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return v[++m]=function(){s("function"==typeof t?t:Function(t),e)},r(m),m},p=function(t){delete v[t]},"process"==n(16)(l)?r=function(t){l.nextTick(a(y,t,1))}:g&&g.now?r=function(t){g.now(a(y,t,1))}:d?(i=(o=new d).port2,o.port1.onmessage=b,r=a(i.postMessage,i,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",b,!1)):r="onreadystatechange"in c("script")?function(t){u.appendChild(c("script")).onreadystatechange=function(){u.removeChild(this),y.call(t)}}:function(t){setTimeout(a(y,t,1),0)}),t.exports={set:h,clear:p}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(3),o=n(8),i=n(33);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){"use strict";e.__esModule=!0,e.urlSafeBase64Encode=function(t){return(t=function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h="",p=[];if(!t)return t;t=function(t){if(null===t||void 0===t)return"";var e=t+"",n="",r=void 0,o=void 0,i=0;r=o=0,i=e.length;for(var a=0;a<i;a++){var s=e.charCodeAt(a),u=null;if(s<128)o++;else if(s>127&&s<2048)u=String.fromCharCode(s>>6|192,63&s|128);else if(63488&s^!0)u=String.fromCharCode(s>>12|224,s>>6&63|128,63&s|128);else{if(64512&s^!0)throw new RangeError("Unmatched trail surrogate at "+a);var c=e.charCodeAt(++a);if(64512&c^!0)throw new RangeError("Unmatched lead surrogate at "+(a-1));s=((1023&s)<<10)+(1023&c)+65536,u=String.fromCharCode(s>>18|240,s>>12&63|128,s>>6&63|128,63&s|128)}null!==u&&(o>r&&(n+=e.slice(r,o)),n+=u,r=o=a+1)}return o>r&&(n+=e.slice(r,i)),n}(t+"");do{n=t.charCodeAt(f++),r=t.charCodeAt(f++),o=t.charCodeAt(f++),i=(c=n<<16|r<<8|o)>>18&63,a=c>>12&63,s=c>>6&63,u=63&c,p[l++]=e.charAt(i)+e.charAt(a)+e.charAt(s)+e.charAt(u)}while(f<t.length);switch(h=p.join(""),t.length%3){case 1:h=h.slice(0,-2)+"==";break;case 2:h=h.slice(0,-1)+"="}return h}(t)).replace(/\//g,"_").replace(/\+/g,"-")},e.urlSafeBase64Decode=function(t){return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h=[];if(!t)return t;t+="";do{i=e.indexOf(t.charAt(f++)),a=e.indexOf(t.charAt(f++)),s=e.indexOf(t.charAt(f++)),u=e.indexOf(t.charAt(f++)),n=(c=i<<18|a<<12|s<<6|u)>>16&255,r=c>>8&255,o=255&c,h[l++]=64===s?String.fromCharCode(n):64===u?String.fromCharCode(n,r):String.fromCharCode(n,r,o)}while(f<t.length);return h.join("")}(t=t.replace(/_/g,"/").replace(/-/g,"+"))}},function(t,e,n){var r=n(46),o=n(32).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){"use strict";e.__esModule=!0,e.pipeline=e.compressImage=e.exif=e.imageInfo=e.watermark=e.imageMogr2=e.getUploadUrl=e.filterParams=e.getHeadersForMkFile=e.getResumeUploadedSize=e.getHeadersForChunkUpload=e.createMkFileUrl=e.region=e.upload=void 0;var r=n(39),o=n(12),i=n(92),a=n(94),s=n(95),u=n(109),c=function(t){return t&&t.__esModule?t:{default:t}}(n(110)),f=new u.StatisticsLogger;e.upload=function(t,e,n,r,o){var a={file:t,key:e,token:n,putExtra:r,config:o};return new s.Observable(function(t){var e=new i.UploadManager(a,{onData:function(e){return t.next(e)},onError:function(e){return t.error(e)},onComplete:function(e){return t.complete(e)}},f);return e.putFile(),e.stop.bind(e)})},e.region=r.region,e.createMkFileUrl=o.createMkFileUrl,e.getHeadersForChunkUpload=o.getHeadersForChunkUpload,e.getResumeUploadedSize=o.getResumeUploadedSize,e.getHeadersForMkFile=o.getHeadersForMkFile,e.filterParams=o.filterParams,e.getUploadUrl=o.getUploadUrl,e.imageMogr2=a.imageMogr2,e.watermark=a.watermark,e.imageInfo=a.imageInfo,e.exif=a.exif,e.compressImage=c.default,e.pipeline=a.pipeline},function(t,e,n){n(40),n(41),n(50),n(69),n(81),n(82),t.exports=n(1).Promise},function(t,e,n){var r=n(26),o=n(27);t.exports=function(t){return function(e,n){var i,a,s=String(o(e)),u=r(n),c=s.length;return u<0||u>=c?t?"":void 0:(i=s.charCodeAt(u))<55296||i>56319||u+1===c||(a=s.charCodeAt(u+1))<56320||a>57343?t?s.charAt(u):i:t?s.slice(u,u+2):a-56320+(i-55296<<10)+65536}}},function(t,e,n){"use strict";var r=n(45),o=n(21),i=n(23),a={};n(6)(a,n(2)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(7),o=n(3),i=n(15);t.exports=n(4)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),s=a.length,u=0;s>u;)r.f(t,n=a[u++],e[n]);return t}},function(t,e,n){var r=n(11),o=n(48),i=n(64);t.exports=function(t){return function(e,n,a){var s,u=r(e),c=o(u.length),f=i(a,c);if(t&&n!=n){for(;c>f;)if((s=u[f++])!=s)return!0}else for(;c>f;f++)if((t||f in u)&&u[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(26),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(9),o=n(24),i=n(30)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){"use strict";var r=n(67),o=n(68),i=n(14),a=n(11);t.exports=n(42)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var r,o,i,a,s=n(13),u=n(0),c=n(19),f=n(51),l=n(5),h=n(8),p=n(20),d=n(70),g=n(71),m=n(52),v=n(53).set,y=n(76)(),b=n(33),w=n(54),x=n(77),S=n(55),P=u.TypeError,_=u.process,C=_&&_.versions,U=C&&C.v8||"",F=u.Promise,I="process"==f(_),k=function(){},E=o=b.f,M=!!function(){try{var t=F.resolve(1),e=(t.constructor={})[n(2)("species")]=function(t){t(k,k)};return(I||"function"==typeof PromiseRejectionEvent)&&t.then(k)instanceof e&&0!==U.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),O=function(t){var e;return!(!h(t)||"function"!=typeof(e=t.then))&&e},T=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,o=1==t._s,i=0;n.length>i;)!function(e){var n,i,a,s=o?e.ok:e.fail,u=e.resolve,c=e.reject,f=e.domain;try{s?(o||(2==t._h&&L(t),t._h=1),!0===s?n=r:(f&&f.enter(),n=s(r),f&&(f.exit(),a=!0)),n===e.promise?c(P("Promise-chain cycle")):(i=O(n))?i.call(n,u,c):u(n)):c(r)}catch(t){f&&!a&&f.exit(),c(t)}}(n[i++]);t._c=[],t._n=!1,e&&!t._h&&R(t)})}},R=function(t){v.call(u,function(){var e,n,r,o=t._v,i=A(t);if(i&&(e=w(function(){I?_.emit("unhandledRejection",o,t):(n=u.onunhandledrejection)?n({promise:t,reason:o}):(r=u.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=I||A(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},A=function(t){return 1!==t._h&&0===(t._a||t._c).length},L=function(t){v.call(u,function(){var e;I?_.emit("rejectionHandled",t):(e=u.onrejectionhandled)&&e({promise:t,reason:t._v})})},D=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),T(e,!0))},j=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw P("Promise can't be resolved itself");(e=O(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,c(j,r,1),c(D,r,1))}catch(t){D.call(r,t)}}):(n._v=t,n._s=1,T(n,!1))}catch(t){D.call({_w:n,_d:!1},t)}}};M||(F=function(t){d(this,F,"Promise","_h"),p(t),r.call(this);try{t(c(j,this,1),c(D,this,1))}catch(t){D.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(78)(F.prototype,{then:function(t,e){var n=E(m(this,F));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=I?_.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&T(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=c(j,t,1),this.reject=c(D,t,1)},b.f=E=function(t){return t===F||t===a?new i(t):o(t)}),l(l.G+l.W+l.F*!M,{Promise:F}),n(23)(F,"Promise"),n(79)("Promise"),a=n(1).Promise,l(l.S+l.F*!M,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),l(l.S+l.F*(s||!M),"Promise",{resolve:function(t){return S(s&&this===a?F:this,t)}}),l(l.S+l.F*!(M&&n(80)(function(t){F.all(t).catch(k)})),"Promise",{all:function(t){var e=this,n=E(e),r=n.resolve,o=n.reject,i=w(function(){var n=[],i=0,a=1;g(t,!1,function(t){var s=i++,u=!1;n.push(void 0),a++,e.resolve(t).then(function(t){u||(u=!0,n[s]=t,--a||r(n))},o)}),--a||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=E(e),r=n.reject,o=w(function(){g(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(19),o=n(72),i=n(73),a=n(3),s=n(48),u=n(74),c={},f={};(e=t.exports=function(t,e,n,l,h){var p,d,g,m,v=h?function(){return t}:u(t),y=r(n,l,e?2:1),b=0;if("function"!=typeof v)throw TypeError(t+" is not iterable!");if(i(v)){for(p=s(t.length);p>b;b++)if((m=e?y(a(d=t[b])[0],d[1]):y(t[b]))===c||m===f)return m}else for(g=v.call(t);!(d=g.next()).done;)if((m=o(g,y,d.value,e))===c||m===f)return m}).BREAK=c,e.RETURN=f},function(t,e,n){var r=n(3);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(14),o=n(2)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(51),o=n(2)("iterator"),i=n(14);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(0),o=n(53).set,i=r.MutationObserver||r.WebKitMutationObserver,a=r.process,s=r.Promise,u="process"==n(16)(a);t.exports=function(){var t,e,n,c=function(){var r,o;for(u&&(r=a.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(u)n=function(){a.nextTick(c)};else if(!i||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var f=s.resolve(void 0);n=function(){f.then(c)}}else n=function(){o.call(r,c)};else{var l=!0,h=document.createTextNode("");new i(c).observe(h,{characterData:!0}),n=function(){h.data=l=!l}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(0).navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var r=n(6);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){"use strict";var r=n(0),o=n(1),i=n(7),a=n(4),s=n(2)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];a&&e&&!e[s]&&i.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(2)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},t(i)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(5),o=n(1),i=n(0),a=n(52),s=n(55);r(r.P+r.R,"Promise",{finally:function(t){var e=a(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var r=n(5),o=n(33),i=n(54);r(r.S,"Promise",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){n(84),t.exports=n(1).Object.assign},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(85)})},function(t,e,n){"use strict";var r=n(4),o=n(15),i=n(35),a=n(25),s=n(24),u=n(47),c=Object.assign;t.exports=!c||n(10)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=c({},t)[n]||Object.keys(c({},e)).join("")!=r})?function(t,e){for(var n=s(t),c=arguments.length,f=1,l=i.f,h=a.f;c>f;)for(var p,d=u(arguments[f++]),g=l?o(d).concat(l(d)):o(d),m=g.length,v=0;m>v;)p=g[v++],r&&!h.call(d,p)||(n[p]=d[p]);return n}:c},function(t,e,n){t.exports={default:n(87),__esModule:!0}},function(t,e,n){var r=n(1),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,n){n(89),t.exports=n(1).Object.keys},function(t,e,n){var r=n(24),o=n(15);n(90)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){var r=n(5),o=n(1),i=n(10);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],a={};a[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(t,e,n){!function(e){t.exports=function(t){"use strict";function e(t,e){var n=t[0],r=t[1],o=t[2],i=t[3];r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[0]-680876936|0)<<7|n>>>25)+r|0)&r|~n&o)+e[1]-389564586|0)<<12|i>>>20)+n|0)&n|~i&r)+e[2]+606105819|0)<<17|o>>>15)+i|0)&i|~o&n)+e[3]-1044525330|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[4]-176418897|0)<<7|n>>>25)+r|0)&r|~n&o)+e[5]+1200080426|0)<<12|i>>>20)+n|0)&n|~i&r)+e[6]-1473231341|0)<<17|o>>>15)+i|0)&i|~o&n)+e[7]-45705983|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[8]+1770035416|0)<<7|n>>>25)+r|0)&r|~n&o)+e[9]-1958414417|0)<<12|i>>>20)+n|0)&n|~i&r)+e[10]-42063|0)<<17|o>>>15)+i|0)&i|~o&n)+e[11]-1990404162|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[12]+1804603682|0)<<7|n>>>25)+r|0)&r|~n&o)+e[13]-40341101|0)<<12|i>>>20)+n|0)&n|~i&r)+e[14]-1502002290|0)<<17|o>>>15)+i|0)&i|~o&n)+e[15]+1236535329|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[1]-165796510|0)<<5|n>>>27)+r|0)&o|r&~o)+e[6]-1069501632|0)<<9|i>>>23)+n|0)&r|n&~r)+e[11]+643717713|0)<<14|o>>>18)+i|0)&n|i&~n)+e[0]-373897302|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[5]-701558691|0)<<5|n>>>27)+r|0)&o|r&~o)+e[10]+38016083|0)<<9|i>>>23)+n|0)&r|n&~r)+e[15]-660478335|0)<<14|o>>>18)+i|0)&n|i&~n)+e[4]-405537848|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[9]+568446438|0)<<5|n>>>27)+r|0)&o|r&~o)+e[14]-1019803690|0)<<9|i>>>23)+n|0)&r|n&~r)+e[3]-187363961|0)<<14|o>>>18)+i|0)&n|i&~n)+e[8]+1163531501|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[13]-1444681467|0)<<5|n>>>27)+r|0)&o|r&~o)+e[2]-51403784|0)<<9|i>>>23)+n|0)&r|n&~r)+e[7]+1735328473|0)<<14|o>>>18)+i|0)&n|i&~n)+e[12]-1926607734|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[5]-378558|0)<<4|n>>>28)+r|0)^r^o)+e[8]-2022574463|0)<<11|i>>>21)+n|0)^n^r)+e[11]+1839030562|0)<<16|o>>>16)+i|0)^i^n)+e[14]-35309556|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[1]-1530992060|0)<<4|n>>>28)+r|0)^r^o)+e[4]+1272893353|0)<<11|i>>>21)+n|0)^n^r)+e[7]-155497632|0)<<16|o>>>16)+i|0)^i^n)+e[10]-1094730640|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[13]+681279174|0)<<4|n>>>28)+r|0)^r^o)+e[0]-358537222|0)<<11|i>>>21)+n|0)^n^r)+e[3]-722521979|0)<<16|o>>>16)+i|0)^i^n)+e[6]+76029189|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[9]-640364487|0)<<4|n>>>28)+r|0)^r^o)+e[12]-421815835|0)<<11|i>>>21)+n|0)^n^r)+e[15]+530742520|0)<<16|o>>>16)+i|0)^i^n)+e[2]-995338651|0)<<23|r>>>9)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[0]-198630844|0)<<6|n>>>26)+r|0)|~o))+e[7]+1126891415|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[14]-1416354905|0)<<15|o>>>17)+i|0)|~n))+e[5]-57434055|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[12]+1700485571|0)<<6|n>>>26)+r|0)|~o))+e[3]-1894986606|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[10]-1051523|0)<<15|o>>>17)+i|0)|~n))+e[1]-2054922799|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[8]+1873313359|0)<<6|n>>>26)+r|0)|~o))+e[15]-30611744|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[6]-1560198380|0)<<15|o>>>17)+i|0)|~n))+e[13]+1309151649|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[4]-145523070|0)<<6|n>>>26)+r|0)|~o))+e[11]-1120210379|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[2]+718787259|0)<<15|o>>>17)+i|0)|~n))+e[9]-343485551|0)<<21|r>>>11)+o|0,t[0]=n+t[0]|0,t[1]=r+t[1]|0,t[2]=o+t[2]|0,t[3]=i+t[3]|0}function n(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return n}function r(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t[e]+(t[e+1]<<8)+(t[e+2]<<16)+(t[e+3]<<24);return n}function o(t){var r,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(r=64;r<=c;r+=64)e(f,n(t.substring(r-64,r)));for(o=(t=t.substring(r-64)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],r=0;r<o;r+=1)i[r>>2]|=t.charCodeAt(r)<<(r%4<<3);if(i[r>>2]|=128<<(r%4<<3),r>55)for(e(f,i),r=0;r<16;r+=1)i[r]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}function i(t){var e,n="";for(e=0;e<4;e+=1)n+=f[t>>8*e+4&15]+f[t>>8*e&15];return n}function a(t){var e;for(e=0;e<t.length;e+=1)t[e]=i(t[e]);return t.join("")}function s(t){return/[\u0080-\uFFFF]/.test(t)&&(t=unescape(encodeURIComponent(t))),t}function u(t){var e,n=[],r=t.length;for(e=0;e<r-1;e+=2)n.push(parseInt(t.substr(e,2),16));return String.fromCharCode.apply(String,n)}function c(){this.reset()}var f=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"];return a(o("hello")),"undefined"==typeof ArrayBuffer||ArrayBuffer.prototype.slice||function(){function e(t,e){return(t=0|t||0)<0?Math.max(t+e,0):Math.min(t,e)}ArrayBuffer.prototype.slice=function(n,r){var o,i,a,s,u=this.byteLength,c=e(n,u),f=u;return r!==t&&(f=e(r,u)),c>f?new ArrayBuffer(0):(o=f-c,i=new ArrayBuffer(o),a=new Uint8Array(i),s=new Uint8Array(this,c,o),a.set(s),i)}}(),c.prototype.append=function(t){return this.appendBinary(s(t)),this},c.prototype.appendBinary=function(t){this._buff+=t,this._length+=t.length;var r,o=this._buff.length;for(r=64;r<=o;r+=64)e(this._hash,n(this._buff.substring(r-64,r)));return this._buff=this._buff.substring(r-64),this},c.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r.charCodeAt(e)<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.prototype.reset=function(){return this._buff="",this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.prototype.getState=function(){return{buff:this._buff,length:this._length,hash:this._hash}},c.prototype.setState=function(t){return this._buff=t.buff,this._length=t.length,this._hash=t.hash,this},c.prototype.destroy=function(){delete this._hash,delete this._buff,delete this._length},c.prototype._finish=function(t,n){var r,o,i,a=n;if(t[a>>2]|=128<<(a%4<<3),a>55)for(e(this._hash,t),a=0;a<16;a+=1)t[a]=0;r=(r=8*this._length).toString(16).match(/(.*?)(.{0,8})$/),o=parseInt(r[2],16),i=parseInt(r[1],16)||0,t[14]=o,t[15]=i,e(this._hash,t)},c.hash=function(t,e){return c.hashBinary(s(t),e)},c.hashBinary=function(t,e){var n=a(o(t));return e?u(n):n},c.ArrayBuffer=function(){this.reset()},c.ArrayBuffer.prototype.append=function(t){var n,o=function(t,e,n){var r=new Uint8Array(t.byteLength+e.byteLength);return r.set(new Uint8Array(t)),r.set(new Uint8Array(e),t.byteLength),r}(this._buff.buffer,t),i=o.length;for(this._length+=t.byteLength,n=64;n<=i;n+=64)e(this._hash,r(o.subarray(n-64,n)));return this._buff=n-64<i?new Uint8Array(o.buffer.slice(n-64)):new Uint8Array(0),this},c.ArrayBuffer.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r[e]<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.ArrayBuffer.prototype.reset=function(){return this._buff=new Uint8Array(0),this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.ArrayBuffer.prototype.getState=function(){var t=c.prototype.getState.call(this);return t.buff=function(t){return String.fromCharCode.apply(null,new Uint8Array(t))}(t.buff),t},c.ArrayBuffer.prototype.setState=function(t){return t.buff=function(t,e){var n,r=t.length,o=new ArrayBuffer(r),i=new Uint8Array(o);for(n=0;n<r;n+=1)i[n]=t.charCodeAt(n);return i}(t.buff),c.prototype.setState.call(this,t)},c.ArrayBuffer.prototype.destroy=c.prototype.destroy,c.ArrayBuffer.prototype._finish=c.prototype._finish,c.ArrayBuffer.hash=function(t,n){var o=a(function(t){var n,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(n=64;n<=c;n+=64)e(f,r(t.subarray(n-64,n)));for(o=(t=n-64<c?t.subarray(n-64):new Uint8Array(0)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],n=0;n<o;n+=1)i[n>>2]|=t[n]<<(n%4<<3);if(i[n>>2]|=128<<(n%4<<3),n>55)for(e(f,i),n=0;n<16;n+=1)i[n]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}(new Uint8Array(t)));return n?u(o):o},c}()}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.UploadManager=void 0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=n(12),u=n(93);e.UploadManager=function(){function t(e,n,r){var o=this;(0,a.default)(this,t),this.config=(0,i.default)({useCdnDomain:!0,disableStatisticsReport:!1,retryCount:3,checkByMD5:!1,uphost:null,forceDirect:!1,concurrentRequestLimit:3,region:null},e.config),this.putExtra=(0,i.default)({fname:"",params:{},mimeType:null},e.putExtra),this.statisticsLogger=r,this.progress=null,this.xhrList=[],this.xhrHandler=function(t){return o.xhrList.push(t)},this.aborted=!1,this.file=e.file,this.key=e.key,this.token=e.token,this.onData=function(){},this.onError=function(){},this.onComplete=function(){},this.retryCount=0,(0,i.default)(this,n)}return t.prototype.putFile=function(){var t=this;if(this.aborted=!1,this.putExtra.fname||(this.putExtra.fname=this.file.name),!this.putExtra.mimeType||!this.putExtra.mimeType.length||(0,s.isContainFileMimeType)(this.file.type,this.putExtra.mimeType)){var e=(0,s.getUploadUrl)(this.config,this.token).then(function(e){return t.uploadUrl=e,t.uploadAt=(new Date).getTime(),t.config.forceDirect?t.directUpload():t.file.size>4194304?t.resumeUpload():t.directUpload()});return e.then(function(e){t.onComplete(e.data),t.config.disableStatisticsReport||t.sendLog(e.reqId,200)},function(e){if(t.clear(),e.isRequestError&&!t.config.disableStatisticsReport){var n=t.aborted?"":e.reqId,r=t.aborted?-2:e.code;t.sendLog(n,r)}var o=e.isRequestError&&0===e.code&&!t.aborted,i=++t.retryCount<=t.config.retryCount;o&&i?t.putFile():t.onError(e)}),e}var n=new Error("file type doesn't match with what you specify");this.onError(n)},t.prototype.clear=function(){this.xhrList.forEach(function(t){return t.abort()}),this.xhrList=[]},t.prototype.stop=function(){this.clear(),this.aborted=!0},t.prototype.sendLog=function(t,e){this.statisticsLogger.log({code:e,reqId:t,host:(0,s.getDomainFromUrl)(this.uploadUrl),remoteIp:"",port:(0,s.getPortFromUrl)(this.uploadUrl),duration:((new Date).getTime()-this.uploadAt)/1e3,time:Math.floor(this.uploadAt/1e3),bytesSent:this.progress?this.progress.total.loaded:0,upType:"jssdk-h5",size:this.file.size},this.token)},t.prototype.directUpload=function(){var t=this,e=new FormData;return e.append("file",this.file),e.append("token",this.token),null!=this.key&&e.append("key",this.key),e.append("fname",this.putExtra.fname),(0,s.filterParams)(this.putExtra.params).forEach(function(t){return e.append(t[0],t[1])}),(0,s.request)(this.uploadUrl,{method:"POST",body:e,onProgress:function(e){t.updateDirectProgress(e.loaded,e.total)},onCreate:this.xhrHandler}).then(function(e){return t.finishDirectProgress(),e})},t.prototype.resumeUpload=function(){var t=this;this.loaded={mkFileProgress:0,chunks:null},this.ctxList=[],this.localInfo=(0,s.getLocalFileInfo)(this.file),this.chunks=(0,s.getChunks)(this.file,4194304),this.initChunksProgress();var e=new u.Pool(function(e){return t.uploadChunk(e)},this.config.concurrentRequestLimit),n=this.chunks.map(function(t,n){return e.enqueue({chunk:t,index:n})}),r=o.default.all(n).then(function(){return t.mkFileReq()});return r.then(function(e){(0,s.removeLocalFileInfo)(t.file)},function(e){701!==e.code||(0,s.removeLocalFileInfo)(t.file)}),r},t.prototype.uploadChunk=function(t){var e=this,n=t.index,r=t.chunk,i=this.localInfo[n],a=this.uploadUrl+"/mkblk/"+r.size,u=i&&!(0,s.isChunkExpired)(i.time),c=this.config.checkByMD5,f=function(){return e.updateChunkProgress(r.size,n),e.ctxList[n]={ctx:i.ctx,size:i.size,time:i.time,md5:i.md5},o.default.resolve(null)};return u&&!c?f():(0,s.computeMd5)(r).then(function(t){if(u&&t===i.md5)return f();var o=(0,s.getHeadersForChunkUpload)(e.token),c=function(t){e.updateChunkProgress(t.loaded,n)},l=e.xhrHandler;return(0,s.request)(a,{method:"POST",headers:o,body:r,onProgress:c,onCreate:l}).then(function(o){c({loaded:r.size}),e.ctxList[n]={time:(new Date).getTime(),ctx:o.data.ctx,size:r.size,md5:t},(0,s.setLocalFileInfo)(e.file,e.ctxList)})})},t.prototype.mkFileReq=function(){var t=this,e=(0,i.default)({mimeType:"application/octet-stream"},this.putExtra),n=(0,s.createMkFileUrl)(this.uploadUrl,this.file,this.key,e),r=this.ctxList.map(function(t){return t.ctx}).join(","),a=(0,s.getHeadersForMkFile)(this.token),u=this.xhrHandler;return(0,s.request)(n,{method:"POST",body:r,headers:a,onCreate:u}).then(function(e){return t.updateMkFileProgress(1),o.default.resolve(e)})},t.prototype.updateDirectProgress=function(t,e){this.progress={total:this.getProgressInfoItem(t,e+1)},this.onData(this.progress)},t.prototype.finishDirectProgress=function(){if(!this.progress)return this.progress={total:this.getProgressInfoItem(this.file.size,this.file.size)},void this.onData(this.progress);var t=this.progress.total;this.progress={total:this.getProgressInfoItem(t.loaded+1,t.size)},this.onData(this.progress)},t.prototype.initChunksProgress=function(){this.loaded.chunks=this.chunks.map(function(t){return 0}),this.notifyResumeProgress()},t.prototype.updateChunkProgress=function(t,e){this.loaded.chunks[e]=t,this.notifyResumeProgress()},t.prototype.updateMkFileProgress=function(t){this.loaded.mkFileProgress=t,this.notifyResumeProgress()},t.prototype.notifyResumeProgress=function(){var t=this;this.progress={total:this.getProgressInfoItem((0,s.sum)(this.loaded.chunks)+this.loaded.mkFileProgress,this.file.size+1),chunks:this.chunks.map(function(e,n){return t.getProgressInfoItem(t.loaded.chunks[n],e.size)})},this.onData(this.progress)},t.prototype.getProgressInfoItem=function(t,e){return{loaded:t,size:e,percent:t/e*100}},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Pool=void 0;var o=r(n(18)),i=r(n(17));e.Pool=function(){function t(e,n){(0,i.default)(this,t),this.runTask=e,this.queue=[],this.processing=[],this.limit=n}return t.prototype.enqueue=function(t){var e=this;return new o.default(function(n,r){e.queue.push({task:t,resolve:n,reject:r}),e.check()})},t.prototype.run=function(t){var e=this;this.queue=this.queue.filter(function(e){return e!==t}),this.processing.push(t),this.runTask(t.task).then(function(){e.processing=e.processing.filter(function(e){return e!==t}),t.resolve(),e.check()},function(e){return t.reject(e)})},t.prototype.check=function(){var t=this,e=this.processing.length,n=this.limit-e;this.queue.slice(0,n).forEach(function(e,n){t.run(e)})},t}()},function(t,e,n){"use strict";function r(t,e){return t=encodeURIComponent(t),"/"!==e.slice(e.length-1)&&(e+="/"),e+t}function o(t,e,n){if(!/^\d$/.test(t.mode))throw"mode should be number in imageView2";var o=t.mode,i=t.w,a=t.h,s=t.q,u=t.format;if(!i&&!a)throw"param w and h is empty in imageView2";var c="imageView2/"+encodeURIComponent(o);return c+=i?"/w/"+encodeURIComponent(i):"",c+=a?"/h/"+encodeURIComponent(a):"",c+=s?"/q/"+encodeURIComponent(s):"",c+=u?"/format/"+encodeURIComponent(u):"",e&&(c=r(e,n)+"?"+c),c}function i(t,e,n){var o=t["auto-orient"],i=t.thumbnail,a=t.strip,s=t.gravity,u=t.crop,c=t.quality,f=t.rotate,l=t.format,h=t.blur,p="imageMogr2";return p+=o?"/auto-orient":"",p+=i?"/thumbnail/"+encodeURIComponent(i):"",p+=a?"/strip":"",p+=s?"/gravity/"+encodeURIComponent(s):"",p+=c?"/quality/"+encodeURIComponent(c):"",p+=u?"/crop/"+encodeURIComponent(u):"",p+=f?"/rotate/"+encodeURIComponent(f):"",p+=l?"/format/"+encodeURIComponent(l):"",p+=h?"/blur/"+encodeURIComponent(h):"",e&&(p=r(e,n)+"?"+p),p}function a(t,e,n){var o=t.mode;if(!o)throw"mode can't be empty in watermark";var i="watermark/"+o;if(1!==o&&2!==o)throw"mode is wrong";if(1===o){var a=t.image;if(!a)throw"image can't be empty in watermark";i+=a?"/image/"+(0,u.urlSafeBase64Encode)(a):""}if(2===o){var s=t.text,c=t.font,f=t.fontsize,l=t.fill;if(!s)throw"text can't be empty in watermark";i+=s?"/text/"+(0,u.urlSafeBase64Encode)(s):"",i+=c?"/font/"+(0,u.urlSafeBase64Encode)(c):"",i+=f?"/fontsize/"+f:"",i+=l?"/fill/"+(0,u.urlSafeBase64Encode)(l):""}var h=t.dissolve,p=t.gravity,d=t.dx,g=t.dy;return i+=h?"/dissolve/"+encodeURIComponent(h):"",i+=p?"/gravity/"+encodeURIComponent(p):"",i+=d?"/dx/"+encodeURIComponent(d):"",i+=g?"/dy/"+encodeURIComponent(g):"",e&&(i=r(e,n)+"?"+i),i}e.__esModule=!0,e.imageView2=o,e.imageMogr2=i,e.watermark=a,e.imageInfo=function(t,e){var n=r(t,e)+"?imageInfo";return(0,s.request)(n,{method:"GET"})},e.exif=function(t,e){var n=r(t,e)+"?exif";return(0,s.request)(n,{method:"GET"})},e.pipeline=function(t,e,n){var s=void 0,u=void 0,c="";if("[object Array]"===Object.prototype.toString.call(t)){for(var f=0,l=t.length;f<l;f++){if(!(s=t[f]).fop)throw"fop can't be empty in pipeline";switch(s.fop){case"watermark":c+=a(s)+"|";break;case"imageView2":c+=o(s)+"|";break;case"imageMogr2":c+=i(s)+"|";break;default:u=!0}if(u)throw"fop is wrong in pipeline"}if(e){var h=(c=r(e,n)+"?"+c).length;"|"===c.slice(h-1)&&(c=c.slice(0,h-1))}return c}throw"pipeline's first param should be array"};var s=n(12),u=n(56)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Observable=void 0;var o=r(n(96)),i=r(n(17));e.Observable=function(){function t(e){(0,i.default)(this,t),this.subscribeAction=e}return t.prototype.subscribe=function(t,e,n){var r=new a(t,e,n),o=this.subscribeAction(r);return new s(r,o)},t}();var a=function(){function t(e,n,r){(0,i.default)(this,t),this.isStopped=!1,"object"===(void 0===e?"undefined":(0,o.default)(e))?(this._onNext=e.next,this._onError=e.error,this._onCompleted=e.complete):(this._onNext=e,this._onError=n,this._onCompleted=r)}return t.prototype.next=function(t){!this.isStopped&&this._onNext&&this._onNext(t)},t.prototype.error=function(t){!this.isStopped&&this._onError&&(this.isStopped=!0,this._onError(t))},t.prototype.complete=function(t){!this.isStopped&&this._onCompleted&&(this.isStopped=!0,this._onCompleted(t))},t}(),s=function(){function t(e,n){(0,i.default)(this,t),this.observer=e,this.result=n}return t.prototype.unsubscribe=function(){this.observer.isStopped=!0,this.result()},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(97)),i=r(n(99)),a="function"==typeof i.default&&"symbol"==typeof o.default?function(t){return typeof t}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":typeof t};e.default="function"==typeof i.default&&"symbol"===a(o.default)?function(t){return void 0===t?"undefined":a(t)}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":void 0===t?"undefined":a(t)}},function(t,e,n){t.exports={default:n(98),__esModule:!0}},function(t,e,n){n(41),n(50),t.exports=n(37).f("iterator")},function(t,e,n){t.exports={default:n(100),__esModule:!0}},function(t,e,n){n(101),n(40),n(107),n(108),t.exports=n(1).Symbol},function(t,e,n){"use strict";var r=n(0),o=n(9),i=n(4),a=n(5),s=n(44),u=n(102).KEY,c=n(10),f=n(31),l=n(23),h=n(22),p=n(2),d=n(37),g=n(38),m=n(103),v=n(104),y=n(3),b=n(8),w=n(24),x=n(11),S=n(29),P=n(21),_=n(45),C=n(105),U=n(106),F=n(35),I=n(7),k=n(15),E=U.f,M=I.f,O=C.f,T=r.Symbol,R=r.JSON,A=R&&R.stringify,L=p("_hidden"),D=p("toPrimitive"),j={}.propertyIsEnumerable,B=f("symbol-registry"),G=f("symbols"),q=f("op-symbols"),N=Object.prototype,z="function"==typeof T&&!!F.f,H=r.QObject,V=!H||!H.prototype||!H.prototype.findChild,W=i&&c(function(){return 7!=_(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=E(N,e);r&&delete N[e],M(t,e,n),r&&t!==N&&M(N,e,r)}:M,J=function(t){var e=G[t]=_(T.prototype);return e._k=t,e},X=z&&"symbol"==typeof T.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof T},Y=function(t,e,n){return t===N&&Y(q,e,n),y(t),e=S(e,!0),y(n),o(G,e)?(n.enumerable?(o(t,L)&&t[L][e]&&(t[L][e]=!1),n=_(n,{enumerable:P(0,!1)})):(o(t,L)||M(t,L,P(1,{})),t[L][e]=!0),W(t,e,n)):M(t,e,n)},K=function(t,e){y(t);for(var n,r=m(e=x(e)),o=0,i=r.length;i>o;)Y(t,n=r[o++],e[n]);return t},$=function(t){var e=j.call(this,t=S(t,!0));return!(this===N&&o(G,t)&&!o(q,t))&&(!(e||!o(this,t)||!o(G,t)||o(this,L)&&this[L][t])||e)},Q=function(t,e){if(t=x(t),e=S(e,!0),t!==N||!o(G,e)||o(q,e)){var n=E(t,e);return!n||!o(G,e)||o(t,L)&&t[L][e]||(n.enumerable=!0),n}},Z=function(t){for(var e,n=O(x(t)),r=[],i=0;n.length>i;)o(G,e=n[i++])||e==L||e==u||r.push(e);return r},tt=function(t){for(var e,n=t===N,r=O(n?q:x(t)),i=[],a=0;r.length>a;)!o(G,e=r[a++])||n&&!o(N,e)||i.push(G[e]);return i};z||(s((T=function(){if(this instanceof T)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),e=function(n){this===N&&e.call(q,n),o(this,L)&&o(this[L],t)&&(this[L][t]=!1),W(this,t,P(1,n))};return i&&V&&W(N,t,{configurable:!0,set:e}),J(t)}).prototype,"toString",function(){return this._k}),U.f=Q,I.f=Y,n(57).f=C.f=Z,n(25).f=$,F.f=tt,i&&!n(13)&&s(N,"propertyIsEnumerable",$,!0),d.f=function(t){return J(p(t))}),a(a.G+a.W+a.F*!z,{Symbol:T});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var rt=k(p.store),ot=0;rt.length>ot;)g(rt[ot++]);a(a.S+a.F*!z,"Symbol",{for:function(t){return o(B,t+="")?B[t]:B[t]=T(t)},keyFor:function(t){if(!X(t))throw TypeError(t+" is not a symbol!");for(var e in B)if(B[e]===t)return e},useSetter:function(){V=!0},useSimple:function(){V=!1}}),a(a.S+a.F*!z,"Object",{create:function(t,e){return void 0===e?_(t):K(_(t),e)},defineProperty:Y,defineProperties:K,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:tt});var it=c(function(){F.f(1)});a(a.S+a.F*it,"Object",{getOwnPropertySymbols:function(t){return F.f(w(t))}}),R&&a(a.S+a.F*(!z||c(function(){var t=T();return"[null]"!=A([t])||"{}"!=A({a:t})||"{}"!=A(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(b(e)||void 0!==t)&&!X(t))return v(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!X(e))return e}),r[1]=e,A.apply(R,r)}}),T.prototype[D]||n(6)(T.prototype,D,T.prototype.valueOf),l(T,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){var r=n(22)("meta"),o=n(8),i=n(9),a=n(7).f,s=0,u=Object.isExtensible||function(){return!0},c=!n(10)(function(){return u(Object.preventExtensions({}))}),f=function(t){a(t,r,{value:{i:"O"+ ++s,w:{}}})},l=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!u(t))return"F";if(!e)return"E";f(t)}return t[r].i},getWeak:function(t,e){if(!i(t,r)){if(!u(t))return!0;if(!e)return!1;f(t)}return t[r].w},onFreeze:function(t){return c&&l.NEED&&u(t)&&!i(t,r)&&f(t),t}}},function(t,e,n){var r=n(15),o=n(35),i=n(25);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,s=n(t),u=i.f,c=0;s.length>c;)u.call(t,a=s[c++])&&e.push(a);return e}},function(t,e,n){var r=n(16);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(11),o=n(57).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return a.slice()}}(t):o(r(t))}},function(t,e,n){var r=n(25),o=n(21),i=n(11),a=n(29),s=n(9),u=n(43),c=Object.getOwnPropertyDescriptor;e.f=n(4)?c:function(t,e){if(t=i(t),e=a(e,!0),u)try{return c(t,e)}catch(t){}if(s(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){n(38)("asyncIterator")},function(t,e,n){n(38)("observable")},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.StatisticsLogger=void 0;var o=r(n(36)),i=r(n(17)),a=n(12);e.StatisticsLogger=function(){function t(){(0,i.default)(this,t)}return t.prototype.log=function(t,e){var n="";(0,o.default)(t).forEach(function(e){return n+=t[e]+","}),this.send(n,e,0)},t.prototype.send=function(t,e,n){var r=(0,a.createXHR)(),o=this;r.open("POST","https://uplog.qbox.me/log/3"),r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.setRequestHeader("Authorization","UpToken "+e),r.onreadystatechange=function(){4===r.readyState&&200!==r.status&&++n<=3&&o.send(t,e,n)},r.send(t)},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=r(n(36)),u=n(111),c=n(12),f={PNG:"image/png",JPEG:"image/jpeg",WEBP:"image/webp",BMP:"image/bmp"},l=Math.log(2),h=(0,s.default)(f).map(function(t){return f[t]}),p=f.JPEG,d=function(){function t(e,n){(0,a.default)(this,t),this.config=(0,i.default)({quality:.92,noCompressIfLarger:!1},n),this.file=e}return t.prototype.process=function(){var t=this;this.outputType=this.file.type;var e={};return function(t){return h.includes(t)}(this.file.type)?this.getOriginImage().then(function(e){return t.getCanvas(e)}).then(function(n){var r=1;return t.config.maxWidth&&(r=Math.min(1,t.config.maxWidth/n.width)),t.config.maxHeight&&(r=Math.min(1,r,t.config.maxHeight/n.height)),e.width=n.width,e.height=n.height,t.doScale(n,r)}).then(function(n){var r=t.toBlob(n);return r.size>t.file.size&&t.config.noCompressIfLarger?{dist:t.file,width:e.width,height:e.height}:{dist:r,width:n.width,height:n.height}}):o.default.reject(new Error("unsupported file type: "+this.file.type))},t.prototype.clear=function(t,e,n){this.outputType===p?(t.fillStyle="#fff",t.fillRect(0,0,e,n)):t.clearRect(0,0,e,n)},t.prototype.getOriginImage=function(){var t=this;return new o.default(function(e,n){var r=(0,c.createObjectURL)(t.file),o=new Image;o.onload=function(){e(o)},o.onerror=function(){n("image load error")},o.src=r})},t.prototype.getCanvas=function(t){var e=this;return new o.default(function(n,r){u.EXIF.getData(t,function(){var r=u.EXIF.getTag(t,"Orientation")||1,o=(0,c.getTransform)(t,r),i=o.width,a=o.height,s=o.matrix,f=document.createElement("canvas"),l=f.getContext("2d");f.width=i,f.height=a,e.clear(l,i,a),l.transform.apply(l,s),l.drawImage(t,0,0),n(f)})})},t.prototype.doScale=function(t,e){if(1===e)return o.default.resolve(t);var n=t.getContext("2d"),r=Math.min(4,Math.ceil(1/e/l)),i=Math.pow(e,1/r),a=document.createElement("canvas"),s=a.getContext("2d"),u=t.width,c=t.height,f=u,h=c;a.width=u,a.height=c;for(var p=void 0,d=void 0,g=0;g<r;g++){var m=u*i|0,v=c*i|0;g===r-1&&(m=f*e,v=h*e),g%2==0?(p=t,d=s):(p=a,d=n),this.clear(d,u,c),d.drawImage(p,0,0,u,c,0,0,m,v),u=m,c=v}var y=p===t?a:t,b=d.getImageData(0,0,u,c);return y.width=u,y.height=c,d.putImageData(b,0,0),o.default.resolve(y)},t.prototype.toBlob=function(t){var e=t.toDataURL(this.outputType,this.config.quality),n=atob(e.split(",")[1]).split("").map(function(t){return t.charCodeAt(0)});return new Blob([new Uint8Array(n)],{type:this.outputType})},t}();e.default=function(t,e){return new d(t,e).process()}},function(t,e,r){var o;(function(){function r(t){return!!t.exifdata}function i(t,e){function n(n){var r=a(n);t.exifdata=r||{};var o=function(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength;n<r;){if(function(t,e){return 56===t.getUint8(e)&&66===t.getUint8(e+1)&&73===t.getUint8(e+2)&&77===t.getUint8(e+3)&&4===t.getUint8(e+4)&&4===t.getUint8(e+5)}(e,n)){var o=e.getUint8(n+7);o%2!=0&&(o+=1),0===o&&(o=4);return s(t,n+8+o,e.getUint16(n+6+o))}n++}}(n);if(t.iptcdata=o||{},g.isXmpEnabled){var i=function(t){if("DOMParser"in self){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength,o=new DOMParser;n<r-4;){if("http"==f(e,n,4)){var i=n-1,a=e.getUint16(n-2)-1,s=f(e,i,a),u=s.indexOf("xmpmeta>")+8,c=(s=s.substring(s.indexOf("<x:xmpmeta"),u)).indexOf("x:xmpmeta")+10;s=s.slice(0,c)+'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:tiff="http://ns.adobe.com/tiff/1.0/" xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" xmlns:exif="http://ns.adobe.com/exif/1.0/" xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '+s.slice(c);return p(o.parseFromString(s,"text/xml"))}n++}}}(n);t.xmpdata=i||{}}e&&e.call(t)}if(t.src)if(/^data\:/i.test(t.src))n(function(t,e){e=e||t.match(/^data\:([^\;]+)\;base64,/im)[1]||"",t=t.replace(/^data\:([^\;]+)\;base64,/gim,"");for(var n=atob(t),r=n.length,o=new ArrayBuffer(r),i=new Uint8Array(o),a=0;a<r;a++)i[a]=n.charCodeAt(a);return o}(t.src));else if(/^blob\:/i.test(t.src))(o=new FileReader).onload=function(t){n(t.target.result)},function(t,e){var n=new XMLHttpRequest;n.open("GET",t,!0),n.responseType="blob",n.onload=function(t){200!=this.status&&0!==this.status||e(this.response)},n.send()}(t.src,function(t){o.readAsArrayBuffer(t)});else{var r=new XMLHttpRequest;r.onload=function(){if(200!=this.status&&0!==this.status)throw"Could not load image";n(r.response),r=null},r.open("GET",t.src,!0),r.responseType="arraybuffer",r.send(null)}else if(self.FileReader&&(t instanceof self.Blob||t instanceof self.File)){var o;(o=new FileReader).onload=function(t){d&&console.log("Got file of length "+t.target.result.byteLength),n(t.target.result)},o.readAsArrayBuffer(t)}}function a(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n,r=2,o=t.byteLength;r<o;){if(255!=e.getUint8(r))return d&&console.log("Not a valid marker at offset "+r+", found: "+e.getUint8(r)),!1;if(n=e.getUint8(r+1),d&&console.log(n),225==n)return d&&console.log("Found 0xFFE1 marker"),l(e,r+4,e.getUint16(r+2));r+=2+e.getUint16(r+2)}}function s(t,e,n){for(var r,o,i,a,s=new DataView(t),u={},c=e;c<e+n;)28===s.getUint8(c)&&2===s.getUint8(c+1)&&(a=s.getUint8(c+2))in x&&(i=s.getInt16(c+3),o=x[a],r=f(s,c+5,i),u.hasOwnProperty(o)?u[o]instanceof Array?u[o].push(r):u[o]=[u[o],r]:u[o]=r),c++;return u}function u(t,e,n,r,o){var i,a,s,u=t.getUint16(n,!o),f={};for(s=0;s<u;s++)i=n+12*s+2,!(a=r[t.getUint16(i,!o)])&&d&&console.log("Unknown tag: "+t.getUint16(i,!o)),f[a]=c(t,i,e,n,o);return f}function c(t,e,n,r,o){var i,a,s,u,c,l,h=t.getUint16(e+2,!o),p=t.getUint32(e+4,!o),d=t.getUint32(e+8,!o)+n;switch(h){case 1:case 7:if(1==p)return t.getUint8(e+8,!o);for(i=p>4?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint8(i+u);return a;case 2:return f(t,i=p>4?d:e+8,p-1);case 3:if(1==p)return t.getUint16(e+8,!o);for(i=p>2?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint16(i+2*u,!o);return a;case 4:if(1==p)return t.getUint32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getUint32(d+4*u,!o);return a;case 5:if(1==p)return c=t.getUint32(d,!o),l=t.getUint32(d+4,!o),(s=new Number(c/l)).numerator=c,s.denominator=l,s;for(a=[],u=0;u<p;u++)c=t.getUint32(d+8*u,!o),l=t.getUint32(d+4+8*u,!o),a[u]=new Number(c/l),a[u].numerator=c,a[u].denominator=l;return a;case 9:if(1==p)return t.getInt32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+4*u,!o);return a;case 10:if(1==p)return t.getInt32(d,!o)/t.getInt32(d+4,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+8*u,!o)/t.getInt32(d+4+8*u,!o);return a}}function f(t,e,r){var o="";for(n=e;n<e+r;n++)o+=String.fromCharCode(t.getUint8(n));return o}function l(t,e){if("Exif"!=f(t,e,4))return d&&console.log("Not valid EXIF data! "+f(t,e,4)),!1;var n,r,o,i,a,s=e+6;if(18761==t.getUint16(s))n=!1;else{if(19789!=t.getUint16(s))return d&&console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"),!1;n=!0}if(42!=t.getUint16(s+2,!n))return d&&console.log("Not valid TIFF data! (no 0x002A)"),!1;var c=t.getUint32(s+4,!n);if(c<8)return d&&console.log("Not valid TIFF data! (First offset less than 8)",t.getUint32(s+4,!n)),!1;if((r=u(t,s,s+c,v,n)).ExifIFDPointer)for(o in i=u(t,s,s+r.ExifIFDPointer,m,n)){switch(o){case"LightSource":case"Flash":case"MeteringMode":case"ExposureProgram":case"SensingMethod":case"SceneCaptureType":case"SceneType":case"CustomRendered":case"WhiteBalance":case"GainControl":case"Contrast":case"Saturation":case"Sharpness":case"SubjectDistanceRange":case"FileSource":i[o]=w[o][i[o]];break;case"ExifVersion":case"FlashpixVersion":i[o]=String.fromCharCode(i[o][0],i[o][1],i[o][2],i[o][3]);break;case"ComponentsConfiguration":i[o]=w.Components[i[o][0]]+w.Components[i[o][1]]+w.Components[i[o][2]]+w.Components[i[o][3]]}r[o]=i[o]}if(r.GPSInfoIFDPointer)for(o in a=u(t,s,s+r.GPSInfoIFDPointer,y,n)){switch(o){case"GPSVersionID":a[o]=a[o][0]+"."+a[o][1]+"."+a[o][2]+"."+a[o][3]}r[o]=a[o]}return r.thumbnail=function(t,e,n,r){var o=function(t,e,n){var r=t.getUint16(e,!n);return t.getUint32(e+2+12*r,!n)}(t,e+n,r);if(!o)return{};if(o>t.byteLength)return{};var i=u(t,e,e+o,b,r);if(i.Compression)switch(i.Compression){case 6:if(i.JpegIFOffset&&i.JpegIFByteCount){var a=e+i.JpegIFOffset,s=i.JpegIFByteCount;i.blob=new Blob([new Uint8Array(t.buffer,a,s)],{type:"image/jpeg"})}break;case 1:console.log("Thumbnail image format is TIFF, which is not implemented.");break;default:console.log("Unknown thumbnail image format '%s'",i.Compression)}else 2==i.PhotometricInterpretation&&console.log("Thumbnail image format is RGB, which is not implemented.");return i}(t,s,c,n),r}function h(t){var e={};if(1==t.nodeType){if(t.attributes.length>0){e["@attributes"]={};for(var n=0;n<t.attributes.length;n++){var r=t.attributes.item(n);e["@attributes"][r.nodeName]=r.nodeValue}}}else if(3==t.nodeType)return t.nodeValue;if(t.hasChildNodes())for(var o=0;o<t.childNodes.length;o++){var i=t.childNodes.item(o),a=i.nodeName;if(null==e[a])e[a]=h(i);else{if(null==e[a].push){var s=e[a];e[a]=[],e[a].push(s)}e[a].push(h(i))}}return e}function p(t){try{var e={};if(t.children.length>0)for(var n=0;n<t.children.length;n++){var r=t.children.item(n),o=r.attributes;for(var i in o){var a=o[i],s=a.nodeName,u=a.nodeValue;void 0!==s&&(e[s]=u)}var c=r.nodeName;if(void 0===e[c])e[c]=h(r);else{if(void 0===e[c].push){var f=e[c];e[c]=[],e[c].push(f)}e[c].push(h(r))}}else e=t.textContent;return e}catch(t){console.log(t.message)}}var d=!1,g=function(t){return t instanceof g?t:this instanceof g?void(this.EXIFwrapped=t):new g(t)};void 0!==t&&t.exports&&(e=t.exports=g),e.EXIF=g;var m=g.Tags={36864:"ExifVersion",40960:"FlashpixVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37500:"MakerNote",37510:"UserComment",40964:"RelatedSoundFile",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37520:"SubsecTime",37521:"SubsecTimeOriginal",37522:"SubsecTimeDigitized",33434:"ExposureTime",33437:"FNumber",34850:"ExposureProgram",34852:"SpectralSensitivity",34855:"ISOSpeedRatings",34856:"OECF",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureBias",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37396:"SubjectArea",37386:"FocalLength",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41492:"SubjectLocation",41493:"ExposureIndex",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRation",41989:"FocalLengthIn35mmFilm",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",40965:"InteroperabilityIFDPointer",42016:"ImageUniqueID"},v=g.TiffTags={256:"ImageWidth",257:"ImageHeight",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer",40965:"InteroperabilityIFDPointer",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",274:"Orientation",277:"SamplesPerPixel",284:"PlanarConfiguration",530:"YCbCrSubSampling",531:"YCbCrPositioning",282:"XResolution",283:"YResolution",296:"ResolutionUnit",273:"StripOffsets",278:"RowsPerStrip",279:"StripByteCounts",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",301:"TransferFunction",318:"WhitePoint",319:"PrimaryChromaticities",529:"YCbCrCoefficients",532:"ReferenceBlackWhite",306:"DateTime",270:"ImageDescription",271:"Make",272:"Model",305:"Software",315:"Artist",33432:"Copyright"},y=g.GPSTags={0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential"},b=g.IFD1Tags={256:"ImageWidth",257:"ImageHeight",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",273:"StripOffsets",274:"Orientation",277:"SamplesPerPixel",278:"RowsPerStrip",279:"StripByteCounts",282:"XResolution",283:"YResolution",284:"PlanarConfiguration",296:"ResolutionUnit",513:"JpegIFOffset",514:"JpegIFByteCount",529:"YCbCrCoefficients",530:"YCbCrSubSampling",531:"YCbCrPositioning",532:"ReferenceBlackWhite"},w=g.StringValues={ExposureProgram:{0:"Not defined",1:"Manual",2:"Normal program",3:"Aperture priority",4:"Shutter priority",5:"Creative program",6:"Action program",7:"Portrait mode",8:"Landscape mode"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{0:"Unknown",1:"Daylight",2:"Fluorescent",3:"Tungsten (incandescent light)",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 - 5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},SensingMethod:{1:"Not defined",2:"One-chip color area sensor",3:"Two-chip color area sensor",4:"Three-chip color area sensor",5:"Color sequential area sensor",7:"Trilinear sensor",8:"Color sequential linear sensor"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},SceneType:{1:"Directly photographed"},CustomRendered:{0:"Normal process",1:"Custom process"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},GainControl:{0:"None",1:"Low gain up",2:"High gain up",3:"Low gain down",4:"High gain down"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},SubjectDistanceRange:{0:"Unknown",1:"Macro",2:"Close view",3:"Distant view"},FileSource:{3:"DSC"},Components:{0:"",1:"Y",2:"Cb",3:"Cr",4:"R",5:"G",6:"B"}},x={120:"caption",110:"credit",25:"keywords",55:"dateCreated",80:"byline",85:"bylineTitle",122:"captionWriter",105:"headline",116:"copyright",15:"category"};g.enableXmp=function(){g.isXmpEnabled=!0},g.disableXmp=function(){g.isXmpEnabled=!1},g.getData=function(t,e){return!((self.Image&&t instanceof self.Image||self.HTMLImageElement&&t instanceof self.HTMLImageElement)&&!t.complete||(r(t)?e&&e.call(t):i(t,e),0))},g.getTag=function(t,e){if(r(t))return t.exifdata[e]},g.getIptcTag=function(t,e){if(r(t))return t.iptcdata[e]},g.getAllTags=function(t){if(!r(t))return{};var e,n=t.exifdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.getAllIptcTags=function(t){if(!r(t))return{};var e,n=t.iptcdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.pretty=function(t){if(!r(t))return"";var e,n=t.exifdata,o="";for(e in n)n.hasOwnProperty(e)&&("object"==typeof n[e]?n[e]instanceof Number?o+=e+" : "+n[e]+" ["+n[e].numerator+"/"+n[e].denominator+"]\r\n":o+=e+" : ["+n[e].length+" values]\r\n":o+=e+" : "+n[e]+"\r\n");return o},g.readFromBinaryFile=function(t){return a(t)},void 0===(o=function(){return g}.apply(e,[]))||(t.exports=o)}).call(this)}])});
//# sourceMappingURL=qiniu.min.js.map

/***/ }),

/***/ 55798:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 54087:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var now = __webpack_require__(75)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 29372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V4": () => (/* reexport */ CSSMotionList),
  "ZP": () => (/* binding */ rc_motion_es)
});

// UNUSED EXPORTS: Provider

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(34203);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/context.js

var _excluded = (/* unused pure expression or super */ null && (["children"]));

var Context = /*#__PURE__*/react.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: props
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(29388);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/DomWrapper.js





var DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);
/* harmony default export */ const es_DomWrapper = (DomWrapper);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(56790);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(30470);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(66680);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useSyncState.js



/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */
function useSyncState(defaultValue) {
  var _React$useReducer = react.useReducer(function (x) {
      return x + 1;
    }, 0),
    _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2),
    forceUpdate = _React$useReducer2[1];
  var currentValueRef = react.useRef(defaultValue);
  var getValue = (0,useEvent/* default */.Z)(function () {
    return currentValueRef.current;
  });
  var setValue = (0,useEvent/* default */.Z)(function (updater) {
    currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue, setValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/interface.js
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
/**
 * Used for disabled motion case.
 * Prepare stage will still work but start & active will be skipped.
 */
var STEP_PREPARED = 'prepared';
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(98924);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/motion.js


// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };
  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }
    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes((0,canUseDom/* default */.Z)(), typeof window !== 'undefined' ? window : {});
var style = {};
if ((0,canUseDom/* default */.Z)()) {
  var _document$createEleme = document.createElement('div');
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if ((0,esm_typeof/* default */.Z)(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useDomMotionEvents.js



/* harmony default export */ const useDomMotionEvents = (function (onInternalMotionEnd) {
  var cacheElementRef = (0,react.useRef)();

  // Remove events
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }

  // Patch events
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);

      // Save as cache in case dom removed trigger by `motionDeadline`
      cacheElementRef.current = element;
    }
  }

  // Clean up when removed
  react.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js



// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = (0,canUseDom/* default */.Z)() ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ const hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(75164);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useNextFrame.js


/* harmony default export */ const useNextFrame = (function () {
  var nextFrameRef = react.useRef(null);
  function cancelNextFrame() {
    raf/* default.cancel */.Z.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = (0,raf/* default */.Z)(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStepQueue.js






var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];

/** Skip current step */
var SkipStep = false;
/** Current step should be update in */
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
/* harmony default export */ const useStepQueue = (function (status, prepareOnly, callback) {
  var _useState = (0,useState/* default */.Z)(STEP_NONE),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useNextFrame = useNextFrame(),
    _useNextFrame2 = (0,slicedToArray/* default */.Z)(_useNextFrame, 2),
    nextFrame = _useNextFrame2[0],
    cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  hooks_useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);
      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else if (nextStep) {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStatus.js












function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
    _ref$motionAppear = _ref.motionAppear,
    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
    _ref$motionLeave = _ref.motionLeave,
    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
    motionDeadline = _ref.motionDeadline,
    motionLeaveImmediately = _ref.motionLeaveImmediately,
    onAppearPrepare = _ref.onAppearPrepare,
    onEnterPrepare = _ref.onEnterPrepare,
    onLeavePrepare = _ref.onLeavePrepare,
    onAppearStart = _ref.onAppearStart,
    onEnterStart = _ref.onEnterStart,
    onLeaveStart = _ref.onLeaveStart,
    onAppearActive = _ref.onAppearActive,
    onEnterActive = _ref.onEnterActive,
    onLeaveActive = _ref.onLeaveActive,
    onAppearEnd = _ref.onAppearEnd,
    onEnterEnd = _ref.onEnterEnd,
    onLeaveEnd = _ref.onLeaveEnd,
    onVisibleChanged = _ref.onVisibleChanged;
  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = (0,useState/* default */.Z)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    asyncVisible = _useState2[0],
    setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    getStatus = _useSyncState2[0],
    setStatus = _useSyncState2[1];
  var _useState3 = (0,useState/* default */.Z)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = (0,react.useRef)(false);
  var deadlineRef = (0,react.useRef)(null);

  // =========================== Dom Node ===========================
  function getDomElement() {
    return getElement();
  }

  // ========================== Motion End ==========================
  var activeRef = (0,react.useRef)(false);

  /**
   * Clean up status & style
   */
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = (0,es/* useEvent */.zX)(function (event) {
    var status = getStatus();
    // Do nothing since not in any transition status.
    // This may happen when `motionDeadline` trigger.
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }

    // Only update status when `canEnd` and not destroyed
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
    _useDomMotionEvents2 = (0,slicedToArray/* default */.Z)(_useDomMotionEvents, 1),
    patchMotionEvents = _useDomMotionEvents2[0];

  // ============================= Step =============================
  var getEventHandlers = function getEventHandlers(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = react.useMemo(function () {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function (newStep) {
      // Only prepare step can be skip
      if (newStep === STEP_PREPARE) {
        var onPrepare = eventHandlers[STEP_PREPARE];
        if (!onPrepare) {
          return SkipStep;
        }
        return onPrepare(getDomElement());
      }

      // Rest step is sync update
      if (step in eventHandlers) {
        var _eventHandlers$step;
        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
      }
      if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
        // Patch events when motion needed
        patchMotionEvents(getDomElement());
        if (motionDeadline > 0) {
          clearTimeout(deadlineRef.current);
          deadlineRef.current = setTimeout(function () {
            onInternalMotionEnd({
              deadline: true
            });
          }, motionDeadline);
        }
      }
      if (step === STEP_PREPARED) {
        updateMotionEndStatus();
      }
      return DoStep;
    }),
    _useStepQueue2 = (0,slicedToArray/* default */.Z)(_useStepQueue, 2),
    startStep = _useStepQueue2[0],
    step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;

  // ============================ Status ============================
  // Update with new status
  hooks_useIsomorphicLayoutEffect(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    // if (!supportMotion) {
    //   return;
    // }

    var nextStatus;

    // Appear
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }

    // Enter
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }

    // Leave
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);

    // Update to next status
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      // Set back in case no motion but prev status has prepare step
      setStatus(STATUS_NONE);
    }
  }, [visible]);

  // ============================ Effect ============================
  // Reset when motion changed
  (0,react.useEffect)(function () {
    if (
    // Cancel appear
    currentStatus === STATUS_APPEAR && !motionAppear ||
    // Cancel enter
    currentStatus === STATUS_ENTER && !motionEnter ||
    // Cancel leave
    currentStatus === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0,react.useEffect)(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);

  // Trigger `onVisibleChanged`
  var firstMountChangeRef = react.useRef(false);
  (0,react.useEffect)(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== undefined && currentStatus === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);

  // ============================ Styles ============================
  var mergedStyle = style;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = (0,objectSpread2/* default */.Z)({
      transition: 'none'
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotion.js




/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */











/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  if ((0,esm_typeof/* default */.Z)(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /*#__PURE__*/react.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$removeOnLeave = props.removeOnLeave,
      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
      forceRender = props.forceRender,
      children = props.children,
      motionName = props.motionName,
      leavedClassName = props.leavedClassName,
      eventProps = props.eventProps;
    var _React$useContext = react.useContext(Context),
      contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);

    // Ref to the react node, it may be a HTMLElement
    var nodeRef = (0,react.useRef)();
    // Ref to the dom wrapper in case ref can not pass to HTMLElement
    var wrapperNodeRef = (0,react.useRef)();
    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0,findDOMNode/* default */.ZP)(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
      _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 4),
      status = _useStatus2[0],
      statusStep = _useStatus2[1],
      statusStyle = _useStatus2[2],
      mergedVisible = _useStatus2[3];

    // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`
    var renderedRef = react.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }

    // ====================== Refs ======================
    var setNodeRef = react.useCallback(function (node) {
      nodeRef.current = node;
      (0,es_ref/* fillRef */.mH)(ref, node);
    }, [ref]);

    // ===================== Render =====================
    var motionChildren;
    var mergedProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, eventProps), {}, {
      visible: visible
    });
    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children((0,objectSpread2/* default */.Z)({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      // In motion
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
        className: classnames_default()(getTransitionName(motionName, status), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
        style: statusStyle
      }), setNodeRef);
    }

    // Auto inject ref if child node not have `ref` props
    if ( /*#__PURE__*/react.isValidElement(motionChildren) && (0,es_ref/* supportRef */.Yr)(motionChildren)) {
      var originNodeRef = (0,es_ref/* getNodeRef */.C4)(motionChildren);
      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/react.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /*#__PURE__*/react.createElement(es_DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ const es_CSSMotion = (genCSSMotion(supportTransition));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/diff.js


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;
  if (key && (0,esm_typeof/* default */.Z)(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);

  // Check prev keys to insert or keep
  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }

    // If not hit, it means key is removed
    if (!hit) {
      list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });

  // Add rest to the list
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }

  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */
  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
        status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });

    // Update `STATUS_ADD` to `STATUS_KEEP`
    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotionList.js









var CSSMotionList_excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
  _excluded2 = ["status"];
/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : es_CSSMotion;
  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    (0,inherits/* default */.Z)(CSSMotionList, _React$Component);
    var _super = (0,createSuper/* default */.Z)(CSSMotionList);
    function CSSMotionList() {
      var _this;
      (0,classCallCheck/* default */.Z)(this, CSSMotionList);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
        keyEntities: []
      });
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "removeKey", function (removeKey) {
        _this.setState(function (prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function (entity) {
            if (entity.key !== removeKey) return entity;
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function () {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function (_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    (0,createClass/* default */.Z)(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          _onVisibleChanged = _this$props.onVisibleChanged,
          onAllRemoved = _this$props.onAllRemoved,
          restProps = (0,objectWithoutProperties/* default */.Z)(_this$props, CSSMotionList_excluded);
        var Component = component || react.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/react.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
          var status = _ref2.status,
            eventProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/react.createElement(CSSMotion, (0,esm_extends/* default */.Z)({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function (props, ref) {
            return children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
              index: index
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });

            // Remove if already mark as removed
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList;
  }(react.Component);
  (0,defineProperty/* default */.Z)(CSSMotionList, "defaultProps", {
    component: 'div'
  });
  return CSSMotionList;
}
/* harmony default export */ const CSSMotionList = (genCSSMotionList(supportTransition));
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/index.js




/* harmony default export */ const rc_motion_es = (es_CSSMotion);

/***/ }),

/***/ 98924:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ canUseDom)
/* harmony export */ });
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),

/***/ 34203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": () => (/* binding */ isDOM),
/* harmony export */   "ZP": () => (/* binding */ findDOMNode)
/* harmony export */ });
/* unused harmony export getDOM */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);



function isDOM(node) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element
  // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
  return node instanceof HTMLElement || node instanceof SVGElement;
}

/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */
function getDOM(node) {
  if (node && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node) === 'object' && isDOM(node.nativeElement)) {
    return node.nativeElement;
  }
  if (isDOM(node)) {
    return node;
  }
  return null;
}

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  var domNode = getDOM(node);
  if (domNode) {
    return domNode;
  }
  if (node instanceof react__WEBPACK_IMPORTED_MODULE_0__.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(react_dom__WEBPACK_IMPORTED_MODULE_1__, node);
  }
  return null;
}

/***/ }),

/***/ 25517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isFragment)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);

var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');

/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */
function isFragment(object) {
  return (
    // Base object type
    object && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object) === 'object' && (
    // React Element type
    object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) &&
    // React Fragment type
    object.type === REACT_FRAGMENT_TYPE
  );
}

/***/ }),

/***/ 66680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useEvent)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useEvent(callback) {
  var fnRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  fnRef.current = callback;
  var memoFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

/***/ }),

/***/ 8410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "o": () => (/* binding */ useLayoutUpdateEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98924);



/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect =  true && (0,_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
  var firstMountRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLayoutEffect);

/***/ }),

/***/ 56982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMemo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

/***/ }),

/***/ 21770:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMergedState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66680);
/* harmony import */ var _useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8410);
/* harmony import */ var _useState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30470);




/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(onChange);
  var _useState3 = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([mergedValue]),
    _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/***/ }),

/***/ 30470:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useSafeState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultValue),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/***/ }),

/***/ 56790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": () => (/* reexport safe */ _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "zX": () => (/* reexport safe */ _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__.Z)
/* harmony export */ });
/* harmony import */ var _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66680);
/* harmony import */ var _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21770);
/* harmony import */ var _ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42550);
/* harmony import */ var _utils_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8880);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80334);







/***/ }),

/***/ 75164:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (false) {}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (wrapperRaf);

/***/ }),

/***/ 42550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": () => (/* binding */ getNodeRef),
/* harmony export */   "Yr": () => (/* binding */ supportRef),
/* harmony export */   "mH": () => (/* binding */ fillRef),
/* harmony export */   "sQ": () => (/* binding */ composeRef),
/* harmony export */   "x1": () => (/* binding */ useComposeRef)
/* harmony export */ });
/* unused harmony export supportNodeRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11805);
/* harmony import */ var _hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56982);
/* harmony import */ var _React_isFragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25517);





var fillRef = function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
};

/**
 * Merge refs into one ref function to support ref passing.
 */
var composeRef = function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
};
var useComposeRef = function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return (0,_hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length !== next.length || prev.every(function (ref, i) {
      return ref !== next[i];
    });
  });
};
var supportRef = function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }

  // React 19 no need `forwardRef` anymore. So just pass if is a React element.
  if (isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) {
    return true;
  }
  var type = (0,react_is__WEBPACK_IMPORTED_MODULE_1__.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(node) && !(0,_React_isFragment__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(node);
}
var supportNodeRef = function supportNodeRef(node) {
  return isReactElement(node) && supportRef(node);
};

/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */
var getNodeRef = function getNodeRef(node) {
  if (node && isReactElement(node)) {
    var ele = node;

    // Source from:
    // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
    return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
  }
  return null;
};

/***/ }),

/***/ 88306:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ get)
/* harmony export */ });
function get(entity, path) {
  var current = entity;
  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }
    current = current[path[i]];
  }
  return current;
}

/***/ }),

/***/ 8880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ merge),
/* harmony export */   "Z": () => (/* binding */ set)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74902);
/* harmony import */ var _babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84506);
/* harmony import */ var _get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88306);





function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = (0,_babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(paths),
    path = _paths[0],
    restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entity);
  } else {
    clone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, entity);
  }

  // Delete prop if `removeIfUndefined` and value is undefined
  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !(0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;

/**
 * Merge objects which will create
 */
function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function (src) {
    function internalMerge(path, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src, path);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        // Only add not loop obj
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(clone, path);
          if (isArr) {
            // Array will always be override
            clone = set(clone, path, []);
          } else if (!originValue || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originValue) !== 'object') {
            // Init container if not exist
            clone = set(clone, path, createEmpty(value));
          }
          keys(value).forEach(function (key) {
            internalMerge([].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(path), [key]), loopSet);
          });
        }
      } else {
        clone = set(clone, path, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}

/***/ }),

/***/ 80334:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kp": () => (/* binding */ warning),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports preMessage, note, resetWarned, call, warningOnce, noteOnce */
/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning(valid, message) {
  if (false) { var finalMessage; }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (false) { var finalMessage; }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (warningOnce);

/***/ }),

/***/ 24996:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


var _interopRequireWildcard = (__webpack_require__(75263)["default"]);
var _interopRequireDefault = (__webpack_require__(64836)["default"]);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = _r;
__webpack_unused_export__ = _u;
exports.sY = render;
exports.vE = unmount;
var _regeneratorRuntime2 = _interopRequireDefault(__webpack_require__(17061));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _objectSpread2 = _interopRequireDefault(__webpack_require__(42122));
var ReactDOM = _interopRequireWildcard(__webpack_require__(73935));
// Let compiler not to search module usage
var fullClone = (0, _objectSpread2.default)({}, ReactDOM);
var version = fullClone.version,
  reactRender = fullClone.render,
  unmountComponentAtNode = fullClone.unmountComponentAtNode;
var createRoot;
try {
  var mainVersion = Number((version || '').split('.')[0]);
  if (mainVersion >= 18) {
    createRoot = fullClone.createRoot;
  }
} catch (e) {
  // Do nothing;
}
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, _typeof2.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = '__rc_react_root__';

// ========================== Render ==========================

function modernRender(node, container) {
  toggleWarning(true);
  var root = container[MARK] || createRoot(container);
  toggleWarning(false);
  root.render(node);
  container[MARK] = root;
}
function legacyRender(node, container) {
  reactRender(node, container);
}

/** @private Test usage. Not work in prod */
function _r(node, container) {
  if (false) {}
}
function render(node, container) {
  if (createRoot) {
    modernRender(node, container);
    return;
  }
  legacyRender(node, container);
}

// ========================= Unmount ==========================
function modernUnmount(_x) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  _modernUnmount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(container) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", Promise.resolve().then(function () {
            var _container$MARK;
            (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
            delete container[MARK];
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
  unmountComponentAtNode(container);
}

/** @private Test usage. Not work in prod */
function _u(container) {
  if (false) {}
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(container) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(createRoot !== undefined)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", modernUnmount(container));
        case 2:
          legacyUnmount(container);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _unmount.apply(this, arguments);
}

/***/ }),

/***/ 51162:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;exports.ForwardRef=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 11805:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(51162);
} else {}


/***/ }),

/***/ 88682:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),

/***/ 14608:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(54087);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(95205);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(13305);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(78669);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(4749);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(56839);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(7679);

var _defaultRenderElements = __webpack_require__(88682);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),

/***/ 7679:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),

/***/ 31298:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.$B = undefined;

var _Scrollbars = __webpack_require__(14608);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.ZP = _Scrollbars2["default"];
exports.$B = _Scrollbars2["default"];

/***/ }),

/***/ 56839:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ 4749:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ 13305:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),

/***/ 95205:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),

/***/ 78669:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),

/***/ 35747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 80842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AbstractTokenizer = void 0;
const peek_readable_1 = __webpack_require__(55167);
/**
 * Core tokenizer
 */
class AbstractTokenizer {
    constructor(fileInfo) {
        /**
         * Tokenizer-stream position
         */
        this.position = 0;
        this.numBuffer = new Uint8Array(8);
        this.fileInfo = fileInfo ? fileInfo : {};
    }
    /**
     * Read a token from the tokenizer-stream
     * @param token - The token to read
     * @param position - If provided, the desired position in the tokenizer-stream
     * @returns Promise with token data
     */
    async readToken(token, position = this.position) {
        const uint8Array = Buffer.alloc(token.len);
        const len = await this.readBuffer(uint8Array, { position });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(uint8Array, 0);
    }
    /**
     * Peek a token from the tokenizer-stream.
     * @param token - Token to peek from the tokenizer-stream.
     * @param position - Offset where to begin reading within the file. If position is null, data will be read from the current file position.
     * @returns Promise with token data
     */
    async peekToken(token, position = this.position) {
        const uint8Array = Buffer.alloc(token.len);
        const len = await this.peekBuffer(uint8Array, { position });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(uint8Array, 0);
    }
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */
    async readNumber(token) {
        const len = await this.readBuffer(this.numBuffer, { length: token.len });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(this.numBuffer, 0);
    }
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */
    async peekNumber(token) {
        const len = await this.peekBuffer(this.numBuffer, { length: token.len });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(this.numBuffer, 0);
    }
    /**
     * Ignore number of bytes, advances the pointer in under tokenizer-stream.
     * @param length - Number of bytes to ignore
     * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
     */
    async ignore(length) {
        if (this.fileInfo.size !== undefined) {
            const bytesLeft = this.fileInfo.size - this.position;
            if (length > bytesLeft) {
                this.position += bytesLeft;
                return bytesLeft;
            }
        }
        this.position += length;
        return length;
    }
    async close() {
        // empty
    }
    normalizeOptions(uint8Array, options) {
        if (options && options.position !== undefined && options.position < this.position) {
            throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
        }
        if (options) {
            return {
                mayBeLess: options.mayBeLess === true,
                offset: options.offset ? options.offset : 0,
                length: options.length ? options.length : (uint8Array.length - (options.offset ? options.offset : 0)),
                position: options.position ? options.position : this.position
            };
        }
        return {
            mayBeLess: false,
            offset: 0,
            length: uint8Array.length,
            position: this.position
        };
    }
}
exports.AbstractTokenizer = AbstractTokenizer;


/***/ }),

/***/ 30778:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BufferTokenizer = void 0;
const peek_readable_1 = __webpack_require__(55167);
const AbstractTokenizer_1 = __webpack_require__(80842);
class BufferTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    /**
     * Construct BufferTokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param fileInfo - Pass additional file information to the tokenizer
     */
    constructor(uint8Array, fileInfo) {
        super(fileInfo);
        this.uint8Array = uint8Array;
        this.fileInfo.size = this.fileInfo.size ? this.fileInfo.size : uint8Array.length;
    }
    /**
     * Read buffer from tokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */
    async readBuffer(uint8Array, options) {
        if (options && options.position) {
            if (options.position < this.position) {
                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
            }
            this.position = options.position;
        }
        const bytesRead = await this.peekBuffer(uint8Array, options);
        this.position += bytesRead;
        return bytesRead;
    }
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param uint8Array
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const bytes2read = Math.min(this.uint8Array.length - normOptions.position, normOptions.length);
        if ((!normOptions.mayBeLess) && bytes2read < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        else {
            uint8Array.set(this.uint8Array.subarray(normOptions.position, normOptions.position + bytes2read), normOptions.offset);
            return bytes2read;
        }
    }
    async close() {
        // empty
    }
}
exports.BufferTokenizer = BufferTokenizer;


/***/ }),

/***/ 27859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromFile = exports.FileTokenizer = void 0;
const AbstractTokenizer_1 = __webpack_require__(80842);
const peek_readable_1 = __webpack_require__(55167);
const fs = __webpack_require__(77209);
class FileTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    constructor(fd, fileInfo) {
        super(fileInfo);
        this.fd = fd;
    }
    /**
     * Read buffer from file
     * @param uint8Array - Uint8Array to write result to
     * @param options - Read behaviour options
     * @returns Promise number of bytes read
     */
    async readBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        this.position = normOptions.position;
        const res = await fs.read(this.fd, uint8Array, normOptions.offset, normOptions.length, normOptions.position);
        this.position += res.bytesRead;
        if (res.bytesRead < normOptions.length && (!options || !options.mayBeLess)) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return res.bytesRead;
    }
    /**
     * Peek buffer from file
     * @param uint8Array - Uint8Array (or Buffer) to write data to
     * @param options - Read behaviour options
     * @returns Promise number of bytes read
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const res = await fs.read(this.fd, uint8Array, normOptions.offset, normOptions.length, normOptions.position);
        if ((!normOptions.mayBeLess) && res.bytesRead < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return res.bytesRead;
    }
    async close() {
        return fs.close(this.fd);
    }
}
exports.FileTokenizer = FileTokenizer;
async function fromFile(sourceFilePath) {
    const stat = await fs.stat(sourceFilePath);
    if (!stat.isFile) {
        throw new Error(`File not a file: ${sourceFilePath}`);
    }
    const fd = await fs.open(sourceFilePath, 'r');
    return new FileTokenizer(fd, { path: sourceFilePath, size: stat.size });
}
exports.fromFile = fromFile;


/***/ }),

/***/ 77209:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/**
 * Module convert fs functions to promise based functions
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.readFile = exports.writeFileSync = exports.writeFile = exports.read = exports.open = exports.close = exports.stat = exports.createReadStream = exports.pathExists = void 0;
const fs = __webpack_require__(4059);
exports.pathExists = fs.existsSync;
exports.createReadStream = fs.createReadStream;
async function stat(path) {
    return new Promise((resolve, reject) => {
        fs.stat(path, (err, stats) => {
            if (err)
                reject(err);
            else
                resolve(stats);
        });
    });
}
exports.stat = stat;
async function close(fd) {
    return new Promise((resolve, reject) => {
        fs.close(fd, err => {
            if (err)
                reject(err);
            else
                resolve();
        });
    });
}
exports.close = close;
async function open(path, mode) {
    return new Promise((resolve, reject) => {
        fs.open(path, mode, (err, fd) => {
            if (err)
                reject(err);
            else
                resolve(fd);
        });
    });
}
exports.open = open;
async function read(fd, buffer, offset, length, position) {
    return new Promise((resolve, reject) => {
        fs.read(fd, buffer, offset, length, position, (err, bytesRead, _buffer) => {
            if (err)
                reject(err);
            else
                resolve({ bytesRead, buffer: _buffer });
        });
    });
}
exports.read = read;
async function writeFile(path, data) {
    return new Promise((resolve, reject) => {
        fs.writeFile(path, data, err => {
            if (err)
                reject(err);
            else
                resolve();
        });
    });
}
exports.writeFile = writeFile;
function writeFileSync(path, data) {
    fs.writeFileSync(path, data);
}
exports.writeFileSync = writeFileSync;
async function readFile(path) {
    return new Promise((resolve, reject) => {
        fs.readFile(path, (err, buffer) => {
            if (err)
                reject(err);
            else
                resolve(buffer);
        });
    });
}
exports.readFile = readFile;


/***/ }),

/***/ 20599:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReadStreamTokenizer = void 0;
const AbstractTokenizer_1 = __webpack_require__(80842);
const peek_readable_1 = __webpack_require__(55167);
const maxBufferSize = 256000;
class ReadStreamTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    constructor(stream, fileInfo) {
        super(fileInfo);
        this.streamReader = new peek_readable_1.StreamReader(stream);
    }
    /**
     * Get file information, an HTTP-client may implement this doing a HEAD request
     * @return Promise with file information
     */
    async getFileInfo() {
        return this.fileInfo;
    }
    /**
     * Read buffer from tokenizer
     * @param uint8Array - Target Uint8Array to fill with data read from the tokenizer-stream
     * @param options - Read behaviour options
     * @returns Promise with number of bytes read
     */
    async readBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const skipBytes = normOptions.position - this.position;
        if (skipBytes > 0) {
            await this.ignore(skipBytes);
            return this.readBuffer(uint8Array, options);
        }
        else if (skipBytes < 0) {
            throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
        }
        if (normOptions.length === 0) {
            return 0;
        }
        const bytesRead = await this.streamReader.read(uint8Array, normOptions.offset, normOptions.length);
        this.position += bytesRead;
        if ((!options || !options.mayBeLess) && bytesRead < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return bytesRead;
    }
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param uint8Array - Uint8Array (or Buffer) to write data to
     * @param options - Read behaviour options
     * @returns Promise with number of bytes peeked
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        let bytesRead = 0;
        if (normOptions.position) {
            const skipBytes = normOptions.position - this.position;
            if (skipBytes > 0) {
                const skipBuffer = new Uint8Array(normOptions.length + skipBytes);
                bytesRead = await this.peekBuffer(skipBuffer, { mayBeLess: normOptions.mayBeLess });
                uint8Array.set(skipBuffer.subarray(skipBytes), normOptions.offset);
                return bytesRead - skipBytes;
            }
            else if (skipBytes < 0) {
                throw new Error('Cannot peek from a negative offset in a stream');
            }
        }
        if (normOptions.length > 0) {
            try {
                bytesRead = await this.streamReader.peek(uint8Array, normOptions.offset, normOptions.length);
            }
            catch (err) {
                if (options && options.mayBeLess && err instanceof peek_readable_1.EndOfStreamError) {
                    return 0;
                }
                throw err;
            }
            if ((!normOptions.mayBeLess) && bytesRead < normOptions.length) {
                throw new peek_readable_1.EndOfStreamError();
            }
        }
        return bytesRead;
    }
    async ignore(length) {
        // debug(`ignore ${this.position}...${this.position + length - 1}`);
        const bufSize = Math.min(maxBufferSize, length);
        const buf = new Uint8Array(bufSize);
        let totBytesRead = 0;
        while (totBytesRead < length) {
            const remaining = length - totBytesRead;
            const bytesRead = await this.readBuffer(buf, { length: Math.min(bufSize, remaining) });
            if (bytesRead < 0) {
                return bytesRead;
            }
            totBytesRead += bytesRead;
        }
        return totBytesRead;
    }
}
exports.ReadStreamTokenizer = ReadStreamTokenizer;


/***/ }),

/***/ 35849:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBuffer = exports.fromStream = exports.EndOfStreamError = void 0;
const ReadStreamTokenizer_1 = __webpack_require__(20599);
const BufferTokenizer_1 = __webpack_require__(30778);
var peek_readable_1 = __webpack_require__(55167);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return peek_readable_1.EndOfStreamError; } }));
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property/
 * @param stream - Read from Node.js Stream.Readable
 * @param fileInfo - Pass the file information, like size and MIME-type of the corresponding stream.
 * @returns ReadStreamTokenizer
 */
function fromStream(stream, fileInfo) {
    fileInfo = fileInfo ? fileInfo : {};
    return new ReadStreamTokenizer_1.ReadStreamTokenizer(stream, fileInfo);
}
exports.fromStream = fromStream;
/**
 * Construct ReadStreamTokenizer from given Buffer.
 * @param uint8Array - Uint8Array to tokenize
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns BufferTokenizer
 */
function fromBuffer(uint8Array, fileInfo) {
    return new BufferTokenizer_1.BufferTokenizer(uint8Array, fileInfo);
}
exports.fromBuffer = fromBuffer;


/***/ }),

/***/ 26597:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromStream = exports.fromBuffer = exports.EndOfStreamError = exports.fromFile = void 0;
const fs = __webpack_require__(77209);
const core = __webpack_require__(35849);
var FileTokenizer_1 = __webpack_require__(27859);
Object.defineProperty(exports, "fromFile", ({ enumerable: true, get: function () { return FileTokenizer_1.fromFile; } }));
var core_1 = __webpack_require__(35849);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return core_1.EndOfStreamError; } }));
Object.defineProperty(exports, "fromBuffer", ({ enumerable: true, get: function () { return core_1.fromBuffer; } }));
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property.
 * @param stream - Node.js Stream.Readable
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns Tokenizer
 */
async function fromStream(stream, fileInfo) {
    fileInfo = fileInfo ? fileInfo : {};
    if (stream.path) {
        const stat = await fs.stat(stream.path);
        fileInfo.path = stream.path;
        fileInfo.size = stat.size;
    }
    return core.fromStream(stream, fileInfo);
}
exports.fromStream = fromStream;


/***/ }),

/***/ 6189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var space = __webpack_require__(7966)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),

/***/ 71788:
/***/ ((module) => {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),

/***/ 7966:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var clean = __webpack_require__(71788)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),

/***/ 83416:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnsiStringType = exports.StringType = exports.BufferType = exports.Uint8ArrayType = exports.IgnoreType = exports.Float80_LE = exports.Float80_BE = exports.Float64_LE = exports.Float64_BE = exports.Float32_LE = exports.Float32_BE = exports.Float16_LE = exports.Float16_BE = exports.INT64_BE = exports.UINT64_BE = exports.INT64_LE = exports.UINT64_LE = exports.INT32_LE = exports.INT32_BE = exports.INT24_BE = exports.INT24_LE = exports.INT16_LE = exports.INT16_BE = exports.INT8 = exports.UINT32_BE = exports.UINT32_LE = exports.UINT24_BE = exports.UINT24_LE = exports.UINT16_BE = exports.UINT16_LE = exports.UINT8 = void 0;
const ieee754 = __webpack_require__(80645);
// Primitive types
function dv(array) {
    return new DataView(array.buffer, array.byteOffset);
}
/**
 * 8-bit unsigned integer
 */
exports.UINT8 = {
    len: 1,
    get(array, offset) {
        return dv(array).getUint8(offset);
    },
    put(array, offset, value) {
        dv(array).setUint8(offset, value);
        return offset + 1;
    }
};
/**
 * 16-bit unsigned integer, Little Endian byte order
 */
exports.UINT16_LE = {
    len: 2,
    get(array, offset) {
        return dv(array).getUint16(offset, true);
    },
    put(array, offset, value) {
        dv(array).setUint16(offset, value, true);
        return offset + 2;
    }
};
/**
 * 16-bit unsigned integer, Big Endian byte order
 */
exports.UINT16_BE = {
    len: 2,
    get(array, offset) {
        return dv(array).getUint16(offset);
    },
    put(array, offset, value) {
        dv(array).setUint16(offset, value);
        return offset + 2;
    }
};
/**
 * 24-bit unsigned integer, Little Endian byte order
 */
exports.UINT24_LE = {
    len: 3,
    get(array, offset) {
        const dataView = dv(array);
        return dataView.getUint8(offset) + (dataView.getUint16(offset + 1, true) << 8);
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint8(offset, value & 0xff);
        dataView.setUint16(offset + 1, value >> 8, true);
        return offset + 3;
    }
};
/**
 * 24-bit unsigned integer, Big Endian byte order
 */
exports.UINT24_BE = {
    len: 3,
    get(array, offset) {
        const dataView = dv(array);
        return (dataView.getUint16(offset) << 8) + dataView.getUint8(offset + 2);
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint16(offset, value >> 8);
        dataView.setUint8(offset + 2, value & 0xff);
        return offset + 3;
    }
};
/**
 * 32-bit unsigned integer, Little Endian byte order
 */
exports.UINT32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getUint32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setUint32(offset, value, true);
        return offset + 4;
    }
};
/**
 * 32-bit unsigned integer, Big Endian byte order
 */
exports.UINT32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getUint32(offset);
    },
    put(array, offset, value) {
        dv(array).setUint32(offset, value);
        return offset + 4;
    }
};
/**
 * 8-bit signed integer
 */
exports.INT8 = {
    len: 1,
    get(array, offset) {
        return dv(array).getInt8(offset);
    },
    put(array, offset, value) {
        dv(array).setInt8(offset, value);
        return offset + 1;
    }
};
/**
 * 16-bit signed integer, Big Endian byte order
 */
exports.INT16_BE = {
    len: 2,
    get(array, offset) {
        return dv(array).getInt16(offset);
    },
    put(array, offset, value) {
        dv(array).setInt16(offset, value);
        return offset + 2;
    }
};
/**
 * 16-bit signed integer, Little Endian byte order
 */
exports.INT16_LE = {
    len: 2,
    get(array, offset) {
        return dv(array).getInt16(offset, true);
    },
    put(array, offset, value) {
        dv(array).setInt16(offset, value, true);
        return offset + 2;
    }
};
/**
 * 24-bit signed integer, Little Endian byte order
 */
exports.INT24_LE = {
    len: 3,
    get(array, offset) {
        const unsigned = exports.UINT24_LE.get(array, offset);
        return unsigned > 0x7fffff ? unsigned - 0x1000000 : unsigned;
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint8(offset, value & 0xff);
        dataView.setUint16(offset + 1, value >> 8, true);
        return offset + 3;
    }
};
/**
 * 24-bit signed integer, Big Endian byte order
 */
exports.INT24_BE = {
    len: 3,
    get(array, offset) {
        const unsigned = exports.UINT24_BE.get(array, offset);
        return unsigned > 0x7fffff ? unsigned - 0x1000000 : unsigned;
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint16(offset, value >> 8);
        dataView.setUint8(offset + 2, value & 0xff);
        return offset + 3;
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getInt32(offset);
    },
    put(array, offset, value) {
        dv(array).setInt32(offset, value);
        return offset + 4;
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getInt32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setInt32(offset, value, true);
        return offset + 4;
    }
};
/**
 * 64-bit unsigned integer, Little Endian byte order
 */
exports.UINT64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigUint64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setBigUint64(offset, value, true);
        return offset + 8;
    }
};
/**
 * 64-bit signed integer, Little Endian byte order
 */
exports.INT64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigInt64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setBigInt64(offset, value, true);
        return offset + 8;
    }
};
/**
 * 64-bit unsigned integer, Big Endian byte order
 */
exports.UINT64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigUint64(offset);
    },
    put(array, offset, value) {
        dv(array).setBigUint64(offset, value);
        return offset + 8;
    }
};
/**
 * 64-bit signed integer, Big Endian byte order
 */
exports.INT64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigInt64(offset);
    },
    put(array, offset, value) {
        dv(array).setBigInt64(offset, value);
        return offset + 8;
    }
};
/**
 * IEEE 754 16-bit (half precision) float, big endian
 */
exports.Float16_BE = {
    len: 2,
    get(dataView, offset) {
        return ieee754.read(dataView, offset, false, 10, this.len);
    },
    put(dataView, offset, value) {
        ieee754.write(dataView, value, offset, false, 10, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 16-bit (half precision) float, little endian
 */
exports.Float16_LE = {
    len: 2,
    get(array, offset) {
        return ieee754.read(array, offset, true, 10, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, true, 10, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 32-bit (single precision) float, big endian
 */
exports.Float32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getFloat32(offset);
    },
    put(array, offset, value) {
        dv(array).setFloat32(offset, value);
        return offset + 4;
    }
};
/**
 * IEEE 754 32-bit (single precision) float, little endian
 */
exports.Float32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getFloat32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setFloat32(offset, value, true);
        return offset + 4;
    }
};
/**
 * IEEE 754 64-bit (double precision) float, big endian
 */
exports.Float64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getFloat64(offset);
    },
    put(array, offset, value) {
        dv(array).setFloat64(offset, value);
        return offset + 8;
    }
};
/**
 * IEEE 754 64-bit (double precision) float, little endian
 */
exports.Float64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getFloat64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setFloat64(offset, value, true);
        return offset + 8;
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, big endian
 */
exports.Float80_BE = {
    len: 10,
    get(array, offset) {
        return ieee754.read(array, offset, false, 63, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, false, 63, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, little endian
 */
exports.Float80_LE = {
    len: 10,
    get(array, offset) {
        return ieee754.read(array, offset, true, 63, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, true, 63, this.len);
        return offset + this.len;
    }
};
/**
 * Ignore a given number of bytes
 */
class IgnoreType {
    /**
     * @param len number of bytes to ignore
     */
    constructor(len) {
        this.len = len;
    }
    // ToDo: don't read, but skip data
    get(array, off) {
    }
}
exports.IgnoreType = IgnoreType;
class Uint8ArrayType {
    constructor(len) {
        this.len = len;
    }
    get(array, offset) {
        return array.subarray(offset, offset + this.len);
    }
}
exports.Uint8ArrayType = Uint8ArrayType;
class BufferType {
    constructor(len) {
        this.len = len;
    }
    get(uint8Array, off) {
        return Buffer.from(uint8Array.subarray(off, off + this.len));
    }
}
exports.BufferType = BufferType;
/**
 * Consume a fixed number of bytes from the stream and return a string with a specified encoding.
 */
class StringType {
    constructor(len, encoding) {
        this.len = len;
        this.encoding = encoding;
    }
    get(uint8Array, offset) {
        return Buffer.from(uint8Array).toString(this.encoding, offset, offset + this.len);
    }
}
exports.StringType = StringType;
/**
 * ANSI Latin 1 String
 * Using windows-1252 / ISO 8859-1 decoding
 */
class AnsiStringType {
    constructor(len) {
        this.len = len;
    }
    static decode(buffer, offset, until) {
        let str = '';
        for (let i = offset; i < until; ++i) {
            str += AnsiStringType.codePointToString(AnsiStringType.singleByteDecoder(buffer[i]));
        }
        return str;
    }
    static inRange(a, min, max) {
        return min <= a && a <= max;
    }
    static codePointToString(cp) {
        if (cp <= 0xFFFF) {
            return String.fromCharCode(cp);
        }
        else {
            cp -= 0x10000;
            return String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    static singleByteDecoder(bite) {
        if (AnsiStringType.inRange(bite, 0x00, 0x7F)) {
            return bite;
        }
        const codePoint = AnsiStringType.windows1252[bite - 0x80];
        if (codePoint === null) {
            throw Error('invaliding encoding');
        }
        return codePoint;
    }
    get(buffer, offset = 0) {
        return AnsiStringType.decode(buffer, offset, offset + this.len);
    }
}
exports.AnsiStringType = AnsiStringType;
AnsiStringType.windows1252 = [8364, 129, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352,
    8249, 338, 141, 381, 143, 144, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732,
    8482, 353, 8250, 339, 157, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168,
    169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184,
    185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200,
    201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216,
    217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
    233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
    248, 249, 250, 251, 252, 253, 254, 255];


/***/ }),

/***/ 57632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ esm_browser_v4)
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ const esm_browser_v4 = (v4);

/***/ }),

/***/ 42480:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 24654:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 4059:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 17156:
/***/ ((module) => {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 38416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ ((module) => {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75263:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 42122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(38416);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93967:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 30907:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 29388:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createSuper)
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61120);
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78814);
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82963);



function _createSuper(t) {
  var r = (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return function () {
    var e,
      o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
    if (r) {
      var s = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, e);
  };
}


/***/ }),

/***/ 4942:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 61120:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _getPrototypeOf)
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 60136:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _inherits)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 78814:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _isNativeReflectConstruct)
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ 59199:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _iterableToArray)
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 25267:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 1413:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectSpread2)
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 45987:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutProperties)
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 82963:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _possibleConstructorReturn)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 89611:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 84506:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _toArray)
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83878);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59199);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40181);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25267);




function _toArray(r) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(r) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 74902:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 83997:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 74038:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 35062:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 87406:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _asyncToGenerator)
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ 19945:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 70072:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70871);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 38389:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70871);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 56369:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 20264:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _iterableToArray)
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 28339:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 81549:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectSpread2)
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38389);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 73009:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _objectWithoutProperties)
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 89255:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _regeneratorRuntime)
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/OverloadYield.js
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regenerator.js

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsyncIterator.js


function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsyncGen.js


function _regeneratorAsyncGen(r, e, t, o, n) {
  return new AsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsync.js

function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js

function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable");
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js







function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: AsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}


/***/ }),

/***/ 69222:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(35062);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(63915);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(28339);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 33641:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(74038);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(20264);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(63915);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 70871:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 80331:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 63915:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74038);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 25431:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

// EXTERNAL MODULE: ./node_modules/decode-uri-component/index.js
var decode_uri_component = __webpack_require__(93696);
// EXTERNAL MODULE: ./node_modules/split-on-first/index.js
var split_on_first = __webpack_require__(33920);
// EXTERNAL MODULE: ./node_modules/filter-obj/index.js
var filter_obj = __webpack_require__(85252);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js




const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : (value === null ? value : decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return (0,decode_uri_component/* default */.Z)(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = (0,split_on_first/* default */.Z)(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options));
		formatter(decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? keysSorter(value) : value;
		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = (0,split_on_first/* default */.Z)(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: (0,filter_obj/* includeKeys */.T)(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js


/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 5121:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ lib_axios)
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": () => (hasBrowserEnv),
  "hasStandardBrowserEnv": () => (hasStandardBrowserEnv),
  "hasStandardBrowserWebWorkerEnv": () => (hasStandardBrowserWebWorkerEnv)
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ const utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ const helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ const defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ const classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ const classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ const classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ const browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ const platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ const lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ const core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ const cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ const cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ const isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ const adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.6.8";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const lib_axios = (axios);


/***/ }),

/***/ 93696:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ decodeUriComponent)
/* harmony export */ });
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}


/***/ }),

/***/ 85252:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ includeKeys)
/* harmony export */ });
/* unused harmony export excludeKeys */
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}


/***/ }),

/***/ 31955:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ api)
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ 33920:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ splitOnFirst)
/* harmony export */ });
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}


/***/ }),

/***/ 97582:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__addDisposableResource": () => (/* binding */ __addDisposableResource),
/* harmony export */   "__assign": () => (/* binding */ __assign),
/* harmony export */   "__asyncDelegator": () => (/* binding */ __asyncDelegator),
/* harmony export */   "__asyncGenerator": () => (/* binding */ __asyncGenerator),
/* harmony export */   "__asyncValues": () => (/* binding */ __asyncValues),
/* harmony export */   "__await": () => (/* binding */ __await),
/* harmony export */   "__awaiter": () => (/* binding */ __awaiter),
/* harmony export */   "__classPrivateFieldGet": () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   "__classPrivateFieldIn": () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   "__classPrivateFieldSet": () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   "__createBinding": () => (/* binding */ __createBinding),
/* harmony export */   "__decorate": () => (/* binding */ __decorate),
/* harmony export */   "__disposeResources": () => (/* binding */ __disposeResources),
/* harmony export */   "__esDecorate": () => (/* binding */ __esDecorate),
/* harmony export */   "__exportStar": () => (/* binding */ __exportStar),
/* harmony export */   "__extends": () => (/* binding */ __extends),
/* harmony export */   "__generator": () => (/* binding */ __generator),
/* harmony export */   "__importDefault": () => (/* binding */ __importDefault),
/* harmony export */   "__importStar": () => (/* binding */ __importStar),
/* harmony export */   "__makeTemplateObject": () => (/* binding */ __makeTemplateObject),
/* harmony export */   "__metadata": () => (/* binding */ __metadata),
/* harmony export */   "__param": () => (/* binding */ __param),
/* harmony export */   "__propKey": () => (/* binding */ __propKey),
/* harmony export */   "__read": () => (/* binding */ __read),
/* harmony export */   "__rest": () => (/* binding */ __rest),
/* harmony export */   "__rewriteRelativeImportExtension": () => (/* binding */ __rewriteRelativeImportExtension),
/* harmony export */   "__runInitializers": () => (/* binding */ __runInitializers),
/* harmony export */   "__setFunctionName": () => (/* binding */ __setFunctionName),
/* harmony export */   "__spread": () => (/* binding */ __spread),
/* harmony export */   "__spreadArray": () => (/* binding */ __spreadArray),
/* harmony export */   "__spreadArrays": () => (/* binding */ __spreadArrays),
/* harmony export */   "__values": () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 71951:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"Tab_Design":"设计","Button_Send":"发送","Input_Describe_Workspace":"输入一句话AI帮你做图","Tab_AgentCase":"Agent 案例","Tab_RecentCreations":"最近打开","Tag_Hot":"热门","Tag_BrandDesign":"品牌设计","Tag_Logo":"Logo","Tag_Posters":"海报设计","Tab_Agent":"Agent","Tool_AiPhotoEditor":"图片编辑","Button_Upload":"上传","Tool_Designer":"创建设计","Title_AiTool":"AI工具","Tool_ImageBackgroundRemover":"智能抠图","Tool_AiBackgroundGenerator":"AI背景生成","Tool_ImageEnhancer":"变清晰","Tool_AiObjectsRemover":"AI消除","Tool_AiModelMannequin":"AI模特","Tool_AiModelFlatlay":"AI试衣","Tool_AiImageRecolor":"服装换色","Tool_AiImageExtender":"AI扩图","Tool_ImageUpscaler":"无损改尺寸","Tool_AiLogo":"AI Logo","Button_BlankCanvas":"创建画布","Sidebar_Create":"主页","Sidebar_Tools":"AI工具箱","Sidebar_Batch":"批处理","Sidebar_MyDesigns":"我的设计","Sidebar_Inspire":"灵感广场","Sidebar_Brand":"品牌库","Sidebar_PackUp":"收起菜单","Tag_All":"全部","Tag_Design":"设计","Sidebar_Unfold":"展开菜单","Menu_Edit":"编辑","Menu_Download":"下载","Menu_Delete":"删除","Tab_RecentlyCreated":"最近创作","Tab_GenerateRecords":"生成记录","Menu_Total":"合计","Menu_Total_Explain_AgentCredits":"仅可在AI Agent中使用，优先消耗","Menu_DueToday":"今日到期","Menu_DueToday_Explain":"每日会自动更新","Menu_Else_AgentCredits":"其他积分","Button_GoPro_GetMore":"获得更多积分","Menu_Total_Explain_PaidCredits":"会员阶段可以在所有功能里使用","Menu_Pro":"会员积分","Menu_Pro_Explain":"会员专属赠送，会员有效期内可用","Menu_Else":"其他积分","Menu_Else_Explain_PaidCredits":"其他来源获得，有效期视来源而定","Menu_Else_Explain_AgentCredits":"其他渠道获得，有效期更长","Menu_UsageDetail":"使用详情","Menu_Total_Explain_SuspendCredits":"已暂停使用重新激活会员后可使用","Tab_Invite":"邀请","Menu_InviteReward":"邀请好友奖励","Tab_Reward":"奖励","Title_AgentCreditForRewards":"奖励的Agent credit：","Table_Time":"时间","Table_Invitee":"被邀请者","Title_ShareWithFriends":"分享给您的朋友","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">每邀请1位新朋友，您和朋友都可以获得</span><span style=\\"color:#2D990C;\\">${0} 个Agent 积分</span>","Title_InvitationLink":"用此链接邀请","Button_Copy":"复制","Title_Tips":"提示：","Title_Tips_ExplainOne":"1.Agent 积分只能在 AI Agent中使用.邀请奖励的Agent积分有效期为两年.","Title_Tips_ExplainTwo":"2.新朋友需要注册成功后会发放奖励，如有问题，请联系支持团队.","Title_GetRewarded":"获得邀请奖励","Title_GetRewarded_Explain":"仅在AI Agent中使用,有效期为两年","Button_Ok":"好的","Title_FailedToReceiveReward":"获得奖励失败","Title_FailedToReceiveReward_Explain":"如有问题，请联系支持团队","Input_Describe_workspace":"输入一句话AI帮你做图","Tool_AiBackgroundGenrator":"AI背景生成","Title_YouCannotUseYourOwnLink":"不能使用自己的邀请链接","Table_AgentCredit":"Agent 积分","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">您最多可邀请</span><span style=\\"color:#2D990C;\\">${0}个新朋友 </span><span style=\\"color:#616266;\\">，即最高可获得${1}个Agent 积分</span>","Button_Invite":"邀请","Menu_Title_Invite":"邀请好友","Text_Button_Invite":"赚取积分","Title_Dialog_Invite":"邀请好友","Desc_Dialog_Invite":"在社交媒体或与朋友分享您的专属链接。当朋友通过您的链接注册时，双方均可获得 ${0} 积分。如果他们订阅了套餐，双方还将额外获得最高 ${1} 积分。    ","Detail_Dialog_Invite":"详情","Text_Copy_Invite":"复制链接","Title_Rewards_Invite":"奖励","SubTitle_Rewards1_Invite":"累计获得积分","SubTitle_Rewards2_Invite":"邀请免费用户","SubTitle_Rewards3_Invite":"邀请付费用户","Success_Copy_Invite":"链接已复制","Title1_Invited_Invite":"您已收到邀请！","Text_Rule1_Invite":"每邀请一位朋友使用您的链接注册，双方均可获得 <strong>${0} 积分</strong>。","Text_Rule2_Invite":"如果您的朋友订阅了套餐，双方均可获得额外积分（<strong>Plus 套餐 ${0} 积分，Pro 套餐 ${1} 积分</strong>）。","Text_Rule3_Invite":"如果订阅套餐内包含的权益已被使用，或赠送的积分已被消耗，购买的订阅将无法退款。同时，免费积分一旦使用也无法撤回。","Text_Rule4_Invite":"每个用户最多可邀请 ${0} 位朋友。","Text_Rule5_Invite":"奖励不适用于已有账号、自推荐、重复账号或涉嫌欺诈性活动的邀请。","Text_Rule6_Invite":"${0} 保留调整本计划及收回异常账号奖励的权利。","Text_Divider_Invite":"或分享链接","Title2_Invited_Invite":"加入 ${0} 领取您的奖励","SubTitle1_Invited_Invite":"一位朋友邀请您体验我们专业的品牌 AI Agent。轻松创建高质量的品牌营销设计，如 Logo、海报、菜单以及社交媒体素材。  ","SubTitle2_Invited_Invite":"<strong>立即注册</strong>，您和您的朋友都将<strong>获得 ${0} 积分</strong>。<strong> 如果您订阅了套餐，</strong>双方还将根据您选择的计划获得额外积分（<strong>Plus 套餐 ${1} 积分 或 Pro 套餐 ${2} 积分</strong>）。立即注册以领取您的奖励。","Button_Invited_Invite":"注册领取奖励","Success_Invited_Invite":"您通过邀请链接加入，已获得 ${0} 积分。","Error_Invited_Invite":"您已经拥有一个账号。","Text_Share_Invite":"我一直在使用 ${0} 快速创建 Logo、视觉图和视频。使用我的链接注册，我们都将获得奖励积分。","Title_Share_Invite":"加入 ${0}，一起赚取积分！","Share_Email_Invite":"邮箱","Text_Rule7_Invite":"您可将积分用于 AI Agent。积分的有效期为一个月。  ","Title_AgentCredits":"+50 Agent 积分","Input_Models":"模型","Button_TryItNow":"做同款","Account_Pricing":"会员套餐和价格","Account_Language":"语言","Account_Language_English":"英文","Account_Language_Chinese":"中文","Tips_Adding":"添加中...","Tips_Loading":"加载中...","Tips_Creating":"正在创建中...","Tips_Downloading":"正在下载中...","Tips_Sending":"正在发送中...","Tips_AddSuccess":"添加成功","Tips_MakeSameError":"系统不支持，无法做同款","Tips_UnsupportedGradientColor":"不支持渐变色","Tips_CanNotAdding":"无法添加","Tips_Uninitialized":"未初始化，无法发送","Tips_UploadFailed":"上传失败，请重试","Tips_UploadMaxCountLimit":"最多允许上传 ${n} 个${type}文件","Tips_UploadMaxFileSize":"无法上传 ${file}，最大允许上传 ${n}MB 的文件","Tips_UploadImageAndVideoLimit":"仅支持单张图片和视频混合上传哦～","Tips_UnsupportedSvgFile":"不支持 SVG 文件","Tips_UnsupportedUploadFileFormats":"不支持上传的文件格式 ${files}","Tips_CanNotAddSameFileTips":"已有相同文件存在，无法添加","Tips_TextMinLengthTips":"至少需要输入 ${n} 个字符","Tips_TextMaxLengthTips":"最多允许输入 ${n} 个字符，其中中文和 Emoji 算 2 个字符","Tips_AccessDenied":"没有权限访问","Tips_CreateFailed":"对话创建失败","Tips_Error":"出错啦！","Tips_NotFound":"对话不存在","Tips_RequestAgentModelListError":"Agent 模型列表获取失败","Desc_Ended":"结束","Button_PeopleUse_Agent":"${n} 人使用","Dropdown_AddToChat":"添加到聊天","Dropdown_AddToBrandKit":"添加到品牌","Dropdown_SaveToBrandKit":"保存为品牌 logo","Dropdown_SaveToBrandTemplate":"保存为品牌模板","Title_Design_Agent":"设计","Title_MainColor":"主色","Title_SecondaryColor":"辅助色","Bitton_ViewTheBrandKit":"点击查看品牌资产库","Dropdown_InportImages":"导入图片","Title_Upgrade_Pro":"升级计划","Desc_SubscribeToUnlock_Pro":"现在订阅解锁更多","Desc_RunOutOfFreeUses_Pro":"对不起，您已经没有免费的使用了","Desc_RunOutOfUsesForToday_Pro":"今天没有剩余的免费使用了，请明天再来","Desc_PurchaseCompleted_Pro":"购买成功","Desc_ContinueDesign_Pro":"准备就绪了，尽情使用吧","Button_UnlockNow":"立即解锁","Tips_Copied":"已复制！","Tips_Credit_Explain_Paid":"什么是付费积分","Title_Total_InactiveCredits":"合计 - 冻结积分","Title_Total_PaidCredits":"合计 - 付费积分","Menu_SuspendCredits":"冻结积分","Menu_Credits":"积分","Tab_RecentCreations_Agent":"Agent","Tab_RecentCreations_Design":"智能工具","Menu_FunctionalPricing":"Agent功能定价","Title_Total_AgentCredits":"合计 - Agent积分","Tips_Credit_Explain_Agent":"什么是Agent积分","Title_FeaturePricing":"Agent功能定价","Tab_Category":"大类","Tab_TaskType":"任务类型","Tab_Consume":"消耗美豆","Tab_ExampleContent":"内容举例","Tips_CreditExplain_Inactive":"什么是冻结积分","langding_more_bg_remover":"智能抠图","langding_more_enhancer":"变清晰","langding_more_objects_remover":"AI消除","langding_more_bg_generator":"AI背景生成","Title_More1_Home":"变清晰","Title_More2_Home":"智能消除","Title_More3_Home":"AI商品图","Title_More4_Home":"智能抠图","Title_More5_Home":"批量编辑器","Title_Home":"你的<span>电商</span>设计AI助手","Placeholder_Input_Home":"描述下你的想法，我会来帮你创作…","Title_Card4_Home":"一句话生成亚马逊套图","Title_Card1_Home":"服装首饰试穿套图生成","Title_Card3_Home":"商品详情图生成","Title_Card2_Home":"智能换背景","Desc_Features1_Home":"AI自动提炼品类特征与风格偏好，构思最合适的设计方案。","Desc_Features2_Home":"只需输入一句话，AI自动生成整套电商图片，从主图、副图到详情页一次搞定。","Text_Btn_Home":"免费开始","Desc_Features3_Home":"自动匹配 Amazon、Etsy、TEMU、eBay 等平台规范与流量偏好，生成符合各平台标准的专属视觉套组。","Desc_Features4_Home":"输入一句话即可可智能转换语言、模特、色调与文化视觉，自动生成多国家本地化版本。","Desc_Features5_Home":"作图流程可一键保存为配方并复用，AI自动批量生成所有SKU图片。","Desc_Features6_Home":"无论是10款还是1000款商品，都能一键完成整套视觉。","Title_Qualification_Home":"超500万电商卖家都在用","Text_Btn_Qualification_Home":"查看资质","Title_Carousel_Home":"更多AI工具","Title_Footer_Home":"你的电商设计助手","Title_Footer1_Home":"官方社媒","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"支持与服务","Subtitle_Footer5_Home":"服务条款","Subtitle_Footer6_Home":"隐私政策","Copyright_Footer_Home":"版权 ${0} 美图（中国）有限公司","Desc_Evaluation1_Home":"我真的很喜欢 Designkit！AI 生成的生活方式图片看起来很自然——温馨、北欧风，非常适合我的香薰蜡烛店。我店铺的商品图变得更专业了，销售额也有所提升。总之物超所值。","Job_Evaluation5_Home":"TEMU 墨西哥卖家","Job_Evaluation6_Home":"亚马逊运营","Job_Evaluation12_Home":"Amazon 印尼多 SKU 店铺店长","Job_Evaluation2_Home":"亚马逊 & Mercado Libre 店主","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"生成的生活方式场景图挺自然，看起来像拍出来的一样，客户也比较喜欢，转化率有提升。","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Lazada & Shopee 印尼跨境店主","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"独立站 设计师","Job_Evaluation8_Home":"Walmart 美国户外店主","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Mercado Libre 阿根廷卖家","Desc_Evaluation7_Home":"生成的宠物用品场景挺可爱的，猫狗比例自然，不会怪怪的。而且尺寸比例基本符合 ML 平台的要求，用起来挺方便的。","Job_Evaluation7_Home":"Mercado Livre 巴西店铺老板","Desc_Evaluation8_Home":"我卖帐篷，用它生成的露营场景挺真实，光线和角度都挺自然，比例也没问题。总体来说，比自己拍摄省了不少时间。","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"这个工具用起来挺快的，生成的图基本可以直接上传到美客多和亚马逊，不用再调来调去。","Desc_Evaluation6_Home":"我以前最担心 AI 会改掉衣服材质，但它几乎完全保持了原样。针织是针织，牛仔是牛仔，也符合亚马逊主图规范，新品上架效率提升了不少。","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"AI 做的产品图挺准的，数据线的长度、接口形状都保持得很好，还能适配 TEMU 的风格，整体上比自己拍图省事很多。","Desc_Evaluation12_Home":"只需要一句话就能生成可用素材，比以前等设计师出图快太多了，挺省心的。","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"金属材质和结构细节都很清楚，整体感觉挺专业的，生成的图直接能用。","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"批量生成很方便，几十个 SKU 一次性搞定，比以前自己做快多了。","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"我是卖服装的，原本担心 AI 会把颜色或布料质感弄得不真实，但结果非常出乎意料！模特姿势很自然，基本上出图就能立即上架使用了。","Job_Evaluation1_Home":"SHEIN 店铺运营","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"亚马逊运营专员","Desc_Evaluation2_Home":"这个工具非常快速，生成的图片几乎可以直接上传到 Mercado Libre 或 Amazon。它甚至会根据当地喜好调整背景和模特，效果非常专业。","Job_Evaluation4_Home":"eBay 德国卖家","Title_Evaluation_Home":"来自我们Designkit社区的故事","Title_Introduction_Home":"更高效、更专业的AI设计工具，助力你成为电商大卖","Desc_Qualification_Home":"亚马逊SPN认证服务商","Title_Seo_Home":"适用于电商的AI产品图像和视频生成器","Desc_Seo_Home":"使用 Designkit 的 AI 智能助手，即可立即为亚马逊、TikTok 等在线商店生成产品图片、海报和视频。立即开始免费设计！<br>","Keywords_Seo_Home":"电商AI代理、电商AI工具、AI产品图片生成器、AI产品视频生成器、AI产品照片编辑器、AI背景去除","Title_Features1_Home":"一句话即可做一整套电商物料图","Title_Features2_Home":"一句话卖全球，多平台多国家全自动本地化","Title_Features3_Home":"多SKU也可批量自动划出图，上新变得更高效","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"向下滚动探索","Tips_Material1_Home":"电商套图","Tips_Material2_Home":"服饰穿戴","Tips_Material3_Home":"A+ 详情页","Tips_Material4_Home":"商品换背景","Free_Button_Home":"免费试用","Title_Header1_Home":"功能","Title_Header2_Home":"解决方案","Title_Header3_Home":"灵感","Title_Header4_Home":"学习","Title_Header5_Home":"价格","SecondTitle_Header1_Home":"AI电商设计Agent","SecondTitle_Header2_Home":"AI图片工具","SecondTitle_Header3_Home":"AI视频工具","SecondTitle_Header4_Home":"亚马逊设计解决方案","SecondTitle_Header5_Home":"社媒电商解决方案","SecondTitle_Header6_Home":"AI 商品图生成器","SecondTitle_Header7_Home":"AI 服装模特生成器","SecondTitle_Header8_Home":"衣服换色","SecondTitle_Header9_Home":"商品视频生成器","SecondTitle_Header10_Home":"AI 工具","SecondTitle_Header11_Home":"AI 图片编辑器","SecondTitle_Header12_Home":"在线 AI 图片编辑器","SecondTitle_Header13_Home":"批量图片编辑器","SecondTitle_Header14_Home":"批量 AI 图片编辑器","SecondTitle_Header15_Home":"批量变清晰","SecondTitle_Header16_Home":"批量去水印","SecondTitle_Header17_Home":"批量背景生成","SecondTitle_Header18_Home":"批量智能抠图","Title_Footer3_Home":"设计工具","Subtitle_Footer8_Home":"AI 图片编辑器","Subtitle_Footer7_Home":"AI 换背景","Subtitle_Footer9_Home":"透明背景","Subtitle_Footer10_Home":"更换背景颜色","Subtitle_Footer11_Home":"图片去水印","Subtitle_Footer12_Home":"移除图片文字","Subtitle_Footer13_Home":"照片加贴纸","Subtitle_Footer14_Home":"照片加水印","Title_Footer4_Home":"图片模型","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"免费下载","Subtitle_Footer16_Home":"iOS APP","Subtitle_Footer17_Home":"Android APP","Title_Footer6_Home":"关注我们","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"视频模型","Button_Export":"下载","Title_Layer":"图层","InputNumber_Opacity":"不透明度","Buttom_Comfirm":"确定","Button_Share":"分享","Button_Delete":"删除","Title_LoginPopup":"  登录解锁免费试用","SubTitle_LoginPopup":"立即开始使用 Zawa 创作","Tip_ModalTitle":"提示","TipContent_HistoryDelete":"删除后，该记录将不可恢复，确认删除吗？","Title_Logo":"Logo","Title_BrandKit":"品牌模板","Tab_BrandKit":"品牌资产","Tab_UploadLocal":"本地上传","Button_UploadImage":"上传图片","Button_UploadProductImage":"上传产品图","Button_UploadReferImage":"上传参考图","Tip_ClickDragParseImage":"点击/拖拽/粘贴图片至此处","Tip_UploadMax":"支持上传${0}M以内JPG、JPEG、PNG，最多支持N张","Tooltip_SwitchBrandKit":"切换品牌库","Discribe_BrandKitSelect":"选择对应品牌后，本次会话将参考其品牌规范进行设计～","Title_Models":"模型","Switch_Auto":"自动","Tab_Image":"图片","Tab_Video":"视频","MenuItem_AddToBrandLogo":"添加为品牌Logo","MenuItem_AddToBrandTemplate":"添加为品牌模板","Button_ExportImage":"导入图片","Button_ExportMedia":"导入视频","Button_ExportFromBrandkit":"从资产库中导入","Dropdown_AddFromBrandkit":"从资产库中添加","Placeholder_ChatInput":"和我一起玩图吧～","MenuItem_AiChange":"AI改图","MenuItem_AiExpend":"AI扩图","MenuItem_AiHD":"AI超清","MenuItem_Eliminate":"AI无痕消除","MenuItem_SplitLayers":"拆分图层","MenuItem_Cutout":"抠图","MenuItem_ChangeText":"无痕改字","MenuItem_Crop":"调整尺寸","MenuItem_AddToChat":"添加到聊天","MenuItem_AddToBrand":"添加到品牌库","Tooltip_Layer":"图层","Tooltip_Grab":"抓手","Tooltip_Select":"选择","Tooltip_Redo":"重做","Tooltip_Undo":"撤销","Tooltip_Add":"添加","Tooltip_ShowAll":"显示全部","Tip_UploadType":"文件格式不支持","Tip_UploadSize":"仅支持${0}MB以内的文件","Tip_UploadWH":"仅支持宽高均为${0} * ${1}以内的图片","Tip_UploadTypeTranslate":"文件格式转换错误","Tip_UploadFail":"文件上传失败","Tooltip_AddText":"添加文本","Text_AddDefault":"我是一段文本","Tooltip_OverflowImageSize":"请将图片缩放到${0}px以内","Placeholder_ImageFusion":"将融图灵感发送给我，我来帮你执行","Button_ImageFusion":"融图","Button_Cancel":"取消","Button_AiChange":"改图","Placeholder_AiChange":"将改图灵感发送给我，我来帮你执行","Button_Eliminate":"消除","Label_OriginSize":"原图尺寸","Label_CropRadio":"裁剪比例","Button_Free":"自由","Button_Origin":"原始","Button_Crop":"裁剪","Placeholder_ChangeText":"输入你想修改成的目标文案，如：你好","Button_ChangeText":"改字","InputNumber_PanSize":"笔刷大小","Label_TargetSize":"目标尺寸","Tooltip_ImageFusion":"支持${0}-${1}张图的快速融合","Title_Workspace":"您的品牌设计AI Agent。","Button_Pro":"免费体验Pro版本","Title_NanoPro":"🍌🍌Nano Banana Pro 现已上线 Zawa。","Dropdown_AdvancedFeatures_Title":"高级功能","Dropdown_AdvancedFeatures_Conent":"无限制访问所有 AI 驱动的工具，提升您的效率。","Dropdown_MassiveContent_Title":"海量素材","Dropdown_MassiveContent_Content":"无限制访问高级模板及海量 Plus 级素材库。","Dropdown_CommercialRights_Title":"商业版权","Dropdown_CommercialRights_Content":"安心使用您的个人创作，享有商用版权保护。","Popup_SubscribeIntl_Desc":"开通 Pro 获取 Zawa 最佳体验","Popup_SubscribeIntl_Desc1":"使用积分解锁更多创作权限","Popup_SubscribeIntl_Detail":"查看计划详情及帮助","Popup_StripeCheckout":"Stripe支付","Popup_LiveSupport":"在线客服","Popup_CancelAnytime":"随时取消","Menu_Language":"语言","Menu_ManageSubscription":"订阅管理","Menu_TermsPolices":"服务条款","Menu_ManageSubscriptions":"订阅管理","Menu_ReferralLink":"邀请链接","Menu_BenefitsUpgraded":"权益","Menu_TermsPolicies":"服务条款","Menu_AccountManagement":"账号管理","Title_ReferralCode":"邀请码","Title_ReferralLink":"邀请链接","Desc_NoActiveSubscription":"暂无有效订阅","Button_ClickToSubscibe":"点击订阅","Title_SubscriptionCancel":"您的订阅已取消","Title_SeeYou":"对于您的取消深表遗憾😭","Desc_NextBillingDate":"下一次续费将会在","Desc_EstimatedAmount":"预计扣费金额","Button_CancelSubscription":"取消订阅","Button_StaySubscribed":"继续订阅","Title_ReasonCancelling":"请选择取消订阅的原因：","Desc_BenefitsContinue":"您可以继续享受会员权益","Desc_GiftedCredits":"订阅到期后，赠送的积分","Desc_SeeYou":"感谢你一直以来的支持，我们很遗憾看到你离开。","Desc_NoNoreCharges":"你将不会再次被扣费，你的会员权益将继续有效，直至","Desc_MayBeRevoked":"将会被收回。","Desc_CancelingNoRefund":"取消订阅<span>不包含退款</span>。如需退款，请联系在线客服。","Button_ClearSelection":"清除选区","Button_Confirm":"确认","Message_Processing":"处理中...","Title_Opacity":"透明度","Button_ExpandImage":"扩图","Button_ExpandRadio":"扩图比例","Title_NoDesigns":"暂无设计","Title_NoGenerations":"暂无生成记录","Desc_NoDesigns":"您的设计将显示在此处。","Desc_NoGenerations":"您的生成记录将显示在此处。","Title_DeleteDesign":"删除此设计","Popup_DeleteDesign":"您确定要永久删除此设计吗？该操作无法撤销。","Message_SaveFail":"保存失败","Title_Pricing":"选择适合您的方案","Title_Tags1_Pricing":"按月","Text_Discount_Pricing":"${0}折","Title_Tags2_Pricing":"按年","Title_Plan1_Pricing":"免费","Current_Plan_Pricing":"当前计划","Title_Instruction1_Pricing":"首次登录赠送20积分","Title_Instruction2_Pricing":"使用AI Agent最多生成20张","Title_Instruction3_Pricing":"使用AI商品图最多生成10张","Title_Rights1_Pricing":"限次体验智能抠图","Title_Rights3_Pricing":"限次体验变清晰（高清）","Title_Plan2_Pricing":"基础会员","Month_Plan_Pricing":"月","Title_Button1_Pricing":"立即开通","Title_Instruction4_Pricing":"500积分/月","Title_Instruction5_Pricing":"使用AI Agent最多生成 500 张","Title_Instruction6_Pricing":"AI商品图：最多250张/月","Title_Plan3_Pricing":"高级会员","Desc_Plan_Pricing":"7天免费试用，到期后${0}/年续费","Title_Button2_Pricing":"7天免费试用","Title_Instruction7_Pricing":"1500积分/月","Title_Instruction8_Pricing":"使用AI Agent最多生成 1500 张","Title_Instruction9_Pricing":"AI商品图：最多750张/月","Title_Rights4_Pricing":"无限次使用智能抠图","Title_Rights5_Pricing":"无限次使用AI消除","Title_Rights6_Pricing":"无限次使用变清晰（超清）","Title_Rights7_Pricing":"批量编辑器","Title_Best_Pricing":"90%的人选择","Title_AllFeatures_Pricing":"对比所有方案","Desc_AllFeatures_Pricing":"使用基础会员/高级会员中的先进 AI 工具，轻松创作惊艳设计","Month_AllFeatures_Pricing":"月","Title_Features1_Pricing":"AI Agent","SubTitle_Features1_Pricing":"图片编辑","SubTitle_Features15_Pricing":"最多生成 ${0} 张","SubTitle_Features16_Pricing":"最多生成 ${0} 张/月","SubTitle_Features2_Pricing":"图片生成","SubTitle_Features3_Pricing":"电商套图生成","SubTitle_Features4_Pricing":"海报生成","Title_Features2_Pricing":"AI 图像处理","SubTitle_Features5_Pricing":"智能抠图","SubTitle_Features17_Pricing":"有限次","SubTitle_Features19_Pricing":"无限次","SubTitle_Features6_Pricing":"AI 消除","SubTitle_Features7_Pricing":"变清晰","SubTitle_Features18_Pricing":"有限次（高清）","SubTitle_Features20_Pricing":"无限次（高清/超清）","SubTitle_Features8_Pricing":"无损改尺寸","SubTitle_Features9_Pricing":"AI 扩图","SubTitle_Features10_Pricing":"AI 商品图","Title_Features3_Pricing":"更多设计功能","SubTitle_Features11_Pricing":"高级功能与模板","SubTitle_Features12_Pricing":"去水印下载","SubTitle_Features13_Pricing":"批量编辑器","SubTitle_Features14_Pricing":"基础编辑功能","Title_Credits_Pricing":"  积分快用完了？ 我们帮你搞定","Desc_Credits_Pricing":"按需购买，一次性付费，无需订阅！","TransactionPrice_Credits_Pricing":"价格： ${0}","Credit_Credits_Pricing":"积分","Popular_Credits_Pricing":"最受欢迎","Buy_Credits_Pricing":"立即购买","Title_FAQ_Pricing":"常见问题","Title_Button4_Pricing":"7天免费试用/立即升级","SubTitle_FAQ1_Pricing":"什么是积分?","Content_FAQ1_Pricing":"积分可用于使用AI工具，不同AI工具需要消耗对应的积分","Content_FAQ2_Pricing":"单独购买的积分有效期为1年。","Content_FAQ3_Pricing":"购买会员赠送的积分当月有效。","SubTitle_FAQ2_Pricing":"如何取消订阅?取消后我的积分会怎样","Content_FAQ4_Pricing":"如果您取消订阅:","Content_FAQ5_Pricing":"-会员到期后您的积分也会随之到期，单独购买的积分不受影响。","Content_FAQ6_Pricing":"如需取消订阅，请至少在下一个账单周期开始前24 小时按照以下步骤操作:","Content_FAQ7_Pricing":"- 打开Designkit并登录。","Content_FAQ8_Pricing":"- 打开会员订阅弹窗。","Content_FAQ9_Pricing":"- 选择[管理订阅]。","Content_FAQ10_Pricing":"- 选择您的订阅选项，然后点击【取消订阅】。","Content_FAQ11_Pricing":"您的订阅将持续有效至当前计费周期结束。如果您无法取消订阅，请截图并尽快联系我们的在线客服。","SubTitle_FAQ3_Pricing":"你们的退款政策是什么？","Content_FAQ12_Pricing":"1. 7天退款保证:","SubTitle_FAQ4_Pricing":"如何升级或降级我的订阅？","Content_FAQ25_Pricing":"1. 升级:你可以直接订阅更高档位的会员套餐。新的套餐立即扣费和生效，旧的套餐将按比例退款并解约;","SubTitle_FAQ5_Pricing":"我可以要一份发票副本吗？","Content_FAQ27_Pricing":"是的!付款成功后，您将收到支付服务提供商发送的包含电子发票的电子邮件。如果您没有收到发票，请联系我们的客服团队。","SubTitle_FAQ6_Pricing":"你们支持那些支付方式？","Content_FAQ28_Pricing":"我们使用 Stripe 管理支付和订阅。我们接受所有主流信用卡、PayPal 和 Google Pay。","SubTitle_FAQ7_Pricing":"我该如何联系客服?","Content_FAQ29_Pricing":"请发送邮件至support@designkit.com，回复时间:3-10个工作日","Content_FAQ13_Pricing":"- 如果您购买了会员套餐但7天内未使用，您可能有资格获得全额退款。","Content_FAQ14_Pricing":"- 如果您购买了积分，您可以在7天内申请退还任何未使用的积分。","Content_FAQ15_Pricing":"2. 对服务不满意:","Content_FAQ16_Pricing":"- 如果您对结果不满意，请邮箱联系我们的线客服团队。我们将根据具体情况提供补偿或退款。","Content_FAQ17_Pricing":"3. 通过 Google Play 或 App Store 购买:","Content_FAQ18_Pricing":"- 如果您是通过 Google Play 商店或 App Store 订阅的，则需要直接向 Google 或 Apple 申请退款。","Content_FAQ19_Pricing":"重要提示:","Content_FAQ20_Pricing":"本退款政策不适用于API用户。如果您使用我们的API，请联系我们了解退款资格。","Content_FAQ21_Pricing":"对干滥用、误用或违反我们条款的情况，我们保留拒绝退款的权利。","Content_FAQ22_Pricing":"退款可能需要几个工作日才能处理完毕，具体取决于您的付款方式。","Content_FAQ23_Pricing":"我们可能会不时更新此退款政策。请定期查看以了解任何变更。","Content_FAQ24_Pricing":"如需进一步帮助，请联系我们的支持团队。","Content_FAQ26_Pricing":"2. 降级:您需要先取消当前的订阅，等账单周期结束后在订阅新的套餐。","Content_Modal_Pricing":"感谢您的支持！准备好将您的创造力提升到新的水平。","Tip_Modal_Pricing":"提示：如果您的会员状态未更新显示，请刷新页面。","Title_Modal_Pricing":"购买成功","Title_Rights2_Pricing":"限时体验AI消除","Title_Button3_Pricing":"已解锁权益","Title_Button5_Pricing":"立即升级","Tool_ImageBgRemover":"智能抠图","Tool_AiBgGenerator":"AI背景生成","Tool_AiLogoGenerator":"AI Logo生成器","Tool_FootwearModel":"AI鞋模","Tool_ImageTranslation":"图片翻译","Tool_BatchImageBgRemover":"批量智能抠图","Tool_BatchImageEnhancer":"批量变清晰","Tool_BatchAiObjectsRemover":"批量AI消除","Tool_VideoEnhancer":"视频变清晰","Tool_VideoBgRemover":"视频抠图","Tool_VideoWatermarkRemover":"视频去水印","Title_Models_Dropdown":"模型","Tips_Uninitialized_Chat":"发送消息失败","Tips_Uninitialized_chat":"发送消息失败","Dropdown_AddImage":"添加图片","Action_SeeAll":"查看全部","Desc_Seedream":"生成真实细腻的图像。","Dropdown_AddVideo":"添加视频","Tips_NotFound_Chat":"对话不存在","Desc_Seedance":"生成逼真且具表现力的视频。","Dropdown_SupportedFormatFile":"支持 Word、Excel、TXT 和 PDF 格式文件。","Dropdown_Example_Option":"示例","Dropdown_NoReference_Option":"暂无参考","Menu_AgentCredits":"Agent 积分","Desc_SeedEdit":"精确自然的图像编辑。","Dropdown_BrandKit_Title":"品牌模板","Desc_GeminiNanoBanana":"快速、可编辑且风格一致的图像生成。","Dropdown_Models_Title":"模型","Dropdown_AddDocument":"添加文档","Dropdown_BrandKit_Desc":"选择品牌风格作为此次设计的参考。","Desc_MidjourneyVideo":"创意且具艺术感的视频生成。","Desc_MidjourneyImage":"艺术且富有想象力的图像生成。","Dropdown_SaveAsBrandTemplate":"保存为品牌模板","Dropdown_SaveAsBrandLogo":"保存为品牌Logo","BatchProcessTable_ImageType":"图片类型","BatchProcessTable_PictureRequirement":"画面需求","BatchProcessTable_CopywritingRequirements":"文案需求","BatchProcessTable_Proportion":"画图比例","BatchProcessTable_Actions":"操作","BatchProcessTable_AddOneRow":"新增一行","BatchProcessList_DeleteError":"删除失败","BatchProcessList_SurePrompt":"确认删除这个工作流吗？","BatchProcessList_SurePrompt_SureText":"确认","BatchProcessList_SurePrompt_CancelText":"取消","BatchProcessList_EmptyText":"空","EditBatchProcess_NameLimitTip":"请输入10字内的名称","EditBatchProcess_Tip":"修改下方表格内容，将影响工作流生成图片的结果","EditBatchProcess_Start":"从工作流开始","EditBatchProcess_GenerateTip":"上传商品图，将批量生成每个商品的工作流图片","Text_AdvanceSetting":"专家设置","Text_MainImage":"主图","Text_ProductAgentUploadGuide1":"1. 可上传同一商品的多视角原图，帮助 AI 更准确还原商品细节。","Text_ProductAgentUploadGuide2":"2. 最多支持 10 张图片，第一张将作为主图重点参考，建议选择角度最全的一张。","Text_Optional":"  (可选）","Tip_ClickDragImageWithSize":"拖拽或点击上传JPEG/JPG/PNG，${0}M以内","Button_AddReferenceImage":"上传参考图","Title_ReferenceImage":"参考图","Input_Placeholder":"请选择","Radio_ReferenceColor":"参考配色","Radio_ReferenceLayout":"参考布局","Tag_FirstImage":"首张","Tag_FirstImageNoPartial":"首张非局部","Tag_Blur":"模糊","Tag_Jigsaw":"拼图","Button_Understood":"知道了","Text_ReferenceImageIndex":"第${0}张图为参考图","Text_ReferenceDimensions":"参考的维度是${0}","Tag_Cropped":"已裁剪","Tag_Underexposed":"曝光不足","Tag_Blurry":"模糊","SelectOption_ColorPalette":"调色板","SelectOption_Layout":"布局","SelectOption_Fonts":"字体","SelectOption_Style":"风格","SelectOption_ShapeElements":"形状元素","Text_SocialMediaAgentUploadGuide":"首先上传您的主推商品图，请确保图片清晰完整。","Video_SR_Success":"视频AI超清成功","Video_Desubtitle_Success":"视频去字幕成功","Video_Dewatermark_Success":"视频去水印成功","Video_Process_Failed":"处理失败，请重试！消耗的积分将会原路退回。","Video_SR":"AI超清","Video_Dewatermark":"去水印","Video_Desubtitle":"去字幕","Video_Task_Price_Estimate":"预计消耗${0}","Video_SR_Start":"开始AI超清，消耗${0}美豆","Video_Dewatermark_Start":"开始去水印，消耗${0}美豆","Video_Desubtitle_Start":"开始去字幕，消耗${0}美豆","Video_Desubtitle_Start_VIP":"开始去字幕","Video_Dewatermark_Start_VIP":"开始去水印","Video_SR_Start_VIP":"开始AI超清","Text_Help_Center":"帮助中心","Title_Request":"询问","Button_Continue":"继续","Button_EditContent":"编辑内容","Title_ChooseImageType":"请选择您希望生成的图片类型（可多选）:","Button_BatchGenerate":"已确认，开始执行电商套图批跑流程","Text_ChatCancelStatus":"任务中止","Text_ChatRespondedStatus":"任务执行","BatchProcess_SaveSuccessTip":"套图配方已保存至此处\\n可一键复用","Button_GotIt":"知道了","Title_Congrats":"恭喜","SubTitle_BrandCreate":"您已建立您的首个品牌模板——是时候探索它的潜力了","Button_CheckUse":"立即查看","Chat_Prompt_Brand":"生成促销海报","Tooltip_UseBrand":"您可以在此处切换或添加品牌模板！","Tooltip_PosterBrand":"点击这里，基于您的品牌模板生成第一张海报","Popup_CreateBrand":"从零开始创建品牌","Desc_CreateBrand":"使用我们的 AI Agent 创作令人惊艳的原创 Logo。","Popup_UploadBrand":"上传您的品牌信息","Desc_UploadBrand":"上传品牌信息，Zawa 将确保所有设计保持风格一致。","Title_BrandEntry":"立即获取专属品牌系统","Desc_BrandEntry":"让 AI 成为您的专属设计师。回答几个问题，即可获得符合您设想的完整品牌系统。","Tooltip_UseBrand_Agent":"应用品牌模板后，设计过程将自动参考品牌 Logo、调色板及整体风格。","Tooltip_PosterBrand_Agent":"您已经准备好使用品牌模板进行设计了","BatchProcess_createText":"套图配方","Label_NormalMode":"普通模式：","Label_AdvancedMode":"高级模式：","Text_NormalMode":"普通模式","Text_AdvancedMode":"高级模式","BatchProcess_DefaultPrompt":"帮我生成套图","Title_CreateBrand":"还没有品牌？","Title_UploadBrand":"已经有Logo？","Button_CreateBrand":"创建品牌","BatchProcess_EditContent":"编辑内容","BatchProcess_PleaseSelect":"请选择套图配方","BatchProcess_SelectTip":"选择后将按照选择的套图配方，对所有上传图片进行批量生成～","BatchProcess_ListEmptyTip":"生成套图后可保存配方，一键批量生成同类套图","BatchProcess_Tip":"套图配方","BatchProcess_Generate":"前往生成套图","BatchProcess_Save":"保存","BatchProcess_GeneratingFormula":"正在生成套图配方","BatchProcess_GenerateCancel":"取消","BatchProcess_WorkFlowCreateError":"创建失败","ProductInfo_PleaseUploadImage":"请上传商品图片","BatchProcess_IntelligenceGenerate":"智能生成套图配方表格","BatchProcess_CreateWorkflow":"创建工作流","BatchProcess_Formula":"套图配方","BatchProcess_WorkFlowSaveSuccess":"套图配方已保存成功","ProductInfo_ImageSizeLimit":"图片最大仅支持${0}M~","ProductInfo_ImageUpload":"上传商品图","ProductInfo_UploadDemo":"商品案例上传参考：","ProductInfo_ECPlatform":"电商平台","ProductInfo_PleaseSelect":"请选择","ProductInfo_InputCustomize":"自定义","ProductInfo_CountryAndLanguage":"销售国家/语言","ProductInfo_Name":"商品名称","ProductInfo_Desc":"商品详情（卖点/尺寸/场景）","ProductInfo_DescPlaceholder":"可输入商品相关详细信息，如商品卖点、尺寸规格、期望场景、适用人群等","ProductInfo_NamePrompt":"商品名称是${0}，","ProductInfo_ECPlatformPrompt":"电商平台是${0}，","ProductInfo_CountryAndLanguagePrompt":"国家语言是${0}，","ProductInfo_DescPrompt":"商品详情是${0}，","ProductInfo_PleaseInput":"请输入","Button_UnlockPro":"解锁Pro版本","Button_UpgradeToPro":"升级到Pro版本","Button_RenewNow":"立即续费","AgentEmpty_CaseUseBtn":"使用","AgentEmpty_CaseRefreshBtn":"换一批","MenuItem_Effect":"特效","MenuItem_Shadow":"阴影","MenuItem_Stroke":"描边","Title_ChangeText":"无痕改字","Button_Logout":"退出登录","Message_ExtractText":"提取文字中","Message_ExtractTextError":"文字提取失败，请重试","Tip_CreditConsume":"本次生成将消耗${0}美豆","Tip_EstimatedTime":"预计等待${0}分钟","BatchProcess_SaveSuccessTip_GotIt":"知道了","BatchProcess_SaveSuccessTip_Title":"套图配方指引","BatchProcess_SaveSuccessTip_Desc":"点击这里查看你保存的套图配方，一键复用可生成相似套图","BatchProcess_tutorial":"使用教程","Text_HandTool":"抓手","Text_Function":"功能","Text_WindowsSystem":"Windows系统","Text_MacSystem":"Mac系统","Menu_KeyboardShortcuts":"快捷键","Title_KeyboardShortcuts":"快捷键","Text_Undo":"撤销","Text_MouseLeft":"鼠标左键","Text_Redo":"重做","Text_Delete":"删除","Text_Cut":"剪切","Text_Copy":"复制","Text_Paste":"粘贴","Text_PasteFixed":"固定位置粘贴","Text_CreateCopy":"创建副本","Text_SelectAll":"全选","Text_SelectMultiple":"多选","Text_Group":"成组","Text_Ungroup":"解组","Text_LockLayer":"锁定图层","Text_Save":"保存","Text_Move":"移动","Text_MoveWithCombinedKeys":"快速移动","Text_TouchEditFastMode":"快速标注改图","Text_Pan":"平移","Title_Canvas":"画布","Title_Edit":"编辑","Title_Elements":"元素","Title_Tools":"工具","Title_Blogs":"Blog","Text_NewText":"新建文字","Text_NewLine":"新增直线","Text_NewRectangle":"新建矩形","Text_NewCircle":"新建圆形","Text_ExitFullScreen":"退出全屏","Text_MoveUpOneLayer":"上移一层","Text_MoveDownOneLayer":"下移一层","Text_Top":"置顶","Text_Bottom":"置底","Text_CanvasZoom":"画布缩放","Text_ToggleReferenceLine":"显示/隐藏参考线","Text_ToggleRulerBar":"显示/隐藏标尺","Text_ArrowKey":"方向键","Text_CanvasShowAll":"显示画布全部内容","Title_Unsupported_Multilayer":"该功能暂不支持多图层进入操作～","Btn_CreateBatchProcessFormula":"创建配方","Button_Hide_Otherlayers":"隐藏其他图层仅画布原图进入","Button_Merge_Alllayers":"合并所有图层进入","Checkbox_Disable_Remind":"不再提示","Button_Tool":"工具","Button_Custom_Ratio":"自定比例","Label_Spacing":"间距","Button_Download_Whole":"整图下载","Button_Download_Layer":"分层下载","Button_Origin_Ratio":"原比例","Text_TouchEdit_Title":"使用“标注改图”功能","Text_TouchEdit_Description":"精确指出想要修改的地方，让改图精确又便捷  ","Tooltip_TouchEdit_Max_Count":"最多只能添加${0}个标注","Tooltip_TouchEdit_Usage":"${0} + 点击，快捷标注改图","Text_TouchEdit_Recognition_Custom":"自定义","Text_TouchEdit_Recognition_Title1":"标注识别","Text_TouchEdit_Recognition_Title2":"未识别到物品，请填写","Text_TouchEdit_Name":"标注改图","Btn_LoginToViewBatchProcess":"请登录后查看套图配方","Btn_Login":"立即登录","Menu_Main_Beautify":"美化","Text_Model_Pricing":"模型定价","Text_Pro_discount":"Pro Plan 视频生成半价","Text_TemplatePrompt":"让我们从灵感开始","Text_Hi":"你好，${0}！","Text_Account_Popup_Left":"您值得信赖的电商设计助手 —— 让每一次产品发布都更快、更完美、更盈利。","Text_PleaseWaitImageUploaded":"请等待图片上传完成","Menu_Redeem_Rights":"兑换权益","Text_Redeem_Now":"立即兑换","Text_Redeem_Placeholder":"请输入兑换码，区分大小写","Text_Redeem_Success":"兑换成功！","Text_Redeem_Use":"使用兑换码","Tooltip_BrandAutoUse":"您的新品牌模板已应用！","Redeem_Redeem_Note":"兑换须知：\\n登录用户账号后，输入兑换码即可完成兑换\\n兑换成功后，即可享受对应的权益和服务\\n请在兑换码有效期内使用，过期作废，不可退款\\n请妥善保管，遗失、泄露、登错账号等不补\\n此卡严禁倒卖、转让，不可兑换现金，不支持开发票","Tooltip_Color_Fill":"颜色填充","Tootip_StartPoint":"起始端点","Tootip_ChangePoint":"交换端点","Tootip_EndPoint":"结束端点","Sidebar_NewDesign":"新建对话","Retouch_Filter_Clear":"清透","Retouch_Filter_Enhance":"增色","Retouch_Filter_Dehaze":"去雾","Retouch_Filter_Texture":"质感","Retouch_Filter_Nature":"自然","Retouch_Filter_Fade":"褪色","Modal_Button_Known":"我知道了","Modal_Button_GotIt":"收下","Modal_Button_Later":"再想想","Text_Appeal_Confirm":"确认申诉","Text_Vip_Open":"开通会员","Text_Appeal_ReGenerate":"当前生成结果已二次编辑，不支持效果申诉","Text_Appeal_Left":"本月剩余次数\\n<i>${0}</i>/${1}次","Text_Appeal_Refunded":"美豆已退回至您的美豆账号，请查收。","MenuItem_Appeal":"效果申诉","Tooltip_Downloading":"正在下载中...","Tooltip_Download_Video":"视频仅支持单个下载","Tooltip_Download_NoneSelected":"请先选中想下载的内容","Text_AI_Thinking":"AI 深度思考中...","Text_Server_Busy":"服务器繁忙，请稍后再试","Text_Prompt_Help_Placeholder":"请输入一些关键词，我会帮您扩写成完整的商业提示词","Text_Prompt_Helping":"正在帮写，请稍等...","Button_Retry":"重试","Button_Rewrite":"重写","Button_Start_Prompt_Help":"开始智能优化","Title_Prompt_Helper":"AI 帮写","Menu_Text_Subscriptions":"订阅","Menu_View_Subscriptions":"查看订阅","Text_Download_XdesignApp":"请下载 <span>Zawa</span> APP 以使用该功能","Text_Free_Trial":"下载获取 7 天免费试用","Text_Install_App":"安装 APP","Text_Scan_Download":"扫码下载","Text_Download_the":"下载平台","Text_Available_On":"支持平台","Desc_ExpireDate":"到期时间","DownloadApp_Title_Widgets":"请下载 ${0} APP 以使用该功能","DownloadApp_SubTitle_Widgets":"下载并享受 ${0} 天免费试用","InstallApp_Title_Widgets":"安装 APP","InstallApp_Desc_Widgets":"扫码下载","AppStore_Desc_Widgets":"在 App Store 下载","GooglePlay_Desc_Widgets":"在 Google Play 下载","Text_Tips_GetFree":"获得一次免费体验机会","Text_AgentLib":"资产库","Tip_ModelSetSaveSuccess":"模特已保存，可点击使用","Text_BatchProcess":"套图配方","Button_Add":"添加","Tab_Recent":"最近保存","Tab_Models":"我的模特","Prompt_Model":"第${0}张图是我的模特","Tip_SaveSuccess":"保存成功","Text_ModelsLogin":"请登录后查看模特库","Loading_CheckFace":"正在检测人脸…","Name_InitialModelName":"我的模特","EmptyTip_ModelList":"暂未保存模特，快去创建吧～","Text_UploadModel":"上传我的模特","Text_Model":"模特","Tips_UnsupportedFormat":"不支持的文件格式","Tips_InputModelName":"请输入模特名称","Tips_UploadModelImage":"请上传模特图片","Title_CreateModel":"创建专属模特","Text_ModelName":"模特名称","Placeholder_Input":"请输入...","Text_UploadModelHint":"拖拽或点击模特照片上传JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"立即上传","Tips_NameLengthLimit":"请输入${0}字内的名称","Tips_DeleteFailed":"删除失败","Title_ConfirmDeleteModel":"确认删除这个模特吗？","Tips_CreateSuccess":"创建成功","Tab_BatchTemplate":"套图模板","Tab_MyModel":"我的模特","Placeholder_InputContent":"输入内容","Title_ChooseSceneType_VideoGenerateCard":"请选择您希望生成的内容类型和分镜结构：","Button_ConfirmGenerate_VideoGenerateCard":"已确认，开始执行视频生成流程","Title_ShotType_VideoGenerateModal":"分镜类型","Title_ShotRequirement_VideoGenerateModal":"分镜描述","Title_Duration_VideoGenerateModal":"时长","Btn_AddOneTableRow":"新增一行","Label_Gender_ModelModal":"性别","Label_Appearance_ModelModal":"外观特征","Label_AgeGroup_ModelModal":"年龄段","Label_Persona_ModelModal":"人设","Label_BodyType_ModelModal":"体型","Tips_GenerateModelFailed_ModelModal":"生成失败，请稍后重试","Tips_NetworkError_ModelModal":"网络异常，请稍后重试","Tab_CustomModel_ModelModal":"定制模特","Tab_OfficialModel_ModelModal":"官方模特","Tab_UploadModel_ModelModal":"上传模特","Text_ModelPreview_ModelModal":"模特预览","Button_Generating_ModelModal":"生成中...","Button_Regenerate_ModelModal":"重新生成","Button_Generate_ModelModal":"生成","Button_Saving_ModelModal":"保存中...","Button_SaveAndUse_ModelModal":"保存并使用","Button_CreateNewModel_AgentLibList":"创建新模特","Message_NotFilled_RequiredField":"未填写${0}","Title_ChooseSceneType2_VideoGenerateCard":"请选择您希望生成的分镜结构：","Title_ContentType_VideoGenerateCard":"内容类型","Title_StoryboardStructure_VideoGenerateCard":"分镜结构","Text_Offical":"官方","Title_AboveTheFold_Main_HomeV2":"让每一张商品图 <br /> <span>更具卖货力</span>","Title_Designkit_Slogan":"让每张商品图都能促成销售","Button_StartFree_HomeV2":"免费开始","Title_AboveTheFoldMobile_Main_HomeV2":"让每一张商品图 <br /><span>更具卖货力</span>  ","SubTitle_AboveTheFoldMobile_HomeV2":"从专业的图片编辑到自动化的 Listing 生成，这里有您所需的一切。","Text_TopBanner_HomeV2":"Seedance 2.0 即将上线，敬请期待","Title_ModuleCard_HomeV2":"首先，生成高质量资产","SubTitle_ModuleCard_HomeV2":"告别空白画布。使用我们的一体化智能创意 AI Agent 矩阵，几秒内生成完整的 <br /> Listing 套图、动态视频、虚拟试衣以及全球本土化适配。","Title_Faq_Q1_HomeV2":"你们提供免费试用吗？","Text_Faq_A1_HomeV2":"是的！新用户注册即享 20 个免费积分。此外，每天登录还可领取 10 个免费积分。这让您在升级为付费计划之前，可持续体验包括图片和视频生成在内的所有核心功能。  ","Title_Faq_Q2_HomeV2":"图片符合Amazon/Shopify的规范吗？","Text_Faq_A2_HOMEV2":"完全符合。针对商品主图，我们的 AI 严格输出符合亚马逊和 Shopify 要求的纯白背景 (RGB 255,255,255)。对于生活场景图及社交媒体图片，它能确保完美的尺寸比例与高分辨率画质，让您的 Listing 完全合规且专业。","Title_Faq_Q3_HomeV2":"生成的资产可以用于商业用途吗？","Text_Faq_A3_HomeV2":"是的。在付费计划下生成的所有图片和视频均为 100% 免版税，并且已全面获得商业使用许可。您可以无限制地将这些资产应用于您的 Shopify 商店、亚马逊 Listing、社交媒体广告及任何其他营销渠道。","Title_Faq_Q4_HomeV2":"批量生成和编辑是如何工作的？","Text_Faq_A4_HomeV2":"Designkit 的各项功能原生支持批量处理。您只需将多张图片直接上传到工作区。无论您是生成新的生活方式背景、去除原始背景、消除多余对象还是提升分辨率，只需一键即可将所选操作应用于整个批次。这不仅能确保您的商店素材完美一致，还能为您节省数小时的人工处理时间。","Title_Faq_Q5_HomeV2":"支持哪些文件格式？","Text_Faq_A5_HomeV2":"视频导出支持为社交媒体和电商平台优化的 MP4 格式。","Title_Questions_Main_HomeV2":"常见问题","Title_Scale_Main_HomeV2":"准备好扩大规模了吗？","SubTitle_Scale_HomeV2":"加入超过 10,000 名卖家的行列，使用 Designkit 自动化您的设计工作流。","Title_Evaluation_HomeV2":"最终，更快地上线并获得更多销量","SubTitle_Evaluation_HomeV2":"削减 90% 的制作时间。抢先您的竞争对手，在亚马逊和 Shopify 上发布高转化率的 Listings。","Tab_Module_ProductImage_HomeV2":"AI商品套图","Desc_Module_ProductImage_HomeV2":"将一张供应商提供的照片瞬间转化为整套 Listing 素材。自动生成白底主图、生活场景图及信息图，并轻松批量处理成百上千个 SKU，同时自动翻译文本以适配全球市场。","Tip_Module_ProductImage_HomeV2":"为这款粉色耳机生成一套亚马逊 Listing 图片。","Tab_Module_ModelImage_HomeV2":"AI模特","Desc_Module_ModelImage_HomeV2":"没有模特？不是问题。在各种不同的 AI 模特身上展示您的服装，无需预定昂贵的实景拍摄，即可有效提升点击率。","Tip_Module_ModelImage_HomeV2":"让一位 25 岁的女性模特展示这套黄绿色西装。","Tab_Module_Video_HomeV2":"AI商品视频","Desc_Module_Video_HomeV2":"让产品生动起来。仅需一段文本或单张图片，即可生成动态产品展示视频、引人入胜的 AI 代言人视频及高转化广告，在各大电商平台及社交媒体上吸引眼球并推动销量。","Tip_Module_Video_HomeV2":"为这个蓝色花瓶生成一段商品展示视频。","Tab_Module_DetailPage_HomeV2":"AI商品详情页","Desc_Module_DetailPage_HomeV2":"无需设计技巧，几分钟内即可为您的网店创建高级 A+ 页面内容和无缝宣传海报。将基础商品图转化为极具吸引力的页面布局，轻松让您的 Listing 脱颖而出。","Tip_Module_DetailPage_HomeV2":"为这组橙色沙发生成一张商品详情长图。","Tab_Module_Photography_HomeV2":"AI商品图","Desc_Module_Photography_HomeV2":"抛弃千篇一律的素材库。将您的产品置于能与欧美市场产生共鸣、独具品牌调性的专属场景中。","Tip_Module_Photography_HomeV2":"为这款香水生成一张摄影背景图。","Title_Module_SecondTitle_HomeV2":"然后，通过AI进行精细修图","SubTitle_Module_SecondSubTitle_HomeV2":"资产已生成？现在让它们变得更完美。使用我们的 AI 图片编辑器批量去除背景、清理瑕疵，并对低清图片进行画质提升。","Text_Upload_HomeV2":"上传","Text_TopBannerMobile_HomeV2":"Seedance 2.0 即将上线","Text_Prompt1_HomeV2":"生成全套亚马逊listing图。","Text_Prompt2_HomeV2":"生成穿着这套衣服的模特。","Text_Prompt3_HomeV2":"生成商品营销视频。","Text_Prompt4_HomeV2":"生成A+内容商品详情页。","Text_Prompt5_HomeV2":"为商品图生成合适的背景。","Desc_Evaluation1_HomeV2":"速度极快！图片即可用于 Mercado Libre 和亚马逊。它能完美地根据当地审美调整背景和模特。生成的作品非常专业。","Desc_Evaluation2_HomeV2":"太喜欢 Designkit 了！AI 生成的生活场景图自然、温馨且充满北欧风——完美契合我的香薰蜡烛店铺。我的 Listing 看起来更精美了，销量也有所增长。非常值得！  ","Desc_Evaluation3_HomeV2":"我是卖服装的，原本担心 AI 会破坏材质质感。但 Designkit 完全搞定了！色彩完美还原，模特的姿势看着很自然，图片出炉就能直接用。","Header_products_socialMediaPostGenerator":"社媒海报生成器","Pricing_Seedance_UnlockLimited":"解锁无限制访问","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> 抢先体验","Pricing_Seedance_SeedanceDesc":"成为首批体验 Seedance 2.0 强大功能的用户之一。现在订阅任意 Pro 计划，即可获得我们新一代 AI 模型的专属无限访问权限。","Pricing_Seedance_Monthly":"月度计划奖励","Pricing_Seedance_DaysUnLimit":"  7 天 <span>无限畅用</span>","Pricing_Seedance_SeedanceV2":"访问 Seedance 2.0","Pricing_Seedance_BestValue":"最划算","Pricing_Seedance_Yearly":"年度计划奖励","Pricing_Seedance_MonthUnLimit":"1 个月 <span>无限畅用</span>","Title_AIBrand_Tools":"✨AI品牌工具","Title_AISocialMediaPosts":"AI社媒海报","Title_AILogoMaker":"AI Logo生成器","Option_Child_Age":"儿童","Option_Infant_Age":"婴儿","Option_MiddleAged_Age":"中年","Option_Senior_Age":"老年","Option_Teen_Age":"青少年","Option_YoungAdult_Age":"青年","Button_GenerateImages_DetailPageAction":"生成详情图","Text_GenerateImagesCount_DetailPageAction":"（${0}张）","Text_GenerateImagesCount_DetailPageAction1":"（${0}张）","Option_MercadoLivre_Platform":"美客多 ","Option_Etsy_Platform":"Etsy ","Option_Walmart_Platform":"沃尔玛 ","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"生成详情页策划方案","Option_AdvancedMobile_DetailPageMode":"高级A+（移动端）","Option_AdvancedWeb_DetailPageMode":"高级A+（Web端）","Option_Standard_DetailPageMode":"普通A+","Option_Accessories_DetailSection":"配件/赠品图","Option_ServiceSupport_DetailSection":"售后保障图","Option_BeforeAfter_DetailSection":"效果对比图","Option_BrandStory_DetailSection":"品牌故事图","Option_KeyHighlights_DetailSection":"核心卖点图","Option_CraftProcess_DetailSection":"工艺制作图","Option_HeroVisual_DetailSection":"首屏主视觉","Option_Composition_DetailSection":"商品成分图","Option_MultiAngle_DetailSection":"多角度图","Option_DetailCloseups_DetailSection":"商品细节图","Option_SceneMood_DetailSection":"场景氛围图","Option_SeriesShowcase_DetailSection":"系列展示图","Option_SizeCapacity_DetailSection":"尺寸/容量/尺码图","Option_Specifications_DetailSection":"详细规格/参数表","Option_UsageScenario_DetailSection":"使用场景图","Option_UsageTips_DetailSection":"使用建议图","Paragraph_ServicePolicy_DetailSection":"说明质保退换政策","Paragraph_BeforeAfter_DetailSection":"使用前后效果对比","Paragraph_BrandConcept_DetailSection":"传达品牌理念","Paragraph_CoreValue_DetailSection":"传递核心价值","Paragraph_CraftProcess_DetailSection":"展示工艺制作过程","Paragraph_Differentiators_DetailSection":"突出差点优势","Paragraph_Composition_DetailSection":"展示配方/材质/成分","Paragraph_MaterialAndCraft_DetailSection":"放大材质与工艺","Paragraph_MultiAngleAppearance_DetailSection":"多角度呈现外观","Paragraph_MultiOptionDisplay_DetailSection":"多色或多SKU展示","Paragraph_IncludedItems_DetailSection":"明确收货的所有物品","Paragraph_DetailData_DetailSection":"展示详细商品数据","Paragraph_RealUsageScene_DetailSection":"呈现真实使用场景","Paragraph_Specifications_DetailSection":"展示规格信息","Paragraph_UsageNotes_DetailSection":"商品使用的注意事项","Paragraph_UsageScenario_DetailSection":"展示使用场景","Title_Nav_DetailPage":"A+详情","Title_ImageSet_DetailPage":"A+详情套图","Input_TaskName_Batch":"输入任务名称","Paragraph_FullAssetSetDescription_Batch":"包含主图、场景图、白底图等全套营销素材，适合多平台铺货","Paragraph_LongFormVisualDescription_Batch":"专注于商品长图、A+描述页及细节对比图的深度氛围渲染","Message_JsonGenerated_Batch":"表单校验通过，已生成 JSON 数据","Message_JsonCopied_Batch":"JSON 已复制","Message_IncompleteRequiredFields_Batch":"该项表单有必填项未完成，请完善后再提交","Message_PleaseUploadSourceImage_Batch":"请上传商品图","Message_PleaseCompleteStrategySettings_Batch":"请完善策略配置","Message_TaskValidationFailed_Batch":"有任务项未通过校验，请先完善","Message_CopyJsonFailed_Batch":"复制失败，请在控制台查看 JSON","Message_PleaseEnterTitle_Batch":"请输入标题","Message_PleaseEnterKeyHighlights_Batch":"请输入卖点描述","Message_PleaseGenerateJsonFirst_Batch":"请先点击提交生成 JSON 数据","Title_DetailPage_Batch":"详情页A+","Title_DetailTask_Batch":"A+任务${0}","Title_IndependentParameters_Batch":"单独调整参数","Title_ImageSet_Batch":"电商爆款套图","Title_ItemTask_Batch":"商品任务","Option_Curvy_BodyType":"微胖","Option_Muscular_BodyType":"肌肉","Option_PlusSize_BodyType":"大码","Option_Slim_BodyType":"纤细","Option_Standard_BodyType":"标准","Button_Reset_Common":"重置","Button_Back_Common":"返回","Button_Collapse_Common":"收起","Button_Expand_Common":"展开","Button_Generate_Common":"去生成","Button_PreviousStep_Common":"上一步","Button_RemoveFavorite_Common":"取消收藏","Button_StartNow_Common":"立即体验","Paragraph_ExitWarning_Common":"返回后数据将要情况","Paragraph_Content1_VirtualModelDisclaimer":"2.生成内容特性理解：AI生成内容基于算法与数据学习，其结果存在不确定性。生成的面容可能与原肖像存在差异，且不排除出现瑕疵或不尽如人意的情形。平台对生成内容的准确性、美观度及适用性不作保证。","Paragraph_Content2_VirtualModelDisclaimer":"3.使用责任自担：您应对上传的人脸照片及生成内容负责，确保其使用不侵犯任何第三方的合法权益（包括但不限于肖像权、隐私权、名誉权等），并符合相关法律法规。禁止将生成内容用于任何违法、侵权（如诽谤、欺诈）、违背公序良俗或侵犯他人尊严的用途。","Paragraph_Content3_VirtualModelDisclaimer":"请谨慎上传，并确认您已充分理解并接受上述告知内容。","Title_Notice_VirtualModelDisclaimer":"在您使用“AI商品套图-服饰穿戴”功能前，请您仔细阅读并理解以下内容：","Message_FailedRetry_Download":"下载失败，请稍后重试","Message_Failed_Download":"下载失败","Message_Success_Download":"下载成功","Message_NoImagesAvailable_Download":"该分组暂无图片","Option_Asian_Ethnicity":"亚洲人","Option_Black_Ethnicity":"非裔","Option_Chinese_Ethnicity":"中国人","Option_Latino_Ethnicity":"拉丁裔","Option_MiddleEastern_Ethnicity":"中东人","Option_SoutheastAsian_Ethnicity":"东南亚人","Option_White_Ethnicity":"欧美白人","Option_Female_Gender":"女","Option_Male_Gender":"男","FormLabel_Ethnicity_Common":"人种","FormLabel_OriginalImage_Common":"原图","FormLabel_OutputLanguage_Common":"输出语言","FormLabel_TargetMarket_Common":"目标市场","FormLabel_TargetPlatform_Common":"目标平台","Option_German_Language":"德语","Option_Japanese_Language":"日语","Option_None_Language":"无文字","Option_Portuguese_Language":"葡萄牙语","Option_Russian_Language":"俄语","Option_Spanish_Language":"西语","Option_Thai_Language":"泰语","Option_Brazil_Market":"巴西","Option_China_Market":"中国","Option_Europe_Market":"欧洲","Option_Germany_Market":"德国","Option_Japan_Market":"日本","Option_Russia_Market":"俄罗斯","Option_SoutheastAsia_Market":"东南亚","Option_Spain_Market":"西班牙","Option_UnitedStates_Market":"美国","Message_MaxLimit_DetailSectionSelection":"最多可选${0}个模块","Option_FollowGlobalSettings_Common":"跟随全局","Text_MaxTasks_Batch":"最多添加${0}项任务","Text_MinTasks_Batch":"至少保留一个任务项","Text_MaxImagesPerTask_Batch":"单项最多上传${0}张图片","Text_SupportedImageFormats_Batch":"仅支持上传 jpg、jpeg、png、heic、webp 图片","Input_AppearanceDetailsExample_TryOn":"例如：小麦色皮肤、齐刘海、眼角有泪痣...","Input_SourceInfoGuide_Batch":"建议包含以下信息生成更精准：\\n1.产品名称\\n2.核心卖点\\n3.适用人群\\n4.期望场景\\n5.具体参数","Tooltip_OutputStyleConsistent_Clone":"   开启后生成的多张图将保持统一的配色和调性，确保整套风格一致； 关闭则每张独立跟随各自参考图风格。","Option_AlibabaInternational_Platform":"阿里国际站","Option_AliExpress_Platform":"速卖通","Option_Amazon_Platform":"亚马逊","Option_Douyin_Platform":"抖音","Option_DouyinEcommerce_Platform":"抖音电商","Option_IndependentSite_Platform":"独立站","Option_Indonesian_Language":"印尼语","Option_JD_Platform":"京东","Option_Pinduoduo_Platform":"拼多多","Option_Taobao_Platform":"淘宝","Option_TaobaoTmall1688_Platform":"淘宝天猫1688","Button_Generate_ImageSet":"一键生成爆款套图","Title_Nav_ImageSet":"商品套图","Message_GenerateFailedRetry_ImageSet":"生成失败，请重试","Message_PleaseSelectStyleFirst_ImageSet":"请先选择爆款风格再生成！","Message_CreateTaskFailed_ImageSet":"创建任务失败","Title_StyleAnalysis_ImageSet":"爆款风格分析","Option_TrafficMaximization_TitleStrategy":"流量最大化","Option_ConversionPriority_TitleStrategy":"转化率优先","Option_SceneImmersion_TitleStrategy":"场景沉浸","Text_ExtractingVisualAttributes_TitleGenerationStatus":"正在提取当前视觉素材核心属性...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"正在结合核心卖点极速运算高转化词库...","Text_MatchingSeoStrategy_TitleGenerationStatus":"正在匹配平台 SEO 最优策略...","Text_GeneratingOptions_TitleGenerationStatus":"正在生成多维度标题方案...","Message_TaskFailedWithStatus_TitleGeneration":"任务执行失败 (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"任务执行超时，请重试","Message_GenerateFailed_TitleGeneration":"标题生成失败，请重试","Message_QueryResultFailed_TitleGeneration":"查询任务结果失败","Paragraph_Content_VirtualModelConsent":"1.肖像权授权确认：本功能将使用您上传的人脸图像，通过人工智能技术生成虚拟模特面容。您必须确保：您是所上传人脸照片的肖像权人，或您已获得肖像权人的明确、有效的书面授权，允许您将其肖像用于本服务及生成作品的相关用途。若上传未成年人肖像，须已获得其监护人的同意。","Button_ConfirmTextChange_TextEdit":"确认改字","Input_ModifyText_TextEdit":"修改图片中的文字","Message_NoImagesAvailable_ResultDownload":"暂无可下载的图片","Message_Failed_TextRecognition":"文字识别失败","Text_Generating_ResultStatus":"AI生成中…","Option_CustomColor_SceneSetting":"自定义颜色","Option_UseOriginalBackground_SceneSetting":"使用原图背景","Text_InsufficientCredits_Common":"美豆不足","Button_LoadMore_Common":"加载更多","Text_ImageUploadLimit_Common":"最多上传${0}张图片","Text_AnalyzingTrend_Common":"正在分析 ${0} 趋势","Text_ChineseOutputProOnly_Common":"仅Pro版支持中文生成哦～已为你切换为无文字版本。","Text_SourceImageUploadLimit_Common":"最多上传${0}张图片","Text_WritingInProgress_AiWriting":"正在帮写请稍后...","Text_DeepThinking_AiWriting":"AI深度思考中…","Text_ThinkingProcess_AiWriting":"思考过程:","Text_ImageSelectionLimit_Common":"最多选择 ${0} 张图片","Message_RegenerationSubmitted_Regeneration":"已提交重新生成，请稍后刷新查看结果","Button_MoreEditOptions_ResultEditor":"更多编辑","FormLabel_DetailSection_DetailPage":"详情页模块","Message_GeneratePlanFailed_DetailPagePlan":"生成策划方案失败","Message_PlanGenerationFailed_DetailPagePlan":"策划方案生成失败","Text_PlanUnavailable_DetailPagePlan":"没有策划方案","Message_SourceImageMissing_Common":"商品图片丢失","Message_GenerationFailed_Common":"生成失败","Paragraph_ConfirmDiscardChanges_Common":"返回后，已编辑的内容将会丢失，确认返回吗？","Message_ProcessFailed_Common":"处理失败","Text_GeneratingEllipsis_Common":"生成中…","Text_StyleGenerationInProgress_ImageSet":"爆款风格生成中…","Message_FavoriteAdded_Common":"收藏成功","Message_FavoriteRemoved_Common":"取消收藏成功","Text_LoadingPlain_Common":"加载中","Text_MultiSelectAvailable_Common":"可多选","Text_NoData_Common":"没有数据","Text_NoDataAvailable_Common":"暂无数据","Text_NoMoreResults_Common":"没有更多了","Message_PleaseEnterKeyHighlights_DetailPage":"请输入核心卖点","Message_PleaseSelectAiModel_TryOn":"请先选择ai模特","Message_SelectSectionMin_DetailPage":"请至少选择${0}个模块","Message_SelectScenePoseMin_TryOn":"请至少选择${0}个场景和姿势","Message_PleaseSelectBaseModel_TryOn":"请选择基准模特","Message_PleaseSelectCustomModel_TryOn":"请先选择自定义模特","Message_PleaseSelectModel_TryOn":"请先选择模特","Message_PleaseSelectSection_DetailPage":"请选择模块","Message_SelectUploadCustomModel_TryOn":"请先选择或上传自定义模特图","Message_PleaseSelectScene_TryOn":"请选择场景","Message_PleaseSelectStrategy_DetailPage":"请先选择策略","Message_PleaseUploadGarmentImage_TryOn":"请先上传服装图","Message_UploadGarmentFile_TryOn":"请先上传服装图片","Message_PleaseUploadSourceImage_Common":"请先上传商品图","Message_PleaseUploadItemImage_Common":"请上传产品图","Message_UploadItemFirst_Common":"请先上传产品图","Message_RegenerateFailedWithReason_Regeneration":"重新生成失败:","Message_SelectResultImages_Result":"请先选择具有结果图的图片","Text_ReleaseToRefresh_Common":"释放刷新","Message_TextRecognitionFormatInvalid_TextRecognition":"识别结果格式错误","Message_TextRecognitionParseFailed_TextRecognition":"解析识别结果失败","Message_TextRecognitionTaskFailed_TextRecognition":"文字识别任务失败","Message_QueryTaskStatusFailed_TextRecognition":"查询任务状态失败","Message_SubmitTaskFailed_TextRecognition":"提交文字识别任务失败","Text_RegenerationProcessing_Regeneration":"已提交重新生成，正在处理中...","Message_RegenerateFailedRetry_Regeneration":"重新生成失败，请稍后重试","Message_OpenEditorFailed_ResultEditor":"跳转编辑失败","Message_RegenerateFailed_Regeneration":"重新生成失败","Message_RefreshFailedRetry_Common":"刷新失败，请重试","Message_UploadGarmentSelectModel_TryOn":"请先上传服装图，并选择模特","Message_PollingTimedOut_Common":"轮询超时","Title_KeyHighlights_DetailPage":"商品卖点&要求","Title_FullStrategyGuide_DetailPage":"全案策略与设计规范","Title_IncludedSections_DetailPage":"包含模块","Title_IncludedSectionsMultiple_DetailPage":"包含模块 (多选)","Title_ModelSelection_TryOn":"模型选择","Title_SectionContent_DetailPage":"模块内容","Title_SectionStrategyGuide_DetailPage":"模块策略与设计规范","Title_OutputAspectRatio_Common":"输出比例","Title_OutputSpecification_Common":"图片比例","Title_SelectModel_TryOn":"选择模特","Title_SelectScene_TryOn":"选择场景","Title_StrategySettings_DetailPage":"生成设置","Title_UploadAssets_Common":"商品原图","Button_GenerateBaseModel_TryOn":"生成基准模特","Button_GenerateRecommendedScenes_TryOn":"生成推荐场景","Button_GenerateSceneImages_TryOn":"生成场景图片（${0}张）","Text_GeneratingBaseModel_TryOn":"基准模特生成中…","Option_CloseUp_Framing":"特写","Option_FullBody_Framing":"全身","Option_HalfBody_Framing":"半身","Option_ThreeQuarter_Framing":"四分之三","Title_Hero_TryOn":"AI服饰穿戴","Option_Ai_TryOnModelMode":"AI 生成","Title_Nav_TryOn":"服饰穿戴","Option_Back_Perspective":"背面","Option_Front_Perspective":"正面","Option_Side_Perspective":"侧面","Option_ThreeQuarterSide_Perspective":"3/4侧","Input_AppearanceDetailsHint_TryOn":"外貌细节：小麦色皮肤、齐刘海、眼角有泪痣...","Message_SaveToAlbumSuccess_Common":"已保存到相册","Text_GeneratingSceneImages_TryOn":"正在生成场景图片...","Message_RefreshFailed_Common":"刷新失败","Message_FailedRefunded_Generation":"AI设计失败，美豆已退还","Title_BaseModelImage_TryOn":"基准模特图","Title_CustomModel_TryOn":"定制专属模特","Paragraph_Intro_TryOn":"上传服装图，定制专属模特，即可生成多种场景不同姿势套图。","Title_UploadGarmentImage_TryOn":"上传服装图片","Tips_UploadFailedPure":"上传失败","Tips_Uploading":"上传中","Text_UploadNewModel":"上传新模特","Text_AllBackgrounds":"所有背景","Text_DefaultTemplateScene":"默认模版场景","Text_ColorScene":"颜色场景","Text_SameProductMax_Common":"同一产品，最多${0}张。","Text_Max_Common":"最多${0}张","Button_Generate_ImageClone":"一键复刻爆款图","Button_RefreshStyle_Common":"换一批风格","Button_Favorite_Common":"收藏","Text_PreviewLargeImage":"预览大图","Text_BaseImage":"基准图","Button_BatchDownload_Common":"批量下载","Button_BatchEdit_Common":"批量编辑","Button_BatchWatermark_Common":"批量加水印","Text_GeneratedResults":"生成结果","Button_DownloadAllImages_Common":"下载全部图片","Text_NoGeneratedResults":"暂无生成结果","Text_SameProductMax_TryOn":"整套搭配或同一件服装不同角度图，最多${0}张。","Title_AdvancedImageGenerationModel":"高级生图模型","Text_SupportChineseOutput_Common":"支持中文输出；细节、审美、可控性增强。","Text_SelectMultipleModules_DetailPage":"可选择多个模块组合生成详情页","Button_CollapseAll_Common":"展开全部","Label_AppearanceDetails_TryOn":"外貌细节 (可选)","Text_WaitingForGeneration_TryOn":"等待生成","Title_SmartTitleAI_ProductTitle":"生成爆款标题","Message_ResultMissing_TitleGeneration":"AI 返回结果缺少 ${0}","Message_InvalidJSONFormat_TitleGeneration":"AI 返回结构不符合预期","Message_InvalidJSONFormat_TitleGeneration1":"AI 返回了无效的 JSON 格式","Text_AutoGeneratedTitleScheme_ProductTitle":"以下是基于您的产品自动生成的标题方案","Text_SelectBestTitle_ProductTitle":"选择最适合您渠道策略的标题，点击一键复制","Button_Copy_Common":"一键复制","Message_PleaseUploadImage_Common":"请先上传图片","Text_DeepThinking1_AiWriting":"DeepSeek深度思考中…","Button_Rewrite1":"重新帮写","Text_TotalImages_Common":"共${0}张","Text_EditText_ResultEditor":"编辑文字","Text_NoTextRecognition_ResultEditor":"未识别到文字","Text_PreviewLongImage_ResultGroup":"预览长图","Text_LimitFree":"限免","Text_UploadSameProductTip1":"1.可上传同一商品的多视角原图，帮助 AI 更准确还原商品细节","Text_UploadSameProductTip2":"2.最多支持 3 张图片，第一张将作为主图重点参考，建议选择角度最全的一张","Text_UploadProductImage_APlusCase":"上传产品图","Text_GenerateEcommerceLongImage_APlusCase":"生成电商长图","Text_MultiPlatform_APlusCase":"符合多电商平台规范","Text_MainImage_ProductCase":"01 主图 (白底/合规)","Text_SceneDisplay_ProductCase":"02 场景展示","Text_ModelSceneImage_ProductCase":"03 模特场景图","Text_DetailDescription_ProductCase":"04 细节说明","Text_FeatureExplanation_ProductCase":"05 卖点详解","Text_UploadProductImage_ProductCase":"上传商品图，Al 即刻生成 <span>符合多电商平台规范</span> 的高转化率商品套图。","Text_UploadGarmentImage_TryOn":"上传服装图，定制专属模特，即刻生成多种场景不同姿势套图。","Text_UploadProductImage_DetailPage":"上传商品图，AI 即刻生成 <span>符合多电商平台规范</span> 的专业详情页。","Title_DetailPage_ProductCase":"A+/详情页","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"  登录解锁免费试用","Login_DK_Title":"免费创建令人眼前一亮的设计","Login_Zawa_Des":"立即开始使用 Zawa 创作","Login_DK_Des":"就现在！来注册或登录来继续你的设计","Tab_Module_ProductImage_TryOn_MultiMix":"多件混搭自动融合","Tab_Module_ProductImage_TryOn_SingleHero":"一件也能出大片","Tab_Module_ProductImage_TryOn_Accessories":"鞋帽饰品完美适配","Text_ShowAdvancedModelTip":"显示高级生图模型提示","Text_HideAdvancedModelTip":"隐藏高级生图模型提示","Text_DeepSeekR1HelpWrite":"DeepSeek R1 帮写","Message_PollingMaxAttempts_Common":"超过最大尝试次数${0}","Title_StandardEdition":"标准版","Text_FastAndEfficient_Common":"极速/省流","Text_PremiumEdition":"高级版","Text_QualityAndDetailEnhancement_Common":"画质/细节增强","Text_PremiumEngineActivated":"<strong>高级版引擎已激活：</strong> 支持中文输出，具备更强的细节审美与画面可控性。","Text_EditBrand_DropTitle1":"拖放 JPG、PNG、WEBP 文件","Text_EditBrand_DropTitle2":"或者从您的电脑<>浏览</>","Text_BaseToolbar_AlignTop":"顶部对齐","Text_BaseToolbar_AlignBottom":"底部对齐","Text_LayerSort":"图层排序","Text_BaseToolbar_AlignCenter":"居中对齐","Text_Attr_Strong":"加粗","Text_GeneratingPlan_DetailPagePlan":"策划方案生成中...","Text_PlanGenerationFailed_ReTry":"策划方案生成失败，请重试","Button_StartAnalyze_ProductCase":"开始分析","Message_SubmitSuccessTip_Batch":"提交成功","Button_ClickAnalyze_ProductCase":"一键分析爆款风格","Button_StartAnalyzing_ProductCase":"分析中","Title_ModelImage":"模特图","Text_Cookie_Title":"首先，Cookie 🍪","Text_Cookie_Content":"我们希望在本网站上使用 Cookie，以确保网站的安全性、高效运行及服务优化。如需了解更多关于我们使用 Cookie 的信息，请点击","Text_Cookie_LearnMore":"了解详情","Button_Cookie_Manage":"管理 Cookie ","Button_Cookie_Accept":"接受","Text_CookieModal_Title1":"Cookie 设置","Text_CookieModal_Desc1":"Cookie 是您访问的网站存储在您设备上的小型文本文件。它们有助于我们记住您的偏好、分析网站流量并改进我们的服务。您的隐私对我们很重要，我们希望您能掌控自己的数据。在此，您可以自定义 Cookie 偏好设置，以优化您的浏览体验。请注意：更改 Cookie 偏好设置可能会影响网站的功能以及我们为您提供的服务。","Text_CookieModal_Title2":"必要 Cookie","Text_CookieModal_Desc2":"这些 Cookie 对于网站的功能、安全及基本性能至关重要。若缺失这些 Cookie，Zawa 中的关键功能及安全防护措施将无法使用，从而影响您的使用体验。","Text_CookieModal_Title3":"可选 Cookie","Text_CookieModal_Desc3":"这些 Cookie 帮助我们了解 Zawa 的用户数量、用户来源及其使用模式。如果您选择禁用这些 Cookie，我们将无法获取改进 Zawa 所需的反馈，从而无法为您及所有用户提供更好的服务。","Button_CookieModal_Save":"保存偏好设置","Text_CookieModal":"始终启用","Text_Agent_Chat_DK":"向Designkit发送消息","Text_Agent_Chat_XD":"想让 Zawa 做什么","Radio_Color":"配色","Radio_Layout":"布局","Radio_Reference":"参考${0}","Radio_Posture":"姿势","Radio_Background":"背景","Language_Banner_Message":"是否切换为 ${0}","Language_Banner_Change":"更改语言","Language_Banner_Other":"其他语言","Title_ItemTaskWithIndex_Batch":"商品任务${0}","Title_DetailTaskPrefix_Batch":"A+任务","Text_CopiedTaskTitle_Batch":"${0}（复制）","Message_SelectSectionMin_Batch":"请至少选择一个模块","Title_GlobalBatchSettings_Batch":"全局批量设置（应用于下方所有任务）","Text_Parameters_Batch":"参数","Text_Modules_Batch":"模块","Title_KeyHighlights_Batch":"卖点描述","Text_ModulesFollowGlobal_Batch":"需要的模块-跟随全局","Title_SelectManagedBusinessType_Batch":"请选择托管业务类型：","Button_SubmitTask_Batch":"提交任务","Text_NewTaskCurrentCount_Batch":"新建任务","Title_NotificationSettings_Batch":"通知设置","Title_ManagedMode_Batch":"托管模式","Button_SaveSettings_Batch":"保存设置","Button_SaveAndContinueSubmit_Batch":"保存并继续提交","Message_PhoneFormatInvalid_Batch":"请输入正确的11位手机号","Message_VerificationCodeSent_Batch":"验证码发送成功，5分钟内有效","Message_VerificationCodeSendFailed_Batch":"验证码发送失败，请稍后重试","Message_PleaseEnterCode_Batch":"请输入验证码","Message_GetCodeFirst_Batch":"请先获取验证码","Message_VerificationCodeExpired_Batch":"验证码已过期，请重新获取","Message_SaveNotificationSettingsFailed_Batch":"保存通知设置失败，请稍后重试","Text_WebMessageNotification_Batch":"任务完成后，会在Web端的消息中通知您","Title_AppPushRecommended_Batch":"APP实时推送（强烈推荐）","Paragraph_AppPushDesc_Batch":"随时随地监控进度，生成成功即刻手机预览，抢先一步发布流量爆款，不错过任何流量高峰","Text_AppDownloadQrCode_Batch":"APP下载二维码","Title_SmsNotification_Batch":"手机短信通知","Placeholder_Phone11Digits_Batch":"请输入手机11位号码","Placeholder_VerificationCode5Min_Batch":"请输入验证码（5分钟内有效）","Text_SendingEllipsis_Batch":"发送中...","Text_RetryAfterSeconds_Batch":"${0}s后重试","Button_GetVerificationCode_Batch":"获取验证码","Message_SubmitSuccess_Batch":"提交成功","Message_SubmitFailedRetry_Batch":"提交失败，请稍后重试","Message_FormValidationPassed_Batch":"表单校验通过","Message_CompleteNotificationSettingsFirst_Batch":"请先完成通知设置，再继续提交任务","Paragraph_CancelManagedTaskWarning_Record":"取消后将停止当前托管任务，且无法恢复。","Button_ConfirmCancel_Record":"确认取消","Message_CancelManagedTaskFailed_Record":"取消托管失败，请稍后重试","Text_WaitingManagedGeneration_Batch":"等待托管生成","Text_WaitingManagedSubmit_Batch":"等待投递","Message_NoExtendableImages_Result":"暂无可延展的图片","Text_IntelligentMultiSizeAdaptation_Result":"智能适配多尺寸，满足多端展示需求","Button_IntelligentResize_Result":"智能改尺寸","Option_CustomSize_DetailPageMode":"自定义尺寸","Title_AdvancedAPlus_DetailPageMode":"高级A+","Title_ManagedModeLaunched_Batch":"批量托管上线啦！","Text_ManagedModeSlogan_Batch":"睡一觉，图就做好了！","Title_BatchProduction_Batch":"批量生产","Paragraph_BatchProductionDesc_Batch":"支持${0}个任务并行生成，效率提升${1}倍","Title_AiIntelligentExtraction_Batch":"AI智能提取","Paragraph_AiIntelligentExtractionDesc_Batch":"自动识别图片卖点，生成高转化销售卖点。","Title_SaveCost20_Batch":"成本立省${0}%","Paragraph_SaveCost20Desc_Batch":"调度夜间闲置算力，享受专属离线点数折扣。","重写":"批量下载","Brand_AutoExtract_Button":"智能取色","Brand_AutoExtract_Success":"智能取色成功","Brand_AutoExtract_Failure":"无法提取颜色，请重试","Brand_AutoExtract_Unavailable":"无法提取颜色","Brand_AutoExtract_ConfirmTitle":"是否从logo提取颜色","Title_ImageSetConfig_ImageSet":"套图结构配置","Title_DefaultConfig_ImageSet":"智能匹配","Desc_DefaultConfig_ImageSet":"AI智能分析商品图，匹配最佳Listing套图","Title_CustomConfig_ImageSet":"自定义配置","Desc_CustomConfig_ImageSet":"可自由调整各类型图片数量，至少选择${0}张","Label_WhiteBackground_ImageSet":"白底图","Desc_WhiteBackground_ImageSet":"白底主图，多角度呈现商品细节","Label_Scene_ImageSet":"场景图","Desc_Scene_ImageSet":"展示商品的生活使用场景和人物搭配","Label_SellingPoint_ImageSet":"卖点图","Desc_SellingPoint_ImageSet":"展示商品的核心卖点及细节特写","Label_Other_ImageSet":"其他","Desc_Other_ImageSet":"对比图、尺寸图等，根据商品智能匹配","Tip_MinTotal_ImageSet":"套图至少保留${0}张","Text_ManagedBatchEntry_Header":"批量托管","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"积分","Text_Higher_Plan":"已订阅更高级别方案","Text_Try_Free":"0元立即试用","Text_Plus_Plan":"Plus套餐","Text_Pro_Plan":"Pro套餐","Button_Generate_Short_Common":"生成","Message_DuplicateTaskSubmitConfirm_Common":"检测到与上次任务相同，是否重复生成？","Text_CreditUnit_Common":"美豆","Text_NewUserDiscountDesc_Product":"首套${0}美豆 其余${1}套${2}美豆","Text_NewUserLimitedTag_Product":"新客首套限时体验","Text_OriginalPrice_Product":"原价${0}美豆","Tip_MaxTotal_ImageSet":"套图最多${0}张","Text_AddDocumentTips":"支持 Word、Excel、Text、PDF、Markdown 格式文件","Tab_SolidColor":"纯色","Tab_Gradient":"渐变","Title_PresetGradient":"渐变预设","Title_PresetSolidColor":"纯色预设","Title_RecentlyUsed":"最近使用","Title_Patterns":"图案","Title_NoFill":"无填充","Description_Brand_Reference":"上传你的海报和喜欢的参考图——Zawa 会学习它们的风格，为你打造符合你审美的专属品牌物料","Text_Generating":"生成中","Text_ChartSending":"发送中","Text_PeopleUnSupport":"暂不支持人像","Button_CancelManagedBatch_ResultGroup":"取消托管","Button_DownloadZip_ResultGroup":"下载ZIP","Button_DownloadLongImage_ResultGroup":"下载长图","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"任务已投递成功，无法取消","Button_GlobalAiWriting_Batch":"全局AI帮写","Text_StandardModel_DistributionBatch":"普通模型（铺货）","Text_StandardModelDescription_Batch":"适合长尾SKU批量铺货","Text_AdvancedModel_PremiumBatch":"高级模型（精铺）","Text_AdvancedModelDescription_Batch":"图片质量高，细节真实，主推品首选","Message_MinSubmitTasks_Batch":"批量模式最少提交${0}个任务","Message_OverwriteSellingPointsConfirm_Batch":"当前有${0} 个任务已填写卖点，请确认是否覆盖重写？","Button_OverwriteAll_Batch":"全部覆盖","Button_FillEmptyOnly_Batch":"仅填写空白","Message_NoEmptySellingPointsToFill_Batch":"当前无空白卖点内容可填充","Message_AiWritingFailedRetry_Batch":"AI帮写失败，请稍后重试","Button_NewTask_Common":"新建任务","Message_Generating_Time":"将在夜间窗口（${0}-${1}）完成生成，可在第二天查看结果","Title_Total_Credits":"合计积分","Text_Used_AllFeatures":"所有功能均可使用","Daily_Present_Credits":"今日到期积分","Daily_Credits_Desc":"每天登录可领取，当日到期","Text_Inactive":"已冻结","Text_Inactive_Monthly":"近1个月即将到期${0}个积分","TITLE_GUIDE_CUTOUT_LITE":"检测到图片中含有印章/Logo","GUIDE_DESC_CUTOUT_LITE":"使用专属提取模式，精准提取印章或Logo元素","GUIDE_ACTION_CUTOUT_LITE":"一键抠印章/Logo","TITLE_CUTOUT_LITE":"一键抠印章/Logo","TIP_CUTOUT_LITE":"专属提取模式，精准提取印章或Logo元素","PROCESSING_CUTOUT_LITE":"正在生成图片","AFTER_CUTOUT_LITE":"结果图","Button_Previous":"上一步","Button_Next":"下一步","Button_Skip":"跳过","Button_Apply":"应用","Text_AgentExpert":"专家","Message_PleaseEnterLinkOrAsin_Clone":"请先输入链接或ASIN","Message_LinkAnalyzeFailed_Clone":"链接分析失败","Message_UploadProductImageFirst_Clone":"请先上传产品原图","Message_ProductImageThumbGenerateFailed_Clone":"产品原图缩略图生成失败，请重新上传","Message_UploadProductImageFirst_ProductCase":"请先上传参考图或粘贴商品链接","Message_ReferenceImageThumbGenerateFailed_Clone":"参考图缩略图生成失败，请重新上传","Title_ReferenceSource_Clone":"参考内容","Option_LinkAsin_Clone":"导入链接","Input_PasteProductLinkOrAsin_Clone":"粘贴亚马逊链接","Button_Parsing_Clone":"解析中","Button_Parse_Clone":"解析","Text_SupportAmazonTiktokLinks_Clone":"支持Amazon、Tiktok链接。","Text_Cloning_ResultStatus":"复刻中...","Input_CloneRequirementOptional_Clone":"参考要求（选填）","Title_ProductOriginalImage_Clone":"产品原图","Title_CloneLevel_Clone":"复刻程度","Option_CompositionReference_Clone":"参考风格","Desc_CompositionReference_Clone":"参考整体风格和结构，自动调整色彩和重构场景。","Option_HighFidelityClone_Clone":"高度复刻","Desc_HighFidelityClone_Clone":"参照参考图视觉结构替换产品和文案，场景细节略有差异。","Label_OutputStyleConsistent_Clone":"输出风格保持一致","Title_SupplementaryNotesOptional_Clone":"统一复刻要求 (选填)","Input_SupplementaryNotesExample_Clone":"例如：文案统一用英文、模特保持完全不变、参考图不变只替换商品。","Title_HotClone_Welcome":"爆款图复刻","Text_HotCloneDescription_Welcome":"想参考的爆款+你的产品图 = 你的爆款图","Text_DefaultTaskName_Clone":"商品套图同款策略","Label_ProductImage_CloneCase":"产品图","Label_ReferenceComposition_CloneCase":"参考风格","Label_HighFidelityClone_CloneCase":"高度复刻","Tag_AiSmartMatch_ImageSet":"AI智能匹配","Title_Date":"日期","Title_Topic":"主题","Button_Replace":"替换","Title_SingleCloneRequirement_Clone":"单张参考要求","Text_UploadedReferenceImagesTip_Clone":"每张参考图可单独备注参考要求，不填默认处理。","Label_ReferenceImageIndex_Clone":"参考图${0}","Option_Mexico_Market":"墨西哥","Text_ParsingReferenceImages_Clone":"解析中...","Text_ParseReferenceImagesSuccess_Clone":"解析完成，得到${0}张参考图","Text_Renew_Restore":"续订会员后可恢复使用","Title_UsageNotice_Clone":"使用须知","Text_UsageNoticeDescription_Clone":"请确认您已获得该链接内容的合法使用权。生成结果基于 AI 风格分析，仅供创作参考。","Label_ReadAndAgreeUsageNotice_Clone":"我已阅读并同意以上须知","Label_DoNotShowAgain_Clone":"下次不再提示","Brand_StatusPopup_ProcessingTitle":"Zawa 正在学习你的品牌...","Brand_StatusPopup_FailedTitle":"Square 同步失败，请稍后重试","Brand_StatusPopup_Retry":"重试","SecondTitle_Header19_Home":"Clone Video Ads","SquareBrandGuide_BrandKitCreatedTip":"已经从square建立了您的品牌库","SquareBrandGuide_DefaultPrompt":"请帮我设计一个产品海报，用于社交媒体宣传","SquareBrandGuide_SendTip":"点击发送，即可启动设计！","Paragraph_BatchProductionDescUnlimited_Batch":"支持无限任务并行生成，效率直线飞升。","Menu_ViewDetail":"查看详情","Menu_CopyFullText":"复制全文","Tip_CopiedToClipboard":"已复制到剪贴板","Tip_CopyFailed":"复制失败","Menu_DownloadImage":"下载图片","Tip_NoImage":"暂无图片","Tip_DownloadStarted":"已开始下载","Menu_CopyText":"复制文案","Tip_NoTextToCopy":"暂无文案可复制","Message_LinkImageFetchFailed_Clone":"无法抓取该链接图片，请检查链接或直接上传参考图","Tab_Chat":"对话","Tab_Files":"文件","Button_Create_New_Chat":"创建新对话","Tip_Agent_Team_Chat_Shared":"你正在查看此案例的只读版本","RoboNeo_Web_input_default_content":"向RoboNeo发送消息","RoboNeo_Web_chatbox_maximum":"当前对话轮数已达上限","RoboNeo_Web_chatbox_maximum_text":"当前对话轮数已达上限，请新建任务以继续","RoboNeo_Web_chatbox_new_task":"新任务","RoboNeo_Web_history_share_text":"分享","RoboNeo_Web_history_delete_text":"删除","RoboNeo_Web_history_delete_hint_text":"提示","RoboNeo_Web_history_delete_main_text":"删除后，该记录将不可恢复，确认删除吗？","RoboNeo_Web_history_delete_hint_confirm":"删除","RoboNeo_Web_history_delete_hint_cancel":"取消","RoboNeo_Web_studio_download":"下载","RoboNeo_Web_toast_share_text":"分享当前对话","RoboNeo_Web_toast_share_main_text":"分享后任何有链接的人都可查看您的当前对话历史","RoboNeo_Web_toast_share_copy":"复制链接","RoboNeo_Web_toast_cancel":"取消","RoboNeo_Web_toast_confirm":"确认","RoboNeo_Web_studio_changing_toast":"今日Neo搬砖额度已用完，每天0点会自动刷新，或投喂「赛博萝卜」为Neo充满能量。","RoboNeo_Web_studio_changing_toast2":"今日Neo搬砖额度已用完","RoboNeo_Web_new_studio":"新会话","RoboNeo_Web_sidebar_close":"收起","RoboNeo_Web_history_text":"历史记录","RoboNeo_Web_sidebar_open":"展开","RoboNeo_Web_upload_warning_text":"不支持同时上传图片和视频","RoboNeo_Web_upload_format_text":"仅支持上传图片JPG、png、jpeg格式；视频 MP4、mov格式","RoboNeo_Web_upload_fail_text":"上传失败","RoboNeo_Web_upload_image_maximum":"最多支持上传{max_num}张图片","RoboNeo_Web_upload_video_size_maximum":"暂不支持{max_size}M以上视频","RoboNeo_Web_upload_image_size_maximum":"暂不支持{max_size}M以上图片","RoboNeo_Web_upload_video_maximum":"最多支持上传{max_num}个视频","RoboNeo_Web_history_dafult_text":"暂无历史记录，快来和我聊聊吧","RoboNeo_Web_upload_content_warning_text":"部分内容存在风险，暂不支持导入","RoboNeo_Web_chat_send_fail":"发送失败， 请稍后重试","RoboNeo_Web_network_fail":"连接失败或超时，请重试 ","RoboNeo_Web_studio_layer_fail":"图层拆分失败","RoboNeo_Web_studio_layer_success":"图层拆分成功","RoboNeo_Web_network_error":"网络错误","RoboNeo_Web_delete_success":"删除成功","RoboNeo_Web_delete_fail":"删除失败","RoboNeo_Web_copy_success":"复制成功","RoboNeo_Web_file_uploading":"{num}个文件上传中","RoboNeo_Web_file_upload_fail":"{num}个文件错误","RoboNeo_Web_file_upload_single_fail":"1个文件错误","RoboNeo_Web_file_uploading_single":"1个文件上传中","RoboNeo_Web_upload_video_maximum_one":"最多支持上传1个视频","RoboNeo_Web_sharepage_wanna_try":"我要试试","RoboNeo_Web_sharepage_load_to_end":"跳转至结果","RoboNeo_Web_studio_loading_text":"画布加载中","RoboNeo_Web_chatbox_add_image":"添加图片","RoboNeo_Web_chatbox_add_video":"添加视频","RoboNeo_Web_image_editor_max":"最大支持10M，最长边4096px","RoboNeo_Web_unlimited_pass_expired":"无限模式已结束，开始使用免费额度","RoboNeo_Web_studio_ai_image_successful":"AI超清成功 ","RoboNeo_Web_studio_ai_image_failed":"AI超清失败","RoboNeo_Web_studio_cutout_successful":"抠图成功","RoboNeo_Web_studio_cutout_failed":"抠图失败","RoboNeo_Web_studio_ai_edit_failed":"AI改图失败","RoboNeo_Web_studio_ai_edit_successful":"AI改图成功","RoboNeo_Web_AI_generated":"AI生成","RoboNeo_Web_loading":"加载中","RoboNeo_Web_view_creative_process":"播放创作过程","RoboNeo_Web_try_now":"我要试试","RoboNeo_web_extender_successful":"AI扩图成功","RoboNeo_web_extender_failed":"AI扩图失败","RoboNeo_web_eliminate_successful":"AI消除成功","RoboNeo_web_eliminate_failed":"AI消除失败","roboneo_web_continue":"继续","roboneo_web_video":"视频","roboneo_web_HTML":"网页","roboneo_web_shared_error_message":"该对话暂不支持分享，试试创建新对话","roboneo_web_open_the_APP_experience":"打开APP体验","roboneo_web_AI_generated_logo":"内容由AI生成，仅供参考","roboneo_web_change_word_success":"改字成功","roboneo_web_change_word_fail":"改字失败","roboneo_web_canvas_loading_failed":"画布加载失败","roboneo_web_export_failed":"导出失败","roboneo_web_export_tips2":"仅支持导出单张小于{width}px*{height}px的图片","roboneo_web_new_topic":"开启新话题","roboneo_web_waiting_reply":"正在等待你的回复","roboneo_web_file_saving_preferences":"文件保存偏好","roboneo_web_includes_AI_watermark":"包含AI水印","roboneo_web_no_remind":"不再提醒","roboneo_web_agree_continue":"同意并继续","roboneo_web_AI_generated":"内容由AI生成","roboneo_web_watermark_protocol":"根据您的请求，您可选择“含AI水印（标识）”和“不含AI水印（标识）”的图片，如您选择“不含AI水印”的图片，表明您同意以下标识义务和责任：您不得利用基于RoboNeoAI功能制作、发布、传播虚假信息。您在任何场景下使用、发布或传播利用基于RoboNeoAI功能制作的内容时，应当符合法律法规的要求，并以显著方式标识。","roboneo_web_rectangle":"矩形","roboneo_web_circle":"圆形","roboneo_web_arrow":"箭头","roboneo_web_image_fusion_success":"融图成功","roboneo_web_image_fusion_failure":"融图失败","roboneo_chat_resources_num_limit_tips":"最多支持同时添加{img_num}张图和{video_num}个视频哦~","RoboNeo_Web_export_confirm_tip_popup_title":"可选择是否带“AI生成“水印导出","RoboNeo_Web_export_confirm_tip_popup_btn":"我知道了"}');

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [9774,179], () => (__webpack_exec__(6840), __webpack_exec__(80880)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);